/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 345);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  env: "QA",
  alkmapsUrl: "//maps-aws-qa.alk.com/api/1.2/ALKMaps.js",
  alkmapsApiKey: "48667533B12E8942B038B8533A35F4A5",
  reportApiKey: {
    "NA": "7BD8599CEA4B8A46AC336735444E486C",
    "EU": "48667533B12E8942B038B8533A35F4A5",
    "OC": "48667533B12E8942B038B8533A35F4A5"
  },
  braze: {
    apiKey: "01e442af-cfcb-43ba-b63f-dbef1f587dac",
    // make this value smaller before demoing
    minimumIntervalBetweenTriggerActionsInSeconds: 30,
    enableLogging: true
  },
  chat: {
    enabled: true,
    regionWhitelist: ["NA"],
    scriptUrl: "https://wchat.freshchat.com/js/widget.js",
    // shared token for all environments
    fcToken: "797ed190-4ef3-4faa-81f8-367d7ba5e6dc"
  },
  pcmwsUrl: "https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc/",
  urlWeatherRadar: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=0&authtoken=",
  urlWeatherSatellite: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=1&authtoken=",
  daUrl: "https://dataanywhere-qa.alk.com/api/",
  ssoUrl: "https://authws-qa.alk.com/api/",
  fleetLinkUrl: "https://api-copilotfleetportal-qa.alk.com/",
  singleSearchUrl: "https://singlesearch-aws-qa.alk.com/ww/api/search/",
  singleSearchAuthToken: "A7FEE5D40BDF4A4A97D623094A657AFB",
  alkiconsUrl: "https://maps.trimble.com/fonts/alk-icons.min.css",
  linkMappingUrl: "https://linkmapping-qa.alk.com/api",
  creditExpireWarningDays: 14,
  trackJsEnvironment: "pcmwebui-qa",
  applicationName: "PCMilerWebsite",
  tidApplicationName: "PC_Miler_Web--dev-qa",
  clientId: "4340ee42-2cd9-4fc6-9c3e-2721ae85e384",
  trimbleCloudUrl: "https://stage.id.trimblecloud.com/",
  alkCloudApplicationName: "PC*Miler Interactive",
  promo: {
    userId: 11553434,
    accountId: 127896
  },
  pcmModernSite: "https://qa.pcmilerweb.com/",
  sumoUrl: "https://collectors.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV3NqK1vVtGOb0Fly8fu4vYhxD_B70jkxrlh33lFU53ial6DElnwM9kHMctfNvhXGVcis-2-dxiDOmDQ3w-S3fo7i2R0Up-n6sX1lQRT67QAOg=="
};

module.exports = config;

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0;

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function createStyleElement() {
	var styleElement = document.createElement("style");
	var head = getHeadElement();
	styleElement.type = "text/css";
	head.appendChild(styleElement);
	return styleElement;
}

function createLinkElement() {
	var linkElement = document.createElement("link");
	var head = getHeadElement();
	linkElement.rel = "stylesheet";
	head.appendChild(linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement());
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement();
		update = updateLink.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement();
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			styleElement.parentNode.removeChild(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.modal", []);
})(window.angular);

__webpack_require__(53);

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./alk-icons.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./alk-icons.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, "i.ico,\nspan.ico {\n  display: inline-block;\n}\n.ico-lg {\n  font-size: 1.33333333em;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n.ico-stack {\n  position: relative;\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  line-height: 1em;\n  vertical-align: middle;\n}\n.ico-stack-1x,\n.ico-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.ico-stack-2x {\n  font-size: 2em;\n}\n.ico-inverse {\n  color: white;\n}\n.ico-inline {\n  font-size: 0.8em;\n}\n.ico-rotate-0 {\n  -webkit-transform: rotate(0);\n  -moz-transform: rotate(0);\n  -ms-transform: rotate(0);\n  -o-transform: rotate(0);\n  transform: rotate(0);\n  transition: transform 350ms ease;\n}\n.ico-rotate-180 {\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n  transition: transform 350ms ease;\n}\n.ico-spin {\n  -webkit-animation: spin 1s infinite linear;\n  -moz-animation: spin 1s infinite linear;\n  -o-animation: spin 1s infinite linear;\n  animation: spin 1s infinite linear;\n}\n@-moz-keyframes spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(359deg);\n  }\n}\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n  }\n}\n@-o-keyframes spin {\n  0% {\n    -o-transform: rotate(0deg);\n  }\n  100% {\n    -o-transform: rotate(359deg);\n  }\n}\n@-ms-keyframes spin {\n  0% {\n    -ms-transform: rotate(0deg);\n  }\n  100% {\n    -ms-transform: rotate(359deg);\n  }\n}\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n", ""]);

// exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./styles.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./styles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,300,400italic,600,800,700,700italic);", ""]);

// module
exports.push([module.i, "/* ALK framework */\n.alk-gray {\n  background: #667582;\n}\n.alk-darkblue {\n  background: #63a1cf;\n}\n.alk-lightblue {\n  background: #6ccff6;\n}\n.alk-green {\n  background: #b0d45d;\n}\n.alk-orange {\n  background: #fbb26a;\n}\n.cp-red {\n  background: #ed4747;\n}\n.pcm-darkblue {\n  background: #153660;\n}\n.pcm-blue {\n  background: #0079c2;\n}\n.pcm-red {\n  background: #c4161c;\n}\n.pageBackground {\n  background: #f1f1ec;\n}\n.dark-gray {\n  background: #2d343a;\n}\n.medium-gray {\n  background: #576571;\n}\n.light-gray {\n  background: #a9b6c1;\n}\n.alk-active {\n  background: #ffd941;\n}\n.info-color {\n  background: #3D8CBD;\n}\n.button-text {\n  background: #68a6dd;\n}\n.button-text-hover {\n  background: #538dc1;\n}\n.selectedColor {\n  background: #E7F4FF;\n}\n/* ============= Helper classes ========== */\n.cursor-pointer {\n  cursor: pointer;\n}\n.text-bold {\n  font-weight: 700;\n}\n.text-small {\n  font-size: 12px;\n}\n.small-caption {\n  font: small-caption;\n}\n.margin-LR-5 {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.text-ellipsis {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.form-control-basics {\n  padding: 3px 10px;\n  min-height: 26px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n}\n.fw-300 {\n  font-weight: 300;\n}\n.wrap-break-word {\n  word-wrap: break-word;\n}\n/* =========== Base Styles =============== */\nbody,\nhtml {\n  width: 100%;\n  height: 100%;\n}\nbody {\n  font-family: \"Open Sans\", sans-serif;\n  background-color: #f1f1ec;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo4MmQwNWZiYS1iYWUwLTllNDUtODgyMS1lMzlmOTlhMjU3YzEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OENDQTFCQTk0RkMzMTFFNDg5RTk5NTAwODY1ODJGRTYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OENDQTFCQTg0RkMzMTFFNDg5RTk5NTAwODY1ODJGRTYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OTk3YWEwODUtZTJjYy1iMjQyLWIwYWQtZDA2NzI0MTY2N2E1IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NTVmYjlmMzEtNGZjMy0xMWU0LTg5NjAtYTVlYzU5ODQxNjJhIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+TRtWpAAAAB9JREFUeNpiZGBg4GBAAygCTOiyLDDG////wTRAgAEAGXMDFY5o8tUAAAAASUVORK5CYII=');\n}\ntable,\ntr,\ntd {\n  padding: 0;\n}\ntable.table-small td,\ntable.table-small th {\n  font-size: 12px;\n}\ntd.center {\n  text-align: center;\n}\nth,\ntd.footer {\n  font-size: 12px;\n  font-weight: 400;\n}\nstrong {\n  font-weight: 600;\n}\n.nav,\n.pagination,\n.carousel,\n.panel-title a {\n  cursor: pointer;\n}\n.legal-text {\n  font-size: 11px;\n  line-height: 20px;\n  margin-left: 10px;\n}\n.orange-bar {\n  width: 100%;\n  background-color: #ffa500;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.orange-bar .container {\n  color: #ffffff;\n  font-size: 1.5rem;\n}\n.orange-bar .container .text-lft .r {\n  font-size: 12px !important;\n  line-height: 2rem;\n  vertical-align: top;\n}\n.orange-bar .container .text-rght {\n  float: right;\n  font-weight: 600;\n}\n.container.with-nav {\n  margin-top: 110px;\n}\n.error-header {\n  text-align: center;\n  background: #c4161c;\n  color: white;\n}\n.popup-content-container {\n  overflow: hidden;\n  padding: 0 !important;\n}\n.popup-content-container .popup-content {\n  width: 100% !important;\n  padding: 0;\n  margin: 0;\n}\n.popup-text {\n  padding: 5px 10px;\n  font-size: 12px;\n}\n.olControlPanZoomBar {\n  display: none;\n}\n.hide-closure-set-opts {\n  display: none;\n}\n.olControlScaleLine {\n  bottom: 8px !important;\n  right: 10px !important;\n}\n#footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  height: 20px;\n  overflow: hidden;\n  -moz-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.15);\n  -webkit-box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  color: #ccc;\n  background-color: #3B3C3F;\n}\n#footer a {\n  color: #68a6dd;\n}\n#footer a:hover {\n  color: #538dc1;\n}\n#locator-panel p,\n#mouse-position,\n#grid-data-version,\n#user-info {\n  padding: 1px 8px;\n  font-size: 11px;\n  color: #999;\n  margin-bottom: 0;\n  line-height: 18px;\n}\n#mouse-position {\n  border-left: 1px solid #999;\n  border-right: 1px solid #999;\n}\n#grid-data-version {\n  border-left: 1px solid #999;\n}\n.ico-info-color {\n  color: #3D8CBD;\n}\n/* ============== Buttons ============== */\n.btn strong {\n  font-weight: 700;\n}\n.btn .ico {\n  position: relative;\n  margin-right: 3px;\n  margin-left: -3px;\n}\n.btn.btn-icon-only .ico {\n  margin: 0;\n}\n.btn-info,\n.btn-warning {\n  color: #222;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.54);\n}\n.btn-info:hover,\n.btn-warning:hover {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);\n}\n.btn-link[disabled] {\n  color: #ccc;\n}\n.btn-default:hover,\n.btn-default:focus,\n.btn-default:active,\n.btn-default.active,\n.open > .dropdown-toggle.btn-default {\n  background-color: #edf7ff;\n  border-color: #68a6dd;\n}\n.btn-save {\n  position: relative;\n}\n.btn-save.btn-sm {\n  height: 26px;\n}\n.btn-delete {\n  border-radius: 50%;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 15px;\n  margin-top: 4px;\n  background-color: #FFFFFF;\n  border-color: #CE8689;\n  color: #D05252;\n}\n.btn-delete:hover {\n  background-color: #CC3A3A;\n  border-color: #862F31;\n  color: #fff;\n}\n.btn.btn-outline {\n  background-color: transparent;\n  border-color: #9f9f9f;\n  color: #9f9f9f;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.btn.btn-fake-addon {\n  color: #777;\n  border: 1px solid #ddd;\n  background-color: #eee;\n  text-align: center;\n  padding-left: 6px;\n  padding-right: 6px;\n  cursor: default;\n}\n.btn.btn-fake-addon .ico {\n  margin: 0;\n}\n.map-btns {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.btn.map-btn {\n  padding: 7px 7px 2px;\n}\n.btn.map-btn .ico {\n  font-size: 21px;\n  line-height: 1;\n  margin: 0;\n}\n.map-btn.btn-default.btn-nofocus:focus {\n  background-color: #ffffff;\n  border-color: #ccc;\n}\n.btn.btn-faux {\n  background: transparent;\n  cursor: default;\n  padding-left: 0;\n  padding-right: 0;\n  font-weight: 700;\n}\n.button-state {\n  opacity: 1;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  line-height: 2;\n}\n.button-state.ng-hide-add,\n.button-state.ng-hide-remove {\n  -webkit-transition: all linear 0.5s;\n  transition: all linear 0.5s;\n}\n.button-state.ng-hide {\n  opacity: 0;\n}\n.btn-xs.btn-cluster {\n  padding: 0px 3px 2px;\n  font-size: 17px;\n  line-height: 1;\n}\n/* ========= Third-party Overrides ============= */\n.ui-select-bootstrap .btn.form-control {\n  height: auto !important;\n  min-height: 26px;\n}\n.ui-select-bootstrap .dropdown-menu {\n  font-size: 12px;\n}\n.ui-select-toggle {\n  height: 26px;\n  padding: 5px 5px 1px;\n  font-size: 12px;\n  border-radius: 3px;\n  color: #333;\n  font-weight: 600;\n  border-radius: 2px;\n  line-height: 15px;\n}\n.ui-select-toggle:hover {\n  background-color: white;\n}\n.ui-select-toggle .caret {\n  border-top: 5px dashed;\n  border-right: 3px solid transparent;\n  border-left: 3px solid transparent;\n}\n.ui-select-choices-row {\n  padding: 4px 6px;\n  line-height: 1.2;\n}\n.ui-select-choices-row a,\n.ui-select-choices-row a:hover {\n  text-decoration: none;\n  color: #000;\n}\n.ui-select-match-item.ellipsis-btn {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n}\n.switch {\n  background: rgba(165, 165, 165, 0.15);\n  border-top-color: #c3c3c3;\n  border-left-color: #c3c3c3;\n  width: 22px;\n  height: 13px;\n}\n.switch small {\n  width: 12px;\n  height: 12px;\n  left: 1px;\n}\n.switch.checked {\n  border-color: rgba(255, 255, 255, 0.36);\n  background: rgba(165, 165, 165, 0.35);\n}\n.switch.checked small {\n  left: 11px;\n}\n/* =========== Basic Elements =========== */\n.page-container .container {\n  margin-top: 110px;\n}\n.datetimepicker-days th.switch {\n  display: table-cell;\n}\n.glyphicon-option-vertical:before {\n  content: \"\\E235\";\n}\n.checkbox.inline-checkbox {\n  margin: 3px 0 0 8px;\n}\n.badge {\n  font-weight: 400;\n  font-size: 11px;\n  background-color: #a9c1d6;\n  padding: 3px 6px 4px;\n}\n.dropdown-menu .btn-menu {\n  width: 100%;\n  text-align: left;\n  text-decoration: none;\n}\n.dropdown-menu .btn-menu:hover {\n  background-color: #d9edf7;\n}\n.dropdown-menu li > a {\n  font-size: 12px;\n}\n.dropdown-menu li > a > .ico {\n  margin-left: -8px;\n  margin-right: 3px;\n  color: #757575;\n}\n.list-group-item {\n  font-size: 13px;\n}\na.list-group-item:focus {\n  background-color: #edf7ff;\n}\na.list-group-item:hover {\n  background-color: #fffbe5;\n}\n.label-sm {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n.label-light {\n  color: #333;\n  font-weight: 300;\n  padding-top: 4px;\n  background-color: #eee;\n}\n.label-outline {\n  display: inline-block;\n  color: #333;\n  font-weight: 300;\n  padding-top: 4px;\n  background-color: transparent;\n  border: 1px solid #ddd;\n  box-sizing: border-box;\n}\n.label-status {\n  font-size: 12px;\n  font-weight: 400;\n  padding-bottom: 3px;\n}\n.label-group *[class*=\"label-\"] {\n  display: inline-block;\n  margin-top: 5px;\n}\n.form-group.sm {\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n.form-group.sm *[class*=\"col-\"] {\n  padding-right: 7px;\n  padding-left: 7px;\n}\n.alert-sm {\n  font-size: 12px;\n  margin-bottom: 0;\n  top: -2px;\n  position: relative;\n  padding: 5px;\n}\n.popup-actions {\n  margin-top: 8px;\n}\n.form-group .alert {\n  margin: 0;\n}\n.placeholder-text {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.tooltip-icon {\n  color: #3D8CBD;\n}\n.tooltip {\n  opacity: 1;\n}\n.tooltip.bottom .tooltip-arrow {\n  border-bottom-color: #3D8CBD;\n}\n.tooltip.top .tooltip-arrow {\n  border-top-color: #3D8CBD;\n}\n.tooltip.left .tooltip-arrow {\n  border-left-color: #3D8CBD;\n}\n.tooltip.right .tooltip-arrow {\n  border-right-color: #3D8CBD;\n}\n.tooltip-inner {\n  background-color: #3D8CBD;\n}\n.alert {\n  background-image: none;\n  box-shadow: none;\n  font-weight: 600;\n}\n.alert-warning {\n  color: #C77A2E;\n}\n.alert-danger {\n  color: #CA1E1B;\n}\n.tab-content {\n  border: 1px solid #dddddd;\n  border-top: 0;\n  padding: 10px;\n  margin-bottom: 10px;\n}\n.nav-tabs > li > a {\n  padding: 2px 10px 4px;\n  font-size: 13px;\n}\n/* ======== Custom elements ============= */\n.selection-conditional {\n  background-color: #fffbe5;\n  border: 1px solid #ffeb7f;\n  padding: 4px 10px;\n}\n.selection-conditional p {\n  font-size: 13px;\n  font-weight: 600;\n  margin: 0;\n}\n.column-table {\n  font-size: 12px;\n  margin: 15px -15px -15px;\n  padding: 0;\n}\n.column-table .column-table-scroll {\n  overflow-y: scroll;\n  max-height: 500px;\n}\n.column-table .row {\n  border-bottom: 1px solid #ddd;\n  margin: 0;\n}\n.column-table .row.column-table-header {\n  width: calc(100% - 17px);\n  font-weight: 600;\n}\n.column-table .row [class*=\"col-\"] {\n  padding: 5px 10px;\n}\n.expand-container {\n  width: 18px;\n  height: 18px;\n  padding: 4px;\n  border: 1px solid #576571;\n  cursor: pointer;\n  border-radius: 50%;\n  margin-left: 5px;\n}\n.expand-button {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  /* Vertical line */\n  /* horizontal line */\n}\n.expand-button:before,\n.expand-button:after {\n  content: \"\";\n  position: absolute;\n  background-color: #576571;\n  -webkit-transition: -webkit-transform 0.25s ease-out;\n  transition: -webkit-transform 0.25s ease-out;\n  transition: transform 0.25s ease-out;\n  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;\n}\n.expand-button:before {\n  top: 0;\n  left: 50%;\n  width: 2px;\n  height: 100%;\n  margin-left: -1px;\n}\n.expand-button:after {\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  margin-top: -1px;\n}\n.expand-button.open:before {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.expand-button.open:after {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.stop-num {\n  width: 25px;\n  overflow: visible;\n  position: relative;\n}\n.stop-num .stop-line {\n  display: block;\n  left: 9px;\n  width: 7px;\n  position: absolute;\n  top: 0;\n  bottom: -1px;\n  z-index: 0;\n  opacity: 0.5;\n  background-color: #ccc;\n}\n.stop-num .stop-line.origin {\n  top: 50%;\n}\n.stop-num .stop-line.destination {\n  bottom: 50%;\n}\n.stop-num span.circle {\n  -moz-border-radius: 9px;\n  -webkit-border-radius: 9px;\n  border-radius: 9px;\n  border: 2px solid;\n  font-size: 10px;\n  font-weight: 700;\n  width: 17px;\n  height: 17px;\n  display: inline-block;\n  padding: 0 0 1px 0;\n  position: relative;\n  background-color: white;\n  border-color: #444;\n  color: #444;\n  line-height: 12px;\n  -moz-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);\n  letter-spacing: -0.4px;\n  text-align: center;\n  margin-left: 2px;\n  text-indent: -0.9px;\n  z-index: 10;\n}\n.stop-num span.circle.origin {\n  color: #259800 !important;\n  border-color: #279E00 !important;\n  border-width: 5px;\n}\n.stop-num span.circle.unknown {\n  background-color: #fff;\n  border-color: #999;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 11px;\n  padding-top: 1px;\n  color: #aaa;\n}\n.stop-num span.circle.destination {\n  color: #be2525 !important;\n  border-color: #be2525 !important;\n  text-indent: 0;\n  border-width: 5px;\n}\n/* =========== Panels and Modals ============= */\n.ui-panel {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background-color: white;\n  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2px;\n  -webkit-transition: all ease-in-out 0.3s;\n  transition: all ease-in-out 0.3s;\n}\n.ui-panel.right-panel {\n  right: 0;\n  border-left: 1px solid #ccc;\n}\n.ui-panel.left-panel {\n  left: 0;\n  overflow: hidden;\n  border-right: 1px solid #ccc;\n}\n.ui-panel.closed {\n  width: 0;\n  padding: 0;\n  border: 0;\n  box-shadow: none;\n  overflow: hidden;\n}\n.panel {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding: 5px;\n}\n.panel.panel-popup,\n.modal.panel-popup,\n.popover.panel-popup {\n  border: 0;\n  box-shadow: none;\n  margin-bottom: 0;\n  height: 100%;\n  position: relative;\n}\n.panel.panel-popup .panel-heading,\n.modal.panel-popup .panel-heading,\n.popover.panel-popup .panel-heading {\n  height: auto;\n  margin-bottom: 0;\n}\n.panel.panel-popup .panel-heading h4,\n.modal.panel-popup .panel-heading h4,\n.popover.panel-popup .panel-heading h4 {\n  margin: 0;\n  text-indent: 10px;\n}\n.panel.panel-popup .panel-footer,\n.modal.panel-popup .panel-footer,\n.popover.panel-popup .panel-footer {\n  position: absolute;\n  bottom: 5px;\n  width: 100%;\n}\n.panel.panel-page,\n.modal.panel-page,\n.popover.panel-page {\n  padding: 40px 30px;\n}\n.panel.panel-fixed,\n.modal.panel-fixed,\n.popover.panel-fixed {\n  background-color: white;\n  box-shadow: none;\n  border: 0;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n.panel.panel-fixed .panel-body,\n.modal.panel-fixed .panel-body,\n.popover.panel-fixed .panel-body {\n  position: absolute;\n  padding: 10px;\n  top: 55px;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n.panel.panel-floating .panel-heading,\n.modal.panel-floating .panel-heading,\n.popover.panel-floating .panel-heading {\n  height: 35px;\n}\n.panel.panel-floating .panel-heading h4.panel-name,\n.modal.panel-floating .panel-heading h4.panel-name,\n.popover.panel-floating .panel-heading h4.panel-name {\n  height: auto;\n  font-size: 15px;\n  margin: 5px 0;\n}\n.panel.panel-floating .panel-heading .btn-link,\n.modal.panel-floating .panel-heading .btn-link,\n.popover.panel-floating .panel-heading .btn-link {\n  color: #777;\n}\n.panel.panel-floating.closed,\n.modal.panel-floating.closed,\n.popover.panel-floating.closed {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n.panel.panel-floating.closed .panel-heading,\n.modal.panel-floating.closed .panel-heading,\n.popover.panel-floating.closed .panel-heading {\n  margin-bottom: 0;\n  border-radius: 3px;\n}\n.panel.page-panel,\n.modal.page-panel,\n.popover.page-panel {\n  border-radius: 0;\n}\n.panel.page-panel .panel-heading,\n.modal.page-panel .panel-heading,\n.popover.page-panel .panel-heading {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.panel .popup-form-container,\n.modal .popup-form-container,\n.popover .popup-form-container {\n  border: 0;\n  background: none;\n  margin: 5px;\n}\n.panel .panel-heading,\n.modal .panel-heading,\n.popover .panel-heading,\n.panel .modal-header,\n.modal .modal-header,\n.popover .modal-header {\n  margin: -5px -5px 5px;\n  background-color: #fff;\n  background-image: none;\n  z-index: 100;\n  padding: 7px 10px;\n  border-bottom: 1px solid #ccc;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);\n  -js-display: flex;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 50px;\n}\n.panel .panel-heading .btn,\n.modal .panel-heading .btn,\n.popover .panel-heading .btn,\n.panel .modal-header .btn,\n.modal .modal-header .btn,\n.popover .modal-header .btn {\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n  align-self: center;\n}\n.panel .panel-heading .btn-sm,\n.modal .panel-heading .btn-sm,\n.popover .panel-heading .btn-sm,\n.panel .modal-header .btn-sm,\n.modal .modal-header .btn-sm,\n.popover .modal-header .btn-sm,\n.panel .panel-heading .no-button,\n.modal .panel-heading .no-button,\n.popover .panel-heading .no-button,\n.panel .modal-header .no-button,\n.modal .modal-header .no-button,\n.popover .modal-header .no-button {\n  min-width: 60px;\n  padding: 3px 8px;\n}\n.panel .panel-heading .panel-name,\n.modal .panel-heading .panel-name,\n.popover .panel-heading .panel-name,\n.panel .modal-header .panel-name,\n.modal .modal-header .panel-name,\n.popover .modal-header .panel-name,\n.panel .panel-heading .modal-title,\n.modal .panel-heading .modal-title,\n.popover .panel-heading .modal-title,\n.panel .modal-header .modal-title,\n.modal .modal-header .modal-title,\n.popover .modal-header .modal-title {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n  height: 30px;\n  padding: 3px 7px;\n  margin: 5px 0 0;\n}\n.panel .panel-heading .panel-name .panel-name-text,\n.modal .panel-heading .panel-name .panel-name-text,\n.popover .panel-heading .panel-name .panel-name-text,\n.panel .modal-header .panel-name .panel-name-text,\n.modal .modal-header .panel-name .panel-name-text,\n.popover .modal-header .panel-name .panel-name-text,\n.panel .panel-heading .modal-title .panel-name-text,\n.modal .panel-heading .modal-title .panel-name-text,\n.popover .panel-heading .modal-title .panel-name-text,\n.panel .modal-header .modal-title .panel-name-text,\n.modal .modal-header .modal-title .panel-name-text,\n.popover .modal-header .modal-title .panel-name-text,\n.panel .panel-heading .panel-name .modal-name-text,\n.modal .panel-heading .panel-name .modal-name-text,\n.popover .panel-heading .panel-name .modal-name-text,\n.panel .modal-header .panel-name .modal-name-text,\n.modal .modal-header .panel-name .modal-name-text,\n.popover .modal-header .panel-name .modal-name-text,\n.panel .panel-heading .modal-title .modal-name-text,\n.modal .panel-heading .modal-title .modal-name-text,\n.popover .panel-heading .modal-title .modal-name-text,\n.panel .modal-header .modal-title .modal-name-text,\n.modal .modal-header .modal-title .modal-name-text,\n.popover .modal-header .modal-title .modal-name-text {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  opacity: 1;\n  padding: 3px 7px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.panel .panel-heading .panel-name .panel-name-text.ng-hide-add,\n.modal .panel-heading .panel-name .panel-name-text.ng-hide-add,\n.popover .panel-heading .panel-name .panel-name-text.ng-hide-add,\n.panel .modal-header .panel-name .panel-name-text.ng-hide-add,\n.modal .modal-header .panel-name .panel-name-text.ng-hide-add,\n.popover .modal-header .panel-name .panel-name-text.ng-hide-add,\n.panel .panel-heading .modal-title .panel-name-text.ng-hide-add,\n.modal .panel-heading .modal-title .panel-name-text.ng-hide-add,\n.popover .panel-heading .modal-title .panel-name-text.ng-hide-add,\n.panel .modal-header .modal-title .panel-name-text.ng-hide-add,\n.modal .modal-header .modal-title .panel-name-text.ng-hide-add,\n.popover .modal-header .modal-title .panel-name-text.ng-hide-add,\n.panel .panel-heading .panel-name .modal-name-text.ng-hide-add,\n.modal .panel-heading .panel-name .modal-name-text.ng-hide-add,\n.popover .panel-heading .panel-name .modal-name-text.ng-hide-add,\n.panel .modal-header .panel-name .modal-name-text.ng-hide-add,\n.modal .modal-header .panel-name .modal-name-text.ng-hide-add,\n.popover .modal-header .panel-name .modal-name-text.ng-hide-add,\n.panel .panel-heading .modal-title .modal-name-text.ng-hide-add,\n.modal .panel-heading .modal-title .modal-name-text.ng-hide-add,\n.popover .panel-heading .modal-title .modal-name-text.ng-hide-add,\n.panel .modal-header .modal-title .modal-name-text.ng-hide-add,\n.modal .modal-header .modal-title .modal-name-text.ng-hide-add,\n.popover .modal-header .modal-title .modal-name-text.ng-hide-add,\n.panel .panel-heading .panel-name .panel-name-text.ng-hide-remove,\n.modal .panel-heading .panel-name .panel-name-text.ng-hide-remove,\n.popover .panel-heading .panel-name .panel-name-text.ng-hide-remove,\n.panel .modal-header .panel-name .panel-name-text.ng-hide-remove,\n.modal .modal-header .panel-name .panel-name-text.ng-hide-remove,\n.popover .modal-header .panel-name .panel-name-text.ng-hide-remove,\n.panel .panel-heading .modal-title .panel-name-text.ng-hide-remove,\n.modal .panel-heading .modal-title .panel-name-text.ng-hide-remove,\n.popover .panel-heading .modal-title .panel-name-text.ng-hide-remove,\n.panel .modal-header .modal-title .panel-name-text.ng-hide-remove,\n.modal .modal-header .modal-title .panel-name-text.ng-hide-remove,\n.popover .modal-header .modal-title .panel-name-text.ng-hide-remove,\n.panel .panel-heading .panel-name .modal-name-text.ng-hide-remove,\n.modal .panel-heading .panel-name .modal-name-text.ng-hide-remove,\n.popover .panel-heading .panel-name .modal-name-text.ng-hide-remove,\n.panel .modal-header .panel-name .modal-name-text.ng-hide-remove,\n.modal .modal-header .panel-name .modal-name-text.ng-hide-remove,\n.popover .modal-header .panel-name .modal-name-text.ng-hide-remove,\n.panel .panel-heading .modal-title .modal-name-text.ng-hide-remove,\n.modal .panel-heading .modal-title .modal-name-text.ng-hide-remove,\n.popover .panel-heading .modal-title .modal-name-text.ng-hide-remove,\n.panel .modal-header .modal-title .modal-name-text.ng-hide-remove,\n.modal .modal-header .modal-title .modal-name-text.ng-hide-remove,\n.popover .modal-header .modal-title .modal-name-text.ng-hide-remove {\n  -webkit-transition: all linear 0.5s;\n  transition: all linear 0.5s;\n}\n.panel .panel-heading .panel-name .panel-name-text.ng-hide,\n.modal .panel-heading .panel-name .panel-name-text.ng-hide,\n.popover .panel-heading .panel-name .panel-name-text.ng-hide,\n.panel .modal-header .panel-name .panel-name-text.ng-hide,\n.modal .modal-header .panel-name .panel-name-text.ng-hide,\n.popover .modal-header .panel-name .panel-name-text.ng-hide,\n.panel .panel-heading .modal-title .panel-name-text.ng-hide,\n.modal .panel-heading .modal-title .panel-name-text.ng-hide,\n.popover .panel-heading .modal-title .panel-name-text.ng-hide,\n.panel .modal-header .modal-title .panel-name-text.ng-hide,\n.modal .modal-header .modal-title .panel-name-text.ng-hide,\n.popover .modal-header .modal-title .panel-name-text.ng-hide,\n.panel .panel-heading .panel-name .modal-name-text.ng-hide,\n.modal .panel-heading .panel-name .modal-name-text.ng-hide,\n.popover .panel-heading .panel-name .modal-name-text.ng-hide,\n.panel .modal-header .panel-name .modal-name-text.ng-hide,\n.modal .modal-header .panel-name .modal-name-text.ng-hide,\n.popover .modal-header .panel-name .modal-name-text.ng-hide,\n.panel .panel-heading .modal-title .modal-name-text.ng-hide,\n.modal .panel-heading .modal-title .modal-name-text.ng-hide,\n.popover .panel-heading .modal-title .modal-name-text.ng-hide,\n.panel .modal-header .modal-title .modal-name-text.ng-hide,\n.modal .modal-header .modal-title .modal-name-text.ng-hide,\n.popover .modal-header .modal-title .modal-name-text.ng-hide {\n  opacity: 0;\n}\n.panel .panel-heading .panel-name button,\n.modal .panel-heading .panel-name button,\n.popover .panel-heading .panel-name button,\n.panel .modal-header .panel-name button,\n.modal .modal-header .panel-name button,\n.popover .modal-header .panel-name button,\n.panel .panel-heading .modal-title button,\n.modal .panel-heading .modal-title button,\n.popover .panel-heading .modal-title button,\n.panel .modal-header .modal-title button,\n.modal .modal-header .modal-title button,\n.popover .modal-header .modal-title button {\n  top: -3px;\n  position: relative;\n}\n.panel .panel-heading .panel-head-icon,\n.modal .panel-heading .panel-head-icon,\n.popover .panel-heading .panel-head-icon,\n.panel .modal-header .panel-head-icon,\n.modal .modal-header .panel-head-icon,\n.popover .modal-header .panel-head-icon {\n  margin: 0 5px;\n  color: #666;\n}\n.panel .panel-heading .panel-name-left-only,\n.modal .panel-heading .panel-name-left-only,\n.popover .panel-heading .panel-name-left-only,\n.panel .modal-header .panel-name-left-only,\n.modal .modal-header .panel-name-left-only,\n.popover .modal-header .panel-name-left-only {\n  padding-right: 60px;\n}\n.panel .modal-header,\n.modal .modal-header,\n.popover .modal-header {\n  margin: 0;\n  border-radius: 5px 5px 0 0;\n}\n.panel .panel-body,\n.modal .panel-body,\n.popover .panel-body {\n  overflow: auto;\n  padding: 0;\n}\n.panel .panel-body .btn.pull-right,\n.modal .panel-body .btn.pull-right,\n.popover .panel-body .btn.pull-right {\n  margin-right: 5px;\n}\n.panel .panel-body .btn.pull-right:first-of-type,\n.modal .panel-body .btn.pull-right:first-of-type,\n.popover .panel-body .btn.pull-right:first-of-type {\n  margin-right: 0;\n}\n.panel .panel-footer,\n.modal .panel-footer,\n.popover .panel-footer {\n  margin: 0 -5px -5px -5px;\n  padding: 5px 15px;\n}\n.panel .modal-footer,\n.modal .modal-footer,\n.popover .modal-footer {\n  padding: 10px 15px;\n  background-color: #eee;\n  border-radius: 0 0 5px 5px;\n}\n.panel ul,\n.modal ul,\n.popover ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.panel ul li,\n.modal ul li,\n.popover ul li {\n  list-style: none;\n}\n.panel ul li:focus,\n.modal ul li:focus,\n.popover ul li:focus {\n  outline: 0;\n}\n.panel ol,\n.modal ol,\n.popover ol {\n  padding-left: 15px;\n}\n.panel ol li,\n.modal ol li,\n.popover ol li {\n  margin: 5px 0;\n}\n.panel .filter-group,\n.modal .filter-group,\n.popover .filter-group {\n  margin-bottom: 5px;\n}\n.panel .form-inline .btn .ico,\n.modal .form-inline .btn .ico,\n.popover .form-inline .btn .ico {\n  top: 1px;\n}\n.panel .input-group .input-group-btn .btn,\n.modal .input-group .input-group-btn .btn,\n.popover .input-group .input-group-btn .btn {\n  min-width: 26px;\n}\n.panel .input-group .input-group-addon,\n.modal .input-group .input-group-addon,\n.popover .input-group .input-group-addon {\n  background-color: #f9f9f9;\n  border-color: #e8e8e8;\n  color: #aaa;\n  padding: 4px 9px !important;\n  border-radius: 2px;\n}\n.date .panel .input-group .input-group-addon,\n.date .modal .input-group .input-group-addon,\n.date .popover .input-group .input-group-addon {\n  line-height: 13px;\n}\n.panel .input-group input.form-control,\n.modal .input-group input.form-control,\n.popover .input-group input.form-control {\n  margin-bottom: 0;\n}\n.panel .info-text,\n.modal .info-text,\n.popover .info-text {\n  font-size: 12px;\n  line-height: 13px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  color: #2e8ada;\n  background-color: #edf7ff;\n  padding: 10px 10px 10px 23px;\n  border: 1px solid #e1f1ff;\n  border-radius: 3px;\n}\n.panel .info-text p,\n.modal .info-text p,\n.popover .info-text p {\n  text-indent: -8px;\n  margin-bottom: 0;\n}\n.panel .info-text .ico,\n.modal .info-text .ico,\n.popover .info-text .ico {\n  color: rgba(61, 140, 189, 0.7);\n  position: relative;\n  top: 1px;\n}\n.panel .info-text:last-child,\n.modal .info-text:last-child,\n.popover .info-text:last-child {\n  margin-bottom: 0;\n}\n.panel .sub-panel-title,\n.modal .sub-panel-title,\n.popover .sub-panel-title {\n  color: #333;\n  font-size: 13px;\n  text-align: left;\n  padding-left: 3px;\n  line-height: 23px;\n  vertical-align: top;\n  font-weight: 600;\n  cursor: pointer;\n  z-index: 100;\n}\n.panel fieldset,\n.modal fieldset,\n.popover fieldset,\n.panel div.fieldset,\n.modal div.fieldset,\n.popover div.fieldset {\n  padding: 0 0 8px;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #ddd;\n}\n.panel fieldset.no-border,\n.modal fieldset.no-border,\n.popover fieldset.no-border,\n.panel div.fieldset.no-border,\n.modal div.fieldset.no-border,\n.popover div.fieldset.no-border {\n  border-bottom: 0;\n}\n.panel label,\n.modal label,\n.popover label {\n  font-size: 11px;\n  font-weight: 400;\n  color: #aaa;\n}\n.panel label.btn-file,\n.modal label.btn-file,\n.popover label.btn-file {\n  width: auto;\n  font-size: 12px;\n  color: #333;\n  display: block;\n  margin-left: 5px;\n}\n.panel label.inline,\n.modal label.inline,\n.popover label.inline {\n  font-size: 12px;\n  font-weight: 600;\n  color: #777;\n}\n.panel label.filler,\n.modal label.filler,\n.popover label.filler {\n  width: 100%;\n}\n.panel .field-section,\n.modal .field-section,\n.popover .field-section {\n  font-size: 13px;\n  font-weight: 400;\n  padding-top: 10px;\n  margin: 0px 0px 10px;\n  color: #63a1cf;\n}\n.panel .field-section .tooltip-icon,\n.modal .field-section .tooltip-icon,\n.popover .field-section .tooltip-icon,\n.panel .field-section .tooltip,\n.modal .field-section .tooltip,\n.popover .field-section .tooltip {\n  text-transform: none !important;\n  letter-spacing: 0;\n}\n.panel div.checkbox,\n.modal div.checkbox,\n.popover div.checkbox {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.panel div.checkbox label,\n.modal div.checkbox label,\n.popover div.checkbox label {\n  font-size: 12px;\n  line-height: 15px;\n  color: #333;\n  font-weight: 600;\n}\n.panel div.checkbox label input,\n.modal div.checkbox label input,\n.popover div.checkbox label input {\n  top: 0;\n}\n.panel div.checkbox.disabled label,\n.modal div.checkbox.disabled label,\n.popover div.checkbox.disabled label {\n  color: #aaa;\n}\n.panel div.checkbox.small-top-margin,\n.modal div.checkbox.small-top-margin,\n.popover div.checkbox.small-top-margin {\n  margin-top: 10px !important;\n}\n.panel .radio label,\n.modal .radio label,\n.popover .radio label,\n.panel .checkbox label,\n.modal .checkbox label,\n.popover .checkbox label {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #333;\n}\n.panel option:disabled,\n.modal option:disabled,\n.popover option:disabled {\n  color: #ccc;\n}\n.panel legend,\n.modal legend,\n.popover legend,\n.panel h5.legend,\n.modal h5.legend,\n.popover h5.legend,\n.panel.panel-popup .panel-heading h4,\n.modal.panel-popup .panel-heading h4,\n.popover.panel-popup .panel-heading h4,\n.panel .modal-header h4,\n.modal .modal-header h4,\n.popover .modal-header h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #63a1cf;\n  border-bottom: 0;\n  width: 100%;\n  padding: 5px 0;\n  margin-bottom: 0;\n}\n.panel legend .btn .ico,\n.modal legend .btn .ico,\n.popover legend .btn .ico,\n.panel h5.legend .btn .ico,\n.modal h5.legend .btn .ico,\n.popover h5.legend .btn .ico,\n.panel.panel-popup .panel-heading h4 .btn .ico,\n.modal.panel-popup .panel-heading h4 .btn .ico,\n.popover.panel-popup .panel-heading h4 .btn .ico,\n.panel .modal-header h4 .btn .ico,\n.modal .modal-header h4 .btn .ico,\n.popover .modal-header h4 .btn .ico {\n  top: 1px;\n}\n.panel legend .btn-group,\n.modal legend .btn-group,\n.popover legend .btn-group,\n.panel h5.legend .btn-group,\n.modal h5.legend .btn-group,\n.popover h5.legend .btn-group,\n.panel.panel-popup .panel-heading h4 .btn-group,\n.modal.panel-popup .panel-heading h4 .btn-group,\n.popover.panel-popup .panel-heading h4 .btn-group,\n.panel .modal-header h4 .btn-group,\n.modal .modal-header h4 .btn-group,\n.popover .modal-header h4 .btn-group {\n  margin-top: 4px;\n}\n.panel legend > .ico,\n.modal legend > .ico,\n.popover legend > .ico,\n.panel h5.legend > .ico,\n.modal h5.legend > .ico,\n.popover h5.legend > .ico,\n.panel.panel-popup .panel-heading h4 > .ico,\n.modal.panel-popup .panel-heading h4 > .ico,\n.popover.panel-popup .panel-heading h4 > .ico,\n.panel .modal-header h4 > .ico,\n.modal .modal-header h4 > .ico,\n.popover .modal-header h4 > .ico {\n  font-size: 19px;\n  margin-right: 3px;\n  top: 3px;\n  position: relative;\n}\n.panel h5.legend,\n.modal h5.legend,\n.popover h5.legend {\n  margin-left: 0;\n  padding-right: 0;\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n.panel legend .btn,\n.modal legend .btn,\n.popover legend .btn {\n  margin-top: 0;\n}\n.panel .list-group,\n.modal .list-group,\n.popover .list-group {\n  box-shadow: none;\n}\n.panel .list-group:last-of-type,\n.modal .list-group:last-of-type,\n.popover .list-group:last-of-type {\n  margin-bottom: 0;\n}\n.panel .list-group.with-sections,\n.modal .list-group.with-sections,\n.popover .list-group.with-sections {\n  margin-top: -20px;\n}\n.panel .list-group .list-group-item.list-group-section,\n.modal .list-group .list-group-item.list-group-section,\n.popover .list-group .list-group-item.list-group-section {\n  font-weight: 700;\n  font-size: 13px;\n  background-color: #F5F5F5;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  margin-top: 20px;\n  min-height: 30px;\n}\n.panel .list-group .list-group-item.list-group-section .label-status,\n.modal .list-group .list-group-item.list-group-section .label-status,\n.popover .list-group .list-group-item.list-group-section .label-status {\n  font-size: 13px;\n  font-weight: 400;\n  top: -1px;\n  position: relative;\n  left: -13px;\n  padding: 2px 8px 4px;\n}\n.panel .list-group .list-group-item.list-group-section.closed,\n.modal .list-group .list-group-item.list-group-section.closed,\n.popover .list-group .list-group-item.list-group-section.closed {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.panel .list-group .list-group-item.info-item,\n.modal .list-group .list-group-item.info-item,\n.popover .list-group .list-group-item.info-item {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: -15px;\n  border-radius: 4px;\n  padding: 5px;\n}\n.panel .list-group .list-group-item fieldset,\n.modal .list-group .list-group-item fieldset,\n.popover .list-group .list-group-item fieldset {\n  border-radius: 0;\n}\n.panel .list-group .list-group-item fieldset:last-of-type,\n.modal .list-group .list-group-item fieldset:last-of-type,\n.popover .list-group .list-group-item fieldset:last-of-type {\n  border-bottom: 0;\n  margin-bottom: -10px;\n}\n.panel input.form-control,\n.modal input.form-control,\n.popover input.form-control {\n  font-size: 12px;\n  font-weight: 600;\n  height: 26px;\n  padding: 0 12px;\n  margin-bottom: 5px;\n  border-radius: 2px;\n}\n.panel input.form-control::-webkit-input-placeholder,\n.modal input.form-control::-webkit-input-placeholder,\n.popover input.form-control::-webkit-input-placeholder {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.panel input.form-control:-moz-placeholder,\n.modal input.form-control:-moz-placeholder,\n.popover input.form-control:-moz-placeholder {\n  /* Firefox 18- */\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.panel input.form-control::-moz-placeholder,\n.modal input.form-control::-moz-placeholder,\n.popover input.form-control::-moz-placeholder {\n  /* Firefox 19+ */\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.panel input.form-control:-ms-input-placeholder,\n.modal input.form-control:-ms-input-placeholder,\n.popover input.form-control:-ms-input-placeholder {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.panel input.form-control::-ms-clear,\n.modal input.form-control::-ms-clear,\n.popover input.form-control::-ms-clear {\n  display: none;\n}\n.panel textarea,\n.modal textarea,\n.popover textarea {\n  font-size: 12px;\n}\n.panel select,\n.modal select,\n.popover select {\n  padding: 3px 10px;\n  min-height: 26px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n  padding-right: 0px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.panel .form-group,\n.modal .form-group,\n.popover .form-group {\n  margin-bottom: 5px;\n}\n.panel .form-group select,\n.modal .form-group select,\n.popover .form-group select {\n  width: 100%;\n}\n.panel .form-group:last-child,\n.modal .form-group:last-child,\n.popover .form-group:last-child {\n  margin-bottom: 0;\n}\n.panel .form-section,\n.modal .form-section,\n.popover .form-section {\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding: 4px 8px;\n}\n.panel .left-border,\n.modal .left-border,\n.popover .left-border {\n  border-left: 1px dotted #ccc;\n}\n.panel .right-border,\n.modal .right-border,\n.popover .right-border {\n  border-right: 1px dotted #ccc;\n}\n.panel .form-control-static,\n.modal .form-control-static,\n.popover .form-control-static {\n  padding: 3px 10px;\n  min-height: 26px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n  border-radius: 2px;\n  border: 1px solid #ccc;\n  border: 0;\n}\n.panel-main-title {\n  font-weight: 300;\n}\n[class*=\"col-\"] .panel {\n  padding: 15px;\n  box-sizing: border-box;\n}\n[class*=\"col-\"] .panel h6 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h6:first-child {\n  margin-top: 0;\n}\n[class*=\"col-\"] .panel h5 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h5:first-child {\n  margin-top: 0;\n}\n[class*=\"col-\"] .panel h4 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h4:first-child {\n  margin-top: 0;\n}\n[class*=\"col-\"] .panel h3 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h3:first-child {\n  margin-top: 0;\n}\n[class*=\"col-\"] .panel h2 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h2:first-child {\n  margin-top: 0;\n}\n[class*=\"col-\"] .panel h1 {\n  margin-bottom: 20px;\n}\n[class*=\"col-\"] .panel h1:first-child {\n  margin-top: 0;\n}\n/* ========= List of Items ============ */\n.v-flex-container,\n.v-flex-group {\n  -js-display: flex;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n}\n.v-flex-container .list-flex,\n.v-flex-group .list-flex,\n.v-flex-container.list-flex,\n.v-flex-group.list-flex,\n.v-flex-container .v-flex-element,\n.v-flex-group .v-flex-element {\n  margin-top: 0;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 1px;\n  min-height: 1px;\n}\n.flex-group {\n  -js-display: flex;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.flex-group * {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.flex-element {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 1px;\n}\n.flex-shrink-container {\n  flex: 0 1 auto;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -moz-flex;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n}\n.flex-shrink-element {\n  -webkit-box-flex: 0 1 auto;\n  -ms-flex: 0 1 auto;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n.item-list-container {\n  overflow: hidden !important;\n  overflow-y: auto !important;\n  border: 1px solid #ddd;\n}\ndiv.toggle-all {\n  padding-left: 7px;\n  margin-bottom: 7px;\n}\ndiv.toggle-all .switch {\n  position: relative;\n  vertical-align: middle;\n  top: 0px;\n  margin-right: 3px;\n  height: 14px;\n  width: 25.2px;\n}\ndiv.toggle-all .switch small {\n  height: 14px;\n  width: 14px;\n}\ndiv.toggle-all .switch.checked small {\n  left: 11.2px;\n}\n.ui-item-list-conditional {\n  background-color: #fffbe5;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  max-height: 120px;\n}\n.ui-item-list-conditional label {\n  color: #333;\n  font-weight: 600;\n}\n.ui-item-list-conditional .btn.pull-right {\n  margin-right: 5px;\n}\n.ui-item-list-conditional .btn.pull-right:first-of-type {\n  margin-right: 0;\n}\n.ui-item-list-conditional.ng-enter,\n.ui-item-list-conditional.ng-leave {\n  -webkit-transition: all cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;\n  transition: all cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;\n}\n.ui-item-list-conditional.ng-enter,\n.ui-item-list-conditional.ng-leave.ng-leave-active {\n  opacity: 0;\n  max-height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ui-item-list-conditional.ng-leave,\n.ui-item-list-conditional.ng-enter.ng-enter-active {\n  opacity: 1;\n  max-height: 100px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\nul.item-list {\n  width: 100%;\n}\nul.item-list li {\n  cursor: pointer;\n  position: relative;\n  padding-left: 7px;\n  padding-right: 5px;\n}\nul.item-list li > i {\n  margin-right: 6px;\n}\nul.item-list li:hover {\n  background-color: #edf7ff;\n}\nul.item-list li.selected {\n  background-color: #fffbe5;\n}\nul.item-list li.conditional-item {\n  background-color: #fffbe5;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  max-height: 120px;\n}\nul.item-list li.conditional-item label {\n  color: #333;\n  font-weight: 600;\n}\nul.item-list li.conditional-item .btn.pull-right {\n  margin-right: 5px;\n}\nul.item-list li.conditional-item .btn.pull-right:first-of-type {\n  margin-right: 0;\n}\nul.item-list li.conditional-item.ng-enter,\nul.item-list li.conditional-item.ng-leave {\n  -webkit-transition: all cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;\n  transition: all cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s;\n}\nul.item-list li.conditional-item.ng-enter,\nul.item-list li.conditional-item.ng-leave.ng-leave-active {\n  opacity: 0;\n  max-height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n}\nul.item-list li.conditional-item.ng-leave,\nul.item-list li.conditional-item.ng-enter.ng-enter-active {\n  opacity: 1;\n  max-height: 100px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\nul.item-list li.list-group-item {\n  border-left: 0;\n  border-right: 0;\n}\nul.item-list li.list-group-item:first-child {\n  border-top: 0;\n}\nul.item-list li.list-group-item:last-child {\n  border-radius: 0;\n  border-bottom: 0;\n}\nul.item-list li.list-group-item.error-item {\n  background-color: #ffeda7;\n  color: #c4161c;\n}\nul.item-list li.list-group-item.loading-item {\n  background-color: #d9edf7;\n  color: #68a6dd;\n}\nul.item-list li.list-group-item .list-text {\n  position: relative;\n  top: -2px;\n}\nul.item-list li.list-group-item .list-group-item-icon {\n  margin: 0 5px;\n  color: #555;\n}\nul.item-list li.list-group-item .list-group-item-expander {\n  padding: 0 21px;\n}\nul.item-list li.list-group-item .switch {\n  position: relative;\n  top: 0px;\n  margin-right: 3px;\n  height: 14px;\n  width: 25.2px;\n}\nul.item-list li.list-group-item .switch small {\n  height: 14px;\n  width: 14px;\n}\nul.item-list li.list-group-item .switch.checked small {\n  left: 11.2px;\n}\nul.item-list li.list-group-item .checkbox {\n  display: inline;\n  position: relative;\n  top: 2px;\n  margin-right: 3px;\n}\nul.item-list li.list-group-item .badge {\n  margin-left: 5px;\n}\nul.item-list li.list-group-item .line-arrow {\n  width: 20px;\n  text-align: right;\n  padding-top: 2px;\n  border-left: 1px solid #ddd;\n}\nul.item-list li.list-group-item input.inline-edit {\n  -webkit-transition: all ease-in-out 0.2s;\n  transition: all ease-in-out 0.2s;\n  font-size: 13px;\n  height: 26px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  margin-top: 5px;\n  padding-left: 5px;\n  margin-right: 10px;\n}\nul.item-list li.list-group-item input[readonly=\"readonly\"],\nul.item-list li.list-group-item textarea[readonly] {\n  border: 0px solid #ddd;\n  background-color: transparent;\n  box-shadow: none;\n  padding: 0 19px 0 5px;\n  margin-top: -6px;\n  margin-bottom: -3px;\n  height: auto;\n  line-height: 18px;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\nul.item-list .item-actions {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 0;\n  width: 24px;\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n  border: 0px solid #ddd;\n  overflow: hidden;\n  background-color: transparent;\n  text-align: right;\n  white-space: nowrap;\n}\nul.item-list .item-actions.parentHoverShow .btn-more {\n  background-color: #d4ecff;\n}\nul.item-list .item-actions .btn-more {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  padding: 0;\n  height: 100%;\n  font-size: 19px;\n  width: 24px;\n  color: #999;\n}\nul.item-list .item-actions .btn-more:active,\nul.item-list .item-actions .btn-more:focus {\n  box-shadow: none;\n  outline: 0;\n}\nul.item-list .item-actions .btn-more i {\n  margin: 0;\n  top: 2px;\n}\nul.item-list .item-actions .item-actions-well {\n  display: inline-block;\n  height: 100%;\n  box-shadow: inset 0 0 7px -1px rgba(0, 0, 0, 0.1);\n  background: #f7f7f7;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  padding: 0 5px;\n}\nul.item-list .item-actions:hover,\nul.item-list .item-actions:focus {\n  width: 145px;\n}\nul.item-list .item-actions:hover .btn-more,\nul.item-list .item-actions:focus .btn-more {\n  margin-right: -3px;\n}\nul.item-list .item-actions.with-chevron {\n  right: 24px;\n}\nul.item-list .with-actions {\n  margin-right: 30px;\n}\nul.item-list .btn-action {\n  width: auto;\n  border: 0;\n  position: relative;\n  z-index: 300;\n  text-align: center;\n  height: 100%;\n  width: 32px;\n  text-decoration: none;\n}\nul.item-list .btn-action i {\n  font-size: 17px;\n  margin: 0;\n}\nul.item-list i.type-icon {\n  float: left;\n  line-height: 30px;\n  font-size: 17px;\n}\nul.item-list i.type-icon.ico-flag {\n  color: #68a6dd;\n}\nul.item-list .results-edit {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  font-size: 12px;\n  white-space: nowrap;\n}\nul.item-list .results-poi-name {\n  width: 100%;\n  display: block;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\nul.item-list .results-place-name {\n  width: 100%;\n  display: block;\n  font-weight: 700;\n  color: #0079c2;\n}\nul.item-list .results-address {\n  width: 100%;\n  display: block;\n  margin-bottom: 2px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\nul.item-list .results-county {\n  width: 100%;\n  display: block;\n  font-size: 11px;\n  color: #999;\n}\nul.item-list .results-custom-place-label {\n  position: absolute;\n  right: 5px;\n  bottom: 5px;\n  font-size: 10px;\n  white-space: nowrap;\n}\n/* ========= Main Ribbon Menu ========== */\nh1.nav-title {\n  float: left;\n  color: #fff;\n  font-weight: 200;\n  font-size: 33px;\n  margin-top: 18px;\n}\n.alk-menu-bar {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 74px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  z-index: 800;\n  background-color: #3B3C3F;\n}\n.small-top-margin {\n  margin-top: 10px;\n}\n.main-logo {\n  float: left;\n  padding: 20px 20px;\n  position: relative;\n  min-width: 220px;\n  height: 74px;\n  border-right: 1px solid #4F5054;\n  cursor: pointer;\n}\n.slant .main-logo {\n  background-color: #232323;\n  margin-right: 42px;\n  border-right: 0;\n}\n.slant .main-logo:after {\n  display: block;\n  content: \" \";\n  width: 70px;\n  height: 74px;\n  top: 0;\n  background-color: #232323;\n  position: absolute;\n  right: -21px;\n  transform: skewX(-30deg);\n  -ms-transform: skewX(-30deg);\n  -webkit-transform: skewX(-30deg);\n  border-right: 1px solid black;\n  z-index: -1;\n}\n.nav-section {\n  padding: 0 6px;\n  margin: 6px -10px 0 3px;\n  float: left;\n  height: 60px;\n  position: relative;\n  border-left: 1px solid #4F5054;\n  padding-bottom: 9px;\n}\n.nav-section .cloud-menu-btn {\n  margin-top: 5px;\n}\n.nav-section .cloud-menu-btn-last {\n  margin-left: 2px;\n}\n.nav-section .cloud-menu-unlicensed-btn {\n  background-color: #f78d28;\n  border-color: #f78d28;\n  color: white;\n}\n.nav-section .cloud-menu-unlicensed-label {\n  margin-left: 5px;\n  line-height: 20px;\n  color: #f78d28;\n}\n.nav-section .cloud-menu-unlicensed-alert {\n  margin-top: 6px;\n}\n.nav-section .cloud-menu-title,\n.nav-section .cloud-menu-text {\n  font-size: 12px;\n}\n.nav-section.right {\n  float: right;\n  border-right: 0;\n  border-left: 1px solid #4F5054;\n  margin-right: 0;\n}\n.nav-section.right:first-of-type {\n  border-left: 1px solid #4F5054 !important;\n}\n.nav-section.right:last-of-type {\n  border-left: 0 !important;\n}\n.nav-section:first-of-type {\n  border-left: 0;\n}\n.nav-section:last-of-type {\n  margin-right: 5px;\n}\n.nav-section.no-border {\n  border: 0;\n}\n.nav-section.button-section {\n  margin-top: 20px;\n}\n.nav-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.nav-section li {\n  list-style: none;\n  padding: 0;\n}\n.nav-section > ul {\n  float: left;\n  margin: 0;\n}\n.nav-section > ul.right-border {\n  border-right: 1px solid #4F5054;\n  margin-right: 5px;\n}\n.nav-section ul.sub-menu {\n  background-color: #3b3c3f;\n  position: absolute;\n  z-index: 1000;\n  border: 1px solid #4F5054;\n  border-radius: 3px;\n  display: none;\n}\n.nav-section ul.sub-menu li {\n  text-align: left;\n  white-space: nowrap;\n}\n.nav-section ul.sub-menu a {\n  height: 24px;\n  min-height: 24px;\n  margin-right: 0;\n  padding: 0 6px;\n}\n.nav-section ul.sub-menu img {\n  width: 20px;\n  height: 24px;\n  display: inline-block;\n  padding: 4px 4px 4px 0;\n  border-right: 1px solid #4F5054;\n  margin-right: 4px;\n}\n.nav-section button,\n.nav-section .nav-button {\n  font-size: 11px;\n  text-decoration: none;\n  color: #ddd;\n  cursor: pointer;\n  border-radius: 4px;\n  background: none;\n}\n.nav-section button:disabled,\n.nav-section .nav-button:disabled {\n  opacity: 0.5;\n}\n.nav-section button:hover,\n.nav-section .nav-button:hover {\n  background-color: #4d4e53;\n}\n.nav-section button:focus,\n.nav-section .nav-button:focus {\n  outline: none;\n}\n.nav-section .nav-control-group {\n  float: left;\n  position: relative;\n  margin: -4px 0;\n}\n.nav-section .large-btn {\n  float: left;\n  text-align: center;\n  margin: -3px 2px 0;\n  max-width: 100px;\n  position: relative;\n}\n.nav-section .large-btn button {\n  display: block;\n  min-width: 32px;\n  min-height: 58px;\n  padding: 3px 6px;\n  margin-right: 5px;\n  line-height: 12px;\n  border: 1px solid #3B3C3F;\n}\n.nav-section .large-btn button.selected {\n  border: 1px solid #bb8c5c;\n}\n.nav-section .large-btn button.alk-apps-button {\n  background: #333;\n  border: 1px solid #000;\n  border-radius: 3px;\n  box-shadow: 0 0 11px rgba(0, 0, 0, 0.6);\n  margin: 0 6px 0 10px;\n}\n.nav-section .large-btn button.alk-apps-button i {\n  line-height: 1;\n  font-size: 27px;\n  color: #0079c2;\n}\n.nav-section .large-btn img,\n.nav-section .large-btn i {\n  display: block;\n  max-height: 32px;\n  max-width: 32px;\n  margin: 0 auto 3px;\n}\n.nav-section .large-btn img.square,\n.nav-section .large-btn i.square {\n  border-radius: 3px;\n  border: 1px solid #000;\n}\n.nav-section .large-btn .popover {\n  right: 10px !important;\n  left: auto !important;\n  max-width: 400px !important;\n  font-family: \"Open Sans\", sans-serif !important;\n}\n.nav-section .large-btn .popover .arrow {\n  right: 22px !important;\n  left: auto !important;\n}\n.nav-section .large-btn .dropdown-menu img.small-inline {\n  display: inline;\n  max-height: 24px;\n  max-width: 24px;\n  margin-left: -15px;\n}\n.nav-section .small-btn {\n  margin-bottom: 4px;\n  margin-top: -3px;\n}\n.nav-section .small-btn button {\n  line-height: 13px;\n  white-space: nowrap;\n  padding: 2px 4px;\n  border: 0;\n}\n.nav-section .small-btn img {\n  margin-right: 3px;\n}\n.nav-section .icon-btn-group {\n  border: 1px solid #717378;\n  border-radius: 3px;\n  margin-right: 5px;\n  margin-bottom: 7px;\n  margin-top: -4px;\n}\n.nav-section .icon-btn {\n  display: inline-block;\n  border-right: 1px solid #717378;\n  overflow: hidden;\n  position: relative;\n  height: 22px;\n  width: 20px;\n  margin-bottom: -2px;\n  margin-left: -3px;\n}\n.nav-section .icon-btn:last-child {\n  border-right: none;\n}\n.nav-section .icon-btn:first-child {\n  margin-left: 0;\n}\n.nav-section .icon-btn a {\n  display: block;\n  border-radius: 0;\n  text-align: center;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  padding-top: 3px;\n  position: absolute;\n}\n.nav-section .nav-group-label {\n  display: block;\n  text-align: center;\n  color: #ddd;\n  font-size: 12px;\n  width: 100%;\n  line-height: 1;\n  margin-bottom: 6px;\n}\n.nav-section .nav-section-label {\n  position: absolute;\n  bottom: -17px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: #9E9E9E;\n  font-size: 12px;\n}\n.nav-section.routing {\n  border-width: 1px 1px 1px 10px;\n  border-style: solid;\n  border-color: #ccc;\n  margin: 1px 0;\n  padding: 6px 6px;\n  height: 88px;\n}\n.nav-section.routing .nav-section-label {\n  bottom: -1px;\n}\n.nav-section .header-icon-large {\n  width: 32px;\n  height: 32px;\n}\n.nav-section .header-icon-small {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\n.cloud-panel {\n  padding: 6px;\n  top: auto;\n  margin-top: 5px;\n}\n.cloud-panel:before {\n  position: absolute;\n  display: block;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n  right: 25px;\n}\n.cloud-panel:before {\n  border-top-width: 0;\n  border-bottom-color: rgba(0, 0, 0, 0.2);\n  content: \"\";\n  border-width: 11px;\n  top: -22px;\n  margin-right: -1px;\n}\n.cloud-panel h5.legend:first-child {\n  margin-top: 0;\n}\n.cloud-panel .cloud-menu {\n  width: 275px;\n}\n.cloud-panel .cloud-menu .cloud-menu-item {\n  font-size: 11px;\n  padding: 5px 5px 4px 8px;\n}\n.cloud-panel .cloud-menu .cloud-menu-item:hover {\n  background-color: #edf7ff;\n}\n.cloud-panel .cloud-menu .cloud-menu-item .cloud-menu-title {\n  color: #333;\n  font-weight: 700;\n}\n.cloud-panel .cloud-menu .cloud-menu-item .cloud-menu-text {\n  color: #8c8c8c;\n}\n.cloud-panel .cloud-menu .cloud-menu-item img {\n  max-height: 40px;\n  max-width: 40px;\n  margin: 4px 10px 0px 4px;\n}\n.cloud-panel .cloud-menu .cloud-menu-item a {\n  text-decoration: none;\n}\n/* custom right, left and below tabs */\n.tabs-below > .nav-tabs,\n.tabs-right > .nav-tabs,\n.tabs-left > .nav-tabs {\n  border-bottom: 0;\n}\n.tab-content > .tab-pane,\n.pill-content > .pill-pane {\n  display: none;\n}\n.tab-content > .active,\n.pill-content > .active {\n  display: block;\n}\n.tabs-below > .nav-tabs {\n  border-top: 1px solid #ddd;\n}\n.tabs-below > .nav-tabs > li {\n  margin-top: -1px;\n  margin-bottom: 0;\n}\n.tabs-below > .nav-tabs > li > a {\n  border-radius: 0 0 4px 4px;\n}\n.tabs-below > .nav-tabs > li > a:hover,\n.tabs-below > .nav-tabs > li > a:focus {\n  border-top-color: #ddd;\n  border-bottom-color: transparent;\n}\n.tabs-below > .nav-tabs > .active > a,\n.tabs-below > .nav-tabs > .active > a:hover,\n.tabs-below > .nav-tabs > .active > a:focus {\n  border-color: transparent #ddd #ddd #ddd;\n}\n.tabs-left > .nav-tabs > li,\n.tabs-right > .nav-tabs > li {\n  float: none;\n  cursor: pointer;\n}\n.tabs-left > .nav-tabs > li:first-child,\n.tabs-right > .nav-tabs > li:first-child {\n  margin-top: 00px;\n}\n.tabs-left > .nav-tabs > li > a,\n.tabs-right > .nav-tabs > li > a {\n  min-width: 102px;\n  margin-right: 0;\n  margin-bottom: 3px;\n}\n.tabs-left > .nav-tabs {\n  position: absolute;\n  border-right: 1px solid #ddd;\n}\n.tabs-left > .nav-tabs > li > a {\n  margin-right: -1px;\n  border-radius: 4px 0 0 4px;\n  text-align: right;\n  padding: 3px;\n  font-size: 12px;\n}\n.tabs-left > .nav-tabs > li > a:hover,\n.tabs-left > .nav-tabs > li > a:focus {\n  border-color: #eeeeee #dddddd #eeeeee #eeeeee;\n}\n.tabs-left > .nav-tabs .active > a,\n.tabs-left > .nav-tabs .active > a:hover,\n.tabs-left > .nav-tabs .active > a:focus {\n  border-color: #ddd transparent #ddd #ddd;\n  *border-right-color: #ffffff;\n  background-color: #fff;\n}\n.tabs-right > .nav-tabs {\n  float: right;\n  margin-left: 19px;\n  border-left: 1px solid #ddd;\n}\n.tabs-right > .nav-tabs > li > a {\n  margin-left: -1px;\n  border-radius: 0 4px 4px 0;\n}\n.tabs-right > .nav-tabs > li > a:hover,\n.tabs-right > .nav-tabs > li > a:focus {\n  border-color: #eeeeee #eeeeee #eeeeee #dddddd;\n}\n.tabs-right > .nav-tabs .active > a,\n.tabs-right > .nav-tabs .active > a:hover,\n.tabs-right > .nav-tabs .active > a:focus {\n  border-color: #ddd #ddd #ddd transparent;\n  *border-left-color: #ffffff;\n}\n/* ==========  Transitions ========== */\n.slide-container {\n  position: relative;\n  width: 100%;\n}\n.slideInRight.ng-hide-remove {\n  -webkit-animation: slideInFromRight 0.3s ease-in-out;\n  animation: slideInFromRight 0.3s ease-in-out;\n  overflow: hidden;\n  position: absolute !important;\n}\n.slideInRight.ng-hide-add {\n  -webkit-animation: slideOutToRight 0.3s ease-in-out;\n  animation: slideOutToRight 0.3s ease-in-out;\n  overflow: hidden;\n  position: absolute !important;\n}\n@-webkit-keyframes slideInFromRight {\n  0% {\n    right: -400px;\n  }\n  100% {\n    right: 0;\n  }\n}\n@keyframes slideInFromRight {\n  0% {\n    right: -400px;\n  }\n  100% {\n    right: 0;\n  }\n}\n@-webkit-keyframes slideOutToRight {\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -400px;\n  }\n}\n@keyframes slideOutToRight {\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -400px;\n  }\n}\n.slideInLeft.ng-hide-remove {\n  -webkit-animation: slideInFromLeft 0.3s ease-in-out;\n  animation: slideInFromLeft 0.3s ease-in-out;\n  overflow: hidden;\n  position: absolute !important;\n}\n.slideInLeft.ng-hide-add {\n  -webkit-animation: slideOutToLeft 0.3s ease-in-out;\n  animation: slideOutToLeft 0.3s ease-in-out;\n  overflow: hidden;\n  position: absolute !important;\n}\n@-webkit-keyframes slideInFromLeft {\n  0% {\n    left: -400px;\n  }\n  100% {\n    left: 0;\n  }\n}\n@keyframes slideInFromLeft {\n  0% {\n    left: -400px;\n  }\n  100% {\n    left: 0;\n  }\n}\n@-webkit-keyframes slideOutToLeft {\n  0% {\n    left: 0;\n  }\n  100% {\n    left: -400px;\n  }\n}\n@keyframes slideOutToLeft {\n  0% {\n    left: 0;\n  }\n  100% {\n    left: -400px;\n  }\n}\n.left-panel-ui-view {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n.panelSlideLeft.ng-enter {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  left: 100%;\n}\n.panelSlideLeft.ng-enter-active {\n  left: 0;\n}\n.panelSlideLeft.ng-leave {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  left: 0;\n}\n.panelSlideLeft.ng-leave-active {\n  left: -100%;\n}\n.panelSlideRight.ng-enter {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  left: -100%;\n}\n.panelSlideRight.ng-enter-active {\n  left: 0;\n}\n.panelSlideRight.ng-leave {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n  left: 0;\n}\n.panelSlideRight.ng-leave-active {\n  left: 100%;\n}\n.no-trans {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n.half-width {\n  width: 50%;\n}\n.easeOpenClose {\n  -webkit-transition: display ease-in-out 0.25s;\n  transition: display ease-in-out 0.25s;\n}\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n}\nbody {\n  padding: 0;\n  margin: 0;\n  font-family: \"Open Sans\";\n  background-color: #f1f1ec !important;\n  background-image: url('/img/banner-grid.png');\n}\n.pcm-product-logo {\n  height: 30px;\n}\n.olControlTouchZoom {\n  right: 12px;\n  left: auto !important;\n}\n.route-toggle-switch {\n  position: relative;\n  top: 3px;\n}\n.premium-feature-note {\n  font-size: 11px;\n  color: #333 !important;\n}\n.premium-feature-note:before {\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  margin-right: 3px;\n  content: \"\\E124\";\n  color: #E29A00;\n  position: relative;\n  top: 0px;\n  font-size: 11px;\n}\n.info-message-container {\n  position: absolute;\n  top: 70px;\n  left: 550px;\n  right: 100px;\n  text-align: center;\n  border: none;\n}\n.info-message-container .trial-info {\n  border: 1px solid #f0ad4e;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.04);\n}\n#help-btn img,\n#fc-btn img {\n  height: 16px;\n  width: 16px;\n}\n.layers-icon {\n  max-width: 45px !important;\n}\n.btn-sm,\n.btn-group-sm > .btn {\n  padding: 3px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n}\n.page-container {\n  position: absolute;\n  min-width: 1000px;\n  min-height: 600px;\n  height: 100%;\n  width: 100%;\n}\n#center-section {\n  position: absolute;\n  top: 110px;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n}\n.zoomWarning {\n  position: absolute;\n  top: 90px;\n  right: 30%;\n  font-size: 14px;\n  font-weight: 400;\n  -webkit-transition-property: all;\n  transition-property: all;\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -webkit-transition-timing-function: ease-in-out;\n  transition-timing-function: ease-in-out;\n  -webkit-transition-delay: initial;\n  transition-delay: initial;\n  z-index: 5000;\n}\n.olControlWeatherAlertLegend {\n  right: 51px !important;\n}\n.roadSuraceLegend {\n  position: fixed;\n  bottom: 265px;\n  right: 51px;\n  z-index: 100;\n  background-color: #FFF;\n  opacity: 0.9;\n  width: 250px;\n  -webkit-transition: all ease-in-out 0.45s;\n  transition: all ease-in-out 0.45s;\n}\n.roadSuraceLegend.relativeLegend {\n  bottom: 78px;\n}\n.roadSuraceLegend.closed {\n  width: 200px;\n}\n.roadSuraceLegend.closed-remove-active .span {\n  display: block;\n  width: 100px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.roadSuraceLegend ul {\n  padding: 5px;\n  margin: 5px;\n}\n.roadSuraceLegend ul li {\n  display: block;\n  margin-bottom: 10px;\n}\n.roadSuraceLegend ul li .surface-icon {\n  float: left;\n  height: 10px;\n  width: 20px;\n  margin-right: 5px;\n  top: 5px;\n  position: relative;\n}\n.roadSuraceLegend ul li .surface-icon.range {\n  background: #000000;\n}\n.roadSuraceLegend ul li .surface-icon.dry {\n  background: #777777;\n}\n.roadSuraceLegend ul li .surface-icon.wet {\n  background: #00ff00;\n}\n.roadSuraceLegend ul li .surface-icon.ice {\n  background: #ff0000;\n}\n.roadSuraceLegend ul li .surface-icon.snow {\n  background: #0000ff;\n}\n#pcmMap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n#pcmMap_map {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  font-family: \"Open Sans\";\n}\n.printableFrame {\n  border: 3px dashed #c4161c;\n  position: absolute;\n  left: 0;\n  top: 74px;\n  display: none;\n}\n.printableFrame p {\n  float: right;\n  margin-right: 10px;\n  color: #c4161c;\n  font-weight: bold;\n}\n.printableFrame-landscape {\n  width: 920px;\n  height: 660px;\n}\n.printableFrame-portrait {\n  width: 790px;\n  height: 1040px;\n}\n.cell-liner {\n  overflow: hidden;\n}\n.loginPage .container,\n.signUpPage .container {\n  margin-top: 70px;\n}\n.loginPage .container .panel,\n.signUpPage .container .panel {\n  padding: 0px;\n}\n.loginPage .container .panel .page-header,\n.signUpPage .container .panel .page-header {\n  margin: 0px;\n}\n.loginPage .container .panel .page-content,\n.signUpPage .container .panel .page-content {\n  padding: 10px;\n}\n#user-panel {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n  z-index: 990;\n}\n#user-panel .login-action img.logo {\n  margin-top: -15px;\n  margin-left: 10px;\n  float: left;\n  width: 190px;\n  margin-right: -53px;\n}\n#user-panel .login-action h3 {\n  margin-top: 6px;\n  margin-bottom: 12px;\n  font-size: 19px;\n}\n#user-panel .login-action p {\n  max-width: 329px;\n  font-size: 12px;\n  color: #666;\n  margin: 12px 6px;\n}\n#user-panel .login-action span {\n  font-size: 12px;\n  color: #999;\n  line-height: 17px;\n  max-width: 268px;\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 0;\n}\n#user-panel .login-action .btn {\n  margin: 2px 5px;\n}\n#user-panel .login-form label {\n  font-size: 12px;\n}\n#user-panel .login-form input.form-control {\n  font-size: 12px;\n  height: 24px;\n  line-height: 15px;\n}\n#user-panel .login-form input[type=\"password\"] {\n  line-height: 9px;\n}\n#user-panel .login-form .form-group {\n  margin-bottom: 8px;\n}\n#user-panel .login-form .checkbox {\n  font-size: 12px;\n}\n#user-panel .mycopilot-panel {\n  width: 350px;\n}\n#user-panel .mycopilot-panel .user-info {\n  float: right;\n}\n#user-panel .mycopilot-panel .user-info .user-name {\n  font-size: 12px;\n  color: #999;\n}\n#user-panel .mycopilot-panel .title {\n  font-size: 16px;\n  color: #ed4747;\n  float: left;\n  margin-left: 8px;\n}\n#user-panel .mycopilot-panel #mycopilot-actions {\n  clear: both;\n}\n#user-panel .mycopilot-panel #mycopilot-actions > ul {\n  padding: 7px 11px 0;\n  margin: 4px -6px 0;\n}\n#user-panel .mycopilot-panel #mycopilot-actions .tab-content {\n  margin: 4px 6px;\n}\n#user-panel .mycopilot-panel #mycopilot-actions .nav > li > a {\n  padding: 2px 7px;\n  font-size: 13px;\n}\n#user-panel .mycopilot-panel #mycopilot-actions #favs {\n  margin-top: -4px;\n}\n.forms-content .place-holder-text {\n  font-weight: 200;\n  color: #ccc;\n}\n.forms-content .form-info {\n  font-size: 12px;\n  font-style: italic;\n  color: #777;\n  line-height: 15px;\n}\n.forms-content .input-line {\n  background-color: transparent;\n  border-width: 0 0 1px 0;\n  box-shadow: none;\n  border-radius: 0;\n  padding: 0;\n  font-size: 16px;\n  color: #444;\n  border-color: #ddd;\n  font-weight: 600;\n  margin-top: 4px;\n}\n.forms-content .input-line:focus {\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.04);\n  text-indent: 4px;\n}\n.forms-content .input-line:disabled {\n  color: #aaa;\n}\n.forms-content .input-line.no-line {\n  border-bottom: 0;\n}\n.forms-content .input-line::-webkit-input-placeholder {\n  font-weight: 200;\n  color: #ccc;\n}\n.forms-content .input-line:-moz-placeholder {\n  /* Firefox 18- */\n  font-weight: 200;\n  color: #ccc;\n}\n.forms-content .input-line::-moz-placeholder {\n  /* Firefox 19+ */\n  font-weight: 200;\n  color: #ccc;\n}\n.forms-content .input-line:-ms-input-placeholder {\n  font-weight: 200;\n  color: #ccc;\n}\n.forms-content select.input-line {\n  border-color: rgba(255, 255, 255, 0);\n  border-width: 1px;\n  border-bottom-color: #ddd;\n}\n.forms-content select.input-line:hover {\n  border-color: #ddd;\n  border-width: 1px;\n}\n.forms-content p.signup-section {\n  font-size: 21px !important;\n  margin: 40px 0 20px;\n  color: #777;\n}\n.forms-content p.help-block {\n  color: #B80400;\n  float: left;\n  width: auto;\n  border-top-width: 0;\n  padding: 0 4px;\n  font-size: 12px !important;\n  margin-top: 0;\n  line-height: 1.5 !important;\n}\n.forms-content p.help-block:before {\n  content: \"(\";\n}\n.forms-content p.help-block:after {\n  content: \")\";\n}\n.forms-content p.form-message {\n  color: #F0AD4E;\n  font-weight: 600;\n  margin-top: 20px;\n  border: 1px solid #F0AD4E;\n  padding: 2px 9px;\n  border-radius: 12px;\n  display: inline-block;\n}\n.forms-content .label-line {\n  margin-top: -26px;\n  margin-bottom: 28px;\n  font-size: 11px;\n  color: #777;\n  font-weight: 400;\n  -webkit-transition: all linear 0.1s;\n  transition: all linear 0.1s;\n  cursor: text;\n}\n.forms-content .label-static {\n  width: 100%;\n  text-align: center;\n}\n.forms-content .form-control-static {\n  height: 26px;\n  display: block;\n  border: none;\n  padding: 0 10px;\n  background-color: rgba(0, 0, 0, 0.04);\n  line-height: 26px;\n}\n.forms-content .has-error .form-control:focus {\n  box-shadow: none;\n}\n.forms-content .has-error .label-line {\n  font-weight: 600;\n  color: #B80400;\n}\n.forms-content .has-error .input-line {\n  color: #B80400;\n  border-bottom-color: #B80400;\n}\n.forms-content p.pricing-header {\n  text-align: center;\n  font-size: 16px;\n  border-bottom: 1px dotted #999;\n  text-transform: uppercase;\n  color: #777;\n  letter-spacing: 3px;\n}\n.forms-content .pricing-totals span {\n  font-size: 18px;\n  line-height: 3;\n}\n.forms-content .table-condensed td,\n.forms-content .table-condensed th {\n  font-size: 12px;\n}\n.forms-content .input-line:focus + .label-line,\n.forms-content .input-line.filled + .label-line {\n  margin-top: 0;\n  margin-bottom: 2px;\n  font-size: 12px;\n}\n.forms-content-small .input-line {\n  font-size: 14px;\n}\n.forms-content-xsmall fieldset {\n  margin-bottom: 10px;\n}\n.forms-content-xsmall fieldset legend {\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n.forms-content-xsmall fieldset ul {\n  margin: 0 -15px;\n}\n.forms-content-xsmall .field-section {\n  font-size: 13px;\n  margin: 0 3px 8px;\n}\n.forms-content-xsmall label {\n  font-size: 12px;\n  font-weight: 600;\n}\n.forms-content-xsmall label input[type=checkbox],\n.forms-content-xsmall label input[type=radio] {\n  position: relative;\n  top: 2px;\n}\n.forms-content-xsmall .input-line {\n  font-size: 12px;\n  height: 24px;\n}\n.forms-content-xsmall .btn-link {\n  white-space: normal;\n  line-height: 1.2;\n}\nfieldset .account-panel .loading-overlay {\n  margin: 0 -20px;\n}\n.account-panel {\n  position: relative;\n}\n.account-panel .loading-overlay {\n  top: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 900;\n}\n.account-panel .loading-overlay span {\n  font-size: 21px;\n  display: block;\n  position: absolute;\n  text-align: center;\n  left: 0;\n  right: 0;\n  top: 40%;\n}\n.account-panel .loading-overlay i {\n  font-size: 21px;\n}\n#locator-panel p {\n  padding: 1px 4px;\n  font-size: 11px;\n  color: #999;\n  margin-bottom: 0;\n}\n#locator-panel i {\n  font-size: 14px;\n  cursor: pointer;\n  color: #bbb;\n  margin-right: 1px;\n}\n#locator-panel i:hover {\n  color: #0082ff;\n}\n#directions-panel {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.direction-item {\n  position: relative;\n  border-top: 1px solid #eee;\n  padding: 4px;\n}\n.direction-item:first-child {\n  border-top: 0;\n}\n.direction-item.sub-direction {\n  border-top: 0;\n  margin-left: 36px;\n  line-height: 12px;\n  font-size: 12px;\n  color: #aaa;\n  padding: 0 0 6px;\n}\n.direction-item span {\n  float: right;\n  margin-left: 14px;\n  min-width: 70px;\n  text-align: right;\n}\n.direction-item .turn-arrow {\n  display: block;\n  margin-right: 6px;\n  width: 26px;\n  height: 40px;\n  float: left;\n}\n.direction-item .turn-arrow img {\n  max-height: 22px;\n  max-width: 22px;\n}\n.direction-item .item-inner {\n  padding: 0;\n}\n.direction-item .item-inner .item-title {\n  font-size: 15px;\n  font-weight: 500;\n}\n.search-placeholder {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n#afsView {\n  margin: 5px;\n}\n.search-panel {\n  position: relative;\n  min-height: 32px;\n  padding: 4px 0 0 2px;\n}\n.search-panel .close-btn {\n  position: absolute;\n  right: 5px;\n  top: 3px;\n  padding: 3px;\n}\n.search-panel label {\n  font-size: 12px;\n}\n.search-panel .nav > li a:hover {\n  background-color: transparent;\n}\n.search-panel .nav-tabs > li.disabled > a {\n  cursor: default;\n}\n.search-panel .nav-tabs > li.disabled > a:hover {\n  border-color: rgba(0, 0, 0, 0);\n}\n.search-panel .nav-tabs > li > a {\n  padding: 2px 10px;\n}\n.search-panel .nav-tabs > li > a:hover {\n  border-color: #ddd;\n}\n.search-panel .nav-tabs > li > a .label-tab {\n  font-size: 12px;\n}\n.search-panel .nav-tabs > li > a .ico {\n  font-size: 17px;\n}\n.search-panel .nav-tabs > li.active > a:hover {\n  background-color: #fff;\n  border-bottom-color: #fff;\n}\n.search-panel .result-info .results-address {\n  max-width: 330px;\n}\n.search-panel .tab-content {\n  background-color: #fff;\n  border-right: 0;\n  margin-bottom: 2px;\n  padding-bottom: 5px;\n}\n.search-panel input.form-control {\n  font-size: 13px;\n  font-weight: 600;\n  height: 29px;\n  line-height: 17px;\n  margin-bottom: 5px;\n}\n.search-panel input.form-control::-webkit-input-placeholder {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.search-panel input.form-control:-moz-placeholder {\n  /* Firefox 18- */\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.search-panel input.form-control::-moz-placeholder {\n  /* Firefox 19+ */\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.search-panel input.form-control:-ms-input-placeholder {\n  font-style: italic;\n  color: #ccc;\n  font-weight: 300;\n}\n.search-panel .alert-sm {\n  position: initial;\n  margin: 1px 0;\n  display: inline-block;\n}\n.search-panel .favorite-list li .result-info {\n  margin-right: 20px;\n}\n.search-panel .favorite-list li .name {\n  font-weight: bold;\n}\n.search-panel .favorite-list li .name:after {\n  content: \" - \";\n}\n.search-panel .favorite-list li .favorite-address {\n  color: #333;\n  font-size: 12px;\n}\n.search-panel .ico-star .premium-feature-note,\n.search-panel .ico-point-location .premium-feature-note,\n.search-panel .ico-map-marker .premium-feature-note {\n  position: relative;\n  bottom: 4px;\n  right: 5px;\n}\n.search-panel .ico-star .tooltip-inner,\n.search-panel .ico-point-location .tooltip-inner,\n.search-panel .ico-map-marker .tooltip-inner {\n  font-family: \"Open Sans\";\n}\n.search-panel .item-list-container .list-group {\n  max-height: 150px;\n  overflow-y: auto;\n  overflow-x: visible;\n  background-color: #fff;\n}\n.search-panel .item-list-container .list-group-item {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.places-tab .tab-content {\n  display: none;\n}\n#search-address {\n  padding-right: 30px;\n}\n.search-wait {\n  color: #68a6dd;\n}\n.search-indicator {\n  font-size: 9px;\n  position: absolute;\n  bottom: 3px;\n  left: 101px;\n  color: #ccc;\n}\n.route-wait .ico {\n  font-size: 17px;\n  margin-right: 4px;\n  top: 3px;\n}\n.route-error {\n  display: block;\n  float: left;\n  margin-left: 10px;\n  text-align: left;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  height: 20px;\n  margin-bottom: 0;\n  color: #a94442;\n  font-size: 11px;\n  margin-top: 4px;\n  font-weight: bold;\n}\n#current-stop {\n  position: relative;\n}\n#current-stop i.ico-map-marker {\n  position: absolute;\n  font-size: 33px;\n  top: 10px;\n  left: 12px;\n  color: #7DACCE;\n}\n#current-stop #current-address {\n  display: inline-block;\n  width: 296px;\n  margin-left: 36px;\n  vertical-align: top;\n}\n#current-stop #current-address .address-line {\n  line-height: 18px;\n  font-weight: 400;\n  font-size: 16px;\n  margin-bottom: 4px;\n  margin-top: 5px;\n}\n#current-stop #current-address .location-line {\n  font-weight: 100;\n  line-height: 15px;\n  margin-bottom: 6px;\n}\n#current-stop #current-address.noAddress .address-line {\n  margin: 0;\n  line-height: 0;\n}\n#current-stop #current-address.noAddress .location-line {\n  line-height: 42px;\n  font-size: 17px;\n}\n#current-stop #current-actions {\n  display: inline-block;\n  width: 114px;\n  text-align: right;\n}\n.geocode-popup-text {\n  padding: 5px 10px;\n  font-size: 12px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\nul.arrDepPanel {\n  padding: 10px;\n  font-size: 12px;\n  width: 200px;\n}\nul.arrDepPanel .radio {\n  margin: 0 0 5px;\n  line-height: 20px;\n}\nul.arrDepPanel .input-sm {\n  cursor: pointer;\n}\n.result-icon {\n  align-self: flex-start;\n}\n.result-icon .ico {\n  font-size: 17px;\n  color: #428bca;\n  margin-right: 6px;\n  position: relative;\n  top: 2px;\n}\n#route-panel {\n  position: relative;\n  padding: 0;\n  background: none;\n  overflow-y: hidden!important;\n}\n#route-panel .route-item {\n  position: relative;\n  min-height: 31px;\n}\n#route-panel .route-item.selected {\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.7), 0 0 11px rgba(0, 0, 0, 0.3);\n  z-index: 200;\n  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n#route-panel .route-item:first-child .panel-heading {\n  border-radius: 3px 3px 0 0;\n}\n#route-panel .route-item:last-child,\n#route-panel .route-item:last-child .panel-heading.closed {\n  border-bottom: 0;\n  border-radius: 0 0 3px 3px;\n}\n#route-panel .route-item:not(.selected) .route-name,\n#route-panel .route-item:not(.selected) .route-info {\n  color: #999 !important;\n}\n#route-panel .route-item-heading {\n  padding: 0;\n  background-color: #eee;\n  border-radius: 0;\n  border-bottom: 0;\n}\n#route-panel .route-item-heading.closed {\n  background-color: #fff;\n  border-bottom: 1px solid #ddd;\n}\n#route-panel .route-item-heading .route-item-header {\n  display: block;\n  border-left: 12px solid;\n  cursor: pointer;\n  padding-bottom: 4px;\n}\n#route-panel .route-item-heading .route-item-header .route-name {\n  font-size: 13px;\n  line-height: 20px;\n  padding-top: 3px;\n  margin-left: 8px;\n  font-weight: 600;\n  white-space: nowrap;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n#route-panel .route-item-heading .route-item-header .route-name i {\n  float: left;\n  height: 21px;\n  margin-right: 3px;\n  top: 1px;\n  -webkit-transform-origin: center 6px;\n  transform-origin: center 6px;\n}\n#route-panel .route-item-heading .route-item-header .route-info {\n  font-size: 11px;\n  font-weight: 600;\n  color: #333333;\n  padding-right: 6px;\n}\n#route-panel .route-item-heading .route-item-header .route-head-options {\n  font-size: 11px;\n  margin-left: 10px;\n  overflow: hidden;\n  width: 400px;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #777777;\n}\n#route-panel .route-item-heading .route-item-header .route-line-toggle {\n  line-height: 48px;\n}\n#route-panel .route-item-heading .route-item-header .route-line-toggle i {\n  line-height: 23px;\n  margin-right: 8px;\n  color: #7A6A6A;\n  font-size: 23px;\n  top: 2px;\n}\n#route-panel .arrival {\n  margin-top: 18px;\n}\n#route-panel .route-options {\n  border-left: 12px solid;\n  padding: 2px 8px 6px 8px;\n  background-color: #eee;\n}\n#route-panel .route-options .route-opt-summary {\n  font-size: 11px;\n  color: #999;\n}\n#route-panel .route-options .btn {\n  font-size: 12px;\n}\n#route-panel .route-options .btn > i {\n  color: #666;\n}\n#route-panel .route-options .traffic-option {\n  line-height: 22px;\n  position: relative;\n  top: 3px;\n}\n#route-panel .route-options .traffic-option label {\n  font-size: 12px;\n  font-weight: 400;\n  position: relative;\n  top: -2px;\n  color: black;\n}\n#route-panel .route-options .traffic-option label:disabled {\n  color: #777;\n}\n#route-panel .route-options .traffic-option > span {\n  position: relative;\n  top: 0;\n  color: #3D8CBD;\n}\n#route-panel .route-options .tooltip-inner {\n  min-width: 150px;\n  background-color: #3D8CBD;\n}\n#route-panel .route-options .tooltip-arrow {\n  border-right-color: #3D8CBD;\n}\n#route-panel .route-actions {\n  text-align: right;\n  padding: 4px 6px 4px 8px;\n  background-color: #eee;\n  border-left: 12px solid;\n}\n#route-panel .route-actions .btn .ico {\n  font-size: 14px;\n  top: 2px;\n  left: 2px;\n}\n#route-panel .route-actions .btn.pull-left {\n  margin-right: 5px;\n}\n#route-panel .route-actions .caret {\n  bottom: 1px;\n  position: relative;\n}\n#route-panel .route-actions .save-icon,\n#route-panel .route-actions .duplicate-icon {\n  display: block;\n  max-height: 16px;\n  max-width: 16px;\n  margin: 1px;\n  height: 16px;\n}\n#route-panel .route-item-fixed-section {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0;\n  flex: 0 0;\n}\n#route-panel .stops-list {\n  overflow-y: auto;\n  border-left: 1px solid;\n}\n#route-panel .stops-list table {\n  width: 100%;\n}\n#route-panel .stops-list thead {\n  background-color: #fff;\n  border-bottom: 1px solid #ddd;\n}\n#route-panel .stops-list th {\n  font-size: 11px;\n}\n#route-panel .stops-list tbody tr {\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-collapse: collapse;\n  background-color: #fff;\n  cursor: ns-resize;\n}\n#route-panel .stops-list tbody tr.selected,\n#route-panel .stops-list tbody tr:hover td {\n  background-color: #fffbe5;\n}\n#route-panel .stops-list tbody tr.route-panel-error {\n  cursor: default;\n}\n#route-panel .stops-list tbody tr.route-panel-error td {\n  background: #c4161c;\n  opacity: 0.7;\n  color: #fff;\n  font-size: 12px;\n  padding: 5px;\n}\n#route-panel .stops-list tbody tr.route-panel-error td a {\n  color: #fff;\n  cursor: pointer;\n}\n#route-panel .stops-list tbody tr.search-row {\n  cursor: default;\n}\n#route-panel .stops-list tbody tr.search-row td {\n  background-color: #fffbe5;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num {\n  vertical-align: top;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num .cell-liner {\n  height: 45px;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num .circle {\n  top: 25px;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num.first .stop-line {\n  top: 40px;\n  bottom: 0;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num.last .stop-line {\n  top: 0;\n  height: 35px;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num .circle {\n  border-color: #9e9e9e;\n  color: #9e9e9e;\n  text-align: center;\n}\n#route-panel .stops-list tbody tr.search-row td.stop-num .circle i.ico {\n  margin-left: 1px;\n  font-size: 9px;\n}\n#route-panel .stops-list tbody tr.search-row td.search-cell {\n  max-width: 1px;\n  padding: 0;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper {\n  height: 31px !important;\n  border-bottom: 1px solid #ddd;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.stop-num .cell-liner {\n  height: 10px;\n  overflow: initial;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.stop-num .circle {\n  top: -1px;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.stop-num .stop-line {\n  top: 0;\n  bottom: 0;\n  height: 100%;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.search-cell {\n  max-width: initial;\n  width: 100%;\n  padding-left: 2px;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.search-cell .search-panel {\n  margin-bottom: -3px;\n}\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.search-cell .tab-content,\n#route-panel .stops-list tbody tr.search-row.ui-sortable-helper td.search-cell .search-stop-label {\n  display: none;\n}\n#route-panel .stops-list tbody tr.search-row.last .stop-line {\n  height: 27px;\n  top: 0;\n}\n#route-panel .stops-list tbody tr.search-row + .insert-stop-row {\n  display: none;\n}\n#route-panel .stops-list tbody tr.search-row:hover {\n  background-color: #fffbe5;\n}\n#route-panel .stops-list tbody tr.insert-stop-row {\n  border: 0;\n}\n#route-panel .stops-list tbody tr.insert-stop-row + .stop-item {\n  border-top: 0;\n}\n#route-panel .stops-list tfoot td {\n  font-weight: 700;\n  background-color: #fff;\n}\n#route-panel .stops-list td {\n  position: relative;\n  font-size: 11px;\n  padding: 7px 2px;\n  background-color: #fff;\n}\n#route-panel .stops-list td.stop-num {\n  width: 35px;\n  padding-left: 11px;\n}\n#route-panel .stops-list td.stop-num .stop-line {\n  left: 18px;\n}\n#route-panel .stops-list td.stop-num .stop-line.search-ext {\n  display: none;\n}\n#route-panel .stops-list td.stop-num .stop-line.search-ext.origin {\n  display: block;\n  top: 0;\n  height: 25px;\n}\n#route-panel .stops-list td.stop-num .stop-line.search-ext.destination {\n  display: block;\n  top: 25px;\n  bottom: 0;\n}\n#route-panel .stops-list td.hover-panel {\n  min-width: 14px;\n}\n#route-panel .stops-list td.collapse-cell {\n  padding: 0;\n}\n#route-panel .stops-list .numeric {\n  text-align: center;\n  width: 50px;\n}\n#route-panel .stops-list .numeric.last-column {\n  padding-right: 0px;\n}\n#route-panel .stops-list .date-range {\n  width: 70px;\n  text-align: center;\n}\n#route-panel .stops-list td.address .cell-liner {\n  min-height: 35px;\n}\n#route-panel .stops-list .info-line,\n#route-panel .stops-list .info-num {\n  background-color: #fffbe5;\n  cursor: default;\n}\n#route-panel .stops-list .info-line .info-label,\n#route-panel .stops-list .info-num .info-label {\n  color: #D3860F;\n  font-style: italic;\n}\n#route-panel .stops-list .insert-line {\n  background-color: #538dc1;\n  color: white;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n#route-panel .stops-list .insert-icon {\n  position: absolute;\n  top: -11px;\n  font-size: 20px;\n  left: -1px;\n  color: #9dcbe2;\n  cursor: pointer;\n  z-index: 190;\n}\n#route-panel .stops-list .insert-icon .ico:first-child {\n  color: #fff;\n}\n#route-panel .stops-list .insert-icon .ico:last-child {\n  font-size: 0.6em;\n  top: 4px;\n}\n#route-panel .stops-list .insert-icon.last {\n  top: auto;\n  bottom: -10px;\n}\n#route-panel .stops-list .address-text {\n  font-weight: 600;\n  font-size: 12px;\n  display: block;\n  min-height: 9px;\n}\n#route-panel .stops-list .place-name {\n  display: block;\n  max-width: 250px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n#route-panel .stops-list .city-text {\n  font-size: 12px;\n}\n#route-panel .stops-list .latlon-text {\n  font-size: 12px;\n}\n#route-panel .stops-list .county-name {\n  font-size: 10px;\n  color: #777;\n  white-space: nowrap;\n}\n#route-panel .stops-list .stop-item.noAddress .address-line {\n  padding: 0;\n}\n#route-panel .stops-list .stop-item.noAddress .location-line {\n  font-weight: 400;\n  line-height: 46px;\n  font-size: 15px;\n  margin-bottom: 2px;\n  color: #555;\n}\n#route-panel .stops-list .hubroute .stop-num .stop-line {\n  display: none;\n}\n#route-panel .stops-list .hubroute.hubstart {\n  background-color: #e5f0d1;\n}\n#route-panel .stops-list .hubroute.hubstart .address .cell-liner:before {\n  content: \"HUB\";\n  position: absolute;\n  color: green;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 1;\n  opacity: 0.1;\n  right: 0;\n}\n#route-panel .stops-list .stop-ctrl-container {\n  width: 14px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding-left: 0;\n  z-index: 100;\n  min-height: 100%;\n  height: 100%;\n  border-left: 1px solid rgba(204, 204, 204, 0);\n  -webkit-transition: all 0.25s ease-in-out;\n  transition: all 0.25s ease-in-out;\n}\n#route-panel .stops-list .stop-ctrl-container.parentHoverShow {\n  box-shadow: inset 0 0 7px -1px rgba(0, 0, 0, 0.1);\n  background: #f7f7f7;\n}\n#route-panel .stops-list .stop-ctrl-container.parentHoverShow .stop-ctrl-indicator {\n  background-color: #C8E5FD;\n}\n#route-panel .stops-list .stop-ctrl-container.parentHoverShow .stop-ctrl-indicator span.glyphicon {\n  color: #63a1cf;\n}\n#route-panel .stops-list .stop-ctrl-container .stop-ctrl-indicator {\n  width: 16px;\n  opacity: 1;\n  padding: 1px 0;\n  height: 100%;\n  margin-top: 0;\n}\n#route-panel .stops-list .stop-ctrl-container span.glyphicon {\n  font-size: 16px;\n  color: #ddd;\n}\n#route-panel .stops-list .stop-ctrl-container:hover {\n  width: 120px;\n  border-left-color: #cccccc;\n}\n#route-panel .stops-list .stop-ctrl-container:hover .stop-ctrl {\n  opacity: 1;\n  background-color: transparent;\n}\n#route-panel .stops-list .stop-ctrl {\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center;\n  margin: 0;\n  border: none;\n  background: none;\n  height: 80%;\n  width: 28px;\n  margin-top: 5%;\n  opacity: 0;\n  -webkit-transition: all linear 0.4s;\n  transition: all linear 0.4s;\n}\n#route-panel .stops-list .stop-ctrl:disabled {\n  cursor: default;\n}\n#route-panel .stops-list .stop-drag {\n  margin: 0;\n  font-size: 18px;\n  color: #666;\n}\n#route-panel .route-screen {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(238, 238, 238, 0.7);\n  z-index: 200;\n  -js-display: flex;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  justify-content: center;\n}\n#route-panel .route-screen .list-flex,\n#route-panel .route-screen.list-flex,\n#route-panel .route-screen .v-flex-element {\n  margin-top: 0;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 1px;\n  min-height: 1px;\n}\n#route-panel .route-screen .route-wait {\n  flex-grow: 0;\n  text-align: center;\n  line-height: 30px;\n}\n.billing-screen-overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(238, 238, 238, 0.9);\n  z-index: 200;\n  -js-display: flex;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  justify-content: center;\n}\n.billing-screen-overlay .list-flex,\n.billing-screen-overlay.list-flex,\n.billing-screen-overlay .v-flex-element {\n  margin-top: 0;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 1px;\n  min-height: 1px;\n}\n.billing-screen-overlay .billing-screen-overlay-message {\n  flex-grow: 0;\n  text-align: center;\n  line-height: 30px;\n}\n.stopArrPanel {\n  width: 230px;\n  padding: 10px;\n  padding-right: 20px;\n  background-color: white;\n}\n.stopArrPanel .input-sm {\n  cursor: pointer;\n}\n.stopArrPanel .checkbox {\n  padding-left: 5px;\n}\n.stopArrPanel .radio {\n  padding-left: 15px;\n}\n.missedTimeWindow {\n  color: red;\n}\n.places-container {\n  height: 300px;\n}\n#routesync-overlay {\n  position: relative;\n  background-color: #eee;\n}\n#routesync-overlay .routesync-summary {\n  padding: 5px 0;\n  border-bottom: 1px solid #ddd;\n  margin-bottom: 5px;\n}\n#routesync-overlay .routesync-summary p {\n  font-size: 12px;\n}\n#routesync-overlay .routesync-summary .route-od-info {\n  font-weight: 700;\n}\n#routesync-overlay .modal-header {\n  padding: 10px 10px 5px;\n  border-bottom: 1px solid #ddd;\n  background-color: transparent;\n  box-shadow: none;\n  border-left: 12px solid;\n  border-radius: 0;\n}\n#routesync-overlay .modal-header h4 {\n  font-size: 14px;\n  font-weight: 600;\n}\n#routesync-overlay .modal-body {\n  padding: 5px 10px;\n}\n#routesync-overlay .modal-footer {\n  border-top: 1px solid #ddd;\n  padding: 5px 10px;\n}\n#routesync-overlay .field-section {\n  padding-top: 10px;\n  margin: 0 0 5px;\n  font-size: 12px;\n}\n#routesync-overlay .vehicle-list {\n  height: 160px;\n  max-height: 160px !important;\n  margin-bottom: 5px;\n}\n#routesync-overlay .filter-group {\n  margin: 5px;\n}\n#routesync-overlay .filter-group .btn {\n  height: 26px;\n}\n#vehicles-panel {\n  position: absolute;\n  top: 10px;\n  right: 50px;\n  z-index: 100;\n  width: 300px;\n  -webkit-transition: all ease-in-out 0.45s;\n  transition: all ease-in-out 0.45s;\n}\n#vehicles-panel.closed {\n  width: 200px;\n}\n#vehicles-panel .vehicle-list {\n  max-height: 264px !important;\n}\n.vehicle-list {\n  overflow-y: scroll;\n  min-height: 44px;\n  position: relative;\n}\n.vehicle-list li.list-group-item {\n  padding: 5px 6px;\n}\n.vehicle-list li.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(242, 242, 242, 0.82);\n}\n.vehicle-list li.loading-overlay .vehicle-wait {\n  position: absolute;\n  top: 40%;\n  left: 0;\n  right: 0;\n  text-align: center;\n}\n.vehicle-list li .status-indicator {\n  display: inline-block;\n  border-radius: 50%;\n  height: 18px;\n  width: 18px;\n  text-align: center;\n  line-height: 16px;\n  font-size: 9px;\n  padding: 0;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);\n  margin-right: 2px;\n}\n.vehicle-list li .status-offline {\n  background-color: #fff;\n  border: 1px solid #aaa;\n}\n.vehicle-list li .status-online {\n  background-color: #5dc25d;\n  border: 1px solid #359235;\n  color: #fff;\n}\n.vehicle-list li .driver-name {\n  line-height: 22px;\n  font-weight: 700;\n  font-size: 12px;\n}\n.vehicle-list li .driver-info {\n  font-size: 11px;\n  display: block;\n  font-style: italic;\n  text-indent: 24px;\n}\n.driver-popup-text {\n  font-size: 12px;\n}\n.driver-popup-text .driver-name {\n  line-height: 22px;\n  font-weight: 700;\n}\n.driver-popup-text .driver-info {\n  line-height: 16px;\n  display: block;\n  font-style: italic;\n  margin-left: 33px;\n  text-indent: -33px;\n}\n.driver-popup-text strong {\n  font-weight: 600;\n}\n.route-warning {\n  text-align: left;\n  margin-bottom: 5px;\n}\n.route-warning p {\n  margin: 0;\n}\n.report-header {\n  width: 100%;\n  height: 40px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  background-color: #3B3C3F;\n}\n.report-header h3 {\n  color: #fff;\n  font-size: 22px;\n  font-weight: 200;\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 34px;\n  white-space: nowrap;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.report-header .print-btns {\n  bottom: 25px;\n  right: 5px;\n  position: relative;\n}\n.report-header-info {\n  padding: 5px 10px 5px;\n}\n.report-header-info p {\n  font-size: 12px;\n  margin: 0 0 3px;\n  line-height: 1.4;\n}\n.report-header-info p .route-od-info {\n  font-weight: 700;\n  margin-right: 10px;\n}\n.report-content {\n  margin: 5px 0 0;\n  padding: 0;\n  position: absolute;\n  top: 100px;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n.report-content .nav > li > a {\n  font-size: 13px;\n  padding: 5px 10px;\n}\n.report-content .tab-pane {\n  padding: 10px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  top: 30px;\n  overflow: auto;\n  background-color: #fff;\n  width: 100%;\n}\n.report-content .print-header {\n  display: none;\n}\n.report-content h2.print-title {\n  display: none;\n}\n.report-content table {\n  width: 100%;\n}\n.report-content table th {\n  font-size: 10px;\n  line-height: 1.2;\n  padding: 2px;\n  color: #999;\n  border-bottom: 1px solid #ddd;\n}\n.report-content table td {\n  font-size: 12px;\n  padding: 2px 4px;\n  white-space: nowrap;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  border-bottom: 1px solid #ddd;\n}\n.report-content table .numeric {\n  text-align: right;\n}\n.report-content table .long-text {\n  white-space: normal;\n  max-width: 252px;\n}\n.report-content table.state-report-list {\n  margin-top: 30px;\n}\n.report-content table tr.total td {\n  font-weight: 700;\n  border-bottom: 1px solid #333;\n}\n.report-content .detail-orig-dest td {\n  font-weight: 700;\n}\n.report-content .detail-warning td {\n  color: #d00400;\n  font-weight: 600;\n  border-bottom: 0;\n}\n.report-content .directions-list {\n  padding-left: 0;\n  list-style: none;\n}\n.report-content .directions-list .direction-item.line-0 {\n  font-weight: 700;\n}\n.report-content .directions-list .direction-item.destination-total {\n  font-weight: 700;\n  color: #333 !important;\n  font-size: 14px;\n  margin: 0 0 10px 4px;\n  border-top: 1px solid #eee;\n  padding-top: 8px;\n}\n.report-content .directions-list .direction-item.sub-direction {\n  color: #999;\n  margin-left: 6px;\n}\n.report-content .directions-list .direction-item.warning {\n  color: #d00400;\n  font-weight: 600;\n  border-bottom: 1px solid white;\n  margin-bottom: -1px;\n  z-index: 1;\n  padding-bottom: 0;\n}\n.report-content .directions-list .direction-item.disclaimer {\n  border: 0;\n  padding: 0;\n  font-size: 11px;\n  color: #aaa;\n  display: inline;\n  margin-right: 4px;\n}\n.report-content .directions-list .direction-item.disclaimer:first-child {\n  padding-top: 10px;\n}\n.help-header {\n  width: 100%;\n  height: 40px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  background-color: #3B3C3F;\n}\n.help-header h3 {\n  display: inline-block;\n  color: #fff;\n  font-size: 22px;\n  font-weight: 200;\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 34px;\n}\n.help-content {\n  position: absolute;\n  top: 40px;\n  bottom: 20px;\n  overflow-y: auto;\n  padding-left: 10px;\n}\n.help-content h4 {\n  border-bottom: 1px solid #ccc;\n}\n.help-content h5 {\n  font-weight: 600;\n  margin-top: 20px;\n  margin-bottom: 5px;\n}\n.help-content p,\n.help-content table {\n  font-size: 13px;\n  margin-left: 10px;\n}\n.help-footer {\n  position: fixed;\n  bottom: 0;\n  height: 20px;\n  width: 100%;\n  border-top: 1px solid #ccc;\n  background-color: #f1f1ec;\n}\n.help-footer p {\n  font-size: 11px;\n  padding: 2px 10px;\n}\n#leastcostMap_map {\n  width: 100%;\n  height: 400px;\n}\n#leastcostReports {\n  width: 100%;\n}\n#leastcostReports table {\n  width: 100%;\n}\n#leastcostReports th {\n  font-size: 11px;\n  font-weight: 700;\n}\n#leastcostReports td:last-child,\n#leastcostReports th:last-child {\n  padding-right: 6px;\n}\n#leastcostReports tbody tr {\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-collapse: collapse;\n  background-color: #fff;\n}\n#leastcostReports tbody tr.selected {\n  background-color: #fffbe5;\n}\n#leastcostReports tbody tr td {\n  cursor: pointer;\n}\n#leastcostReports tfoot td {\n  font-weight: 700;\n  background-color: #fff;\n}\n#leastcostReports td {\n  position: relative;\n  font-size: 11px;\n  padding: 3px 4px;\n}\n#leastcostReports td.min-value {\n  background-color: rgba(255, 249, 144, 0.51);\n}\n#leastcostReports .color-block-cell {\n  text-align: center;\n}\n#leastcostReports .color-block-cell .color-block {\n  height: 12px;\n  width: 36px;\n  opacity: 0.5;\n}\n#leastcostReports .numeric {\n  text-align: center;\n  width: 70px;\n}\n#leastcostReports .date-range {\n  width: 90px;\n  text-align: center;\n}\n.report-footer {\n  position: fixed;\n  bottom: 0;\n  height: 20px;\n}\n.report-footer p {\n  font-size: 11px;\n  padding: 2px 10px;\n}\n.print-footer {\n  display: none;\n}\ni.ico-star.active {\n  color: #ffd941;\n}\ni.ico-star.active:disabled:hover {\n  color: #ffd941;\n}\n.msg {\n  position: absolute;\n  bottom: 20px;\n  right: 10px;\n  z-index: 2000;\n  display: none;\n}\n.favorite-routeList {\n  overflow: auto;\n}\n.favorite-routeList .modal-title {\n  height: 36px !important;\n}\n.favorite-routeList li {\n  overflow: auto;\n}\n.favorite-routeList li.selected {\n  background-color: #fffbe5;\n}\n.favorite-routeList li .favorite-address {\n  width: 500px;\n}\n.favorite-routeList li .name {\n  font-weight: 700;\n}\n.favorite-routeList li .name:after {\n  content: \" : \";\n}\n.favorite-routeList li .no-routes {\n  width: 500px;\n}\n.favorite-routeList .selected {\n  background-color: #fffbe5;\n}\nform[name=saveRouteForm] .error-glyph,\nform[name=saveLocationForm] .error-glyph,\nform[name=routeOptionsForm] .error-glyph,\nform[name=saveRouteForm] .error-glyph-small,\nform[name=saveLocationForm] .error-glyph-small,\nform[name=routeOptionsForm] .error-glyph-small,\nform[name=saveRouteForm] .error-glyph-small-left,\nform[name=saveLocationForm] .error-glyph-small-left,\nform[name=routeOptionsForm] .error-glyph-small-left {\n  position: absolute;\n  right: 20px;\n  top: 50px;\n  color: #a94442;\n}\nform[name=saveRouteForm] .error-glyph .error-tooltip,\nform[name=saveLocationForm] .error-glyph .error-tooltip,\nform[name=routeOptionsForm] .error-glyph .error-tooltip,\nform[name=saveRouteForm] .error-glyph-small .error-tooltip,\nform[name=saveLocationForm] .error-glyph-small .error-tooltip,\nform[name=routeOptionsForm] .error-glyph-small .error-tooltip,\nform[name=saveRouteForm] .error-glyph-small-left .error-tooltip,\nform[name=saveLocationForm] .error-glyph-small-left .error-tooltip,\nform[name=routeOptionsForm] .error-glyph-small-left .error-tooltip {\n  display: none;\n}\nform[name=saveRouteForm] .error-glyph:hover .error-tooltip,\nform[name=saveLocationForm] .error-glyph:hover .error-tooltip,\nform[name=routeOptionsForm] .error-glyph:hover .error-tooltip,\nform[name=saveRouteForm] .error-glyph-small:hover .error-tooltip,\nform[name=saveLocationForm] .error-glyph-small:hover .error-tooltip,\nform[name=routeOptionsForm] .error-glyph-small:hover .error-tooltip,\nform[name=saveRouteForm] .error-glyph-small-left:hover .error-tooltip,\nform[name=saveLocationForm] .error-glyph-small-left:hover .error-tooltip,\nform[name=routeOptionsForm] .error-glyph-small-left:hover .error-tooltip {\n  display: block;\n  position: absolute;\n  right: -5px;\n  padding: 2px 5px;\n  border: 1px solid #a94442;\n  z-index: 100;\n  top: 20px;\n  min-width: 110px;\n}\nform[name=saveRouteForm] .has-error .help-block,\nform[name=saveLocationForm] .has-error .help-block,\nform[name=routeOptionsForm] .has-error .help-block {\n  font-size: 11px;\n}\nform[name=saveRouteForm] .has-error,\nform[name=saveLocationForm] .has-error,\nform[name=routeOptionsForm] .has-error {\n  color: #a94442;\n}\navoid-favors-map ul.item-list .with-actions {\n  margin-right: 5px;\n}\navoid-favors-map .exceptions-dropdown {\n  max-height: 300px;\n  width: 240px !important;\n  overflow: auto;\n  z-index: 100;\n}\navoid-favors-map .exceptions-dropdown p {\n  margin-top: 5px;\n  display: inline-block;\n}\navoid-favors-map .exceptions-dropdown .exception-name {\n  position: relative;\n  top: -3px;\n}\navoid-favors-map .exceptions-dropdown input {\n  position: relative;\n  top: 2px;\n  right: 3px;\n}\navoid-favors-map .exceptions-dropdown .flex-group {\n  text-align: left;\n}\navoid-favors-map .exceptions-dropdown .flex-group button {\n  border: none;\n  color: #3D8CBD;\n  min-height: 37px;\n}\navoid-favors-map .exceptions-dropdown .flex-group button i {\n  font-size: 16px;\n  margin-bottom: 0px;\n}\navoid-favors-map .exceptions-dropdown .flex-group button:hover {\n  background-color: #edf7ff;\n  text-decoration: none;\n}\navoid-favors-map .exceptions-dropdown .flex-group .list-buttons {\n  border: solid 1px #dddddd;\n  color: #000000;\n  min-height: 27px;\n  margin: 5px;\n  cursor: pointer;\n}\navoid-favors-map .disabled-switch {\n  pointer-events: none;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n  cursor: not-allowed;\n}\n.cat-icons {\n  display: inline !important;\n  max-height: 20px !important;\n}\noption {\n  z-index: relative;\n}\n.tooltip {\n  z-index: 999999999999;\n}\nform[name=routeOptionsForm] .container {\n  padding: 0px;\n}\nform[name=routeOptionsForm] .panel {\n  padding-bottom: 0px;\n}\nform[name=routeOptionsForm] .panel-heading {\n  display: block;\n  margin-bottom: 0px;\n  background-color: #eee;\n  border: none;\n  box-shadow: none;\n  height: 35px;\n}\nform[name=routeOptionsForm] .panel-heading.closed {\n  border-radius: 4px;\n}\nform[name=routeOptionsForm] .panel-heading .panel-title label {\n  color: black;\n  font-size: 13px;\n  font-weight: 700;\n}\nform[name=routeOptionsForm] .premium-feature-heading:after {\n  left: -2px;\n  top: -4px;\n  font-size: 10px;\n}\nform[name=routeOptionsForm] .panel-body {\n  overflow: visible;\n  margin: 10px;\n}\nform[name=routeOptionsForm] .panel-body input {\n  height: 30px;\n}\nform[name=routeOptionsForm] .panel-body .input-group-addon {\n  background-color: #fff;\n  border: none;\n  font-size: 12px;\n}\nform[name=routeOptionsForm] .panel-body .input-group-addon i {\n  cursor: pointer;\n  cursor: hand;\n}\nform[name=routeOptionsForm] .panel-body .trailer-settings,\nform[name=routeOptionsForm] .panel-body .eu-emissions {\n  border-bottom: 2px solid #eee;\n}\nform[name=routeOptionsForm] .panel-body .select-options {\n  padding-left: 0px;\n}\nform[name=routeOptionsForm] .tooltip {\n  width: 200px;\n  word-wrap: pre-wrap;\n}\nform[name=routeOptionsForm] .error-glyph.glyphicon-exclamation-sign {\n  top: 7px;\n  right: 50px;\n  z-index: 100;\n}\nform[name=routeOptionsForm] .checkbox {\n  padding-top: 10px;\n}\nform[name=routeOptionsForm] .checkbox.options {\n  margin-top: 20px;\n}\nform[name=routeOptionsForm] .checkbox.input {\n  height: 32px;\n}\nform[name=routeOptionsForm] .exception-name .name {\n  position: relative;\n  bottom: 2px;\n}\n.route-exceptions-container {\n  max-height: 290px;\n}\n.grouped-input {\n  height: 26px !important;\n}\n.help-question {\n  color: #3D8CBD;\n  padding-left: 4px;\n}\nform[name=applicationSettingForm] {\n  background: white;\n}\nform[name=applicationSettingForm] .left-panel {\n  position: absolute;\n  width: 180px;\n  background-color: #dfdfdf;\n  color: #333;\n  height: 100%;\n  padding-right: 5px;\n}\nform[name=applicationSettingForm] .panel {\n  max-height: 1500px;\n  position: relative;\n  border: none;\n  background: none;\n  padding: 0px;\n}\nform[name=applicationSettingForm] .panel-header {\n  position: relative;\n}\nform[name=applicationSettingForm] .panel-header .panel-heading {\n  margin: 0px;\n  height: 60px;\n}\nform[name=applicationSettingForm] .panel-body {\n  min-height: 500px;\n  overflow-x: hidden;\n}\nform[name=applicationSettingForm] .action-footer {\n  position: relative;\n  bottom: 45px;\n  right: 10px;\n}\nform[name=applicationSettingForm] .action-footer .btn {\n  margin-left: 10px;\n}\nform[name=applicationSettingForm] .tab-content {\n  border: none;\n  margin-left: 150px;\n}\nform[name=applicationSettingForm] ul {\n  width: 180px;\n  left: 1px;\n  top: 20px;\n  border-right: none !important;\n}\nform[name=applicationSettingForm] ul li {\n  margin-bottom: 10px;\n}\nform[name=applicationSettingForm] ul li a {\n  color: #333;\n  border: none;\n  font-size: 14px;\n  padding-right: 10px !important;\n}\nform[name=applicationSettingForm] ul li a:active,\nform[name=applicationSettingForm] ul li a:hover {\n  border: none;\n  color: #333;\n}\nform[name=applicationSettingForm] .form-group {\n  margin-bottom: 10px;\n}\nform[name=applicationSettingForm] .input-group-addon {\n  background-color: #fff !important;\n  border: none;\n  font-size: 11px;\n}\nform[name=applicationSettingForm] .error-glyph,\nform[name=applicationSettingForm] .error-glyph-small,\nform[name=applicationSettingForm] .error-glyph-small-left {\n  position: absolute;\n  right: 30px;\n  top: 50px;\n  color: #a94442;\n  z-index: 100;\n}\nform[name=applicationSettingForm] .error-glyph .error-tooltip,\nform[name=applicationSettingForm] .error-glyph-small .error-tooltip,\nform[name=applicationSettingForm] .error-glyph-small-left .error-tooltip {\n  display: none;\n}\nform[name=applicationSettingForm] .error-glyph:hover .error-tooltip,\nform[name=applicationSettingForm] .error-glyph-small:hover .error-tooltip,\nform[name=applicationSettingForm] .error-glyph-small-left:hover .error-tooltip {\n  display: block;\n  position: absolute;\n  right: -5px;\n  padding: 2px 5px;\n  font-family: \"Open Sans\";\n  border: 1px solid #a94442;\n  z-index: 100;\n  top: 20px;\n  min-width: 110px;\n}\nform[name=applicationSettingForm] .has-error .help-block {\n  font-size: 11px;\n}\nform[name=applicationSettingForm] .alert-success {\n  position: absolute;\n  right: 5px;\n  bottom: 0px;\n}\nform[name=applicationSettingForm] .base-unit {\n  padding: 5px 8px;\n  height: 30px;\n}\nform[name=applicationSettingForm] .error-icon {\n  top: 8px;\n}\n.checkbox-label {\n  font-size: 12px !important;\n  color: black !important;\n}\n.premium-feature label:before {\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  margin-right: 5px;\n  content: \"\\E124\";\n  color: #E29A00;\n}\n.premium-feature-heading:after {\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  margin-left: 3px;\n  content: \"\\E124\";\n  color: #E29A00;\n  position: relative;\n  top: 1px;\n}\n.premium-help-text {\n  font-size: 11px;\n  padding-left: 20px;\n  padding-bottom: 10px;\n}\n#pcm-options .panel-body {\n  padding-top: 15px;\n  font-size: 12px;\n}\n#pcm-options .panel-heading > li > a {\n  padding: 6px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n#pcm-options .panel-heading > a .has-error {\n  color: #a94442;\n}\n.account-page .trash,\n.account-page .ico-user {\n  color: #c4161c;\n  font-size: 13px;\n  margin: 1px;\n}\n.account-page .form-group {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.account-page .form-group td {\n  word-wrap: break-word;\n}\n#pcm-options .tab-content {\n  padding-top: 15px;\n}\n#pcm-options .routing-center {\n  padding-left: 25px!important;\n  padding-right: 25px!important;\n}\n#pcm-options .nav-tabs > li > a {\n  padding: 6px 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n#pcm-options .nav-tabs > li > a .has-error {\n  color: #a94442;\n}\n#pcm-options .error-glyph,\n#pcm-options .error-glyph-small,\n#pcm-options .error-glyph-small-left {\n  position: absolute;\n  right: 20px;\n  top: 28px;\n  color: #a94442;\n}\n#pcm-options .error-glyph .error-tooltip,\n#pcm-options .error-glyph-small .error-tooltip,\n#pcm-options .error-glyph-small-left .error-tooltip {\n  display: none;\n}\n#pcm-options .error-glyph:hover .error-tooltip,\n#pcm-options .error-glyph-small:hover .error-tooltip,\n#pcm-options .error-glyph-small-left:hover .error-tooltip {\n  display: block;\n  position: absolute;\n  right: -5px;\n  padding: 2px 5px;\n  font-family: \"Open Sans\";\n  border: 1px solid #a94442;\n  z-index: 100;\n  top: 20px;\n  min-width: 110px;\n}\n#pcm-options .error-glyph-small {\n  top: 8px;\n}\n#pcm-options .error-glyph-small-left {\n  top: 8px;\n  right: 10px;\n}\n#pcm-options .has-error .help-block {\n  font-size: 11px;\n}\n#pcm-options .checkbox {\n  margin: 0;\n}\n#pcm-options .indent {\n  margin-left: 20px;\n}\n#pcm-options .radio {\n  margin: 0;\n}\n#pcm-options .radio select,\n#pcm-options .radio .date {\n  margin-top: 4px;\n  margin-bottom: 15px;\n}\n#pcm-options .stopList {\n  height: 200px;\n  overflow: auto;\n}\n#pcm-options .stopList div.stop {\n  padding: 10px;\n  border-bottom: 1px solid #DDD;\n}\n#pcm-options .stopList span.circle {\n  border-radius: 9px;\n  border: 1px solid;\n  font-size: 10px;\n  width: 17px;\n  display: inline-block;\n  padding: 0 0 1px 0;\n  text-align: center;\n}\n#pcm-options .stopList span.circle.origin {\n  background-color: #8af36a;\n  border-color: #7fb96c;\n}\n#pcm-options .stopList span.circle.waypoint {\n  background-color: #ffef65;\n  border-color: #ddad37;\n}\n#pcm-options .stopList span.circle.destination {\n  background-color: #ffbaaa;\n  border-color: #eb7d64;\n}\n#pcm-options .col-loaded {\n  padding-right: 5px;\n}\n#pcm-options .col-empty {\n  padding-left: 5px;\n}\n#pcm-options .arrDepPanel {\n  list-style: none;\n  padding-left: 0;\n  font-size: 12px;\n}\n#pcm-options .arrDepPanel .divider {\n  height: 1px;\n  margin: 9px 0;\n  overflow: hidden;\n  background-color: #e5e5e5;\n}\n#pcm-options.basic-subscription .premium-feature label:before {\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  margin-right: 5px;\n  content: \"\\E124\";\n  color: #E29A00;\n}\n#pcm-options.basic-subscription .premium-feature-heading:after {\n  font-family: 'Glyphicons Halflings';\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  margin-left: 2px;\n  content: \"\\E124\";\n  color: #E29A00;\n}\n#pcm-options .premium-help-text {\n  font-size: 11px;\n}\n.dontshowdate th.switch {\n  visibility: hidden;\n}\n.dontshowdate td fieldset:first-child {\n  margin-top: -20px;\n}\n.stopDurationInputError {\n  background-color: #ffdddd;\n  border-color: #C00000;\n}\ntable.fixed {\n  table-layout: fixed;\n}\ntable.fixed td.fixed {\n  overflow: hidden;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n}\n/* ng-animate css */\n.slide.ng-enter,\n.slide.ng-leave {\n  -webkit-transition: 0.5s linear all;\n  transition: 0.5s linear all;\n}\n.ng-animate.ng-hide-add.panel-body,\n.ng-animate.ng-hide-remove.panel-body {\n  overflow: hidden !important;\n}\n.ng-animate.ng-enter.route-item,\n.ng-animate.ng-leave.route-item {\n  overflow: hidden !important;\n}\n.ng-animate.ng-enter .panel-body,\n.ng-animate.ng-leave .panel-body {\n  overflow: hidden !important;\n}\n.longFadeOut.ng-leave,\n.longFadeOut.ng-hide-add {\n  -webkit-animation: longFadeOut 7s linear;\n  animation: longFadeOut 7s linear;\n}\n.fadeInOut.ng-leave,\n.fadeInOut.ng-hide-add {\n  -webkit-animation: fadeOut 0.5s ease-in-out;\n  animation: fadeOut 0.5s ease-in-out;\n}\n.fadeInOut.ng-enter,\n.fadeInOut.ng-hide-remove {\n  -webkit-animation: fadeIn 0.5s ease-in-out;\n  animation: fadeIn 0.5s ease-in-out;\n}\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n@-webkit-keyframes longFadeOut {\n  0% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes longFadeOut {\n  0% {\n    opacity: 1;\n  }\n  80% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.longFadeOut {\n  -webkit-animation-name: longFadeOut;\n  animation-name: longFadeOut;\n}\n.itemAddDelete.ng-leave,\n.itemAddDelete.ng-leave .cell-liner {\n  -webkit-animation: slideOutUp 0.5s ease-in-out;\n  animation: slideOutUp 0.5s ease-in-out;\n}\n.itemAddDelete.ng-enter,\n.itemAddDelete.ng-enter .cell-liner {\n  -webkit-animation: slideInDown 0.5s ease-in-out;\n  animation: slideInDown 0.5s ease-in-out;\n}\n.itemAddDelete50.ng-leave,\n.itemAddDelete50.ng-leave .cell-liner {\n  -webkit-animation: slideOutUp50 0.5s ease-in-out;\n  animation: slideOutUp50 0.5s ease-in-out;\n}\n.itemAddDelete50.ng-enter,\n.itemAddDelete50.ng-enter .cell-liner {\n  -webkit-animation: slideInDown50 0.5s ease-in-out;\n  animation: slideInDown50 0.5s ease-in-out;\n}\n.slideInOut.ng-hide-remove {\n  -webkit-animation: slideInDown 0.5s ease-in-out;\n  animation: slideInDown 0.5s ease-in-out;\n}\n.slideInOut.ng-hide-add {\n  -webkit-animation: slideOutUp 0.5s ease-in-out;\n  animation: slideOutUp 0.5s ease-in-out;\n}\n@-webkit-keyframes slideInDown {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n@keyframes slideInDown {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n@-webkit-keyframes slideOutUp {\n  0% {\n    opacity: 1;\n    max-height: 300px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n  }\n}\n@keyframes slideOutUp {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n@-webkit-keyframes slideInDown50 {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 50px;\n  }\n}\n@keyframes slideInDown50 {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 50px;\n  }\n}\n@-webkit-keyframes slideOutUp50 {\n  0% {\n    opacity: 1;\n    max-height: 50px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0;\n  }\n}\n@keyframes slideOutUp50 {\n  0% {\n    opacity: 0;\n    max-height: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 50px;\n  }\n}\n@media (max-width: 992px) {\n  .panel.panel-page .left-border {\n    border: none;\n  }\n}\n@media (max-width: 1250px) {\n  .nav-section {\n    padding: 0 2px;\n  }\n  .general {\n    padding-right: 10px;\n  }\n  .pcm-product-logo {\n    height: 26px;\n  }\n  .main-logo {\n    padding: 20px 10px;\n    min-width: 200px;\n  }\n}\n@media (max-width: 1050px) {\n  #help-btn,\n  #account-btn {\n    overflow: hidden;\n    width: 25px;\n  }\n  .report-content {\n    top: 120px;\n  }\n}\n@media (max-width: 640px) {\n  .report-content {\n    top: 140px;\n  }\n}\n.ie #route-panel .route-item-fixed-section {\n  -ms-flex: inherit;\n  flex: inherit;\n}\n.ie .main-logo img {\n  min-width: 220px;\n}\n.ie .address-text {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.ie #route-panel .stops-list .stop-ctrl-container {\n  min-height: 50px;\n}\n.ie #route-panel .stops-list td {\n  background-color: transparent;\n}\n.ie #route-panel .stops-list td.stop-num {\n  padding: 0;\n}\n.ie #route-panel .stops-list td.stop-num .cell-liner {\n  min-height: 50px;\n}\n.ie #route-panel .stops-list td.stop-num span.circle {\n  top: 16px;\n  left: 11px;\n}\n@media print {\n  .show-for-print {\n    display: block !important;\n  }\n  img.olTileImage {\n    max-width: none !important;\n  }\n  .reportsBody .report-header h3 {\n    white-space: normal;\n    overflow: visible;\n    width: 780px;\n    margin-bottom: 10px;\n  }\n  .reportsBody .report-header button {\n    display: none;\n  }\n  .reportsBody .report-header-info {\n    margin-top: 5px;\n  }\n  .reportsBody .report-header-info p {\n    margin: 0;\n  }\n  .reportsBody .nav-tabs {\n    display: none !important;\n  }\n  .reportsBody .report-content {\n    margin-top: 0;\n    position: relative;\n    top: 0;\n    bottom: auto;\n  }\n  .reportsBody .report-content .tab-pane {\n    position: relative;\n    top: 0;\n    padding-top: 0;\n    page-break-after: always;\n    overflow: visible;\n  }\n  .reportsBody .report-content .direction-item {\n    padding-top: 0;\n  }\n  .reportsBody .report-content .direction-item.sub-direction {\n    margin-left: 22px;\n    padding-bottom: 3px;\n  }\n  .reportsBody .report-content .direction-item.sub-direction.destination-total {\n    font-weight: 700;\n    margin-left: 0;\n  }\n  .reportsBody .report-content .direction-item.disclaimer {\n    font-size: 9px;\n  }\n  .reportsBody .report-content h2.print-title {\n    display: block;\n    margin-top: 15px;\n    font-size: 17px;\n    font-weight: 700;\n  }\n  .reportsBody .report-content table td {\n    padding: 0 4px;\n    white-space: normal;\n  }\n  .reportsBody .report-footer {\n    display: none;\n  }\n  .reportsBody .print-footer {\n    position: relative;\n    height: 20px;\n    margin-top: 20px;\n  }\n  .reportsBody .print-footer p {\n    font-size: 9px;\n  }\n  .map-btns {\n    display: none;\n  }\n  .hover-panel > .stop-ctrl-container {\n    display: none;\n  }\n  .btn-group-x {\n    display: none;\n  }\n  .route-options * {\n    display: none;\n  }\n  #route-panel {\n    border: 1px solid #ccc;\n  }\n  #route-panel .panel-heading .route-header .route-name i {\n    display: none;\n  }\n  #route-panel .stops-list {\n    max-height: none;\n    border-bottom: 1px solid #ddd;\n  }\n  #route-panel .stops-list .insert-icon {\n    display: none;\n  }\n  #route-panel .panel-heading .route-header .route-info {\n    padding-top: 6px;\n  }\n  #route-panel .search-row {\n    display: none;\n  }\n  #route-panel .route-actions {\n    display: none;\n  }\n  .stop-num span.circle {\n    background-color: #fff !important;\n    border-radius: 50%;\n  }\n  #center-section {\n    top: 0;\n  }\n  #main-ui * {\n    background: #fff !important;\n  }\n  #GeocodingPopup_GroupDiv {\n    background: #fff !important;\n  }\n  #GeocodingPopup_stemContainerDiv {\n    height: 20px;\n  }\n  .popup-actions,\n  #GeocodingPopup_close {\n    display: none;\n  }\n  .olControlTouchZoom {\n    display: none;\n  }\n  #footerLinks {\n    display: none;\n  }\n  .printableFrame-landscape,\n  .printableFrame-portrait {\n    top: 0;\n  }\n}\n#footer {\n  position: fixed;\n}\n@media print and (max-height: 820px) {\n  #main-ui {\n    overflow-y: auto;\n    width: auto;\n    bottom: 0;\n    border-right: none;\n  }\n  #pcmMap_map {\n    left: 0;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  angular.module("alk.services", []);

  angular.module("alk.services").provider("Messages", function () {
    var broadcastType = "ngRoute";

    this.setBroadcastType = function (broadcast) {
      //  only supports ui.router or ngRoute for the moment
      broadcastType = broadcast;

      //  fall back to ngRoute if something weird is specified
      if (broadcastType !== "ngRoute" && broadcastType !== "ui.router") broadcastType = "ngRoute";
    };

    this.$get = ["$rootScope", "$timeout", "_", "$injector", function ($rootScope, $timeout, _, $injector) {
      var allMessages = [];
      var messagesToDisplay = [];
      var currentMessageId = 0;

      function handleRouteChange() {
        messagesToDisplay = [];

        for (var i = 0; i < allMessages.length; i++) {
          if (allMessages[i].showOnNextPage === true) {
            messagesToDisplay.push(allMessages[i]);
          }
        }

        // remove all the items from all messages that we are going to display on this page.
        allMessages = _.filter(allMessages, function (message) {
          return message.showOnNextPage !== true;
        });
      }

      if (broadcastType === "ui.router") {
        $injector.get("$transitions").onSuccess({}, handleRouteChange);
      } else if (broadcastType === "ngRoute") {
        $rootScope.$on("$routeChangeSuccess", handleRouteChange);
      }

      return {
        add: function add(type, message, options) {
          options = options || {};

          var onlyDisplayOne = options.onlyDisplayOne == null || options.onlyDisplayOne === true; // can use == with null because it means null or undefined
          var showOnNextPage = options.showOnNextPage == null || options.showOnNextPage === true;
          var deleteAfterTimeout = options.deleteAfterTimeout || false;
          var messageObj;

          if (showOnNextPage === true) {
            messageObj = _.find(allMessages, {
              message: message
            });
          } else {
            messageObj = _.find(messagesToDisplay, {
              message: message
            });
          }

          if (messageObj && onlyDisplayOne === true) {
            messageObj.number++;
          } else {
            messageObj = {
              type: type,
              message: message,
              number: 1,
              showOnNextPage: showOnNextPage,
              deleteAfterTimeout: deleteAfterTimeout,
              id: currentMessageId
            };

            if (_.isNumber(messageObj.deleteAfterTimeout)) {
              setTimeout(function () {
                if (messageObj.showOnNextPage === true) {
                  allMessages = _.reject(allMessages, function (m) {
                    return m.id === messageObj.currentMessageId;
                  });
                } else {
                  messagesToDisplay = _.reject(messagesToDisplay, function (m) {
                    return m.id === messageObj.currentMessageId;
                  });
                }
              }, messageObj.deleteAfterTimeout);
            }

            currentMessageId++;

            if (messageObj.showOnNextPage === true) {
              allMessages.push(messageObj);
            } else {
              messagesToDisplay.push(messageObj);
            }
          }
        },
        getMessages: function getMessages() {
          return messagesToDisplay;
        },
        clear: function clear() {
          messagesToDisplay = [];
        }
      };
    }];
  });
})(window.angular);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} alkModalService
 * @property {Function} show
 * @property {Function} initiateModalWizard
 * @property {Function} openNextModal
 * @property {Function} openPrevModal
 * @property {Function} getCurrentWizardData
 * @property {Function} setCurrentWizardData
 * @property {Function} clearWizardData
 * @property {Function} setWizardCleanupFunction
 */

(function (angular) {

  angular.module("alk.modal").factory("alkModalService", ["$uibModal", "$translate",
  /** @name alkModalService
   * @ngdoc service
   * @param {service} $uibModal angularJS twitter bootstrap [modal service](https://angular-ui.github.io/bootstrap/#!#modal)
   * @param {service} $translate angularJS [translation service](https://angular-translate.github.io/)
   * @description Provides services for displaying  and configuring custom modal flows.
   * @returns alkModalService
   * @memberof alk.modal
   */
  function ($uibModal, $translate) {

    var defaultController = ["modalOptions", "$uibModalInstance", function defaultModalController(modalOptions, $uibModalInstance) {
      var vm = this;
      vm.modalOptions = modalOptions;

      vm.close = function () {
        $uibModalInstance.close(modalOptions);
      };

      vm.dismiss = function () {
        $uibModalInstance.dismiss("cancel");
      };
    }];

    var modalWizardArray = [];
    var modalWizardIndex = 0;
    var currentWizardData = null;
    var wizardCleanupFunction = null;

    var modalDefaults = {
      backdrop: true,
      keyboard: true,
      modalFade: true,
      template: __webpack_require__(54)
    };

    function getModalOptions() {
      return {
        closeButtonText: $translate.instant("views.common.Cancel"),
        actionButtonText: $translate.instant("views.common.OK"),
        okOnly: false,
        headerText: "",
        bodyText: null,
        bodyTemplate: null,
        data: {}
      };
    }

    return {
      show: show,
      initiateModalWizard: initiateModalWizard,
      openNextModal: openNextModal,
      openPrevModal: openPrevModal,
      getCurrentWizardData: getCurrentWizardData,
      setCurrentWizardData: setCurrentWizardData,
      clearWizardData: clearWizardData,
      setWizardCleanupFunction: setWizardCleanupFunction
    };

    /** show - Display a modal. The default is to display a "static" modal according to ui-bootstrap.
     * @param {Object} customModalDefaults - Custom defaults for the modal. The same options for a [uibootstrap-modal](https://angular-ui.github.io/bootstrap/#!#modal)
     * are allowed here.
     * @param {Object} customModalOptions - Custom options for the modal. The custom options object can look like
     * `{bodyTemplate: string, bodyText: string, headerText: string, okOnly: boolean, closeButtonText: string, actionButtonText: string, onRender: function}`.
     * Reasonable defaults for an actionable modal are to supply just `bodyText` and `headerText`.
     *
     * `bodyTemplate` is a url to template to include in the modal's body.
     *
     * `bodyText` is a string of text that will be displayed in the modal's body.
     *
     * `headerText` is a string of text that will be displayed in the modal's header.
     *
     * `okOnly` is a boolean to indicate that the modal should only have an action button.
     *
     * `closeButtonText` text to be displayed in the close button for the modal. Default is "Cancel"
     *
     * `actionButtonText` text to be displayed in the action button for the modal. Default is "OK".
     *
     * @returns {Promise}  Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves when the modal is closed
     * or is rejected when the modal is dismissed.
     * @memberof alkModalService
     */
    function show(customModalDefaults, customModalOptions) {
      if (!customModalDefaults) {
        customModalDefaults = {};
      }

      customModalDefaults.backdrop = customModalDefaults.backdrop || "static";

      //Create temp objects to work with since we"re in a singleton service
      var tempModalDefaults = {};
      var tempModalOptions = {};

      //Map angular-ui modal custom defaults to modal defaults defined in service
      angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

      //Map modal.html $scope custom properties to defaults defined in service
      angular.extend(tempModalOptions, getModalOptions(), customModalOptions);

      // prioritize template url over template
      if (tempModalDefaults.template && tempModalDefaults.templateUrl) {
        delete tempModalDefaults.template;
      }

      if (!tempModalDefaults.controller) {
        //tempModalDefaults.controller = controllerId; //TODO: what is this used for? if anything? controllerId is not defined.
        tempModalDefaults.resolve = {
          modalOptions: function modalOptions() {
            return tempModalOptions;
          }
        };
        tempModalDefaults.controller = defaultController;
        tempModalDefaults.controllerAs = "$ctrl";
      }

      return $uibModal.open(tempModalDefaults).result;
    }

    //See places.controller.js for an example of this function being used

    /** initiateModalWizard - Initiates a modal wizard given an array of custom modal objects. Will launch the modals in the order they are provided in the array.
     * @param {Object[]} modalArray - modalArray. Each member of the array is an object with the following format:
     * `{onModalSuccess: function, modalOptions: object}`. The `modalOptions` object should be an object with standard [uib-modal](https://angular-ui.github.io/bootstrap/#!#modal) options.
     * `onModalSuccess` is a function that runs when the modal has been submitted. This can call [`openPrevModal`](alk.modal.alkModalService.html#openPrevModal) (go to prev modal in wizard)
     * or [`openNextModal`](alk.modal.alkModalService.html#openNextModal) (go to next modal in wizard).
     * @param {Object} wizardData - Object that contains fields that should persist for the duration of the modal wizard.
     * @memberof alkModalService
     */
    function initiateModalWizard(modalArray, wizardData) {
      currentWizardData = wizardData;
      modalWizardArray = modalArray;
      modalWizardIndex = 0;
      _openModal(modalWizardArray[0]);
    }

    /** openNextModal - Opens the next modal in the wizard. This should be called from within the
     * `onModalSuccess` callback function.
     * @memberof alkModalService
     * @param {Number} skip - optional arg to increment index
     */
    function openNextModal() {
      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var nextModalWizardIndex = modalWizardIndex + skip + 1;
      if (nextModalWizardIndex >= modalWizardArray.length) {
        return;
      }
      var nextModal = modalWizardArray[nextModalWizardIndex];
      modalWizardIndex = nextModalWizardIndex;
      _openModal(nextModal);
    }

    /** openPrevModal - Opens the previous modal in the wizard. This should be called from within the modal
     * object's `onModalCancel` callback.
     * @memberof alkModalService
     * @param {Number} skip - optional arg to decrement index
     */
    function openPrevModal() {
      var skip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var prevModalWizardIndex = modalWizardIndex - skip - 1;
      if (prevModalWizardIndex < 0) {
        return;
      }
      modalWizardIndex = prevModalWizardIndex;
      _openModal(modalWizardArray[prevModalWizardIndex]);
    }

    /** getCurrentWizardData - Returns the current wizard data for the modal service.
     * @returns {Object} Object that contains fields that should persist for the duration of the modal wizard.
     * @memberof alkModalService
     */
    function getCurrentWizardData() {
      return currentWizardData;
    }

    /** setCurrentWizardData - Sets the current wizard data for the modal service.
     * @param {Object} data - Object that contains fields that should persist for the duration of the modal wizard.
     * @memberof alkModalService
     */
    function setCurrentWizardData(data) {
      currentWizardData = data;
    }

    //Clear the wizard data, which can also call a custom cleanup function that can be set via setWizardCleanupFunction().
    //To be called by consuming code when the modal completes successfully. (It gets called automatically called if the modal was cancelled.)
    function clearWizardData() {
      currentWizardData = null;
      modalWizardArray = [];
      modalWizardIndex = 0;
      if (wizardCleanupFunction) {
        wizardCleanupFunction();
        wizardCleanupFunction = null;
      }
    }

    function setWizardCleanupFunction(func) {
      wizardCleanupFunction = func;
    }

    //Used internally by modal wizard system
    function _openModal(customModalObj) {
      var modal = $uibModal.open(customModalObj.modalOptions);
      modal.result.then(function (result) {
        customModalObj.onModalSuccess(result);
      }, function (cancel) {
        clearWizardData();
      });
    }
  }]);
})(window.angular);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title\">{{$ctrl.modalOptions.headerText}}</h4>\n</div>\n<div class=\"modal-body\">\n  <p ng-if=\"$ctrl.modalOptions.bodyText\">{{$ctrl.modalOptions.bodyText}}</p>\n  <div ng-if=\"$ctrl.modalOptions.bodyTemplate\" ng-include=\"$ctrl.modalOptions.bodyTemplate\"></div>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-sm btn-default\" ng-if=\"!$ctrl.modalOptions.okOnly\" ng-click=\"$ctrl.dismiss()\">{{$ctrl.modalOptions.closeButtonText}}</button>\n  <button class=\"btn btn-sm btn-primary\" ng-click=\"$ctrl.close($ctrl.modalOptions)\">{{$ctrl.modalOptions.actionButtonText}}</button>\n</div>\n";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.translations", ["pascalprecht.translate", "tmh.dynamicLocale", "ngCookies"]);
})(window.angular);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.authentication", []);
})(window.angular);

__webpack_require__(57);
__webpack_require__(58);
__webpack_require__(59);
__webpack_require__(60);
__webpack_require__(61);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} alkAuthenticationService
 * @property {Function} logout
 * @property {Function} validate
 * @property {Function} forgotPassword
 * @property {Function} resetPassword
 * @property {Function} changePassword
 * @property {Function} acceptTerms
 */

(function () {
  "use strict";

  angular.module("alk.authentication")
  /** @name alk.authentication.config
   * @ngdoc constant
   * @description Provides configuration settings for the [alkAuthenticationService](alk.authentication.alkAuthenticationService.html) service.
   * @example
   * app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", function (authProvider, authConfig) {
   *   // set up authentication provider
   *   authProvider.dataAnywhereUrl = config.daUrl;
   *   authConfig.applicationUrl = config.mapsureUrl;
   *   authConfig.mapsureUrl = config.mapsureUrl;
   *   authConfig.pcmwsUrl = config.pcmwsUrl;
   *   authConfig.alkmapsApiKey = config.alkmapsApiKey;
   *   authConfig.linkMappingUrl = config.linkMappingUrl;
   * }]);
   * @memberof alk.authentication
   */
  .constant("alk.authentication.config", {
    httpInterceptor: true,

    //  should be the url to the API for the web app
    applicationUrl: "/",

    loginRoute: "login",

    //  url for SSO
    ssoUrl: "",

    //  for validating that a username/password combination is correct.
    validateUrl: "v1/validate",

    //  for resetting a user's password via use of a reset token
    resetPasswordUrl: "v1/password/reset",

    //  for generating a reset password token
    forgotPasswordUrl: "v1/password/forgot",

    //  for changing a user's password
    changePasswordUrl: "v1/password/change",

    //  for accepting the terms of use
    termsOfUseUrl: "v1/user/accept-terms",

    //  for getting user info by auth token
    userInfoUrl: "v1/user",

    //  the name of the current application
    applicationName: "",

    shouldLogoutOnForbidden: function shouldLogoutOnForbidden(rejection) {
      if (rejection.config.url.indexOf(this.loginUrl) === 0) {
        return false;
      }

      return true;
    },
    skipLogoutOnForbidden: {
      get: function get() {
        return config.skipLogoutOnForbidden;
      },
      set: function set(value) {
        config.skipLogoutOnForbidden = value;
      }
    },
    extraUserProperties: {}
  }).provider("alkAuthenticationService", ["alk.authentication.config",
  /** @name alkAuthenticationService
   * @ngdoc service
   * @param {constant} alk.authentication.config - an [alk.authentication.config](alk.authentication.alk.authentication.config.html) object
   * @description Provides functionality for interfacing with ALK's authentication API.
   * @returns alkAuthenticationService
   * @memberof alk.authentication
   */
  function (config) {
    Object.defineProperties(this, {
      httpInterceptor: {
        get: function get() {
          return config.httpInterceptor;
        },
        set: function set(value) {
          config.httpInterceptor = value;
        }
      },
      applicationUrl: {
        get: function get() {
          return config.applicationUrl;
        },
        set: function set(value) {
          config.applicationUrl = value;
        }
      },
      loginRoute: {
        get: function get() {
          return config.loginRoute;
        },
        set: function set(value) {
          config.loginRoute = value;
        }
      },
      validateUrl: {
        set: function set(value) {
          config.validateUrl = value;
        },
        get: function get() {
          return config.validateUrl;
        }
      },
      resetPasswordUrl: {
        get: function get() {
          return config.resetPasswordUrl;
        },
        set: function set(value) {
          config.resetPasswordUrl = value;
        }
      },
      forgotPasswordUrl: {
        get: function get() {
          return config.forgotPasswordUrl;
        },
        set: function set(value) {
          config.forgotPasswordUrl = value;
        }
      },
      pcmilerUrl: {
        get: function get() {
          return config.pcmilerUrl;
        },
        set: function set(value) {
          config.pcmilerUrl = value;
        }
      },
      dataAnywhereUrl: {
        get: function get() {
          return config.dataAnywhereUrl;
        },
        set: function set(value) {
          config.dataAnywhereUrl = value;
        }
      },
      shouldLogoutOnForbidden: {
        get: function get() {
          return config.shouldLogoutOnForbidden;
        },
        set: function set(value) {
          config.shouldLogoutOnForbidden = value;
        }
      },
      extraUserProperties: {
        get: function get() {
          return config.extraUserProperties;
        },
        set: function set(value) {
          config.extraUserProperties = value;
        }
      },
      ssoUrl: {
        get: function get() {
          return config.ssoUrl;
        },
        set: function set(value) {
          config.ssoUrl = value;
        }
      },
      applicationName: {
        get: function get() {
          return config.applicationName;
        },
        set: function set(value) {
          config.applicationName = value;
        }
      }
    });

    this.$get = ["$http", "$q", "$window", "$location", "UserProvider", function ($http, $q, $window, $location, UserProvider) {

      function _getTrueUrl(url) {
        return config.applicationUrl + url;
      }

      function getUserInfo(authToken, userName, account) {
        var forcePasswordReset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var basicAuthHeader = userName + ":" + account + ":" + authToken;
        var encodedHeader = "Basic " + window.btoa(basicAuthHeader);

        var userInfoRequest = {
          url: _getTrueUrl(config.userInfoUrl),
          method: "GET",
          headers: {
            Authorization: encodedHeader
          }
        };

        var deferred = $q.defer();
        $http(userInfoRequest).then(function (resp) {
          var data = resp.data;

          data.forcePasswordReset = forcePasswordReset;
          deferred.resolve(data);
        }, function (err) {
          deferred.reject(err.data);
        });

        return deferred.promise;
      }

      /** validate - logs the user in but does not set any roles
       * Some controller actions need to be accessed while logged in during the signup process (e.g. - getting list of accounts for the user).
       * This authenticates the SSO user so they can use those actions but they currently don"t have an account.
       * @param {ALKLogin} login - An [ALKLogin](alk.authentication.ALKLogin.html) object.
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
       * to the response from the service. If the response from the server is not valid, or if the user is null,
       * it rejects to the response from the service, also.
       * Otherwise, it rejects to the error, if there is one.
       * @memberof alkAuthenticationService
       */
      function validate(login) {
        var deferred = $q.defer();

        $http.post(_getTrueUrl(config.validateUrl), {
          username: login.username,
          password: login.password
        }).then(function (raw) {
          var response = raw.data;
          if (response.isValid === true && response.user !== null) {
            // when validating the user, we are not validating for a specific account or application, not setting account here
            UserProvider.loadUser(response.user);
            deferred.resolve(response);
          } else {
            logout();
            deferred.reject(response);
          }
        }, function (err) {
          logout();
          deferred.reject(err.data);
        });

        return deferred.promise;
      }

      /** resetPassword - Reset a user's password using a reset token.
       * @param {ALKResetPassword} resetPassword - An [ALKResetPassword](alk.authentication.ALKResetPassword.html) object.
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
       * @memberof alkAuthenticationService
       */
      function resetPassword(resetPassword) {
        return $http.post(_getTrueUrl(config.resetPasswordUrl), {
          email: resetPassword.email,
          newPassword: resetPassword.newPassword,
          token: resetPassword.token
        });
      }

      /** forgotPassword - Send an email with a reset tken to a user that has forgotten their password.
       * @param {ALKForgotPassword} forgotPassword - An [ALKForgotPassword](alk.authentication.ALKForgotPassword.html) object.
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
       * @memberof alkAuthenticationService
       */
      function forgotPassword(forgotPassword) {
        return $http.post(_getTrueUrl(config.forgotPasswordUrl), {
          email: forgotPassword.email
        });
      }

      /** changePassword - Changes a user's password.
       * @param {ALKChangePassword} changePassword - An [ALKChangePassword](alk.authentication.ALKChangePassword.html) object.
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
       * @memberof alkAuthenticationService
       */
      function changePassword(changePassword) {
        return $http.post(_getTrueUrl(config.changePasswordUrl), {
          existingPassword: changePassword.oldPassword,
          newPassword: changePassword.newPassword
        });
      }

      function login(login) {
        var deferred = $q.defer();

        var loginRequest = {
          method: "POST",
          url: config.ssoUrl + "v2/security/authenticate",
          data: {
            email: login.username,
            password: login.password,
            account: login.account,
            product: config.applicationName
          },
          withCredentials: true
        };

        $http(loginRequest).then(function (res) {
          var data = res.data;

          if (data.userId && data.authToken) {
            if (config.applicationUrl) {
              var authToken = data.authToken,
                  username = data.username,
                  accountName = data.accountName,
                  forcePasswordReset = data.forcePasswordReset;

              getUserInfo(authToken, username, accountName, forcePasswordReset).then(function (userInfo) {
                UserProvider.loadUser(userInfo.user);
                deferred.resolve(userInfo);
              }, function (err) {
                console.log("rejected user info", err);
                deferred.reject(err);
              });
            } else {
              UserProvider.loadUser(data);
              deferred.resolve(data);
            }
          } else {
            deferred.reject(data);
          }
        }, function (err) {
          deferred.reject(err.data);
        });

        return deferred.promise;
      }

      function verifyService() {
        var deferred = $q.defer();

        var verifyRequest = {
          method: "POST",
          url: config.ssoUrl + "v2/security/verify",
          data: {
            product: config.applicationName
          },
          withCredentials: true
        };

        $http(verifyRequest).then(function (response) {
          deferred.resolve(response.data);
        }, function (err) {
          deferred.reject(err.data);
        });

        return deferred.promise;
      }

      function verify() {
        var deferred = $q.defer();

        verifyService().then(function (response) {
          if (response.userId && response.authToken) {
            if (config.applicationUrl) {
              getUserInfo(response.authToken, response.username, response.accountName).then(function (userInfo) {
                UserProvider.loadUser(userInfo.user);
                deferred.resolve();
              }, function (err) {
                console.log("rejected user info", err);
                deferred.reject(err);
              });
            } else {
              UserProvider.loadUser(response);
              deferred.resolve(response);
            }
          } else {
            deferred.reject(response);
          }
        }, function (err) {
          console.log("verify error", err);
          deferred.reject(err);
        });

        return deferred.promise;
      }

      /** logout - Logout a user by clearing them from the UserProvider, and globally expiring them across other apps.
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise.
       * @memberof alkAuthenticationService
       */
      function logout() {
        var verifyRequest = {
          method: "POST",
          url: config.ssoUrl + "v2/security/logout",
          data: {
            authToken: UserProvider.getUser().authToken
          },
          withCredentials: true
        };

        // clear local user
        UserProvider.clearUser();

        $window.sessionStorage["logoutInProgress"] = true;

        // log the user out of the server
        return $http(verifyRequest);
      }

      /** acceptTerms - accepts the current terms of use
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
       * to nothing or rejects to the error from the service.
       * @memberof alkAuthenticationService
       */
      function acceptTerms() {
        var deferred = $q.defer();

        $http.post(_getTrueUrl(config.termsOfUseUrl), {}).then(function (response) {
          deferred.resolve();
        }, function (err) {
          deferred.reject(err);
        });

        return deferred.promise;
      }

      /** getLicensedApps - gets the applications the currently logged in user can access
       * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves
       * to nothing or rejects to the error from the service.
       * @memberof alkAuthenticationService
       */
      function getLicensedApps() {
        var deferred = $q.defer();

        var url = _getTrueUrl("v1/user/licensed-apps");

        $http.get(url).then(function (raw) {
          var data = raw.data;
          var alkCloudProducts = {
            expired: [],
            unlicensed: [],
            licensed: []
          };
          for (var i = 0; i < data.length; i++) {
            var product = {
              productId: i,
              // temporarily remove ALK and CoPilot app name prefixes in front-end
              // TODO pchen: do this in ALKSSO.TALK_Applications instead
              productTitle: data[i].name.replace(/^ALK /, "").replace(/^CoPilot /, ""),
              productText: data[i].description,
              productLicensed: data[i].licensed,
              productAppUrl: data[i].homeUrl,
              productInfoUrl: data[i].homeUrl,
              productImgSrc: "/img/" + data[i].imageSource,
              productExpired: data[i].expired,
              showUnlicensedMessage: false
            };

            if (product.productExpired) {
              alkCloudProducts.expired.push(product);
            } else if (!product.productLicensed) {
              alkCloudProducts.unlicensed.push(product);
            } else if (product.productLicensed) {
              alkCloudProducts.licensed.push(product);
            }
          }

          deferred.resolve(alkCloudProducts);
        }, function (err) {
          console.log(err);
          deferred.reject(err.data);
        });

        return deferred.promise;
      }

      var service = {
        logout: logout,
        validate: validate,
        forgotPassword: forgotPassword,
        resetPassword: resetPassword,
        changePassword: changePassword,
        acceptTerms: acceptTerms,
        getLicensedApps: getLicensedApps,
        getUserInfo: getUserInfo,
        login: login,
        verifyService: verifyService,
        verify: verify
      };

      return service;
    }];
  }]).factory("UserProvider", ["$rootScope", "$window", "alk.authentication.config", function ($rootScope, $window, config) {

    function loadUser(user) {
      $rootScope.userInfo = angular.extend({
        isLoggedIn: true
      }, user, config.extraUserProperties);
      $window.sessionStorage["userAuthInfo"] = JSON.stringify($rootScope.userInfo); // jshint ignore:line

      $rootScope.$broadcast("UserLoggedIn", $rootScope.userInfo);
    }

    function init() {
      if ($window.sessionStorage["userAuthInfo"]) {
        // jshint ignore:line
        loadUser(JSON.parse($window.sessionStorage["userAuthInfo"])); // jshint ignore:line
      }

      // always watch for changes to the user info object and if any are made, than update the session storage correctly.
      $rootScope.$watch("userInfo", function (newValue, oldValue, scope) {
        // jshint ignore:line
        if (newValue === null) {
          delete $window.sessionStorage["userAuthInfo"]; // jshint ignore:line
          delete $window.sessionStorage["groupSelectedForSession"];
        } else if (angular.equals(newValue, oldValue) === false) {
          $window.sessionStorage["userAuthInfo"] = JSON.stringify(newValue); // jshint ignore:line
        }
      }, true);
    }

    function getUser() {
      if ($rootScope.userInfo) {
        return $rootScope.userInfo;
      }

      var defaultUser = {
        isLoggedIn: false,
        userName: "",
        userId: -1,
        authToken: "",
        account: "",
        roles: []
      };

      // return default - not logged in user
      return angular.extend(defaultUser, config.extraUserProperties);
    }

    function clearUser() {
      // delete the user from session first so if the init function is called, it does not get the stale user from session.
      delete $window.sessionStorage["userAuthInfo"]; // jshint ignore:line
      delete $window.sessionStorage["groupSelectedForSession"];
      $rootScope.userInfo = null;

      $rootScope.$broadcast("UserLoggedOut");
    }

    init();

    return {
      loadUser: loadUser,
      getUser: getUser,
      clearUser: clearUser
    };
  }]).factory("alk.authentication.interceptor", ["$window", "$location", "$q", "UserProvider", "Messages", "alk.authentication.config", function ($window, $location, $q, UserProvider, Messages, alkConfig) {
    return {
      request: function request(config) {

        if (alkConfig.httpInterceptor === false) {
          return config;
        }

        var user = UserProvider.getUser();
        if (!user.isLoggedIn && !window.localStorage.getItem("jwtToken")) {
          return config;
        }

        if (!config.headers) {
          config.headers = {};
        }

        if (config.url.indexOf(alkConfig.dataAnywhereUrl) === 0) {
          // we need to check to see if we are currently in a support account.
          // if we are in a support account, we have an encrypted owner id.
          // we do not want to send encrypted owner IDs as our authentication
          // mechanism for the owner ID route. send our auth token.
          if (user.supportOwnerId && config.url.indexOf("/api/owner/") === -1) {
            // attach authorization with the encrypted owner id
            config.headers.Authorization = "pcmws=" + user.supportOwnerId;
          } else if (window.localStorage.getItem("jwtToken") && $location.url().startsWith("/place-editor")) {
            // We must use token when on place-editor
            config.headers.Authorization = "bearer " + window.localStorage.getItem("jwtToken");
          } else {
            // attach authorization header to all requests made to data anywhere
            config.headers.Authorization = "token=" + user.authToken;
          }
        } else if (config.url.indexOf("/") === 0 || config.url.indexOf(alkConfig.applicationUrl) === 0) {
          // attach authorization header to all requests made to the this website.
          var basicAuthHeader = user.userName + ":" + user.account + ":" + user.authToken;

          if (user.supportOwnerId) basicAuthHeader += ":" + user.supportOwnerId;

          if (config.headers.Authorization === undefined) config.headers.Authorization = "Basic " + window.btoa(basicAuthHeader);
        } else if (config.url.indexOf(alkConfig.pcmwsUrl) === 0) {
          // if Web UI, use region-specific reportApiKey; if Mapsure, use WW alkmapsApiKey
          var apiKey = void 0;
          if (alkConfig.reportApiKey) {
            apiKey = alkConfig.reportApiKey[UserProvider.getUser().region || "NA"];
          } else {
            apiKey = alkConfig.alkmapsApiKey;
          }
          // attach authorization header in the style of FleetPortal: API Key | authToken | date
          config.headers.Authorization = apiKey + "|" + user.authToken + "|" + new Date().toISOString();

          if (user.supportOwnerId) {
            config.headers.Authorization += "|" + user.supportOwnerId;
          }
        }

        return config;
      },
      responseError: function responseError(rejection) {
        if (alkConfig.httpInterceptor === false || alkConfig.shouldLogoutOnForbidden(rejection) === false || alkConfig.skipLogoutOnForbidden === true) {
          return $q.reject(rejection);
        }

        var clearUser = false;

        // The expected use of this is to capture the case of when a user was authenticatd but it has expired, to send them to the login screen to re-login.
        // If the "unauthorized" error is coming from trying to login originally, don"t redirect them
        if (rejection.status === 401 && rejection.config.url.indexOf("/") === 0) {
          // if the request is unauthorized (status code 401), log the user out and bring them to the login screen.  This would happen if the token ever expires after the user is logged in.
          Messages.add("danger", "Please login again.", {
            showOnNextPage: true
          });
          clearUser = true;
        } else if ((rejection.status === 0 || rejection.status === 403) && rejection.config.url.indexOf(alkConfig.dataAnywhereUrl) === 0) {
          // if data anywhere sends a status of 0, it means that the token passed is invalid, log the user out and make them log in again.
          Messages.add("danger", "Please login again.", {
            showOnNextPage: true
          });
          clearUser = true;
        } else if (rejection.status === 403 && rejection.config.url.indexOf(alkConfig.pcmilerUrl) === 0) {
          Messages.add("danger", "Please login again.", {
            showOnNextPage: true
          });
          clearUser = true;
        }

        if (clearUser === true) {
          UserProvider.clearUser();
          $location.path(alkConfig.loginRoute);
        }

        return $q.reject(rejection);
      }
    };
  }]).config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push("alk.authentication.interceptor");
  }]);
})();

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} ALKChangePassword
 * @property {String} oldPassword
 * @property {String} newPassword
 */

(function () {
  "use strict";

  angular.module("alk.authentication").factory("ALKChangePassword", ALKChangePassword);

  /** @name ALKChangePassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates change password requests.
   * @param {String} oldPassword - existing password for the user
   * @param {String} newPassword - new password for the user
   * @example
   * var change = new ALKChangePassword(oldPassword, newPassword);
   * @returns ALKChangePassword
   * @memberof alk.authentication
   */
  function ALKChangePassword() {
    return function (oldPassword, newPassword) {
      this.oldPassword = oldPassword;
      this.newPassword = newPassword;
    };
  }
})();

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} ALKForgotPassword
 * @property {String} email
 */

(function () {
  "use strict";

  angular.module("alk.authentication").factory("ALKForgotPassword", ALKForgotPassword);

  /** @name ALKForgotPassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates forgot password requests.
   * @param {String} email - email of the user to which a "forgot password" email will be sent
   * @example
   * var forgot = new ALKForgotPassword(email);
   * @returns ALKForgotPassword
   * @memberof alk.authentication
   */
  function ALKForgotPassword() {
    return function (email) {
      this.email = email;
    };
  }
})();

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} ALKLogin
 * @property {String} login
 * @property {String} logout
 * @property {String} validate
 * @property {String} forgotPassword
 */

(function () {
  "use strict";

  angular.module("alk.authentication").factory("ALKLogin", ALKLogin);

  /** @name ALKLogin
   * @ngdoc factory
   * @description A factory for an object that encapsulates login requests. 
   * @param {String} username - username for the request
   * @param {String} password - password for the request
   * @param {String} account - optional account name for the request.
   * @param {String} application - optional application name for the request.
   * @example
   * var login = new ALKLogin(username, password, acct);
   * @returns ALKLogin
   * @memberof alk.authentication
   */
  function ALKLogin() {
    return function (username, password) {
      var _this = this;

      var account = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var application = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

      this.username = username;
      this.password = password;
      this.account = account;
      this.application = application;

      this.isBaseValid = _.bind(function () {
        return _this.username && _this.username.length > 0 && _this.password && _this.password.length > 0;
      }, this);
      this.isAccountValid = _.bind(function () {
        return _this.account.length > 0;
      }, this);
      this.isApplicationValid = _.bind(function () {
        return _this.application.length > 0;
      }, this);
    };
  }
})();

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} ALKResetPassword
 * @property {String} email
 * @property {String} newPassword
 * @property {String} token
 */

(function () {
  "use strict";

  angular.module("alk.authentication").factory("ALKResetPassword", ALKResetPassword);

  /** @name ALKResetPassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates reset password requests.
   * @param {String} email - email of the user resetting their password
   * @param {String} newPassword - the new password that will be set for the user
   * @param {String} token - the reset token for the user
   * @example
   * var reset = new ALKResetPassword(email, newPassword, token);
   * @returns ALKResetPassword
   * @memberof alk.authentication
   */
  function ALKResetPassword() {
    return function (email, newPassword, token) {
      this.email = email;
      this.newPassword = newPassword;
      this.token = token;
    };
  }
})();

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var controllerId = "forgotPasswordController";
  angular.module("app").controller(controllerId, ["$scope", "$location", "Messages", "alkAuthenticationService", "ALKForgotPassword", function ($scope, $location, Messages, alkAuthenticationService, ALKForgotPassword) {
    $scope.isProcessing = false;

    var redirectTo = $location.search().r;

    $scope.submitForgotPassword = function () {
      $scope.isProcessing = true;
      Messages.clear();

      var forgotPassword = new ALKForgotPassword($scope.email, redirectTo);

      alkAuthenticationService.forgotPassword(forgotPassword).then(function () {
        Messages.add("success", "An email has been sent to your email address to reset your password.", {
          showOnNextPage: false
        });
      }, function (err) {
        if (err && err.data && err.data.Message) {
          Messages.add("danger", err.data.Message, {
            showOnNextPage: false
          });
        } else {
          Messages.add("danger", "Error while sending Forgot Password email.", {
            showOnNextPage: false
          });
        }
      }).finally(function () {
        $scope.isProcessing = false;
      });
    };
  }]);
})(window.angular);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  var controllerId = "resetPasswordController";
  angular.module("app").controller(controllerId, ["$scope", "$location", "$timeout", "Messages", "alkAuthenticationService", "ALKResetPassword", function ($scope, $location, $timeout, Messages, alkAuthenticationService, ALKResetPassword) {
    var redirectTo = $location.search().r;

    $scope.submitResetPassword = function () {
      $scope.isProcessing = true;
      Messages.clear();

      var resetPassword = new ALKResetPassword($scope.userInfo.email, $scope.userInfo.password, $scope.userInfo.token);
      alkAuthenticationService.resetPassword(resetPassword).then(function () {
        Messages.add("success", "Password has been reset.", {
          showOnNextPage: true
        });

        if (redirectTo === "signup") {
          $location.url("/signup?userName=" + $scope.userInfo.email);
        } else {
          $location.url("/login");
        }
      }, function (err) {
        if (err && err.data && err.data.Message) {
          Messages.add("danger", err.data.Message, {
            showOnNextPage: false
          });
        } else {
          Messages.add("danger", "Error while resetting password.", {
            showOnNextPage: false
          });
        }
      }).finally(function () {
        $scope.isProcessing = false;
      });
    };

    $scope.init = function () {
      var searchObject = $location.search();
      $scope.tokenExists = searchObject.token ? true : false;
      $scope.showTokenField = !$scope.tokenExists;
      $scope.userInfo = {
        email: searchObject.email,
        token: searchObject.token
      };

      // initialize the correct field on page load
      if ($scope.userInfo.email && $scope.userInfo.token) {
        $timeout(function () {
          $("#password").focus(); // jshint ignore:line
        });
      } else if ($scope.userInfo.email) {
        $timeout(function () {
          $("#token").focus(); // jshint ignore:line
        });
      } else {
        $timeout(function () {
          $("#email").focus(); // jshint ignore:line
        });
      }
    };
  }]);
})(window.angular);

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var controllerId = "loginController";
  angular.module("app").controller(controllerId, ["$scope", "$location", "$window", "alkAuthenticationService", "_", "alkModalService", "ALKLogin", "UserProvider", function ($scope, $location, $window, alkAuthenticationService, _, alkModalService, ALKLogin, UserProvider) {
    if ($location.path() === "/login") {
      $scope.formTab = "login";
    } else if ($location.path() === "/forgot") {
      $scope.formTab = "forgot";
    } else {
      $scope.formTab = "signup";
    }

    if ($location.search().dataVersion) {
      $scope.dataVersion = $location.search().dataVersion;
    }

    $scope.isIE9 = !_.isUndefined($window.isIE9);
    $scope.isltIE9 = !_.isUndefined($window.isltIE9);

    $scope.canShowForgotPassword = true;
    $scope.canShowForgotPassword = $scope.hideForgotPassword !== "true";
    $scope.userInfo = {};
    $scope.isEmailFocused = true;
    $scope.accounts = [];
    $scope.login = function (userInfo, loginForm, application) {
      $scope.showGenericError = false;
      $scope.showPasswordIncorrect = false;
      $scope.showNoAccountForApplication = false;
      $scope.showAccountDisabled = false;
      $scope.showUserDisabled = false;

      //if ($scope.loginForm.$valid) {
      var login = new ALKLogin(userInfo.username, userInfo.password, userInfo.account);
      if (!login.isBaseValid()) {
        return;
      }

      if ($scope.accounts.length > 0 && !login.isAccountValid()) {
        return;
      }

      $scope.isProcessing = true;
      alkAuthenticationService.login(login).then(function () {
        $scope.loginSuccess();
      }, function (error) {

        var failedLogin = true;
        // if username/password was not correct.
        if (error.status !== null && error.status === "FailedToLogin") {
          $scope.showPasswordIncorrect = true;
          //  FIXME:
          //  handle this
        } else if (error.status === "FailedToLoginAccountDisabled") {
          $scope.showAccountDisabled = true;
        } else if (error.status === "FailedToLoginUserDisabled") {
          $scope.showUserDisabled = true;
        }
        // if username/password was correct but does not belong to any account.
        else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
            $scope.showNoAccountForApplication = true;
            // if username/password was correct but has one or more accounts. Display the accounts and user can selecte one.
          } else if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
            $scope.accounts = error.accounts;
            $scope.userInfo.account = $scope.accounts[0].accountName;
            loginForm.submitted = false;
            failedLogin = false;
          } else if (error.status !== null && error.status === "FailedToLoginAccountExpired") {
            if (typeof error.userInfo !== 'undefined') {
              // if the account expired, we need to get userInfo and redirect user to account page for upgrade.
              alkAuthenticationService.getUserInfo(error.userInfo.authToken, error.userInfo.username, error.userInfo.accountName).then(function (response) {
                UserProvider.loadUser(response.user);
                $scope.loginSuccess();
              }, function (err) {
                console.log("rejected user info", err);
              });
            } else {
              $scope.showAccountDisabled = true;
            }
          } else {
            //Should handle generic errors, i.e. 500
            $scope.showGenericError = true;
          }

        if (failedLogin) {
          $scope.accounts = [];
          delete $scope.userInfo.account;
        }
        $scope.isProcessing = false;
      });
    };

    $scope.loginSuccess = function () {
      var user = UserProvider.getUser();
      try {
        trackJs.configure({
          userId: user.userName + " (#" + user.userId + "), Account " + user.account + " (#" + user.accountId + ")"
        });
      } catch (err) {
        console.log("trackJs configure error:", err);
      }

      var gotoPage = $location.search().path || "/app";
      var message;

      // if netSuite is down, temporarily allow user to login and disable billing related features.
      if (!user.netSuiteOnline) {
        $location.url(gotoPage);
      } else if (user.hasBillingIssue) {
        message = user.isAdmin() ? "There was an error to the credit card on file.  Go to Account Settings and update your card information to continue." : "There was an error to the credit card on file.  Please have your company’s administrator go to Account Settings to update your card information.";

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Issue",
          bodyText: message,
          okOnly: true,
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(function () {
          $location.url("/account");
        });
      } else if (typeof user.creditExpiresSoon === "function" && user.creditExpiresSoon() && user.isMonthlyPaidCustomer && !user.isInvoiced) {
        message = user.isAdmin() ? "The credit card linked to your account is set to expire on " + user.getCreditExpiresDate().format("MM/DD/YYYY") + ".  To avoid any disruption in service, please update your card information now." : "The credit card linked to your account is set to expire on " + user.getCreditExpiresDate().format("MM/DD/YYYY") + ".  To avoid any disruption in service, please have your company\u2019s administrator update the card information.";

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Warning",
          bodyText: message,
          okOnly: !user.isAdmin() || user.isMonthlyPaidCustomer && user.checkCreditExpiration(),
          closeButtonText: "Later",
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(function () {
          if (user.isAdmin()) {
            $location.url("/account");
          } else {
            $location.url(gotoPage);
          }
        }).catch(function () {
          $location.url(gotoPage);
        });
      } else if (user.hasEmptyRecordList) {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Subscription Issue",
          bodyTemplate: "/app/modal/emptyResponse.template.html",
          okOnly: true,
          actionButtonText: "OK"
        }).then(function () {
          $scope.isProcessing = false;
          $location.url(gotoPage);
        });
      } else {
        $location.url(gotoPage);
      }
    };
    $scope.goToSignup = function () {
      $scope.url = $scope.dataVersion ? "/signupForm?dataVersion=" + $scope.dataVersion : "/signupForm";
      $location.url($scope.url);
    };
  }]);
})(window.angular);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var controllerId = "signUpController";
  angular.module("app").controller(controllerId, ["$scope", "_", "STATES", "signupService", "$window", "$timeout", "$location", "alkAuthenticationService", "Messages", "ALKLogin", "eventTracker", "pcmtidLoginService", function ($scope, _, STATES, signupService, $window, $timeout, $location, alkAuthenticationService, Messages, ALKLogin, eventTracker, pcmtidLoginService) {
    eventTracker.track("Sign Up - Form Loaded");
    var vm = this;
    vm.isAlertShowing = false;
    vm.alertMessage = "";
    vm.title = "signUpController";
    vm.states = STATES;
    vm.countries = _.uniq(STATES, "country");
    vm.wizardStep = 1;
    vm.userAccounts = [];
    vm.enterNewAccount = false; // use existing account if available
    vm.canUserSignupForTrial = true;
    vm.trimbleCloudUrl = pcmtidLoginService.getTrimbleCloudUrl();
    vm.clientId = pcmtidLoginService.getClientId();
    vm.tidApplicationName = pcmtidLoginService.getTidApplicationName();
    vm.searchObject = $location.search();
    vm.invalidToken = false;
    var redirectUrl = pcmtidLoginService.baseUrl() + "/signup?featureLevel=" + vm.searchObject.featureLevel;
    if (vm.searchObject.featureLevel !== undefined) {
      eventTracker.track("Sign Up - " + vm.searchObject.featureLevel + " Clicked"); // Premium, Trial
    }
    var InitialSignup = {
      city: "",
      state: "",
      country: "",
      featureLevel: "Premium", // default feature is Trial
      price: "Free",
      isCreditCardRequired: function isCreditCardRequired() {
        return this.featureLevel !== "Trial";
      },
      userExists: false, // start off with the empty form, the user does not exist.
      numberOfUsers: 1,
      newPlusAccount: false,
      card: {},
      numberOfTrucks: 0
    };
    vm.signup = angular.copy(InitialSignup);
    var numProcessing = 0;

    var startProcessing = function startProcessing() {
      numProcessing++;
      vm.isProcessing = true;
    };

    var stopProcessing = function stopProcessing() {
      numProcessing--;

      if (numProcessing < 0) {
        numProcessing = 0;
      }

      if (numProcessing === 0) {
        vm.isProcessing = false;
      }
    };
    var scrollToTop = function scrollToTop() {
      $window.scrollTo(0, 0);
    };
    var onError = function onError(errorObj) {
      if (errorObj === null) {
        Messages.add("danger", "Unknown error.", {
          showOnNextPage: false
        });
        scrollToTop();
        return;
      }
      var message = errorObj.ExceptionMessage || errorObj.Message;

      if (errorObj.ModelState != null) {
        for (var property in errorObj.ModelState) {
          if (property.indexOf(".") > 0 && errorObj.ModelState.hasOwnProperty(property) && _.isArray(errorObj.ModelState[property])) {
            // do stuff
            _.each(errorObj.ModelState[property], function (validationMessage) {
              Messages.add("danger", validationMessage, {
                showOnNextPage: false
              });
            }); // jshint ignore:line
          } else {
            Messages.add("danger", errorObj.ExceptionMessage || errorObj.Message, {
              showOnNextPage: false
            });
          }
        }
      } else if (message != null) {
        Messages.add("danger", errorObj.ExceptionMessage || errorObj.Message, {
          showOnNextPage: false
        });
      } else if (typeof errorObj === "string") {
        Messages.add("danger", errorObj, {
          showOnNextPage: false
        });
      } else {
        Messages.add("danger", "Unknown error.", {
          showOnNextPage: false
        });
      }
      vm.isProcessing = false;
      scrollToTop();
    };
    var callService = function callService(func, setProcessing) {
      if (setProcessing === null) {
        setProcessing = true;
      }

      if (setProcessing) {
        startProcessing();
      }

      var resp = func();
      resp.error(onError);

      if (setProcessing) {
        resp["finally"](stopProcessing);
      }

      return resp;
    };

    $scope.gettidAccounts = function (code, tAccount, rUrl) {
      vm.isProcessing = true;
      pcmtidLoginService.tidlogin(vm.searchObject.code, tAccount, rUrl).then(function (resp) {
        vm.isProcessing = false;
        vm.signup.firstName = resp.firstName;
        vm.signup.lastName = resp.lastName;
        // console.log(resp.accountName);
        var acc = { accountId: resp.accountId, accountName: resp.account };
        // vm.wizardStep = 4;
        if (tAccount === null) {
          vm.userAccounts = [];
          vm.userAccounts.push(acc);
          vm.canUserSignupForTrial = signupService.canUserSignupForTrial(vm.userAccounts);
          if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
            vm.signup.featureLevel = "Premium";
          }

          // if there are no accounts with this user, just display the regular form
          vm.wizardStep = vm.userAccounts.length > 0 ? 3 : 4;
        }
      }, function (error) {
        switch (error.status) {
          case "FailedToLoginDueToMultipleAccounts":
            {
              var accounts = error.accounts;
              vm.userAccounts = [];

              for (var i = 0; i < accounts.length; i++) {
                vm.userAccounts.push(accounts[i]);
              }

              vm.canUserSignupForTrial = signupService.canUserSignupForTrial(accounts);
              if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
                vm.signup.featureLevel = "Premium";
              }

              // if there are no accounts with this user, just display the regular form
              vm.wizardStep = accounts.length > 0 ? 3 : 4;
              var enabledAccount = _.find(accounts, function (account) {
                return account.userState === "Enabled" && account.accountState === 1;
              });
              if (enabledAccount) {
                $scope.gettidAccounts(code, enabledAccount.accountName, rUrl);
              } else {
                vm.isProcessing = false;
              }
              break;
            }

          case "NoAccess":
            {
              vm.wizardStep = 4;
              vm.isProcessing = false;
              break;
            }
          case "NotExist":
            {
              vm.wizardStep = 4;
              vm.isProcessing = false;
              break;
            }
          case "UserDisabled":
            {
              vm.isProcessing = false;
              break;
            }

          case "FailedToLoginAccountExpired":
            {
              if (error.userInfo !== null) {
                vm.isProcessing = false;
                var userInfo = error.userInfo;
                var expiredAccount = { accountName: userInfo.accountName, accountId: userInfo.accountId };
                if (vm.userAccounts.length === 0) {
                  vm.userAccounts.push(expiredAccount);
                }
                vm.signup.firstName = userInfo.firstName;
                vm.signup.lastName = userInfo.lastName;
                vm.wizardStep = vm.userAccounts.length > 0 ? 3 : 4;
                break;
              }
              break;
            }
          case "FailedToValidateTrimbleIdentityToken":
            {
              vm.invalidToken = true;
              vm.isProcessing = false;
              break;
            }

          case "AccountDisabled":
            {
              vm.isProcessing = false;
              $scope.gettidAccounts(code, vm.userAccounts[1].accountName, rUrl);
              break;
            }
          default:
            {
              vm.wizardStep = 4;
              vm.isProcessing = false;
            }
        }
      });
    };

    var account = null;

    if (vm.searchObject.state) {
      vm.signup.userName = vm.searchObject.state;
      if (vm.searchObject.ssoUser === "true") {

        $scope.gettidAccounts(vm.searchObject.code, null, redirectUrl);
      } else {
        vm.wizardStep = 4;
      }
    }

    var updatePrice = function updatePrice() {
      if (!vm.signup.isCreditCardRequired()) {
        vm.signup.numberOfUsers = 1;
        vm.signup.price = 0;
      } else if (vm.signup.featureLevel === "Standard") {
        vm.signup.price = 59.99 * vm.signup.numberOfUsers;
      } else {
        // premium
        vm.signup.price = 84.99 * vm.signup.numberOfUsers;
      }
    };

    // wizard step 1 - check if the username exists
    var checkUserNameExists = function checkUserNameExists(sendEmail) {
      // before making any calls, ensure to log out so we don't send old credentials.
      alkAuthenticationService.logout();

      // checks to see if the user exists.
      var onSuccess = function onSuccess(userExistsResponse) {
        vm.signup.userExists = userExistsResponse.Exists;

        vm.signup.confirmPassword = "";

        // step 2 is user verification - for new users that is with an emailed token, and existing users that is with the password
        vm.wizardStep = 2;
        if (userExistsResponse.Exists === true) {
          eventTracker.track("Sign Up - Existing Email Address");
        } else {
          eventTracker.track("Sign Up - New Email Address");
        }
        // if the user is new, send them a verification token
        if (userExistsResponse.Exists === false && sendEmail === true) {

          if (vm.signup.userName.indexOf("+") > -1) {
            vm.signup.newPlusAccount = true;
          } else {
            pcmtidLoginService.checkTidEmail(vm.signup.userName).then(function (data) {
              if (data.migrated) {
                var url = pcmtidLoginService.goToTidSignin(vm.signup.userName, redirectUrl, false);
                window.location.href = url;
              } else {
                var createUrl = pcmtidLoginService.goToTidSignup(vm.signup.userName, redirectUrl, false);
                window.location.href = createUrl;
              }
            }, function (error) {});

            // else
            // {
            //     signupService.sendVerification(vm.signup.userName, $location.search().featureLevel);
            // }
          }
        }

        // for both, new user signup, and validating user password, the next field is #password, so focus that
        $timeout(function () {
          if (vm.signup.userExists) {

            pcmtidLoginService.checkTidEmail(vm.signup.userName).then(function (data) {
              if (data.migrated) {
                var url = pcmtidLoginService.goToTidSignin(vm.signup.userName, redirectUrl, true);
                window.location.href = url;
              } else {
                var createUrl = pcmtidLoginService.goToTidSignup(vm.signup.userName, redirectUrl, true);
                window.location.href = createUrl;
              }
            }, function (error) {});
            $("#password").focus(); // jshint ignore:line
          }
        });
      };

      var resp = callService(function () {

        return signupService.userExists(vm.signup.userName);
      });

      resp.success(onSuccess);
    };

    // wizard step 2 - this step only needed if the username does exist. This step verifies the users username/password.
    var validateExistingUserPassword = function validateExistingUserPassword() {
      // validate password,
      // if it is not valid, show validation error.
      // if it is valid, display all the accounts for that user and

      // not logging into the application here, only validating username, password.
      var login = new ALKLogin(vm.signup.userName, vm.signup.password);
      alkAuthenticationService.validate(login).then(function () {
        var getUserResponse = callService(function () {
          return signupService.getUser(vm.signup.userName);
        });

        getUserResponse.success(function (foundUser) {
          vm.signup.firstName = foundUser.firstName;
          vm.signup.lastName = foundUser.lastName;
        });

        var accountsResponse = callService(function () {
          return signupService.getAccounts(vm.signup.userName);
        });

        accountsResponse.success(function (accounts) {
          vm.userAccounts = [];

          for (var i = 0; i < accounts.length; i++) {
            vm.userAccounts.push(accounts[i]);
          }

          vm.canUserSignupForTrial = signupService.canUserSignupForTrial(accounts);
          if (vm.canUserSignupForTrial === false && vm.signup.featureLevel === "Trial") {
            vm.signup.featureLevel = "Premium";
          }

          // if there are no accounts with this user, just display the regular form
          vm.wizardStep = accounts.length > 0 ? 3 : 4;
        });
      }, function () {
        Messages.add("danger", "Invalid username or password", {
          showOnNextPage: false
        });
        vm.isProcessing = false;
      });
    };

    // wizard step 3 - make sure this company is not associated with pcm already and make sure the name does not already exist.
    var validateCompany = function validateCompany() {
      vm.wizardStep = 4;
    };

    // wizard step 4 - submits the form
    var signupUser = function signupUser() {

      var onSuccess = function onSuccess() {

        vm.isAlertShowing = true;
        vm.alertMessage = "You have successfully signed up.";
        if (vm.searchObject.ssoUser !== "true") {
          $scope.gettidAccounts(vm.searchObject.code, null, redirectUrl);
        }
        $timeout(function () {

          vm.isAlertShowing = false;
          $location.url("/signupLogin");
        }, 1900);
        eventTracker.track(eventTracker.EVENTS.SIGNUP, { signup: vm.signup });
        $window.ga("send", "event", "SignupSubmitted", vm.signup.featureLevel + "Signup", "success");
        eventTracker.track("Sign Up - Form Submitted");
      };

      var signupVm = vm.signup;
      vm.signup.password = "PCMPassword@1234";
      signupVm.CardHolderName = vm.signup.card.name;
      signupVm.CardType = vm.signup.card.type;
      signupVm.CardNumber = vm.signup.card.number;
      signupVm.ExpirationMonth = vm.signup.card.expMonth;
      signupVm.ExpirationYear = vm.signup.card.expYear;
      signupVm.CVV = vm.signup.card.cvv;

      var resp = callService(function () {
        vm.isProcessing = true;
        return signupService.createSelfServiceUser(signupVm);
      });

      // if the model is valid, submit it using the user service.
      resp.success(onSuccess);
    };

    // handle page load and query parameters.  This includes getting the 'verification email' token and the hyperlink and parameters. Also, if the user enters the page from the homepage and selects Trial
    if (vm.searchObject.featureLevel === "Trial" || vm.searchObject.featureLevel === "Premium" || vm.searchObject.featureLevel === "Standard") {
      vm.signup.featureLevel = vm.searchObject.featureLevel;
    }

    if (vm.searchObject.userName != null) {
      vm.signup.userName = vm.searchObject.userName;

      if (vm.searchObject.token != null) {
        vm.signup.verificationToken = vm.searchObject.token;
      }

      checkUserNameExists(false);
    }

    // Submit the form in its current state.  This displays all validaion errors on the current form and if the form is valid, performs the operation for the current step.
    vm.signUp = function () {
      Messages.clear();
      $scope.$broadcast("show-errors-check-validity");

      // console.log(vm.isProcessing);
      if (vm.wizardStep >= 4) {
        $scope.signUpForm.detailsForm.submitted = true;
      }

      if ($scope.signUpForm.$valid) {
        if (vm.wizardStep === 1) {
          checkUserNameExists(true);
        } else if (vm.wizardStep === 2) {

          if (vm.signup.userExists) {
            validateExistingUserPassword();
          } else {
            vm.wizardStep = 4;

            // after going to the next step, set the correct field to focus
            $timeout(function () {
              $("#password").focus(); // jshint ignore:line
            });
          }
        } else if (vm.wizardStep === 3) {
          validateCompany();
        } else {

          signupUser();
        }
      } else {
        eventTracker.track("Sign Up - Form Invalid");
      }
    };

    vm.useNewAccount = function () {
      // console.log("use new account");

      // cleanup the model - account id is no longer being used
      delete vm.signup.accountId;
      delete vm.signup.companyName;
      delete vm.companyAdminEmail;
      delete vm.hdnAccountId;

      vm.enterNewAccount = true;

      $timeout(function () {
        $("#newCompanyName").focus(); // jshint ignore:line
      });
    };

    vm.useExistingAccount = function () {
      // cleanup the model - company name is no longer being used
      delete vm.signup.companyName;
      delete vm.companyAdminEmail;
      delete vm.hdnAccountId;

      vm.enterNewAccount = false;
    };

    vm.accountSelected = function (account) {
      if (account.AssociatedWithPCM) {
        return;
      }

      vm.signup.companyName = account.AccountName;
      vm.signup.accountId = account.AccountId;
      vm.hdnAccountId = account.AccountId;
    };

    vm.sendVerificationToken = function () {
      var resp = callService(function () {
        return signupService.sendVerification(vm.signup.userName, $location.search().featureLevel);
      }, false);

      resp.success(function () {
        vm.verificationEmailSent = true;
      });
    };

    vm.reset = function () {
      // vm.signup = angular.copy(InitialSignup);
      vm.signup = {
        city: "",
        state: "",
        country: "",
        featureLevel: $location.search().featureLevel, // default feature is Trial
        price: $location.search().featureLevel === "Premium" ? 84.99 : $location.search().featureLevel === "Standard" ? 59.99 : 0,
        isCreditCardRequired: function isCreditCardRequired() {
          return this.featureLevel !== "Trial";
        },
        userExists: false, // start off with the empty form, the user does not exist.
        numberOfUsers: 1,
        newPlusAccount: false,
        card: {},
        numberOfTrucks: 0
      };

      $scope.$broadcast("show-errors-reset");

      vm.wizardStep = 1;
      vm.userAccounts = [];
      vm.canUserSignupForTrial = true;
      Messages.clear();

      vm.enterNewAccount = false; // use existing account if available
      vm.verificationEmailSent = false;
      delete vm.hdnAccountId;

      vm.invalidToken = false;

      $timeout(function () {
        $("#userName").focus(); // jshint ignore:line
      });
    };

    $scope.$watch("vm.signup.state", function () {
      if (vm.signup && vm.signup.state != null && vm.signup.state !== "") {
        var c = _.find(STATES, {
          abbreviation: vm.signup.state
        });
        if (c.country !== vm.signup.country) {
          vm.signup.country = c.country;
        }
      }
    });

    $scope.$watch("vm.signup.country", function () {
      if (vm.signup && vm.signup.state != null && vm.signup.state !== "") {
        var c = _.find(STATES, {
          abbreviation: vm.signup.state
        });
        if (c.country !== vm.signup.country) {
          vm.signup.state = "";
        }
      }
    });

    $scope.$watchGroup(["vm.signup.featureLevel", "vm.signup.numberOfUsers"], function () {
      updatePrice();

      if (vm.signup.featureLevel === "Trial") {
        vm.signup.card = {};
      }
    });
  }]);
})(angular);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var serviceId = "signupService";

  angular.module("app").factory(serviceId, ["$http", "_", function ($http, _) {
    function createSelfServiceUser(newUserSignup) {
      return $http.post("/api/Signup", newUserSignup);
    }

    function userExists(email) {
      return $http.get("/api/UserInfo/Exists?email=" + encodeURIComponent(email));
    }

    function getAccounts(username) {
      return $http.get("/api/Account?userName=" + encodeURIComponent(username));
    }

    function getUser(username) {
      return $http.get("/api/UserInfo/Get?email=" + encodeURIComponent(username));
    }

    function sendVerification(email, featureLevel) {
      var featureLevelQuery = "";
      if (featureLevel) {
        featureLevelQuery = "&featureLevel=" + featureLevel;
      }

      return $http.post("/api/Signup/SendVerificationToken?email=" + encodeURIComponent(email) + featureLevelQuery);
    }

    function canUserSignupForTrial(accounts) {
      var isAssociatedWithPCM = _.findIndex(accounts, {
        AssociatedWithPCM: true
      }) >= 0;
      return !isAssociatedWithPCM;
    };

    return {
      createSelfServiceUser: createSelfServiceUser,
      userExists: userExists,
      getAccounts: getAccounts,
      getUser: getUser,
      sendVerification: sendVerification,
      canUserSignupForTrial: canUserSignupForTrial
    };
  }]);
})(angular);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  var serviceId = "userService";

  angular.module("app").factory(serviceId, ["$http", "$q", "$rootScope", "_", "mapService", "routeService", "$window", "LocationItem", "UserProvider", "routingProfile", "routeExceptionService", "favoriteLocationsService", "eventTracker", "applicationSettingsService", function ($http, $q, $rootScope, _, mapService, routeService, $window, LocationItem, userProvider, routingProfile, routeExceptionService, favoriteLocationsService, eventTracker, applicationSettingsService) {
    var dataServiceUrl = config.daUrl;

    var totalMiles = 0;
    var savedRoutes = [];

    var avoidFavorsSet = [];
    var avoidFavorsSetReady = false;
    var saveRouteLimit = 1500;
    function getTotalMiles() {
      return totalMiles;
    }

    function getData() {
      // if the user is not logged in, don't get any trips
      if (userProvider.getUser().isLoggedIn !== true) {
        return;
      }

      var avoidFavorPromise = routeExceptionService.getRouteExceptionSets(false);

      avoidFavorPromise.then(function (resp) {
        var getGroupsPromises = [];

        _.forEach(resp.data, function (set) {
          var deferred = $q.defer();

          routeExceptionService.getGroupsForSet(set.SetID, true).then(function (res) {
            set.groups = res.data;
            deferred.resolve(set);
          });

          getGroupsPromises.push(deferred.promise);
        });

        $q.all(getGroupsPromises).then(function (res) {
          avoidFavorsSet = res;
          avoidFavorsSetReady = true;
        });
      });

      function buildSavedRoutes(data) {
        return _.map(data, function (v) {
          return {
            savedId: v.Id,
            name: v.Name,
            stops: _.map(v.Stops, function (val) {
              if (!val.Location.PlaceName) {
                return new LocationItem(val.Location);
              } else {
                return new LocationItem(val.Location, val.Location.PlaceName);
              }
            }),
            options: routingProfile.getPCMRouteOptionsFromDA(v.Profile)
          };
        });
      }

      var tripPromise = $http.get(dataServiceUrl + "trips/-1?onlyMine=True&pageSize=" + getSaveRouteLimit());
      var routeSyncPromise = $http.get(dataServiceUrl + "routesync/-1");

      // TODO: investigate if the routeSyncPromise is still needed to filter dupes
      $q.all([tripPromise, routeSyncPromise]).then(function (results) {
        var rsIds = [];
        _.each(results[1].data, function (r) {
          if (r.Trip !== null && r.Trip !== undefined) {
            rsIds.push(r.Trip.Id);
          }
        });
        // filter out trips from routeSync
        results[0].data = _.filter(results[0].data, function (d) {
          return rsIds.indexOf(d.Id) === -1;
        });
        savedRoutes = buildSavedRoutes(results[0].data);
        if (savedRoutes && savedRoutes.length > 0) {
          var least = getLeastVersion(savedRoutes);
          window.sessionStorage.setItem("Minimum_Data_Version_Used", least.options.dataVersion);
          var userCfg = applicationSettingsService.getUserCfg(); // get user cfg
          if (userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
            var leastVersionIndex = getLeastVersionIndex(least.options.dataVersion, userCfg.Minimum_Data_Version_Used);
            if (leastVersionIndex === 0) {
              userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
              applicationSettingsService.updateUserCfg(userCfg);
              eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
                version: least.options.dataVersion
              });
            }
          } else {
            userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
            applicationSettingsService.updateUserCfg(userCfg);
            eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
              version: least.options.dataVersion
            });
          }
        }
      })
      // TODO pchen: refactor this with finally (savedRoutes outside of promise chain, etc.)
      .catch(function (err) {
        // NOTE: this was added to prevent the trips from not loading when /routesync request fails
        tripPromise.then(function (results) {
          savedRoutes = buildSavedRoutes(results.data);
        });
      });

      // pchen: does this need to be in the $q.all above?
      favoriteLocationsService.loadData();
    }

    // Init the data when this this service first gets initialized in case the user is already logged in and we haven't started listening for the UserLoaded event.
    getData();

    var upsert = function upsert(arr, key, newval) {
      var match = _.find(arr, key);
      if (match) {
        var index = _.indexOf(arr, _.find(arr, key));
        arr.splice(index, 1, newval);
      } else {
        arr.push(newval);
      }
    };

    function getLeastVersion(versions) {
      var filterEmptyDataVersionRoutes = versions.filter(function (route) {
        return route.options.dataVersion && route.options.dataVersion !== "";
      });
      var least = filterEmptyDataVersionRoutes.reduce(function (previous, current) {
        var leastVersionIndex = getLeastVersionIndex(current.options.dataVersion, previous.options.dataVersion);
        if (leastVersionIndex >= 0) {
          return leastVersionIndex === 0 ? current : previous;
        } else {
          return angular.lowercase(current.options.dataVersion) < angular.lowercase(previous.options.dataVersion) ? current : previous;
        }
      });
      return least;
    }

    function getLeastVersionIndex(version, version1) {
      var currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3, 5));
      var previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3, 5));
      if (typeof currentVersionNo === "number" && typeof previousVersionNo === "number") {
        return currentVersionNo > previousVersionNo ? 1 : 0;
      } else {
        var versionArray = [currentVersionNo, previousVersionNo];
        var index = versionArray.findIndex(function (val) {
          return typeof val === "number";
        });
        return index;
      }
    }

    function updateRoute(route) {
      var deferred = $q.defer();
      var savedRoute;

      if (!route.savedId && canSaveRoute(angular.copy(route.stops), angular.copy(route.options)) === false) {
        deferred.reject({});
        return deferred.promise;
      }

      var r = {
        Id: route.savedId,
        Name: route.name,
        Stops: _.map(_.map(route.stops, "ALKObj"), function (stop) {
          return {
            "Location": stop
          };
        }),
        Profile: routingProfile.getDARouteOptionsFromPCM(route.options)
      };

      // save new route.
      $http.put(dataServiceUrl + "trips/" + route.savedId, r).success(function (resp) {
        upsert(savedRoutes, {
          savedId: route.savedId
        }, angular.copy(route));
        deferred.resolve(route);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function saveRoute(stops, options, name) {
      var deferred = $q.defer();
      var savedRoute;
      //remove routing profileId from options and set it to -1
      options.routingProfileId = -1;
      if (canSaveRoute(angular.copy(stops), angular.copy(options)) === false) {
        deferred.reject({});
        return deferred.promise;
      }

      var r = {
        Name: name,
        Stops: _.map(_.map(stops, "ALKObj"), function (stop) {
          return {
            "Location": stop
          };
        }),
        Profile: routingProfile.getDARouteOptionsFromPCM(options)
      };

      // save new route.
      $http.post(dataServiceUrl + "trips", r).success(function (resp) {
        savedRoute = {
          savedId: resp.Id,
          name: name,
          stops: angular.copy(stops),
          options: angular.copy(options)
        };

        savedRoutes.push(savedRoute);
        deferred.resolve(savedRoute);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function getSavedRoute(stops, options) {
      var originalStops = _.map(stops, "ALKObj");

      // if the passed in route (stops and options) are the same as any of the current route stops/options in the saved routes, don't allow it to be saved.
      var route = _.find(savedRoutes, function (r) {
        var currentStops = _.map(r.stops, "ALKObj");

        return angular.equals(originalStops, currentStops) && angular.equals(options, r.options);
      });

      return route;
    }

    function canSaveRoute(stops, options) {
      if (userProvider.getUser().isLoggedIn === false) {
        return false;
      }

      // if this route already exists in the list of saved routes, don't allow it to be saved.
      // if this route does not exist in the list of saved routes, let the user save it.
      if (getSavedRoute(stops, options)) {
        return false;
      }

      return true;
    }

    function getSavedRoutes() {
      return savedRoutes;
    }

    function deleteSavedRoute(r) {
      $http.delete(dataServiceUrl + "trips/" + r.savedId).success(function () {
        _.remove(savedRoutes, r);
      });
    }

    function getAvoidFavorsSets() {
      return avoidFavorsSet;
    }

    function hasAvoidFavorsSet() {
      return getAvoidFavorsSets() !== null && getAvoidFavorsSets() !== undefined && getAvoidFavorsSets().length > 0;
    }

    function isAvoidFavorsSetReady() {
      return avoidFavorsSetReady;
    }
    function getSaveRouteLimit() {
      return saveRouteLimit;
    }
    function getSavedTrip(tripId) {
      var deferred = $q.defer();
      // get saved new route along with randomly generated routingProfileId
      $http.get(dataServiceUrl + "trips/" + tripId).success(function (resp) {
        deferred.resolve(resp);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }
    $rootScope.$on("UserLoggedIn", function (event, message) {
      // jshint ignore:line
      getData();
    });

    // when a user logs out, clear all data back to initial values.
    $rootScope.$on("UserLoggedOut", function (event, message) {
      // jshint ignore:line
      totalMiles = 0;
      savedRoutes = [];
      favoriteLocationsService.clearData();
    });

    return {
      getTotalMiles: getTotalMiles,
      saveRoute: saveRoute,
      updateRoute: updateRoute,
      canSaveRoute: canSaveRoute,
      getSavedRoutes: getSavedRoutes,
      deleteSavedRoute: deleteSavedRoute,
      getAvoidFavorsSets: getAvoidFavorsSets,
      hasAvoidFavorsSet: hasAvoidFavorsSet,
      isAvoidFavorsSetReady: isAvoidFavorsSetReady,
      getSaveRouteLimit: getSaveRouteLimit,
      getSavedTrip: getSavedTrip
    };
  }]);
})();

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    "use strict";

    angular.module("alk.accountManagement", []).constant("alk.accountManagement.config", {
        addUserUrl: "/api/ManageAccount/AddUser",
        removeUserUrl: "/api/ManageAccount/RemoveUser",
        changeUserRoleUrl: "/api/ManageAccount/ChangeUserRole",
        getUsersUrl: "/api/ManageAccount/GetUsersInAccount",
        changeEnabledUrl: "/api/ManageAccount/ChangeUserEnabled"
    }).provider("AccountManagement", ["alk.accountManagement.config", function (config) {
        Object.defineProperties(this, {
            addUserUrl: {
                get: function get() {
                    return config.addUserUrl;
                },
                set: function set(value) {
                    config.addUserUrl = value;
                }
            },
            removeUserUrl: {
                get: function get() {
                    return config.removeUserUrl;
                },
                set: function set(value) {
                    config.removeUserUrl = value;
                }
            },
            getUsersUrl: {
                get: function get() {
                    return config.getUsersUrl;
                },
                set: function set(value) {
                    config.getUsersUrl = value;
                }
            },
            changeUserRoleUrl: {
                get: function get() {
                    return config.changeUserRoleUrl;
                },
                set: function set(value) {
                    config.changeUserRoleUrl = value;
                }
            },
            changeEnabledUrl: {
                get: function get() {
                    return config.changeEnabledUrl;
                },
                set: function set(value) {
                    config.changeEnabledUrl = value;
                }
            }
        });

        this.$get = ["$q", "$http", function ($q, $http) {
            function addUser(user) {
                return $http.post(config.addUserUrl, user);
            }

            function removeUser(user) {
                return $http.post(config.removeUserUrl, user);
            }

            function changeUserRole(userRole) {
                var deferred = $q.defer();

                $http.post(config.changeUserRoleUrl, userRole).success(function (resp) {
                    deferred.resolve(resp.role);
                }).error(function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            }

            function getUsers(pagingParam, includeDisabled) {
                var deferred = $q.defer();

                pagingParam.params.includeDisabled = includeDisabled === true;

                $http.get(config.getUsersUrl, pagingParam).success(function (resp) {

                    deferred.resolve({
                        total: resp.Total,
                        users: _.map(resp.Results, function (item) {
                            item.isAdmin = item.RoleName === "Company Administrator";
                            return item;
                        })
                    });
                }).error(function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            }

            function changeEnabled(toggleAccess) {
                var deferred = $q.defer();

                $http.post(config.changeEnabledUrl, toggleAccess).success(function (resp) {
                    deferred.resolve();
                }).error(function (err) {
                    deferred.reject(err);
                    return $q.reject(err);
                });

                return deferred.promise;
            }

            var service = {
                addUser: addUser,
                removeUser: removeUser,
                changeUserRole: changeUserRole,
                getUsers: getUsers,
                changeEnabled: changeEnabled
            };

            return service;
        }];
    }]);
})();

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

  angular.module("app").filter("moment", [function () {
    return function (date, method) {
      var momented = window.moment(date);
      return momented[method].apply(momented, Array.prototype.slice.call(arguments, 2));
    };
  }]);

  angular.module("app").filter("momentParse", [function () {
    return function (date, format) {
      return window.moment(date, format);
    };
  }]);

  angular.module("app").filter("colorFilter", function () {
    function hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }

    function rgbToHex(r, g, b) {
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    function shadeColor(color, percent) {
      var f = parseInt(color.slice(1), 16),
          t = percent < 0 ? 0 : 255,
          p = percent < 0 ? percent * -1 : percent,
          R = f >> 16,
          G = f >> 8 & 0x00FF,
          B = f & 0x0000FF;
      return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
    }

    function blendColors(c0, c1, p) {
      var f = parseInt(c0.slice(1), 16),
          t = parseInt(c1.slice(1), 16),
          R1 = f >> 16,
          G1 = f >> 8 & 0x00FF,
          B1 = f & 0x0000FF,
          R2 = t >> 16,
          G2 = t >> 8 & 0x00FF,
          B2 = t & 0x0000FF;
      return "#" + (0x1000000 + (Math.round((R2 - R1) * p) + R1) * 0x10000 + (Math.round((G2 - G1) * p) + G1) * 0x100 + (Math.round((B2 - B1) * p) + B1)).toString(16).slice(1);
    }

    return function (input, type, value) {
      var returnVal;

      if (type === "darken") {
        returnVal = shadeColor(input, value * -1);
      }

      if (type === "lighten") {
        returnVal = shadeColor(input, value);
      }

      return returnVal;
    };
  });

  angular.module("app").filter("unsafe", ["$sce", function ($sce) {
    return $sce.trustAsHtml;
  }]);
})();

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var integerDirectiveId = "pcmInteger";
  var numberDirectiveId = "pcmNumber";
  var rangeDirectiveId = "pcmRange";
  var accountInUseDirectiveId = "pcmAccountInUse";
  var uniqueAccountNameDirectiveId = "pcmUniqueAccount";
  var verificationTokenDirectiveId = "pcmVerificationToken";
  var matchDirectiveId = "pcmCompareField";

  angular.module("app").directive(integerDirectiveId, function () {
    return {
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {
        var INTEGER_REGEXP = /^\-?\d+$/;

        function integerValidation(val) {

          if (val == null || val === "") {
            ctrl.$setValidity("pcmInteger", true);
            return val;
          }

          if (INTEGER_REGEXP.test(val)) {
            ctrl.$setValidity("pcmInteger", true);
            return parseInt(val);
          } else {
            ctrl.$setValidity("pcmInteger", false);
            return undefined;
          }
        }

        ctrl.$parsers.unshift(integerValidation);
        ctrl.$formatters.unshift(integerValidation);
      }
    };
  });

  angular.module("app").directive(numberDirectiveId, function () {
    return {
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {
        var NUM_REGEXP = /^\-?\d+((\.|\,)\d+)?$/;

        function numberValidation(val) {
          if (val == null || val === "") {
            ctrl.$setValidity("pcmNumber", true);
            return val;
          }

          if (typeof val === "number") {
            val = val.toString();
          }

          if (NUM_REGEXP.test(val)) {
            ctrl.$setValidity("pcmNumber", true);
            return parseFloat(val.replace(",", "."));
          } else {
            ctrl.$setValidity("pcmNumber", false);
            return undefined;
          }
        }

        ctrl.$parsers.unshift(numberValidation);
        ctrl.$formatters.unshift(numberValidation);
      }
    };
  });

  angular.module("app").directive(rangeDirectiveId, function () {
    return {
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {
        scope.$watch(function () {
          return attrs.pcmRangeMin;
        }, function () {
          ctrl.$validate();
        });
        scope.$watch(function () {
          return attrs.pcmRangeMax;
        }, function () {
          ctrl.$validate();
        });

        function rangeValidation(val) {
          var min = parseFloat(attrs.pcmRangeMin);
          var max = parseFloat(attrs.pcmRangeMax);
          if (val == null || val === "") {
            ctrl.$setValidity("pcmRange", true);
            return val;
          }

          if (min !== undefined && max !== undefined) {
            val = parseFloat(val);
            if (val >= min && val <= max) {
              ctrl.$setValidity("pcmRange", true);
              return val;
            } else {
              ctrl.$setValidity("pcmRange", false);
              return undefined;
            }
          }
        }

        ctrl.$parsers.unshift(rangeValidation);
        ctrl.$formatters.unshift(rangeValidation);
      }
    };
  });

  // idea from: http://stackoverflow.com/questions/24385104/password-matching-in-angularjs-using-the-validators-pipeline-produces-unexpecte
  angular.module("app").directive(matchDirectiveId, function () {
    var d = {
      restrict: "A",
      require: "ngModel",
      scope: {},
      link: function link(scope, element, attr, control) {
        scope.$watch(matchDirectiveId, function () {
          control.$validate();
        });

        control.$validators[matchDirectiveId] = function (modelValue, viewValue) {
          var value = modelValue || viewValue;
          var password = scope[matchDirectiveId];
          return value === password;
        };
      }
    };

    d.scope[matchDirectiveId] = "=";

    return d;
  });

  // Determines if an account name already exists in SSO
  angular.module("app").directive(uniqueAccountNameDirectiveId, ["$http", "$q", function ($http, $q) {
    return {
      require: "ngModel",
      link: function link(scope, elem, attrs, ngModel) {
        ngModel.$asyncValidators[uniqueAccountNameDirectiveId] = function (modelValue, viewValue) {

          if (!viewValue) {
            return $q.when(true);
          }

          var deferred = $q.defer();

          //todo: add caching for ajax calls like this to prevent them from being called with the same parameters multiple times.
          $http.get("/api/Account/Exists?accountName=" + encodeURIComponent(viewValue)).then(function (resp) {
            if (resp.data.Exists === true) {
              deferred.reject();
            } else {
              deferred.resolve();
            }
          }).catch(function () {
            deferred.reject();
          });

          return deferred.promise;
        };
      }
    };
  }]);

  // Determines if an account name already exists in SSO associated with PCMiler Website
  angular.module("app").directive(accountInUseDirectiveId, function () {
    return {
      restrict: "A",
      require: "ngModel",
      scope: {
        match: "="
      },
      link: function link(scope, element, attr, control) {
        control.$validators[accountInUseDirectiveId] = function (modelValue, viewValue) {
          var value = modelValue || viewValue;

          // if neither viewValue or modelValue is set, return valid - The required validator takes care of making sure the value is set.
          if (value == null) {
            return true;
          }

          var accountId = parseInt(value);

          // the account Id is set to -1 on the hdnAccountId element when
          return accountId >= 0;
        };
      }
    };
  });

  // Determines if a verification token is valid for an emails address
  angular.module("app").directive(verificationTokenDirectiveId, ["$http", "$q", function ($http, $q) {
    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$asyncValidators[verificationTokenDirectiveId] = function (modelValue, viewValue) {
          if (!viewValue) {
            return $q.when(true);
          }

          var deferred = $q.defer();

          var email = attrs[verificationTokenDirectiveId];
          if (email == null || email === "") {
            return $q.when(true);
          }

          $http.post("/api/Signup/ValidateToken?email=" + encodeURIComponent(email) + "&token=" + viewValue).success(function (response) {
            if (response.IsValid) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          }).error(function () {
            deferred.reject();
          });

          return deferred.promise;
        };
      }
    };
  }]);

  angular.module("app").directive("uniqueFavoriteName", ["_", "favoriteNameValidator", "$q", function (_, favoriteNameValidator, $q) {
    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$asyncValidators["uniqueFavoriteName"] = function (modelValue, viewValue) {
          if (viewValue == null) {
            return $q.resolve(true);
          }

          return favoriteNameValidator.isNameUnique(viewValue);
        };
      }
    };
  }]);

  angular.module("app").directive("pcmEmail", function () {
    var REGEX_EMAIL = /^([\w?^_.+-]+\w)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$validators.pcmEmail = function (modelValue) {
          if (modelValue == null || modelValue === "") {
            return true;
          }
          return REGEX_EMAIL.test(modelValue);
        };
      }
    };
  });

  angular.module("app").directive("accountEmail", function () {
    var REGEX_EMAIL = /^([\w?^_.-]+\w)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$validators.accountEmail = function (modelValue) {
          if (modelValue == null || modelValue === "") {
            return true;
          }
          return REGEX_EMAIL.test(modelValue);
        };
      }
    };
  });

  angular.module("app").directive("pcmUnique", function () {
    return {
      restrict: "A",
      scope: {
        "items": "="
      },
      require: "ngModel",
      link: function link(scope, elem, attrs, ngModel) {

        scope.$watch("items", function (newValue, oldValue) {
          var count = 0;
          var value = ngModel.$viewValue;

          for (var i = 0; i < newValue.length; i++) {
            // TODO: make this more generic so 'email' is not hard coded here.  How to take the newvalue[i] and get the $viewValue from it?
            if (newValue[i].email === value) {
              count++;

              if (count > 1) {
                ngModel.$setValidity("pcmUnique", false);
                return;
              }
            }
          }

          ngModel.$setValidity("pcmUnique", true);
        }, true);
      }
    };
  });

  // Determines if an account name already exists in SSO
  angular.module("app").directive("uniqueUsername", ["$q", "signupService", function ($q, signupService) {
    return {
      require: "ngModel",
      link: function link(scope, elem, attrs, ngModel) {
        ngModel.$asyncValidators.uniqueUsername = function (modelValue, viewValue) {

          if (!viewValue) {
            return $q.when(true);
          }

          var deferred = $q.defer();

          signupService.userExists(viewValue).then(function (resp) {
            if (resp.data.Exists === true) {
              deferred.reject();
            } else {
              deferred.resolve();
            }
          }).catch(function () {
            deferred.reject();
          });

          return deferred.promise;
        };
      }
    };
  }]);

  angular.module("app").directive("alkPassword", ["$compile", function ($compile) {
    return {
      restrict: "A",
      require: "ngModel",
      scope: {},
      link: function link(scope, element, attrs, ngModel) {

        ngModel.$validators.alkPassword = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var validationObj = {};
          validationObj.length = password.length >= 8 && password.length <= 20;
          validationObj.lowercase = /[a-z]/.test(password);
          validationObj.uppercase = /[A-Z]/.test(password);
          validationObj.number = /\d/.test(password);
          validationObj.specialCharacter = /[!@#\$%&\*\^_\-\+]/.test(password);
          validationObj.overall = Object.values(validationObj).every(function (isTrue) {
            return isTrue;
          });
          return validationObj.overall;
        };
        ngModel.$validators.hasLength = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var length = password.length >= 8 && password.length <= 20;
          return length;
        };
        ngModel.$validators.hasLowercase = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var lowercase = /[a-z]/.test(password);
          return lowercase;
        };
        ngModel.$validators.hasUppercase = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var uppercase = /[A-Z]/.test(password);
          return uppercase;
        };
        ngModel.$validators.hasNumber = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var number = /\d/.test(password);
          return number;
        };
        ngModel.$validators.hasCharacter = function (password) {
          if (password == null || password === "") {
            return true;
          }
          var specialCharacter = /[!@#\$%&\*\^_\-\+]/.test(password);
          return specialCharacter;
        };
      }
    };
  }]);
})(angular);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  // TODO pchen: refactor this and the identically-named
  //   directive in Common Javascript Files/.../common-directives.js
  //   note: will probably require moving copyrightText outside of
  //   common-directives.js, since the other directives have dependencies
  //   that ALKCloud does not need to require
  //   note 2: I still can't find the ALKCloud page that has a copyright...
  var m = angular.module("copyright.text", []);

  m.directive("copyrightText", function () {
    return {
      scope: {},
      restrict: "AE",
      replace: true,
      template: "<span class=\"copyright-text\">Copyright &copy; 2010-{{year}} Trimble Inc. All Rights Reserved.</span>",
      link: function link(scope, elem, attrs) {
        // jshint ignore:line
        scope.year = new Date().getFullYear();
      }
    };
  });
})(angular);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  var m = angular.module("app");

  m.directive("pcmMessages", ["Messages", "_", function (Messages, _) {

    var templateString = "<div id=\"messages\">" + "<div class=\"alert alert-{{ message.type }}\" ng-repeat=\"message in messages\">" + "<a class=\"close\" ng-click=\"closeMessage(message)\" data-dismiss=\"alert\">&times;</a>" + "<span ng-bind-html=\"message.message | unsafe\"></span>" + "</div>" + "</div>";

    return {
      restrict: "E",
      template: templateString,
      scope: {},
      controller: ["$scope", function ($scope) {
        var messages = Messages.getMessages();

        for (var i = 0; i < messages.length; i++) {
          messages[i].read = true;
        }
        $scope.messages = messages;

        $scope.closeMessage = function (message) {
          message.closed = true;
          var index = $scope.messages.indexOf(message);
          $scope.messages.splice(index, 1);
        };

        $scope.$watchCollection(function () {
          return Messages.getMessages();
        }, function (messages) {
          for (var j = 0; j < messages.length; j++) {
            messages[j].read = true;
          }
          $scope.messages = messages;
        });
      }],
      link: function link(scope, element, attrs) {}
    };
  }]);

  m.directive("pcmSubmit", ["$parse", function ($parse) {
    return {
      restrict: "A",
      require: ["form"],
      link: function link(scope, element, attrs, controllers) {
        var formController = controllers[0];
        var fn = $parse(attrs.pcmSubmit);
        var submitIfFn;

        if (attrs.pcmSubmitIf) {
          submitIfFn = $parse(attrs.pcmSubmitIf);
        }

        formController.shouldSubmit = function (event) {
          if (typeof submitIfFn === "function" && submitIfFn(scope, {
            $event: event
          }) === false) {
            return false;
          }

          return true;
        };

        formController.needsAttention = function (field) {
          return field.$invalid && formController.submitted;
        };

        formController.setSubmitted = function (val) {
          formController.submitted = val;
          if (!scope.$$phase) scope.$apply();
        };

        function safeApply(scope, fn) {
          scope.$$phase || scope.$root.$$phase ? fn() : scope.$apply(fn);
        }

        element.bind("submit", function (event) {
          if (formController.shouldSubmit(event) === false) {
            return;
          }

          formController.setSubmitted(true);

          if (!scope.$$phase) scope.$apply();

          if (!formController.$valid) return false;

          safeApply(scope, function () {
            formController.setSubmitted(false);
            fn(scope, {
              $event: event
            });
          });
        });
      }
    };
  }]);
})(window.angular);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var classOnValueDirective = "pcmClassOnValue";

  angular.module("app").directive(classOnValueDirective, function () {
    return {
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        scope.$watch(function () {
          return ngModel.$viewValue;
        }, function (newValue, oldValue) {
          if (newValue !== "" && newValue != null) {
            element.addClass(attrs.pcmClassOnValue);
          } else {
            element.removeClass(attrs.pcmClassOnValue);
          };
        });
      }
    };
  });
})(angular);

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.geocode", []);
})(window.angular);

__webpack_require__(113);

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./marketing.less", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./marketing.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Droid+Serif:400,400i,700,700i|Oswald);", ""]);

// module
exports.push([module.i, ".Oswald {\n  font-family: \"Oswald\";\n}\n.tal {\n  text-align: left;\n}\n.tac {\n  text-align: center;\n}\n.tar {\n  text-align: right;\n}\n.textCenter {\n  text-align: center;\n}\n.fontBold {\n  font-weight: 700;\n}\n.ico-alk-logo,\n.ico-alk-logo-registered {\n  font-size: 100px;\n  color: white;\n  -webkit-transition: all linear 0.2s;\n  transition: all linear 0.2s;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0.5);\n}\n.ico-alk-logo:hover,\n.ico-alk-logo-registered:hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n.ico-alk-logo-registered {\n  margin-right: -10%;\n}\n.clearfix {\n  display: block;\n  -ms-zoom: 1;\n  zoom: 1;\n}\n.clearfix:after {\n  content: \" \";\n  display: block;\n  font-size: 0;\n  height: 0;\n  clear: both;\n  visibility: hidden;\n}\nbody.marketingPage {\n  background-color: #2d3238;\n}\n.marketing-page {\n  position: relative;\n  padding: 0;\n  font-family: 'Open Sans', sans-serif;\n}\n.marketing-page h1 {\n  margin: 0;\n}\n.marketing-page h3 {\n  font-size: 32px;\n  line-height: 1.3;\n  font-weight: 400;\n  letter-spacing: 0;\n  font-family: \"Oswald\";\n  text-align: center;\n}\n.marketing-page .preload {\n  display: none;\n}\n.marketing-page .page-logo {\n  width: 230px;\n  margin: 40px 0;\n}\n.marketing-page .btn {\n  border-radius: 0;\n  border-width: 0;\n  text-shadow: none;\n}\n.marketing-page .btn.btn-default {\n  border-width: 1px;\n}\n.marketing-page .btn.btn-lg {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.top-section h1 {\n  font-family: \"Oswald\";\n  font-size: 20pt;\n  line-height: 25pt;\n}\n.top-section h1.with-icon {\n  padding-left: 112px;\n}\n.top-section p.subhead {\n  margin-top: 30px;\n  font-size: 14pt;\n  line-height: 22pt;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n.top-section p.subhead.bullet {\n  padding-left: 25px;\n  margin-top: 15px;\n}\n.top-section p.subhead.bullet > span.ico {\n  margin-left: -25px;\n  margin-right: 9px;\n}\n.landing-app-icon {\n  display: block;\n  height: 92px;\n  width: 92px;\n  padding: 13px;\n  background-color: #fff;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);\n}\n.top-section .landing-app-icon {\n  margin-right: 20px;\n  margin-bottom: 20px;\n  display: inline-block;\n  float: left;\n  margin-left: -112px;\n  margin-bottom: 0;\n}\n.login-box {\n  overflow: hidden;\n}\n.login-form {\n  background-color: #fff;\n  border-radius: 5px 5px 0 0;\n  padding: 20px 35px;\n  position: relative;\n  z-index: 10;\n}\n.login-form .row {\n  margin-bottom: 10px;\n}\n.login-form .row:last-of-type {\n  margin-bottom: 0;\n}\n.login-form .form-group {\n  margin-bottom: 5px;\n}\n.login-form label {\n  font-weight: 600;\n  color: #7d8690;\n  font-size: 12px;\n}\n.login-form ul {\n  padding: 0px;\n}\n.login-form ul li {\n  list-style: none;\n}\n.login-form input,\n.login-form select {\n  background-color: #f6f6f6;\n  border: 1px solid #f6f6f6;\n  color: #7d8690;\n  font-size: 12pt;\n  height: 50px;\n  border-radius: 0;\n  font-weight: 300;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n}\n.login-form input:focus,\n.login-form select:focus {\n  border-color: #8fcbe6;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.login-form input[type=\"checkbox\"] {\n  top: 20px;\n  position: relative;\n  margin-right: 10px;\n  width: auto;\n}\n.login-form input[type=\"email\"] {\n  width: 98% !important;\n}\n.login-form input[name=\"number_of_trucks_text\"] {\n  width: 47% !important;\n}\n.login-form .hs-error-msgs label {\n  color: #a94442;\n}\n.login-form .hs-button {\n  color: #ffffff;\n  background-color: #5cb85c;\n  border-color: #4cae4c;\n}\n.login-form .hs-button:hover {\n  color: #ffffff;\n  background-color: #449d44;\n  border-color: #398439;\n}\n.login-form .hs_error_rollup {\n  display: none;\n}\n.login-form .has-error .form-control {\n  border-color: #a94442;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.login-form .help-block {\n  font-size: 12px;\n}\n.login-form .text-small {\n  font-size: 13px;\n}\n.login-form input:-webkit-autofill,\n.login-form input:-webkit-autofill:hover,\n.login-form input:-webkit-autofill:focus input:-webkit-autofill,\n.login-form textarea:-webkit-autofill,\n.login-form textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,\n.login-form select:-webkit-autofill,\n.login-form select:-webkit-autofill:hover,\n.login-form select:-webkit-autofill:focus {\n  -webkit-box-shadow: inset 0 0 0px 9999px #f6f6f6;\n}\n.login-title {\n  font-family: \"Oswald\";\n  font-size: 19.5pt;\n  line-height: 22.5pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #3f4449;\n  margin-bottom: 5px;\n}\n.login-subhead {\n  font-size: 14pt;\n  line-height: 19.5pt;\n  font-weight: 300;\n  letter-spacing: -0.52pt;\n  color: #3f4449;\n  margin-bottom: 15px;\n}\n.login-tabs .login-tab {\n  font-size: 15pt;\n  line-height: 41pt;\n  text-transform: uppercase;\n  cursor: pointer;\n  text-align: center;\n  -webkit-box-shadow: inset 0 2px 4px 1px rgba(0, 0, 0, 0.25);\n  box-shadow: inset 0 2px 4px 1px rgba(0, 0, 0, 0.25);\n}\n.login-tabs .login-tab:first-child {\n  border-bottom-left-radius: 5px;\n}\n.login-tabs .login-tab:last-child {\n  border-bottom-right-radius: 5px;\n}\n.login-tabs .login-tab.active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.login-tabs .login-tab.active:before {\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 10px 16.5px 0 16.5px;\n  border-color: #ffffff transparent transparent transparent;\n  position: absolute;\n  z-index: 20;\n  left: calc(50% - 16px);\n}\np.availability {\n  font-family: \"Droid Serif\";\n  font-style: italic;\n  font-size: 13pt;\n  line-height: 17pt;\n  font-weight: 700;\n  letter-spacing: 0;\n  color: #dddee4;\n  margin-top: 20px;\n}\np.availability-dark {\n  font-family: \"Droid Serif\";\n  font-style: italic;\n  font-size: 13pt;\n  line-height: 17pt;\n  font-weight: 700;\n  letter-spacing: 0;\n  color: #4a525c;\n  margin-top: 20px;\n}\n.navbar-brand {\n  padding: 0 30px;\n  height: 20px;\n}\n#main-menu {\n  width: 100%;\n  margin-bottom: 0;\n}\n#main-menu .nav-wrapper {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  height: 110px;\n  width: 100%;\n  background-color: white;\n  -webkit-transition: all ease-in-out 0.2s;\n  transition: all ease-in-out 0.2s;\n}\n#main-menu .nav-wrapper .ico-alk-logo,\n#main-menu .nav-wrapper .ico-alk-logo-registered {\n  font-size: 120px;\n  color: #4a525c;\n  -webkit-transition: all linear 0.2s;\n  transition: all linear 0.2s;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0);\n}\n#main-menu .nav-wrapper .ico-alk-logo:hover,\n#main-menu .nav-wrapper .ico-alk-logo-registered:hover {\n  color: #1d2023;\n}\n#main-menu .nav-wrapper .ico-alk-logo-registered {\n  margin-right: -10%;\n}\n#main-menu .nav-wrapper .navbar-brand {\n  background-color: white;\n  margin-top: -20px;\n  border-radius: 14px 14px 0 0;\n  box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.25);\n}\n#main-menu.transform-fix .nav-wrapper {\n  -webkit-transform: translate3D(0, 0, 0);\n  -moz-transform: translate3D(0, 0, 0);\n  -ms-transform: translate3D(0, 0, 0);\n  -o-transform: translate3D(0, 0, 0);\n  transform: translate3D(0, 0, 0);\n}\n.is-sticky #main-menu,\n#main-menu.alk-static-nav {\n  position: fixed;\n  top: 0;\n}\n.is-sticky #main-menu .nav-wrapper,\n#main-menu.alk-static-nav .nav-wrapper {\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.25);\n  height: 80px;\n  top: 0;\n  width: 100%;\n}\n.is-sticky #main-menu .nav-wrapper .ico-alk-logo,\n#main-menu.alk-static-nav .nav-wrapper .ico-alk-logo,\n.is-sticky #main-menu .nav-wrapper .ico-alk-logo-registered,\n#main-menu.alk-static-nav .nav-wrapper .ico-alk-logo-registered {\n  font-size: 90px;\n  color: #4a525c;\n  -webkit-transition: all linear 0.2s;\n  transition: all linear 0.2s;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0);\n}\n.is-sticky #main-menu .nav-wrapper .ico-alk-logo:hover,\n#main-menu.alk-static-nav .nav-wrapper .ico-alk-logo:hover,\n.is-sticky #main-menu .nav-wrapper .ico-alk-logo-registered:hover,\n#main-menu.alk-static-nav .nav-wrapper .ico-alk-logo-registered:hover {\n  color: #1d2023;\n}\n.is-sticky #main-menu .nav-wrapper .ico-alk-logo-registered,\n#main-menu.alk-static-nav .nav-wrapper .ico-alk-logo-registered {\n  margin-right: -10%;\n}\n.is-sticky #main-menu .navbar-brand,\n#main-menu.alk-static-nav .navbar-brand {\n  margin-top: -4px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.is-sticky #main-menu .navbar-nav,\n#main-menu.alk-static-nav .navbar-nav {\n  margin-top: 14px;\n}\n.is-sticky #main-menu + div,\n#main-menu.alk-static-nav + div {\n  margin-top: 80px;\n}\n.navbar-toggle {\n  padding: 5px 8px;\n  font-size: 48px;\n  line-height: 0.75;\n  color: #4a525c;\n  border-radius: 2px;\n  border: 1px solid #4a525c;\n}\n.navbar-toggle:focus,\n.navbar-toggle:hover {\n  background-color: transparent;\n}\n#side-nav {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 0;\n  z-index: 1001;\n  overflow: hidden;\n  -webkit-transition: height ease-in-out 0.5s;\n  transition: height ease-in-out 0.5s;\n}\n#side-nav.side-menu-active {\n  height: 100%;\n}\n#side-nav.side-menu-active #side-menu {\n  height: 100%;\n  overflow: scroll;\n}\n#side-nav.side-menu-active #side-menu .navbar-header {\n  height: 70px;\n  opacity: 1;\n}\n#side-nav .ico-alk-logo,\n#side-nav .ico-alk-logo-registered {\n  font-size: 90px;\n  color: white;\n  -webkit-transition: all linear 0.2s;\n  transition: all linear 0.2s;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0);\n}\n#side-nav .ico-alk-logo:hover,\n#side-nav .ico-alk-logo-registered:hover {\n  color: rgba(255, 255, 255, 0.8);\n}\n#side-nav .ico-alk-logo-registered {\n  margin-right: -10%;\n}\n#side-nav #side-menu {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 0;\n  margin-bottom: 0;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n}\n#side-nav #side-menu .navbar-header {\n  position: fixed;\n  opacity: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 0;\n  padding: 0 25px 0 24px;\n  background-color: #000;\n  overflow: hidden;\n  z-index: 2000;\n  -webkit-transition: all ease-in-out 0.5s;\n  transition: all ease-in-out 0.5s;\n}\n#side-nav #side-menu .navbar-header .navbar-brand {\n  position: relative;\n  top: -4px;\n}\n#side-nav #side-menu .navbar-header .navbar-toggle {\n  display: block !important;\n  color: white;\n}\n#side-nav #side-menu .navbar-header .navbar-toggle:active,\n#side-nav #side-menu .navbar-header .navbar-toggle:focus {\n  background-color: transparent;\n}\n#side-nav #side-menu .nav-sidebar {\n  position: relative;\n  top: 70px;\n}\n#side-nav #side-menu li > a {\n  color: white;\n  font-size: 18px;\n  line-height: 34px;\n}\n#side-nav #side-menu .nav > li > a:focus,\n#side-nav #side-menu .nav > li > a:hover {\n  background-color: rgba(120, 127, 135, 0.4);\n}\n#side-nav #side-menu .dropdown-header {\n  font-size: 18px;\n  padding-left: 0;\n  padding-right: 0;\n  color: #aaa;\n}\n.nav-background {\n  background-color: #4a525c;\n  background-color: rgba(26, 32, 51, 0.4);\n}\n.dropDownUpMenu {\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  border: 1px solid #d9d9d9;\n  min-width: 100%;\n  margin-bottom: 0;\n}\n.navbar-nav {\n  margin-top: 24px;\n}\n.navbar-nav > li.dropup > .dropdown-menu {\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  border: 1px solid #d9d9d9;\n  min-width: 100%;\n  margin-bottom: 0;\n  border-bottom: 0;\n  border-radius: 5px 5px 0 0;\n}\n.navbar-nav > li.dropdown > .dropdown-menu {\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  border: 1px solid #d9d9d9;\n  min-width: 100%;\n  margin-bottom: 0;\n  border-top: 0;\n  border-radius: 0 0 5px 5px;\n}\n.navbar-nav .dropdown-header {\n  font-size: 10px;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n.navbar-default .navbar-nav li a {\n  color: #4a525c;\n  font-size: 15px;\n  font-weight: 600;\n  border: 1px solid white;\n  -webkit-transition: border-color linear 0.3s;\n  transition: border-color linear 0.3s;\n}\n.navbar-default .navbar-nav > li:hover > a {\n  background-color: white;\n  border: 1px solid #d9d9d9;\n  position: relative;\n  z-index: 1002;\n}\n.navbar-default .navbar-nav > li.dropdown:hover > a {\n  border-bottom-color: white;\n}\n.navbar-default .navbar-nav > li.dropup:hover > a {\n  border-top-color: white;\n}\n.navbar-default {\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0);\n  border-color: rgba(231, 231, 231, 0);\n}\n.sideBySideBase {\n  background-color: white;\n  position: absolute;\n  min-width: 380px;\n  display: none;\n  border-radius: 0 0 5px 5px;\n  z-index: 1000;\n}\n.dropdown .side-by-side,\n.dropup .side-by-side {\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n  border: 1px solid #d9d9d9;\n  min-width: 100%;\n  margin-bottom: 0;\n  background-color: white;\n  position: absolute;\n  min-width: 380px;\n  display: none;\n  border-radius: 0 0 5px 5px;\n  z-index: 1000;\n  margin-top: -1px;\n}\n.dropdown .side-by-side .dropdown-menu.dropdown-menu-float,\n.dropup .side-by-side .dropdown-menu.dropdown-menu-float {\n  background: none;\n  border: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  float: left;\n  position: relative;\n}\n.dropdown:hover .side-by-side,\n.dropup:hover .side-by-side {\n  display: block;\n}\n.dropup .side-by-side {\n  bottom: 51px;\n  margin-bottom: -1px;\n  border-radius: 5px 5px 0 0;\n}\n.pcm-asterix {\n  font-size: 0.75em;\n}\n.searchBar {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 1px;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n.greyDarkRow {\n  background-color: #2d3238;\n  color: #ffffff;\n}\n.whiteRow {\n  background-color: #ffffff;\n}\n.greyMediumRow {\n  background-color: #4a525c;\n}\n.topBannerArea {\n  /*&.fixed {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100px;\n    z-index: 200;\n    }*/\n  background-size: cover;\n  background-position: center bottom;\n  box-shadow: inset 0 -1px 4px rgba(0, 0, 0, 0.25);\n  background-repeat: no-repeat;\n}\n.topBannerArea .basic-banner {\n  max-height: 450px;\n  position: relative;\n  overflow: hidden;\n}\n.topBannerArea .basic-title {\n  text-align: right;\n  position: absolute;\n  bottom: 0;\n  font-weight: 900;\n  font-size: 130px;\n  line-height: 0.72;\n  margin: 0;\n  letter-spacing: -0.05em;\n  color: #FFFFFF;\n  right: 3px;\n  text-shadow: 0 0 6px rgba(0, 0, 0, 0.25);\n  text-transform: uppercase;\n}\n.topBannerArea .basic-title.small-title {\n  font-size: 80px;\n}\n.topBannerArea .banner-background {\n  background-size: cover;\n  background-color: #8c94a8;\n}\n.topBannerArea .banner-background .container {\n  height: 100%;\n  position: relative;\n}\n.topBannerArea .carousel,\n.topBannerArea .carousel-inner,\n.topBannerArea .carousel-caption,\n.topBannerArea .item,\n.topBannerArea .banner-background {\n  height: 100%;\n}\n.topBannerArea .banner-text {\n  position: absolute;\n  left: 15px;\n  right: 15px;\n}\n.topBannerArea .banner-text .top-title {\n  font-weight: 900;\n  font-size: 44px;\n  color: white;\n  letter-spacing: -0.05em;\n  line-height: 0.9;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0.8);\n}\n.topBannerArea .banner-text .bottom-title {\n  color: #ffdf71;\n  font-size: 40px;\n  font-weight: 200;\n  line-height: 0.9;\n  letter-spacing: -0.03em;\n  text-shadow: 1px 1px 0 rgba(74, 82, 92, 0.8);\n}\n.ALKfooter {\n  font-weight: 100;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  background-color: #2d3238;\n}\n.ALKfooter .content,\n.ALKfooter .copyright {\n  color: #787f87;\n}\n.ALKfooter .title {\n  color: #1ca8f1;\n}\n.ALKfooter .alk-img {\n  margin-bottom: 10px;\n}\n.ALKfooter a {\n  color: #b1bbc7;\n}\n.ALKfooter a:hover {\n  color: #ffffff;\n  text-decoration: none;\n}\n.ALKfooter .logo {\n  background-image: url(" + __webpack_require__(110) + ");\n  width: 92px;\n  height: 62px;\n}\n.ALKfooter .img-icon-social img,\n.ALKfooter .logos img {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.ALKfooter .logos {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.ALKfooter #alk-footer {\n  margin-bottom: 10px;\n}\n.ALKfooter .strapLine {\n  font-size: 30px;\n  font-weight: 300;\n  letter-spacing: 0.06em;\n  color: #ffffff;\n  min-height: 80px;\n  text-align: center;\n  padding-top: 0px;\n  padding-bottom: 20px;\n  margin-top: 2px;\n}\n.ALKfooter .strapLine .ico-inline {\n  margin-left: 10px;\n  margin-right: 15px;\n}\n.socialIcons a {\n  text-decoration: none;\n  font-size: 46px;\n}\n.ico-facebook-circled {\n  color: #3b5998;\n}\n.ico-facebook-circled:hover {\n  color: #718dc8;\n}\n.ico-twitter-circled {\n  color: #4099FF;\n}\n.ico-twitter-circled:hover {\n  color: #a6cfff;\n}\n.ico-vimeo-circled {\n  color: #1ab7ea;\n}\n.ico-vimeo-circled:hover {\n  color: #77d4f3;\n}\n.ico-linkedin-circled {\n  color: #0077b5;\n}\n.ico-linkedin-circled:hover {\n  color: #1cb1ff;\n}\n.back-to-top {\n  background: none;\n  margin: 0;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: 70px;\n  height: 70px;\n  z-index: 100;\n  display: none;\n  text-decoration: none;\n  color: #787f87;\n}\n.back-to-top i {\n  font-size: 60px;\n}\n#carousel-logos .carousel-inner .item {\n  text-align: center;\n}\n#carousel-logos .carousel-inner > .item > a > img,\n#carousel-logos .carousel-inner .carousel-inner > .item > img,\n#carousel-logos .carousel-inner .img-responsive,\n#carousel-logos .carousel-inner .thumbnail a > img,\n#carousel-logos .carousel-inner .thumbnail > img {\n  display: inline;\n}\n#carousel-logos .carousel-control {\n  visibility: hidden;\n}\n@media (max-width: 767px) {\n  .is-sticky #main-menu + div {\n    margin-top: 70px;\n  }\n  .topBannerArea .basic-banner {\n    max-height: initial;\n  }\n  .topBannerArea .basic-title {\n    font-size: 50px;\n    right: 0;\n  }\n  .topBannerArea .basic-title.small-title {\n    font-size: 40px;\n  }\n  .marketing-page .container {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .marketing-page .top-section p.subhead {\n    margin-bottom: 30px;\n  }\n  .ALKfooter .strapLine {\n    font-size: 18px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .topBannerArea .banner-text .top-title {\n    font-size: 54px;\n  }\n  .topBannerArea .banner-text .bottom-title {\n    font-size: 50px;\n  }\n}\n@media (max-width: 1024px) {\n  #main-menu .nav-wrapper {\n    height: 70px;\n  }\n  #main-menu .nav-wrapper .navbar-brand {\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    margin-top: -4px;\n    padding: 0 15px;\n  }\n  #main-menu .nav-wrapper .ico-alk-logo,\n  #main-menu .nav-wrapper .ico-alk-logo-registered {\n    font-size: 80px;\n  }\n  #side-nav .navbar-header {\n    height: 70px;\n  }\n  #side-nav .navbar-brand {\n    background-color: transparent;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    margin-top: 0;\n    padding: 0 7px;\n  }\n  #side-nav .ico-alk-logo,\n  #side-nav .ico-alk-logo-registered {\n    font-size: 80px;\n  }\n  #side-nav .navbar-toggle {\n    margin-right: 0;\n  }\n  .navbar-toggle {\n    font-size: 38px;\n    margin-top: 10px;\n  }\n  .is-sticky #main-menu .nav-wrapper {\n    height: 70px;\n  }\n  .is-sticky #main-menu .nav-wrapper .ico-alk-logo,\n  .is-sticky #main-menu .nav-wrapper .ico-alk-logo-registered {\n    font-size: 80px;\n  }\n}\n/* iPad and Tablet nav overrides*/\n@media (min-width: 768px) and (max-width: 1024px) {\n  .is-sticky #main-menu + div {\n    margin-top: 70px;\n  }\n  .side-menu-active .topBannerArea > .container {\n    overflow: visible;\n  }\n  .navbar-header {\n    float: none;\n    /*.side-menu-active & {\n            left: 0;\n            right: 0;\n            padding: 0 25px;\n        }*/\n  }\n  .navbar-default .navbar-toggle {\n    display: block;\n    /*margin-right: 0;\n        margin-top: 20px;\n        margin-bottom: 15px;*/\n  }\n  .navbar-collapse.collapse {\n    display: none !important;\n    height: 0 !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .topBannerArea .basic-title {\n    font-size: 100px;\n  }\n  .topBannerArea .basic-title.small-title {\n    font-size: 60px;\n  }\n  #side-nav #side-menu > ul {\n    margin: 0 20px;\n  }\n  .sol_box h3 {\n    font-size: 28px;\n    line-height: 1.1;\n  }\n  .sol_box p {\n    font-size: 14px;\n    line-height: 1.3;\n    margin: 0;\n  }\n}\n/* iPad and Tablet nav overrides*/\n@media (min-width: 1025px) {\n  .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .topBannerArea .banner-text .top-title {\n    font-size: 64px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .topBannerArea .banner-text .bottom-title {\n    font-size: 60px;\n  }\n}\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  .topBannerArea .banner-text .top-title {\n    font-size: 84px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .topBannerArea .banner-text .bottom-title {\n    font-size: 80px;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n.pcmweb-top-section,\n.pcm-top-section {\n  padding-top: 45px;\n  padding-bottom: 45px;\n}\n.pcmweb-top-section .page-logo,\n.pcm-top-section .page-logo {\n  width: 285px;\n}\n.homePage .pcmweb-top-section .page-logo,\n.homePage .pcm-top-section .page-logo {\n  width: 390px;\n}\n.pcmweb-top-section h1,\n.pcm-top-section h1 {\n  color: #b0d45d;\n}\n.pcmweb-top-section p.subhead,\n.pcm-top-section p.subhead {\n  color: #fff;\n}\n.pcmweb-top-section p.subhead.bullet > span.ico,\n.pcm-top-section p.subhead.bullet > span.ico {\n  color: #b0d45d;\n}\n.pcmweb-top-section .callout .subhead,\n.pcm-top-section .callout .subhead {\n  padding-bottom: 15px;\n  font-weight: 600;\n  margin-top: 15px;\n}\n.pcmweb-top-section .subhead:first-child,\n.pcm-top-section .subhead:first-child {\n  padding-top: 30px;\n  border-bottom: 1px solid #ddd;\n}\n.pcmweb-top-section .btn-default,\n.pcm-top-section .btn-default {\n  background-color: #1b2b56;\n  color: #fff;\n  border: 0;\n}\n.pcmweb-top-section .btn-default:hover,\n.pcm-top-section .btn-default:hover {\n  background-color: #1e377a;\n}\n.pcmweb-top-section .login-form,\n.pcm-top-section .login-form {\n  border-radius: 5px;\n}\n.pcmweb-top-section .row,\n.pcm-top-section .row {\n  margin-left: -5px;\n  margin-right: -5px;\n}\n.pcmweb-top-section div[class*=\"col-sm\"],\n.pcm-top-section div[class*=\"col-sm\"] {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.pcmPage #view,\n.pcmPage .marketing-page {\n  height: 100%;\n}\n.pcmPage .support-section {\n  height: 45%;\n}\n.pcmPage .signup-page-section {\n  min-height: 90%;\n}\n.pcmPage .border-bottom {\n  border-bottom: 2px solid #eee;\n  padding-bottom: 10px;\n  margin-bottom: 5px;\n}\n.pcmPage .login-button {\n  cursor: pointer;\n}\n.signUp-pcm .container {\n  margin-top: 0px;\n}\n.pcmweb-top-section {\n  background-image: url(\"/img/pcmweb-banner.jpg\");\n  background-size: cover;\n  padding-top: 0px ! important;\n}\n.tmxtid-banner-component {\n  padding: 16px 16px 0 16px;\n}\n.center-countdown {\n  width: 240px;\n  margin: auto;\n}\n.marketing-page-header {\n  background-image: url(\"/img/pcmweb-banner.jpg\");\n  background-size: cover;\n  padding-top: 45px;\n  padding-bottom: 45px;\n}\n.marketing-page-header .page-logo {\n  width: 285px;\n  margin-bottom: 0;\n}\n.marketing-page-header h1.page-title {\n  text-align: right;\n  color: #fff;\n  font-family: \"Oswald\";\n  text-transform: uppercase;\n  font-size: 35pt;\n  letter-spacing: -1pt;\n  margin-right: 15px;\n  margin-bottom: -47px;\n  line-height: 47px;\n}\n.pcm-top-section,\n.pcm-header {\n  background-color: #06476b;\n  background-image: url(\"/img/pcm-banner.webp\");\n  background-size: cover;\n  background-position: center;\n}\n.pcm-top-section .page-logo,\n.pcm-header .page-logo {\n  margin-bottom: 15px;\n}\n.alkcloud-header {\n  background-image: url(\"/img/alkcloud-banner.png\");\n  background-size: cover;\n  background-position: center;\n}\n.top-section .landing-app-icon {\n  margin-top: -12px;\n}\n.login-cta-section {\n  margin-top: 30px;\n}\np.availability {\n  font-size: 10pt;\n  line-height: 12pt;\n}\n.copilot-section {\n  background-color: #fff;\n  padding-top: 55px;\n  padding-bottom: 55px;\n}\n.copilot-section .copilot-icon {\n  width: 110px;\n  margin-bottom: 0px;\n}\n.copilot-section h2 {\n  font-family: \"Oswald\";\n  font-size: 22.5pt;\n  line-height: 27pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.copilot-section p.subhead {\n  font-size: 15pt;\n  line-height: 22.5pt;\n  font-weight: 300;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.copilot-section .btn {\n  background-color: #a0a5ba;\n  color: #fff;\n}\n.copilot-section .btn:hover {\n  background-color: #7f87a8;\n}\n.signup-box {\n  padding: 20px 35px !important;\n  border-radius: 5px;\n}\n.signup-box .heading {\n  font-family: \"Oswald\";\n  font-size: 19.5pt;\n  line-height: 22.5pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #3f4449;\n  margin-bottom: 5px;\n}\n.signup-box .sub-heading {\n  font-size: 14pt;\n  line-height: 19.5pt;\n  font-weight: 300;\n  letter-spacing: -0.52pt;\n  color: #3f4449;\n  margin-bottom: 15px;\n  padding: 5px;\n}\n.signup-box a {\n  color: #fff;\n}\n.news-section {\n  background-color: #f1f2f7;\n  padding-top: 55px;\n  padding-bottom: 90px;\n}\n.news-section .cloud-icon {\n  width: 135px;\n  color: #2978b3;\n}\n.news-section h2 {\n  font-family: \"Oswald\";\n  font-size: 22.5pt;\n  line-height: 27pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.news-section p.subhead {\n  font-size: 15pt;\n  line-height: 22.5pt;\n  font-weight: 300;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.news-section p.subhead.bullet {\n  font-size: 11pt;\n  line-height: 25pt;\n  font-weight: 700;\n  letter-spacing: 0;\n}\n.news-section p.subhead.bullet > span.ico {\n  color: #056fac;\n  margin-right: 5px;\n}\n.cloud-section {\n  background-color: #f1f2f7;\n  padding-top: 55px;\n  padding-bottom: 90px;\n}\n.cloud-section .cloud-icon {\n  width: 135px;\n  color: #2978b3;\n}\n.cloud-section h2 {\n  font-family: \"Oswald\";\n  font-size: 22.5pt;\n  line-height: 27pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.cloud-section p.subhead {\n  font-size: 15pt;\n  line-height: 22.5pt;\n  font-weight: 300;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.support-section {\n  background-color: #b0d45d;\n  padding-top: 55px;\n  padding-bottom: 90px;\n}\n.support-section .support-icon {\n  width: 150px;\n}\n.support-section h2 {\n  font-family: \"Oswald\";\n  font-size: 22.5pt;\n  line-height: 27pt;\n  font-weight: 400;\n  letter-spacing: 0;\n  color: #2d3238;\n}\n.login-pcmweb .login-tab {\n  background-color: #bd2f30;\n  color: #fff;\n}\n.login-pcmweb .login-tab.active {\n  background-color: #d04344;\n}\n.pricing-section {\n  background-color: #fff;\n  padding-top: 30px;\n  padding-bottom: 60px;\n}\n.pricing-section h2 {\n  color: #96c93d;\n  text-align: center;\n  padding: 20px 100px;\n  font-size: 15pt;\n  line-height: 20pt;\n  font-weight: 600;\n}\n.pricing-table {\n  padding-top: 50px;\n}\n.pricing-table .table {\n  background-color: #f3f3f3;\n}\n.pricing-table .table.premium {\n  margin-top: -50px;\n}\n.pricing-table .table.selected {\n  border: 1px solid #ccc;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);\n}\n.pricing-table .table td {\n  text-align: center;\n  border: 0;\n}\n.pricing-table .table tr.price-title {\n  border-bottom: 6px solid;\n}\n.pricing-table .table tr.price-title td p,\n.pricing-table .table tr.price-title td label {\n  font-family: \"Oswald\";\n  font-size: 24pt;\n  text-transform: uppercase;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.pricing-table .table .price {\n  font-family: \"Oswald\";\n  font-size: 34pt;\n  line-height: 40pt;\n  font-weight: 400;\n  letter-spacing: -0.03em;\n  margin-top: 20px;\n}\n.pricing-table .table .price-note {\n  font-size: 11pt;\n  line-height: 11pt;\n  font-weight: 300;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n.pricing-table .table .price-features {\n  font-size: 14pt;\n  line-height: 18pt;\n  font-weight: 300;\n  letter-spacing: 0;\n}\n.pricing-table .table .price-features strong {\n  font-weight: 600;\n}\n.pricing-table .table .price-features small {\n  display: block;\n  font-size: 11pt;\n  line-height: 11pt;\n  font-weight: 300;\n  letter-spacing: 0;\n  margin-top: 15px;\n}\n.pricing-table .table.free tr.price-title {\n  color: #f78d28;\n  border-color: #f78d28;\n}\n.pricing-table .table.premium tr.price-title {\n  color: #96c93d;\n  border-color: #96c93d;\n}\n.pricing-table .table.standard tr.price-title {\n  color: #55c2eb;\n  border-color: #55c2eb;\n}\n.pricing-table .table .btn {\n  color: #fff;\n  margin-bottom: 15px;\n}\n.pricing-table .table .account-type-radio {\n  display: none;\n}\n.features-section {\n  background-color: #f1f2f7;\n  padding-top: 55px;\n  padding-bottom: 90px;\n}\n.features-section .feature-table {\n  background-color: #fff;\n}\n.features-section .feature-table td,\n.features-section .feature-table th {\n  vertical-align: middle;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-color: #eee;\n}\n.features-section .feature-table td p,\n.features-section .feature-table th p {\n  margin: 0;\n}\n.features-section .feature-table td i.ico,\n.features-section .feature-table th i.ico {\n  text-align: center;\n  display: block;\n  font-size: 21px;\n  color: #96c93d;\n}\n.features-section .feature-table th {\n  border-bottom-width: 1px;\n}\n.features-section .feature-table .feature-table-section {\n  padding: 4px 12px;\n  border-bottom: 0;\n  min-width: 100px;\n  font-family: \"Oswald\";\n  font-size: 16pt;\n}\n.features-section .feature-table .feature-table-section.standard {\n  color: #55c2eb;\n}\n.features-section .feature-table .feature-table-section.premium {\n  color: #96c93d;\n}\n.features-section .feature-table .feature-no-border {\n  border: 0;\n}\n.faq-section {\n  background-color: #fff;\n  padding-top: 55px;\n  padding-bottom: 55px;\n}\n.faq-section .faq-item {\n  background-color: rgba(85, 194, 235, 0.1);\n  padding: 5px 20px;\n  margin-bottom: 10px;\n}\n.faq-section .faq-item h4 {\n  font-size: 15px;\n  line-height: 1.3;\n  font-weight: 600;\n  letter-spacing: 0;\n}\n.faq-section .faq-item p {\n  font-size: 13px;\n  line-height: 1.3;\n  font-weight: 400;\n  letter-spacing: 0;\n}\n.signup-page-section {\n  background-color: #fff;\n}\n.signup-page-section .control-label {\n  display: block;\n  min-height: 17px;\n}\n.signup-page-section p.signup-section {\n  font-family: \"Oswald\";\n  font-size: 26px;\n  line-height: 1.2;\n  font-weight: 400;\n  letter-spacing: -0.03em;\n  margin: 40px 0 20px;\n}\n.signup-page-section p.signup-section .label {\n  font-size: 15px;\n  position: relative;\n  top: -4px;\n}\n.signup-page-section p.form-instruction {\n  color: #0e79bf;\n  font-weight: 700;\n  font-size: 13px;\n}\n.signup-page-section p.pricing-header {\n  font-family: \"Oswald\";\n  font-size: 18px;\n  border-bottom: 1px dotted #999;\n  text-transform: uppercase;\n  color: #777;\n}\n/* ------ Old Marketing/Landing Page Styles ----------\nbody.contentPage {\n  &.withHeader {\n    #header {\n      position: fixed;\n    }\n    .container {\n      padding-top: 90px;\n      margin-bottom: 40px;\n    }\n  }\n  &.reportsBody {\n    background-image: none;\n  }\n  &.migratePage {\n    .form-group .help-block,\n    .form-group .alert-danger {\n      display: none;\n    }\n    .form-group.has-error .help-block,\n    .form-group.has-error .alert-danger {\n      display: block;\n    }\n  }\n  &.signUpPage {\n    .header-login-form {\n      display: none;\n    }\n    .form-group {\n      margin-bottom: 5px;\n    }\n    .form-group .help-block,\n    .form-group .alert-danger {\n      display: none;\n    }\n    .form-group.has-error .help-block,\n    .form-group.has-error .alert-danger {\n      display: block;\n    }\n  }\n  &.cloudAccountPage {\n    .page-header {\n      margin: -1px -41px;\n      border-bottom: 0;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n    h1 {\n      margin-top: 0;\n    }\n  }\n  &.contentPage {\n    height: auto;\n    min-height: 100%;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    background-color: #ddddd7;\n    .panel.main-panel {\n      overflow: hidden;\n      border-color: #C7C4C4;\n      padding-top: 20px;\n      background-color: #fff;\n    }\n    .page-header {\n      margin: 0 -5px;\n      border-bottom: 0;\n    }\n    .menu-section {\n      margin-top: 23px;\n      margin-left: 20px;\n      padding: 0 6px 9px;\n      float: left;\n      height: 60px;\n      position: relative;\n      &.pull-right {\n        margin-right: 25px;\n      }\n      ul {\n        display: inline-block;\n        margin-top: 10px;\n      }\n      .btn {\n        top: 13px;\n        position: relative;\n      }\n      .input-sm {\n        height: 26px;\n      }\n    }\n    .page-right-content {\n      margin-top: 10px;\n    }\n    .page-content {\n      margin: 0 80px 40px;\n      position: relative;\n      p {\n        font-size: 13px;\n        line-height: 1.6;\n      }\n      .hero-container {\n        position: relative;\n        margin: 0 -85px;\n        max-height: 400px;\n        overflow: hidden;\n      }\n      .hero-text {\n        position: absolute;\n        right: 0;\n        left: 0;\n        padding: 30px;\n        background: rgba(52, 84, 119, 0.6);\n        bottom: 0;\n        text-align: left;\n        border: 1px solid #ddd;\n        border-top: 0;\n        h1 {\n          // color: #7C7474;\n          color: white;\n          font-weight: 200;\n          font-size: 43px;\n          margin: 0 230px 0 50px;\n          line-height: 1.2;\n          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3);\n        }\n      }\n      .hero-buttons {\n        text-align: center;\n        margin-top: 10px;\n        button,\n        a {\n          width: 200px;\n          display: block;\n          margin-bottom: 10px;\n        }\n        span {\n          font-weight: 600;\n        }\n      }\n      h2 {\n        color: darken(@alk-green, 15%);\n        font-weight: 400;\n        font-size: 23px;\n        line-height: 1.5;\n        margin-bottom: 30px;\n      }\n      h3 {\n        margin-top: 0;\n        color: @pcm-wordmark;\n        font-size: 19px;\n        font-weight: 600;\n        &.callout {\n          font-weight: 300;\n          font-size: 22px;\n        }\n      }\n      h5.col-header {\n        text-transform: uppercase;\n        letter-spacing: 2px; // text-align: center;\n        border-bottom: 1px dotted #ccc;\n        line-height: 2.3;\n        font-weight: 600;\n        font-size: 13px;\n      }\n      .text-boxes {\n        li {\n          font-size: 12px;\n          margin-bottom: 11px;\n        }\n      }\n    }\n    hr {\n      margin-bottom: 40px;\n      margin-top: 40px;\n    }\n    .features {\n      img {\n        max-width: 100%;\n        border: 1px solid #ccc;\n        box-sizing: content-box;\n      }\n      p {\n        color: #7C7474;\n        font-weight: 200;\n        font-size: 19px;\n      }\n    }\n    .feature-list li {\n      font-size: 20px;\n      margin-bottom: 20px;\n      font-weight: 100;\n      padding-left: 24px;\n      padding-left: 0;\n      .ico {\n        font-size: 18px;\n        margin-left: -24px;\n        color: rgb(150, 194, 232);\n      }\n    }\n    .feature-list-content {\n      border: 1px solid lighten(@alk-lightblue, 20%);\n      border-radius: 13px;\n      padding: 5px 5px 5px 34px;\n      background-color: lighten(@alk-lightblue, 27%);\n    }\n    .feature-table {\n      td {\n        p {\n          line-height: 20px;\n          margin-bottom: 0;\n        }\n        i {\n          width: 100%;\n          text-align: center;\n          &.glyphicon-ok {\n            color: #4aa54a;\n          }\n          &.glyphicon-remove {\n            color: #F7DEDE;\n          }\n        }\n      }\n    }\n  }\n}\n\nbody.contentPage.loginPage .panel {\n  padding-top: 0;\n}\n\nbody.loginPage .page-header {\n  border-radius: 4px 0 0 0;\n  overflow: hidden;\n}\n\n.row.pricing-table {\n  padding: 15px;\n  div[class*=\"col-\"] {\n    padding: 0;\n    -webkit-transition: all ease-in-out 0.2s;\n    transition: all ease-in-out 0.2s;\n    background-color: #fff;\n    border: 1px solid #aaa;\n    &.selected {\n      -webkit-transform: scale(1.1);\n      transform: scale(1.1);\n      z-index: 100;\n      box-shadow: 0 0 7px 2px rgba(0, 0, 0, 0.1);\n    }\n  }\n  table {\n    margin-bottom: 0;\n  }\n  label {\n    background-color: #999;\n    color: #fff;\n    width: 100%;\n    margin-bottom: 0;\n    line-height: 2;\n    font-size: 20px;\n    font-weight: 300;\n    cursor: pointer;\n    &.trial {\n      background-color: desaturate(@alk-lightblue, 20%);\n    }\n    &.standard {\n      background-color: desaturate(@alk-green, 15%);\n    }\n    &.premium {\n      background-color: desaturate(@alk-orange, 15%);\n    }\n  }\n  span.glyphicon.glyphicon-ok {\n    font-size: 17px;\n    margin-right: 8px;\n  }\n  input[type=radio] {\n    display: none;\n  }\n  td,\n  th {\n    text-align: center;\n    border: 0;\n  }\n  th {\n    padding: 0;\n  }\n  span.price {\n    display: block;\n    font-size: 27px;\n    font-weight: 300;\n  }\n}\n\n.trial-info {\n  padding-bottom: 7px;\n  strong {\n    font-size: 10px;\n    letter-spacing: 2px;\n    font-weight: 700;\n    display: block;\n    margin: 3px 0;\n  }\n}\n\n.faq-container {\n  .panel-heading {\n    background: none;\n  }\n  a.accordion-toggle {\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 14px;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  accordion .panel-body li {\n    font-size: 13px;\n    margin-bottom: 16px;\n    border-left: 3px solid #ACD7F2;\n    padding-left: 11px;\n  }\n}\n*/\n", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Common Style Files/img/ALK_Logo.91a12972d5b8554b0732fc45a8d2aa6a.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.filters", []);

  angular.module("alk.filters").filter("fullAddressFilter", [function () {
    //return an HTML string from an ALK Address result
    // eslint-disable-next-line complexity
    return function (address, returnHtml, linebreaks) {
      returnHtml = returnHtml || false;
      linebreaks = linebreaks || false;
      var addrStr = "";
      var br = void 0;
      if (!linebreaks) {
        br = ", ";
      } else if (returnHtml) {
        br = "<br>";
      } else {
        br = "\n";
      }

      if (address.City !== "" && address.City !== null && address.City !== undefined) {
        addrStr += address.City;
      }
      if (address.State !== "" && address.State !== null && address.State !== undefined) {
        addrStr += ", " + address.State;
      }
      if (address.Zip !== "" && address.Zip !== null && address.Zip !== undefined) {
        addrStr += ", " + address.Zip;
      }
      if (address.Country !== "" && address.Country !== null && address.Country !== undefined && address.Country !== "United States") {
        addrStr += ", " + address.Country;
      }

      if (returnHtml) {
        if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
          addrStr = "<strong>" + address.StreetAddress + "</strong>" + (br + addrStr);
        }
        if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
          addrStr = "<strong>" + address.SPLC + "</strong>" + (br + addrStr);
        }
      } else {
        if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
          addrStr = address.StreetAddress + br + addrStr;
        }
        if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
          addrStr = address.SPLC + br + addrStr;
        }
      }

      return addrStr;
    };
  }]);

  // format output from Links service
  angular.module("alk.filters").filter("getRouteName", function () {
    return function (props, index) {
      var routeName = "";
      var routenums;
      if (!index) index = 0;
      if (props.routenums) {
        routenums = props.routenums;
      } else {
        routenums = props;
      }
      if (typeof routenums === "string") JSON.parse(routenums);
      if (routenums !== "") {
        if (routenums[index].category) routeName += " " + routenums[index].category;
        if (routenums[index].rtnum) routeName += " " + routenums[index].rtnum;
        if (routenums[index].modifier) routeName += " " + routenums[index].modifier;
        if (routenums[index].alpha) routeName += " " + routenums[index].alpha;
        if (routenums[index].compass) routeName += " " + routenums[index].compass;
      }
      return routeName;
    };
  });

  angular.module("alk.filters").filter("concatName", function () {
    return function (names, index) {
      var fullName = "";
      if (typeof names === "string") JSON.parse(names);
      if (names !== "" && names.length > 0) {
        if (names[index].prefix) fullName += " " + names[index].prefix.abbreviation;
        fullName += " " + names[index].name;
        if (names[index].type) fullName += " " + names[index].type.description;
        if (names[index].suffix) fullName += " " + names[index].suffix.abbreviation;
      }
      return fullName;
    };
  });

  angular.module("alk.filters").filter("getFullName", ["concatNameFilter", "getRouteNameFilter", function (concatNameFilter, getRouteNameFilter) {
    return function (props, index) {
      if (_.isUndefined(props) || _.isNull(props)) {
        return "";
      } else {
        if (!index) index = 0;
        var fullName = "";
        if (props.names != null && props.names.length > 0) {
          // jshint ignore:line
          var names = props.names;
          fullName = concatNameFilter(names, index);
        } else if (props.routenums != null && props.routenums.length > 0) {
          // jshint ignore:line
          fullName = getRouteNameFilter(props, index);
        } else {
          var names = props;
          fullName = concatNameFilter(names, index);
        }
        if (fullName === "") fullName = "Unnamed";
        return fullName;
      }
    };
  }]);

  angular.module("alk.filters").filter("coordsToCardinal", function () {
    return function (coords, index) {
      var outputStr = "";
      var xCardinal, yCardinal;
      if (typeof coords !== "undefined") {
        xCardinal = parseFloat(coords.Lon) > 0 ? " E" : " W";
        yCardinal = parseFloat(coords.Lat) > 0 ? " N" : " S";
        outputStr = coords.Lat + yCardinal + ", " + coords.Lon + xCardinal;
      }
      return outputStr;
    };
  });

  angular.module("alk.filters").filter("hexToRGBa", function () {
    return function (hex, alpha) {
      var r = parseInt(hex.slice(1, 3), 16),
          g = parseInt(hex.slice(3, 5), 16),
          b = parseInt(hex.slice(5, 7), 16);

      if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
      } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
      }
    };
  });

  angular.module("alk.filters").filter("propsFilter", function () {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        items.forEach(function (item) {
          var itemMatches = false;

          var keys = Object.keys(props);
          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  });

  angular.module("alk.filters").filter("unsafe", ["$sce", function ($sce) {
    return $sce.trustAsHtml;
  }]);

  angular.module("alk.filters").filter("minmax", function () {
    return function (arr, min, max, incr) {
      min = parseInt(min);
      max = parseInt(max);
      incr = parseInt(incr) || 1;
      for (var i = min; i <= max; i += incr) {
        arr.push(i);
      }
      return arr;
    };
  });
})();

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  angular.module("alk.services").service("GeoParser", [function () {

    function convertCompassToLatLon(degree1, compass1, degree2, compass2) {
      // normalize degrees to use - when referring to West or South compass directions
      if (compass1 === "W" || compass1 === "S") {
        degree1 = "-" + degree1;
      }

      if (compass2 === "W" || compass2 === "S") {
        degree2 = "-" + degree2;
      }

      if ((compass1 === "W" || compass1 === "E") && (compass2 === "N" || compass2 === "S")) {
        return { lat: Number(degree2), lon: Number(degree1) };
      } else if ((compass1 === "N" || compass1 === "S") && (compass2 === "W" || compass2 === "E")) {
        return { lat: Number(degree1), lon: Number(degree2) };
      } else {
        return {};
      }
    }

    function getLatLon(input) {
      // cleanup input by removing explicit + sign
      input = input.replace("+", "");
      var latlon;
      var searchll;
      var matches;

      // matches positive decimal followed by compass direction, with comma or spaces following by the same thing
      var regexCompassPost = /^(\d+.{0,1}\d+)\s*([NSEW])[\s,]+(\d+.{0,1}\d+)\s*([NSEW])$/;

      // matches compass direction followed by decimal, with comma or spaces, followed by the same thing
      var regexCompassPre = /^([NSEW])\s*(\d+.{0,1}\d+)[\s,]+([NSEW])\s*(\d+.{0,1}\d+)$/;

      if (matches = input.match(regexCompassPost)) {
        latlon = convertCompassToLatLon(matches[1], matches[2], matches[3], matches[4]);
      } else if (matches = input.match(regexCompassPre)) {
        latlon = convertCompassToLatLon(matches[2], matches[1], matches[4], matches[3]);
      } else if ((searchll = input.split(/[\s,]+/)).length === 2) {
        //todo: if they can both be parsed as floats return them as lat/lon, otherwise null.
        latlon = { lat: Number(searchll[0]), lon: Number(searchll[1]) };
      } else {
        return null;
      }

      if (Math.abs(latlon.lat) < 90 && Math.abs(latlon.lon) < 180) {
        return latlon;
      }

      return null;
    }

    var parseCity = function parseCity(strAddr) {
      var pTxt = strAddr.trim();
      var pObj = {
        city: "",
        state: "",
        zip: "",
        error: 0,
        errorTxt: ""
      };
      if (pTxt !== null) {
        pTxt = pTxt.replace(/,/g, " ");
        pTxt = pTxt.replace(/\s{2,}/g, " ");
        var pVals = pTxt.split(" ");
        //console.log(pVals);

        var stateMarker = pVals.length;

        //test last 'word' or two for zip or postcode
        if (pVals[pVals.length - 1].match(/^\d{1,5}$|^\d{5}-\d{1,4}$|^[A-Za-z]\d[A-Za-z][-]?\d[A-Za-z]\d$/) !== null) {
          if (pVals[pVals.length - 1].match(/^[A-Za-z]\d[A-Za-z][-]\d[A-Za-z]\d$/) !== null) {
            //strip hypen from postcode if necessary
            pObj.zip = pVals[pVals.length - 1].replace("-", "");
          } else {
            pObj.zip = pVals[pVals.length - 1];
            stateMarker = pVals.length - 1;
          }
        } else if (pVals.length > 1 && pVals[pVals.length - 2].match(/^[A-Za-z]\d[A-Za-z]$/) !== null && pVals[pVals.length - 1].match(/^\d[A-Za-z]\d$/) !== null) {
          pObj.zip = pVals[pVals.length - 2] + pVals[pVals.length - 1];
          stateMarker = pVals.length - 2;
        }

        //walk the 'words' backwards and test for US or Canada State/province.  Need to add MX and EU codes
        for (var p = pVals.length - 1; p >= 0; p--) {
          if (_.find(STATES, { abbreviation: pVals[p].toUpperCase() }) !== undefined) {
            //if (typeof (states[pVals[p].toUpperCase()]) != "undefined") {
            pObj.state = pVals[p];
            stateMarker = p;
            break;
          }
        }

        if (!(pObj.zip !== "" && pVals.length === 1)) {
          for (var z = 0; z < stateMarker; z++) {
            if (typeof pVals[z] !== "undefined") {
              pObj.city += pVals[z] + " ";
            }
          }
          pObj.city = pObj.city.trim();
        }
      }
      if (pObj.zip === "" && pObj.city === "") {
        pObj.error = 1;
        pObj.errorTxt = $translate.instant("controllers.searchController.NoZipOrCity");
      }
      return pObj;
    };

    return {
      getLatLon: getLatLon,
      parseCity: parseCity
    };
  }]);
})(window.angular);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} alkGeocodeService
 *  @property {Function} geocode
 *  @property {Function} reverseGeocode
 */

(function () {
  "use strict";

  alkGeocodeService.$inject = ["ALKMaps", "$q", "$timeout"];
  angular.module("alk.geocode").service("alkGeocodeService", alkGeocodeService);

  /** @name alkGeocodeService
   * @ngdoc service
   * @param {service} ALKMaps [ALKMaps](https://maps.alk.com/Developer/1.2/api_docs)
   * @param {service} $q angularJS [promises/deferred objects service](https://docs.angularjs.org/api/ng/service/$q)
   * @param {service} timeout angularJS [window.setTimeout wrapper](https://docs.angularjs.org/api/ng/service/$timeout#!)
   * @description Provides geocoding and reverse geocoding functions as a light wrapper around [ALKMaps](https://maps.alk.com/Developer/1.2/api_docs)
   * @returns alkGeocodeService
   * @memberof alk.geocode
   */
  function alkGeocodeService(ALKMaps, $q, $timeout) {
    "ngInject";

    return {
      geocode: geocode,
      reverseGeocode: reverseGeocode
    };

    ////////////////

    /** geocode - Turn an address object into an array of Addresses. By default, we return one address unless
     * options.listSize > 1.
     * @param {Object} address - The input address to geocode. Should look like `{addr: string, city: string, state: string, zip: string, region: string}`
     * @param {Object} options - Options for geocoding. Supports `{listSize: int, region: string, dataset: string}`.
     * Valid values for region are NA, EU, OC, and SA. Valid values for dataset are PCM_EU, PCM_OC, PCM_SA, or Current.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of address objects or
     * rejects to an object `{searchError: boolean, messages: [String]}`.
     * @memberof alkGeocodeService
     */
    function geocode(address, options) {
      var deferred = $q.defer();

      options = options || {};

      address.region = options.region || "NA";
      address.dataset = options.dataset || "PCM_NA";

      ALKMaps.Geocoder.geocode({
        address: address,
        listSize: options.listSize || 1, //Optional. The number of results returned if the geocoding service finds multiple matches.
        success: function success(resp) {
          $timeout(function () {
            var chk = checkResponseError(resp);
            if (chk.hasError === true) {
              deferred.reject({
                searchError: true,
                messages: chk.messages
              });
            } else {
              deferred.resolve(resp);
            }
          });
        },
        failure: function failure(err) {
          $timeout(function () {
            if (err && err.responseText) {
              deferred.reject({
                searchError: true,
                messages: err.responseText
              });
            } else {
              deferred.reject({
                searchError: true
              });
            }
          });
        }
      });

      return deferred.promise;
    }

    /** reverseGeocode - Turn a longitude and a latitude into an address.
     * @param {Object} lonLat - An [ALKMaps.LonLat](https://maps.alk.com/api/1.2/docs/files/BaseTypes/LonLat-js.html) or an object with lon and lat properties.
     * @param {Object} optsObj - Options for reverse geocoding. Supports region: string, dataset: string.
     * Valid values for region are NA, EU, OC, and SA. Valid values for dataset are PCM_EU, PCM_OC, PCM_SA, or Current.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of address objects or
     * rejects to an object `{searchError: boolean, messages: [String]}`.
     * @memberof alkGeocodeService
     */
    function reverseGeocode(lonLat, optsObj) {
      var deferred = $q.defer();

      optsObj = optsObj || {};

      ALKMaps.Geocoder.reverseGeocode({
        lonLat: lonLat,
        region: optsObj.region || "NA",
        dataset: optsObj.dataset || "PCM_NA",
        success: function success(resp) {
          $timeout(function () {
            var chk = checkResponseError(resp);

            if (chk.hasError === true) {
              deferred.reject({
                searchError: true,
                messages: chk.messages
              });
            } else {
              deferred.resolve(resp);
            }
          });
        },
        failure: function failure(err) {
          $timeout(function () {
            if (err && err.responseText) {
              deferred.reject({
                searchError: true,
                messages: err.responseText
              });
            } else {
              deferred.reject({
                searchError: true
              });
            }
          });
        }
      });

      return deferred.promise;
    }

    function checkResponseError(resp) {
      var hasError = false;
      var messages = [];
      if (resp !== null && resp.length > 0) {
        var errors = resp[0].Errors; // Errors in first item
        if (errors !== null && errors.length > 0) {
          for (var i = 0; i < errors.length; i++) {
            if (errors[i].Type === 1) {
              hasError = true;
              messages.push(errors[i].Description);
            }
          }
        }
      }
      return {
        hasError: hasError,
        messages: messages
      };
    }
  }
})();

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.maps", ["alk.geocode", "alk.constants"]);
})(window.angular);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("alk.constants", []);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("alk.constants")
/** @name PCMRegion
 * @ngdoc constant
 * @description Provides a list of the supported PCMiler regions recognized by PCMiler Web Services.
 * The constant is the following object:
 * 
 * `{
 * "Unknown": 0,
 * "AF": 1,
 * "AS": 2,
 * "EU": 3,
 * "NA": 4,
 * "OC": 5,
 * "SA": 6,
 * "ME": 7
 * }`
 * @memberof alk.constants
 */
.constant("PCMRegion", {
  "Unknown": 0,
  "AF": 1,
  "AS": 2,
  "EU": 3,
  "NA": 4,
  "OC": 5,
  "SA": 6,
  "ME": 7
});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//These lengths are obtained from the CustomData database. Going over them can sometimes result in SQL errors.

angular.module("alk.constants")
/** @name MAXDBLENGTHS
 * @ngdoc constant
 * @description Provides an object that contains the sizes of fields in the CustomData database
 * for various types of objects.
 * @example
 * var input = "1 Independence Way";
 * if (input.length > MAXDBLENGTHS["Street"]) {
 *   // return a validation error
 * }
 * @memberof alk.constants
 */
.constant("MAXDBLENGTHS", {
  //Common
  STREET: 100,
  CITY: 100,
  ZIP: 25,
  PHONE: 20,
  COUNTY: 100,
  COUNTRY: 100, //??? doesn't seem to be a field in TLocations table. Just using 100 for now

  //Places
  PLACE_NAME: 140,
  CID: 24,
  YARD_NAME: 100,
  SITE_DETAIL: 1000,
  PLACE_COMMENTS: 140,
  YARD_GATE_NOTE: 60
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("alk.constants")
/** @name STATES
 * @ngdoc constant
 * @description Provides a list of states that are supported by ALK applications.
 * The constant is an array of objects that look like
 * `{abbreviation: string, name: string, country: string}`
 * @memberof alk.constants
 */
.constant("STATES", [{
  "abbreviation": "AL",
  "name": "Alabama",
  "country": "United States"
}, {
  "abbreviation": "AK",
  "name": "Alaska",
  "country": "United States"
}, {
  "abbreviation": "AZ",
  "name": "Arizona",
  "country": "United States"
}, {
  "abbreviation": "AR",
  "name": "Arkansas",
  "country": "United States"
}, {
  "abbreviation": "CA",
  "name": "California",
  "country": "United States"
}, {
  "abbreviation": "CO",
  "name": "Colorado",
  "country": "United States"
}, {
  "abbreviation": "CT",
  "name": "Connecticut",
  "country": "United States"
}, {
  "abbreviation": "DE",
  "name": "Delaware",
  "country": "United States"
}, {
  "abbreviation": "DC",
  "name": "District of Columbia",
  "country": "United States"
}, {
  "abbreviation": "FL",
  "name": "Florida",
  "country": "United States"
}, {
  "abbreviation": "GA",
  "name": "Georgia",
  "country": "United States"
}, {
  "abbreviation": "HI",
  "name": "Hawaii",
  "country": "United States"
}, {
  "abbreviation": "ID",
  "name": "Idaho",
  "country": "United States"
}, {
  "abbreviation": "IL",
  "name": "Illinois",
  "country": "United States"
}, {
  "abbreviation": "IN",
  "name": "Indiana",
  "country": "United States"
}, {
  "abbreviation": "IA",
  "name": "Iowa",
  "country": "United States"
}, {
  "abbreviation": "KS",
  "name": "Kansas",
  "country": "United States"
}, {
  "abbreviation": "KY",
  "name": "Kentucky",
  "country": "United States"
}, {
  "abbreviation": "LA",
  "name": "Louisiana",
  "country": "United States"
}, {
  "abbreviation": "ME",
  "name": "Maine",
  "country": "United States"
}, {
  "abbreviation": "MD",
  "name": "Maryland",
  "country": "United States"
}, {
  "abbreviation": "MA",
  "name": "Massachusetts",
  "country": "United States"
}, {
  "abbreviation": "MI",
  "name": "Michigan",
  "country": "United States"
}, {
  "abbreviation": "MN",
  "name": "Minnesota",
  "country": "United States"
}, {
  "abbreviation": "MS",
  "name": "Mississippi",
  "country": "United States"
}, {
  "abbreviation": "MO",
  "name": "Missouri",
  "country": "United States"
}, {
  "abbreviation": "MT",
  "name": "Montana",
  "country": "United States"
}, {
  "abbreviation": "NE",
  "name": "Nebraska",
  "country": "United States"
}, {
  "abbreviation": "NV",
  "name": "Nevada",
  "country": "United States"
}, {
  "abbreviation": "NH",
  "name": "New Hampshire",
  "country": "United States"
}, {
  "abbreviation": "NJ",
  "name": "New Jersey",
  "country": "United States"
}, {
  "abbreviation": "NM",
  "name": "New Mexico",
  "country": "United States"
}, {
  "abbreviation": "NY",
  "name": "New York",
  "country": "United States"
}, {
  "abbreviation": "NC",
  "name": "North Carolina",
  "country": "United States"
}, {
  "abbreviation": "ND",
  "name": "North Dakota",
  "country": "United States"
}, {
  "abbreviation": "OH",
  "name": "Ohio",
  "country": "United States"
}, {
  "abbreviation": "OK",
  "name": "Oklahoma",
  "country": "United States"
}, {
  "abbreviation": "OR",
  "name": "Oregon",
  "country": "United States"
}, {
  "abbreviation": "PA",
  "name": "Pennsylvania",
  "country": "United States"
}, {
  "abbreviation": "RI",
  "name": "Rhode Island",
  "country": "United States"
}, {
  "abbreviation": "SC",
  "name": "South Carolina",
  "country": "United States"
}, {
  "abbreviation": "SD",
  "name": "South Dakota",
  "country": "United States"
}, {
  "abbreviation": "TN",
  "name": "Tennessee",
  "country": "United States"
}, {
  "abbreviation": "TX",
  "name": "Texas",
  "country": "United States"
}, {
  "abbreviation": "UT",
  "name": "Utah",
  "country": "United States"
}, {
  "abbreviation": "VT",
  "name": "Vermont",
  "country": "United States"
}, {
  "abbreviation": "VA",
  "name": "Virginia",
  "country": "United States"
}, {
  "abbreviation": "WA",
  "name": "Washington",
  "country": "United States"
}, {
  "abbreviation": "WV",
  "name": "West Virginia",
  "country": "United States"
}, {
  "abbreviation": "WI",
  "name": "Wisconsin",
  "country": "United States"
}, {
  "abbreviation": "WY",
  "name": "Wyoming",
  "country": "United States"
}, {
  "abbreviation": "AB",
  "name": "Alberta",
  "country": "Canada"
}, {
  "abbreviation": "BC",
  "name": "British Columbia",
  "country": "Canada"
}, {
  "abbreviation": "MB",
  "name": "Manitoba",
  "country": "Canada"
}, {
  "abbreviation": "NB",
  "name": "New Brunswick",
  "country": "Canada"
}, {
  "abbreviation": "NF",
  "name": "Newfoundland",
  "country": "Canada"
}, {
  "abbreviation": "NT",
  "name": "Northwest Territory",
  "country": "Canada"
}, {
  "abbreviation": "NS",
  "name": "Nova Scotia",
  "country": "Canada"
}, {
  "abbreviation": "NU",
  "name": "Nunavut",
  "country": "Canada"
}, {
  "abbreviation": "ON",
  "name": "Ontario",
  "country": "Canada"
}, {
  "abbreviation": "PE",
  "name": "Prince Edward Island",
  "country": "Canada"
}, {
  "abbreviation": "QC",
  "name": "Quebec",
  "country": "Canada"
}, {
  "abbreviation": "SK",
  "name": "Saskatchewan",
  "country": "Canada"
}, {
  "abbreviation": "YT",
  "name": "Yukon Territory",
  "country": "Canada"
}, {
  "abbreviation": "AG",
  "name": "Aguascalientes",
  "country": "Mexico"
}, {
  "abbreviation": "BJ",
  "name": "Baja California",
  "country": "Mexico"
}, {
  "abbreviation": "BS",
  "name": "Baja California Sur",
  "country": "Mexico"
}, {
  "abbreviation": "CP",
  "name": "Campeche",
  "country": "Mexico"
}, {
  "abbreviation": "CH",
  "name": "Chiapas",
  "country": "Mexico"
}, {
  "abbreviation": "CI",
  "name": "Chihuahua",
  "country": "Mexico"
}, {
  "abbreviation": "CU",
  "name": "Coahuila",
  "country": "Mexico"
}, {
  "abbreviation": "CL",
  "name": "Colima",
  "country": "Mexico"
}, {
  "abbreviation": "DF",
  "name": "Distrito Federal",
  "country": "Mexico"
}, {
  "abbreviation": "DG",
  "name": "Durango",
  "country": "Mexico"
}, {
  "abbreviation": "GJ",
  "name": "Guanajuato",
  "country": "Mexico"
}, {
  "abbreviation": "GR",
  "name": "Guerrero",
  "country": "Mexico"
}, {
  "abbreviation": "HG",
  "name": "Hidalgo",
  "country": "Mexico"
}, {
  "abbreviation": "JA",
  "name": "Jalisco",
  "country": "Mexico"
}, {
  "abbreviation": "EM",
  "name": "Mexico",
  "country": "Mexico"
}, {
  "abbreviation": "MH",
  "name": "Michoacan",
  "country": "Mexico"
}, {
  "abbreviation": "MR",
  "name": "Morelos",
  "country": "Mexico"
}, {
  "abbreviation": "NA",
  "name": "Nayarit",
  "country": "Mexico"
}, {
  "abbreviation": "NL",
  "name": "Nuevo Leon",
  "country": "Mexico"
}, {
  "abbreviation": "OA",
  "name": "Oaxaca",
  "country": "Mexico"
}, {
  "abbreviation": "PU",
  "name": "Puebla",
  "country": "Mexico"
}, {
  "abbreviation": "QA",
  "name": "Queretaro",
  "country": "Mexico"
}, {
  "abbreviation": "QR",
  "name": "Quintana Roo",
  "country": "Mexico"
}, {
  "abbreviation": "SL",
  "name": "San Luis Potosi",
  "country": "Mexico"
}, {
  "abbreviation": "SI",
  "name": "Sinaloa",
  "country": "Mexico"
}, {
  "abbreviation": "SO",
  "name": "Sonora",
  "country": "Mexico"
}, {
  "abbreviation": "TA",
  "name": "Tabasco",
  "country": "Mexico"
}, {
  "abbreviation": "TM",
  "name": "Tamaulipas",
  "country": "Mexico"
}, {
  "abbreviation": "TL",
  "name": "Tlaxcala",
  "country": "Mexico"
}, {
  "abbreviation": "VZ",
  "name": "Veracruz",
  "country": "Mexico"
}, {
  "abbreviation": "YC",
  "name": "Yucatan",
  "country": "Mexico"
}, {
  "abbreviation": "ZT",
  "name": "Zacatecas",
  "country": "Mexico"
}]);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("alk.translations").constant("LOCALES", {
  "locales": {
    "en_US": "English"
    // "es_ES": "Espanol",
    // "de_DE": "Deutsch"
  }
});

angular.module("alk.translations").service("alkLocaleService", ["$translate", "LOCALES", "$rootScope", "tmhDynamicLocale", "$http", "$templateCache", function ($translate, LOCALES, $rootScope, tmhDynamicLocale, $http, $templateCache) {
  "use strict";
  // VARS

  var localesObj = LOCALES.locales;

  // locales and locales display names
  var _LOCALES = Object.keys(localesObj);
  if (!_LOCALES || _LOCALES.length === 0) {
    console.error("There are no _LOCALES provided");
  }
  var _LOCALES_DISPLAY_NAMES = [];
  _LOCALES.forEach(function (locale) {
    _LOCALES_DISPLAY_NAMES.push(localesObj[locale]);
  });

  var currentLocale = $translate.proposedLanguage() || $translate.use();

  // on initial load of the app, make sure to set the custom alk-language header as well as update the html attribute to be correct as per the language currently showing.
  $http.defaults.headers.common["ALK-Language"] = currentLocale;
  document.documentElement.setAttribute("lang", currentLocale);

  // METHODS
  var checkLocaleIsValid = function checkLocaleIsValid(locale) {
    return _LOCALES.indexOf(locale) !== -1;
  };

  var setLocale = function setLocale(locale) {
    if (!checkLocaleIsValid(locale)) {
      console.error("Locale name '" + locale + "' is invalid");
      return;
    }
    startLoadingAnimation();
    currentLocale = locale;
    $translate.use(locale);
  };

  /**
   * Stop application loading animation when translations are loaded
   */
  var $html = angular.element("html");
  var LOADING_CLASS = "app-loading";

  function startLoadingAnimation() {
    $html.addClass(LOADING_CLASS);
  }

  function stopLoadingAnimation() {
    $html.removeClass(LOADING_CLASS);
  }

  // EVENTS
  $rootScope.$on("$translateChangeSuccess", function (event, data) {
    document.documentElement.setAttribute("lang", data.language); // sets "lang" attribute to html
    $http.defaults.headers.common["ALK-Language"] = data.language;

    // this ensures that any pages that were using language specific view are no longer cached. example of this is the terms of use template
    // TODO: come up with more robust way to remove all [[language]] templates
    $templateCache.remove("templates/[[language]]/terms.html");

    tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, "-")); // load Angular locale
  });

  $rootScope.$on("$localeChangeSuccess", function (e, locale) {
    stopLoadingAnimation();
  });

  return {
    getLocaleDisplayName: function getLocaleDisplayName() {
      return localesObj[currentLocale];
    },
    setLocaleByDisplayName: function setLocaleByDisplayName(localeDisplayName) {
      setLocale(_LOCALES[_LOCALES_DISPLAY_NAMES.indexOf(localeDisplayName) // get locale index
      ]);
    },
    getLocalesDisplayNames: function getLocalesDisplayNames() {
      return _LOCALES_DISPLAY_NAMES;
    }
  };
}]);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var app = angular.module("alk.translations");

app.factory("alkTranslationLoader", [function () {

  function load($translateProvider) {
    //Turn this on during debugging to get console warnings when translations are missing
    $translateProvider.useMissingTranslationHandlerLog();

    $translateProvider.useStaticFilesLoader({
      //Put common first so that app-specific overrides for same translation string
      files: [{
        prefix: "/resources/common/",
        suffix: ".json"
      }, {
        prefix: "/resources/",
        suffix: ".json"
      }]
    }).registerAvailableLanguageKeys(["en_US", "es_ES", "de_DE"], {
      "en-US": "en_US",
      "es-ES": "es_ES",
      "de-DE": "de_DE",
      "en": "en_US",
      "es": "es_ES",
      "de": "de_DE"
    }).determinePreferredLanguage(function () {
      // if a language is not explicitely set by the user, it uses the language returned from the html "lang" attribute.  This is set on the serverside based on the Accept-Language request header.
      var lang = document.getElementsByTagName("html")[0].lang;
      return lang;
    }).fallbackLanguage("en_US");

    $translateProvider.useSanitizeValueStrategy("escapeParameters");

    $translateProvider.useLocalStorage();
  }

  return {
    load: load
  };
}]);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  angular.module("alk.translations").directive("alkLanguageSelect", ["alkLocaleService", function (alkLocaleService) {
    return {
      replace: true,
      restrict: "A",
      template: "" + "<div class=\"language-select\" ng-if=\"visible\">" + "<select class=\"form-control\" ng-model=\"currentLocaleDisplayName\"" + "ng-options=\"localesDisplayName for localesDisplayName in localesDisplayNames\"" + "ng-change=\"changeLanguage(currentLocaleDisplayName)\">" + "</select>" + "</div>" + "",
      controller: ["$scope", function ($scope) {
        $scope.currentLocaleDisplayName = alkLocaleService.getLocaleDisplayName();
        $scope.localesDisplayNames = alkLocaleService.getLocalesDisplayNames();

        //  don't show if there's one or less languages available for select
        $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

        $scope.changeLanguage = function (locale) {
          alkLocaleService.setLocaleByDisplayName(locale);
        };
      }]
    };
  }]);
})(window.angular);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// this is in its own file (and removed from app.js) so our unit test configuration can exclude it
angular.module("app").config(["$translateProvider", "alkTranslationLoaderProvider", function ($translateProvider, alkTranslationLoaderProvider) {
  alkTranslationLoaderProvider.$get().load($translateProvider);
}]);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  angular.module("app").controller("accountController", ["$scope", "$q", "$http", "$window", "alkModalService", "_", "alkAuthenticationService", "$location", "UserProvider", "Messages", "netSuite", "AccountManagement", "ALKChangePassword", "$filter", "eventTracker", function ($scope, $q, $http, $window, alkModalService, _, alkAuthenticationService, $location, userProvider, Messages, netSuite, AccountManagement, ALKChangePassword, $filter, eventTracker) {
    var vm = this;

    vm.isProcessing = false;

    function updateForUser(user) {
      if (user.isLoggedIn === false) {
        return;
      }
      if (user.accountType === "Trial") {
        vm.featureLevel.featureLevel = "Trial";
        vm.featureLevelInfo = vm.featureLevelInfo.filter(function (feature) {
          return feature.name !== "Standard";
        });
      } else {
        vm.featureLevel.featureLevel = user.subscriptionLevel;

        // for non-trial users, don't let them go back to a Trial account

        vm.featureLevelInfo = vm.featureLevelInfo.filter(function (feature) {
          return vm.featureLevel.featureLevel === "Premium" ? feature.name === "Premium" : feature.name !== "Trial";
        });
      }
    }

    function getPaymentInfo() {
      // if user is not admin, or if netSuite is down, do not try to get payment info
      if (!userProvider.getUser().isAdmin() || !userProvider.getUser().netSuiteOnline) return $q.when();

      var deferred = $q.defer();

      netSuite.getPaymentInformation().then(function (paymentInformation) {
        vm.billing = paymentInformation.billing;
        vm.creditCard = paymentInformation.credit;

        originalBilling = angular.copy(vm.billing);
        vm.originalCreditCard = angular.copy(vm.creditCard);

        deferred.resolve();
      });

      return deferred.promise;
    }

    function shouldSubmitBillingAddress() {
      // if the billing has been updated or if there was no billing to start with, we need to send it.
      var isBillingUpdated = !angular.equals(vm.billing, originalBilling);
      return isBillingUpdated || originalBilling == null;
    }

    function shouldSubmitFeatureLevel() {
      var isFeatureLevelUpdated = !angular.equals(vm.featureLevel, originalFeatureLevel);
      return isFeatureLevelUpdated;
    };

    var originalBilling = {};
    vm.originalCreditCard = {};
    var originalFeatureLevel = {};

    vm.newUserFormVisible = false;

    vm.account = {};
    vm.featureLevelInfo = [{
      "name": "Trial",
      "cost": 0
    }, {
      "name": "Standard",
      "cost": 59.99
    }, {
      "name": "Premium",
      "cost": 84.99
    }];
    vm.featureLevelCost = function () {
      if (!_.isUndefined(vm.featureLevel.featureLevel)) {
        return _.find(vm.featureLevelInfo, {
          "name": vm.featureLevel.featureLevel
        }).cost;
      } else {
        return "";
      }
    };
    vm.newUser = {};

    vm.loginInfo = {};
    vm.featureLevel = {};
    vm.billing = {};
    vm.creditCard = {};

    vm.usersCurrentPage = 1;

    vm.usersPerPage = 10;

    vm.usersPageChanged = function () {
      if (userProvider.getUser().isAdmin() !== true) {
        return;
      }

      var pagingParam = {
        Count: vm.usersPerPage,
        Skip: (vm.usersCurrentPage - 1) * vm.usersPerPage
      };

      AccountManagement.getUsers({
        params: pagingParam
      }).then(function (resp) {
        vm.usersTotalCount = resp.total;
        vm.account.users = resp.users;
      });
    };

    // have separate submit functions for each section of information so we can only submit the sections we need to and not validate the entire outer form
    vm.shouldSubmitCreditCard = function () {
      if (vm.originalCreditCard == null) return true;
      if (userProvider.getUser().hasBillingIssue == true) return true;

      var number = vm.originalCreditCard.number || "";
      var name = vm.originalCreditCard.name || "";
      var expMonth = vm.originalCreditCard.expMonth || "";
      var expYear = vm.originalCreditCard.expYear || "";
      var cvv = vm.originalCreditCard.cvv || "";
      var hash = number + "_" + name + "_" + expMonth + "_" + expYear + "_" + cvv;

      // the credit card should be required if the user does not currently have a card on file (vm.originalCreditCard is null) or if the the card has been modified (check each of the fields)
      return hash !== vm.creditCardDirty;
    };

    vm.cancelCustomer = function () {
      var _message = "Are you sure that you want to cancel your account? Your access to the account will be disabled immediately.";
      if (userProvider.getUser().accountType !== "Trial") {
        _message += " Please note that no refund will be issued.";
      }

      alkModalService.show({
        size: "md",
        templateUrl: "/app/account/cancelCustomer.template.html",
        controller: "cancelAccountController as vm",
        resolve: {
          message: function message() {
            return _message;
          }
        }
      }).then(function (result) {
        alkAuthenticationService.logout();
        $location.url("/");
        eventTracker.track(eventTracker.EVENTS.CANCEL_ACCOUNT, { featureLevel: vm.featureLevel.featureLevel });
      });
    };

    vm.deleteUser = function (user) {
      $http.post("/api/ManageAccount/DisableUser", {
        email: user.UserName
      }).success(function () {
        var indexOf = _.indexOf(vm.account.users, user);
        if (indexOf >= 0) {
          vm.account.users.splice(indexOf, 1);
          vm.usersTotalCount = vm.usersTotalCount - 1;

          // handle the edge case where we are on the last page of results and we delete the only user on that page.  should than change the page we are on.
          var lastPage = Math.ceil(vm.usersTotalCount / vm.usersPerPage);

          if (vm.usersCurrentPage > lastPage) {
            vm.usersCurrentPage = lastPage;
          }

          vm.usersPageChanged();
        }
      });
    };

    vm.replaceUser = function (user) {
      //display popup to allow the user to replace this user.
      alkModalService.show({
        size: "md",
        templateUrl: "/app/account/replaceUser.template.html",
        controller: "replaceUserController as vm",
        resolve: {
          isReplacingCurrent: function isReplacingCurrent() {
            return user.UserName == userProvider.getUser().userName;
          },
          oldUser: function oldUser() {
            return user;
          }
        }
      }).then(function () {
        //if user is replacing them self, log out, otherwise, refresh the users list
        if (user.UserName == userProvider.getUser().userName) {
          alkAuthenticationService.logout();
          $location.url("/");
        } else {
          // repopulate the list of users since the person was changed.
          vm.usersPageChanged();
        }
      });
    };

    vm.toggleNewUserForm = function () {
      vm.newUserFormVisible = !vm.newUserFormVisible;

      if (vm.newUserFormVisible === false) {
        vm.newUser.firstName = "";
        vm.newUser.lastName = "";
        vm.newUser.email = "";
      }
    };

    vm.submitNewUser = function (user) {
      Messages.clear();

      if (!user) return;
      user.email = user.email.toLowerCase();
      vm.isProcessing = true;

      var newUser = {
        Email: user.email,
        FirstName: user.firstName,
        LastName: user.lastName
      };

      AccountManagement.addUser(newUser).then(function () {
        vm.usersTotalCount++;
        vm.featureLevel.newNumberOfUsers = vm.featureLevel.newNumberOfUsers = vm.featureLevel.newNumberOfUsers >= userProvider.getUser().maxNumberOfUsers ? userProvider.getUser().maxNumberOfUsers : vm.featureLevel.newNumberOfUsers + 1;
        // currently, vm.account.users only has a single page of users, so we store the total count in a separate property.
        vm.newUser = {};

        if (userProvider.getUser().maxNumberOfUsers - vm.usersTotalCount < 1) {
          // if no more users are available, toggle this form closed.
          vm.newUserFormVisible = false;
          vm.newUser.firstName = "";
          vm.newUser.lastName = "";
          vm.newUser.email = "";
        }

        vm.usersPageChanged();
      }).finally(function () {
        vm.isProcessing = false;
      });
    };

    vm.toggleAdminRole = function (user) {
      Messages.clear();

      var originalIsAdmin = !user.isAdmin; // at this point, the bound variable is already changed so it's the opposite.
      var toggleAccess = {
        userName: user.UserName,
        addRole: user.RoleName !== "Company Administrator"
      };

      user.isProcessing = true;

      AccountManagement.changeUserRole(toggleAccess).then(function () {
        if (toggleAccess.addRole) {
          user.RoleName = "Company Administrator";
        } else {
          user.RoleName = "User";
        }
        user.isProcessing = false;
        Messages.add("success", "Successfully updated user's role.", {
          showOnNextPage: false
        });
      }, function (err) {
        user.isAdmin = originalIsAdmin;
        user.isProcessing = false;
        Messages.add("danger", "Error while changing user's role.", {
          showOnNextPage: false
        });
      });
    };

    vm.init = function () {
      vm.usersPageChanged();

      vm.loadingAccount = true;
      vm.loadingPayment = true;

      updateForUser(userProvider.getUser());
      vm.featureLevel.newNumberOfUsers = userProvider.getUser().maxNumberOfUsers;
      originalFeatureLevel = angular.copy(vm.featureLevel);
      getPaymentInfo().finally(function () {
        vm.loadingAccount = false;
        vm.loadingPayment = false;
      });
    };

    vm.submitAccountFeatures = function () {
      Messages.clear();
      var accountFeatures = {};

      accountFeatures.isBillingUpdated = shouldSubmitBillingAddress();
      accountFeatures.isFeatureLevelUpdated = shouldSubmitFeatureLevel();
      accountFeatures.isCreditCardUpdated = vm.shouldSubmitCreditCard();

      if (!accountFeatures.isBillingUpdated && !accountFeatures.isFeatureLevelUpdated && !accountFeatures.isCreditCardUpdated) return;

      vm.isSubmittingAccountFeatures = true;
      vm.isProcessing = true;

      if (accountFeatures.isBillingUpdated) {
        accountFeatures.billing = {
          address1: vm.billing.address1,
          address2: vm.billing.address2,
          city: vm.billing.city,
          state: vm.billing.state,
          zip: vm.billing.postalCode,
          country: vm.billing.country,
          phoneNumber: vm.billing.phoneNumber
        };
      }

      if (accountFeatures.isCreditCardUpdated) {
        accountFeatures.credit = {
          cardHolderName: vm.creditCard.name,
          expirationYear: vm.creditCard.expYear,
          expirationMonth: vm.creditCard.expMonth,
          cardNumber: vm.creditCard.number,
          cardType: vm.creditCard.type,
          cvv: vm.creditCard.cvv
        };
      }

      accountFeatures.featureLevel = {
        featureLevel: vm.featureLevel.featureLevel,
        numberOfUsers: vm.featureLevel.newNumberOfUsers
      };

      $http.post("/api/ManageAccount/UpdateAccountFeatures", accountFeatures).success(function (response) {
        if (accountFeatures.isBillingUpdated) {
          Messages.add("success", "Successfully updated billing address", {
            showOnNextPage: false
          });

          eventTracker.track(eventTracker.EVENTS.UPDATE_BILLING, {
            ogCity: originalBilling.city,
            newCity: accountFeatures.billing.city,
            ogState: originalBilling.state,
            newState: accountFeatures.billing.state
          });

          originalBilling = angular.copy(vm.billing);
        }

        if (accountFeatures.isCreditCardUpdated) {
          Messages.add("success", "Successfully updated credit card", {
            showOnNextPage: false
          });
          vm.creditCard = response.credit;
          vm.originalCreditCard = angular.copy(response.credit);
        }

        if (accountFeatures.isFeatureLevelUpdated) {
          Messages.add("success", "Successfully updated feature level", {
            showOnNextPage: false
          });

          eventTracker.track(eventTracker.EVENTS.UPDATE_SUB_LEVEL, {
            ogFL: originalFeatureLevel.featureLevel,
            newFL: vm.featureLevel.featureLevel
          });

          vm.featureLevel.newNumberOfUsers = response.User.maxNumberOfUsers;
          originalFeatureLevel = angular.copy(vm.featureLevel);
        }

        userProvider.loadUser(response.User);
        updateForUser(response.User);

        console.log("Finished submit billing address");
      }).error(function (err) {
        if (typeof err === "string") Messages.add("danger", err, {
          showOnNextPage: false
        });
      }).finally(function () {
        vm.isProcessing = false;
        vm.isSubmittingAccountFeatures = false;
      });
    };
  }]);
})(window.angular);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  angular.module("app").controller("migrateController", ["$location", "$q", "_", "STATES", "migrateService", "signupService", "alkAuthenticationService", "Messages", "ALKLogin", function ($location, $q, _, STATES, migrateService, signupService, alkAuthenticationService, Messages, ALKLogin) {
    var vm = this;

    vm.states = STATES;
    vm.countries = _.uniq(STATES, "country");
    vm.wizardStep = 0;

    // handle page load and query parameters.
    vm.pcmUser = {
      username: $location.search().username,
      account: $location.search().account
    };

    vm.isSSOPasswordValid = true;

    vm.totalPrice = function () {
      var unitPrice = vm.signup.user.featureLevel === 'Standard' ? 59.99 : 84.99;
      return vm.signup.user.numberOfUsers * unitPrice;
    };

    vm.accountSelected = function (account) {
      vm.signup.user.account = account.AccountName;
      vm.signup.user.accountId = account.AccountId;
    };

    vm.toggleUseExistingAccount = function () {
      vm.enterNewAccount = !vm.enterNewAccount;

      delete vm.signup.user.account;
      delete vm.signup.user.accountId;
    };

    vm.loginToSSO = function () {
      return loginToSSO().then(getUserAccounts);
    };

    vm.notMyEmail = function () {
      vm.signup.user.ssoExists = false;

      delete vm.signup.user.password;
      delete vm.signup.user.ssoId;
      delete vm.signup.user.username;

      vm.signup.user.ssoFirstName = vm.signup.contact == null ? "" : vm.signup.contact.firstName;
      vm.signup.user.ssoLastName = vm.signup.contact == null ? "" : vm.signup.contact.lastName;

      vm.wizardStep = 2;
    };

    vm.loginToPcMiler = function () {
      vm.isProcessing = true;

      return migrateService.authenticate(vm.pcmUser).then(function (data) {
        console.log(data);
        vm.oSignup = angular.copy(data);

        pcMilerSignedIn(data);

        vm.wizardStep = data.user.ssoExists === true ? 1 : 2;
      }).finally(function () {
        vm.isProcessing = false;
      });
    };

    vm.deleteUser = function (user) {
      var indexOf = vm.signup.user.subUsers.indexOf(user);
      if (indexOf >= 0) {
        vm.signup.user.subUsers.splice(indexOf, 1);
      }
    };

    // Submit the form in its current state.  This displays all validaion errors on the current form and if the form is valid, performs the operation for the current step.
    vm.migrate = function () {
      vm.isProcessing = true;

      if (vm.isBillingChanged() === false) {
        vm.signup.user.isBillingAccepted = null;
      }

      migrateService.migrate(vm.signup).then(function () {
        Messages.add("success", "Your account has been successfully updated.", {
          showOnNextPage: true
        });
        $location.url("/login");
      }).catch(function (err) {
        console.log('error');
        console.log(err);
      }).finally(function () {
        vm.isProcessing = false;
      });
    };

    vm.reset = function () {
      pcMilerSignedIn(angular.copy(vm.oSignup));
      vm.wizardStep = 0;
    };

    vm.countryChanged = function () {
      var c = _.find(STATES, {
        abbreviation: vm.signup.customer.billing.State
      });
      if (c && c.country !== vm.signup.customer.billing.Country) {
        vm.signup.customer.billing.State = "";
      }
    };

    vm.stateChanged = function () {
      var c = _.find(STATES, {
        abbreviation: vm.signup.customer.billing.State
      });
      if (c && c.country !== vm.signup.customer.billing.Country) {
        vm.signup.customer.billing.Country = c.country;
      }
    };

    vm.isBillingChanged = function () {
      return vm.signup.user.numberOfUsers !== vm.oSignup.user.numberOfUsers || vm.oSignup.user.featureLevel === "Lite" || vm.signup.user.featureLevel !== vm.oSignup.user.featureLevel;
    };

    vm.isOriginalCardValid = function () {
      // if the original card was not valid, or if the card is changed - require the card information to be entered.

      if (vm.oSignup.customer.isInvoiced) {
        return true;
      }

      if (!vm.oSignup.customer.credit) {
        return false;
      }

      if (!vm.oSignup.customer.credit.number) {
        return false;
      }

      if (!vm.oSignup.customer.credit.name) {
        return false;
      }

      if (!vm.oSignup.customer.credit.expMonth) {
        return false;
      }

      if (!vm.oSignup.customer.credit.expYear) {
        return false;
      }

      return true;
    };

    function pcMilerSignedIn(data) {
      if (data.user.featureLevel === "Lite") {
        // Lite is no longer allowed
        data.user.featureLevel = "Standard";
      }

      // try to use the users email as their email, otherwise, use the username.
      data.user.email = data.user.email || data.user.username;

      if (data.user.subUsers) {
        for (var i = 0; i < data.user.subUsers.length; i++) {
          // populate the email field with the email if it exists for the user, otherwise, the username (and let the user correct the "email")
          data.user.subUsers[i].email = data.user.subUsers[i].email || data.user.subUsers[i].username;
        }
      }

      vm.signup = data;

      // todo - set all scope variables for current user.
      if (data.user.ssoExists !== true) {
        // user does not exist in SSO, new user form prepopulated
        vm.signup.user.ssoFirstName = vm.signup.contact == null ? "" : vm.signup.contact.firstName;
        vm.signup.user.ssoLastName = vm.signup.contact == null ? "" : vm.signup.contact.lastName;

        // if the user does not have an ALK SSO user yet, prepopulate the password and confirm password fields for their new user with the pcmiler live password
        vm.signup.user.password = vm.signup.user.pcmPassword;
        vm.signup.user.confirmPassword = vm.signup.user.pcmPassword;
      }
    }

    function loginToSSO() {
      vm.isSSOPasswordValid = true;

      var login = new ALKLogin(vm.signup.user.email, vm.signup.user.password);
      return alkAuthenticationService.validate(login).then(function () {
        vm.wizardStep = 2;
      }).catch(function (err) {
        vm.isSSOPasswordValid = false;
        return $q.reject(err);
      });
    }

    function getUserAccounts() {
      return signupService.getAccounts(vm.signup.user.email).then(function (accounts) {
        vm.userAccounts = [];

        for (var i = 0; i < accounts.data.length; i++) {
          vm.userAccounts.push(accounts.data[i]);
        }

        if (vm.userAccounts.length > 0) {
          delete vm.signup.user.account;
        }
      });
    }
  }]);
})(angular);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var serviceId = "migrateService";

  angular.module("app").factory(serviceId, ["$http", "$q", "Messages", function ($http, $q, Messages) {

    function authenticate(creds) {
      Messages.clear();

      var deferred = $q.defer();

      $http.post("/api/Migrate/Authenticate", creds).then(function (resp) {
        deferred.resolve(resp.data);
      }, function (err) {
        if (err.status === 401) {
          Messages.add("danger", "Invalid username or password", {
            showOnNextPage: false
          });
        }
        if (err.status === 400 && err.data !== "") {
          // bad request, display the message 
          Messages.add("danger", err.data, {
            showOnNextPage: false
          });
        } else {
          Messages.add("danger", "We have encountered an error and are unable to proceed. Please contact PC*MILER|Web Support team at <a href='mailto:pcmsupport@alk.com'>pcmsupport@alk.com</a> to complete the update process.", {
            showOnNextPage: false
          });
        }

        deferred.reject(err);
        return $q.reject(err);
      });

      return deferred.promise;
    }

    function migrate(data) {
      Messages.clear();

      var deferred = $q.defer();

      $http.post("/api/Migrate/Migrate", data).then(function (resp) {
        deferred.resolve(resp.data);
      }, function (err) {
        if (err.status === 400 && err.data !== "") {
          // bad request, display the message 
          Messages.add("danger", err.data, {
            showOnNextPage: false
          });
        } else {
          Messages.add("danger", "We have encountered an error and are unable to proceed. Please contact PC*MILER|Web Support team at <a href='mailto:pcmsupport@alk.com'>pcmsupport@alk.com</a> to complete the update process.", {
            showOnNextPage: false
          });
        }

        deferred.reject(err);
        return $q.reject(err);
      });

      return deferred.promise;
    }

    return {
      authenticate: authenticate,
      migrate: migrate
    };
  }]);
})(angular);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("app").controller("replaceUserController", ["$http", "$uibModalInstance", "$q", "alkModalService", "oldUser", "isReplacingCurrent", function ($http, $uibModalInstance, $q, alkModalService, oldUser, isReplacingCurrent) {
    var vm = this;

    vm.oldUser = oldUser;
    vm.newUser = {};

    function getVm() {
      return {
        OldUserEmail: vm.oldUser.UserName,
        FirstName: vm.newUser.firstName,
        LastName: vm.newUser.lastName,
        Email: vm.newUser.email
      };
    }

    function replaceUser() {
      return $http.post("/api/ManageAccount/ReplaceUser", getVm());
    }

    function showWarningIfNeeded() {
      if (isReplacingCurrent) {
        return alkModalService.show({
          size: "sm"
        }, {
          headerText: "Replace yourself?",
          bodyText: "Are you sure you want to replace yourself?",
          closeButtonText: "Cancel",
          actionButtonText: "Replace myself"
        });
      } else {
        return $q.when();
      }
    }

    vm.replaceUser = function () {
      vm.isProcessing = true;
      vm.showGenericError = false;

      showWarningIfNeeded().then(replaceUser).then(function () {
        $uibModalInstance.close();
      }).catch(function (err) {
        if (err !== "cancel") {
          vm.showGenericError = true;
          return $q.reject(err);
        }
      }).finally(function () {
        vm.isProcessing = false;
      });
    };

    vm.close = function () {
      $uibModalInstance.dismiss("cancel");
    };
  }]);
})();

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "pageController";

  angular.module("app").controller(controllerId, ["$scope", "$rootScope", "$location", function pageController($scope, $rootScope, $location) {

    $scope.getClass = function (path) {
      if ($location.path().substr(0, path.length) === path) {
        return "active";
      } else {
        return "";
      }
    };

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
  }]);
})();

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("app").factory("netSuite", ["$http", "$q", function ($http, $q) {
    function getBilling() {
      var deferred = $q.defer();

      $http.get("/api/ManageAccount/GetBillingInformation").success(function (response) {

        var billing = {
          hasBillingInformation: response.HasBillingInformation,
          address1: response.Address1,
          address2: response.Address2,
          city: response.City,
          state: response.State,
          postalCode: response.Zip,
          country: response.Country,
          phoneNumber: response.PhoneNumber
        };

        deferred.resolve(billing);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function getCredit() {
      var deferred = $q.defer();

      $http.get("/api/ManageAccount/GetCreditInformation").success(function (response) {

        var credit = {
          hasCreditInformation: response.HasCreditInformation,
          name: response.CardName,
          expYear: response.CardExpYear,
          expMonth: response.CardExpMonth,
          type: response.CardType,
          number: response.CardLastDigits
        };

        deferred.resolve(credit);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function getPaymentInformation() {
      var deferred = $q.defer();

      $http.get("/api/ManageAccount/GetPaymentInformation").success(function (response) {

        deferred.resolve(response);
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    return {
      getPaymentInformation: getPaymentInformation
    };
  }]);
})();

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var serviceId = "conversionService";

  angular.module("app").factory(serviceId, ["_", function (_) {
    var NUM_INCHES_IN_METER = 39.370;
    var NUM_POUNDS_IN_KILOGRAM = 2.20462;
    var NUM_INCHES_IN_FOOT = 12;

    function feetToString(wholeFeet) {
      var feet = feet(wholeFeet);
      var inches = inches(wholeFeet);
      var retval = feet + "'" + inches + '"';
      return retval;
    }

    function feet(wholeFeet) {
      var feet = Math.floor(wholeFeet);
      return feet;
    }

    function inches(wholeFeet) {
      var feet = Math.floor(wholeFeet);
      var inches = Math.round((wholeFeet - feet) * 12);
      return inches;
    }

    function round(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
    }

    function feetInchesToMeters(feet, inches, decimals) {
      var totalInches = NUM_INCHES_IN_FOOT * feet + inches;

      var meters = totalInches / NUM_INCHES_IN_METER;

      if (decimals) {
        return round(meters, decimals);
      }

      return meters;
    }

    function metersToFeetInches(meters, decimals) {
      var inches = parseInt(meters * NUM_INCHES_IN_METER);
      return [parseInt(inches / NUM_INCHES_IN_FOOT), inches % NUM_INCHES_IN_FOOT];
    }

    function stringToFeetInches(str) {
      var nums = str.match(/\d+/g);
      if (nums === null || nums === undefined) {
        nums = ["0", "0"];
      }
      if (nums.length < 2) {
        if (str.indexOf("\"")) {
          nums.unshift("0");
        } else {
          nums.push("0");
        }
      }
      return [parseInt(nums[0]), parseInt(nums[1])];
    }

    function stringToTotalInches(str) {
      var feetInches = stringToFeetInches(str);
      var feet = feetInches[0];
      var inches = feetInches[1];

      return feet * NUM_INCHES_IN_FOOT + inches;
    }

    function totalInchesToString(totalInches, keepTotalInches) {
      if (keepTotalInches === true) {
        return totalInches.toString() + "\"";
      }

      var feet = Math.floor(totalInches / NUM_INCHES_IN_FOOT);
      var inches = totalInches % NUM_INCHES_IN_FOOT;

      var feetInches = [feet, inches];

      return feetInchesToString(feetInches);
    }

    function feetInchesToString(arr) {
      var feet = arr[0];
      var inches = arr[1];

      if (feet !== "") {
        feet += "'";
      }
      if (inches !== "") {
        inches += "\"";
      }
      return feet + inches;
    }

    function poundsToKilograms(str, decimals) {
      var num;

      if (_.isString(str)) {
        num = parseFloat(str);
      } else if (_.isNumber(str)) {
        num = str;
      }

      var kilograms = num / NUM_POUNDS_IN_KILOGRAM;

      if (decimals) {
        return round(kilograms, decimals);
      }

      return kilograms;
    }

    function kilogramsToPounds(str) {
      return parseInt(parseFloat(str) * NUM_POUNDS_IN_KILOGRAM);
    }

    function inchesToMeters(inch, decimals) {
      var m = parseFloat(inch) / NUM_INCHES_IN_METER;

      return decimals ? round(m, decimals) : m;
    }

    function metersToInches(meter) {
      return parseInt(parseFloat(meter) * NUM_INCHES_IN_METER);
    }

    function bounds(min, max, value) {
      if (value < min) return min;
      if (value > max) return max;
      return value;
    }

    var service = {
      stringToFeetInches: stringToFeetInches,
      feetInchesToString: feetInchesToString,

      metersToFeetInches: metersToFeetInches,
      feetInchesToMeters: feetInchesToMeters,

      poundsToKilograms: poundsToKilograms,
      kilogramsToPounds: kilogramsToPounds,

      inchesToMeters: inchesToMeters,
      metersToInches: metersToInches,

      totalInchesToString: totalInchesToString,
      stringToTotalInches: stringToTotalInches,
      feetToString: feetToString,
      feet: feet,
      inches: inches,
      round: round,
      bounds: bounds
    };

    return service;
  }]);
})(window.angular);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon", []);

  angular.module("pcmCommon").constant("_", window._);
  angular.module("pcmCommon").constant("moment", window.moment);
})();

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon").constant("defaultDimensions", {
    min: {
      heightEnglish: 5, // in feet
      lengthEnglish: 8, // in feet
      weightEnglish: 1500,
      widthEnglish: 60, // in inch
      heightMetric: 1.524,
      lengthMetric: 2.4384,
      weightMetric: 680.39,
      widthMetric: 1.524,
      // eu trailer only
      trlHeightEnglish: 3, // in feet
      trlWeightEnglish: 4400,
      trlHeightMetric: 0.9144,
      trlWeightMetric: 2000
    },
    max: {
      heightEnglish: 15, // in feet
      lengthEnglish: 70, // in feet
      weightEnglish: 156470,
      widthEnglish: 102, // in inch
      heightMetric: 5,
      lengthMetric: 28,
      weightMetric: 60000,
      widthMetric: 3,
      // eu trailer only
      trlHeightEnglish: 20, // in feet
      trlWeightEnglish: 132000,
      trlHeightMetric: 6.096,
      trlWeightMetric: 60000
    },
    def: {
      truck: {
        height: 13.5,
        length: 48,
        weight: 80000,
        axles: 5,
        width: 96
      },
      light: {
        height: 13.5,
        length: 26,
        weight: 26000,
        axles: 2,
        width: 96
      },
      car: {
        height: 7,
        length: 20,
        weight: 8500,
        axles: 2,
        width: 96
      },
      euTrailer: {
        hasTrailer: false,
        trlType: 1, // None
        trlMaxHt: "13'6\"",
        trlMaxWt: 80000,
        trlCount: 0,
        trlMaxAxles: 1,
        isHybrid: false,
        minPoll: false,
        emiType: 7 // Euro V
      },
      limit: {
        elevationEnglish: 7500,
        elevationMetric: 2286,
        governorSpeedEnglish: 55,
        governorSpeedMetric: 88
      }
    }
  });
})();

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon").constant("systemDefaultOptions", {
    name: "Default",
    vehicleType: 0,
    trkUnits: 0,
    trkLength: "48'0\"",
    trkWidth: "96\"",
    trkHeight: "13'6\"",
    trkWeight: 80000,
    trkAxles: 5,
    trkLCV: false,
    routingType: 0,
    distanceUnits: 0,
    tollDiscourage: false,
    bordersOpen: true,
    overrideRestrict: false,
    highwayOnly: false,
    inclFerryDist: true,
    classOverrides: 0,
    hazMatType: 0,
    tollCurrency: 0,
    exchangeRate: 1.355,
    hubRouting: false,
    fuelUnits: 0,
    costGHG: 22.40,
    costPerFuelUnit: 4.02,
    fuelEconLoad: 6.96,
    fuelEconEmpty: 6.96,
    costMaintLoad: 0.22,
    costMaintEmpty: 0.22,
    costTimeLoad: 47.89,
    costTimeEmpty: 47.89,
    dataVersion: "current",
    inclTollData: false,
    tollPlan: "",
    ferryDiscourage: false,
    elevLimit: null,
    tollRoadType: 3,
    governorSpeedLimit: null,
    sideOfStreetAdherence: 0,
    useTraffic: false,
    useSites: false,
    afSetIDs: "",
    euHazmatType: "None",
    euHazmat: "None",
    EUOptions: {
      fuelType: 4, // Diesel
      refrigerated: false,
      fuelConsumption: 0,
      emiType: 7,
      hasTrailer: false,
      isHybrid: false,
      minPoll: false,
      trlCount: 0,
      trlMaxAxles: 1,
      trlMaxHt: "13'6\"",
      trlMaxWt: 80000,
      trlType: 1
    }
  });
  // Toll road type: '3' represents "Use Toll roads".  This enumeration value is requried in data anywhere and is not available for users in pcmiler web ui to choose. HardCode this value.
})();

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon").filter("optionSummaryFilter", ["_", "UserProvider", "optionsUI", function (_, userProvider, optionsUI) {
    return function (route) {
      var summary = "";

      //summary += (route.options.routingType === 0) ? "Practical, " : "Shortest, ";
      summary += _.find(optionsUI.vehicleType, {
        "value": route.options.vehicleType
      }).display + ", ";
      summary += route.options.afSetIDs && route.options.afSetIDs !== "" ? "Use Route Modifiers, " : "", summary += route.options.tollDiscourage ? "Avoid Tolls, " : "";
      summary += route.options.elevLimit ? "Elev." + route.options.elevLimit + "," : "Elevation Discouraged, ";
      summary += route.options.highwayOnly ? "Highway Only, " : "Use Local Streets, ";
      summary += route.options.ferryDiscourage ? "Ferry Discouraged, " : "Ferry incl., ";
      summary += "Side of Street: ";
      summary += _.find(optionsUI.sideOfStreetAdherence, {
        "value": route.options.sideOfStreetAdherence
      }).display + ", ";
      summary += route.options.hubRouting ? "Hub, " : "";
      summary += route.options.useSites ? "Site, " : "";
      summary += route.options.classOverrides === 3 ? "National Network, " : "";
      summary += route.options.classOverrides === 3 ? "53' Trailer, " : "";
      summary += route.options.bordersOpen ? "Borders Open, " : "Borders Closed, ";
      summary += route.options.governorSpeedLimit ? "Governor Speed Limit, " : "";
      summary += route.options.hazMatType > 0 ? _.find(optionsUI.hazmat, {
        "value": route.options.hazMatType
      }).display + ", " : "";
      summary += route.options.overrideRestrict ? "Override, " : "";
      summary += _.find(optionsUI.routingType, {
        "value": route.options.routingType
      }).display + " Routing Type, ";
      summary += route.options.inclFerryDist ? "Ferry Dist. incl, " : "";

      return summary.substr(0, summary.length - 2);
    };
  }]);

  angular.module("pcmCommon").filter("vehicleSummaryFilter", ["$filter", function ($filter) {
    return function (route) {
      var summary = "Weight: ";

      if (route.options.trkUnits === 0) {
        summary += $filter("number")(route.options.trkWeight) + "lbs | Height: ";
        summary += route.options.trkHeight + " | Length: ";
        summary += route.options.trkLength + " | Width: ";
        summary += route.options.trkWidth;
      } else {
        summary += $filter("number")(route.options.trkWeight) + "kgs | Height: ";
        summary += route.options.trkHeight + "m | Length: ";
        summary += route.options.trkLength + "m | Width: ";
        summary += route.options.trkWidth;
      }

      summary += " | Axles: " + route.options.trkAxles;

      return summary;
    };
  }]);

  angular.module("pcmCommon").filter("tollCostSummaryFilter", ["_", "optionsUI", function (_, optionsUI) {
    return function (amount, currencyType) {
      var curr = _.find(_.union(optionsUI.tollCurrency, optionsUI.tollCurrencyEU), { value: currencyType });
      return curr.isPrefix ? curr.symbol + amount : amount + " " + curr.symbol;
    };
  }]);
})();

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon").factory("LocationItem", ["stopService", "ArrivalTime", function (stopService, ArrivalTime) {
    var typeIcons = {
      "Country": "ico-frame-box",
      "State": "ico-frame-box",
      "County": "ico-frame-box",
      "City": "ico-dot-circle-o",
      "Zip": "ico-dot-circle-o",
      "SPLC": "ico-point-location",
      "Street": "ico-envelope",
      "RouteNumber": "ico-highway",
      "RouteAlpha": "ico-highway",
      "POI": "ico-map-marker",
      "FullPostCode": "ico-point-location",
      "POIType": "ico-map-marker",
      "CustomPlace": "ico-map-marker",
      "AthenaPlace": "ico-map-marker",
      "None": "ico-point-location"
    };

    // The mapping of ResultType to ResultTypeString should be obtained from /api/search/resultTypes instead
    // of hard-coding.
    var resultTypeMapping = {
      "0": "Country",
      "1": "State",
      "2": "County",
      "3": "City",
      "4": "Zip",
      "5": "SPLC",
      "6": "Street",
      "7": "RouteNumber",
      "8": "RouteAlpha",
      // pchen: returned for Athena Places too
      "9": "POI",
      "10": "POIStreet",
      "11": "FullPostCode",
      "12": "POIType",
      "13": "CrossStreet",
      "14": "LatLon",
      "15": "CustomPlace",
      "16": "CustomPlaceStreet",
      // pchen: only returned for latlon lookup when includeTrimblePlaceIds=true
      "17": "AthenaPlace",
      "18": "None"
    };
    function LocationItem(data, name) {
      var self = this;
      //todo: figure out if this is the right solution for this (using data.PlaceId || data.Id).  data anywhere service returns back an 'Id' property with the Id, i think some other place returns back a 'PlaceId' property. Custom places return CompanyId verify this
      self.Id = data.PlaceId || data.Id;
      self.Name = name;
      self.Address = data.Address;
      self.Coords = data.Coords;
      self.TypeIcon = typeIcons["None"];
      // SWPWEB-1298, SWPWEB-1302
      self.origLatlon = data.origLatlon ? data.origLatlon : null;
      if (data.ResultTypeString) {
        self.TypeIcon = typeIcons[data.ResultTypeString];
      } else if (data.ResultType && data.ResultType in resultTypeMapping) {
        data.ResultTypeString = resultTypeMapping[data.ResultType];
        self.TypeIcon = typeIcons[data.ResultTypeString];
      } else {
        if (data.Address.City !== "") {
          self.TypeIcon = typeIcons["City"];
        }
        if (data.Address.Zip !== "") {
          self.TypeIcon = typeIcons["Zip"];
        }
        if (data.Address.StreetAddress !== "") {
          self.TypeIcon = typeIcons["Street"];
        }
        if (data.PlaceName !== "") {
          self.TypeIcon = typeIcons["POI"];
        }
      }
      if (data.location) {
        data = data.location;
      }
      self.Icon = "destination";
      self.IconText = "D";
      // self.LineClass = (data.Address.StreetAddress === "") ? "noAddress" : "";
      self.CityStateZip = (data.Address.City !== null && data.Address.City !== "" ? data.Address.City + ", " : "") + data.Address.State + (data.Address.Zip != null ? " " + data.Address.Zip : "");

      self.CountyStr = data.Address.County !== "" && data.Address.County !== null ? data.Address.County + " County" : "";
      self.Country = data.Address.Country !== "" && data.Address.Country != null ? data.Address.Country : "";

      populatePlaceName(data, name);
      self.ALKObj = data;

      self.PlaceNameID = actualDisplayPlaceNameId(data);

      self.isVisible = false;

      self.showMe = function () {
        this.isVisible = true;
      };

      self.hideMe = function () {
        this.isVisible = false;
      };

      //The duration in string format. Can be in hh:mm, hh.hh or mm
      self.duration = data.duration;
      if (!self.duration) {
        self.duration = "";
      }

      self.earliestArrivalTime = new ArrivalTime({
        type: 0,
        arrivalTime: data.earliestArrivalTime,
        checkboxLabel: "Earliest Arrival",
        weekdayTimeLabel: "Earliest arrive at (local time)"
      });

      self.latestArrivalTime = new ArrivalTime({
        type: 1,
        arrivalTime: data.latestArrivalTime,
        checkboxLabel: "Latest Arrival",
        weekDayTimeLabel: "Latest arrive at (local time)"
      });

      self.getDurationInHours = function () {
        return stopService.getHoursFromString(this.duration);
      };

      self.getDurationInSeconds = function () {
        return stopService.getSecondsFromString(this.duration);
      };

      self.etaInTimeWindow = function () {
        if (!this.earliestArrivalTime.hasValue() && !this.latestArrivalTime.hasValue()) {
          return true;
        }
        var startWindow = this.earliestArrivalTime.getWsMomentTime();
        var endWindow = this.latestArrivalTime.getWsMomentTime();
        var ETA = moment(this.ETA, "M/D/YYYY hh:mm A");
        return ETA >= startWindow && ETA <= endWindow;
      };

      self.getArrivalDateRange = function () {
        if (!this.earliestArrivalTime.hasValue() && !this.latestArrivalTime.hasValue()) {
          return "-";
        }
        return this.earliestArrivalTime.getUIFormattedTime() + " - " + this.latestArrivalTime.getUIFormattedTime();
      };

      //Copy over certain fields from another locationitem. (includes duration, arrival times, etc)
      self.copySavedData = function (origLocationItem) {
        this.duration = origLocationItem.duration;
        this.earliestArrivalTime = origLocationItem.earliestArrivalTime;
        this.latestArrivalTime = origLocationItem.latestArrivalTime;
      };

      //Subtract the duration from the WS returned hours because it factors in duration and we don't want it to
      self.getHoursWithoutDuration = function () {
        if (!this.duration || this.Hours === "0:00") {
          return this.Hours;
        }
        var stopDurationSeconds = stopService.getSecondsFromString(this.duration);
        var wsHoursInSeconds = moment.duration(this.Hours).asSeconds();
        if (wsHoursInSeconds <= 0 || stopDurationSeconds <= 0) {
          return this.Hours;
        }
        var diff = wsHoursInSeconds - stopDurationSeconds;
        var hours = diff / 3600;
        var hourComponent = Math.floor(hours); //Whole number hours component
        var minuteComponent = Math.round((hours - hourComponent) * 60); //Whole number minutes component
        var minuteString = String(minuteComponent);
        if (minuteString.length === 1) {
          minuteString = "0" + minuteString;
        }
        return String(hourComponent) + ":" + minuteString;
      };
    }

    function populatePlaceName(data, name) {
      var resultTypesWithNameRegex = /^(POI|CustomPlace|AthenaPlace)$/;
      var ShortString = data.ShortString,
          ResultTypeString = data.ResultTypeString;

      data.PlaceName = resultTypesWithNameRegex.test(ResultTypeString) ? ShortString : name;
    }

    function actualDisplayPlaceNameId(_ref) {
      var PlaceName = _ref.PlaceName,
          CompanyId = _ref.CompanyId,
          PlaceId = _ref.PlaceId;

      var placeID = CompanyId || PlaceId;
      if (placeID) {
        return PlaceName + " (" + placeID + ")";
      } else {
        return PlaceName;
      }
    }

    return LocationItem;
  }]);
})();

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

  angular.module("pcmCommon").factory("stopService", stopService);

  stopService.$inject = [];

  function stopService() {

    var service = {
      getHoursFromString: getHoursFromString,
      getSecondsFromString: getSecondsFromString,
      getDurationInHHMM: getDurationInHHMM
    };

    return service;

    /////////////////////

    //Given a string, get hours from format of either hh:mm, hh.hh or mm.
    //If not in any of these formats, returns null.
    function getHoursFromString(str) {
      if (!str) {
        return 0;
      } //Blank string should be valid (since the field is optional)

      //hh:mm
      var pieces = str.split(":");
      if (pieces.length === 2 && /^[0-9]{1,}:[0-9]{2}$/.exec(str) !== null) {
        //Regex matches <one or more digits>:<exactly two digits>
        return Number(pieces[0]) + Number(pieces[1]) / 60;
      }
      //hh.hh
      pieces = str.split(".");
      if (pieces.length === 2 && /^([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/.exec(str) !== null) {
        //Regex matches <any number of digits>.<any number of digits>
        return Number(str);
      }
      //mm
      if (/^[0-9]+$/.exec(str) !== null) {
        //Regex matches any sequence of digits
        var fieldNum = Number(str);
        if (fieldNum < 0) {
          return null;
        }
        return Number(str) / 60;
      }
      return null;
    }

    //Same as above function but returns seconds, not hours
    function getSecondsFromString(str) {
      var hours = getHoursFromString(str);
      if (!hours) {
        return 0;
      }
      return hours * 3600;
    }

    //Always returns in hh:mm format from a string that is either in hh:mm, hh.hh or mm
    function getDurationInHHMM(str) {
      var hours = getHoursFromString(str);
      if (!hours) {
        return "00:00";
      }
      var decimal = hours - Math.floor(hours);
      var minutes = String(Math.round(decimal * 60));
      hours = String(Math.floor(hours));

      if (hours.length === 1) {
        hours = "0" + hours;
      }
      if (minutes.length === 1) {
        minutes = "0" + minutes;
      }
      if (minutes.length > 2) {
        minutes = minutes[0] + minutes[1];
      }
      return hours + ":" + minutes;
    }
  }
})();

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("pcmCommon").constant("optionsUI", {
    vehicleType: [{
      display: "Truck",
      value: 0
    }, {
      display: "Light Truck",
      value: 1
    }, {
      display: "Car",
      value: 2
    }],
    cpVehicleType: [{
      display: "Car",
      value: 2
    }, {
      display: "RV",
      value: 3
    }, {
      display: "Motorcycle",
      value: 4
    }, {
      display: "Bicycle",
      value: 5
    }, {
      display: "Walking",
      value: 6
    }],
    routingType: [{
      display: "Practical",
      value: 0
    }, {
      display: "Shortest",
      value: 1
    }, {
      display: "Fastest",
      value: 2
    }],
    arrDepTypes: [{
      display: "None",
      value: "None"
    }, {
      display: "Depart now",
      value: "now"
    }, {
      display: "Depart at...",
      value: "Depart"
    }, {
      display: "Arrive by...",
      value: "Arrive"
    }],
    tollDiscourage: [{
      display: "Allowed",
      value: false
    }, {
      display: "Discouraged",
      value: true
    }],
    classOverrides: [{
      display: "None",
      value: 0
    }, {
      display: "State + National Network",
      value: 3
    }],
    highwayOnly: [{
      display: "Highways & Streets",
      value: false
    }, {
      display: "Highway Only",
      value: true
    }],
    bordersOpen: [{
      display: "Open",
      value: true
    }, {
      display: "Closed",
      value: false
    }],
    overrideRestrict: [{
      display: "Use",
      value: false
    }, {
      display: "Override",
      value: true
    }],
    ferryDiscourage: [{
      display: "Allowed",
      value: false
    }, {
      display: "Discouraged",
      value: true
    }],
    useSites: [{
      display: "Enabled",
      value: true
    }, {
      display: "Disabled",
      value: false
    }],
    hubRouting: [{
      display: "Disabled",
      value: false
    }, {
      display: "Enabled",
      value: true
    }],
    governorSpeedLimits: [{
      display: "Disabled",
      value: false
    }, {
      display: "Enabled",
      value: true
    }],
    elevLimit: [{
      display: "Any",
      value: false
    }, {
      display: "Discouraged Above",
      value: true
    }],
    cpTolls: [
    //{ display: "Always Avoid Tolls", value: true },
    {
      display: "Avoid Tolls if Possible",
      value: true
    }, {
      display: "Tolls OK",
      value: false
    }],
    distanceUnits: [{
      display: "Miles",
      value: 0
    }, {
      display: "Kilometers",
      value: 1
    }],
    fuelUnits: [{
      display: "Gallons",
      value: 0
    }, {
      display: "Liters",
      value: 1
    }],
    trkUnits: [{
      displayNA: "US Customary",
      displayEU: "English",
      value: 0
    }, {
      displayNA: "Metric",
      displayEU: "Metric",
      value: 1
    }],
    travelSpeeds: [{
      display: "Real-time Traffic",
      value: true
    }, {
      display: "Historic Traffic",
      value: false
    }],
    hazmat: [{
      display: "None",
      value: 0
    }, {
      display: "Corrosive",
      value: 2
    }, {
      display: "Explosives",
      value: 3
    }, {
      display: "Flammable",
      value: 4
    }, {
      display: "Inhalants",
      value: 5
    }, {
      display: "Radioactive",
      value: 6
    }, {
      display: "Other",
      value: 1
    }],
    daydatetype: [{
      display: "Specific Day",
      value: "weekday"
    }, {
      display: "Specific Date",
      value: "date"
    }],
    tollCurrency: [{
      display: "US Dollars",
      value: 0,
      exchangeRate: 1.355,
      symbol: "$",
      isPrefix: true
    }, {
      display: "Canadian Dollars",
      value: 1,
      exchangeRate: 0.738,
      symbol: "$",
      isPrefix: true
    }],
    tollCurrencyEU: [{
      display: "Albanian lek",
      value: 2,
      exchangeRate: 1,
      symbol: "Lek",
      isPrefix: false
    }, {
      display: "Aremenian dram",
      value: 3,
      exchangeRate: 1,
      symbol: "֏",
      isPrefix: true
    }, {
      display: "Azerbaijani manat",
      value: 4,
      exchangeRate: 1,
      symbol: "₼",
      isPrefix: true
    }, {
      display: "Bosnia and Herzegovina convertible mark",
      value: 5,
      exchangeRate: 1,
      symbol: "marks",
      isPrefix: false
    }, {
      display: "Bulgarian lev",
      value: 6,
      exchangeRate: 1,
      symbol: "лв.",
      isPrefix: true
    }, {
      display: "Belarusian ruble",
      value: 7,
      exchangeRate: 1,
      symbol: "rubles",
      isPrefix: false
    }, {
      display: "Swiss franc",
      value: 8,
      exchangeRate: 1,
      symbol: "Fr.",
      isPrefix: true
    }, {
      display: "Czech koruna",
      value: 9,
      exchangeRate: 1,
      Symbol: "Kč",
      isPrefix: false
    }, {
      display: "Danish krone",
      value: 10,
      exchangeRate: 1,
      symbol: "kr.",
      isPrefix: true
    }, {
      display: "Euros",
      value: 11,
      exchangeRate: 1,
      symbol: "€",
      isPrefix: true
    }, {
      display: "Pound sterling",
      value: 12,
      exchangeRate: 1,
      symbol: "£",
      isPrefix: true
    }, {
      display: "Georgian lari",
      value: 13,
      exchangeRate: 1,
      symbol: "GEL",
      isPrefix: true
    }, {
      display: "Croatian kuna",
      value: 14,
      exchangeRate: 1,
      symbol: "kn",
      isPrefix: false
    }, {
      display: "Hungarian forint",
      value: 15,
      exchangeRate: 1,
      symbol: "Ft",
      isPrefix: false
    }, {
      display: "Icelandic króna: second króna",
      value: 16,
      exchangeRate: 1,
      symbol: "kr",
      isPrefix: true
    }, {
      display: "Moldovan leu",
      value: 17,
      exchangeRate: 1,
      symbol: "lei",
      isPrefix: false
    }, {
      display: "Second Macedonian denar",
      value: 18,
      exchangeRate: 1,
      symbol: "	ден",
      isPrefix: true
    }, {
      display: "Norwegian krone",
      value: 19,
      exchangeRate: 1,
      symbol: "kr",
      isPrefix: true
    }, {
      display: "Polish złoty",
      value: 20,
      exchangeRate: 1,
      symbol: "zł",
      isPrefix: true
    }, {
      display: "Fourth Romanian leu",
      value: 21,
      exchangeRate: 1,
      symbol: "leu",
      isPrefix: false
    }, {
      display: "Serbian dinar",
      value: 22,
      exchangeRate: 1,
      symbol: "din",
      isPrefix: false
    }, {
      display: "Russian ruble",
      value: 23,
      exchangeRate: 1,
      symbol: "₽",
      isPrefix: false
    }, {
      display: "Swedish krona",
      value: 24,
      exchangeRate: 1,
      symbol: "kr",
      isPrefix: true
    }, {
      display: "Turkish lira",
      value: 25,
      exchangeRate: 1,
      symbol: "₺",
      isPrefix: true
    }, {
      display: "Ukrainian hryvnia",
      value: 26,
      exchangeRate: 1,
      symbol: "₴",
      isPrefix: true
    }],
    reportDataVersion: [{
      display: "Current",
      value: "current"
    },
    // Note: add here new data version is added.
    {
      display: "PC*MILER 37",
      value: "PCM37"
    }, {
      display: "PC*MILER 36",
      value: "PCM36"
    }, {
      display: "PC*MILER 35",
      value: "PCM35"
    }, {
      display: "PC*MILER 34",
      value: "PCM34"
    }, {
      display: "PC*MILER 33",
      value: "PCM33"
    }, {
      display: "PC*MILER 32",
      value: "PCM32"
    }, {
      display: "PC*MILER 31",
      value: "PCM31"
    }, {
      display: "PC*MILER 30",
      value: "PCM30"
    }, {
      display: "PC*MILER 29",
      value: "PCM29"
    }, {
      display: "PC*MILER 28",
      value: "PCM28"
    }, {
      display: "PC*MILER 27",
      value: "PCM27"
    }, {
      display: "PC*MILER 26",
      value: "PCM26"
    }, {
      display: "PC*MILER 25",
      value: "PCM25"
    }, {
      display: "PC*MILER 24",
      value: "PCM24"
    }, {
      display: "PC*MILER 23",
      value: "PCM23"
    }, {
      display: "PC*MILER 22",
      value: "PCM22"
    }, {
      display: "PC*MILER 21",
      value: "PCM21"
    }, {
      display: "PC*MILER 20",
      value: "PCM20"
    }, {
      display: "PC*MILER 19",
      value: "PCM19"
    }, {
      display: "PC*MILER 18",
      value: "PCM18"
    }],
    sideOfStreetAdherence: [{
      display: "Off",
      value: 0
    }, {
      display: "Minimal",
      value: 1
    }, {
      display: "Moderate",
      value: 2
    }, {
      display: "Average",
      value: 3
    }, {
      display: "Strict",
      value: 4
    }, {
      display: "Adhere",
      value: 5
    }, {
      display: "Strongly Adhere",
      value: 6
    }],
    classicSearchView: [{
      display: "Separate Search Fields",
      value: true
    }, {
      display: "Single Search Field",
      value: false
    }],
    trlType: [{
      display: "None",
      value: 1
    }, {
      display: "Caravan",
      value: 2
    }, {
      display: "Trailer",
      value: 3
    }],
    trlMaxAxles: [{
      display: 1,
      value: 1
    }, {
      display: 2,
      value: 2
    }, {
      display: 3,
      value: 3
    }, {
      display: 4,
      value: 4
    }, {
      display: 5,
      value: 5
    }, {
      display: 6,
      value: 6
    }, {
      display: 7,
      value: 7
    }, {
      display: 8,
      value: 8
    }],
    emiType: [{
      display: "Euro I",
      value: 3
    }, {
      display: "Euro II",
      value: 4
    }, {
      display: "Euro III",
      value: 5
    }, {
      display: "Euro IV",
      value: 6
    }, {
      display: "Euro V",
      value: 7
    }, {
      display: "Euro VI",
      value: 8
    }],
    trkAxles: [{
      display: 2,
      value: 2
    }, {
      display: 3,
      value: 3
    }, {
      display: 4,
      value: 4
    }, {
      display: 5,
      value: 5
    }, {
      display: 6,
      value: 6
    }, {
      display: 7,
      value: 7
    }, {
      display: 8,
      value: 8
    }, {
      display: 9,
      value: 9
    }, {
      display: 10,
      value: 10
    }, {
      display: 11,
      value: 11
    }, {
      display: 12,
      value: 12
    }, {
      display: 13,
      value: 13
    }, {
      display: 14,
      value: 14
    }],
    euHazmatType: [{
      display: "None",
      value: "None"
    }, {
      display: "General",
      value: "General"
    }, {
      display: "Explosives",
      value: "Explosives"
    }, {
      display: "Flammable",
      value: "Flammable"
    }, {
      display: "Harmful to Water",
      value: "Harmful to Water"
    }],
    euHazmatCat: [{
      display: "None",
      value: "None"
    }, {
      display: "E Prohibited",
      value: "E Prohibited"
    }, {
      display: "D, E Prohibited",
      value: "D, E Prohibited"
    }, {
      display: "C, D, E Prohibited",
      value: "C, D, E Prohibited"
    }, {
      display: "B, C, D, E Prohibited",
      value: "B, C, D, E Prohibited"
    }],
    fuelType: [{
      display: "Petrol",
      value: 0
    }, {
      display: "Petrol_E5",
      value: 1
    }, {
      display: "Petrol_E10",
      value: 2
    }, {
      display: "Ethanol",
      value: 3
    }, {
      display: "Diesel",
      value: 4
    }, {
      display: "Biodiesel",
      value: 5
    }, {
      display: "Diesel_D5",
      value: 6
    }, {
      display: "Diesel_D7",
      value: 7
    }, {
      display: "Count",
      value: 8
    }]
  });
})();

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  angular.module("pcmCommon").factory("RouteItem", ["$rootScope", "_", "moment", "routingProfile", function ($rootScope, _, moment, routingProfile) {
    function RouteItem(name, stops, options, warnings) {
      var self = this;
      self.id = _.uniqueId();
      self.name = name || "Route " + self.id;
      self.isVisible = true;
      self.stops = stops || [];
      self.warnings = warnings || [];
      self.reportWindow = null;
      self.sortableItems = [];

      self.syncStopsToSortableItems = function (index, alwaysAddSearch) {
        var noSearchPanel = self.getSearchPanelIndex() === -1;
        self.sortableItems = [];
        _.each(self.stops, function (s, i) {
          self.sortableItems.push({ "type": "stop", "value": s });
        });
        //Do not add search panel if it was explictly removed previously
        if (noSearchPanel && !alwaysAddSearch && self.stops.length > 1) {
          return;
        } else if (index !== null && index !== undefined) {
          self.sortableItems.splice(index, 0, { "type": "search", "value": null });
        } else {
          self.sortableItems.push({ "type": "search", "value": null });
        }
        // add warnings between stops if necesary
        if (self.warnings !== []) {
          self.warnings.forEach(function (warning) {
            if (index === 0) {
              //search bar gets added at 0
              self.sortableItems.splice(warning.index + 1, 0, { "type": "warning", "value": warning.text });
            } else {
              self.sortableItems.splice(warning.index, 0, { "type": "warning", "value": warning.text });
            }
          });
        }
        //console.log("Trigger from syncStopsToSortableItems: sortableItems", self.sortableItems);
      };

      self.syncSortableItemsToStops = function () {
        self.stops = [];
        _.each(self.sortableItems, function (s, i) {
          if (s.type === "stop") {
            self.stops.push(s.value);
          }
        });
        //console.log("Trigger from:syncSortableItemsToStops, stops", self.stops);
      };

      self.getSearchPanelIndex = function () {
        return _.findIndex(self.sortableItems, function (s) {
          return s.type === "search";
        });
      };

      self.removeSortableItem = function (index) {
        self.sortableItems.splice(index, 1);
      };
      self.syncStopsToSortableItems(null, true);

      // the users modified default options are passed into this method from the one spot that currently calls this, but in the future, if more spots call into this and don't pass in the modified defaults, use the system defaults.
      self.options = options || routingProfile.getSystemDefaultOptions();

      self.uiRoutingSelection = self.options.routingType;
      self.updateRoutingSelection = function (i) {
        if (i !== self.options.routingType) {
          self.uiRoutingSelection = i;
          self.options.routingType = i;
          $rootScope.$broadcast("RunRoute", self);
        }
      };

      self.hasTime = false;
      self.uiArrDepSelection = {
        type: "None",
        datetype: "date",
        useTraffic: false,
        weekday: moment(new Date()).format("dddd"),
        date: moment(new Date()).format("M/DD/YYYY"),
        time: moment(new Date()).format("h:mm A")
      };

      self.updateArrDepTime = function () {
        self.uiArrDepSelection.time = moment(new Date()).format("h:mm A");
      };

      self.applyArrDep = function () {
        /* estimatedTimeOpts	{String} Estimated time options, format Depart(Arrive)|[DayOfWeek][SpecificDateTime]|[TimeOfDay],
            ex: Depart|Monday|18:30 to depart given day of week and time of day;
            or Arrive|2014-03-04T08:15:30-05:00 to arrive at specific date/time,
            or Arrive or Depart to arrive or depart with system time.
         */
        var data = self.uiArrDepSelection;
        var arrDepString = "";
        self.hasTime = false;
        if (data.type !== "None") {
          var tempDate;
          var tempTime;
          if (data.type === "now") {
            arrDepString += "Depart";
          } else {
            arrDepString += data.type;
            tempDate = moment(data.date, "M/DD/YYYY");
            tempTime = moment(data.time, "hh:mm A");
          }
          self.hasTime = true;
          // SWPWEB-1220; do not add timestamp if date.type = now
          if (data.type !== "now" && data.datetype === "date") {
            arrDepString += "|" + moment(tempDate).format("YYYY-MM-DD") + "T" + moment(tempTime).format("HH:mm:ssZ");
          } else if (data.type !== "now" && data.datetype === "weekday") {
            arrDepString += "|" + data.weekday + "|" + moment(tempTime).format("HH:mm");
          }

          self.hasTime = true;
        }

        self.options.estimatedTimeOpts = arrDepString;
        // console.log("estimatedTimeOpts: " + self.options.estimatedTimeOpts);
        $rootScope.$broadcast("RunRoute", self);
      };

      self.hasExpectedArrival = function () {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = self.stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var stop = _step.value;

            if (stop.earliestArrivalTime.hasValue() || stop.latestArrivalTime.hasValue()) {
              return true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return false;
      };

      self.isCalculating = false;
      self.isError = false;
      self.errorMessage = "";
      self.hasStops = function () {
        return self.stops.length > 0;
      };
      self.isValidRoute = function () {
        return self.stops.length > 1;
      };
      self.isSelectedRoute = true;
      self.isOpen = false;

      self.addStop = function (stop) {
        var index = self.getSearchPanelIndex();
        if (!Array.isArray(stop)) {
          stop = [stop];
        }

        if (index === -1) {
          var _self$stops;

          (_self$stops = self.stops).push.apply(_self$stops, _toConsumableArray(stop));
          self.syncStopsToSortableItems(null);
        } else {
          var _self$stops2;

          (_self$stops2 = self.stops).splice.apply(_self$stops2, [index, 0].concat(_toConsumableArray(stop)));
          self.syncStopsToSortableItems(index + stop.length);
        }

        self.updateStopIcons();
        self.isOpen = true;
        $rootScope.$broadcast("RunRoute", self);
      };

      self.deleteStop = function (stop) {
        //self.stops.splice(idx, 1);
        _.remove(self.stops, stop);
        self.syncStopsToSortableItems();

        self.updateStopIcons();
        $rootScope.$broadcast("RunRoute", self);
      };

      self.deleteAllStops = function () {
        self.stops = [];
        self.syncStopsToSortableItems();
      };

      self.clearTotals = function () {
        //if (self.isValidRoute()) {
        //    mapService.removeRoute();
        //}
        self.routeDistance = "";
        self.routeTime = "";
        self.routeDirections = "";
        self.routeTMiles = "";
        self.routeTHours = "";
        self.routeTTolls = "";
        self.routeTCost = "";
      };

      self.updateStopIcons = function () {
        for (var i = 0; i < self.stops.length; i++) {
          var iStyle = "waypoint";
          var iText = i.toString();
          if (i === self.stops.length - 1 && !self.options.hubRouting) {
            iStyle = "destination";
            iText = "";
          }
          if (i === 0) {
            iStyle = "origin";
            iText = "";
          }
          if (i === 0 && self.options.hubRouting) {
            iText = "";
          }

          self.stops[i].Icon = iStyle;
          self.stops[i].IconText = iText;
        }
      };

      self.setOrigStopTimes = function () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = self.stops[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var stop = _step2.value;

            stop.origDuration = stop.duration;
            stop.origEarliestArrivalTime = angular.copy(stop.earliestArrivalTime);
            stop.origLatestArrivalTime = angular.copy(stop.latestArrivalTime);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };

      self.revertStopTimes = function () {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = self.stops[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var stop = _step3.value;

            stop.duration = stop.origDuration;
            stop.earliestArrivalTime = stop.origEarliestArrivalTime;
            stop.latestArrivalTime = stop.origLatestArrivalTime;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      };

      self.optimizeStops = function (results) {
        //Get new ordering of array indices, i.e. [4 2 1 3]
        var newOrdering = _.map(results.Stops, function (stop) {
          return stop.OptimizationInfo.OriginalPosition;
        });
        //console.log("REORDERING LIKE THIS:");
        //console.log(newOrdering);
        var newStops = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = newOrdering[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var newOrderIndex = _step4.value;

            newStops.push(self.stops[newOrderIndex]);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        self.stops = newStops;
        self.syncStopsToSortableItems();
        self.updateStopIcons();
      };
    }

    return RouteItem;
  }]);
})();

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  angular.module("pcmCommon").factory("ArrivalTime", [function () {

    var DATETIME_FORMAT = "HH:mm"; //Used internally by the UI datetime widgets

    //class that represents an arrival time

    var ArrivalTime = function () {
      function ArrivalTime(params) {
        _classCallCheck(this, ArrivalTime);

        //Whether or not to use earliest/latest arrival time
        this.enabled = false;

        //0 = earliest arrival time, 1 = latest
        this.type = params.type;

        //The datetime string representation for the arrival time. Format in: 10:15 AM
        this.arrivalTime = "";

        this.checkboxLabel = params.checkboxLabel;

        this.weekDayTimeLabel = params.weekdayTimeLabel;

        if (params.arrivalTime) {
          this.arrivalTime = params.arrivalTime;
          this.enabled = true;
        } else {
          this.arrivalTime = moment().format(DATETIME_FORMAT);
        }
      }

      _createClass(ArrivalTime, [{
        key: "hasValue",
        value: function hasValue() {
          return this.enabled;
        }
      }, {
        key: "getWsMomentTime",
        value: function getWsMomentTime() {
          if (this.hasValue()) {
            return moment(this.arrivalTime, DATETIME_FORMAT);
          } else {
            if (this.type === 0) {
              return moment().startOf("day");
            } else {
              return moment().endOf("day");
            }
          }
        }
      }, {
        key: "getWsFormattedTime",
        value: function getWsFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }
      }, {
        key: "getUIFormattedTime",
        value: function getUIFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }
      }]);

      return ArrivalTime;
    }();

    return ArrivalTime;
  }]);
})();

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var config = __webpack_require__(1);

(function () {
  var serviceId = "mapService";
  angular.module("alk.maps").factory(serviceId, ["$http", "$window", "$rootScope", "$q", "$compile", "$filter", "_", "alkGeocodeService", "STATES", "ALKMaps", "UserProvider", "alkModalService", "LocationItem", "eventTracker", function mapService($http, $window, $rootScope, $q, $compile, $filter, _, alkGeocodeService, STATES, ALKMaps, userProvider, alkModalService, LocationItem, eventTracker) {
    var maps = [];
    var isIE = false;
    var weatherLegend = document.getElementById("weatherLegend");
    var savedCenters = {};

    function saveCenter(centerInfo, id) {
      savedCenters[id] = centerInfo;
    }

    function getSavedCenter(id) {
      return savedCenters[id];
    }

    if ($window.navigator.userAgent.match(/Trident/)) {
      isIE = true;
    }

    var iconStyle = function iconStyle(externalGraphic) {
      return {
        externalGraphic: ALKMaps._getScriptLocation() + externalGraphic,
        graphicHeight: 26,
        graphicWidth: 26,
        graphicXOffset: -12,
        graphicYOffset: -26
      };
    };

    var startIconStyle = iconStyle("img/flag_start.png");
    var waypointIconStyle = iconStyle("img/flag_stop.png");
    var endIconStyle = iconStyle("img/flag_end.png");

    var isDraggable = true;

    function initializeMap(mapInst, mapId) {
      var ignoreGeolocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


      //TODO: check for existence of mapId
      var mapObj = _.find(maps, {
        id: mapId
      });

      if (mapObj === undefined) {
        mapObj = {};
        mapObj.id = mapId;
        maps.push(mapObj);
      }

      mapObj.savedInfo = {
        mapCenter: null,
        mapZoom: null,
        mapStyle: "default",
        showTraffic: false
      };
      mapObj.routeElements = [];
      mapObj.map = mapInst;
      mapObj.markerLayer = new ALKMaps.Layer.VectorMarkers("Marker Layer", {
        displayInLayerSwitcher: false
      });
      mapObj.trafficLayer = new ALKMaps.Layer.Traffic("ALK LiveTraffic™", {
        displayInLayerSwitcher: false
      }, {
        visibility: false,
        opacity: 0.8
      });
      mapObj.weatherAlertsLayer = new ALKMaps.Layer.WeatherAlerts("ALK LiveWeatherAlert", {
        optionControlVisible: false,
        displayInLayerSwitcher: false,
        visibility: false,
        externalDivForLegend: weatherLegend,
        onErrorCallback: function onErrorCallback(err) {}
      });
      mapObj.weatherCloudLayer = new ALKMaps.Layer.XYZ("ALK LiveWeatherCloud", config.urlWeatherSatellite + ALKMaps.Util.getApiKey(true), {
        displayInLayerSwitcher: false,
        visibility: false,
        opacity: 0.5,
        attribution: ALKMaps.Services.getAttribution({
          className: "ALKMaps.PCMWEBUI.WeatherRadar"
        })
      });

      if (userProvider.getUser().region === "NA") {
        mapObj.weatherRadarLayer = new ALKMaps.Layer.XYZ("ALK LiveWeatherRadar", config.urlWeatherRadar + ALKMaps.Util.getApiKey(true), {
          displayInLayerSwitcher: false,
          visibility: false,
          opacity: 0.5,
          attribution: ALKMaps.Services.getAttribution({
            className: "ALKMaps.PCMWEBUI.WeatherRadar"
          })
        });
      } else {
        mapObj.weatherRadarLayer = new ALKMaps.Layer.WeatherRadarEU("ALK LiveWeatherRadar", {}, {
          optionControlVisible: false,
          displayInLayerSwitcher: false,
          visibility: false,
          onErrorCallback: function onErrorCallback(err) {}
        });
      }

      mapObj.roadSurfaceLayer = new ALKMaps.Layer.RoadSurface("ALK RoadSurface", {
        provider: "RC1"
      }, {
        displayInLayerSwitcher: false,
        visibility: false,
        opacity: 0.5
      });

      mapObj.map.addLayers([mapObj.markerLayer, mapObj.trafficLayer, mapObj.weatherAlertsLayer, mapObj.weatherCloudLayer, mapObj.weatherRadarLayer, mapObj.roadSurfaceLayer]);

      mapObj.navHistoryControl = new ALKMaps.Control.NavigationHistory();
      mapObj.zoomBoxControl = new ALKMaps.Control.ZoomBox({
        autoActivate: false
      });
      mapObj.map.addControls([mapObj.navHistoryControl, mapObj.zoomBoxControl]);

      mapObj.mapStyle = mapObj.savedInfo.mapStyle;

      if ($window.navigator.geolocation && ignoreGeolocation !== true) {
        if (mapObj.savedInfo.mapCenter === null) {
          $window.navigator.geolocation.getCurrentPosition(function (pos) {
            plotCurrentPosition(pos, mapObj.id);
          });
        }
      }

      setMapStyle(mapObj.mapStyle, mapObj.id);
      mapObj.trafficLayer.setVisibility(mapObj.savedInfo.showTraffic);
      mapObj.weatherAlertsLayer.legendControl.header.innerHTML = "<h3 class='title'>Weather Alerts</h3>";
    }

    function releaseMap(mapId) {
      var broadcast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var mapObj = getMapFromId(mapId);

      if (mapObj.map !== null) {
        mapObj.savedInfo.mapCenter = mapObj.map.getCenter();
        mapObj.savedInfo.mapZoom = mapObj.map.getZoom();
        mapObj.savedInfo.mapStyle = mapObj.mapStyle;
      }

      if (broadcast) {
        $rootScope.$broadcast("releaseMap", {
          center: mapObj.map.getCenter(),
          zoom: mapObj.map.getZoom(),
          style: mapObj.mapStyle
        });
      }

      mapObj.map = null;
      mapObj.markerLayer = null;
      mapObj.routeElements = [];
      mapObj.trafficLayer = null;
      mapObj.searchMarker = null;
      mapObj.markerPopup = null;
      mapObj.currentLoc = null;
      mapObj.navHistoryControl = null;
      mapObj.zoomBoxControl = null;
      mapObj.mapStyle = "default";
      mapObj.avoidFavorsLayer = null;
    }

    function restoreCenterZoom(mapId) {
      var mapObj = getMapFromId(mapId);

      if (mapObj.savedInfo.mapCenter !== null && mapObj.savedInfo.mapZoom !== null) {
        mapObj.map.setCenter(mapObj.savedInfo.mapCenter, mapObj.savedInfo.mapZoom);
      }
    }

    function clearSavedCenterZoom(mapId) {
      var mapObj = getMapFromId(mapId);

      if (mapObj) {
        mapObj.savedInfo = {
          mapCenter: null,
          mapZoom: null,
          mapStyle: "default",
          showTraffic: false
        };
      }
    }

    function clearRouteMarkers(routeId, mapId) {
      var mapObj = getMapFromId(mapId);
      var re = getRouteElements(routeId);
      for (var i = 0; i < re.routeMarkers.length; i++) {
        mapObj.markerLayer.removeMarker(re.routeMarkers[i]);
      }

      re.routeMarkers = [];
    }

    function updateRouteMarkers(routeId, routeColor, stops, options, mapId) {
      var mapObj = getMapFromId(mapId);
      clearRouteMarkers(routeId, mapId);

      var re = getRouteElements(routeId);

      for (var i = 0; i < stops.length; i++) {
        var stopData = stops[i].Coords;
        var ll = new ALKMaps.LonLat(stopData.Lon, stopData.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

        //var mStyle = waypointIconStyle;
        var mStyle = {
          externalGraphic: "",
          fontColor: $filter("colorFilter")(routeColor, "lighten", 0.25),
          fontSize: "11",
          fontWeight: "700",
          strokeColor: $filter("colorFilter")(routeColor, "lighten", 0.2),
          pointRadius: 9,
          strokeWidth: 3,
          fillColor: "#FFFFFF",
          label: "",
          labelYOffset: isIE ? -4 : 0
        };
        if (i === stops.length - 1 && !options.hubRouting) {
          //mStyle = endIconStyle;
          mStyle = {
            externalGraphic: "",
            fontColor: "#e25656",
            fontSize: "11",
            fontWeight: "700",
            strokeColor: "#be2525",
            pointRadius: 6.5,
            strokeWidth: 5.5,
            fillColor: "#FFFFFF",
            label: "",
            labelYOffset: isIE ? -4 : 0
          };
        }
        if (i === 0) {
          //mStyle = startIconStyle;
          mStyle = {
            externalGraphic: "",
            fontColor: "#259800",
            fontSize: "11",
            fontWeight: "700",
            strokeColor: "#279E00",
            pointRadius: 6.5,
            strokeWidth: 5.5,
            fillColor: "#FFFFFF",
            label: "",
            labelYOffset: isIE ? -4 : 0
          };
        }

        re.routeMarkers.push(mapObj.markerLayer.createMarker(ll, {
          markerType: "custom"
        }, mStyle));
      }
    }

    function getMap(mapId) {
      var mapObj = getMapFromId(mapId);
      return mapObj.map;
    }

    function getLayer(mapId, layer) {
      var mapObj = getMapFromId(mapId);
      return mapObj[layer];
    }

    function zoomIn(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.map.zoomIn();
    }

    function zoomOut(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.map.zoomOut();
    }

    function boxZoom(active, mapId) {
      var mapObj = getMapFromId(mapId);
      if (active) {
        mapObj.zoomBoxControl.activate();
      } else {
        mapObj.zoomBoxControl.deactivate();
      }
    }

    function currentZoom(mapId) {
      var mapObj = getMapFromId(mapId);
      return mapObj.map.getZoom();
    }

    function goBack(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.navHistoryControl.previousTrigger();
    }

    function goForward(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.navHistoryControl.nextTrigger();
    }

    function historyStack(mapId) {
      var mapObj = getMapFromId(mapId);
      return {
        backCount: mapObj.navHistoryControl.previousStack.length,
        forwardCount: mapObj.navHistoryControl.nextStack.length
      };
    }

    //#region Routing and Reporting Methods
    function cleanupStops(stops, mapId) {
      var mapObj = getMapFromId(mapId);
      var tempStops = [];
      for (var i = 0; i < stops.length; i++) {
        var stopData = stops[i].Coords;
        var ll = new ALKMaps.LonLat(stopData.Lon, stopData.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
        stops[i].smLonLat = ll;
        tempStops.push(ll);
      }
      return tempStops;
    }

    function getStopCosts(stops) {
      var stopCosts = "";
      for (var i = 0; i < stops.length; i++) {
        if (i > 0) {
          stopCosts += "|";
        }
        var durationInHours = stops[i].getDurationInHours();
        if (!durationInHours) {
          durationInHours = 0;
        }
        stopCosts += "0.0," + durationInHours + ",true,true,false";
      }
      return stopCosts;
    }

    function _parseEstimatedTimeOpts(data) {
      if (data == null || data === "" || data.type === "None") {
        return null;
      }

      var eto = {};
      var DayOfWeekEnum = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6
      };

      // ETAETD param
      if (data.type === "now" || data.type === "Depart") {
        eto.ETAETD = 1; // Depart
      } else {
        eto.ETAETD = 0; // Arrival
      }

      // DateOption and DateAndTime param
      if (data.type === "now") {
        eto.DateOption = 0; // Current
        eto.DateAndTime = null;
      } else if (data.datetype === "date") {
        eto.DateOption = 1; // Specific
        eto.DateAndTime = {
          CalendarDate: data.date,
          DayOfWeek: DayOfWeekEnum[data.weekday],
          TimeOfDay: data.time,
          TimeZone: 0
        };
      } else if (data.datetype === "weekday") {
        eto.DateOption = 2; // DayOfWeek
        eto.DateAndTime = {
          CalendarDate: null,
          DayOfWeek: DayOfWeekEnum[data.weekday],
          TimeOfDay: data.time,
          TimeZone: 0
        };
      }

      return eto;
    }

    function getErrorMsg(resp) {
      var error = "";
      try {
        var responseText = JSON.parse(resp.responseText);
        error = responseText[0].Description;
      } catch (e) {
        if (resp.status && resp.statusText) {
          error = resp.status + " " + resp.statusText;
        } else {
          error = "Unknown error";
        }
      }
      return error;
    }

    /*
      For premium customers, if they enable ALK/Custom places layers, there will have a conflict with routing layer.
      Thus, we need to deactivate and then reactivate feature event control for this routing layer and ALK/Custom places layers
      every time addRoute() is called. Otherwise, either you can not drag route, or you can not hover over or click POIs
    */
    function resetFeatureEventControl() {

      var layers = getLayersFromMap(function (s) {
        return s.name.indexOf("PlaceSetLayer") > -1;
      });
      var routingLayers = getLayersFromMap(function (s) {
        return s.name.indexOf("Routing Layer") > -1;
      });
      if (layers && layers.length > 0) {
        removeFeatureEventControl();
        _.forEach(routingLayers, function (r) {
          layers.push(r);
        });
        addFeatureEventControl(layers);
      }
    }

    function addRoute(routeId, routeColor, stops, options, frameRoute, callback, errorCallback, mapId) {
      var re = getRouteElements(routeId, mapId);

      resetFeatureEventControl();
      //clean up stops
      var tempStops = cleanupStops(stops, mapId);
      var stopCosts = getStopCosts(stops);

      updateRouteMarkers(routeId, routeColor, stops, options);
      removeRoute(routeId, mapId);

      var findStop = function findStop(x, y) {
        var findme = null;
        for (var j = 0; j < tempStops.length; j++) {
          var tempStop = tempStops[j];
          if (tempStop.lat === y && tempStop.lon === x || distanceTo(tempStop.lon, tempStop.lat, x, y) <= 0.25) {
            // Todo: Report service does not return the same lat/lons as inputs. If a returned point is within 0.25 meter, we consider it match.
            findme = stops[j];
            //Set lat/lon to unused values to keep identical (favorite) stops from being matched again [PCMW-137].
            tempStops[j].lat = NaN;
            tempStops[j].lon = NaN;
            break;
          }
        }

        return findme;
      };

      var reOrderStops = function reOrderStops(resp) {
        if (options.routeOptimization == null || options.routeOptimization != null && options.routeOptimization === 0) {
          clearRouteMarkers(routeId);
          resp.stops = stops;
          callback(resp);
        } else {
          var stopList = resp.stops;
          var optimizedStops = [];
          for (var k = 0; k < stopList.length; k++) {
            var astop = stopList[k];
            var waypoint = findStop(astop.x, astop.y);
            optimizedStops.push(waypoint);
          }

          resp.stops = optimizedStops;
          clearRouteMarkers(routeId);
          callback(resp);
        }
      };

      var routingError = function routingError(resp) {
        var error = getErrorMsg(resp);
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Routing Error",
          bodyText: error,
          okOnly: true
        }).then(function () {
          $rootScope.$broadcast("FocusSearchField");
        });
        errorCallback(error);
      };

      re.routingLayer.addRoute({
        stops: tempStops,
        stopCosts: stopCosts, // second field is the stop duration, other fields keep it 0.0 or true.
        functionOptions: {
          routeId: routeId,
          callback: reOrderStops,
          failure: routingError,
          frameRoute: frameRoute === undefined ? true : frameRoute,
          style: {
            strokeWidth: 9,
            strokeOpacity: 0.7,
            strokeColor: routeColor
          }
        },
        routeOptions: options
      });
    }

    function addReport(routeId, stops, options, uiArrDepSelection, rptType, callback, errorCallback) {
      var ReportRoutes = {};
      // routeId param
      ReportRoutes.RouteId = routeId;
      // stops param
      if (!options.dataset) {
        options.dataset = userProvider.getUser().dataset;
      }
      ReportRoutes.Stops = populateStops(stops, options);
      //check if thwere are stops
      if (!ReportRoutes.Stops || ReportRoutes.Stops.length < 2) {
        return;
      }
      // route option param
      ReportRoutes.Options = populateRouteOptions(options);
      // report option param
      ReportRoutes.ReportingOptions = populateReportOptions(options, uiArrDepSelection);
      var requestDataVersion = "";
      // for NA region, if it's current dataVersion, use PCM_NA; otherwise, use specific version like PCM30, PCM29
      if (userProvider.getUser().dataset === "PCM_NA") {
        requestDataVersion = options.dataVersion === "current" ? "PCM_NA" : options.dataVersion;
      } else {
        // for OC, EU region, always use PCM_XX for dataVersion for report request
        requestDataVersion = userProvider.getUser().dataset;
      }
      // report type param
      ReportRoutes.ReportTypes = populateReportType(rptType);
      // fuel option param
      ReportRoutes.FuelOptions = null;
      var data = {
        request: { ReportRoutes: [ReportRoutes] },
        dataVersion: requestDataVersion,
        success: callback,
        failure: errorCallback
      };

      var request = {
        method: "POST",
        url: config.pcmwsUrl + "route/routeReports?dataVersion=" + data.dataVersion,
        headers: {
          Authorization: config.reportApiKey[userProvider.getUser().region || "NA"] + "|" + userProvider.getUser().authToken + "|" + new Date().toISOString()
        },
        data: {
          ReportRoutes: [ReportRoutes]
        }
      };
      $http(request).then(function (results) {
        callback(results.data);
      }, function (error) {
        errorCallback(error);
      });
    }
    // Helper Function for addReport
    function populateStops(stopsIn, options) {
      var isEU = options.dataVersion == "PCM_EU";
      var stopsOut = [];

      if (checkHistoricalVersion(options.dataVersion)) {
        _.forEach(stopsIn, function (stop) {

          var temp = {};
          var useLatLon = stop.origLatlon ? true : false; // if user input is latlon
          var hasSPLC = !!(stop && stop.Address && stop.Address.SPLC);
          var hasLatLon = !!(stop && stop.Coords && stop.Coords.Lat && stop.Coords.Lon);
          var hasAddress = stop.Address.StreetAddress !== "" || stop.Address.City !== "" || stop.Address.Country !== "" || stop.Address.County !== "" && stop.Address.County !== null || stop.Address.State !== "" || stop.Address.Zip !== "";
          temp.Coords = angular.copy(stop.Coords);
          temp.Address = angular.copy(stop.Address);
          if (!isEU) {
            // dataVersion is not EU
            temp.Coords = angular.copy(stop.Coords); // always send coords
            if (options.dataset !== "PCM_EU") {
              // SWPWEB-1238, SWPWEB-1334
              if (useLatLon) {
                temp.Address = null; // use only coords even if stop has addr
              } else if (hasSPLC) {
                temp.Address = null;
                temp.Coords = null;
                temp.Address = { SPLC: stop.Address.SPLC };
              } else if (hasLatLon) {
                temp.Address = null;
              } else {
                // !useLatLon && !hasAddress
                temp.Address = angular.copy(stop.Address);
                temp.Coords = null;
                temp.Address.CountryPostalFilter = 2; // To handle both US and Mexico zipcode.
              }
            }

            // EU Region some state return "" while the value is actually in Country.
            // dataset can be EU even if dataversion is not.
            if (options.dataset === "PCM_EU" && temp.Address.State === "") {
              temp.Address.State = temp.Address.Country;
            }
          } else {
            // isEU
            temp.Coords = angular.copy(stop.Coords);
            temp.Address = null;
          }
          temp.PlaceName = null;
          var durationInHours = stop.getDurationInHours();
          if (!durationInHours) {
            durationInHours = 0;
          }
          temp.Costs = {
            CostOfStop: 0.0,
            HoursPerStop: durationInHours,
            Loaded: true,
            OnDuty: true,
            UseOrigin: false
          };

          stopsOut.push(temp);
        });
        return stopsOut;
      } else {
        _.forEach(stopsIn, function (stop) {

          var temp = {};

          var hasSPLC = !!(stop && stop.Address && stop.Address.SPLC);

          if (!isEU) {
            // dataVersion is not EU
            temp.Coords = angular.copy(stop.Coords); // always send coords
            temp.Address = angular.copy(stop.Address);
            if (options.dataset !== "PCM_EU") {

              if (hasSPLC) {
                temp.Address = null;
                temp.Coords = null;
                temp.Address = { SPLC: stop.Address.SPLC };
              } else {
                temp.Address = angular.copy(stop.Address);
                temp.Address.CountryPostalFilter = 2; // To handle both US and Mexico zipcode.
              }
            }

            // EU Region some state return "" while the value is actually in Country.
            // dataset can be EU even if dataversion is not.
            if (options.dataset === "PCM_EU" && temp.Address.State === "") {
              temp.Address.State = temp.Address.Country;
            }
          } else {
            // isEU
            temp.Coords = angular.copy(stop.Coords);
            temp.Address = null;
          }
          temp.PlaceName = null;
          var durationInHours = stop.getDurationInHours();
          if (!durationInHours) {
            durationInHours = 0;
          }
          temp.Costs = {
            CostOfStop: 0.0,
            HoursPerStop: durationInHours,
            Loaded: true,
            OnDuty: true,
            UseOrigin: false
          };

          stopsOut.push(temp);
        });
        return stopsOut;
      }
    }
    // Helper Function for addReport
    function populateRouteOptions(options) {
      var tempRouteOptions = {
        BordersOpen: options.bordersOpen,
        ClassOverrides: options.classOverrides,
        DistanceUnits: options.distanceUnits,
        ElevLimit: options.elevLimit,
        FerryDiscourage: options.ferryDiscourage,
        UseSites: options.useSites,
        GovernorSpeedLimit: options.governorSpeedLimit,
        HazMatType: options.hazMatType,
        HighwayOnly: options.highwayOnly,
        HubRouting: options.hubRouting,
        OverrideRestrict: options.overrideRestrict,
        RouteOptimization: options.routeOptimization,
        RoutingType: options.routingType,
        SideOfStreetAdherence: options.sideOfStreetAdherence,
        TollDiscourage: options.tollDiscourage,
        VehicleType: options.vehicleType
      };
      // convert comma-separated string of ints into array of ints
      if (options.afSetIDs) {
        if (_typeof(options.afSetIDs) === "object") {
          options.afSetIDs = options.afSetIDs.toString();
        }
        tempRouteOptions.AFSetIDs = options.afSetIDs.split(",").map(function (s) {
          return parseInt(s);
        });
      }

      // SWPWEB-961 - If classOverrides is 3(nationalNetwork + fiftyThreeFoot) while report version is PCM18 - 21, set it to 2.
      if (tempRouteOptions.ClassOverrides === 3 && ["PCM18", "PCM19", "PCM20", "PCM21"].indexOf(options.dataVersion) > -1) {
        tempRouteOptions.ClassOverrides = 2;
      }

      // if vehicle type is not Auto, provide truck config
      if (options.vehicleType !== 2) {
        tempRouteOptions.TruckCfg = {
          Axles: options.trkAxles,
          Height: options.trkHeight,
          LCV: options.trkLCV,
          Length: options.trkLength,
          Weight: options.trkWeight,
          Width: options.trkWidth,
          Units: options.trkUnits
        };
      }

      // additional EU Trailer config if any
      if ((options.dataVersion === "PCM_EU" || options.dataset === "PCM_EU") && options.EUOptions && options.EUOptions.hasTrailer) {
        //to-do, pass EU trailer config.
        tempRouteOptions.TrailerCfg = {
          TypeOfTrailer: options.EUOptions.trlType,
          Count: options.EUOptions.trlCount,
          MaxHeight: options.EUOptions.trlMaxHt,
          MaxWeight: options.EUOptions.trlMaxWt,
          MaxAxles: options.EUOptions.trlMaxAxles,
          Engine: {
            Hybrid: options.EUOptions.isHybrid,
            EmissionType: options.EUOptions.emiType,
            MinPollutionVeh: options.EUOptions.minPoll
          }
        };
      }
      return tempRouteOptions;
    }
    // Helper Function for addReport
    function populateReportOptions(options, uiArrDepSelection) {
      var tempReportOptions = {
        UseTraffic: options.useTraffic,
        ExchangeRate: options.ExchangeRate,
        FuelUnits: options.fuelUnits,
        TollCurrency: options.tollCurrency,
        TollDiscount: options.tollPlan,
        UseTollData: options.inclTollData,
        reportFmt: "JSON" // for ALKMaps use only
      };

      // only provide route costs when it's current or PCM_EU dataVersion
      // Note we do not use fuelEconEmpty, costMaintEmpty and costTimeEmpty. Pass 0.0 in request.
      if (options.dataVersion === "current" || options.dataVersion === "PCM_EU") {
        tempReportOptions.RouteCosts = {
          PricePerFuelUnit: options.costPerFuelUnit,
          GreenHouseGas: options.costGHG,
          FuelEconomyLoaded: options.fuelEconLoad,
          FuelEconomyEmpty: 0.0, //options.fuelEconEmpty,
          OtherCostPerDistUnitLoaded: options.costMaintLoad,
          OtherCostPerDistanceUnitEmpty: 0.0, //options.costMaintEmpty,
          CostTimeLoaded: options.costTimeLoad,
          CostTimeEmpty: 0.0 //options.costTimeEmpty
        };
      }

      // EU Emission param
      if (options.dataVersion === "PCM_EU" || options.dataset === "PCM_EU") {
        tempReportOptions.FuelConsumption = options.EUOptions.fuelConsumption;
        tempReportOptions.Refrigerated = options.EUOptions.refrigerated;
        tempReportOptions.FuelType = options.EUOptions.fuelType;
      }

      // add estimatedTimeOpts if there is any
      tempReportOptions.EstimatedTimeOptions = _parseEstimatedTimeOpts(uiArrDepSelection);
      return tempReportOptions;
    }
    // Helper Function for addReport
    function populateReportType(rptType) {
      var tempRptTypeOptions = [];
      if (rptType != null) {
        var rptArray = rptType.split(",");
        _.forEach(rptArray, function (rpt) {
          tempRptTypeOptions.push({
            "__type": rpt + "ReportType:http://pcmiler.alk.com/APIs/v1.0"
          });
        });
      }
      return tempRptTypeOptions;
    }

    function addRoutePromise(routeId, routeColor, stops, options, frameRoute, mapId) {
      var deferred = $q.defer();

      addRoute(routeId, routeColor, stops, options, frameRoute, function (response) {
        deferred.resolve(response);
      }, function (response) {
        deferred.reject(response);
      }, mapId);

      return deferred.promise;
    }

    function addReportPromise(routeId, stops, options, uiArrDepSelection, rptType) {
      var deferred = $q.defer();

      addReport(routeId, stops, options, uiArrDepSelection, rptType, function (response) {
        deferred.resolve(response);
      }, function (response) {
        deferred.reject(getErrorMsg(response));
      });

      return deferred.promise;
    }

    function removePopup(mapId) {
      var mapObj = getMapFromId(mapId);
      //if (mapObj.searchMarker === null) {
      if (mapObj.markerPopup) {
        mapObj.map.removePopup(mapObj.markerPopup);
      }
      //}
    }

    function deleteRoute(routeId, mapId) {
      var mapObj = getMapFromId(mapId);
      var re = _.find(mapObj.routeElements, {
        id: routeId
      });

      if (re !== undefined) {
        re.routingLayer.setDraggable(false);
        removePopup(mapId);
        //re.routingLayer.destroy();
        // https://gis.stackexchange.com/questions/40552/openlayers-error-after-removing-selectfeature-control
        mapObj.map.events.unregister("moveend", re.routingLayer, re.routingLayer._onLayerMove);
        re.routingLayer.removeRoute(routeId);
        mapObj.map.removeLayer(re.routingLayer);
        _.remove(mapObj.routeElements, {
          id: routeId
        });
        resetFeatureEventControl();
        if (re.routeMarkers !== null) {
          for (var mkrIndex = 0; mkrIndex < re.routeMarkers.length; mkrIndex++) {
            mapObj.markerLayer.removeMarker(re.routeMarkers[mkrIndex]);
          }
        }
      }
    }

    function deleteAllRoutes(mapId) {
      var mapObj = getMapFromId(mapId);
      for (var k = mapObj.routeElements.length - 1; k >= 0; k--) {
        var route = mapObj.routeElements[k];
        deleteRoute(route.id, mapId);
      }
    }

    function removeRoute(routeId, mapId) {
      var re = getRouteElements(routeId, mapId);
      removePopup(mapId);
      re.routingLayer.removeRoute(routeId);
      resetFeatureEventControl();
    }

    function showRoute(routeId, mapId) {
      var re = getRouteElements(routeId, mapId);
      //showPopup(re, true);
      removePopup(mapId);
      re.routingLayer.setVisibility(true);
    }

    function hideRoute(routeId, mapId) {
      var re = getRouteElements(routeId, mapId);
      //showPopup(re, false);
      removePopup(mapId);
      re.routingLayer.setVisibility(false);
    }

    function frameRoute(routeId, mapId) {
      var re = getRouteElements(routeId, mapId);
      var mapObj = getMapFromId(mapId);
      mapObj.map.zoomToExtent(re.routingLayer.getDataExtent());
    }

    function activateRoute(routeId, mapId) {
      var mapObj = getMapFromId(mapId);
      removePopup(mapId);
      _.forEach(mapObj.routeElements, function (re) {
        if (re.id === routeId) {
          re.routingLayer.setOpacity(1);
          re.routingLayer.setDraggable(isDraggable);
          //showPopup(re, true);
        } else {
          re.routingLayer.setOpacity(0.6);
          re.routingLayer.setDraggable(false);
          //showPopup(re, false);
        }
      });
    }

    function setRouteHandle(routeId, mapId, stop, handleOptions) {
      var re = getRouteElements(routeId, mapId);
      re.routingLayer.setRouteHandle(routeId, stop, handleOptions);
    }

    function getRouteElements(routeId, mapId) {
      var mapObj = getMapFromId(mapId);
      //get/check for elements
      var re = _.find(mapObj.routeElements, {
        id: routeId
      });
      //create if needed
      if (re === undefined) {
        //create layer
        re = {};
        re.id = routeId;

        re.routingLayer = new ALKMaps.Layer.Routing("Routing Layer " + routeId, {
          isDraggable: isDraggable,
          originURL: "",
          waypointURL: "",
          destinationURL: ""
        });
        mapObj.map.addLayers([re.routingLayer]);
        mapObj.map.raiseLayer(re.routingLayer, -1);

        re.routeMarkers = [];
        re.stops = [];

        re.routingLayer.onRouteModified = function (response) {
          $rootScope.$broadcast("RouteModified", {
            response: response
          });
        };

        re.routingLayer.onErrorRouteModification = function (response) {
          $rootScope.$broadcast("RouteModifiedError", {
            response: response
          });
          re.routingLayer.dragControl.cancel();
        };

        re.routingLayer.dragControl.onStart = function (feature, pixel) {
          // jshint ignore:line
          this.dragStart = true;
          $rootScope.$broadcast("DragStart", {
            feature: feature
          });
        };

        re.routingLayer.dragControl.onDrag = function (feature, pixel) {
          // jshint ignore:line
          this.dragStart = true;
          removePopup(mapId);
        };

        re.routingLayer.dragControl.onComplete = function (feature, pixel) {
          $rootScope.$broadcast("DragEnd", {
            feature: feature
          });
          this.dragComplete(feature, pixel);
        };

        mapObj.routeElements.push(re);
      }

      return re;
    }

    //#endregion

    //#region Markers

    function showPin(resp, pan, controllerScope, mapId, onlyPin) {
      // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
      if (resp && resp.Coords && resp.Coords.Lat && !resp.Coords.Lat.includes(".")) {
        var hasNegative = resp.Coords.Lat.includes("-");
        var indexPosition = hasNegative ? resp.Coords.Lat.length > 9 ? 4 : 3 : resp.Coords.Lat.length > 8 ? 3 : 2;
        resp.Coords.Lat = resp.Coords.Lat.substring(0, indexPosition) + "." + resp.Coords.Lat.substring(indexPosition);
      }
      if (resp && resp.Coords && resp.Coords.Lon && !resp.Coords.Lon.includes(".")) {
        var hasNegative = resp.Coords.Lon.includes("-");
        var indexPosition = hasNegative ? resp.Coords.Lon.length > 9 ? 4 : 3 : resp.Coords.Lon.length > 8 ? 3 : 2;
        resp.Coords.Lon = resp.Coords.Lon.substring(0, indexPosition) + "." + resp.Coords.Lon.substring(indexPosition);
      }
      // Ends Temporary fix
      var mapObj = getMapFromId(mapId);
      var tempStopListObj = {};
      tempStopListObj.lat = resp.Coords.Lat;
      tempStopListObj.lon = resp.Coords.Lon;

      clearSearchMarker(mapId);
      clearPlaceSearchMarker(mapId);

      var cleanLL = new ALKMaps.LonLat(resp.Coords.Lon, resp.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

      mapObj.searchMarker = mapObj.markerLayer.createMarker(cleanLL, {}, {
        externalGraphic: "/img/marker.png",
        graphicHeight: 33,
        graphicWidth: 28,
        graphicXOffset: -14,
        graphicYOffset: -28
      });

      if (mapObj.markerPopup) {
        mapObj.map.removePopup(mapObj.markerPopup);
      }

      if (!onlyPin) {
        var addr;
        if (resp.CityStateZip) {
          addr = resp.CityStateZip;
        } else {
          //for alk sites @bpan @vani
          addr = resp.Address.City + "," + resp.Address.State + resp.Address.Zip;
        }

        if (resp.Address.StreetAddress !== "") {
          addr = "<b>" + resp.Address.StreetAddress + "</b><br>" + addr;
        }

        mapObj.markerPopup = new ALKMaps.Popup.SimplePopup("GeocodingPopup", cleanLL, null, //autosize
        "<div class=\"popup-text\">" + addr + "<div class=\"popup-actions\">" + "    <button id=\"save-fav-btn\" class=\"btn btn-default btn-xs\" ng-disabled=\"!routeVm.canSavePopupFavorite()\" ng-click=\"routeVm.savePopupFavorite();\" title=\"{{(!userInfo.isPremium())?'Premium Only':''}}\" alk-analytics=\"['Map','Popup','Add Favorite']\">" + "        <i class=\"ico ico-star\"></i> Save" + "    </button>" + "    <button id=\"get-directions-btn\" class=\"btn btn-default btn-xs\" ng-click=\"routeVm.addSelectedLocationToRoute()\" alk-analytics=\"['Map','Popup','Add Stop to Route']\">" + "        <i class=\"ico ico-circle-plus\"></i> Add Stop" + "    </button>" + "</div>" + "</div>", new ALKMaps.Pixel(0, 4), //offset
        true, function () {
          clearSearchMarker();
        });

        mapObj.map.addPopup(mapObj.markerPopup);
      }

      if (pan) {
        safePanTo(cleanLL, 16, mapId);
      }

      //hacktastic fix to get Angular to recognize the popup added by ALKMaps
      var e = angular.element("#GeocodingPopup");
      $compile(e)(controllerScope);
    }

    function showPlacePin(location, controllerScope, mapId) {
      var mapObj = getMapFromId(mapId);

      var tempStopListObj = {};
      tempStopListObj.lat = location.Coords.Lat;
      tempStopListObj.lon = location.Coords.Lon;

      clearSearchMarker(mapId);
      clearPlaceSearchMarker(mapId);

      var cleanLL = new ALKMaps.LonLat(location.Coords.Lon, location.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

      var addr = "";
      if (location.Name !== null && location.Name !== undefined && location.Name !== "") {
        addr += "<b>" + location.Name + "</b>";
      }
      if (location.Address.StreetAddress !== null && location.Address.StreetAddress !== undefined && location.Address.StreetAddress !== "") {
        addr += "<br>" + location.Address.StreetAddress;
      }
      if (location.CityStateZip !== null && location.CityStateZip !== undefined && location.CityStateZip !== "") {
        addr += "<br>" + location.CityStateZip;
      }

      mapObj.placeMarkerPopup = new ALKMaps.Popup.SimplePopup("GeocodingPopup", cleanLL, null, //autosize
      "<div class=\"popup-text\">" + addr + "<div class=\"popup-actions\">" + "    <button id=\"save-fav-btn\" class=\"btn btn-default btn-xs\" disabled ng-click=\"routeVm.savePopupFavorite();\" title=\"{{(!userInfo.isPremium())?'Premium Only':''}}\" alk-analytics=\"['Map','Popup','Add Favorite']\">" + "        <i class=\"ico ico-star\"></i> Save" + "    </button>" + "    <button id=\"get-directions-btn\" class=\"btn btn-default btn-xs\" ng-click=\"routeVm.addSelectedLocationToRoute()\" alk-analytics=\"['Map','Popup','Add Stop to Route']\">" + "        <i class=\"ico ico-circle-plus\"></i> Add Stop" + "    </button>" + "</div>" + "</div>", new ALKMaps.Pixel(0, 28), //offset
      true, function () {
        clearPlaceSearchMarker();
      });

      mapObj.map.addPopup(mapObj.placeMarkerPopup);

      //hacktastic fix to get Angular to recognize the popup added by ALKMaps
      var e = angular.element("#GeocodingPopup");
      $compile(e)(controllerScope);
    }

    function showPlaceHoverPopup(location, controllerScope, mapId) {
      var mapObj = getMapFromId(mapId);

      if (location.CityStateZip === null || location.CityStateZip === undefined) {
        if (location.PlaceName !== null && location.PlaceName !== undefined) {
          location = new LocationItem(location, location.PlaceName);
        } else {
          location = new LocationItem(location);
        }
      }

      var tempStopListObj = {};
      tempStopListObj.lat = location.Coords.Lat;
      tempStopListObj.lon = location.Coords.Lon;

      clearSearchMarker(mapId);

      var cleanLL = new ALKMaps.LonLat(location.Coords.Lon, location.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

      var addr = "";
      if (location.Name !== null && location.Name !== undefined && location.Name !== "") {
        addr += "<b>" + location.Name + "</b>";
      }
      if (location.Address.StreetAddress !== null && location.Address.StreetAddress !== undefined && location.Address.StreetAddress !== "") {
        addr += "<br>" + location.Address.StreetAddress;
      }
      if (location.CityStateZip !== null && location.CityStateZip !== undefined && location.CityStateZip !== "") {
        addr += "<br>" + location.CityStateZip;
      }

      if (mapObj.markerPopup) {
        mapObj.map.removePopup(mapObj.markerPopup);
      }

      mapObj.markerPopup = new ALKMaps.Popup.SimplePopup("GeocodingPopup", cleanLL, null, //autosize
      "<div class=\"geocode-popup-text\">" + addr + "</div>", new ALKMaps.Pixel(0, 10), //offset
      true, clearSearchMarker);

      mapObj.map.addPopup(mapObj.markerPopup);

      //hacktastic fix to get Angular to recognize the popup added by ALKMaps
      var e = angular.element("#GeocodingPopup");
      $compile(e)(controllerScope);
    }

    function clearSearchMarker(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;

      if (mapObj.searchMarker) {
        retVal = true;
        mapObj.markerLayer.removeMarker(mapObj.searchMarker);
        mapObj.searchMarker = null;
      }

      if (mapObj.markerPopup) {
        mapObj.map.removePopup(mapObj.markerPopup);
      }

      return retVal;
    }

    function clearPlaceSearchMarker(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      if (mapObj.placeMarkerPopup) {
        mapObj.map.removePopup(mapObj.placeMarkerPopup);
      }
      return retVal;
    };

    function dragStart(feature, stops, mapId) {
      var mapObj = getMapFromId(mapId);
      // var re = _.find(routeElements, { id: routeId });
      var x = feature.geometry.x;
      var y = feature.geometry.y;
      var stop = null;

      for (var index = 0; index < stops.length; index++) {
        var tempStop = stops[index].smLonLat;
        if (tempStop.lat === y && tempStop.lon === x || distanceTo(tempStop.lon, tempStop.lat, x, y) <= 0.25) {
          // Todo: Report service does not return the same lat/lons as inputs. If a returned point is within 0.25 meter, we consider it match.
          stop = stops[index];
          break;
        }
      }

      if (stop != null) {
        if (feature.style != null && (feature.style.graphicTitle === "Origin" || feature.style.graphicTitle === "Destination" || feature.style.graphicTitle === "Waypoint")) {

          clearSearchMarker(mapId);

          //if (feature.popup == null) {
          var address = stop.Address;

          var addressStr = stop.CityStateZip;
          if (address.StreetAddress !== "") {
            addressStr = "<b>" + address.StreetAddress + "</b><br>" + addressStr;
          }
          var newTempStop = tempStop.lat + "," + tempStop.lon;
          // var disableSave = routeController.canSaveRoutePopupFavourite();

          mapObj.markerPopup = new ALKMaps.Popup.SimplePopup("SelectedStopPopup", new ALKMaps.LonLat(feature.geometry.x, feature.geometry.y), null, "<div class=\"popup-text\">" + addressStr + "<div class=\"popup-actions\">" + '    <button id="save-fav-btn" class="btn btn-default btn-xs" ng-style="routeVm.canSaveRoutePopupFavourite()" ng-click="routeVm.saveAndDeleteStopModal(' + tempStop.lat + ',' + tempStop.lon + ',false)" alk-analytics="[Map,Popup,AddFavorite]">' + '        <i class=\"ico ico-star\"></i> Save' + '    </button>' + '<button id="newTempStop" class="btn btn-default btn-xs" ng-click="routeVm.saveAndDeleteStopModal(' + tempStop.lat + ',' + tempStop.lon + ',true)" alk-analytics="[Map,Popup,DeleteStop]">' + '       <i class="ico ico-trash"></i> Delete Stop' + '   </button>' + "</div>" + "</div>", new ALKMaps.Pixel(0, 0), //offset
          true);
          // Don't pan the map, panning map will mess up dragging.
          mapObj.markerPopup.panMapIfOutOfView = false;
          mapObj.map.addPopup(mapObj.markerPopup);

          var e = angular.element("#SelectedStopPopup");
          $compile(e)(angular.element("#route-panel").scope());
        }
      }

      return stop;
    }

    function setDraggable(d) {
      isDraggable = d;
    }
    //#endregion

    //#region Traffic
    function showTrafficLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.trafficLayer.setVisibility(true);
      mapObj.savedInfo.showTraffic = true;
      // when user shows traffic layer, automatically hides road surface layer.
      hideRoadSurfaceLayer(mapId);
    }

    function hideTrafficLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.trafficLayer.setVisibility(false);
      mapObj.savedInfo.showTraffic = false;
    }

    function isTrafficVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      retVal = mapObj.trafficLayer.getVisibility();
      return retVal;
    }
    //#endregion

    //#region sites
    function showALKSitesLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      ALKMaps.SSOToken = "token=" + userProvider.getUser().authToken;
      mapObj.alkSitesLayer = new ALKMaps.Layer.Sites("ALK Sites", {
        minZoomLevel: 15,
        siteType: 1,
        includeSiteGates: true
      });
      mapObj.map.addLayer(mapObj.alkSitesLayer);
    }

    function showCustomSitesLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      ALKMaps.SSOToken = "token=" + userProvider.getUser().authToken;
      mapObj.customSitesLayer = new ALKMaps.Layer.Sites("Custom Sites", {
        minZoomLevel: 15,
        siteType: 2,
        includeSiteGates: true
      });
      mapObj.map.addLayer(mapObj.customSitesLayer);
    }

    function hideALKSitesLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      var siteLayer = _.find(mapObj.map.layers, {
        name: "ALK Sites"
      });
      if (siteLayer) {
        siteLayer.destroy();
      }
    }

    function hideCustomSitesLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      var siteLayer = _.find(mapObj.map.layers, {
        name: "Custom Sites"
      });
      if (siteLayer) {
        siteLayer.destroy();
      }
    }

    function isALKSitesVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      return _.some(mapObj.map.layers, {
        name: "ALK Sites"
      });
    }

    function isCustomSitesVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      return _.some(mapObj.map.layers, {
        name: "Custom Sites"
      });
    }

    function addFeatureEventControl(allLayers, mapId) {
      var mapObj = getMapFromId(mapId);
      var customPlaceSelectCtrl = new ALKMaps.Control.FeatureEvent(allLayers);
      mapObj.map.addControls([customPlaceSelectCtrl]);
      customPlaceSelectCtrl.activate();
    }

    function removeFeatureEventControl(mapId) {
      var mapObj = getMapFromId(mapId);
      var control = _.filter(mapObj.map.controls, function (c) {
        return c.displayClass === "olControlFeatureEvent";
      });
      mapObj.map.removeControl(control[0]);
    }
    //#region

    //#region Weather
    function showWeatherAlertsLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherAlertsLayer.setVisibility(true);
      mapObj.savedInfo.showWeatherAlerts = true;
    }

    function hideWeatherAlertsLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherAlertsLayer.setVisibility(false);
      mapObj.savedInfo.showWeatherAlerts = false;
    }

    function isWeatherAlertsVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      retVal = mapObj.weatherAlertsLayer.getVisibility();
      return retVal;
    }

    function showWeatherCloudLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherCloudLayer.setVisibility(true);
      mapObj.savedInfo.showWeatherCloud = true;
    }

    function hideWeatherCloudLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherCloudLayer.setVisibility(false);
      mapObj.savedInfo.showWeatherCloud = false;
    }

    function isWeatherCloudVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      retVal = mapObj.weatherCloudLayer.getVisibility();
      return retVal;
    }

    function showWeatherRadarLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherRadarLayer.setVisibility(true);
      mapObj.savedInfo.showWeatherRadar = true;
    }

    function hideWeatherRadarLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.weatherRadarLayer.setVisibility(false);
      mapObj.savedInfo.showWeatherRadar = false;
    }

    function isWeatherRadarVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      retVal = mapObj.weatherRadarLayer.getVisibility();
      return retVal;
    }
    //#endregion

    //#region RoadSurface
    function showRoadSurfaceLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.roadSurfaceLayer.setVisibility(true);
      mapObj.savedInfo.showRoadSurface = true;
      // when user shows road surface layer, automatically hides traffic layer.
      hideTrafficLayer(mapId);
    }

    function hideRoadSurfaceLayer(mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.roadSurfaceLayer.setVisibility(false);
      mapObj.savedInfo.showRoadSurface = false;
    }

    function isRoadSurfaceVisible(mapId) {
      var mapObj = getMapFromId(mapId);
      var retVal = false;
      retVal = mapObj.roadSurfaceLayer.getVisibility();
      return retVal;
    }
    //#endregion

    //#region Map Styles
    function setStyle(style, mapId) {
      var mapObj = getMapFromId(mapId);

      if (mapObj.mapStyle !== style) {
        mapObj.mapStyle = style;
        if (style === "satellite_only") {
          mapObj.map.baseLayer.satelliteOnly = true;
          mapObj.map.baseLayer.changeStyle("satellite");
        } else {
          if (mapObj.map.baseLayer.satelliteOnly) {
            delete mapObj.map.baseLayer.satelliteOnly;
          }
          mapObj.map.baseLayer.changeStyle(style);
        }
      }
    }

    function setMapStyle(style, mapId) {
      var mapObj = getMapFromId(mapId);
      mapObj.map.baseLayer.changeStyle(style);
    }

    function getStyle(mapId) {
      var mapObj = getMapFromId(mapId);
      return mapObj.mapStyle;
    }
    //#endregion

    //#region Location Methods
    function getMapCenter(mapId) {
      var mapObj = getMapFromId(mapId);
      return transformFromSphericalMercator(mapObj.map.getCenter());
    }

    function panToLocation(resp, mapId) {
      var mapObj = getMapFromId(mapId);
      var tempStopListObj = {};

      tempStopListObj.lat = resp.Coords.Lat;
      tempStopListObj.lon = resp.Coords.Lon;

      var cleanLL = new ALKMaps.LonLat(resp.Coords.Lon, resp.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());

      safePanTo(cleanLL, 16);
    }

    function safePanTo(lonlat, zoom, mapId) {
      var mapObj = getMapFromId(mapId);
      zoom = zoom || mapObj.map.getZoom();
      if (zoom > 7) {
        mapObj.map.zoomTo(4);
      }
      mapObj.map.panTo(lonlat);
      mapObj.map.zoomTo(zoom);
    }

    function getLocationString(mapId) {
      var mapObj = getMapFromId(mapId);
      if (!mapObj.map) {
        return $q.reject();
      }

      var deferred = $q.defer();

      var latLon = getMapCenter();

      alkGeocodeService.reverseGeocode(latLon, opt).then(function (r) {
        var retVal = "";
        var zoom = mapObj.map.getZoom();

        var resp = r[0];
        mapObj.currentLoc = resp;

        var strCity = resp.Address.City + " > ";
        var strCounty = resp.Address.County != null && resp.Address.County !== "" ? resp.Address.County + " County > " : "";
        var strState = resp.Address.State;
        var strCountry = "";
        var stObj = _.find(STATES, {
          abbreviation: resp.Address.State
        });

        if (stObj) {
          strState = stObj.name + " > ";
          strCountry = stObj.country;
        }
        switch (true) {
          case zoom >= 13:
            retVal = strCity + strCounty + strState + strCountry;
            break;
          case zoom >= 10:
            retVal = strCounty + strState + strCountry;
            break;
          case zoom >= 7:
            retVal = strState + strCountry;
            break;
          case zoom < 7:
            retVal = strCountry;
        }

        deferred.resolve(retVal);
      }).catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function getCurrentLocation(mapId) {
      var mapObj = getMapFromId(mapId);
      return mapObj.currentLoc;
    }
    //#endregion

    //#region Helper Methods
    function transformFromSphericalMercator(lonLat, mapId) {
      var mapObj = getMapFromId(mapId);
      return lonLat.transform(mapObj.map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
    }

    function transformToSphericalMercator(lonLat, mapId) {
      var mapObj = getMapFromId(mapId);
      return lonLat.transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
    }

    function distanceTo(x, y, x1, y1) {
      return Math.sqrt(Math.pow(x - x1, 2) + Math.pow(y - y1, 2));
    }

    function getLayersFromMap(filterArgs, mapId) {
      var mapObj = getMapFromId(mapId);
      return _.filter(mapObj.map.layers, filterArgs); //https://lodash.com/docs/4.17.10#filter
    }
    //#endregion

    //#region Internal Methods
    function plotCurrentPosition(position, mapId) {
      // if user is in NA and logs in to EU account. Use default EU center, not current location and vice versa.
      if (position.coords.longitude > -20 && userProvider.getUser().region === "NA" || position.coords.longitude < -20 && userProvider.getUser().region === "EU") {
        return;
      }
      var mapObj = getMapFromId(mapId);

      if (mapObj.map !== null) {
        var myLonLat = new ALKMaps.LonLat(position.coords.longitude, position.coords.latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.map.getProjectionObject());
        mapObj.map.setCenter(myLonLat, 12);
      }
    }

    function getMapFromId(mapId) {
      //if mapId is undefined, return first
      if (mapId === undefined) {
        return maps[0];
      }
      return _.find(maps, {
        id: mapId
      });
    }
    //#endregion

    // This methd implemented for event tracker, do not use this method to get userInfo
    function getUserCfg(storageKey, key) {
      var userCfg = $window.localStorage.getItem(storageKey);
      if (userCfg != null && userCfg != "undefined") {
        var obj = JSON.parse(userCfg);
        return key ? obj[key] : obj;
      }
    }

    function getLeastVersionIndex(version, version1) {
      var currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3, 5));
      var previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3, 5));
      if (typeof currentVersionNo === "number" && typeof previousVersionNo === "number") {
        return currentVersionNo > previousVersionNo ? 1 : 0;
      } else {
        var versionArray = [currentVersionNo, previousVersionNo];
        var index = versionArray.findIndex(function (val) {
          return typeof val === "number";
        });
        return index;
      }
    }

    function checkHistoricalVersion(version) {
      var versionNo = parseInt(version.substring(3, 5));
      var storageKey = "userCfg" + hashCode(userProvider.getUser().userId, userProvider.getUser().accountId);
      var userCfg = getUserCfg(storageKey, null);
      if (userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
        var leastVersionIndex = getLeastVersionIndex(version, userCfg.Minimum_Data_Version_Used);
        if (leastVersionIndex === 0) {
          userCfg.Minimum_Data_Version_Used = version;
          var val = JSON.stringify(userCfg);
          $window.localStorage.setItem(storageKey, val);
          window.sessionStorage.setItem("Minimum_Data_Version_Used", version);
          eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
            version: version
          });
        }
      } else if (userCfg && !userCfg.hasOwnProperty('Minimum_Data_Version_Used')) {
        userCfg.Minimum_Data_Version_Used = version;
        var val = JSON.stringify(userCfg);
        $window.localStorage.setItem(storageKey, val);
        window.sessionStorage.setItem("Minimum_Data_Version_Used", version);
        eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
          version: version
        });
      }

      return typeof versionNo === "number" && versionNo >= 18 && versionNo <= 27;
    }

    function hashCode(a, b) {
      var num = 3 * a + 7 * b;
      var str = num.toString();
      var hash = 5381;
      for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + c */
      }
      return hash;
    }
    // function checkHistoricalVersion(version) {
    //   const versionNo = parseInt(version.substring(3, 5));
    //   return (typeof (versionNo) === "number" && versionNo >= 18 && versionNo <= 27);
    // Define the functions and properties to reveal.
    var service = {
      getCurrentLocation: getCurrentLocation,
      getMapCenter: getMapCenter,
      initializeMap: initializeMap,
      releaseMap: releaseMap,
      restoreCenterZoom: restoreCenterZoom,
      showPin: showPin,
      showPlacePin: showPlacePin,
      showPlaceHoverPopup: showPlaceHoverPopup,
      panToLocation: panToLocation,
      clearSearchMarker: clearSearchMarker,
      clearPlaceSearchMarker: clearPlaceSearchMarker,
      addRoute: addRoute,
      addRoutePromise: addRoutePromise,
      addReport: addReport,
      addReportPromise: addReportPromise,
      removeRoute: removeRoute,
      transformFromSphericalMercator: transformFromSphericalMercator,
      transformToSphericalMercator: transformToSphericalMercator,
      getLocationString: getLocationString,
      updateRouteMarkers: updateRouteMarkers,
      getStyle: getStyle,
      setStyle: setStyle,
      setMapStyle: setMapStyle,
      showRoute: showRoute,
      hideRoute: hideRoute,
      deleteRoute: deleteRoute,
      deleteAllRoutes: deleteAllRoutes,
      activateRoute: activateRoute,
      setRouteHandle: setRouteHandle,
      zoomIn: zoomIn,
      zoomOut: zoomOut,
      boxZoom: boxZoom,
      currentZoom: currentZoom,
      safePanTo: safePanTo,
      goBack: goBack,
      goForward: goForward,
      historyStack: historyStack,
      showTrafficLayer: showTrafficLayer,
      hideTrafficLayer: hideTrafficLayer,
      isTrafficVisible: isTrafficVisible,
      showALKSitesLayer: showALKSitesLayer,
      hideALKSitesLayer: hideALKSitesLayer,
      isALKSitesVisible: isALKSitesVisible,
      showCustomSitesLayer: showCustomSitesLayer,
      hideCustomSitesLayer: hideCustomSitesLayer,
      isCustomSitesVisible: isCustomSitesVisible,
      showWeatherAlertsLayer: showWeatherAlertsLayer,
      hideWeatherAlertsLayer: hideWeatherAlertsLayer,
      isWeatherAlertsVisible: isWeatherAlertsVisible,
      showWeatherCloudLayer: showWeatherCloudLayer,
      hideWeatherCloudLayer: hideWeatherCloudLayer,
      isWeatherCloudVisible: isWeatherCloudVisible,
      showWeatherRadarLayer: showWeatherRadarLayer,
      hideWeatherRadarLayer: hideWeatherRadarLayer,
      isWeatherRadarVisible: isWeatherRadarVisible,
      showRoadSurfaceLayer: showRoadSurfaceLayer,
      hideRoadSurfaceLayer: hideRoadSurfaceLayer,
      isRoadSurfaceVisible: isRoadSurfaceVisible,
      clearSavedCenterZoom: clearSavedCenterZoom,
      distanceTo: distanceTo,
      getMap: getMap,
      getLayer: getLayer,
      getMapFromId: getMapFromId,
      getRouteElements: getRouteElements,
      dragStart: dragStart,
      setDraggable: setDraggable,
      frameRoute: frameRoute,
      saveCenter: saveCenter,
      getSavedCenter: getSavedCenter,
      addFeatureEventControl: addFeatureEventControl,
      removeFeatureEventControl: removeFeatureEventControl,
      resetFeatureEventControl: resetFeatureEventControl,
      getLayersFromMap: getLayersFromMap,
      checkHistoricalVersion: checkHistoricalVersion
    };

    return service;
  }]);
})();

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var directiveId = "alkmapsMap";
  angular.module("app").directive(directiveId, ["$rootScope", "$location", "ALKMaps", "$window", "mapService", "UserProvider", "Messages", "savedMapInfo", "$timeout", function alkmapsMap($rootScope, $location, ALKMaps, $window, mapService, userProvider, Messages, savedMapInfo, $timeout) {
    function link(scope, element, attrs) {
      ALKMaps.APIKey = scope.apikey || "token=" + userProvider.getUser().authToken;

      scope.mapId = attrs.id || "map";
      scope.divId = scope.mapId + "_map";
      scope.urlSync = attrs.urlSync === "true" || false;
      scope.elementWithFocus = false;
      scope.keyboardControl = null;
      scope.navControl = null;

      scope.map = new ALKMaps.Map(scope.divId, { displayProjection: new ALKMaps.Projection("EPSG:4326") });
      var region = userProvider.getUser().region;
      var dataset = userProvider.getUser().dataset;

      var basemap = new ALKMaps.Layer.BaseMap("BaseMap", {
        region: region,
        dataset: dataset
      }, {
        wrapDateLine: true,
        displayInLayerSwitcher: false
      });

      var errorCount = 0;

      var onTileError = function onTileError(event) {
        errorCount++;
      };

      var onLoadStart = function onLoadStart(event) {
        errorCount = 0;
      };

      var onLoadEnd = function onLoadEnd(event) {

        if (errorCount > 0) {
          errorCount = 0;

          Messages.add("danger", "Please login again.");
          userProvider.clearUser();
          $location.path("/login");
        }
      };

      basemap.events.register("tileerror", basemap, onTileError);
      basemap.events.register("loadstart", basemap, onLoadStart);
      basemap.events.register("loadend", basemap, onLoadEnd);

      scope.map.addLayer(basemap);

      var savedInfo = savedMapInfo.getSavedInfo();

      scope.map.setCenter(savedInfo.mapCenter, savedInfo.mapZoom);

      var c = new ALKMaps.Handler.Click(new ALKMaps.Control(), {
        "click": function click(e) {
          var ll = scope.map.getLonLatFromPixel(e.xy);
          $rootScope.$broadcast("MapClick", ll);

          if (scope.elementWithFocus !== false) {
            scope.elementWithFocus.blur();
          }
        }
      }, {
        "single": true
      });
      c.setMap(scope.map);
      c.activate();

      var onMoveEnd = function onMoveEnd() /* e */{
        $timeout(function () {
          updateUrlCenterParameter();
          $rootScope.$broadcast("MapMove");
        });
      };

      scope.map.events.register("moveend", {}, onMoveEnd);

      //Handle disabling of map keyboard tracking for specific input controls
      for (var i = 0; i < scope.map.controls.length; i++) {
        if (scope.map.controls[i].displayClass === "olControlKeyboardDefaults") {
          scope.keyboardControl = scope.map.controls[i];
        } else if (scope.map.controls[i].displayClass === "olControlNavigation") {
          scope.navControl = scope.map.controls[i];
        }
      }

      scope.$on("MapInputFocus", function (event, message) {
        // jshint ignore:line
        scope.keyboardControl.deactivate();
        scope.elementWithFocus = message;
      });

      scope.$on("MapInputBlur", function () /*event, message */{
        scope.keyboardControl.activate();
        scope.elementWithFocus = false;
      });

      scope.$on("$destroy", function () {
        mapService.releaseMap(scope.mapId, scope.urlSync);

        basemap.events.unregister("tileerror", basemap, onTileError);
        basemap.events.unregister("loadstart", basemap, onLoadStart);
        basemap.events.unregister("loadend", basemap, onLoadEnd);
        scope.map.events.unregister("moveend", {}, onMoveEnd);
        c.deactivate();

        scope.map = null;
      });

      mapService.initializeMap(scope.map, scope.mapId, !savedInfo.couldTryGeolocating);

      updateUrlCenterParameter();

      function updateUrlCenterParameter() {
        if (scope.urlSync && scope.map) {
          savedMapInfo.saveCurrentInfo(scope.map.getCenter(), scope.map.getZoom(), scope.map.style);
          $location.search("center", savedMapInfo.getSavedInfoAsUrl());
        }
      }
    }

    // Usage:
    //
    // Creates:
    //TODO: add attribs for center and zoom
    var directive = {
      link: link,
      restrict: "E",
      scope: {
        apikey: "@"
      },
      template: function template(elem, attrs) {
        var divId = attrs.id || "map";
        divId += "_map";
        return "<div id=\"" + divId + "\" tabindex=\"0\"></div>";
      }
    };

    return directive;
  }]);

  angular.module("app").directive("alkmapsFocus", ["$timeout", "$parse", function alkmapsFocus($timeout, $parse) {
    function link(scope, element, attrs) {
      var model = $parse(attrs.alkmapsFocus);
      scope.$watch(model, function (value) {
        //console.log(value);
        if (value === true) {
          $timeout(function () {
            element[0].focus();
          });
        }
      });
      element.bind("blur", function () {
        //console.log('blur');
        scope.$apply(model.assign(scope, false));
      });
    }

    var directive = {
      link: link,
      //scope: {},
      restrict: "A"
    };

    return directive;
  }]);

  angular.module("app").directive("alkmapsNavigation", ["$rootScope", "mapService", function alkmapsInput($rootScope, mapService) {
    function link(scope, element, attrs) {
      scope.mapId = attrs.mapId;
      scope.zoomIn = function () {
        mapService.zoomIn(scope.mapId);
      };

      scope.zoomOut = function () {
        mapService.zoomOut(scope.mapId);
      };

      scope.boxZoomState = false;
      scope.toggleBoxZoom = function () {
        scope.boxZoomState = !scope.boxZoomState;
        mapService.boxZoom(scope.boxZoomState, scope.mapId);
      };

      scope.backDisabled = true;
      scope.nextDisabled = true;
      scope.goBack = function () {
        mapService.goBack(scope.mapId);
      };
      scope.goForward = function () {
        mapService.goForward(scope.mapId);
      };

      scope.$on("MapMove", function (event, message) {
        // jshint ignore:line
        var historyCount = mapService.historyStack();
        if (historyCount.backCount > 1) {
          scope.backDisabled = false;
        } else {
          scope.backDisabled = true;
        }
        if (historyCount.forwardCount > 0) {
          scope.nextDisabled = false;
        } else {
          scope.nextDisabled = true;
        }
      });
    }

    var template = "<div class=\"map-btns btn-group-vertical\">\n        <button class=\"btn btn-default btn-nofocus map-btn zoom-in-btn\" ng-click=\"zoomIn()\" title=\"Zoom In\">\n          <i class=\"ico ico-plus\"></i>\n        </button>\n        <button class=\"btn btn-default btn-nofocus map-btn zoom-out-btn\" ng-click=\"zoomOut()\" title=\"Zoom Out\">\n          <i class=\"ico ico-minus\"></i>\n        </button>\n        <button class=\"btn btn-default btn-nofocus map-btn zoom-box-btn\" ng-click=\"toggleBoxZoom()\" \n          title=\"{{(boxZoomState)?'Drag to Pan':'Drag to Zoom'}}\">\n          <i class=\"ico\" ng-class=\"(boxZoomState)?'ico-hand':'ico-box'\"></i>\n        </button>\n       <button class=\"btn btn-default btn-nofocus map-btn map-prev-btn\" ng-click=\"goBack()\" ng-disabled=\"backDisabled\" \n        title=\"Previous View\">\n        <i class=\"ico ico-back\"></i>\n       </button>\n       <button class=\"btn btn-default btn-nofocus map-btn map-next-btn\" ng-click=\"goForward()\" ng-disabled=\"nextDisabled\" \n        title=\"Next View\">\n         <i class=\"ico ico-next\"></i>\n       </button>\n       </div>";

    var directive = {
      link: link,
      restrict: "E",
      scope: {},
      template: template
    };

    return directive;
  }]);
})();

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "menuController";
  angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$location", "mapService", "routeService", "$window", "siteService", "userService", "alkModalService", "alkAuthenticationService", "UserProvider", "routingProfile", "$timeout", "eventTracker", "applicationSettingsService", "fcWidgetAsync", function menuController($rootScope, $scope, $location, mapService, routeService, $window, siteService, userService, alkModalService, alkAuthenticationService, userProvider, routingProfile, $timeout, eventTracker, applicationSettingsService, fcWidgetAsync) {

    $scope.isRSCollapsed = true;
    $scope.isOpen = false;
    $scope.placeSets = [];
    $scope.currentPath = $location.path();
    $scope.isPlacesLayerInit = false;
    $scope.initIfNeeded = function () {
      if ($scope.isPlacesLayerInit === false) {
        // SWPWEB-1160: athena sites layer always on
        mapService.showALKSitesLayer();
        siteService.initializeSetLayers();
        $scope.isPlacesLayerInit = true;
      }
    };

    /*
      If user is premium. Initialize set layers first.
      If user does not have a mapLayers saved yet. Create dummy one for them and save.
      Check ALK Places/Custom Places in map layers settings. If true, enable them; else disable them
    */
    $scope.userCfg = applicationSettingsService.getUserCfg(); // get user cfg
    if (userProvider.getUser().isPremium()) {
      $scope.initIfNeeded();
      if ($scope.userCfg.mapLayers === null || $scope.userCfg.mapLayers === undefined) {
        $scope.userCfg.mapLayers = {
          traffic: false,
          weatherRadar: false,
          weatherCloud: false,
          roadSurface: false,
          weatherAlerts: false,
          customPlaces: false
        };
        applicationSettingsService.updateUserCfg($scope.userCfg);
      }
    }

    $scope.toggleTrafficVisibility = function () {
      if (mapService.isTrafficVisible()) {
        mapService.hideTrafficLayer();
        eventTracker.track("Hide Traffic");
        eventTracker.delAttr("Traffic");
      } else {
        mapService.showTrafficLayer();
        eventTracker.track("Show Traffic");
        eventTracker.setAttr("Traffic", true);
      }
    };

    $scope.isTrafficVisible = function () {
      return mapService.isTrafficVisible() ? "selected" : "";
    };

    $scope.toggleWeatherAlertsVisibility = function () {
      if (mapService.isWeatherAlertsVisible()) {
        mapService.hideWeatherAlertsLayer();
      } else {
        mapService.showWeatherAlertsLayer();
      }
      eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService: mapService });
    };

    $scope.isWeatherAlertsVisible = function () {
      return mapService.isWeatherAlertsVisible() ? "selected" : "";
    };

    $scope.toggleWeatherCloudVisibility = function () {
      if (mapService.isWeatherCloudVisible()) {
        mapService.hideWeatherCloudLayer();
      } else {
        mapService.showWeatherCloudLayer();
      }
      eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService: mapService });
    };

    $scope.isWeatherCloudVisible = function () {
      return mapService.isWeatherCloudVisible() ? "selected" : "";
    };

    // Enable/Disable Custom Places. Note to dynamically show and hide POIs and Sites will be controlled by MapMove event
    $scope.toggleCustomPlacesVisibility = function () {
      if (siteService.isCustomPlacesEnabled()) {
        siteService.disableCustomPlaces();
      } else {
        siteService.enableCustomPlaces();
      }
    };

    $scope.customPlacesStyle = function () {
      return siteService.isCustomPlacesEnabled() ? "selected" : "";
    };

    $scope.toggleWeatherRadarVisibility = function () {
      if (mapService.isWeatherRadarVisible()) {
        mapService.hideWeatherRadarLayer();
      } else {
        mapService.showWeatherRadarLayer();
      }
      eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService: mapService });
    };

    $scope.isWeatherRadarVisible = function () {
      return mapService.isWeatherRadarVisible() ? "selected" : "";
    };

    $scope.toggleRoadSurfaceVisibility = function () {
      if (mapService.isRoadSurfaceVisible()) {
        mapService.hideRoadSurfaceLayer();
      } else {
        mapService.showRoadSurfaceLayer();
      }
      eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService: mapService });
    };

    $scope.isPlacesVisible = function () {
      return siteService.isCustomPlacesEnabled();
    };

    $scope.isRoadSurfaceVisible = function () {
      return mapService.isRoadSurfaceVisible() ? "selected" : "";
    };

    $scope.toggleRS = function () {
      $scope.isRSCollapsed = !$scope.isRSCollapsed;
    };

    $scope.closeRS = function () {
      mapService.hideRoadSurfaceLayer();
    };

    $scope.getZoomLevel = function () {
      return mapService.currentZoom();
    };

    $scope.routeCount = function () {
      return routeService.getAllRoutes().length;
    };

    $scope.newRoute = function () {
      $rootScope.$broadcast("NewRoute");
      $rootScope.$broadcast("FocusSearchField");
    };

    $scope.home = function () {
      $location.url("/app");
    };

    $scope.openRoute = function () {
      var openController = ["$scope", "$uibModalInstance", "savedRoutes", "_", function ($scope, $uibModalInstance, savedRoutes, _) {
        $scope.savedRoutes = savedRoutes;
        $scope.selectedRoute = null;

        if (savedRoutes.length > 0) {
          $scope.selectedRoute = savedRoutes[0];
        }

        $scope.selectRoute = function (route) {
          $scope.selectedRoute = route;
        };
        $scope.getSaveRouteLimit = function () {
          return userService.getSaveRouteLimit();
        };

        $scope.deleteRoute = function (route) {
          alkModalService.show({
            size: "sm"
          }, {
            headerText: "Delete Saved Route",
            bodyText: "Are you sure you want to delete this saved route?"
          }).then(function () {
            userService.deleteSavedRoute(route);

            _.remove(savedRoutes, route);
            $rootScope.$broadcast("DeleteSaveRoutes", { deletedRoute: route });
            if (route === $scope.selectedRoute) {
              $scope.selectedRoute = null;
            }
          });
        };

        $scope.ok = function () {
          $uibModalInstance.close($scope.selectedRoute);
          eventTracker.track("Clicks Open Saved Route");
        };
        $scope.close = function () {
          $uibModalInstance.dismiss("cancel");
        };
      }];
      alkModalService.show({
        size: "md",
        templateUrl: "/app/route/openRoute.template.html",
        controller: openController,
        resolve: {
          savedRoutes: function savedRoutes() {
            return userService.getSavedRoutes();
          }
        }
      }).then(function (result) {
        if (result !== null) {
          $rootScope.$broadcast("NewRoute", angular.copy(result));
        }
      });
    };

    $scope.defaultOptions = function () {
      var defaultOptions = routingProfile.getDefaultOptions();

      alkModalService.show({
        size: "lg",
        templateUrl: "/app/route/options.template.html",
        controller: "routeOptionModalController as vm",
        resolve: {
          routeCopy: function routeCopy() {
            return {
              name: "N/A",
              options: angular.copy(defaultOptions)
            };
          },
          optionsUI: function optionsUI() {
            return routeService.getOptionsUI();
          },
          subscriptionLevel: function subscriptionLevel() {
            return userProvider.getUser().subscriptionLevel;
          },
          isDefault: function isDefault() {
            return true;
          }
        }
      }).then(function (result) {
        routingProfile.setDefaultOptions(result.options);
      });
    };

    $scope.isVehiclesVisible = false;

    $scope.toggleVehicles = function () {
      $rootScope.$broadcast("toggleVehicles");
      $scope.isVehiclesVisible = !$scope.isVehiclesVisible;
    };

    $scope.onLogOut = function () {
      var checkRoutes = routeService.checkUnsavedRoutes();
      if (checkRoutes) {
        mapService.clearSavedCenterZoom();
        routeService.deleteAllRoutes();
        eventTracker.track(eventTracker.EVENTS.LOGOUT);
      }
      return checkRoutes;
    };

    $scope.onAppChange = function (product) {
      eventTracker.track(eventTracker.EVENTS.APP_CHANGE, { product: product });
    };

    $scope.logout = function () {
      $scope.onLogOut();
      alkAuthenticationService.logout();
      $location.url("/");
    };

    $scope.goToAccount = function () {
      eventTracker.track("Clicks My Account");
      $location.url("/account");
    };

    $scope.goToApplicationSettings = function () {
      $location.url("/applicationSettings");
    };

    $scope.showHelp = function () {
      eventTracker.track("Clicks Help");

      var newWindow = window.open("http://support.pcmilerweb.com/en/support/home", "help_window", "height=700,width=1200,location=no");
      if (typeof newWindow === "undefined") {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Help Window Blocked",
          bodyText: "Your pop-up blocker is preventing the reports from opening. Please allow pop-ups for this site.",
          okOnly: true
        });
      }
    };

    $scope.hasChatAccess = function () {
      return false;
    };
    $scope.toggleShowChat = function () {};
    fcWidgetAsync.then(function (fcWidget) {
      $scope.hasChatAccess = fcWidget.isInitialized;
      $scope.toggleShowChat = function () {
        if (!fcWidget.isOpen()) {
          var _userProvider$getUser = userProvider.getUser(),
              firstName = _userProvider$getUser.firstName,
              lastName = _userProvider$getUser.lastName,
              userName = _userProvider$getUser.userName,
              account = _userProvider$getUser.account,
              accountType = _userProvider$getUser.accountType,
              subscriptionLevel = _userProvider$getUser.subscriptionLevel,
              promo = _userProvider$getUser.promo;

          fcWidget.user.setProperties({
            firstName: firstName,
            lastName: lastName,
            email: promo ? "TrialWeb@trimble.com" : userName,
            account: account,
            // pchen: (accountType, subscriptionLevel) can be (Trial, Premium), (PCMWeb, Standard), or (PCMWeb, Premium)
            subscription: accountType === "Trial" ? "Trial" : subscriptionLevel
          }).then(function () {
            fcWidget.open();
          });
        } else {
          fcWidget.close();
        }
      };
    });

    $scope.deleteAllRoutes = function () {
      alkModalService.show({
        size: "sm"
      }, {
        headerText: "Delete All Routes",
        bodyText: "Are you sure you want to delete all routes?"
      }).then(function () {
        $rootScope.$broadcast("DeleteAllRoutes");
        $rootScope.$broadcast("FocusSearchField");
      });
    };
    $scope.hasRoutes = routeService.hasRoutes;

    $scope.subscriptionLevel = function () {
      return userProvider.getUser().subscriptionLevel;
    };

    $scope.routingProfileNotAvailable = function () {
      return routingProfile.getDefaultOptions().routingProfileNotAvailable;
    };

    $scope.updateCustomSetLayer = function () {
      siteService.updateCustomSetLayer();
    };
    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
    $rootScope.$on("MapMove", function () {
      $scope.updateCustomSetLayer();
    });
  }]).directive("routeDialogLocation", function () {
    return {
      restrict: "E",
      scope: {
        location: "=location"
      },
      templateUrl: "/app/route/routeDialogLocation.template.html"
    };
  });
})();

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals ALKMaps */
var config = __webpack_require__(1);

(function () {

  angular.module("app").factory("routeService", routeService);

  routeService.$inject = ["$rootScope", "$window", "$sce", "$q", "_", "mapService", "alkModalService", "$filter", "optionsUI", "RouteItem", "LocationItem", "alkGeocodeService", "$http", "UserProvider", "$location", "conversionService", "routingProfile", "$timeout", "stopService", "$document", "eventTracker", "alkAuthenticationService", "applicationSettingsService"];

  function routeService($rootScope, $window, $sce, $q, _, mapService, alkModalService, $filter, optionsUI, RouteItem, LocationItem, alkGeocodeService, $http, userProvider, $location, conversionService, routingProfile, $timeout, stopService, $document, eventTracker, alkAuthenticationService, applicationSettingsService) {
    //Locals

    var mapId = "pcmMap";
    var routes = [];
    var reportWindows = [];
    var selectedRoute = null;
    var isIE = false;
    var nextRouteNumber = 1;
    var routeColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"];
    var uiColors = ["#889EE1", "#DBA47F", "#B98BD0", "#8EB5D3", "#DA86AC", "#A286DE", "#7FCEE1", "#F29E7F"];
    var availableRoutColors = angular.copy(routeColors);
    var availableUiColors = angular.copy(uiColors);

    if ($window.navigator.userAgent.match(/Trident/) || $window.navigator.userAgent.match(/Edge/)) {
      isIE = true;
    }

    var service = {
      isRouteUnique: isRouteUnique,
      selectRoute: selectRoute,
      getSelectedRoute: getSelectedRoute,
      getRoute: getRoute,
      getAllRoutes: getAllRoutes,
      hasRoutes: hasRoutes,
      newRoute: newRoute,
      addStop: addStop,
      deleteRoute: deleteRoute,
      deleteAllRoutes: deleteAllRoutes,
      updateAllRoutesOptions: updateAllRoutesOptions,
      updateAllRoutesAppSettingsOptions: updateAllRoutesAppSettingsOptions,
      getReportWindow: getReportWindow,
      newReportWindow: newReportWindow,
      closeAllReports: closeAllReports,
      loadSessionRoutes: loadSessionRoutes,
      clearSessionRoutes: clearSessionRoutes,
      runRoute: runRoute,
      runAllRoutes: runAllRoutes,
      reloadRoutes: reloadRoutes,
      deleteStop: deleteStop,
      getOptionsUI: getOptionsUI,
      optimizeStopOrderPromise: optimizeStopOrderPromise,
      saveSessionRoute: saveSessionRoute,
      routeModified: routeModified,
      routeModifiedError: routeModifiedError,
      dragStart: dragStart,
      setDraggable: setDraggable,
      checkUnsavedRoutes: checkUnsavedRoutes,
      getDataset: getDataset,
      checkHistoricalVersion: checkHistoricalVersion
    };

    return service;

    /////////////////////

    function incrementAPIRouteCount() {
      if (userProvider.getUser().accountType === "Trial" && userProvider.getUser().remainingRoutes <= 0) {
        $location.url("/account");
        return $q.reject();
      } else {
        var deferred = $q.defer();

        $http.post("/api/UserInfo/IncrementAPIRouteCount").success(function (response) {
          var remainingRoutes = response.RemainingRoutes;
          userProvider.getUser().remainingRoutes = remainingRoutes;
          deferred.resolve();
          eventTracker.setAttr("Routes Remaining (Trial User)", remainingRoutes);
        }).error(deferred.reject);

        return deferred.promise;
      }
    }

    function newRoute(name, stops, options, savedId, uiArrDepSelection, isDuplicatedRoute) {
      // the route is not already open, add it.
      if (routes.length < 8) {
        var defaultOptions = angular.copy(routingProfile.getDefaultOptions());

        //Set highway only for Standard accounts
        if (!(userProvider.getUser().subscriptionLevel === "Premium" || userProvider.getUser().subscriptionLevel === "Trial")) {
          if (defaultOptions !== undefined) {
            defaultOptions.highwayOnly = true;
          }
        }

        var tempRoute = new RouteItem(name, stops, defaultOptions);
        tempRoute.name = angular.isDefined(name) ? name : "Route " + nextRouteNumber++;
        var rc = availableRoutColors.splice(0, 1);
        var uc = availableUiColors.splice(0, 1);
        tempRoute.color = rc[0];
        tempRoute.uicolor = uc[0];

        // if we are opening a saved route, count this route
        if (angular.isDefined(savedId)) {
          tempRoute.hasBeenCounted = true;
          incrementAPIRouteCount();
        } else if (isDuplicatedRoute === true) {
          tempRoute.hasBeenCounted = true;
          incrementAPIRouteCount();
        } else {
          tempRoute.hasBeenCounted = false;
        }

        if (options) {
          angular.extend(tempRoute.options, options);
        }

        if (savedId !== undefined) {
          tempRoute.savedId = savedId;
        }

        if (uiArrDepSelection) {
          angular.extend(tempRoute.uiArrDepSelection, uiArrDepSelection);
        }

        tempRoute.options.name = tempRoute.name;

        // todo: this should check temp route, this will run the route even if the number of stops is 1, should this be if tempRoute.stops.length >= 2?
        if (stops) {
          tempRoute.updateStopIcons();
          runRoute(tempRoute, true);
        }

        routes.push(tempRoute);
        var userCfg = applicationSettingsService.getUserCfg(); // get user cfg
        var least = getLeastVersion(routes);
        if (userCfg && userCfg.Minimum_Data_Version_Used && userCfg.Minimum_Data_Version_Used !== "") {
          var leastVersionIndex = getLeastVersionIndex(least.options.dataVersion, userCfg.Minimum_Data_Version_Used);
          if (leastVersionIndex === 0) {
            userCfg.Minimum_Data_Version_Used = least.options.dataVersion;
            applicationSettingsService.updateUserCfg(userCfg);
            window.sessionStorage.setItem("Minimum_Data_Version_Used", least.options.dataVersion);
            eventTracker.track(eventTracker.EVENTS.LEAST_DATA_VERSION, {
              version: least.options.dataVersion
            });
          }
        }
        selectRoute(tempRoute);
        return tempRoute;
      }
    }

    function getLeastVersion(versions) {
      var filterEmptyDataVersionRoutes = versions.filter(function (route) {
        return route.options.dataVersion && route.options.dataVersion !== "";
      });
      var least = filterEmptyDataVersionRoutes.reduce(function (previous, current) {
        var leastVersionIndex = getLeastVersionIndex(current.options.dataVersion, previous.options.dataVersion);
        if (leastVersionIndex >= 0) {
          return leastVersionIndex === 0 ? current : previous;
        } else {
          return angular.lowercase(current.options.dataVersion) < angular.lowercase(previous.options.dataVersion) ? current : previous;
        }
      });
      return least;
    }

    function getLeastVersionIndex(version, version1) {
      var currentVersionNo = version.length > 5 ? angular.lowercase(version) : parseInt(version.substring(3, 5));
      var previousVersionNo = version1.length > 5 ? angular.lowercase(version1) : parseInt(version1.substring(3, 5));
      if (typeof currentVersionNo === "number" && typeof previousVersionNo === "number") {
        return currentVersionNo > previousVersionNo ? 1 : 0;
      } else {
        var versionArray = [currentVersionNo, previousVersionNo];
        var index = versionArray.findIndex(function (val) {
          return typeof val === "number";
        });
        return index;
      }
    }

    function selectRoute(r) {
      if (r.isSelectedRoute && r.isOpen) {
        r.isOpen = false;
      } else {
        for (var i = 0; i < routes.length; i++) {
          routes[i].isSelectedRoute = false;
          routes[i].isOpen = false;
        }
        r.isSelectedRoute = true;
        r.isOpen = !r.isOpen;
        selectedRoute = r;
        mapService.activateRoute(r.id, mapId);
        $timeout(function () {
          $rootScope.$broadcast("FocusSearchField");
        }, 100);
      }
    }

    function getSelectedRoute() {
      return selectedRoute;
    }

    function getRoute(routeId) {
      return _.find(routes, {
        id: routeId
      });
    }

    function getReportWindow(routeId) {
      var winObj = _.find(reportWindows, {
        id: routeId
      });
      if (typeof winObj !== "undefined") {
        return winObj.window;
      } else {
        return null;
      }
    }

    function getAllRoutes() {
      return routes;
    }

    function hasRoutes() {
      return routes.length > 0;
    }

    function deleteRoute(routeId) {
      var idx = _.findIndex(routes, {
        id: routeId
      });

      if (routes[idx].reportWindow) {
        routes[idx].reportWindow.close();
      }

      var removedRoutes = _.remove(routes, {
        id: routeId
      });
      availableRoutColors.push(removedRoutes[0].color);
      availableUiColors.push(removedRoutes[0].uicolor);
      selectedRoute = null;
      $window.sessionStorage.removeItem("route_" + routeId);
      closeReportWindow(routeId);

      return idx;
    }

    function deleteAllRoutes() {
      clearSessionRoutes();
      closeAllReports();
      availableRoutColors = [];
      availableUiColors = [];
      for (var i = 0; i < routeColors.length; i++) {
        availableRoutColors.push(routeColors[i]);
      }
      for (var j = 0; j < uiColors.length; j++) {
        availableUiColors.push(uiColors[j]);
      }
      routes = [];
      reportWindows = [];
      selectedRoute = null;
    }

    function updateAllRoutesOptions(updatedOptions) {
      if (updatedOptions != null) {
        _.each(routes, function (route) {
          var temp = route.options.estimatedTimeOpts;
          route.options = updatedOptions;
          route.options.estimatedTimeOpts = temp;
        });
      }
    }

    function updateAllRoutesAppSettingsOptions(updatedOptions) {
      if (updatedOptions !== null) {
        for (var i = 0; i < routes.length; i++) {
          routes[i].options.costGHG = updatedOptions.costGHG;
          routes[i].options.costMaintEmpty = updatedOptions.costMaintEmpty;
          routes[i].options.costMaintLoad = updatedOptions.costMaintLoad;
          routes[i].options.costPerFuelUnit = updatedOptions.costPerFuelUnit;
          routes[i].options.costTimeEmpty = updatedOptions.costTimeEmpty;
          routes[i].options.costTimeLoad = updatedOptions.costTimeLoad;
          routes[i].options.fuelEconEmpty = updatedOptions.fuelEconEmpty;
          routes[i].options.fuelEconLoad = updatedOptions.fuelEconLoad;
          routes[i].options.exchangeRate = updatedOptions.exchangeRate;
          routes[i].options.fuelUnits = updatedOptions.fuelUnits;
          routes[i].options.distanceUnits = updatedOptions.distanceUnits;
          routes[i].options.inclTollData = updatedOptions.inclTollData;
          routes[i].options.tollPlan = updatedOptions.tollPlan;
          routes[i].options.tollCurrency = updatedOptions.tollCurrency;
          if (routes[i].options.trkUnits !== updatedOptions.trkUnits) {
            routes[i].options.trkUnits = updatedOptions.trkUnits;
            routes[i].options = applicationSettingsService.changeUnits(routes[i].options);
          }
          if (routes[i].options.trkUnits === 0) {
            if (Array.isArray(routes[i].options.trkLength)) {
              routes[i].options.trkLength = conversionService.feetInchesToString(routes[i].options.trkLength);
              routes[i].options.trkHeight = conversionService.feetInchesToString(routes[i].options.trkHeight);
            }
            if (userProvider.getUser().region === "EU" && Array.isArray(routes[i].options.EUOptions.trlMaxHt)) {
              routes[i].options.EUOptions.trlMaxHt = conversionService.feetInchesToString(routes[i].options.EUOptions.trlMaxHt);
            }
          }
        }
      }
    }

    function newReportWindow(route) {
      var newWindow = window.open("/reports.html?id=" + route.id, "route_window_" + route.id, "height=700,width=1000");
      if (typeof newWindow !== "undefined") {
        newWindow.route = route;
        var thisWin = getReportWindow(route.id);
        if (thisWin) {
          thisWin = newWindow;
        } else {
          reportWindows.push({
            id: route.id,
            window: newWindow
          });
        }
      } else {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Report Window Blocked",
          bodyText: "Your pop-up blocker is preventing the reports from opening. Please allow pop-ups for this site.",
          okOnly: true
        });
      }
    }

    function updateReportWindow(route) {
      $rootScope.$broadcast("UpdateReport", route.id);
    }

    function closeAllReports() {
      for (var i = 0; i < routes.length; i++) {
        closeReportWindow(routes[i].id);
      }
      reportWindows = [];
    }

    function closeReportWindow(routeId) {
      var thisWin = getReportWindow(routeId);
      if (thisWin) {
        thisWin.close();
      }

      _.remove(reportWindows, {
        id: routeId
      });
    }

    function addStop(stop, route) {
      if ((route === undefined || route === null) && selectedRoute === null) {
        route = newRoute();
      } else if (route === undefined) {
        route = selectedRoute;
      }

      // if this route has not been counted toward the api key usage and the first time it calculates a route (which happens when the route gets its second stop), it should use one of it's remaining routes.
      // add the stop to the route after checking this, don't want to calculate a new route if this puts us over the limit
      if (route.hasBeenCounted === false && route.stops.length + 1 === 2) {
        route.hasBeenCounted = true;
        incrementAPIRouteCount();
      }

      route.addStop(stop);
      mapService.resetFeatureEventControl();
    }

    function deleteStop(stop, route) {

      if (route === undefined && selectedRoute === null) {
        route = newRoute();
      } else if (route === undefined) {
        route = selectedRoute;
      }

      route.deleteStop(stop);

      // if the user removes every stop from a route reset this flag
      // todo: consider doing this reset when the number of stops hits 1?
      if (route.stops.length === 0) {
        route.hasBeenCounted = false;
      }
    }

    function saveSessionRoute(route) {
      var sessRoute = {
        savedId: route.savedId,
        name: route.name,
        stops: _.map(route.stops, "ALKObj"),
        options: route.options,
        uiArrDepSelection: route.uiArrDepSelection
      };
      $window.sessionStorage["route_" + route.id] = JSON.stringify(sessRoute);
    }

    function loadSessionRoutes() {
      var createLocItem = function createLocItem(val) {
        if (!val.PlaceName) {
          return new LocationItem(val);
        } else {
          return new LocationItem(val, val.PlaceName);
        }
      };
      var sessRoutes = [];
      for (var i = 0; i < $window.sessionStorage.length; i++) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          var r = {};
          r.sessRoute = JSON.parse($window.sessionStorage.getItem($window.sessionStorage.key(i)));
          r.tempStops = _.map(r.sessRoute.stops, createLocItem);
          sessRoutes.push(r);
        }
      }

      clearSessionRoutes();

      if (sessRoutes.length === 0) {
        newRoute();
      } else {
        for (var index = 0; index < sessRoutes.length; index++) {
          newRoute(sessRoutes[index].sessRoute.name, sessRoutes[index].tempStops, sessRoutes[index].sessRoute.options, sessRoutes[index].sessRoute.savedId, sessRoutes[index].sessRoute.uiArrDepSelection);
        }
      }
    }

    function clearSessionRoutes() {
      for (var i = $window.sessionStorage.length - 1; i >= 0; i--) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          $window.sessionStorage.removeItem($window.sessionStorage.key(i));
        }
      }
    }

    function runRoute(route, frameRoute) {
      if (route === undefined) {
        route = getSelectedRoute();
      }
      if (route.isValidRoute()) {
        route.isCalculating = true;
        $timeout(function () {
          if ($document[0].activeElement) {
            // for IE 11 issue where activeElement is undefined
            $document[0].activeElement.blur();
          }
        });

        //remove cost options if not current version
        // keep the options on the route the same, only modify the copy of the route options.
        var tempOptions = angular.copy(route.options);
        if (route.options.dataVersion !== "current" && route.options.dataVersion !== "PCM_EU") {
          delete tempOptions.costPerFuelUnit;
          delete tempOptions.costGHG;
          delete tempOptions.fuelEconLoad;
          delete tempOptions.fuelEconEmpty;
          delete tempOptions.costMaintLoad;
          delete tempOptions.costMaintEmpty;
          delete tempOptions.costTimeLoad;
          delete tempOptions.costTimeEmpty;
        }

        // remove truckCfg if the vehicle type is auto
        if (route.options.vehicleType === 2) {
          delete tempOptions.trkAxles;
          delete tempOptions.trkHeight;
          delete tempOptions.trkLCV;
          delete tempOptions.trkLength;
          delete tempOptions.trkWeight;
          delete tempOptions.trkWidth;
          delete tempOptions.trkUnits;
        }

        var routePromise = mapService.addRoutePromise(route.id, route.color, route.stops, tempOptions, frameRoute, mapId);
        var reportPromise = mapService.addReportPromise(route.id, route.stops, tempOptions, route.uiArrDepSelection, "Mileage, Directions");

        $q.all([routePromise, reportPromise]).then(function (response) {
          route.isError = false;
          route.errorMessage = "";
          var data = {
            report: response[1],
            routeId: response[0].routeId,
            stops: response[0].stops
          };
          runRouteIsDone(route, data);
        }).catch(function (response) {
          route.isCalculating = false;
          $rootScope.$broadcast("FocusSearchField");
          route.isError = true;
          route.errorMessage = response;
        });
        return routePromise;
      }
    }

    function routeModified(response) {
      var re = getRoute(response.routeId);
      var stopsNeedReverGeocode = [];

      //Duplicate (modifiable) stop list need to handle identical favorites [PCMW-137].
      var tempStops = angular.copy(re.stops);

      for (var sIndex = 0; sIndex < response.stops.length; sIndex++) {
        var stop = response.stops[sIndex];
        var foundLocationItem = false;
        for (var lIndex = 0; lIndex < tempStops.length; lIndex++) {
          var stopData = tempStops[lIndex].Coords;
          var ll = mapService.transformToSphericalMercator(new ALKMaps.LonLat(stopData.Lon, stopData.Lat), mapId);
          if (mapService.distanceTo(ll.lon, ll.lat, stop.x, stop.y) <= 0.25) {
            response.stops[sIndex] = re.stops[lIndex];
            foundLocationItem = true;
            //Set lat/lon to unused values to keep identical (favorite) stops from being matched again [PCMW-137].
            tempStops[lIndex].Coords.Lat = NaN;
            tempStops[lIndex].Coords.Lon = NaN;
            break;
          }
        }
        if (foundLocationItem === false) {
          var aStop = mapService.transformFromSphericalMercator(new ALKMaps.LonLat(stop.x, stop.y), mapId); //new ALKMaps.LonLat(stop.x, stop.y).transform(map.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
          aStop.ll = new ALKMaps.LonLat(stop.x, stop.y);
          stopsNeedReverGeocode.push({
            stop: aStop,
            index: sIndex
          });
        }
      }

      var promises = stopsNeedReverGeocode.map(function (list) {
        var deferred = $q.defer();

        alkGeocodeService.reverseGeocode(list.stop, {
          region: userProvider.getUser().region,
          dataset: userProvider.getUser().dataset
        }).then(function (resp) {
          resp[0].origLatlon = resp[0].Coords.Lat + ", " + resp[0].Coords.Lon;
          var tempLocItem = new LocationItem(resp[0]);
          tempLocItem.smLonLat = list.stop.ll;
          deferred.resolve({
            stop: tempLocItem,
            index: list.index
          });
        });

        return deferred.promise;
      });

      var qAll = $q.all(promises);
      qAll.then(function (results) {
        for (var qIndex = 0; qIndex < results.length; qIndex++) {
          response.stops[results[qIndex].index] = results[qIndex].stop;
        }

        //Copy any saved data such as stop duration or it will be overwritten
        if (re.stops.length === response.stops.length) {
          _.each(response.stops, function (stop, index) {
            stop.copySavedData(re.stops[index]);
          });
        }

        re.stops = response.stops;

        runRoute(re);
        //runRouteIsDone(re, response);
      });
    }

    function routeModifiedError(response) {
      var route = getSelectedRoute();

      route.isError = true;
      route.errorMessage = "Can't drag stop to that location";

      //Re-run old route to reset
      runRoute(route);
    }

    function runRouteIsDone(route, response) {
      route.stops = response.stops;
      route.updateStopIcons();
      route.syncStopsToSortableItems(route.getSearchPanelIndex());
      $timeout(function () {
        route.isCalculating = false;
        $rootScope.$broadcast("FocusSearchField");
      }, 500);

      if (route.uiArrDepSelection.type !== "None") {
        route.hasTime = true;
      }

      for (var i = 0; i < route.stops.length; i++) {
        route.stops[i].Miles = response.report[0].ReportLines[i].LMiles;
        route.stops[i].Cost = response.report[0].ReportLines[i].LCostMile;
        route.stops[i].Hours = response.report[0].ReportLines[i].LHours;
        route.stops[i].Tolls = response.report[0].ReportLines[i].LTolls;

        var arrOrDep = "";
        if (route.uiArrDepSelection.type !== "None") {
          if (i === 0) {
            arrOrDep = "Dep";
          } else {
            arrOrDep = "Arr";
          }
          arrOrDep += " ";
        }

        var etaDateTime = response.report[0].ReportLines[i].EtaEtd;
        var momentEta = moment(etaDateTime, "M/D/YYYY h:mm A", true);
        route.stops[i].displayETA = "";

        if (momentEta.isValid()) {
          var etaDate = momentEta.format("M/D");
          var etaTime = momentEta.format("h:mm A");
          route.stops[i].displayETA = etaDate + "<br/>" + etaTime;
        } else {
          momentEta = moment(etaDateTime, "ddd H:mm A", true);
          if (momentEta.isValid()) {
            route.stops[i].displayETA = momentEta.format("ddd h:mm A");
          }
        }

        if (route.stops[i].displayETA !== "") {
          route.stops[i].displayETA = arrOrDep + route.stops[i].displayETA;
        }

        var fontColor = $filter("colorFilter")(route.color, "lighten", 0.25);
        var fillColor = "#FFFFFF";
        var strokeColor = $filter("colorFilter")(route.color, "lighten", 0.2);
        var strokeWidth = 3;
        var pointRadius = 9;

        if (i === 0) {
          fontColor = "#259800";
          strokeColor = "#279E00";

          if (route.options.hubRouting) {
            route.stops[i].IconText = "H";
          } else {
            strokeWidth = 5.5;
            pointRadius = 6.5;
          }
        } else if (i === route.stops.length - 1 && !route.options.hubRouting) {
          fontColor = "#e25656";
          strokeColor = "#be2525";
          strokeWidth = 5.5;
          pointRadius = 6.5;
        }

        mapService.setRouteHandle(route.id, mapId, i, {
          externalGraphic: "",
          fontColor: fontColor,
          fontSize: "11",
          fontWeight: "700",
          strokeColor: strokeColor,
          pointRadius: pointRadius,
          strokeWidth: strokeWidth,
          fillColor: fillColor,
          label: route.stops[i].IconText,
          labelYOffset: isIE ? -4 : 0
        });
      }

      var l = response.report[0].ReportLines.length - 1;
      route.routeDistance = response.report[0].ReportLines[l].TMiles + " mi.";
      route.routeTMiles = response.report[0].ReportLines[l].TMiles;
      var timeArr = response.report[0].ReportLines[l].THours.split(":");
      var timeStr = "";
      if (parseInt(timeArr[0]) === 0) {
        timeStr = timeArr[1] + " min.";
      } else {
        timeStr = timeArr[0] + " hr. " + timeArr[1] + " min.";
      }
      route.routeTime = timeStr;
      route.routeTHours = response.report[0].ReportLines[l].THours;
      route.routeTTolls = response.report[0].ReportLines[l].TTolls;
      route.routeTCost = response.report[0].ReportLines[l].TCostMile;

      //save to sessionStorage
      saveSessionRoute(route);
      updateReportWindow(route);
    }

    function runAllRoutes() {
      _.each(routes, function (route) {
        runRoute(route, false);
      });

      mapService.restoreCenterZoom(mapId);
    }

    function getOptionsUI() {
      return optionsUI;
    }

    function reloadRoutes() {
      if (routes.length === 0) {
        //if there are no routes check the sessionStorage
        loadSessionRoutes();
      } else {
        runAllRoutes();
      }
    }

    function isRouteUnique(routeName) {
      var lowerCaseViewValue = angular.lowercase(routeName);

      var deferred = $q.defer();

      $http.get(config.daUrl + "trips/-1").success(function (trips) {
        var foundTrip = _.find(trips, function (trip) {
          return angular.lowercase(trip.Name) === lowerCaseViewValue;
        });

        if (foundTrip == null) {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      }).error(function () {
        deferred.reject();
      });

      return deferred.promise;
    }

    /**
     * Function: optimizeStopOrderPromise
     *
     * Parameters:
     * opt - {Number} 0, 1 or 2
     */
    function optimizeStopOrderPromise(opt, route) {
      /*
      var stopsArr = [];
      for(var i = 0; i < route.stops.length; i++) {
        var stop = route.stops[i];
        var wsStop = {
          Location: {
            Coords: stop.Coords,
          },
          OptimizationOptions: {
            TimeWindow: {
              StartTime: stop.earliestArrivalTime.getWsFormattedTime(),
              EndTime: stop.latestArrivalTime.getWsFormattedTime()
            },
            WaitTime: stop.getDurationInSeconds(),
            //If "Keep Destination" option chosen and last stop: make it static. Also, first stop is always static
            IsStatic: (i === 0) || (opt === 2 && i === route.stops.length - 1)
          }
        };
        stopsArr.push(wsStop);
      }
       var req = {
        method: "POST",
        url: config.pcmwsUrl + "route/optimize?region=NA&dataset=PCM_NA",
        headers: {
          Authorization: "68B06901AF7DA34884CE5FB7A202A743"//config.alkmapsApiKey
        },
        data: {
          Route: {
            Name: route.name,
            Stops: stopsArr
          }
        }
      };
       return $http(req).then(function(results) {
        route.optimizeStops(results.data);
        return runRoute(route, true);
      }, function(error) {
        console.log(error);
        //return runRoute(route, true);
      });
      */

      return runRoute(route, true);
    }

    function dragStart(feature) {
      var routeId = feature.attributes.routeId;
      var route = getRoute(routeId);
      if (route != null) {
        return mapService.dragStart(feature, route.stops, mapId);
      }
    }

    function setDraggable(d) {
      mapService.setDraggable(d);
    }

    $rootScope.$on("UserLoggedIn", function (event, message) {
      // jshint ignore:line
      nextRouteNumber = 1;
    });

    function checkUnsavedRoutes() {
      var sessionRoutes = [];
      for (var i = $window.sessionStorage.length - 1; i >= 0; i--) {
        if ($window.sessionStorage.key(i).indexOf("route_") !== -1) {
          sessionRoutes.push(JSON.parse($window.sessionStorage.getItem($window.sessionStorage.key(i))));
        }
      }
      var unsavedroutes = sessionRoutes.find(function (route) {
        return route.savedId === undefined;
      });
      if (!unsavedroutes) {
        return true;
      } else {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Unsaved Routes",
          bodyText: "You have unsaved changes that will be lost if you continue.",
          closeButtonText: "Cancel",
          actionButtonText: "Continue"

        }).then(function () {
          mapService.clearSavedCenterZoom();
          deleteAllRoutes();
          eventTracker.track(eventTracker.EVENTS.LOGOUT);
          alkAuthenticationService.logout().then(function () {
            $window.location.href = "";
          });
        });

        return false;
      }
    }
    function checkHistoricalVersion(version) {
      return mapService.checkHistoricalVersion(version);
    }

    function getDataset() {
      var dataset = userProvider.getUser().dataset;
      var selRoute = this.getSelectedRoute();
      if (selRoute !== null && selRoute.options !== null && selRoute.options.dataVersion !== null) {
        var dataVersion = selRoute.options.dataVersion;
        var isLegacyVersion = this.checkHistoricalVersion(dataVersion);
        if (dataset === "PCM_NA" && isLegacyVersion === true) {
          dataset = dataVersion;
        }
      }
      return dataset;
    }
  }
})();

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  var controllerId = "routeController";

  angular.module("app").controller("routeController", routeController);

  routeController.$inject = ["$scope", "$rootScope", "$window", "$sce", "_", "$filter", "alkGeocodeService", "routeService", "mapService", "userService", "alkModalService", "LocationItem", "UserProvider", "vehicleService", "alkImportService", "$translate", "$q", "routeSyncErrors", "stopService", "routeExceptionsLayerService", "eventTracker", "favoriteLocationsService"];

  function routeController($scope, $rootScope, $window, $sce, _, $filter, alkGeocodeService, routeService, mapService, userService, alkModalService, LocationItem, userProvider, vehicleService, alkImportService, $translate, $q, routeSyncErrors, stopService, routeExceptionsLayerService, eventTracker, favoriteLocationsService) {

    var routeVm = this;
    routeVm.addWarnings = addWarnings;
    routeVm.cancelArrDep = cancelArrDep;
    routeVm.canSaveFavorite = canSaveFavorite;
    routeVm.canSavePopupFavorite = canSavePopupFavorite;
    routeVm.savePopupFavorite = savePopupFavorite;
    routeVm.canSaveRoute = canSaveRoute;
    routeVm.canSaveRoutePopupFavourite = canSaveRoutePopupFavourite;
    routeVm.canSendRoute = false;
    routeVm.changeTraffic = changeTraffic;
    routeVm.clearRoute = clearRoute;
    routeVm.duplicateRoute = duplicateRoute;
    routeVm.deleteRoute = deleteRoute;
    routeVm.deleteStop = deleteStop;
    routeVm.saveAndDeleteStopModal = saveAndDeleteStopModal;
    routeVm.dropdownStatus = {};
    routeVm.frameRoute = frameRoute;
    routeVm.getRoute = function (routeId) {
      return routeService.getRoute(routeId);
    };
    routeVm.getDurationInHHMM = getDurationInHHMM;
    routeVm.hasRoutes = function () {
      return routeService.hasRoutes();
    };
    routeVm.hideRouteSync = hideRouteSync;
    routeVm.isRouteSyncPanelVisible = false;
    routeVm.lightenRouteColor = function (route, num) {
      return $filter("colorFilter")(route.color, "lighten", num);
    };
    routeVm.mapId = "pcmMap";
    routeVm.optimizeStopOrder = optimizeStopOrder;
    routeVm.optionsUI = routeService.getOptionsUI();
    routeVm.routes = routeService.getAllRoutes();
    routeVm.routeCount = routeCount;
    routeVm.newRoute = newRoute;
    routeVm.runRoute = runRoute;
    routeVm.saveFavorite = saveFavorite;
    routeVm.saveRoute = saveRoute;
    routeVm.selectRoute = selectRoute;
    routeVm.showLeastCost = showLeastCost;
    routeVm.showLocation = showLocation;
    routeVm.showImportStops = showImportStops;
    routeVm.showOptions = showOptions;
    routeVm.showReports = showReports;
    routeVm.stopTimeClick = stopTimeClick;
    routeVm.stopTimeCancel = stopTimeCancel;
    routeVm.stopTimeSave = stopTimeSave;
    routeVm.moveSearchPanel = moveSearchPanel;
    routeVm.showRouteSync = showRouteSync;
    routeVm.tempStop = null;
    routeVm.toggleRouteVisibility = toggleRouteVisibility;
    routeVm.uiRoutingOpt = ["Practical", "Shortest", "Fastest"];
    routeVm.uiArrDepOpt = ["None", "Arrive", "Depart At", "Depart By"];
    routeVm.uiTollRoads = ["Use Tolls", "Avoid Tolls"];
    routeVm.shouldAllowRouteSync = shouldAllowRouteSync;
    routeVm.getRouteSyncErrors = getRouteSyncErrors;
    routeVm.isDurationValid = isDurationValid;
    routeVm.canSaveDurations = canSaveDurations;
    routeVm.onSortableUpdate = onSortableUpdate;
    routeVm.region = userProvider.getUser().region;
    routeVm.dataset = userProvider.getUser().dataset;
    routeVm.watchTraffic = watchTraffic;
    routeVm.addSelectedLocationToRoute = addSelectedLocationToRoute;
    routeVm.popupLocation = null;
    routeVm.hasAvoidFavors = hasAvoidFavors;
    routeVm.shouldShowAvoidFavors = shouldShowAvoidFavors;
    init();

    ////////////////

    function init() {
      routeService.reloadRoutes();
      addWarnings();
    }

    /// Route Functions ///

    function canSaveFavorite(loc) {
      return favoriteLocationsService.canSave(loc);
    }

    function hasAvoidFavors() {
      return routeExceptionsLayerService.hasAvoidFavors();
    }

    function shouldShowAvoidFavors() {
      return routeExceptionsLayerService.hasAvoidFavors() && routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    function cancelArrDep($event) {
      //console.log($event);
      angular.element(".arrDepDropdown").dropdown("toggle");
    }

    function canSaveRoute(route) {
      return route.isValidRoute() && userService.canSaveRoute(angular.copy(route.stops), angular.copy(route.options));
    }

    function changeTraffic(route) {
      // do not change it to depart now if check useTraffic SWPWEB-818
      // if (route.options.useTraffic) {
      //   route.uiArrDepSelection.type = "now";
      //   route.uiArrDepSelection.datetype = "now";
      // }
      route.applyArrDep();
    }
    function watchTraffic(route) {
      if (route.uiArrDepSelection.type === "None") {
        route.options.useTraffic = false;
      }
    }

    function clearRoute(route) {
      mapService.removeRoute(route.id, routeVm.mapId);
    }

    function duplicateRoute(route) {
      eventTracker.track("Clicks Duplicate Route");

      if (!route) {
        return;
      }
      var duplicatedRoute = {};
      duplicatedRoute.name = route.name + " - Copy";
      duplicatedRoute.options = angular.copy(route.options);
      duplicatedRoute.stops = angular.copy(route.stops);
      duplicatedRoute.uiArrDepSelection = angular.copy(route.uiArrDepSelection);
      duplicatedRoute.isDuplicatedRoute = true;
      $rootScope.$broadcast("NewRoute", duplicatedRoute);
    }

    function deleteRoute(route) {
      alkModalService.show({
        size: "sm"
      }, {
        headerText: "Delete Route",
        bodyText: "Are you sure you want to delete this route?"
      }).then(function () {
        mapService.deleteRoute(route.id, routeVm.mapId);
        var idx = routeService.deleteRoute(route.id);
        var selectThisRoute = null;
        if (idx <= routeVm.routes.length - 1) {
          selectThisRoute = routeVm.routes[idx];
        } else if (idx > routeVm.routes.length - 1 && routeVm.routes.length > 0) {
          selectThisRoute = routeVm.routes[routeVm.routes.length - 1];
        }

        if (selectThisRoute !== null) {
          setTimeout(function () {
            $scope.$apply(function () {
              routeVm.selectRoute(selectThisRoute);
            });
          }, 500);
        } else {
          newRoute();
        }
      });
    }

    function frameRoute(r) {
      mapService.frameRoute(r.id, routeVm.mapId);
    }

    function optimizeStopOrder(opt, route) {
      if (opt === 1 && route.stops.length >= 3 || opt === 2 && route.stops.length >= 4) {
        var previousOptimization = route.options.routeOptimization;
        route.options.routeOptimization = opt;
        var optimizeStopOrderPromise = routeService.optimizeStopOrderPromise(opt, route);
        optimizeStopOrderPromise.then(function () {
          route.options.routeOptimization = previousOptimization;
        }, function () {
          route.options.routeOptimization = previousOptimization;
        });
      }
    }

    function runRoute(route) {
      routeVm.hideRouteSync();
      if (route === undefined) {
        route = routeService.getSelectedRoute();
      }
      //console.log("Trigger from routeControoler :: runRoute", route);

      if (route.isValidRoute()) {
        routeService.runRoute(route);
      } else {
        mapService.removeRoute(route.id, routeVm.mapId);
        mapService.updateRouteMarkers(route.id, route.color, route.stops, route.options);
        route.clearTotals();
      }
      addWarnings();
    }

    function saveNewRoute(route) {
      var savedRoute = userService.getSavedRoutes();
      if (savedRoute.length >= userService.getSaveRouteLimit()) {
        alkModalService.show({
          size: "sm",
          templateUrl: "/app/route/showLimitError.template.html"
        });
      } else {
        alkModalService.show({
          size: "sm",
          templateUrl: "/app/route/saveRoute.template.html",
          controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
            $scope.route = {};

            $scope.ok = function (isValid) {
              if (!isValid) {
                return;
              }

              $scope.isCheckingRouteName = true;
              $scope.isRouteNameDuplicate = false;

              routeService.isRouteUnique($scope.route.name).then(function () {
                $uibModalInstance.close($scope.route.name);
              }).catch(function () {
                $scope.isRouteNameDuplicate = true;
              }).finally(function () {
                $scope.isCheckingRouteName = false;
              });
            };

            $scope.isFocused = true;

            $scope.close = function () {
              $uibModalInstance.dismiss("cancel");
            };
          }]
        }).then(function (routeName) {
          userService.saveRoute(route.stops, route.options, routeName).then(function (savedRoute) {
            route.savedId = savedRoute.savedId;
            route.name = savedRoute.name;
            userService.getSavedTrip(savedRoute.savedId).then(function (tripResponse) {
              if (tripResponse.length) {
                route.options.routingProfileId = tripResponse[0].Profile.routingProfileId;
                routeService.saveSessionRoute(route);
              }
            });
          });
        });
      }
    }

    function saveRoute(route) {
      if (route.savedId) {
        // display update route modal
        updateRoute(route);
      } else {
        // display save new route modal
        saveNewRoute(route);
      }
    }

    function selectRoute(r) {
      routeVm.hideRouteSync();
      routeService.selectRoute(r);
      if (r.isValidRoute()) {
        routeVm.frameRoute(r);
      }
    }

    function showLeastCost(route) {
      alkModalService.show({
        size: "lg",
        templateUrl: "/app/modal/dialog.template.html",
        controller: "leastCostModalController",
        resolve: {
          data: function data() {
            return {
              route: route //,
              //baseMap: mapService.cloneBaseMap(),
              //trafficLayer: mapService.cloneTrafficLayer()
            };
          }
        }
      }).then(function (result) {
        if (route.options.routingType !== result.routingType || route.options.tollDiscourage !== result.tollDiscourage) {
          route.options.tollDiscourage = result.tollDiscourage;
          route.options.routingType = result.routingType;
          routeVm.runRoute(route);
        }
      });
    }

    function stopTimeClick(route) {
      route.stopTime = true;
      route.setOrigStopTimes();
    }

    function stopTimeCancel(route) {
      route.stopTime = false;
      route.revertStopTimes();
      routeService.runRoute(route);
    }

    function stopTimeSave(route) {
      route.stopTime = false;
      routeService.runRoute(route);
    }

    function toggleRouteVisibility(r) {
      if (r.isVisible) {
        mapService.hideRoute(r.id, routeVm.mapId);
        r.isVisible = false;
      } else {
        mapService.showRoute(r.id, routeVm.mapId);
        r.isVisible = true;
      }
    }

    function updateRoute(_route) {
      alkModalService.show({
        size: "sm",
        templateUrl: "/app/route/updateRoute.template.html",
        controller: ["$scope", "$uibModalInstance", "route", function ($scope, $uibModalInstance, route) {
          $scope.route = {};

          $scope.ok = function () {
            $uibModalInstance.close();
          };

          $scope.route = route;

          $scope.close = function () {
            $uibModalInstance.dismiss("cancel");

            // display popup for saving new route
            saveNewRoute(route);
          };
        }],
        resolve: {
          route: function route() {
            return _route;
          }
        }
      }).then(function () {
        userService.updateRoute(_route).then(function (savedRoute) {
          routeService.saveSessionRoute(savedRoute);
        });
      });
    }

    /// Stop Functions ///

    function deleteStop(stop) {

      routeService.deleteStop(stop);
    }

    function saveAndDeleteStopModal(lat, long, isDelete) {
      var selectedRoute = routeService.getSelectedRoute();
      var currentStop = selectedRoute.stops.filter(function (x) {
        return x.smLonLat.lat == lat && x.smLonLat.lon == long;
      });
      if (currentStop != undefined && currentStop.length) {
        if (isDelete) {
          routeService.deleteStop(currentStop[0]);
        } else {
          routeVm.saveFavorite(currentStop[0]);
        }
      }
    }

    function canSaveRoutePopupFavourite() {

      // var disableFavorite = true;
      // var selectedRoute = routeService.getSelectedRoute();
      // var currentStop = selectedRoute.stops.filter(x=>x.smLonLat.lat==lat && x.smLonLat.lon==long);
      // if(currentStop!=undefined && currentStop.length){
      //   // routeVm.saveFavorite(currentStop[0]);
      //   disableFavorite=favoriteLocationsService.canSave(currentStop[0]);


      // }
      //  return disableFavorite;
      var issave = routeVm.canSaveFavorite(routeVm.popupLocation);
      if (issave) {
        return "";
      } else {
        return "cursor: not-allowed;pointer-events: none;color: #c0c0c0;background-color: #ffffff;";
      }
    }

    function isDurationValid(str) {
      if (!str || stopService.getHoursFromString(str) !== null) {
        return true;
      } else {
        return false;
      }
    }

    function canSaveDurations(route) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = route.stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stop = _step.value;

          if (!isDurationValid(stop.duration)) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    }

    function onSortableUpdate() {
      $rootScope.$broadcast("FocusSearchField");
    }

    function getDurationInHHMM(stop) {
      return stopService.getDurationInHHMM(stop.duration);
    }

    function saveFavorite(loc) {

      alkModalService.show({
        size: "sm",
        templateUrl: "/app/modal/favoriteDialog.template.html",
        controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
          $scope.location = {
            isShared: false
          };

          $scope.ok = function (isValid) {

            if (isValid) {
              $uibModalInstance.close($scope.location);
            }
          };

          $scope.isFocused = true;

          $scope.close = function () {
            $uibModalInstance.dismiss("cancel");
          };
        }]
      }).then(function (location) {
        favoriteLocationsService.saveNew(angular.copy(loc), location.name, location.isShared);
      });
    }

    function showLocation(loc) {
      //$rootScope.$broadcast("ShowLocation", loc);
      mapService.panToLocation(loc, routeVm.mapId);
    }

    //Options for ui-sortable directive (drag/drop stops)
    routeVm.sortableOptions = {
      update: function update() /*e, ui*/{},
      stop: function stop(e, ui) {
        // will find a better way to check if it's the search panel that gets moved.
        if (ui.item[0].innerText.indexOf("Add Stop") === -1) {
          // this callback has the changed model
          var selectedRoute = routeService.getSelectedRoute();
          selectedRoute.syncSortableItemsToStops();
          selectedRoute.updateStopIcons();
          routeVm.runRoute();
        }
      },
      axis: "y",
      items: ".sort-item"
    };

    /// Map Popup Functions ///
    function addSelectedLocationToRoute() {
      $rootScope.$broadcast("AddStop", routeVm.popupLocation);
    }

    function canSavePopupFavorite() {
      return routeVm.canSaveFavorite(routeVm.popupLocation);
    }

    function savePopupFavorite() {

      routeVm.saveFavorite(routeVm.popupLocation);
    }

    /// Search Functions ///
    function moveSearchPanel(index) {
      var selectedRoute = routeService.getSelectedRoute();
      var searchIndex = selectedRoute.getSearchPanelIndex();
      // if search panel is currently below the position to move to.
      if (searchIndex === -1 || searchIndex > index) {
        selectedRoute.syncStopsToSortableItems(index, true);
      } else {
        // if search panel is currently above the position to move to.
        selectedRoute.syncStopsToSortableItems(index - 1, true);
      }
    }

    /// Options Functions ///

    function showOptions(route) {
      alkModalService.show({
        size: "lg",
        templateUrl: "/app/route/options.template.html",
        controller: "routeOptionModalController as vm",
        resolve: {
          routeCopy: function routeCopy() {
            return angular.copy(route);
          },
          optionsUI: function optionsUI() {
            return routeService.getOptionsUI();
          },
          subscriptionLevel: function subscriptionLevel() {
            return userProvider.getUser().subscriptionLevel;
          },
          isDefault: function isDefault() {
            return false;
          }
        }
      }).then(function (result) {
        var orig = angular.copy(route);

        route.options = result.options;
        route.uiArrDepSelection = result.uiArrDepSelection;
        // after modifying the route, get a copy of it to determine if was changed.
        var copy = angular.copy(route);

        // after the copy is taken, we can set the name since name changes won't affect if the route should be re-run
        route.name = result.name;

        if (angular.equals(copy, orig) !== true) {
          route.applyArrDep();
        }
      });
    }

    /// Report Functions ///

    function showReports(route) {
      var thisWin = routeService.getReportWindow(route.id);
      if (thisWin === null || thisWin.closed) {
        routeService.newReportWindow(route);
      } else {
        thisWin.focus();
      }
      eventTracker.track("Reports");
    }

    /// RouteSync Functions ///

    function shouldAllowRouteSync() {
      return routeSyncErrors.areRouteOptionsValid(routeService.getSelectedRoute());
    }

    function getRouteSyncErrors() {
      return routeSyncErrors.getErrorsFromRouteOptions(routeService.getSelectedRoute());
    }

    function showRouteSync() {
      if (shouldAllowRouteSync()) {
        routeVm.isRouteSyncPanelVisible = true;
      }
    }

    function hideRouteSync() {
      routeVm.isRouteSyncPanelVisible = false;
      $rootScope.$broadcast("routeSyncHidden");
    }

    function routeCount() {
      return routeService.getAllRoutes().length;
    }

    function newRoute() {
      $rootScope.$broadcast("NewRoute");
      $rootScope.$broadcast("FocusSearchField");
      hideRouteSync();
    }

    function addWarnings() {
      routeVm.routes.forEach(function (route) {
        var addtion = 0;
        route.warnings = [];
        mapService.addReport(route.id, route.stops, route.options, route.uiArrDepSelection, "Directions", function (response) {
          response[0].ReportLegs.forEach(function (leg, index) {
            var warningText = [];
            var warningFinal = [];
            var warning = false;
            leg.ReportLines.forEach(function (line) {
              // combine all warnings per leg
              if (line.Direction && line.Direction.includes("Warning - ")) {
                warning = true;
                warningText = line.Direction.replace("Warning - ", "");
                warningText = warningText.split(";");

                var temp = [];
                warningText.forEach(function (text) {
                  temp = text.split(":");
                  temp[0] = temp[0].trim();
                  warningText.push(temp[0]);
                });
                warningText.splice(0, warningText.length / 2);
                warningFinal = _.union(warningFinal, warningText);
              }
            });
            warningFinal = warningFinal.join(", ");
            warningFinal = "Warning: " + warningFinal;
            if (warning) {
              addtion++;
              var i = index + addtion;
              route.warnings.push({
                type: "warning",
                index: i,
                legIndex: index,
                text: warningFinal
              });
            }
          });
        }, function (err) {});
      });
    }

    /// Import Functions ///

    //Launches the 3-modal popup
    function showImportStops() {

      var oldBrowser = alkImportService.browserImportIncompatible();

      var firstModal = {
        modalOptions: {
          size: "sm",
          template: __webpack_require__(144),
          controller: "importModalController",

          controllerAs: "vm",
          backdrop: oldBrowser ? true : "static"

        },
        onModalSuccess: function onModalSuccess() {
          alkModalService.openNextModal();
        }
      };

      var secondModal = {
        modalOptions: {
          size: "md",
          template: __webpack_require__(145),
          controller: "importFieldsModalController",
          resolve: {
            data: function data() {
              var route = routeService.getSelectedRoute();

              return {
                checkHistoricalVersion: routeService.checkHistoricalVersion(route.options.dataVersion)
                //baseMap: mapService.cloneBaseMap(),
                //trafficLayer: mapService.cloneTrafficLayer()
              };
            }
          },
          controllerAs: "vm",
          backdrop: "static"
        },
        onModalSuccess: function onModalSuccess(res) {
          //Back clicked
          if (res.back) {
            alkModalService.openPrevModal();
            return;
          } else if (res.wasGeocoded) {
            //Call third modal
            alkModalService.openNextModal();
          } else {
            //Code that runs after import completes
          }
        }
      };

      var thirdModal = {
        modalOptions: {
          size: "lg",
          template: __webpack_require__(146),
          controller: "importAddressModalController",
          controllerAs: "vm",
          backdrop: "static"

        },
        onModalSuccess: function onModalSuccess(res) {
          //Call fourth modal
          if (res.back) {
            alkModalService.openPrevModal();
          } else {
            alkModalService.openNextModal();
          }
        }
      };

      var fourthModal = {
        modalOptions: {
          size: "sm",
          template: __webpack_require__(147),
          controller: "importDetailsModalController",
          controllerAs: "vm",
          backdrop: "static"
        },
        onModalSuccess: function onModalSuccess(res) {
          //Back clicked
          if (res.back) {
            alkModalService.openPrevModal();
          } else {
            //Code that runs after import completes
          }
        }
      };
      var wizardData = {
        importFeatureType: "PCMWebUIStops",
        importFunction: importStops, //Callback for import function
        onShowMap: function onShowMap(result) {
          //Callback that happens when "Show Map" button clicked on geocode results modal popup
          //result will have a Coords object with Lat/Lon
          mapService.showPin(result, true, $scope, routeVm.mapId, true);
        },
        onShowList: function onShowList() {
          //Callback that happens when "Show List" button clicked on geocode results modal popup (after clicking "Show Map")
          //Delete the marker/popup created if there was one
          mapService.clearSearchMarker(routeVm.mapId);
        },
        callback: function callback(result) {
          //Runs after the import is done and wizard is closed.
        }
      };

      alkModalService.initiateModalWizard([firstModal, secondModal, thirdModal, fourthModal], wizardData);
    }

    //importRows will be popuplated with an array of objects whose keys match the import field object's name properties set (see alkImportService.js)
    //i.e. StopName, StreetAddress, City, State, Zip, Country, EstimatedDuration, EarliestArrivalTime, LatestArrivalTime.
    //importType returns 0 for append, 1 for replace, in function above
    function importStops(importRows, importType) {

      var promises = [];
      var tempStops = [];

      //Replace stops - delete them all first
      if (importType === 1) {
        var route = routeService.getSelectedRoute();
        route.deleteAllStops();
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = importRows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var importRow = _step2.value;


          var address = {
            StreetAddress: importRow.StreetAddress ? importRow.StreetAddress : "",
            City: importRow.City ? importRow.City : "",
            State: importRow.State ? importRow.State : "",
            Zip: importRow.Zip ? importRow.Zip : "",
            County: importRow.County ? importRow.County : "",
            Country: importRow.Country ? importRow.Country : ""
          };
          var coords = {
            Lat: String(importRow.Latitude),
            Lon: String(importRow.Longitude)
          };

          var importName = importRow.StopName ? importRow.StopName : "";

          var stop = new LocationItem({
            Address: address,
            Coords: coords,
            PlaceName: importName,
            duration: importRow.EstimatedDuration,
            earliestArrivalTime: importRow.EarliestArrivalTime,
            latestArrivalTime: importRow.LatestArrivalTime
          }, importName);
          stop.origLatlon = false; // SWPWEB-1334, use addr only
          tempStops.push(stop);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      routeService.addStop(tempStops, routeService.getSelectedRoute());

      //Must return a promise for the import modal service callback, even if not asynchronous
      return $q.all(promises);
    }

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
    $scope.$on("DeleteAllRoutes", function () {
      mapService.deleteAllRoutes(routeVm.mapId);
      routeService.deleteAllRoutes();
      routeVm.routes = routeService.getAllRoutes();
    });
    $scope.$on("AddStop", function (event, message) {
      var selectedRoute = routeService.getSelectedRoute();

      function addStop(stop, isRouteDraggable) {
        routeService.setDraggable(isRouteDraggable);
        routeService.addStop(stop, selectedRoute);

        var hadMarker = mapService.clearSearchMarker(routeVm.mapId);
        mapService.clearPlaceSearchMarker(routeVm.mapId);
        //show stops that are outside of viewport
        if (!hadMarker && selectedRoute !== null && selectedRoute.stops.length === 1) {
          routeVm.showLocation(stop);
        }
      }

      if (!userProvider.getUser().isPremium()) {
        if (selectedRoute !== null && selectedRoute.stops.length >= 10) {

          alkModalService.show({
            size: "sm",
            backdrop: true
          }, {
            headerText: "Maximum Stops Reached",
            bodyText: "You need a Premium Subscription to add more than 10 stops to a route.",
            okOnly: true
          }).then(function (result) {});

          eventTracker.track("Maximum Stops Reached");

          mapService.clearSearchMarker(routeVm.mapId);
          return;
        }

        // If the passed in stop doesn't have a street address, there is no need to perform another geocode.
        if (!message.Address.StreetAddress) {
          addStop(message, false);
        } else {
          var dataset = routeService.getDataset();
          //convert full location to ZIP based
          //geocode
          var geoOpt = {
            listSize: 1,
            region: routeVm.region,
            dataset: dataset
          };
          alkGeocodeService.geocode({
            city: message.Address.City,
            state: message.Address.State,
            zip: message.Address.Zip
          }, geoOpt).then(function (r) {
            //add stop
            var newLoc = new LocationItem(r[0]);
            addStop(newLoc, false);
          }).catch(function (err) {
            console.log("Error");
          });
        }
      } else {
        addStop(message, true);
      }
    });

    $scope.$on("MapClick", function (event, message) {
      // jshint ignore:line
      routeVm.popupLocation = null;
      var dataset = routeService.getDataset();
      var transformedLonLat = mapService.transformFromSphericalMercator(message, routeVm.mapId);
      alkGeocodeService.reverseGeocode(transformedLonLat, { dataset: dataset, region: routeVm.region }).then(function (r) {
        // store coords from map event if user clicks on map, SWPWEB-1302
        r[0].origLatlon = transformedLonLat.lat + ", " + transformedLonLat.lon;
        var newLoc = new LocationItem(r[0]);
        // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
        if (newLoc && newLoc.Coords && newLoc.Coords.Lat && !newLoc.Coords.Lat.includes(".")) {
          var hasNegative = newLoc.Coords.Lat.includes("-");
          var indexPosition = hasNegative ? newLoc.Coords.Lat.length > 9 ? 4 : 3 : newLoc.Coords.Lat.length > 8 ? 3 : 2;
          newLoc.Coords.Lat = newLoc.Coords.Lat.substring(0, indexPosition) + "." + newLoc.Coords.Lat.substring(indexPosition);
        }
        if (newLoc && newLoc.Coords && newLoc.Coords.Lon && !newLoc.Coords.Lon.includes(".")) {
          var hasNegative = newLoc.Coords.Lon.includes("-");
          var indexPosition = hasNegative ? newLoc.Coords.Lon.length > 9 ? 4 : 3 : newLoc.Coords.Lon.length > 8 ? 3 : 2;
          newLoc.Coords.Lon = newLoc.Coords.Lon.substring(0, indexPosition) + "." + newLoc.Coords.Lon.substring(indexPosition);
        }
        // Ends Temporary fix
        routeVm.popupLocation = newLoc;
        mapService.showPin(newLoc, false, $scope, routeVm.mapId);
      });
    });

    $scope.$on("MapPlaceClick", function (event, message) {
      // jshint ignore:line
      routeVm.popupLocation = message;
      mapService.showPlacePin(message, $scope, routeVm.mapId);
    });

    $scope.$on("MapPlaceHover", function (event, message) {
      mapService.showPlaceHoverPopup(message, $scope, routeVm.mapId);
    });

    $scope.$on("MapPlaceHoverOut", function (event, message) {
      mapService.clearSearchMarker(routeVm.mapId);
    });

    $scope.$on("ShowPin", function (event, message) {
      routeVm.popupLocation = message.location;
      mapService.showPin(message.location, message.pan, $scope, message.mapId);
    });

    $scope.$on("SaveFavorite", function (event, message) {
      // jshint ignore:line
      routeVm.saveFavorite(message);
    });

    $scope.$on("RemoveSortableItem", function (event, index) {
      routeService.getSelectedRoute().removeSortableItem(index);
    });

    $scope.$on("NewRoute", function (event, message) {
      if (message) {
        routeService.newRoute(message.name, message.stops, message.options, message.savedId, message.uiArrDepSelection, message.isDuplicatedRoute);
      } else {
        routeService.newRoute();
      }
    });

    $scope.$on("RunRoute", function () {
      routeVm.runRoute();
    });

    $scope.$on("$destroy", function () {
      routeService.closeAllReports();
    });

    $window.onbeforeunload = function () {
      routeService.closeAllReports();
    };

    $scope.$on("RouteModified", function (event, message) {
      routeService.routeModified(message.response);
    });

    $scope.$on("RouteModifiedError", function (event, message) {
      routeService.routeModifiedError(message.response);
      $scope.$apply();
    });

    $scope.$on("DragStart", function (event, message) {
      var s = routeService.dragStart(message.feature);

      if (s !== null) {
        s.origLatlon = s.Coords.Lat + ", " + s.Coords.Lon;
        routeVm.tempStop = s;
      }
    });

    $scope.$on("DragEnd", function (event, message) {
      var selectedRoute = routeService.getSelectedRoute();
      selectedRoute.isCalculating = true;
      $scope.$apply();
      addWarnings();
    });

    $scope.$on("DeleteSaveRoutes", function (event, opt) {
      routeVm.routes.forEach(function (param) {
        if (param.savedId === opt.deletedRoute.savedId) {
          param.savedId = null;
        }
      });
    });
  }
})();

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "<!--This error message gets shown if the user's browser doesn't support file upload-->\n<div ng-show=\"vm.oldBrowser\">\n  <div style=\"padding:10px\">{{ \"common.unsupportedBrowserFeature\" | translate }}</div>\n  <div class=\"modal-footer\">\n    <button class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">{{ \"common.OK\" | translate }}</button>\n  </div>\n</div>\n\n<!--The main import form-->\n<form id=\"importForm\" name=\"importForm\" ng-show=\"!vm.oldBrowser\" novalidate>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{ vm.importModalTitle }}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <fieldset class=\"panel panel-popup\" ng-disabled=\"vm.submitted\">\n      <div class=\"form-group\">\n\n        <div class=\"form-group\" id=\"importFileSection\">\n          <label translate=\"common.File\"></label><br/>\n          <button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.clickUpload()\" translate=\"common.import.chooseFile\"\n            ng-keydown=\"vm.keydownOnFileInput($event)\"></button>\n          <label id=\"importFileName\" class=\"wrap-break-word\">{{ vm.getFileMessage() }}</label>\n          <input ng-if=\"!vm.isExceptionsImport\" type=\"file\" id=\"importSetFileInput\" style=\"display: none\" name=\"importSetFileInput\" accept=\".csv\">\n          <input ng-if=\"vm.isExceptionsImport\" type=\"file\" id=\"importSetFileInput\" style=\"display: none\" name=\"importSetFileInput\" accept=\".dat\">\n        </div>\n        <div id=\"dragDropFileDiv\" ng-class=\"{'dragDropFileDivHover': vm.fileUploadHover}\">\n          <span>{{ \"common.import.dropFile\" | translate }}</span>\n        </div>\n        <div class=\"form-group\" ng-if=\"!vm.isExceptionsImport\">\n          <label>{{ \"common.import.fieldSeparator\" | translate }}</label><br/>\n          <select style=\"width:50%\" ng-model=\"vm.delimiter\" ng-change=\"vm.processFileLogic(vm.file)\">\n            <option value=\"AutoDetect\">{{ \"common.import.autoDetectDelimiter\" | translate }}</option>\n            <option value=\"Comma\">{{ \"common.import.commaDelimLabel\" | translate }}</option>\n            <option value=\"Tab\">{{ \"common.import.tabDelimLabel\" | translate }}</option>\n            <option value=\"Pipe\">{{ \"common.import.pipeDelimLabel\" | translate }}</option>\n          </select>\n          <label ng-if=\"vm.showDetectedDelimiter()\">{{ vm.getDetectedDelimiter() }}</label><br/>\n        </div>\n    </fieldset>\n    </div>\n    <div class=\"modal-footer\">\n      <div class=\"import-errors alert alert-sm alert-danger text-left\" ng-show=\"vm.errors.length > 0\">\n        <p ng-repeat=\"error in vm.getDisplayErrors()\">{{error}}</p>\n      </div>\n      <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">{{ \"common.Cancel\" | translate }}</button>\n      <button class=\"btn btn-sm btn-success pull-right\" ng-click=\"vm.submit()\" ng-disabled=\"!vm.canSubmit()\" tabindex=\"0\">\n        <span ng-if=\"!vm.submitted\">{{ vm.submitButtonText }}</span>\n        <span ng-if=\"vm.submitted\" class=\"ico ico-circle-notch ico-spin\"></span>\n        <span ng-if=\"vm.submitted\" translate=\"common.import.importing\"></span>\n      </button>\n    </div>\n</form>\n";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "<form name=\"importForm\" class=\"importFieldsForm\" novalidate>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{ \"common.import.selectFields\" | translate }}</h4>\n  </div>\n  <div class=\"importScrollWrapper\">\n    <div class=\"modal-body\">\n      <fieldset id=\"fieldSetId\" class=\"panel panel-popup\" ng-disabled=\"vm.submitted\">\n        <div class=\"form-group\" ng-show=\"vm.importRows.length > 1\">\n          <div class=\"checkbox\">\n            <label>\n              <input type=\"checkbox\" ng-model=\"vm.headerChecked\" ng-change=\"vm.validate(); vm.alignColumnLayout();\" />\n              <span>{{ \"common.import.csvHeaderCheckboxLabel\" | translate }}</span>\n            </label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <table class=\"table-small\">\n            <tbody>\n              <tr style=\"height:30px;\" ng-repeat=\"col in vm.importCols\">\n                <td class=\"fieldHeaderCol\" ng-attr-title=\"{{ vm.headerChecked ? col[0] : vm.getDefaultFieldLabel($index) }}\">\n                  {{ vm.headerChecked ? col[0] : vm.getDefaultFieldLabel($index) }}\n                </td>\n                <td class=\"fieldValueCol\">\n                  <select id=\"{{ 'importFieldSelect' + $index }}\" ng-model=\"vm.headers[$index]\" style=\"width:auto;\" ng-change=\"vm.validate();\">\n                    <option value=\"Skip\">{{ \"common.Skip\" | translate }}</option>\n                    <option ng-repeat=\"field in vm.fields\" value=\"{{field.name}}\">{{ field.translationId | translate }}</option>\n                  </select>\n                </td>\n                <td class=\"firstFiveCol\">\n                  {{ vm.headerChecked ? vm.firstFiveValuesStr(col, true) : vm.firstFiveValuesStr(col, false) }}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </fieldset>\n      <div ng-show=\"vm.geocodeSubmitted\">\n        <div class=\"text-small text-bold text-center\">\n          <span>{{ vm.progressMessage }}</span>\n        </div>\n        <div class=\"progress\">\n          <div class=\"progress-bar no-trans\" ng-style=\"{'width': vm.progressPercent.toString() + '%' }\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <div class=\"import-errors alert alert-danger alert-sm text-left\" ng-show=\"vm.errors.length > 0\">\n        <p ng-repeat=\"error in vm.getDisplayErrors() track by $index\">{{error}}</p>\n      </div>\n      <div class=\"alert alert-danger alert-sm text-left\" ng-show=\"vm.submitError !== ''\">{{vm.submitError}}</div>\n      <button type=\"button\" class=\"btn btn-sm btn-default pull-left\" ng-click=\"vm.back()\" ng-disabled=\"vm.submitted\">{{ \"common.Back\" | translate }}</button>\n      <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.submitted && !vm.geocodeSubmitted\">{{ \"common.Cancel\" | translate }}</button>\n      <button class=\"btn btn-sm btn-success pull-right\" ng-click=\"vm.submitForm()\" ng-disabled=\"!vm.canSubmit()\" tabindex=\"0\">\n          <span>{{ vm.getSubmitButtonText() }}</span>\n        </button>\n    </div>\n  </div>\n</form>\n";

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "<form name=\"addressResultsForm\" novalidate>\n  <div class=\"modal-header\">\n    <h4 class=\"modal-title\">{{ \"common.import.addressResultTitle\" | translate }}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <fieldset class=\"panel panel-popup\" ng-disabled=\"vm.submitted\" style=\"padding-bottom:0\">\n      <h5 class=\"ellipsis-overflow\" ng-bind=\"vm.setName\"></h5>\n      <div ng-if=\"!vm.showMapPlace\" class=\"form-inline\" style=\"margin-top: 20px; margin-bottom: -10px;\">\n        <!-- Set Filter -->\n        <div class=\"input-group\">\n          <span class=\"input-group-btn\">\n                <span class=\"btn btn-sm btn-fake-addon\">\n                <i class=\"ico ico-filter\"></i>\n                </span>\n          </span>\n          <input type=\"text\" ng-model=\"vm.textFilter\" class=\"form-control\" id=\"results-filter\" placeholder=\"{{'common.Filter' | translate }}\"\n            ng-change=\"vm.onFilterChange()\">\n          <span class=\"input-group-btn\">\n                <button class=\"btn btn-sm btn-default\" type=\"button\" ng-click=\"vm.textFilter = ''; vm.onFilterChange();\">&times;</button>\n              </span>\n        </div>\n        <div class=\"btn-group\" style=\"margin-top: -4px; margin-left: 10px;\">\n          <label class=\"btn btn-default btn-sm\" ng-model=\"vm.qualityFilter\" uib-btn-radio=\"'all'\" ng-change=\"vm.onFilterChange()\"><span translate=\"common.All\"></span></label>\n          <label class=\"btn btn-default btn-sm\" ng-model=\"vm.qualityFilter\" uib-btn-radio=\"'exact'\" ng-change=\"vm.onFilterChange()\"><span translate=\"common.import.addressExact\"></span></label>\n          <label class=\"btn btn-default btn-sm\" ng-model=\"vm.qualityFilter\" uib-btn-radio=\"'good'\" ng-change=\"vm.onFilterChange()\"><span translate=\"common.import.addressGood\"></span></label>\n          <label class=\"btn btn-default btn-sm\" ng-model=\"vm.qualityFilter\" uib-btn-radio=\"'uncertain'\" ng-change=\"vm.onFilterChange()\"><span translate=\"common.import.addressUncertain\"></span></label>\n          <label class=\"btn btn-default btn-sm\" ng-model=\"vm.qualityFilter\" uib-btn-radio=\"'skipped'\" ng-change=\"vm.onFilterChange()\"><span translate=\"common.import.addressFailed\"></span></label>\n        </div>\n      </div>\n      <div class=\"container-fluid column-table\">\n        <div class=\"row column-table-header\">\n          <div ng-class=\"vm.columnWidths[0]\">\n            <button type=\"button\" class=\"btn btn-sm btn-faux\">{{ \"common.import.csvRow\" | translate }}</button>\n          </div>\n          <div ng-class=\"vm.columnWidths[1]\">\n            <button type=\"button\" class=\"btn btn-sm btn-faux\">{{ \"common.import.addressMatch\" | translate }}</button>\n          </div>\n          <div ng-class=\"vm.columnWidths[2]\">\n            <button type=\"button\" class=\"btn btn-sm btn-faux\">{{ \"common.import.addressInput\" | translate }}</button>\n          </div>\n          <div ng-class=\"vm.columnWidths[3]\">\n            <button type=\"button\" class=\"btn btn-sm btn-faux\">{{ \"common.import.addressFound\" | translate }}</button>\n          </div>\n          <div ng-if=\"vm.hasLatLon\" ng-class=\"vm.columnWidths[4]\">\n            <button type=\"button\" class=\"btn btn-sm btn-faux\">{{ \"common.import.addressInputLatLon\" | translate }}</button>\n          </div>\n          <div ng-class=\"vm.columnWidths[5]\">\n            <div ng-if=\"!vm.showMapPlace\" class=\"pull-right\">\n              <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.skipOrUnskipAll(false)\">{{ \"common.import.addressUnskipAll\" | translate }}</button>\n              <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.skipOrUnskipAll(true)\">{{ \"common.import.addressSkipAll\" | translate }}</button>\n            </div>\n          </div>\n        </div>\n        <div id=\"resultsScrollDiv\" class=\"column-table-scroll\">\n          <div class=\"row\" ng-show=\"vm.allAddressesHidden()\">\n            <div class=\"col-xs-12\">{{ \"common.import.allAddressesFiltered\" | translate }}</div>\n          </div>\n          <div ng-if=\"!vm.isHiddenDueToShowMap(result)\" ng-repeat=\"result in vm.currentPageResults track by result.index\">\n            <div class=\"row\" ng-class=\"{ 'import-address-row-highlight': result.latlonMismatch, 'import-address-row-error-highlight': result.badSiteCoords }\">\n              <!--Data row index column-->\n              <div class=\"{{ vm.columnWidths[0] }}\" ng-class=\"{ 'text-muted': result.disabled }\" ng-bind-html=\"result.inputRow.RowNum\"></div>\n              <!--Confidence level column-->\n              <div class=\"{{ vm.columnWidths[1] }}\">\n                <div ng-class=\"{ 'text-muted': result.disabled }\" ng-bind=\"vm.getConfidenceStr(result.ConfidenceLevel)\"></div>\n                <span ng-if=\"result.latlonMismatch || result.badSiteCoords\" class=\"ico ico-warning import-address-warning\" tooltip-placement=\"top-left\" uib-tooltip=\"{{ vm.getRowTextIssue(result) }}\"\n                  tooltip-append-to-body=\"true\"></span>\n              </div>\n              <!--Request address column-->\n              <div class=\"{{ vm.columnWidths[2] }} wrap-break-word\" ng-class=\"{ 'text-muted': result.disabled }\" ng-bind-html=\"result.requestAddressStr | highlight: vm.textFilter\"></div>\n              <!--Response address column-->\n              <div class=\"{{ vm.columnWidths[3] }} wrap-break-word\"\n                ng-class=\"{\n                  'text-muted': result.disabled,\n                  'selectable-match-cell': vm.matchAddressSelectEnabled(result),\n                  'match-cell-select' : vm.matchAddressSelectEnabled(result) && !result.useInputLatLon\n                }\"\n                ng-click=\"vm.matchAddressSelectEnabled(result) ? result.useInputLatLon = false : 0\">\n                <button ng-model=\"result.useInputLatLon\" uib-button-radio=\"false\" class=\"match-cell-checkbox\"\n                  ng-attr-title=\"{{ 'common.import.useGeocodedLatLon' | translate }}\"\n                  ng-if=\"vm.shouldShowAddressSelect(result)\" ng-disabled=\"!vm.matchAddressSelectEnabled(result)\">\n                    <span class=\"ico ico-checkbox-checked\"></span>\n                  </button>\n                <span ng-bind-html=\"vm.getResponseAddressStr(result) | highlight: vm.textFilter\"></span>\n                <span ng-if=\"result.badMatchAddressCoords\" class=\"ico ico-warning import-address-warning\" tooltip-placement=\"top-left\"\n                  uib-tooltip=\"{{ 'templates.importPlaces.matchAddressNotInSiteCoords' | translate }}\" tooltip-append-to-body=\"true\"></span>\n              </div>\n              <!--Lat/lon comparison column-->\n              <div class=\"{{ vm.columnWidths[4] }}\" ng-if=\"vm.hasLatLon\"\n                ng-class=\"{\n                  'text-muted': result.disabled || !vm.inputLatLonSelectEnabled(result),\n                  'selectable-match-cell': vm.inputLatLonSelectEnabled(result),\n                  'match-cell-select' : vm.inputLatLonSelectEnabled(result) && result.useInputLatLon\n                }\"\n                ng-click=\"vm.inputLatLonSelectEnabled(result) ? result.useInputLatLon = true : 0\">\n                <button ng-model=\"result.useInputLatLon\" uib-button-radio=\"true\" class=\"match-cell-checkbox\" ng-attr-title=\"{{ 'common.import.useInputLatLon' | translate }}\"\n                  ng-if=\"vm.shouldShowLatLonSelect(result)\" ng-disabled=\"!vm.inputLatLonSelectEnabled(result)\">\n                  <span class=\"ico ico-checkbox-checked\"></span>\n                  </button>\n                <span ng-bind-html=\"vm.getLatLonComparison(result)\"></span>\n              </div>\n              <!--UI/buttons/checkbox column-->\n              <div ng-class=\"vm.columnWidths[5]\">\n                <div class=\"pull-right\">\n                  <button type=\"button\" class=\"btn btn-sm btn-default\" style=\"display:inline-block\" ng-click=\"!vm.showMapPlace ? vm.showMap(result, $event) : vm.showList();\"\n                    ng-disabled=\"result.disabled\">\n                    {{ !vm.showMapPlace ? \"common.import.addressShowMap\" : \"common.import.addressShowList\" | translate }}\n                  </button>\n                  <!--\n                  <button ng-if=\"vm.hasLatLon\" type=\"button\" class=\"btn btn-sm btn-default\" style=\"display:inline-block\" ng-disabled=\"result.disabled\">\n                    {{ \"common.import.addressMoreMatches\" | translate }}\n                  </button>\n                  -->\n                  <span class=\"checkbox inline-checkbox\" style=\"display:inline-block\">\n                    <label ng-class=\"{ 'text-muted': result.disabled }\">\n                      <input type=\"checkbox\" ng-model=\"result.skipped\" ng-disabled=\"result.disabled\"> {{ \"common.import.addressSkip\" | translate }}\n                    </label>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </fieldset>\n  </div>\n  <div class=\"modal-footer\">\n    <nav ng-if=\"!vm.showMapPlace && vm.pages.length > 1\" style=\"float:left\" aria-label=\"Page navigation example\">\n      <ul class=\"pagination-sm\" uib-pagination total-items=\"vm.geocodeResults.length\" ng-model=\"vm.pageNumber\" max-size=\"12\" items-per-page=\"vm.resultsPerPage\"\n        boundary-links=\"true\" ng-change=\"vm.onPageChange()\" first-text=\"{{ 'common.PaginationFirst' | translate }}\" previous-text=\"{{ 'common.PaginationPrev' | translate }}\"\n        next-text=\"{{ 'common.PaginationNext' | translate }}\" last-text=\"{{ 'common.PaginationLast' | translate }}\"></ul>\n    </nav>\n    <table ng-if=\"!vm.showMapPlace\" class=\"table table-condensed table-bordered table-small text-left\" style=\"background-color: #fff; margin-bottom: 5px\">\n      <tr>\n        <td><strong>{{ vm.countTotalPlaces }}</strong> {{ vm.totalCountMessage }}</td>\n        <td><strong>{{ vm.countTotalPlacesGeocoded }}</strong> {{ vm.geocodedCountMessage }}</td>\n        <td><strong>{{ vm.countTotalPlacesGeocoded - vm.getSkippedPlacesCount() }}</strong> {{ vm.matchedCountMessage }}</td>\n        <td><strong>{{ vm.getSkippedPlacesCount() }}</strong> {{ vm.failedCountMessage }}</td>\n      </tr>\n    </table>\n    <div class=\"alert alert-danger alert-sm text-left\" ng-show=\"vm.submitError !== ''\">{{vm.submitError}}</div>\n    <div ng-if=\"!vm.showMapPlace\">\n      <button type=\"button\" class=\"btn btn-sm btn-default pull-left\" ng-click=\"vm.back()\">{{ \"common.Back\" | translate }}</button>\n      <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">{{ \"common.Cancel\" | translate }}</button>\n      <button class=\"btn btn-sm btn-success pull-right\" ng-click=\"vm.finish()\" ng-disabled=\"!vm.hasMatchSelected() || vm.submitted\">{{ \"common.Continue\" | translate }}</button>\n    </div>\n  </div>\n</form>\n";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "<form id=\"importForm\" name=\"importForm\" ng-show=\"!vm.oldBrowser\" novalidate>\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\">{{ vm.importModalTitle }}</h4>\n    </div>\n    <div class=\"modal-body\">\n      <fieldset class=\"panel panel-popup\" ng-disabled=\"vm.submitted\">\n        <div class=\"form-group\">\n  \n          <!--Content tools import: New Set, Append to Set, Replace Set-->\n          <div class=\"radio\" style=\"margin-top:0px;\" ng-if=\"vm.isPlacesImport\">\n            <label style=\"display:block\">\n              <input type=\"radio\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"0\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.newSet\" | translate }}</span>\n            </label>\n            <label style=\"display:block\"> \n              <input type=\"radio\" ng-disabled=\"{{vm.sets.length === 0}}\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"1\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.appendToSet\" | translate }}</span>\n            </label>\n            <label style=\"display:block\">\n              <input type=\"radio\" ng-disabled=\"{{vm.sets.length === 0}}\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"2\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.replaceSet\" | translate }}</span>\n            </label>\n          </div>\n  \n          <!--Exceptions import: New Set, Append to Set-->\n          <div class=\"radio\" style=\"margin-top:0px;\" ng-if=\"vm.isExceptionsImport\">\n            <label style=\"display:block\">\n              <input type=\"radio\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"0\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.newSet\" | translate }}</span>\n            </label>\n            <label style=\"display:block\">\n              <input type=\"radio\" ng-disabled=\"{{vm.sets.length === 0}}\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"1\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.appendToSet\" | translate }}</span>\n            </label>\n            <label style=\"display:block\">\n              <input type=\"radio\" ng-disabled=\"{{vm.sets.length === 0}}\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"2\" ng-change=\"vm.validate()\">\n              <span>{{ \"common.import.replaceSet\" | translate }}</span>\n            </label>\n          </div>\n  \n          <!--PCMWebUI Stops import: Append to or replace stops-->\n          <div class=\"radio\" style=\"margin-top:0px;\" ng-if=\"vm.isStopsImport\">\n            <label style=\"display:block\">\n              <input type=\"radio\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"0\" ng-change=\"vm.validate()\">\n              <span>{{ \"templates.importStops.appendToStops\" | translate }}</span>\n            </label>\n            <label style=\"display:block\">\n              <input type=\"radio\" name=\"importType\" ng-model=\"vm.importType\" ng-value=\"1\" ng-change=\"vm.validate()\">\n              <span>{{ \"templates.importStops.replaceStops\" | translate }}</span>\n            </label>\n          </div>\n  \n          <div class=\"form-group\" ng-show=\"vm.showSetName() || vm.showSetList()\">\n            <label for=\"setName\" ng-bind=\"vm.getSetLabel()\"></label>\n            <div ng-show=\"vm.showSetName()\" ng-class=\"{ 'has-error' : importForm.setName.$error.pattern }\">\n              <input ng-pattern=\"/^[^\\^/\\\\*?\\x22<>|]+$/\" type=\"text\" id=\"setName\" name=\"setName\" maxlength=\"100\" class=\"form-control input-sm no-trans\" ng-model=\"vm.setName\"\n                ng-change=\"vm.showEmptySetWarning=true; vm.validate()\">\n              <p class=\"help-block \" ng-show=\"importForm.setName.$error.pattern\">{{ 'templates.locations.canNotContainSpecialCharacters2' | translate }}</p>\n            <!-- New Set Categories -->             \n              <div class=\"categories-container\" ng-if=\"vm.isPlacesImport\">\n                <label for=\"setcategories\" translate=\"common.categoryIcon\"></label>\n                <ul class=\"button-icon\">\n                  <li class=\"\" uib-dropdown auto-close=\"outsideClick\" is-open=\"vm.showSetIcons\">\n                    <button id=\"btn btn-default\" uib-dropdown-toggle alkmaps-input style=\"border-width: 1px; background: white;\">\n                      <img class=\"cat-icons\" ng-src=\"/img/poi-icons/{{vm.selectedCategory.Icon}}.png\" />\n                      <span class=\"caret\"></span>\n                    </button>\n                    <ul class=\"list-group item-list icons-list\" uib-dropdown-menu role=\"menu\" ng-show=\"vm.showSetIcons\">\n                      <li class=\"list-group-item\" ng-repeat=\"category in vm.categoryIcons\" ng-click=\"vm.changeSetCategory(category)\">\n                        <img class=\"cat-icons\" title={{category.name}} ng-src=\"/img/poi-icons/{{category.Icon}}.png\" >\n                      </li>\n                    </ul>\n                  </li>\n                </ul>\n              </div>\n              <!--Copilot settings for places import-->\n              <div ng-if=\"vm.isPlacesImport\" class=\"import-copilot-settings\" ng-show=\"true\">\n                <label translate=\"templates.locations.setCopilotSettings\"></label><br/>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" ng-model=\"vm.copilotOptions.DisplayOnMap\" />\n                    <span class=\"cp-settings-label\" translate=\"templates.locations.setShowOnMap\"></span>\n                  </label>\n                </div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" ng-model=\"vm.copilotOptions.Searchable\" />\n                    <span class=\"cp-settings-label\" translate=\"templates.locations.setSearchable\"></span>\n                  </label>\n                </div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" ng-model=\"vm.copilotOptions.Alertable\" />\n                    <span class=\"cp-settings-label\" translate=\"templates.locations.setAlertable\"></span>\n                  </label>\n                </div>\n              </div>\n            </div>\n            <ui-select class=\"no-trans\" ng-model=\"vm.selectedSet\" ng-show=\"vm.showSetList()\" ng-change=\"vm.validate()\"\n              theme=\"bootstrap\">\n              <ui-select-match placeholder=\"{{'common.import.selectPlaceholder' | translate}}\">{{ $select.selected.Name }}</ui-select-match>\n              <ui-select-choices ui-select-infinite-scroll=\"50\" repeat=\"set in vm.sets | filter: $select.search | limitTo: limit\">\n                <span ng-bind-html=\"set.Name | highlight: $select.search\"></span>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n      </fieldset>\n      </div>\n      <div class=\"modal-footer\">\n        <div class=\"import-warnings alert alert-sm alert-warning text-left\" ng-show=\"vm.showEmptySetWarning && !vm.setName && vm.showSetName()\">\n          {{ \"common.import.setNameInvalid\" | translate }}\n        </div>\n        <div class=\"import-errors alert alert-sm alert-danger text-left\" ng-show=\"vm.errors.length > 0\">\n          <p ng-repeat=\"error in vm.getDisplayErrors()\">{{error}}</p>\n        </div>\n        <button type=\"button\" class=\"btn btn-sm btn-default pull-left\" ng-click=\"vm.back()\">{{ \"common.Back\" | translate }}</button>\n        <button type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"vm.cancel()\">{{ \"common.Cancel\" | translate }}</button>\n        <button class=\"btn btn-sm btn-success pull-right\" ng-click=\"vm.submit()\" ng-disabled=\"vm.disableFinish() || importForm.setName.$error.pattern\">{{ \"common.Finish\" | translate }}</button>\n      </div>\n  </form>\n  ";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  var serviceId = "routingProfile";

  angular.module("app").factory(serviceId, ["$rootScope", "$q", "_", "$http", "systemDefaultOptions", "UserProvider", "conversionService", "applicationSettingsService", function routeService($rootScope, $q, _, $http, systemDefaultOptions, userProvider, conversionService, applicationSettingsService) {
    var defaultOptions;

    // Note: change this when PCM38 becomes base data.
    var BASE_DATA = "PCM37";

    var daVehicleType = {
      Auto: 0,
      Truck: 3,
      MidsizeTruck: 12,
      LightDuty: 11
    };

    var pcmVehicleType = {
      Truck: 0,
      LightTruck: 1,
      Car: 2
    };

    // eslint-disable-next-line complexity
    function getPCMRouteOptionsFromDA(options) {
      /*da options. {
        "VehicleGroups": [ ],
        "displayRestrictions": 0,
        "ferryClosed": false,
        "propane": false,
        "revision": "January, 2015",
        "totalWeightPerAxle": 0,
        "truckDimensions": 0,
      }*/
      var pcmOptions = {
        routingProfileId: options.routingProfileId, //added this field since Id is needed
        name: options.name,
        trkUnits: options.unitsOfMeasure,
        trkWeight: options.totalWeight,
        trkAxles: options.numAxles,
        trkLCV: options.LCV,
        routingType: options.routingType,
        distanceUnits: options.distanceUnits,
        tollDiscourage: options.tollDiscouraged,
        tollRoadType: options.tollRoadType,
        bordersOpen: options.bordersOpen,
        overrideRestrict: options.overrideRestrictions,
        highwayOnly: options.highwayOnly,
        inclFerryDist: options.includeFerryDistance,
        hazMatType: options.hazmatType,
        tollCurrency: options.tollCurrency,
        exchangeRate: parseFloat(options.exchangeRate),
        hubRouting: options.hubRouting,
        fuelUnits: options.fuelUnits,
        costGHG: parseFloat(options.costGHG),
        costPerFuelUnit: parseFloat(options.costPerFuelUnit),
        fuelEconLoad: parseFloat(options.fuelEconomyLoad),
        fuelEconEmpty: parseFloat(options.fuelEconomyEmpty),
        costMaintLoad: parseFloat(options.costMaintLoad),
        costMaintEmpty: parseFloat(options.costMaintEmpty),
        costTimeLoad: parseFloat(options.costTimeLoad),
        costTimeEmpty: parseFloat(options.costTimeEmpty),
        dataVersion: options.dataVersion,
        inclTollData: options.includeTollData,
        tollPlan: options.includeTollData ? options.tollDiscountPlans : "",
        ferryDiscourage: options.isFerryDiscouraged,
        useSites: options.useSites || false,
        elevLimit: userProvider.getUser().isPremium() ? options.elevationLimit : null,
        governorSpeedLimit: options.governorSpeedLimit,
        sideOfStreetAdherence: options.sideOfStreetAdherence ? options.sideOfStreetAdherence : 0,
        EUOptions: {
          fuelType: options.euProfile.fuelType !== null ? options.euProfile.fuelType : undefined,
          refrigerated: options.euProfile.refrigerated !== null ? options.euProfile.refrigerated : undefined,
          fuelConsumption: options.euProfile.fuelConsumption !== null ? options.euProfile.fuelConsumption : undefined,
          emiType: options.euProfile.emiType !== null ? options.euProfile.emiType : undefined,
          hasTrailer: options.euProfile.hasTrailer !== null ? options.euProfile.hasTrailer : undefined,
          isHybrid: options.euProfile.isHybrid !== null ? options.euProfile.isHybrid : undefined,
          minPoll: options.euProfile.minPoll !== null ? options.euProfile.minPoll : undefined,
          trlCount: options.euProfile.trailerCount !== null ? options.euProfile.trailerCount : undefined,
          trlMaxAxles: options.euProfile.trailerMaxAxles !== null ? options.euProfile.trailerMaxAxles : undefined,
          trlType: options.euProfile.trailerType !== null ? options.euProfile.trailerType : undefined,
          trlMaxWt: options.euProfile.trailerMaxWt !== null ? options.euProfile.trailerMaxWt : undefined
        }
      };

      // vehicle types in dataanywhere are different from what is in the UI.  Use this mapping.
      // vehicle groups which are not light duty, auto, or truck are filtered out before this.
      if (options.vehicleType === daVehicleType.LightDuty) {
        pcmOptions.vehicleType = pcmVehicleType.LightTruck;
      } else if (options.vehicleType === daVehicleType.Auto) {
        pcmOptions.vehicleType = pcmVehicleType.Car;
      } else {
        pcmOptions.vehicleType = pcmVehicleType.Truck;
      }

      // For new customers, only use unitOfMeasure; for existing customer, fix governorSpeedLimit and elevLimit if 2 units are different.
      if (options.unitsOfMeasure === 0 && options.distanceUnits === 1) {
        pcmOptions.governorSpeedLimit = pcmOptions.governorSpeedLimit == null ? null : Math.floor(pcmOptions.governorSpeedLimit / 1.61);
        pcmOptions.elevLimit = pcmOptions.elevLimit == null ? null : Math.floor(pcmOptions.elevLimit / 1.61);
        pcmOptions.distanceUnits = 0;
      }
      if (options.unitsOfMeasure === 1 && options.distanceUnits === 0) {
        pcmOptions.governorSpeedLimit = pcmOptions.governorSpeedLimit == null ? null : Math.floor(pcmOptions.governorSpeedLimit * 1.61);
        pcmOptions.elevLimit = pcmOptions.elevLimit == null ? null : Math.floor(pcmOptions.elevLimit * 1.61);
        pcmOptions.distanceUnits = 1;
      }

      if (options.unitsOfMeasure === 0) {
        //English
        pcmOptions.trkLength = conversionService.totalInchesToString(options.totalLength);
        pcmOptions.trkWidth = conversionService.totalInchesToString(options.maxWidth, true);
        pcmOptions.trkHeight = conversionService.totalInchesToString(options.maxHeight);

        if (options.euProfile.trailerMaxHt) {
          pcmOptions.EUOptions.trlMaxHt = conversionService.totalInchesToString(options.euProfile.trailerMaxHt);
        }
      } else if (options.unitsOfMeasure === 1) {
        // Metric
        pcmOptions.trkLength = options.totalLength.toString();
        pcmOptions.trkWidth = options.maxWidth.toString();
        pcmOptions.trkHeight = options.maxHeight.toString();
        if (options.euProfile.trailerMaxHt) {
          pcmOptions.EUOptions.trlMaxHt = options.euProfile.trailerMaxHt.toString();
        }
      }

      // we only want classOverrides 0(None) or 3(fiftyThreeFootTrailer + nationalNetwork) to be consistent with PCM UI.
      if (options.classOverrides > 0) {
        pcmOptions.classOverrides = 3;
      } else {
        pcmOptions.classOverrides = 0;
      }

      return pcmOptions;
    }

    function getDARouteOptionsFromPCM(options) {
      var daOptions = {
        LCV: options.trkLCV,
        VehicleGroups: [],
        classOverrides: options.classOverrides === 3 ? 3 : 0,
        costGHG: options.costGHG.toString(),
        costMaintEmpty: options.costMaintEmpty.toString(),
        costMaintLoad: options.costMaintLoad.toString(),
        costPerFuelUnit: options.costPerFuelUnit.toString(),
        costTimeEmpty: options.costTimeEmpty.toString(),
        costTimeLoad: options.costTimeLoad.toString(),
        dataVersion: options.dataVersion,
        //displayRestrictions: 1,
        distanceUnits: options.distanceUnits,
        exchangeRate: options.exchangeRate.toString(),
        //ferryClosed: false,
        fiftyThreeFootTrailer: options.classOverrides === 3,
        fuelEconomyEmpty: options.fuelEconEmpty.toString(),
        fuelEconomyLoad: options.fuelEconLoad.toString(),
        fuelUnits: options.fuelUnits,
        hazmatType: options.hazMatType,
        highwayOnly: options.highwayOnly,
        includeFerryDistance: options.inclFerryDist,
        nationalNetwork: options.classOverrides === 3,
        numAxles: options.trkAxles,
        //propane: true,
        routingProfileId: options.routingProfileId,
        tollCurrency: options.tollCurrency,
        tollDiscouraged: options.tollDiscourage,
        tollRoadType: options.tollRoadType,
        totalWeight: options.trkWeight,
        //totalWeightPerAxle: 0,
        truckDimensions: 16,
        unitsOfMeasure: options.trkUnits,
        name: options.name,
        bordersOpen: options.bordersOpen,
        routingType: options.routingType,
        overrideRestrictions: options.overrideRestrict,
        hubRouting: options.hubRouting,
        includeTollData: options.inclTollData,
        tollDiscountPlans: options.inclTollData ? options.tollPlan : "", // if toll data is false, put empty string.
        elevationLimit: options.elevLimit,
        isFerryDiscouraged: options.ferryDiscourage,
        useSites: options.useSites,
        governorSpeedLimit: options.governorSpeedLimit,
        sideOfStreetAdherence: options.sideOfStreetAdherence,
        euProfile: {
          fuelType: options.EUOptions.fuelType,
          refrigerated: options.EUOptions.refrigerated,
          fuelConsumption: options.EUOptions.fuelConsumption,
          emiType: options.EUOptions.emiType,
          hasTrailer: options.EUOptions.hasTrailer,
          isHybrid: options.EUOptions.isHybrid,
          minPoll: options.EUOptions.minPoll,
          trailerCount: options.EUOptions.trlCount,
          trailerMaxAxles: options.EUOptions.trlMaxAxles,
          trailerType: options.EUOptions.trlType,
          trailerMaxWt: options.EUOptions.trlMaxWt
        }
      };

      // vehicle types in dataanywhere are different from what is in the UI.  Use this mapping.
      if (options.vehicleType === pcmVehicleType.Car) {
        daOptions.vehicleType = daVehicleType.Auto;
      } else if (options.vehicleType === pcmVehicleType.LightTruck) {
        daOptions.vehicleType = daVehicleType.LightDuty;
      } else {
        daOptions.vehicleType = daVehicleType.Truck;
      }

      if (options.trkUnits === 0) {
        // english units.
        daOptions.maxHeight = conversionService.stringToTotalInches(options.trkHeight);
        daOptions.maxWidth = conversionService.stringToTotalInches(options.trkWidth);
        daOptions.totalLength = conversionService.stringToTotalInches(options.trkLength);
        if (options.EUOptions.trlMaxHt) {
          if (userProvider.getUser().region === "EU") {
            daOptions.euProfile.trailerMaxHt = conversionService.stringToTotalInches(options.EUOptions.trlMaxHt);
          } else {
            daOptions.euProfile.trailerMaxHt = daOptions.maxHeight;
          }
        }
      } else {
        // metric untis
        daOptions.maxHeight = options.trkHeight;
        daOptions.maxWidth = parseFloat(options.trkWidth);
        daOptions.totalLength = options.trkLength;
        if (options.EUOptions.trlMaxHt) {
          if (userProvider.getUser().region === "EU") {
            daOptions.euProfile.trailerMaxHt = options.EUOptions.trlMaxHt;
          } else {
            daOptions.euProfile.trailerMaxHt = daOptions.maxHeight;
          }
        }
      }

      return daOptions;
    }

    /**
     * Only display certain routing profiles.
     * Don't want to display ones that are deleted.
     * Also, don't want to display ones that have options that are not valid for pcmiler web ui (example: a vehicle type of medium)
     */
    function isValidPCMilerWebUIProfile(item) {
      if (item.statusDeleted) return false;

      if (item.vehicleType != daVehicleType.Auto && item.vehicleType != daVehicleType.LightDuty && item.vehicleType != daVehicleType.Truck) return false;

      return true;
    }

    function getDefaultOptionsFromService() {
      var deferred = $q.defer();

      $http.get(config.daUrl + "routing-profiles/default").success(function (options) {
        // Only want the route options which are not explicitly deleted (if the statusDeleted column doesnt come back or if it is false, we assume the rout eoption is not deleted)
        options = options || [];
        var option = _.find(options, function (item) {
          return isValidPCMilerWebUIProfile(item);
        });

        // Copy object to make changes and not alter defaults so we don't break logout/change subcription level
        var sdo = getSystemDefaultOptions();

        // SWPWEB-8 - Initially enable toll data for Premium users. Saved defaults will overide this value.
        if (userProvider.getUser().isPremium()) {
          sdo.inclTollData = true;
        }

        if (option) {
          var pcmOptions = getPCMRouteOptionsFromDA(option);

          // Clear saved toll enabling from downgraded account
          if (!userProvider.getUser().isPremium()) {
            pcmOptions.inclTollData = false;
          }

          pcmOptions.afSetIDs = applicationSettingsService.getUserCfg("afSetIDs") || "";
          if (userProvider.getUser().region === "EU") {
            pcmOptions.EUOptions = _.defaults(pcmOptions.EUOptions, sdo.EUOptions);
          }

          if (userProvider.getUser().region !== "EU" && !userProvider.getUser().isPremium()) {
            pcmOptions.dataVersion = BASE_DATA;
          }

          deferred.resolve(_.defaults(pcmOptions, sdo));
        } else {
          var daOptions = getDARouteOptionsFromPCM(sdo);
          daOptions.default = true;

          $http.post(config.daUrl + "routing-profiles", daOptions).success(function (newDefaultRoutingProfile) {
            deferred.resolve(_.defaults({
              routingProfileId: newDefaultRoutingProfile.Id
            }, sdo));
          }).error(function (err) {
            deferred.reject(err);
          });
        }
      }).error(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    // currently, most routing profile options can be retrieved from DA service, some options like afsetId and EU options are saved in browser localStorage.
    function getSystemDefaultOptions() {
      var temp = angular.copy(systemDefaultOptions);

      if (!(userProvider.getUser().subscriptionLevel === "Premium" || userProvider.getUser().subscriptionLevel === "Trial")) {
        temp.highwayOnly = true;
      }

      if (userProvider.getUser().region === "EU") {
        temp.tollCurrency = 11; // EUR Currency
        temp.exchangeRate = 1;
        temp.dataVersion = "PCM_EU";
      } else if (!userProvider.getUser().isPremium()) {
        // SWPWEB-728 standard customers can only get access to base data.
        temp.dataVersion = BASE_DATA;
      }
      return temp;
    }

    function getDefaultOptionsPromise() {
      var defaultOptionsPromise = $q.defer();

      if (userProvider.getUser().isLoggedIn !== true) {
        defaultOptionsPromise.reject({
          message: "not logged in"
        });
        return defaultOptionsPromise.promise;
      }

      // if we already have default options retrieved from the service, use those.  If the options we currently have were our system default options because the service was down, try to get the options again from the service.
      if (defaultOptions != null && !defaultOptions.routingProfileNotAvailable) {
        defaultOptionsPromise.resolve(defaultOptions);
      } else {
        getDefaultOptionsFromService().then(function (resp) {
          defaultOptions = resp;
          defaultOptionsPromise.resolve(resp);
        }, function (err) {
          // If there is an error getting the default routing profile, use the system default options instead.
          // The user will have to log out and back in again to check again for their actual routing profile.
          var sdo = getSystemDefaultOptions();
          sdo.routingProfileNotAvailable = true;
          defaultOptions = sdo;
          defaultOptionsPromise.resolve(sdo);
        });
      }

      return defaultOptionsPromise.promise;
    }

    function getDefaultOptions() {
      return defaultOptions;
    }

    // currently, most routing profile options can be retrieved from DA service, some options like afsetId and EU options are saved in browser localStorage.
    function setDefaultOptions(options) {
      var copiedOptions = angular.copy(options);

      // when saving other options as defaults, set the name to "Default" (so we can retrieve it by name next time), and the routing profile id (so we update the correct item).
      copiedOptions.name = "Default";
      copiedOptions.routingProfileId = defaultOptions.routingProfileId;

      var daOptions = getDARouteOptionsFromPCM(copiedOptions);
      daOptions.default = true;

      defaultOptions = copiedOptions;

      // save some options to localStorage.
      var tempOptions = {};
      tempOptions.afSetIDs = copiedOptions.afSetIDs;
      if (userProvider.getUser().region === "EU") {
        tempOptions.options = copiedOptions.EUOptions;
      }
      applicationSettingsService.updateUserCfg(tempOptions);

      return $http.put(config.daUrl + "routing-profiles/" + daOptions.routingProfileId, daOptions); // jshint ignore:line
    }

    // whenever a user is loaded, get the data for them.
    $rootScope.$on("UserLoggedIn", function (event, message) {
      // jshint ignore:line
      defaultOptions = null;
    });

    var service = {
      getPCMRouteOptionsFromDA: getPCMRouteOptionsFromDA,
      getDARouteOptionsFromPCM: getDARouteOptionsFromPCM,
      setDefaultOptions: setDefaultOptions,
      getDefaultOptions: getDefaultOptions,
      getDefaultOptionsPromise: getDefaultOptionsPromise,
      getSystemDefaultOptions: getSystemDefaultOptions
    };

    return service;
  }]);
})();

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var applicationSettingsControllerId = "applicationSettingsController";

  angular.module("app").controller(applicationSettingsControllerId, ["$window", "$rootScope", "$scope", "$location", "$filter", "routingProfile", "alkModalService", "UserProvider", "optionsUI", "_", "$timeout", "routeService", "conversionService", "defaultDimensions", "applicationSettingsService", function ($window, $rootScope, $scope, $location, filter, routingProfile, alkModalService, userProvider, optionsUI, _, $timeout, routeService, conversionService, defaultDimensions, applicationSettingsService) {
    var vm = this;
    vm.title = "Application Settings";
    vm.optionsUI = optionsUI;
    vm.appSettingCopy = angular.copy(routingProfile.getDefaultOptions());
    vm.useTollDiscounts = vm.appSettingCopy.tollPlan === "All" ? true : false;
    vm.supported = false;
    vm.isAlertShowing = false;
    vm.alertMessage = "";
    vm.userIsPremium = userProvider.getUser().isPremium();
    vm.region = userProvider.getUser().region;
    vm.tollCurrencyChanged = tollCurrencyChanged;
    vm.changeUnits = changeUnits;
    vm.afterUnitChange = afterUnitChange;
    vm.ok = ok;
    vm.tollCurrencyStr = tollCurrencyStr;
    vm.resetToDefaults = resetToDefaults;
    vm.cancel = cancel;
    vm.userCfg = {
      classicSearchView: applicationSettingsService.getUserCfg("classicSearchView"),
      includePOI: applicationSettingsService.getUserCfg("includePOI")
    };

    ////////////////////////////////////
    function tollCurrencyChanged() {
      vm.appSettingCopy.exchangeRate = _.find(vm.optionsUI.tollCurrency, function (item) {
        return item.value === vm.appSettingCopy.tollCurrency;
      }).exchangeRate;
    }

    function changeUnits() {
      vm.appSettingCopy = applicationSettingsService.changeUnits(vm.appSettingCopy);
    }

    function afterUnitChange() {
      if (vm.region === "EU" && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1) {
        vm.appSettingCopy.EUFuelEconLoad = (100 / vm.appSettingCopy.fuelEconLoad).toFixed(2);
      }
    }

    function tollCurrencyStr() {
      return _.find(vm.optionsUI.tollCurrencyEU, {
        value: vm.appSettingCopy.tollCurrency
      }).display;
    }

    // toll discounts can only be enabled if includeTollData is true
    $scope.$watch("vm.appSettingCopy.inclTollData", function () {
      if (vm.appSettingCopy.inclTollData === false) {
        vm.useTollDiscounts = false;
      }
    });

    $scope.$watch("vm.userCfg.classicSearchView", function () {
      if (vm.userCfg.classicSearchView === true) {
        vm.userCfg.includePOI = false;
      }
    });

    // for EU customers with metric distance unit and liter fuel unit, auto convert liters Per 100 kms to fuelEconLoad
    $scope.$watch("vm.appSettingCopy.EUFuelEconLoad", function (newValue, oldValue) {
      if (vm.region === "EU" && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1) {
        // code first initialized, calculate EUFuelEconLoad from fuelEconLoad value
        if (!newValue && !oldValue) {
          vm.appSettingCopy.EUFuelEconLoad = (100 / vm.appSettingCopy.fuelEconLoad).toFixed(2);
          return;
        }
        vm.appSettingCopy.fuelEconLoad = (100 / vm.appSettingCopy.EUFuelEconLoad).toFixed(2);
      }
    });

    function ok() {
      if (vm.appSettingCopy.trkUnits === 0) {
        if (Array.isArray(vm.appSettingCopy.trkLength)) {
          vm.appSettingCopy.trkLength = conversionService.feetInchesToString(vm.appSettingCopy.trkLength);
          vm.appSettingCopy.trkHeight = conversionService.feetInchesToString(vm.appSettingCopy.trkHeight);
        }
        if (vm.region === "EU" && Array.isArray(vm.appSettingCopy.EUOptions.trlMaxHt)) {
          vm.appSettingCopy.EUOptions.trlMaxHt = conversionService.feetInchesToString(vm.appSettingCopy.EUOptions.trlMaxHt);
        }
      }
      vm.appSettingCopy.tollPlan = vm.useTollDiscounts ? "All" : "";
      routingProfile.setDefaultOptions(vm.appSettingCopy);
      // update route.options so that when going back to app page, all existing routes will re-run with new routing profile.
      routeService.updateAllRoutesAppSettingsOptions(vm.appSettingCopy);
      // save includePOI and classicSearchView to localStorage
      applicationSettingsService.updateUserCfg(vm.userCfg);
      vm.isAlertShowing = true;
      vm.alertMessage = "Application Settings have been updated.";
      $timeout(function () {
        vm.isAlertShowing = false;
        $location.url("/app");
      }, 1200);
    }

    function cancel() {
      if (!$scope.applicationSettingForm.$pristine) {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Exit Application Settings",
          bodyText: "Are you sure you want to exit without saving your changes?"
        }).then(function () {
          $location.url("/app");
        });
      } else {
        $location.url("/app");
      }
    }

    function resetToDefaults() {
      var reset = applicationSettingsService.resetUserCfg();
      vm.userCfg = {
        classicSearchView: reset.classicSearchView,
        includePOI: reset.includePOI
      };
      vm.appSettingCopy = routingProfile.getSystemDefaultOptions();
      routingProfile.setDefaultOptions(vm.appSettingCopy);
      vm.useTollDiscounts = vm.appSettingCopy.tollPlan === "All" ? true : false;
      // update route.options so that when going back to app page, all existing routes will re-run with new routing profile.
      routeService.updateAllRoutesOptions(vm.appSettingCopy);
      vm.isAlertShowing = true;
      vm.alertMessage = "Application Settings have been reset to Default.";
      $timeout(function () {
        vm.isAlertShowing = false;
      }, 1200);
    }
  }]);
})();

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "reportController";
  var pageTitle = " Reports | PC*MILER Web";
  angular.module("reportApp").controller(controllerId, ["$rootScope", "$scope", "$window", "$sce", "$filter", "_", "optionsUI", "UserProvider", "mapService", "$timeout", function reportController($rootScope, $scope, $window, $sce, $filter, _, optionsUI, userProvider, mapService, $timeout) {
    ALKMaps.APIKey = "token=" + userProvider.getUser().authToken;
    $scope.isLoading = true;
    $scope.region = userProvider.getUser().region;
    $scope.subscriptionLevel = userProvider.getUser().subscriptionLevel;

    var queryString = function () {
      var queryString = $window.location.search.substring(1);
      var params = {},
          queries,
          temp,
          i,
          l;

      // Split into key/value pairs
      queries = queryString.split("&");
      // Convert the array of strings into an object
      for (i = 0, l = queries.length; i < l; i++) {
        temp = queries[i].split("=");
        params[temp[0]] = temp[1];
      }
      return params;
    }();

    $scope.id = queryString.id;
    $scope.route = $window.opener.angular.element("#route-panel").scope().routeVm.getRoute($scope.id);

    var updateReport = function updateReport(event, message) {
      if (message === $scope.id) {
        $scope.route = $window.opener.angular.element("#route-panel").scope().routeVm.getRoute($scope.id);
        $scope.init();
      }
    };

    var updateReportListener = $window.opener.angular.element("#route-panel").scope().$on("UpdateReport", updateReport);

    $window.onbeforeunload = function () {
      updateReportListener();
    };

    $scope.showAllForPrint = false;

    $scope.printOne = function () {
      $scope.showAllForPrint = false;
      setTimeout(function () {
        //do not change this to $setTimeout since it stays inside the scope
        $window.print();
      }, 10);
    };

    $scope.printAll = function () {
      $scope.showAllForPrint = true;
      setTimeout(function () {
        //do not change this to $setTimeout since it stays inside the scope
        $window.print();
      }, 10);
    };

    $scope.isCurrentData = function () {
      return $scope.route.options.dataVersion === "current" || $scope.route.options.dataVersion === "PCM_EU";
    };
    $scope.dataVersionStr = function () {
      if (userProvider.getUser().region === "EU") {
        return "PCM_EU";
      }
      return _.find(optionsUI.reportDataVersion, {
        value: $scope.route.options.dataVersion
      }).display;
    };
    $scope.tollCurrencyStr = function () {
      return _.find(optionsUI.tollCurrencyEU, {
        value: $scope.route.options.tollCurrency
      }).display;
    };
    $scope.distanceUnit = function () {
      return $scope.route.options.distanceUnits === 0 ? "Miles" : "KMs";
    };
    $scope.distanceUnitAbbr = function () {
      return $scope.route.options.distanceUnits === 0 ? "mi" : "km";
    };

    $scope.postReports = function () {

      var rptType = "";

      if (userProvider.getUser().region === "EU") {
        rptType = $scope.subscriptionLevel === "Premium" ? "Mileage,Directions,Detail,State,Road,TollDetail" : "Mileage,Directions,Detail,State,Road";
        _.extend($scope.route.options, {
          region: "EU"
        });
      } else {
        rptType = "Mileage,Directions,Detail,State,Road";
      }

      var reportPromise = mapService.addReportPromise($scope.route.id, $scope.route.stops, $scope.route.options, $scope.route.uiArrDepSelection, rptType);

      var getSpecificResponse = function getSpecificResponse(resp, keyword) {
        return _.filter(resp, function (res) {
          return res["__type"].indexOf(keyword) === 0;
        });
      };

      reportPromise.then(function (resp) {
        var temp = [];
        // process report and generate HTML if there is any
        temp = getSpecificResponse(resp, "Mileage");
        if (temp.length > 0) {
          $scope.processMileage(temp[0]);
        }
        temp = getSpecificResponse(resp, "Directions");
        if (temp.length > 0) {
          $scope.processDirections(temp[0]);
        }
        temp = getSpecificResponse(resp, "Detail");
        if (temp.length > 0) {
          $scope.processDetails(temp[0]);
        }
        temp = getSpecificResponse(resp, "State");
        if (temp.length > 0) {
          $scope.processStateMileage(temp[0]);
        }
        temp = getSpecificResponse(resp, "Road");
        if (temp.length > 0) {
          $scope.processRoadTypes(temp[0]);
        }
        temp = getSpecificResponse(resp, "TollDetail");
        if (temp.length > 0) {
          $scope.processTollDetail(temp[0]);
        }
        $scope.isLoading = false;
        $timeout(function () {
          $scope.$apply();
        }, 10);
      }, function (err) {
        console.log(err);
      });
    };

    $scope.init = function () {
      $scope.postReports();
      $rootScope.pageTitle = $scope.route.name + pageTitle;
    };

    var wrapCell = function wrapCell(str, cssclass, span) {
      var classStr = typeof cssclass === "undefined" || cssclass === "" ? "" : " class='" + cssclass + "'";
      var spanStr = typeof span === "undefined" || span === "" ? "" : " colspan='" + span + "'";
      if (str === null) {
        str = "";
      }
      return "<td" + classStr + spanStr + ">" + str + "</td>";
    };

    var latlonOnly = function latlonOnly(stop) {
      if (stop.origLatlon) {
        return true;
      } else if (stop.Address.City === "" && stop.Address.Country === "" && stop.Address.County === "" && stop.Address.State === "" && stop.Address.StreetAddress === "") {
        return true;
      } else {
        return false;
      };
    };

    var fullAddress = function fullAddress(data) {
      var addrStr = "";
      if (data) {
        if (latlonOnly(data)) {
          addrStr = "Lon: " + data.Coords.Lon + ", Lat: " + data.Coords.Lat;
        } else {
          if (data.Address.StreetAddress !== null && data.Address.StreetAddress !== "") {
            addrStr += data.Address.StreetAddress + ", ";
          }
          if (data.Address.City !== null && data.Address.City !== "") {
            addrStr += data.Address.City + ", ";
          }
          if (data.Address.State !== null && data.Address.State !== "") {
            addrStr += data.Address.State + " ";
          }
          if (data.Address.Zip !== null && data.Address.Zip !== "") {
            addrStr += data.Address.Zip + " ";
          }
          if (data.Address.Country !== null && data.Address.Country !== "") {
            addrStr += ", " + data.Address.Country;
          }
        }
      }
      return addrStr;
    };

    $scope.routeODInfo = function () {
      var infoStr = "";
      var numStops = $scope.route.stops.length;

      if (latlonOnly($scope.route.stops[0])) {
        infoStr += "Lon: " + $scope.route.stops[0].Coords.Lon + ", Lat: " + $scope.route.stops[0].Coords.Lat;
      } else {
        infoStr += $scope.route.stops[0].CityStateZip;
      }

      if (latlonOnly($scope.route.stops[numStops - 1])) {
        infoStr += " to " + "Lon: " + $scope.route.stops[numStops - 1].Coords.Lon + ", Lat: " + $scope.route.stops[numStops - 1].Coords.Lat;
      } else {
        infoStr += " to " + $scope.route.stops[numStops - 1].CityStateZip;
      }

      infoStr += " : " + (numStops === 2 ? "No " : numStops - 2) + " Stop" + (numStops === 3 ? "" : "s");
      return infoStr;
    };

    $scope.detailsHTML = "";
    $scope.directionsHTML = "";
    $scope.stateTopHTML = "";
    $scope.stateListHTML = "";
    $scope.roadTypeHTML = "";
    $scope.tollDetailSegmentHTML = "";
    $scope.tollDetailSummaryHTML = "";

    $scope.processMileage = function (json) {
      var l = json.ReportLines.length - 1;

      $scope.route.routeDistance = json.ReportLines[l].TMiles + " " + $scope.distanceUnitAbbr();
      $scope.route.routeTMiles = json.ReportLines[l].TMiles;
      var timeArr = json.ReportLines[l].THours.split(":");
      var timeStr = "";
      if (parseInt(timeArr[0]) === 0) {
        timeStr = timeArr[1] + " min.";
      } else {
        timeStr = timeArr[0] + " hr. " + timeArr[1] + " min.";
      }
      $scope.route.routeTime = timeStr;
      $scope.route.routeTHours = json.ReportLines[l].THours;
      $scope.route.routeTTolls = json.ReportLines[l].TTolls;
      $scope.route.routeTCost = json.ReportLines[l].TCostMile;
    };

    $scope.processDetails = function (json) {
      json = json.ReportLegs;
      var detailOutput = "";
      var stopCount = 0;
      if (json.length > 0) {
        for (var l = 0; l < json.length; l++) {
          // each route leg
          for (var i = 0; i < json[l].ReportLines.length; i++) {
            //each line of the report
            var thisLine = json[l].ReportLines[i];
            var etaCell = $scope.route.hasTime ? wrapCell(thisLine.EtaEtd, "numeric") : "";
            var hazmatCell = $scope.route.options.hazMatType ? wrapCell(thisLine.Restriction, "numeric") : "";
            var TtollCell = $scope.route.options.inclTollData ? wrapCell(thisLine.TToll != null ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(thisLine.TToll, 2) : "", "numeric") + "<td></td>" : "";
            var LtollCell = $scope.route.options.inclTollData ? wrapCell(thisLine.LToll !== "0.00" ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(thisLine.LToll, 2) : "--", "numeric") : "";
            var PlazaCell = $scope.route.options.inclTollData ? wrapCell(thisLine.TollPlazaAbbr, "numeric") : "";
            if (thisLine.Stop !== null) {
              //origin or destination
              var stopStr = fullAddress($scope.route.stops[stopCount]);
              stopCount++;
              detailOutput += "<tr class='detail-orig-dest'>" + wrapCell(stopStr, "long-text", 4) + wrapCell(thisLine.Time, "numeric") + wrapCell(thisLine.InterCh, "long-text") + wrapCell($filter("number")(thisLine.LMiles, 1), "numeric") + wrapCell(thisLine.LTime, "numeric") + wrapCell($filter("number")(thisLine.TMiles, 1), "numeric") + wrapCell(thisLine.TTime, "numeric") + TtollCell + etaCell + hazmatCell + "</tr>";
            } else if (thisLine.ArState !== null) {
              //Arrival text
              var colSpan = 13;
              if (!$scope.route.hasTime) {
                colSpan -= 1;
              };
              if (!$scope.route.inclTollData) {
                colSpan -= 2;
              };
              detailOutput += "<tr class='detail-orig-dest'>" + wrapCell(thisLine.ArState, "", colSpan) + "</tr>";
            } else if (thisLine.Warn !== null) {
              //Arrival text
              var colSpan = 13;
              if (!$scope.route.hasTime) {
                colSpan -= 1;
              };
              if (!$scope.route.inclTollData) {
                colSpan -= 2;
              };
              detailOutput += "<tr class='detail-warning'>" + wrapCell(thisLine.Warn, "", colSpan) + "</tr>";
            } else {
              detailOutput += "<tr class='detail-line'>" + wrapCell(thisLine.State) + wrapCell(thisLine.LToll !== null && thisLine.LToll !== "0.00" ? $filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) : "") + wrapCell(thisLine.Route, "long-text") + wrapCell($filter("number")(thisLine.Miles, 1), "numeric") + wrapCell(thisLine.Time, "numeric") + wrapCell(thisLine.InterCh, "long-text") + wrapCell($filter("number")(thisLine.LMiles, 1), "numeric") + wrapCell(thisLine.LTime, "numeric") + wrapCell($filter("number")(thisLine.TMiles, 1), "numeric") + wrapCell(thisLine.TTime, "numeric") + LtollCell + PlazaCell + etaCell + hazmatCell + "</tr>";
            }
          }
        }
      }
      $scope.detailsHTML = $sce.trustAsHtml(detailOutput);
    };

    $scope.processDirections = function (json) {
      //console.log(json);
      json = json.ReportLegs;
      var dirOutput = "";
      if (json.length > 0) {
        for (var l = 0; l < json.length; l++) {
          var reportArr = json[l];
          for (var i = 0; i < reportArr.ReportLines.length; i++) {
            var line = reportArr.ReportLines[i];
            var dirStr = "";
            if (i === 0) {
              dirOutput += "<li class=\"direction-item line-" + i + "\">" + fullAddress($scope.route.stops[l]) + "<span class=\"stat dist\">" + $scope.distanceUnit() + "</span>" + "<span class=\"stat time\">Hr:Min</span>" + "</li>";
            } else if (l === json.length - 1 && i === reportArr.ReportLines.length - 7) {
              dirStr = fullAddress($scope.route.stops[$scope.route.stops.length - 1]);
              dirOutput += "<li class=\"direction-item sub-direction destination-total\">" + dirStr + "<span class=\"stat dist\">" + $filter("number")(line.Dist, 1) + "</span>" + "<span class=\"stat time\">" + line.Time + "</span>" + "</li>";
            } else if (l === json.length - 1 && i >= reportArr.ReportLines.length - 6) {
              dirStr = line.Direction;
              dirOutput += "<li class=\"direction-item disclaimer\">" + dirStr + "</li>";
            } else {
              var dirClass = "";
              if (line.Direction !== null) {
                dirStr = line.Direction;
              } else {
                dirStr = line.Warn;
              }
              var warnTest = /(Warning)/i;
              if (warnTest.test(line.Direction)) {
                dirClass = " warning";
              }

              if (line.Dist === null) {
                dirOutput += "<li class=\"direction-item line-" + i + dirClass + "\">" + dirStr + "</li>";
              } else {
                dirOutput += "<li class=\"direction-item sub-direction\">" + dirStr + "<span class=\"stat dist\">" + $filter("number")(line.Dist, 1) + "</span>" + "<span class=\"stat time\">" + line.Time + "</span>" + "</li>";
              }
            }
          }
        }
      }
      //console.log(dirOutput);
      $scope.directionsHTML = $sce.trustAsHtml(dirOutput);
    };

    $scope.processStateMileage = function (json) {
      var stateStops = "";
      var stopTolls = function stopTolls(line) {
        return $scope.route.options.inclTollData ? wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.LTolls, 2), "numeric") + wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.TTolls, 2), "numeric") : "";
      };
      for (var s = 0; s < json.MileageReportLines.length; s++) {
        var stopLine = json.MileageReportLines[s];
        stateStops += "<tr class='state-stop-line'>" + wrapCell(fullAddress($scope.route.stops[s])) + wrapCell($filter("number")(stopLine.LMiles, 1), "numeric") + wrapCell($filter("number")(stopLine.TMiles, 1), "numeric") + wrapCell($filter("tollCostSummaryFilter")(stopLine.LCostMile, $scope.route.options.tollCurrency), "numeric") + wrapCell($filter("tollCostSummaryFilter")(stopLine.TCostMile, $scope.route.options.tollCurrency), "numeric") + wrapCell(stopLine.LHours, "numeric") + wrapCell(stopLine.THours, "numeric") + stopTolls(stopLine) + wrapCell($filter("number")(stopLine.LEstghg, 1), "numeric") + wrapCell($filter("number")(stopLine.TEstghg, 1), "numeric") + "</tr>";
      }
      $scope.stateTopHTML = $sce.trustAsHtml(stateStops);

      var stateData = "";
      var stateTolls = function stateTolls(line) {
        return $scope.route.options.inclTollData ? wrapCell($filter("tollCostSummaryFilter")("", $scope.route.options.tollCurrency) + $filter("number")(line.Tolls, 2), "numeric") : "";
      };
      for (var ss = 0; ss < json.StateReportLines.length; ss++) {
        var stateLine = json.StateReportLines[ss];
        if (stateLine.StCntry != null) {
          if (stateLine.StCntry.search(new RegExp("(US|Canada|Mexico|Total)", "gi")) !== -1) {
            stateData += "<tr class='state-report-line total'>";
          } else {
            stateData += "<tr class='state-report-line'>";
          }
          stateData += wrapCell(stateLine.StCntry) + wrapCell($filter("number")(stateLine.Total, 1), "numeric") + wrapCell($filter("number")(stateLine.Toll, 1), "numeric") + wrapCell($filter("number")(stateLine.Free, 1), "numeric") + wrapCell($filter("number")(stateLine.Ferry, 1), "numeric") + wrapCell($filter("number")(stateLine.Loaded, 1), "numeric") + wrapCell($filter("number")(stateLine.Empty, 1), "numeric") + stateTolls(stateLine) + "</tr>";
        }
      }
      $scope.stateListHTML = $sce.trustAsHtml(stateData);
    };

    $scope.processRoadTypes = function (json) {
      var roadOutput = "";
      if (json.ReportLines.length > 0) {
        for (var i = 0; i < json.ReportLines.length; i++) {
          //each line of the report
          var thisLine = json.ReportLines[i];
          if (thisLine.Stop !== null) {
            //origin or destination
            roadOutput += "<tr class='roadtype-line'>" + wrapCell(fullAddress($scope.route.stops[i]), "long-text");
          } else {
            roadOutput += "<tr class='roadtype-line total'>" + wrapCell("Total", "long-text");
          }
          roadOutput += wrapCell(thisLine.LMiles, "numeric") + wrapCell($filter("number")(thisLine.InterSt, 1), "numeric") + wrapCell($filter("number")(thisLine.InterstNoRamp, 1), "numeric") + wrapCell($filter("number")(thisLine.Divide, 1), "numeric") + wrapCell($filter("number")(thisLine.Prime, 1), "numeric") + wrapCell($filter("number")(thisLine.Second, 1), "numeric") + wrapCell($filter("number")(thisLine.Ferry, 1), "numeric") + wrapCell($filter("number")(thisLine.Ramp, 1), "numeric") + wrapCell($filter("number")(thisLine.Local, 1), "numeric") + wrapCell($filter("number")(thisLine.Toll, 1), "numeric") + "</tr>";
        }
      }
      $scope.roadTypeHTML = $sce.trustAsHtml(roadOutput);
    };

    $scope.processTollDetail = function (json) {
      var segment = "";
      for (var s = 0; s < json.SegmentLines.length; s++) {
        var segLine = json.SegmentLines[s];
        segment += "<tr class=''>" + wrapCell(segLine.Country, "long-text") + wrapCell(segLine.Road, "long-text") + wrapCell(segLine.TollName, "long-text") + wrapCell(segLine.DistanceBased, "numeric") + wrapCell(segLine.Pass, "numeric") + wrapCell($filter("number")(segLine.Flat, 1), "numeric") + "</tr>";
      }
      $scope.tollDetailSegmentHTML = $sce.trustAsHtml(segment);

      var summary = "";
      var total = 0;
      for (var ss = 0; ss < json.SummaryLines.length; ss++) {
        var summaryLine = json.SummaryLines[ss];
        summary += "<tr class=''>" + wrapCell(summaryLine.Country, "long-text") + wrapCell(summaryLine.TollType, "long-text") + wrapCell(summaryLine.TollName, "long-text") + wrapCell(summaryLine.TollDistance, "numeric") + wrapCell(summaryLine.TollsLocal, "numeric") + wrapCell(summaryLine.Tolls, "numeric") + wrapCell(summaryLine.PaymentOption, "numeric") + "</tr>";

        if (!isNaN(summaryLine.Tolls) && summaryLine.TollType !== "Vignettes") {
          total += Number(summaryLine.Tolls);
        }
      }
      summary += "<tr class=''>" + wrapCell("<b>Total</b>", "long-text", 5) + wrapCell("<b>" + total.toFixed(2) + "</b>", "numeric") + wrapCell("", "numeric");
      $scope.tollDetailSummaryHTML = $sce.trustAsHtml(summary);
    };
  }]);
})();

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);
/* globals ALKMaps */
(function () {
  var serviceId = "vehicleService";

  angular.module("app").factory(serviceId, ["$http", "$q", "$rootScope", "_", "mapService", "routeService", "$window", "$compile", "LocationItem", "UserProvider", "routingProfile", "routeSyncService", function vehicleService($http, $q, $rootScope, _, mapService, routeService, $window, $compile, LocationItem, userProvider, routingProfile, routeSyncService) {
    var dataServiceUrl = config.daUrl;
    var authServiceUrl = config.ssoUrl;
    var pcmServiceUrl = config.pcmwsUrl;
    var vehicleList = [];
    var selectedVehicle;
    var vehiclesLayer;

    var mapObj = mapService.getMap();
    var vehiclesShown = false;

    var vehicleStyleMap = new ALKMaps.StyleMap({
      default: new ALKMaps.Style({
        graphicName: "circle",
        pointRadius: 10,
        fillColor: "${fill}",
        fillOpacity: 1,
        strokeColor: "${stroke}",
        strokeWidth: 2,
        label: "${labelTxt}",
        labelXOffset: 0,
        labelYOffset: 0,
        fontColor: "${labelColor}",
        fontSize: "9px",
        fontWeight: "normal",
        display: "block",
        graphicZIndex: 0
      }, {
        context: {
          fill: function fill(feature) {
            if (feature.cluster) {
              return "#d76852";
            } else {
              if (feature.attributes.info.OnlineStatus === 1) {
                return "#5dc25d";
              } else {
                return "#ffffff";
              }
            }
          },
          stroke: function stroke(feature) {
            if (feature.attributes.info.OnlineStatus === 1) {
              return "#359235";
            } else {
              return "#666666";
            }
          },
          labelTxt: function labelTxt(feature) {
            if (feature.cluster) {
              return "+";
            } else {
              if (feature.attributes.info.OnlineStatus === 1) {
                return "on";
              } else {
                return "off";
              }
            }
          },
          labelColor: function labelColor(feature) {
            if (feature.attributes.info.OnlineStatus === 1) {
              return "#ffffff";
            } else {
              return "#333333";
            }
          }
        }
      }),
      select: {
        strokeColor: "#6ccff6",
        graphicZIndex: 1000
      },
      temporary: {
        strokeColor: "#6ccff6"
      }
    });

    function createVehicleLayer() {
      vehiclesLayer = new ALKMaps.Layer.VectorMarkers("Vehicle Markers", {
        styleMap: vehicleStyleMap
      });
      mapObj.addLayers([vehiclesLayer]);

      var eventSelect = new ALKMaps.Control.FeatureEvent([vehiclesLayer], {
        featureAttributesFilter: [{
          property: "isMarker",
          value: true
        }]
      });
      mapObj.addControls([eventSelect]);
      eventSelect.activate();

      //Display VectorMarker popup on click
      var clickHandler = function clickHandler(event) {
        if (mapObj.vehiclePopup) {
          mapObj.removePopup(mapObj.vehiclePopup);
        }

        mapObj.vehiclePopup = new ALKMaps.Popup.SimplePopup("vehiclePopup", event.feature.lonlat, null, //autosize
        getPopupText(event.feature.attributes.info), new ALKMaps.Pixel(0, 0), //offset
        true, function () {
          if (mapObj.vehiclePopup) {
            mapObj.removePopup(mapObj.vehiclePopup);
          }
        });

        mapObj.addPopup(mapObj.vehiclePopup);
      };

      vehiclesLayer.events.register("featureclicked", this, clickHandler);
    }

    $rootScope.$on("routeSyncHidden", function () {
      return clearVehicleMarker();
    });

    function getPopupText(vehicleObj) {
      return "<div class='popup-text driver-popup-text'>" + "<span class='driver-name'>" + vehicleObj.Email + "</span>" + "<span class='driver-location driver-info'><strong>Near:</strong> " + vehicleObj.Address.StreetAddress + "<br/>" + vehicleObj.Address.City + " " + vehicleObj.Address.State + "  " + vehicleObj.Address.Zip + "</span>" + "<span class='driver-update driver-info'><strong>Updated:</strong> " + vehicleObj.displayDate + "</span>" + "</div>";
    }

    function getVehicleList() {
      // is the user is not logged in
      if (userProvider.getUser().isLoggedIn !== true) {
        return;
      }
      var deferred = $q.defer();

      // get RS vehicles
      routeSyncService.getVehicles().then(function (vehicles) {
        var vehicleData = angular.copy(vehicles);
        for (var i = 0; i < vehicleData.length; i++) {
          if (vehicleData[i].Latitude > 90 || vehicleData[i].Latitude < -90) {
            vehicleData[i].Latitude = vehicleData[i].Latitude / 1000000;
          }

          if (vehicleData[i].Longitude > 90 || vehicleData[i].Longitude < -90) {
            vehicleData[i].Longitude = vehicleData[i].Longitude / 1000000;
          }

          var modDate = new Date(vehicleData[i].ModifiedOn / 10000);
          vehicleData[i].displayDate = moment(modDate).format("M/D/YY h:mma");
        }
        vehicleList = vehicleData;
        deferred.resolve(vehicleList);
      }, function (err) {
        deferred.reject(err.ErrorMessage);
      });

      return deferred.promise;
    }

    function hasVehicles() {
      return vehicleList.length > 0;
    }

    function showAllVehicles() {
      vehiclesLayer.clearMarkers();
      if (mapObj.vehiclePopup) {
        mapObj.removePopup(mapObj.vehiclePopup);
      }
      for (var v = 0; v < vehicleList.length; v++) {
        var cleanLL = new ALKMaps.LonLat(vehicleList[v].Longitude, vehicleList[v].Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
        vehiclesLayer.createMarker(cleanLL, {
          markerType: "custom",
          info: vehicleList[v]
        });
      }
      vehiclesShown = true;
    }

    function hideVehicles() {
      vehiclesLayer.clearMarkers();
      vehiclesShown = false;
    }

    function frameAllVehicles() {
      var vehExt = vehiclesLayer.getDataExtent();
      mapObj.zoomToExtent(vehExt);
    }

    function showVehicle(vehicle, pan) {
      var cleanLL = new ALKMaps.LonLat(vehicle.Longitude, vehicle.Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
      if (!vehiclesShown) {
        clearVehicleMarker();
        mapObj.vehicleMarker = vehiclesLayer.createMarker(cleanLL, {
          markerType: "custom",
          info: vehicle
        });
      }

      if (mapObj.vehiclePopup) {
        mapObj.removePopup(mapObj.vehiclePopup);
      }

      mapObj.vehiclePopup = new ALKMaps.Popup.SimplePopup("vehiclePopup", cleanLL, null, //autosize
      getPopupText(vehicle), new ALKMaps.Pixel(0, 14), //offset
      true, function () {
        clearVehicleMarker();
      });

      mapObj.addPopup(mapObj.vehiclePopup);

      if (pan) {
        mapService.safePanTo(cleanLL, 14);
      }
    }

    function clearVehicleMarker() {
      var retVal = false;

      if (mapObj.vehicleMarker) {
        retVal = true;
        vehiclesLayer.removeMarker(mapObj.vehicleMarker);
        mapObj.vehicleMarker = null;
      }

      if (mapObj.vehiclePopup) {
        mapObj.removePopup(mapObj.vehiclePopup);
      }

      return retVal;
    }

    function getSelectedVehicle(id) {
      return getVehicleById(id);
    }

    function setSelectedVehicle(id) {
      selectedVehicle = id;
    }

    function getVehicleById(id) {
      return _.find(vehicleList, {
        OwnerID: id
      });
    }

    function getAccountShortcode() {
      var deferred = $q.defer();
      var token = userProvider.getUser().authToken;
      $http.get(authServiceUrl + "account-alias", {
        params: {
          "authToken": token
        }
      }).success(function (resp) {
        console.log(resp);
        deferred.resolve(resp.Data);
      }).error(function (err) {
        deferred.reject(resp.ErrorMessage);
      });
      return deferred.promise;
    }

    function resetAccountShortcode(code) {
      var deferred = $q.defer();
      var token = userProvider.getUser().authToken;
      $http.put(authServiceUrl + "account-alias", {}, {
        params: {
          "oldAlias": code,
          "authToken": token
        }
      }).success(function (resp) {
        console.log(resp);
        deferred.resolve(resp.Data);
      }).error(function (err) {
        deferred.reject(resp.ErrorMessage);
      });
      return deferred.promise;
    }

    function getReducedRoutePoints(code) {
      var deferred = $q.defer();
      var token = userProvider.getUser().authToken;
      $http.put(pcmServiceUrl + "route/routePath", {}, {
        params: {
          "oldAlias": code,
          "authToken": token
        }
      }).success(function (resp) {
        console.log(resp);
        deferred.resolve(resp.Data);
      }).error(function (err) {
        deferred.reject(err.ErrorMessage);
      });
      return deferred.promise;
    }

    function sendRSMessage(routeSyncOptions) {
      var route = angular.copy(routeService.getRoute(routeSyncOptions.routeId));
      var mapObj = mapService.getMap();
      var deferred = $q.defer();
      var routeSyncObject = {
        "TargetUser": {
          "OwnerId": routeSyncOptions.ownerId
        },
        "RouteSync": {
          "Compliance": routeSyncOptions.complianceAmount,
          "OorDistance": routeSyncOptions.alertDist,
          "DataVersion": "",
          "Legs": []
        }
      };

      var routeElements = mapService.getRouteElements(route.id);

      for (var f = 0; f < routeElements.routingLayer.features.length; f++) {
        var legNum = 0;
        if (routeElements.routingLayer.features[f].geometry.components) {
          //only linestrings have components
          var components = routeElements.routingLayer.features[f].geometry.components;
          var leg = {};
          leg.SequenceId = legNum;
          leg.Coords = [];
          leg.Links = []; //this should not be required by the service
          for (var i = 0; i < components.length; i++) {
            var ll = new ALKMaps.LonLat(components[i].x, components[i].y).transform(mapObj.getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));
            leg.Coords.push(Math.round(ll.lon * 1000000));
            leg.Coords.push(Math.round(ll.lat * 1000000));
          }
          routeSyncObject.RouteSync.Legs.push(leg);
          legNum++;
        }
      }

      routeSyncObject.RouteSync.Trip = {
        Name: route.name,
        Stops: _.map(_.map(route.stops, "ALKObj"), function (stop) {
          return {
            "Location": stop
          };
        }),
        Profile: routingProfile.getDARouteOptionsFromPCM(route.options)
      };

      routeSyncService.sendRouteSyncMessage(routeSyncObject).then(function (resp) {
        deferred.resolve(resp);
      }, function (err) {
        console.error(err);
        deferred.reject(err);
      });

      // $http.post(dataServiceUrl + "routesync-message", routeSyncObject).success(function (resp) {
      //   console.log(resp);
      //   deferred.resolve(resp);
      // }).error(function (err) {
      //   deferred.reject(err);
      // });
      return deferred.promise;
    }

    return {
      createVehicleLayer: createVehicleLayer,
      getVehicleList: getVehicleList,
      hasVehicles: hasVehicles,
      getAccountShortcode: getAccountShortcode,
      resetAccountShortcode: resetAccountShortcode,
      showVehicle: showVehicle,
      showAllVehicles: showAllVehicles,
      frameAllVehicles: frameAllVehicles,
      hideVehicles: hideVehicles,
      getSelectedVehicle: getSelectedVehicle,
      setSelectedVehicle: setSelectedVehicle,
      sendRSMessage: sendRSMessage
    };
  }]);
})();

/*
 {
    "TargetUser": {
        "OwnerId": 2668
    },
    "RouteSync": {
        "Compliance": 0,
        "DataVersion": "9.12.14.3",
        "OorDistance": 0.2,
        "ExternalRouteID": "",
        "StartingIndex": 0,
        "Legs": [
            {
                "SequenceId": 0,
                "Coords": [
                    -74189445,
                    39803416,
                    -74189445,
                    39803416,
                    -74190584,
                    39803545,
                    -74190699,
                    39802870,
                    -74190828,
                    39802254
                ],
        "Trip": {
            "Name": "",
            "Profile": {
                "name": "2147104196",
                "vehicleType": 3,
                "routingType": 0,
                "tollRoadType": 2,
                "truckDimensions": 0,
                "maxHeight": 1620,
                "maxWidth": 960,
                "totalLength": 5760,
                "totalWeight": 8000,
                "totalWeightPerAxle": -1,
                "hazmatType": 0,
                "displayRestrictions": 1,
                "nationalNetwork": false,
                "fiftyThreeFootTrailer": false,
                "overrideRestrictions": true,
                "bordersOpen": true,
                "propane": false,
                "ferryClosed": false
            },
            "Stops": [
                {
                    "Location": {
                        "Address": {
                            "StreetAddress": "10 Mizzen Way",
                            "City": "Waretown",
                            "State": "NJ",
                            "Zip": "08758",
                            "County": "Ocean",
                            "Country": "",
                            "SPLC": "",
                            "CountryPostalFilter": 0,
                            "AbbreviationFormat": 0
                        },
                        "Coords": {
                            "Lat": "39.803416",
                            "Lon": "-74.189445"
                        },
                        "Region": 0,
                        "Label": "",
                        "PlaceName": "",
                        "TimeZone": "",
                        "Errors": ""
                    },
                    "Waypoint": false
                },
                {
                    "Location": {
                        "Address": {
                            "StreetAddress": "933 Wellington Avenue",
                            "City": "Toms River",
                            "State": "NJ",
                            "Zip": "08757",
                            "County": "Ocean",
                            "Country": "",
                            "SPLC": "",
                            "CountryPostalFilter": 0,
                            "AbbreviationFormat": 0
                        },
                        "Coords": {
                            "Lat": "40.004736",
                            "Lon": "-74.266524"
                        },
                        "Region": 0,
                        "Label": "",
                        "PlaceName": "",
                        "TimeZone": "",
                        "Errors": ""
                    },
                    "Waypoint": false
                }
            ]
        }
    }
}
 */

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "vehiclesController";
  angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$location", "moment", "vehicleService", "routeService", "mapService", "alkGeocodeService", "$window", "UserProvider", function vehiclesController($rootScope, $scope, $location, moment, vehicleService, routeService, mapService, alkGeocodeService, $window, userProvider) {
    $scope.isInit = false;
    $scope.showVehicles = false;
    $scope.isVehiclesCollapsed = true;
    $scope.userIsAdmin = userProvider.getUser().isAdmin;
    $scope.opt = {
      region: userProvider.getUser().region,
      dataset: userProvider.getUser().dataset
    };
    $scope.showSearch = false;
    $scope.filterVehicles = function () {
      $scope.showSearch = !$scope.showSearch;
    };

    $scope.hasRoutes = function () {
      return routeService.getSelectedRoute() !== null;
    };

    $scope.getVehicleList = function () {
      return $scope.vehicleList;
    };

    $scope.toggleVehicles = function () {
      $scope.isVehiclesCollapsed = !$scope.isVehiclesCollapsed;
    };

    $scope.closeVehicles = function () {
      $scope.showVehicles = false;
      vehicleService.hideVehicles();
    };

    $scope.getVehicleAddressString = function (address) {
      if (!address) {
        return "Location Unknown";
      }

      return _.reject([address.City, address.State], _.isEmpty).join(", ");
    };

    var getVehicleAddress = function getVehicleAddress(vehicle) {
      if (!vehicle.Latitude && !vehicle.Longitude) {
        vehicle.Address = null;
        return;
      }

      alkGeocodeService.reverseGeocode({
        "lat": vehicle.Latitude,
        "lon": vehicle.Longitude
      }, $scope.opt).then(function (data) {
        vehicle.Address = data[0].Address;
      });
    };

    $scope.refreshVehicles = function () {
      $scope.isLoadingVehicles = true;
      vehicleService.getVehicleList().then(function (results) {
        $scope.vehicleList = results;
        vehicleService.showAllVehicles();
        $scope.isLoadingVehicles = false;
        for (var i = 0; i < $scope.vehicleList.length; i++) {
          getVehicleAddress($scope.vehicleList[i]);
        }
      });
    };

    $scope.frameAll = function () {
      vehicleService.frameAllVehicles();
    };

    function showVehiclePanel() {
      vehicleService.getAccountShortcode().then(function (results) {
        $scope.shortcode = results;
      });
      $scope.refreshVehicles();
    }

    function hideVehiclePanel() {
      vehicleService.hideVehicles();
    }

    $scope.$on("toggleVehicles", function () {
      $scope.showVehicles = !$scope.showVehicles;
      if (!$scope.isInit) {
        vehicleService.createVehicleLayer();
        $scope.isInit = !$scope.isInit;
      }
      if ($scope.showVehicles) {
        showVehiclePanel();
      } else {
        hideVehiclePanel();
      }
    });

    $scope.selectVehicle = function (vehicle) {
      vehicleService.setSelectedVehicle(vehicle.OwnerID);
    };

    $scope.selectedVehicle = function () {
      return vehicleService.getSelectedVehicle();
    };

    $scope.showLocation = function (vehicle) {
      vehicleService.showVehicle(vehicle, true, $scope);
    };

    $scope.showClosest = function () {
      vehicleService.getClosesttToOrigin();
    };

    $scope.resetShortcode = function (shortcode) {
      vehicleService.resetAccountShortcode(shortcode).then(function (results) {
        $scope.shortcode = results;
      });
    };

    $scope.sendRoute = function (vehicleId) {
      vehicleService.prepareMessage(vehicleId);
    };
  }]);
})();

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var directiveIdShow = "showonhoverparent";
  var directiveIdHide = "hideonhoverparent";
  angular.module("app").directive(directiveIdShow, function () {
    return {
      restrict: "A",
      link: function link(scope, element, attrs) {
        element.addClass("parentHoverHide");
        var elemToBind = element.parent();
        if (attrs.showonhoverparent !== "") {
          elemToBind = element.closest(attrs.showonhoverparent);
        }
        elemToBind.bind("mouseenter", function () {
          element.removeClass("parentHoverHide");
          element.addClass("parentHoverShow");
        });
        elemToBind.bind("mouseleave", function () {
          element.removeClass("parentHoverShow");
          element.addClass("parentHoverHide");
        });
      }
    };
  });

  angular.module("app").directive(directiveIdHide, function () {
    return {
      restrict: "A",
      link: function link(scope, element, attrs) {
        element.addClass("parentHoverShow");

        var elemToBind = element.parent();

        if (attrs.hideonhoverparent !== "") {
          elemToBind = element.closest(attrs.hideonhoverparent);
        }

        elemToBind.bind("mouseenter", function () {
          element.removeClass("parentHoverHide");
          element.addClass("parentHoverShow");
        });
        elemToBind.bind("mouseleave", function () {
          element.removeClass("parentHoverShow");
          element.addClass("parentHoverHide");
        });
      }
    };
  });
})();

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var listSelectDirective = "listSelect";

  angular.module("app").directive(listSelectDirective, ["$timeout", "$document", function ($timeout, $document) {
    return {
      restrict: "A",
      link: function link(scope, element, attrs) {
        // don't auto focus the list all the time.  when the list items are in a filtered list, if the user types into the filter, the filter loses focus because the list item would steal focus
        if (attrs.listSelectSkipAutoFocus !== "true") {
          if (scope.$last) {
            $timeout(function () {
              element.parent().children().first().focus();
            }, 1);
          }
        }

        element.bind("focusout", function (event) {
          element.removeClass("selected").siblings().removeClass("selected");
        });

        element.bind("focus", function (event) {
          element.removeClass("selected").siblings().removeClass("selected");
          element.addClass("selected");
        });

        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.listSelectOnEnter);
            });
            event.preventDefault();
          }

          if (event.which === 38) {
            //up arrow
            if (!element.is(element.parent().children().first())) {
              element.prev().focus();
            } else if (attrs.listInputClass) {
              //Focus the previous input this list belongs to.
              var inputs = $document[0].getElementsByClassName(attrs.listInputClass);
              for (var i = 0; i < inputs.length; i++) {
                inputs[i].focus();
              }
            }

            if (attrs.listSelect !== "") {
              element.parent().children(".selected").click();
            }

            return false;
          }

          if (event.which === 40) {
            //down arrow
            if (!element.is(element.parent().children().last())) {
              element.next().focus();
            }

            if (attrs.listSelect !== "") {
              element.parent().children(".selected").click();
            }

            return false;
          }
        });
      }
    };
  }]);
})();

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var directiveId = "dateTimePicker";

  //Prevent datetime picker from lingering around if you press escape in certain situations.
  function onDocumentKeyPress(event) {
    if (event.keyCode === 27) {
      angular.element(".datetimepicker").css("display", "none");
    }
  }

  //requires jquery.scrollTableBody-1.0.0.js
  angular.module("app").directive(directiveId, ["$document", function ($document) {
    return {
      restrict: "A",
      replace: true,
      scope: true,
      link: function link(scope, element, attrs /*, ngModel*/) {
        //var input = element.find('input');
        var pickerOpt = {
          format: "mm/dd/yyyy hh:ii",
          minView: 0,
          maxView: 3,
          showMeridian: false,
          autoclose: true,
          todayHighlight: true,
          bootcssVer: 3,
          pickerPosition: "bottom-right"
        };
        var iconClass = "glyphicon-th";
        switch (attrs.dateTimePicker) {
          case "date":
            pickerOpt.minView = 2;
            pickerOpt.format = "mm/dd/yyyy";
            break;
          case "time":
            pickerOpt.maxView = 1;
            pickerOpt.startView = 1;
            pickerOpt.format = "H:ii P";
            pickerOpt.showMeridian = true;
            iconClass = "glyphicon-time";
            pickerOpt.pickerPosition = "bottom-right dontshowdate";
            break;
        }
        element.find(".glyphicon").addClass(iconClass);
        element.datetimepicker(pickerOpt);

        //Prevent datetime picker from lingering around if you press escape in certain situations.
        //We first remove the previous event so it doesn't get fired multiple times for multiple datetime directives
        $document.off("keydown", onDocumentKeyPress);
        $document.on("keydown", onDocumentKeyPress);

        scope.$on("$destroy", function () {
          //On destroy of whatever scope uses this directive, we should unbind the function from the event, otherwise it will persist and leak memory
          $document.off("keydown", onDocumentKeyPress);
          //If using this directive we must manually remove the datetime picker we created, on scope destroy - otherwise, old datetimepicker divs will not be removed from <body>,
          //and they will pile up everytime user navigates from and to the page, causing memory leaks over time.
          element.datetimepicker("remove");
        });

        //element.bind('blur keyup change', function () {
        //  scope.ngModel = input.val();
        //});
      }
    };
  }]);
})();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var m = angular.module("app");

  m.directive("billingAddress", ["STATES", "_", function (STATES, _) {
    return {
      scope: {
        address: "=ngModel",
        ngDisabled: "=",
        ngRequired: "="
      },
      restrict: "E",
      replace: true,
      require: "^form",
      templateUrl: function templateUrl(element, attrs) {
        return attrs.template || "/app/account/billing_address.html";
      },
      link: function link(scope, elem, attrs, form) {
        scope.form = form;

        scope.states = STATES;
        scope.countries = _.uniq(STATES, "country");

        scope.$watch("address.state", function () {
          if (scope.address && scope.address.state != null && scope.address.state !== "") {
            var c = _.find(STATES, {
              abbreviation: scope.address.state
            });
            if (c.country !== scope.address.country) {
              scope.address.country = c.country;
            }
          }
        });

        scope.$watch("address.country", function () {
          if (scope.address && scope.address.state != null && scope.address.state !== "") {
            var c = _.find(STATES, {
              abbreviation: scope.address.state
            });
            if (c.country !== scope.address.country) {
              scope.address.state = "";
            }
          }
        });
      }
    };
  }]);

  // MIT Licensed Credit Card validation: https://gist.github.com/lrvick/8789669
  m.directive("billingInformation", [function () {
    return {
      scope: {
        card: "=ngModel",
        ngDisabled: "=",
        ngRequired: "=",
        cardDirty: "=?"
      },
      restrict: "E",
      replace: true,
      require: "^form",
      templateUrl: "/app/account/billing_information.html",
      link: function link(scope, elem, attrs, form) {
        scope.form = form;

        var expirationStartYear = new Date().getFullYear();

        scope.expirationYears = [expirationStartYear, expirationStartYear + 1, expirationStartYear + 2, expirationStartYear + 3, expirationStartYear + 4, expirationStartYear + 5, expirationStartYear + 6, expirationStartYear + 7, expirationStartYear + 8, expirationStartYear + 9, expirationStartYear + 10];

        attrs.$observe("showErrorsOnLoad", function () {
          scope.showErrorsOnLoad = attrs.showErrorsOnLoad === "true";
        });

        scope.$watch(function () {
          var number = scope.form.cardNumber.$viewValue || "";
          var name = scope.form.cardName.$viewValue || "";
          var expMonth = scope.form.expirationMonth.$viewValue || "";
          var expYear = scope.form.expirationYear.$viewValue || "";
          var cvv = scope.form.cvv.$viewValue || "";

          return number + "_" + name + "_" + expMonth + "_" + expYear + "_" + cvv;
        }, function (n, o) {
          if (angular.equals(n, o)) return;

          scope.cardDirty = n;
        });
      }
    };
  }]);

  m.directive("cardType", function () {
    return {
      scope: {
        cardType: "="
      },
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {
        var initialCardType;

        function getType(value) {
          var type = /^5[1-5]/.test(value) ? "MasterCard" : /^4/.test(value) ? "VISA" : /^3[47]/.test(value) ? "AmEx" : undefined;
          return type;
        }

        var unregisterInitialCardType = scope.$watch("cardType", function (n, o) {
          if (angular.equals(n, o)) return;

          // keep track of the original card.  When the card field is empty, we can set the card type to the original card Type.
          initialCardType = n;
          unregisterInitialCardType();
        });

        scope.$watch(function () {
          return ctrl.$viewValue;
        }, function (n, o) {
          if (angular.equals(n, o)) return;

          if (n == null || n == "") scope["cardType"] = initialCardType;else scope["cardType"] = getType(n);
        });

        ctrl.$validators["cardType"] = function (modelValue, viewValue) {
          var value = modelValue || viewValue;

          // if value is not set, consider it valid because ng-required attribute will handle this case.
          if (value == null || value == "") return true;

          var type = getType(value);

          return type != null;
        };
      }
    };
  });

  m.directive("cardExpiration", ["moment", function (moment) {
    return {
      scope: {
        cardMonth: "=",
        cardYear: "="
      },
      restrict: "A",
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {

        scope.$watchGroup(["cardMonth", "cardYear"], function () {
          ctrl.$validate();
        });

        ctrl.$validators["cardExpiration"] = function () {

          if (scope.cardYear == null || scope.cardMonth == null) return true; // if the necessary fields aren't filled in, don't return a negative validation

          // credit expiration 
          var now = moment();

          var expDate = moment(scope.cardYear + "-" + scope.cardMonth + "-1", "YYYY-MM-DD").endOf("month");

          return expDate.isAfter(now);
        };
      }
    };
  }]);
})(window.angular);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  var m = angular.module("app");

  m.directive("pcmFormContainer", ["_", function (_) {
    return {
      restrict: "AE",
      scope: {},
      require: ["pcmFormContainer"],
      controller: ["$scope", function controller($scope) {
        var forms = [];
        var controller = this;

        this.addForm = function (newForm) {
          forms.push(newForm);
        };

        this.submitForms = function (event) {
          var i = 0,
              allFormsValid = true;

          // first, check if all the forms which should be submitted are valid
          for (i = 0; i < forms.length; i++) {
            if (forms[i].controller.shouldSubmit(event) === true) {
              forms[i].controller.setSubmitted(true);

              if (forms[i].controller.$valid === false) {
                allFormsValid = false;
              }
            }
          }

          if (allFormsValid === true) {
            // all the forms which should be submitted are valid, submit all the forms which should be submitted
            var sortedForms = _.sortBy(forms, "pcmOrder");

            for (i = 0; i < sortedForms.length; i++) {
              if (sortedForms[i].controller.shouldSubmit(event) === true) {
                sortedForms[i].element.submit();
              }
            }
          }
        };
      }]
    };
  }]).directive("pcmForm", function () {
    return {
      require: ["^pcmFormContainer", "form"],
      restrict: "A",
      scope: {
        pcmOrder: "=" // allow a specific order be used for submitting forms
      },
      link: function link(scope, element, attrs, controllers) {
        var formController = controllers[0];
        formController.addForm({
          controller: controllers[1],
          element: element,
          pcmOrder: scope.pcmOrder
        });
      }
    };
  }).directive("pcmContainerSubmit", function () {
    return {
      require: ["^pcmFormContainer"],
      scope: {},
      restrict: "AE",
      link: function link(scope, element, attrs, controllers) {
        var formController = controllers[0];

        element.on("click", function (event) {
          formController.submitForms(event);
        });
      }
    };
  });
})(window.angular);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("app").directive("pcmShowOnKey", ["$document", function ($document) {
    return {
      link: function link(scope, element, attrs) {

        $document.on("keydown", function (evt) {
          if (evt.keyCode === parseInt(attrs.pcmShowOnKey, 10) && evt.ctrlKey === true) {
            element.show();

            //evt.stopPropagation();
            //evt.preventDefault();
          }
        });

        $document.on("keyup", function (evt) {
          element.hide();
        });
      }
    };
  }]);
})(angular);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var m = angular.module("pcmwsui.message", []);

  m.directive("pcmwsuiMessage", ["$location", function ($location) {

    var templateString =
    //"<div id=\"pcmwsuiMessage\" style=\"display:{{ showPcmwsuiMessage ? 'block' : 'none' }};\">" + // doesn't work in IE10
    "<div id=\"pcmwsuiMessage\" ng-attr-style=\"{{pcmwsuiStyleVar}}\">" + "<div class=\"alert alert-danger\" style=\"background-color:#fcf8e3;\">" + "<a class=\"close\" ng-click=\"closeMessage()\">&times;</a>" + "<span style=\"font-weight:bold;\">You have been re-directed to PC*Miler Web because the PC*Miler Web Services User Interface has been shut off. If you would like to maintain a visual interface to PC*Miler, contact your account representative at 800-377-6453 ext. 1 or <a href=\"mailto:sales@alk.com\">sales@alk.com</a>.</span>" + "</div>" + "</div>";

    return {
      restrict: "E",
      replace: true,
      scope: {},

      controller: ["$scope", function ($scope) {
        $scope.showPcmwsuiMessage = false;
        if ($location.search().pcmwsui) $scope.showPcmwsuiMessage = true;

        $scope.closeMessage = function () {
          $scope.showPcmwsuiMessage = false;
          $scope.pcmwsuiStyleVar = "display: none;";
        };

        $scope.pcmwsuiStyleVar = $scope.showPcmwsuiMessage ? "display: block;" : "display: none;";
      }],

      template: templateString
    };
  }]);
})(angular);

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getDisplayRowIndex(rowIndex, vm) {
  return vm.headerChecked ? String(rowIndex + 2) : String(rowIndex + 1);
}

module.exports = getDisplayRowIndex;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Gets the import rows that don't include the header row, if the header checkbox is checked
function getImportDataRows(vm) {
  if (!Array.isArray(vm.importRows)) {
    throw Error("vm.importRows should be an array");
  }
  var newImportRows = vm.importRows;
  if (vm.headerChecked) {
    newImportRows = vm.importRows.slice(1); //Don't include first element of array (the header row)
  }
  return newImportRows;
}

module.exports = getImportDataRows;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} alkLinkMappingService
 *  @property {Function} getDataVersions
 *  @property {Function} dataVersionSupportsPLIDs
 */

var config = __webpack_require__(1);

(function () {
  "use strict";

  alkLinkMappingService.$inject = ["$http"];
  angular.module("alk.linkMapping").service("alkLinkMappingService", alkLinkMappingService);

  /** @name alkLinkMappingService
   * @ngdoc service
   * @param {service} $http angularJS [HTTP communication service](https://docs.angularjs.org/api/ng/service/$http)
   * @description Interfaces with the Link Mapping API to translate PLIDs to grid/links, and get PLIDs from grid/links across different data versions.
   * @returns alkLinkMappingService
   * @memberof alk.linkMapping
   */
  function alkLinkMappingService($http) {
    "ngInject";

    var service = {
      getDataVersions: getDataVersions,
      dataVersionSupportsPLIDs: dataVersionSupportsPLIDs
    };

    return service;

    ////////////////

    /** getDataVersions - Returns the list of data versions that are currently supported by the Link Mapping API.
     * @param {Boolean} fullDataVersion - Optional switch to return full data version strings from the API. Default is false.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that resolves to an array of string
     * representing the data versions, or rejects to an empty array. The response would look like
     * `["NA-2016-02-12-7", "EU-2016-01-1-5"]`.
     * @memberof alkLinkMappingService
     */
    function getDataVersions() {
      var fullDataVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return $http({
        url: config.linkMappingUrl + "/get-dataversions",
        params: {
          fullVersion: fullDataVersion
        }
      }).then(function (resp) {
        return resp.data;
      }, function (err) {
        console.log(err);
        return [];
      });
    }

    /** dataVersionSupportsPLIDs - Returns whether or not the supplied data version is part of the Link Mapping API's list of supported data versions.
     * @param {String} dataVersion - The data version to check to see if it supports PLIDs. Default is the empty string.
     * @returns {Promise} Returns a [$q](https://docs.angularjs.org/api/ng/service/$q) promise that only resolves to a Boolean.
     * True if the data version supports PLIDs, or false if it doesn't.
     * @memberof alkLinkMappingService
     */
    function dataVersionSupportsPLIDs() {
      var dataVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      return getDataVersions().then(function (dataVersions) {
        return dataVersionHasPLIDs(dataVersion, dataVersions);
      });
    }

    function dataVersionHasPLIDs() {
      var dataVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var linkMappingDataVersions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (_.isEmpty(dataVersion) || dataVersion === "Current") {
        return true;
      }

      //  split by .
      var splitDataVersion = dataVersion.split(".");

      //  check length
      if (splitDataVersion.length < 7) {
        return false;
      }

      //  get components
      var components = [splitDataVersion[1], splitDataVersion[2], splitDataVersion[3], splitDataVersion[4], splitDataVersion[5]];

      var linkMappingDataVersion = components.join("-");
      return _.includes(linkMappingDataVersions, linkMappingDataVersion);
    }
  }
})();

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Used by all
__webpack_require__(48);
__webpack_require__(50);
__webpack_require__(108);

//Used by index.html
__webpack_require__(52);
__webpack_require__(111);
__webpack_require__(346);
__webpack_require__(112);
__webpack_require__(85);
__webpack_require__(114);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(115);
__webpack_require__(116);
__webpack_require__(117);
__webpack_require__(118);
__webpack_require__(349);
__webpack_require__(41);
__webpack_require__(350);
__webpack_require__(359);
__webpack_require__(55);
__webpack_require__(119);
__webpack_require__(120);
__webpack_require__(121);
__webpack_require__(122);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(372);
__webpack_require__(56);

// account component
__webpack_require__(123);
__webpack_require__(382);
__webpack_require__(62);
__webpack_require__(63);
__webpack_require__(64);
__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(124);
__webpack_require__(125);
__webpack_require__(126);
__webpack_require__(67);
__webpack_require__(127);
__webpack_require__(383);
__webpack_require__(128);
__webpack_require__(384);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);

// alk.common component
__webpack_require__(129);
__webpack_require__(68);
__webpack_require__(69);
__webpack_require__(388);
__webpack_require__(391);
__webpack_require__(393);
__webpack_require__(394);
__webpack_require__(395);

// PCM common components
__webpack_require__(130);
__webpack_require__(131);
__webpack_require__(132);
__webpack_require__(133);
__webpack_require__(134);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(137);
__webpack_require__(396);
__webpack_require__(138);

// map component
__webpack_require__(139); // use this to replace maps.service.js in alk.maps
__webpack_require__(397);
__webpack_require__(140);
__webpack_require__(398);
__webpack_require__(399);
__webpack_require__(407);
__webpack_require__(408);

// layout component
__webpack_require__(141);
__webpack_require__(410);
__webpack_require__(411);
__webpack_require__(412);
__webpack_require__(413);

// route component
__webpack_require__(142);
__webpack_require__(143);
__webpack_require__(415);
__webpack_require__(416);
__webpack_require__(148);

// application settings component
__webpack_require__(149);
__webpack_require__(417);

// report component
__webpack_require__(150);

// search component
__webpack_require__(418);
__webpack_require__(419);

// places component
__webpack_require__(420);
__webpack_require__(421);
__webpack_require__(422);
__webpack_require__(423);

// routeSync component
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(426);
__webpack_require__(427);

// vehicle component
__webpack_require__(151);
__webpack_require__(152);

// AFs component
__webpack_require__(428);
__webpack_require__(429);
__webpack_require__(430);

__webpack_require__(153);
__webpack_require__(154);
__webpack_require__(155);
__webpack_require__(432);

__webpack_require__(70);
__webpack_require__(71);
__webpack_require__(156);
__webpack_require__(72);
__webpack_require__(157);
__webpack_require__(73);
__webpack_require__(158);
__webpack_require__(159);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.directives", ["alk.services", "alk.filters"]);

  angular.module("alk.directives").directive("onlyDigits", function () {

    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ctrl) {
        function inputValue(val) {
          if (val) {
            var digits = val.replace(/[^0-9]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }
            return parseInt(digits, 10);
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
  });

  angular.module("alk.directives").directive("alkInteger", function () {
    return {
      require: "ngModel",
      link: function link(scope, elm, attrs, ctrl) {
        var INTEGER_REGEXP = /^\d+$/;

        function integerValidation(val) {
          if (!val || INTEGER_REGEXP.test(val)) {
            ctrl.$setValidity("pcmInteger", true);
            return val;
          } else {
            ctrl.$setValidity("pcmInteger", false);
            return undefined;
          }
        }

        ctrl.$parsers.unshift(integerValidation);
        ctrl.$formatters.unshift(integerValidation);
      }
    };
  });

  angular.module("alk.directives").directive("copyrightText", ["$compile", function ($compile) {
    return {
      scope: {
        type: "@"
      },
      restrict: "AE",
      replace: true,
      link: function link(scope, elem, attrs) {
        // jshint ignore:line
        var templates = {
          Default: "<span class=\"copyright-text\">Copyright &copy; <a target=\"_blank\" href=\"https://maps.trimble.com\">Trimble, Inc.</a> 1986-{{year}}</span>",
          WebUI: "<span class=\"copyright-text\">Copyright &copy; 2010-{{year}} Trimble, Inc. All Rights Reserved.</span>"
        };
        scope.year = new Date().getFullYear();
        var html = "";
        if (scope.type === "WebUI") {
          html = templates.WebUI;
        } else {
          html = templates.Default;
        }
        elem.replaceWith($compile(html)(scope));
      }
    };
  }]);

  angular.module("alk.directives").directive("alkEmail", function () {
    var REGEX_EMAIL = /^([\w!#$%&"*+\/=?^_`{|}~.-]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,24}|[0-9]{1,3})(\]?)$/;

    return {
      restrict: "A",
      require: "ngModel",
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$validators.alkEmail = function (modelValue) {
          if (modelValue === null || modelValue === "") {
            return true;
          }
          return REGEX_EMAIL.test(modelValue);
        };
      }
    };
  });

  angular.module("alk.directives").directive("alkCompare", function () {
    var d = {
      restrict: "A",
      require: "ngModel",
      scope: {},
      link: function link(scope, element, attr, control) {
        scope.$watch("alkCompare", function () {
          control.$validate();
        });

        control.$validators.alkCompare = function (modelValue, viewValue) {
          var value = modelValue || viewValue;
          var other = scope.alkCompare;
          return value === other;
        };
      }
    };

    d.scope.alkCompare = "=";

    return d;
  });

  angular.module("alk.directives").directive("alkSubmit", ["$parse", "$timeout", function ($parse, $timeout) {
    return {
      restrict: "A",
      require: ["form"],
      link: function link(scope, element, attrs, controllers) {
        var formController = controllers[0];
        var fn = $parse(attrs.alkSubmit);
        var submitIfFn;

        if (attrs.alkSubmitIf) {
          submitIfFn = $parse(attrs.alkSubmitIf);
        }

        formController.shouldSubmit = function (event) {
          if (typeof submitIfFn === "function" && submitIfFn(scope, {
            $event: event
          }) === false) {
            return false;
          }

          return true;
        };

        formController.needsAttention = function (field) {
          return field.$invalid && formController.submitted;
        };

        formController.setSubmitted = function (val) {
          formController.submitted = val;
          if (!scope.$$phase) scope.$apply();
        };

        element.bind("submit", function (event) {
          if (formController.shouldSubmit(event) === false) {
            return;
          }

          formController.setSubmitted(true);

          if (!scope.$$phase) scope.$apply();

          if (!formController.$valid) return false;

          $timeout(function () {
            formController.setSubmitted(false);
            fn(scope, {
              $event: event
            });
          });
        });
      }
    };
  }]);

  angular.module("alk.directives").directive("alkMessages", ["Messages", "_", function (Messages, _) {

    var templateString = "<div id=\"messages\">" + "<div class=\"alert alert-{{ message.type }}\" ng-repeat=\"message in messages\">" + "<a class=\"close\" ng-click=\"closeMessage(message)\" data-dismiss=\"alert\">&times;</a>" + "<span ng-bind-html=\"message.message | unsafe\"></span>" + "</div>" + "</div>";

    return {
      restrict: "E",
      template: templateString,
      scope: {},
      controller: ["$scope", function ($scope) {
        var messages = Messages.getMessages();

        for (var i = 0; i < messages.length; i++) {
          messages[i].read = true;
        }
        $scope.messages = messages;

        $scope.closeMessage = function (message) {
          message.closed = true;
          var index = $scope.messages.indexOf(message);
          $scope.messages.splice(index, 1);
        };

        $scope.$watchCollection(function () {
          return Messages.getMessages();
        }, function (messages) {
          for (var j = 0; j < messages.length; j++) {
            messages[j].read = true;
          }
          $scope.messages = messages;
        });
      }],
      link: function link(scope, element, attrs) {}
    };
  }]);

  angular.module("alk.directives").directive("alkAutofocus", ["$timeout", "$parse", function ($timeout, $parse) {
    return {
      restrict: "A",
      link: function link($scope, $element, attrs) {
        if (attrs.alkAutofocus === "" || $parse(attrs.alkAutofocus)($scope)) {
          $timeout(function () {
            $element[0].focus();
          });
        }
      }
    };
  }]);

  angular.module("alk.directives").directive("alkDisabled", [function () {
    return {
      restrict: "A",
      scope: {
        alkDisabled: "="
      },
      controller: ["$scope", function ($scope) {
        this.getDisabled = function () {
          return $scope.alkDisabled;
        };
      }]
    };
  }]);

  var disabledInputDirective = [function () {
    return {
      restrict: "E",
      require: "?^alkDisabled",
      link: function link($scope, $element, attrs, alkDisableController) {
        if (!alkDisableController) return;

        $scope.$watch(function () {
          return alkDisableController.getDisabled();
        }, function (newValue, oldValue) {
          if (newValue === true) {
            $element.attr("disabled", "disabled");
          } else {
            $element.removeAttr("disabled");
          }
        }, true);
      }
    };
  }];

  angular.module("alk.directives").directive("button", disabledInputDirective).directive("select", disabledInputDirective).directive("input", disabledInputDirective);

  var mapsInputDirective = ["$rootScope", function ($rootScope) {
    return {
      restrict: "E",
      require: "?^alkmap",
      link: function link($scope, $element, attrs, alkMapController) {
        if (!alkMapController) {
          $element.on("focus", function () /* event */{
            $rootScope.$broadcast("MapInputFocus", $element);
          });

          $element.on("blur", function () {
            $rootScope.$broadcast("MapInputBlur", $element);
          });
        }
      }
    };
  }];

  angular.module("alk.directives").directive("input", mapsInputDirective).directive("textarea", mapsInputDirective);

  angular.module("alk.directives").directive("alkmapsInput", ["$rootScope", function alkmapsInput($rootScope) {
    function link(scope, element /*, attrs */) {
      element.on("focus", function () /* event */{
        $rootScope.$broadcast("MapInputFocus", element);
      });

      element.on("blur", function () {
        $rootScope.$broadcast("MapInputBlur", element);
      });
    }

    var directive = {
      link: link,
      restrict: "A",
      scope: {}
    };

    return directive;
  }]);

  angular.module("alk.directives").directive("includeReplace", function () {
    return {
      require: "ngInclude",
      restrict: "A",
      link: function link(scope, el, attrs) {
        el.replaceWith(el.children());
      }
    };
  });
})();

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  "use strict";

  angular.module("alk.maps").factory("mapUtilities", ["ALKMaps", "mapService", "PCMRegion", function mapUtilities(ALKMaps, mapService, PCMRegion) {
    //colors to use on the map with 50% opacity
    var mapColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"];
    //colors to use in the UI at full opacity that match the mapColors above at 50% opacity
    var uiColors = ["#889EE1", "#DBA47F", "#B98BD0", "#8EB5D3", "#DA86AC", "#A286DE", "#7FCEE1", "#F29E7F"];

    var mapBaseLayerDefs = {
      "WW": {
        index: 0,
        name: "WWMap",
        region: "EU",
        dataset: "current"
      },
      "NA": {
        index: 1,
        name: "NAMap",
        region: "NA",
        dataset: "Current"
      },
      "EU": {
        index: 2,
        name: "EUMap",
        region: "EU",
        dataset: "PCM_EU"
      },
      "SA": {
        index: 3,
        name: "SAMap",
        region: "SA",
        dataset: "PCM_SA"
      },
      "OC": {
        index: 4,
        name: "OCMap",
        region: "OC",
        dataset: "PCM_OC"
      },
      "ME": {
        index: 5,
        name: "MEMap",
        region: "ME",
        dataset: "PCM_ME"
      },
      "AS": {
        index: 6,
        name: "ASMap",
        region: "AS",
        dataset: "PCM_AS"
      },
      "AF": {
        index: 7,
        name: "AFMap",
        region: "AF",
        dataset: "PCM_AF"
      }
    };

    var service = {
      getMapColor: getMapColor,
      getUIColor: getUIColor,
      parseCenterParams: parseCenterParams,
      LLtoMerc: LLtoMerc,
      MercToLL: MercToLL,
      zoomToCurrentLocation: zoomToCurrentLocation,
      attachScopeToMapEvents: attachScopeToMapEvents,
      deactivateKeyboardControl: deactivateKeyboardControl,
      activateKeyboardControl: activateKeyboardControl,
      getMapBaseLayerDefs: getMapBaseLayerDefs,
      getRegionFromLonLat: getRegionFromLonLat,
      getCenterLonLatFromRegion: getCenterLonLatFromRegion,
      isPolygonSelfIntersecting: isPolygonSelfIntersecting,
      getDistanceFromCoords: getDistanceFromCoords
    };

    return service;

    ///////////////////////
    function getMapColor(index) {
      if (typeof index !== "undefined" && isNumeric(index)) {
        return mapColors[index % mapColors.length];
      } else {
        return mapColors;
      }
    }

    function getUIColor(index) {
      if (typeof index !== "undefined" && isNumeric(index)) {
        return mapColors[index % mapColors.length];
      } else {
        return mapColors;
      }
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function parseCenterParams(params) {
      if (params && params.center) {
        var args = params.center.split(",");
        if (args.length === 3) {
          var zoom = parseInt(args[0], 10),
              lat = parseFloat(args[1]),
              lon = parseFloat(args[2]);
          if (isNaN(zoom) || isNaN(lat) || isNaN(lon)) {
            return false;
          } else {
            return {
              center: [lon, lat],
              zoom: zoom
            };
          }
        } else {
          return false;
        }
      }
    }

    function zoomToCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          mapService.setCenter(LLtoMerc(position.coords.longitude, position.coords.latitude), 16);
        }, function (error) {
          console.log(error);
        }, {
          timeout: 10000
        });
      }
    }

    function LLtoMerc(lon, lat) {
      if ((typeof lon === "undefined" ? "undefined" : _typeof(lon)) === "object") {
        lat = lon.lat;
        lon = lon.lon;
      }
      return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
    }

    function MercToLL(lon, lat) {
      if ((typeof lon === "undefined" ? "undefined" : _typeof(lon)) === "object") {
        lat = lon.lat;
        lon = lon.lon;
      }
      return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
    }

    function attachScopeToMapEvents(scopeToAttach) {
      scopeToAttach.$on("MapInputFocus", function (event, message) {
        // jshint ignore:line
        deactivateKeyboardControl();
      });

      scopeToAttach.$on("MapInputBlur", function () /*event, message */{
        activateKeyboardControl();
      });
    }

    function deactivateKeyboardControl() {
      var map = mapService.getMap();
      if (map == null) {
        return;
      }

      for (var i = 0; i < map.controls.length; i++) {
        if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
          map.controls[i].deactivate();
        }
      }
    }

    function activateKeyboardControl() {
      var map = mapService.getMap();
      if (map == null) {
        return;
      }

      for (var i = 0; i < map.controls.length; i++) {
        if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
          map.controls[i].activate();
        }
      }
    }

    function getMapBaseLayerDefs() {
      return mapBaseLayerDefs;
    }

    function getRegionFromLonLat(centerlon, centerlat) {
      var region = "NA";

      if (centerlat > -36 && centerlat < 11.5 && centerlon > -27 && centerlon < 64 || centerlat > 11.501 && centerlat < 34 && centerlon > -27 && centerlon < 34) {
        region = "AF";
      } else if (centerlat > -10.8 && centerlat < 10.38 && centerlon > 70 && centerlon < 146 || centerlat > 8 && centerlat < 27.2 && centerlon > 71.2 && centerlon < 92.15 || centerlat > 0 && centerlat < 25.6 && centerlon > 120 && centerlon < 130) {
        region = "AS";
      } else if (centerlat > 37.6 && centerlat < 71.5 && centerlon > -15 && centerlon < 39.5 || centerlat > 55.8 && centerlat < 78 && centerlon > 0 && centerlon < 179.9 || centerlat > 27.63 && centerlat < 33.20 && centerlon > -18.25 && centerlon < -13.40) {
        region = "EU";
      } else if (centerlat > 25 && centerlat < 75 && centerlon > -168 && centerlon < -30 || centerlat > 14.6 && centerlat < 25 && centerlon > -162 && centerlon < -93 || centerlat > 17.5 && centerlat < 19 && centerlon > -67.5 && centerlon < -63.5) {
        region = "NA";
      } else if (centerlat > -44.65 && centerlat < -12.2 && centerlon > 112.3 && centerlon < 153.4 || centerlat > -47.5 && centerlat < -33 && centerlon > 165 && centerlon < 179) {
        region = "OC";
      } else if (centerlat > 22.75 && centerlat < 27.1 && centerlon > -79.4 && centerlon < -73 || centerlat > 32.2 && centerlat < 32.5 && centerlon > -65 && centerlon < -64.5 || centerlat > 17.5 && centerlat < 23 && centerlon > -74.1 && centerlon < -67.8) {
        region = "SA";
      } else if (centerlat > -60 && centerlat < 24 && centerlon > -86 && centerlon < -32) {
        region = "SA";
      } else if (centerlat > 17.5 && centerlat < 20.1 && centerlon > -74.5 && centerlon < -68.3) {
        region = "WW";
      } else {
        var lonlat = new ALKMaps.LonLat(centerlon, centerlat);
        var results = ALKMaps.Geocoder.reverseGeocode({
          lonLat: lonlat,
          async: false,
          region: "EU",
          dataset: "current"
        });

        if (results[0].Address != null && results[0].Region != null) {
          var regionFromGeocoder = results[0].Region;
          var currentState = results[0].Address.State;
          if (regionFromGeocoder === PCMRegion.AF) {
            region = "AF";
          } else if (regionFromGeocoder === PCMRegion.AS) {
            if (currentState === "PK") {
              region = "WW";
            } else {
              region = "AS";
            }
          } else if (regionFromGeocoder === PCMRegion.EU) {
            region = "EU";
          } else if (regionFromGeocoder === PCMRegion.NA) {
            region = "NA";
          } else if (regionFromGeocoder === PCMRegion.OC) {
            region = "OC";
          } else if (regionFromGeocoder === PCMRegion.SA) {
            region = "SA";
          } else if (regionFromGeocoder === PCMRegion.ME) {
            region = "ME";
          }
        }
      }

      return region;
    }

    function getCenterLonLatFromRegion(region) {
      if (!region) region = "NA";

      var zoom = 5;
      var lat = 38.5;
      var lon = -95;

      if (region === "WW") {
        zoom = 3, lat = 31.5;
        lon = -44;
      } else if (region === "EU") {
        zoom = 5;
        lat = 47.8;
        lon = 8.4;
      } else if (region === "OC") {
        zoom = 5;
        lat = -27.387;
        lon = 133.164;
      } else if (region === "SA") {
        zoom = 4;
        lat = -19.24;
        lon = -57.43;
      } else if (region === "AF") {
        zoom = 4;
        lat = 8.95;
        lon = 17.46;
      } else if (region === "AS") {
        zoom = 5;
        lat = 19.87;
        lon = 84.21;
      } else if (region === "ME") {
        zoom = 5;
        lat = 30.24;
        lon = 62.85;
      }

      return {
        zoom: zoom,
        lat: lat,
        lon: lon
      };
    }

    function isPolygonSelfIntersecting(polygon) {
      var outer = [];
      if (polygon.CLASS_NAME === "ALKMaps.Geometry.LinearRing") {
        outer = polygon.components;
      } else if (polygon.CLASS_NAME === "ALKMaps.Geometry.Polygon") {
        outer = polygon.components[0].components;
      }
      var segments = outer.slice(1).map(function (right, i) {
        var left = outer[i];
        return new ALKMaps.Geometry.LineString([left.clone(), right.clone()]);
      });
      return segments.some(function (segment) {
        return segmentIntersects(segment, segments);
      });
    }

    function segmentIntersects(segment1, segments) {
      return segments.some(function (segment2) {
        return !startOrStopEquals(segment1, segment2) && segment1.intersects(segment2);
      });
    }

    function startOrStopEquals(segment1, segment2) {
      if (segment1.components[0].equals(segment2.components[0])) {
        return true;
      }
      if (segment1.components[0].equals(segment2.components[1])) {
        return true;
      }
      if (segment1.components[1].equals(segment2.components[0])) {
        return true;
      }
      if (segment1.components[1].equals(segment2.components[1])) {
        return true;
      }
      return false;
    }

    /*
      calculate the real distance between 2 point.
      If coords are in degree, pass in projection "EPSG:4326"
      If coords are in meters, pass in projection "EPSG:900913"
    */
    function getDistanceFromCoords(lonlat1, lonlat2, projection) {
      var line = new ALKMaps.Geometry.LineString([lonlat1, lonlat2]);
      return line.getGeodesicLength(new ALKMaps.Projection(projection));
    }
  }]);
})();

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.maps").factory("savedMapInfo", savedMapInfo);
  savedMapInfo.$inject = ["$rootScope", "$location", "ALKMaps", "UserProvider", "mapUtilities"];

  function savedMapInfo($rootScope, $location, ALKMaps, UserProvider, mapUtilities) {
    var mapElem = {};

    var service = {
      getSavedInfo: getSavedInfo,
      saveCurrentInfo: saveCurrentInfo,
      getSavedInfoAsUrl: getSavedInfoAsUrl
    };

    $rootScope.$on("UserLoggedIn", function () {
      mapElem.savedInfo = null;
    });

    $rootScope.$on("releaseMap", function (event, data) {
      mapElem = mapElem || {};
      mapElem.savedInfo = mapElem.savedInfo || {};
      mapElem.savedInfo.mapCenter = data.center;
      mapElem.savedInfo.mapZoom = data.zoom;
      mapElem.savedInfo.mapStyle = data.style;
    });

    return service;

    function getSavedInfoAsUrl() {
      var savedInfo = getSavedInfo();
      var precision = Math.max(0, Math.ceil(Math.log(savedInfo.mapZoom) / Math.LN2));
      var center = angular.copy(savedInfo.mapCenter).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
      var urlCenterParam = [savedInfo.mapZoom, center.lat.toFixed(precision), center.lon.toFixed(precision)].join(",");
      return urlCenterParam;
    }

    function saveCurrentInfo(center, zoom, style) {
      mapElem = mapElem || {};
      mapElem.savedInfo = mapElem.savedInfo || {};
      mapElem.savedInfo.mapCenter = center;
      mapElem.savedInfo.mapZoom = zoom;
      mapElem.savedInfo.mapStyle = style;
    }

    function getSavedInfo() {
      if (mapElem.savedInfo) return mapElem.savedInfo;

      var zoom;
      var center;
      var urlCenter = mapUtilities.parseCenterParams($location.search());
      var couldTryGeolocating = false;
      if (urlCenter) {
        center = mapUtilities.LLtoMerc(urlCenter.center[0], urlCenter.center[1]);
        zoom = urlCenter.zoom;
      } else {
        // initial location of map is based on the region the user is setup for currently. in the future if the user has access to world wide, use the location of the browser possibly?
        if (UserProvider.getUser().region === "EU") {
          center = mapUtilities.LLtoMerc(8.403, 47.875);
          zoom = 5;
        } else {
          center = mapUtilities.LLtoMerc(-95, 38.5);
          zoom = 5;
        }

        //  if there is no saved info, and we had to fallback to just a default lat/lon for a region,
        //  then it is up to the app to choose if they want to geolocate instead.
        couldTryGeolocating = true;
      }

      return {
        mapCenter: center,
        mapStyle: ALKMaps.STYLE.DEFAULT,
        mapZoom: zoom,
        couldTryGeolocating: couldTryGeolocating
      };
    }
  }
})();

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("alk.constants")
/** @name COUNTRIES
 * @ngdoc constant
 * @description Provides the countries supported by ALK applications. The constant is
 * an object keyed by [PCMRegion](alk.constants.PCMRegion.html) strings that map to an array of
 * objects of the form
 * `{ name: string, id: number, abbreviation: string}`
 * @memberof alk.constants
 */
.constant("COUNTRIES", {
  "AF": [{
    "name": "Algeria",
    "id": 3,
    "abbreviation": "DZ"
  }, {
    "name": "Angola",
    "id": 6,
    "abbreviation": "AO"
  }, {
    "name": "Benin",
    "id": 22,
    "abbreviation": "BJ"
  }, {
    "name": "Botswana",
    "id": 27,
    "abbreviation": "BW"
  }, {
    "name": "Burkina Faso",
    "id": 32,
    "abbreviation": "BF"
  }, {
    "name": "Burundi",
    "id": 34,
    "abbreviation": "BI"
  }, {
    "name": "Cameroon",
    "id": 36,
    "abbreviation": "CM"
  }, {
    "name": "Cape Verde",
    "id": 38,
    "abbreviation": "CV"
  }, {
    "name": "Central African Republic",
    "id": 40,
    "abbreviation": "CF"
  }, {
    "name": "Chad",
    "id": 41,
    "abbreviation": "TD"
  }, {
    "name": "Comoros",
    "id": 46,
    "abbreviation": "KM"
  }, {
    "name": "Congo, Democratic Republic (Kinshasa)",
    "id": 176,
    "abbreviation": "CG"
  }, {
    "name": "Congo, Replublic of the (Brazzaville)",
    "id": 47,
    "abbreviation": "CD"
  }, {
    "name": "Djibouti",
    "id": 56,
    "abbreviation": "DJ"
  }, {
    "name": "Egypt",
    "id": 61,
    "abbreviation": "EG"
  }, {
    "name": "Equatorial Guinea",
    "id": 63,
    "abbreviation": "GQ"
  }, {
    "name": "Eritrea",
    "id": 64,
    "abbreviation": "ER"
  }, {
    "name": "Ethiopia",
    "id": 66,
    "abbreviation": "ET"
  }, {
    "name": "Gabon",
    "id": 75,
    "abbreviation": "GA"
  }, {
    "name": "Gambia",
    "id": 76,
    "abbreviation": "GM"
  }, {
    "name": "Ghana",
    "id": 79,
    "abbreviation": "GH"
  }, {
    "name": "Guinea",
    "id": 87,
    "abbreviation": "GN"
  }, {
    "name": "Guinea-Bissau",
    "id": 88,
    "abbreviation": "GW"
  }, {
    "name": "Ivory Coast (Cote d'Ivoire)",
    "id": 103,
    "abbreviation": "CI"
  }, {
    "name": "Kenya",
    "id": 108,
    "abbreviation": "KE"
  }, {
    "name": "Lesotho",
    "id": 118,
    "abbreviation": "LS"
  }, {
    "name": "Liberia",
    "id": 119,
    "abbreviation": "LR"
  }, {
    "name": "Libya",
    "id": 120,
    "abbreviation": "LY"
  }, {
    "name": "Madagascar",
    "id": 126,
    "abbreviation": "MG"
  }, {
    "name": "Malawi",
    "id": 127,
    "abbreviation": "MW"
  }, {
    "name": "Mali",
    "id": 130,
    "abbreviation": "ML"
  }, {
    "name": "Mauritania",
    "id": 134,
    "abbreviation": "MR"
  }, {
    "name": "Mauritius",
    "id": 135,
    "abbreviation": "MU"
  }, {
    "name": "Mayotte",
    "id": 136,
    "abbreviation": "YT"
  }, {
    "name": "Morocco",
    "id": 145,
    "abbreviation": "MA"
  }, {
    "name": "Mozambique",
    "id": 146,
    "abbreviation": "MZ"
  }, {
    "name": "Namibia",
    "id": 148,
    "abbreviation": "NA"
  }, {
    "name": "Niger",
    "id": 156,
    "abbreviation": "NE"
  }, {
    "name": "Nigeria",
    "id": 157,
    "abbreviation": "NG"
  }, {
    "name": "Rwanda",
    "id": 180,
    "abbreviation": "RW"
  }, {
    "name": "Saint Helena",
    "id": 181,
    "abbreviation": "SH"
  }, {
    "name": "Sao Tome and Principe",
    "id": 187,
    "abbreviation": "ST"
  }, {
    "name": "Senegal",
    "id": 189,
    "abbreviation": "SN"
  }, {
    "name": "Seychelles",
    "id": 190,
    "abbreviation": "SC"
  }, {
    "name": "Sierra Leone",
    "id": 191,
    "abbreviation": "SL"
  }, {
    "name": "Somalia",
    "id": 196,
    "abbreviation": "SO"
  }, {
    "name": "South Africa",
    "id": 197,
    "abbreviation": "ZA"
  }, {
    "name": "South Sudan",
    "id": 246,
    "abbreviation": "SS"
  }, {
    "name": "Sudan",
    "id": 200,
    "abbreviation": "SD"
  }, {
    "name": "Swaziland",
    "id": 203,
    "abbreviation": "SZ"
  }, {
    "name": "Tanzania",
    "id": 209,
    "abbreviation": "TZ"
  }, {
    "name": "Togo",
    "id": 211,
    "abbreviation": "TG"
  }, {
    "name": "Tunisia",
    "id": 215,
    "abbreviation": "TN"
  }, {
    "name": "Uganda",
    "id": 220,
    "abbreviation": "UG"
  }, {
    "name": "Western Sahara",
    "id": 234,
    "abbreviation": "EH"
  }, {
    "name": "Zambia",
    "id": 238,
    "abbreviation": "ZM"
  }, {
    "name": "Zimbabwe",
    "id": 239,
    "abbreviation": "ZW"
  }],
  "AS": [{
    "name": "Bangladesh",
    "id": 17,
    "abbreviation": "BD"
  }, {
    "name": "Bhutan",
    "id": 24,
    "abbreviation": "BT"
  }, {
    "name": "British Indian Ocean Territory",
    "id": 252,
    "abbreviation": "IO"
  }, {
    "name": "Brunei",
    "id": 30,
    "abbreviation": "BN"
  }, {
    "name": "Burma (Myanmar)",
    "id": 33,
    "abbreviation": "MM"
  }, {
    "name": "Cambodia",
    "id": 35,
    "abbreviation": "KH"
  }, {
    "name": "China",
    "id": 44,
    "abbreviation": "CN"
  }, {
    "name": "Guam",
    "id": 85,
    "abbreviation": "GU"
  }, {
    "name": "Hong Kong",
    "id": 92,
    "abbreviation": "HK"
  }, {
    "name": "India",
    "id": 95,
    "abbreviation": "IN"
  }, {
    "name": "Indonesia",
    "id": 96,
    "abbreviation": "ID"
  }, {
    "name": "Japan",
    "id": 105,
    "abbreviation": "JP"
  }, {
    "name": "Korea, North",
    "id": 111,
    "abbreviation": "KP"
  }, {
    "name": "Korea, South",
    "id": 112,
    "abbreviation": "KR"
  }, {
    "name": "Laos",
    "id": 115,
    "abbreviation": "LA"
  }, {
    "name": "Macau (Macao)",
    "id": 124,
    "abbreviation": "MO"
  }, {
    "name": "Malaysia",
    "id": 128,
    "abbreviation": "MY"
  }, {
    "name": "Maldives",
    "id": 129,
    "abbreviation": "MV"
  }, {
    "name": "Mongolia",
    "id": 142,
    "abbreviation": "MN"
  }, {
    "name": "Nepal",
    "id": 150,
    "abbreviation": "NP"
  }, {
    "name": "Northern Mariana Islands",
    "id": 160,
    "abbreviation": "MP"
  }, {
    "name": "Pakistan",
    "id": 163,
    "abbreviation": "PK"
  }, {
    "name": "Palau",
    "id": 164,
    "abbreviation": "PW"
  }, {
    "name": "Papua New Guinea",
    "id": 167,
    "abbreviation": "PG"
  }, {
    "name": "Philippines",
    "id": 170,
    "abbreviation": "PH"
  }, {
    "name": "Singapore",
    "id": 192,
    "abbreviation": "SG"
  }, {
    "name": "Solomon Islands",
    "id": 195,
    "abbreviation": "SB"
  }, {
    "name": "Sri Lanka",
    "id": 199,
    "abbreviation": "LK"
  }, {
    "name": "Taiwan",
    "id": 207,
    "abbreviation": "TW"
  }, {
    "name": "Thailand",
    "id": 210,
    "abbreviation": "TH"
  }, {
    "name": "Timor-Leste",
    "id": 59,
    "abbreviation": "TL"
  }, {
    "name": "Vietnam",
    "id": 231,
    "abbreviation": "VN"
  }],
  "EU": [{
    "name": "Akrotiri",
    "id": 249,
    "abbreviation": "(blank)"
  }, {
    "name": "Albania",
    "id": 2,
    "abbreviation": "AL"
  }, {
    "name": "Andorra",
    "id": 5,
    "abbreviation": "AD"
  }, {
    "name": "Armenia",
    "id": 10,
    "abbreviation": "AM"
  }, {
    "name": "Austria",
    "id": 13,
    "abbreviation": "AT"
  }, {
    "name": "Azerbaijan",
    "id": 14,
    "abbreviation": "AZ"
  }, {
    "name": "Belarus",
    "id": 21,
    "abbreviation": "BY"
  }, {
    "name": "Belgium",
    "id": 19,
    "abbreviation": "BE"
  }, {
    "name": "Bosnia and Herzegovina",
    "id": 26,
    "abbreviation": "BA"
  }, {
    "name": "Bulgaria",
    "id": 31,
    "abbreviation": "BG"
  }, {
    "name": "Channel Islands",
    "id": 42,
    "abbreviation": "(blank)"
  }, {
    "name": "Croatia",
    "id": 51,
    "abbreviation": "HR"
  }, {
    "name": "Cyprus",
    "id": 53,
    "abbreviation": "CY"
  }, {
    "name": "Czech Republic",
    "id": 54,
    "abbreviation": "CZ"
  }, {
    "name": "Denmark",
    "id": 55,
    "abbreviation": "DK"
  }, {
    "name": "Dhekelia",
    "id": 251,
    "abbreviation": "(blank)"
  }, {
    "name": "Estonia",
    "id": 65,
    "abbreviation": "EE"
  }, {
    "name": "Faroe Islands",
    "id": 67,
    "abbreviation": "FO"
  }, {
    "name": "Finland",
    "id": 70,
    "abbreviation": "FI"
  }, {
    "name": "France",
    "id": 71,
    "abbreviation": "FR"
  }, {
    "name": "Georgia",
    "id": 77,
    "abbreviation": "GE"
  }, {
    "name": "Germany",
    "id": 78,
    "abbreviation": "DE"
  }, {
    "name": "Gibraltar",
    "id": 80,
    "abbreviation": "GI"
  }, {
    "name": "Greece",
    "id": 81,
    "abbreviation": "GR"
  }, {
    "name": "Guernsey",
    "id": 243,
    "abbreviation": "GG"
  }, {
    "name": "Hungary",
    "id": 93,
    "abbreviation": "HU"
  }, {
    "name": "Iceland",
    "id": 94,
    "abbreviation": "IS"
  }, {
    "name": "Ireland",
    "id": 99,
    "abbreviation": "IE"
  }, {
    "name": "Isle of Man",
    "id": 100,
    "abbreviation": "IM"
  }, {
    "name": "Italy",
    "id": 102,
    "abbreviation": "IT"
  }, {
    "name": "Jersey",
    "id": 244,
    "abbreviation": "JE"
  }, {
    "name": "Kazakhstan",
    "id": 107,
    "abbreviation": "KZ"
  }, {
    "name": "Kosovo",
    "id": 240,
    "abbreviation": "XK"
  }, {
    "name": "Kyrgyzstan",
    "id": 114,
    "abbreviation": "KG"
  }, {
    "name": "Latvia",
    "id": 116,
    "abbreviation": "LV"
  }, {
    "name": "Liechtenstein",
    "id": 121,
    "abbreviation": "LI"
  }, {
    "name": "Lithuania",
    "id": 122,
    "abbreviation": "LT"
  }, {
    "name": "Luxembourg",
    "id": 123,
    "abbreviation": "LU"
  }, {
    "name": "Macedonia",
    "id": 125,
    "abbreviation": "MK"
  }, {
    "name": "Malta",
    "id": 131,
    "abbreviation": "MT"
  }, {
    "name": "Moldova",
    "id": 140,
    "abbreviation": "MD"
  }, {
    "name": "Monaco",
    "id": 141,
    "abbreviation": "MC"
  }, {
    "name": "Montenegro",
    "id": 143,
    "abbreviation": "ME"
  }, {
    "name": "Netherlands",
    "id": 151,
    "abbreviation": "NL"
  }, {
    "name": "Norway",
    "id": 161,
    "abbreviation": "NO"
  }, {
    "name": "Poland",
    "id": 172,
    "abbreviation": "PL"
  }, {
    "name": "Portugal",
    "id": 173,
    "abbreviation": "PT"
  }, {
    "name": "Romania",
    "id": 178,
    "abbreviation": "RO"
  }, {
    "name": "Russia",
    "id": 179,
    "abbreviation": "RU"
  }, {
    "name": "San Marino",
    "id": 186,
    "abbreviation": "SM"
  }, {
    "name": "Serbia",
    "id": 237,
    "abbreviation": "RS"
  }, {
    "name": "Slovakia",
    "id": 193,
    "abbreviation": "SK"
  }, {
    "name": "Slovenia",
    "id": 194,
    "abbreviation": "SI"
  }, {
    "name": "Spain",
    "id": 198,
    "abbreviation": "ES"
  }, {
    "name": "Svalbard Islands",
    "id": 202,
    "abbreviation": "SJ"
  }, {
    "name": "Sweden",
    "id": 204,
    "abbreviation": "SE"
  }, {
    "name": "Switzerland",
    "id": 205,
    "abbreviation": "CH"
  }, {
    "name": "Tajikistan",
    "id": 208,
    "abbreviation": "TJ"
  }, {
    "name": "Turkey",
    "id": 216,
    "abbreviation": "TR"
  }, {
    "name": "Turkmenistan",
    "id": 217,
    "abbreviation": "TM"
  }, {
    "name": "Ukraine",
    "id": 221,
    "abbreviation": "UA"
  }, {
    "name": "United Kingdom",
    "id": 223,
    "abbreviation": "GB"
  }, {
    "name": "Uzbekistan",
    "id": 227,
    "abbreviation": "UZ"
  }, {
    "name": "Vatican City",
    "id": 229,
    "abbreviation": "VA"
  }],
  "ME": [{
    "name": "Afghanistan",
    "id": 1,
    "abbreviation": "AF"
  }, {
    "name": "Bahrain",
    "id": 16,
    "abbreviation": "BH"
  }, {
    "name": "Gaza Strip",
    "id": 248,
    "abbreviation": "XG"
  }, {
    "name": "Iran",
    "id": 97,
    "abbreviation": "IR"
  }, {
    "name": "Iraq",
    "id": 98,
    "abbreviation": "IQ"
  }, {
    "name": "Israel",
    "id": 101,
    "abbreviation": "IL"
  }, {
    "name": "Jordan",
    "id": 106,
    "abbreviation": "JO"
  }, {
    "name": "Kuwait",
    "id": 113,
    "abbreviation": "KW"
  }, {
    "name": "Lebanon",
    "id": 117,
    "abbreviation": "LB"
  }, {
    "name": "Oman",
    "id": 162,
    "abbreviation": "OM"
  }, {
    "name": "Palestinian Territory",
    "id": 165,
    "abbreviation": "PS"
  }, {
    "name": "Qatar",
    "id": 175,
    "abbreviation": "QA"
  }, {
    "name": "Saudi Arabia",
    "id": 188,
    "abbreviation": "SA"
  }, {
    "name": "Syria",
    "id": 206,
    "abbreviation": "SY"
  }, {
    "name": "United Arab Emirates",
    "id": 222,
    "abbreviation": "AE"
  }, {
    "name": "West Bank",
    "id": 250,
    "abbreviation": "XW"
  }, {
    "name": "Yemen",
    "id": 236,
    "abbreviation": "YE"
  }],
  "NA": [{
    "name": "Canada",
    "id": 37,
    "abbreviation": "CA"
  }, {
    "name": "Greenland",
    "id": 82,
    "abbreviation": "GL"
  }, {
    "name": "Mexico",
    "id": 137,
    "abbreviation": "MX"
  }, {
    "name": "Puerto Rico",
    "id": 174,
    "abbreviation": "PR"
  }, {
    "name": "Saint Pierre and Miquelon",
    "id": 184,
    "abbreviation": "PM"
  }, {
    "name": "United States",
    "id": 224,
    "abbreviation": "US"
  }, {
    "name": "Virgin Islands, U.S.",
    "id": 225,
    "abbreviation": "VI"
  }],
  "OC": [{
    "name": "American Samoa",
    "id": 4,
    "abbreviation": "AS"
  }, {
    "name": "Australia",
    "id": 12,
    "abbreviation": "AU"
  }, {
    "name": "Cook Islands",
    "id": 48,
    "abbreviation": "CK"
  }, {
    "name": "Fiji",
    "id": 69,
    "abbreviation": "FJ"
  }, {
    "name": "French Polynesia",
    "id": 73,
    "abbreviation": "PF"
  }, {
    "name": "French Southern and Antarctic Lands",
    "id": 74,
    "abbreviation": "TF"
  }, {
    "name": "Kiribati",
    "id": 110,
    "abbreviation": "KI"
  }, {
    "name": "Marshall Islands",
    "id": 132,
    "abbreviation": "MH"
  }, {
    "name": "Micronesia, Federated States of",
    "id": 138,
    "abbreviation": "FM"
  }, {
    "name": "Midway Island",
    "id": 139,
    "abbreviation": "UM"
  }, {
    "name": "Nauru",
    "id": 149,
    "abbreviation": "NR"
  }, {
    "name": "New Caledonia",
    "id": 153,
    "abbreviation": "NC"
  }, {
    "name": "New Zealand",
    "id": 154,
    "abbreviation": "NZ"
  }, {
    "name": "Niue",
    "id": 158,
    "abbreviation": "NU"
  }, {
    "name": "Norfolk Island",
    "id": 159,
    "abbreviation": "NF"
  }, {
    "name": "Pitcairn Islands",
    "id": 171,
    "abbreviation": "PN"
  }, {
    "name": "Samoa (Western Samoa)",
    "id": 235,
    "abbreviation": "WS"
  }, {
    "name": "Tokelau",
    "id": 212,
    "abbreviation": "TK"
  }, {
    "name": "Tonga",
    "id": 213,
    "abbreviation": "TO"
  }, {
    "name": "Tuvalu",
    "id": 219,
    "abbreviation": "TV"
  }, {
    "name": "Vanuatu",
    "id": 228,
    "abbreviation": "VU"
  }, {
    "name": "Wake Island",
    "id": 232,
    "abbreviation": "WQ"
  }, {
    "name": "Wallis and Futuna",
    "id": 233,
    "abbreviation": "WF"
  }],
  "SA": [{
    "name": "Anguilla",
    "id": 7,
    "abbreviation": "AI"
  }, {
    "name": "Antigua and Barbuda",
    "id": 8,
    "abbreviation": "AG"
  }, {
    "name": "Argentina",
    "id": 9,
    "abbreviation": "AR"
  }, {
    "name": "Aruba",
    "id": 11,
    "abbreviation": "AW"
  }, {
    "name": "Bahamas",
    "id": 15,
    "abbreviation": "BS"
  }, {
    "name": "Barbados",
    "id": 18,
    "abbreviation": "BB"
  }, {
    "name": "Belize",
    "id": 20,
    "abbreviation": "BZ"
  }, {
    "name": "Bermuda",
    "id": 23,
    "abbreviation": "BM"
  }, {
    "name": "Bolivia",
    "id": 25,
    "abbreviation": "BO"
  }, {
    "name": "Brazil",
    "id": 28,
    "abbreviation": "BR"
  }, {
    "name": "Caribbean Netherlands",
    "id": 152,
    "abbreviation": "BQ"
  }, {
    "name": "Cayman Islands",
    "id": 39,
    "abbreviation": "KY"
  }, {
    "name": "Chile",
    "id": 43,
    "abbreviation": "CL"
  }, {
    "name": "Colombia",
    "id": 45,
    "abbreviation": "CO"
  }, {
    "name": "Costa Rica",
    "id": 49,
    "abbreviation": "CR"
  }, {
    "name": "Cuba",
    "id": 52,
    "abbreviation": "CU"
  }, {
    "name": "Curacao",
    "id": 50,
    "abbreviation": "CW"
  }, {
    "name": "Dominica",
    "id": 57,
    "abbreviation": "DM"
  }, {
    "name": "Dominican Republic",
    "id": 58,
    "abbreviation": "DO"
  }, {
    "name": "Ecuador",
    "id": 60,
    "abbreviation": "EC"
  }, {
    "name": "El Salvador",
    "id": 62,
    "abbreviation": "SV"
  }, {
    "name": "Falkland Islands (Islas Malvinas)",
    "id": 68,
    "abbreviation": "FK"
  }, {
    "name": "French Guiana",
    "id": 72,
    "abbreviation": "GF"
  }, {
    "name": "Grenada",
    "id": 83,
    "abbreviation": "GD"
  }, {
    "name": "Guadeloupe",
    "id": 84,
    "abbreviation": "GP"
  }, {
    "name": "Guantanamo Bay",
    "id": 241,
    "abbreviation": "(blank)"
  }, {
    "name": "Guatemala",
    "id": 86,
    "abbreviation": "GT"
  }, {
    "name": "Guyana",
    "id": 89,
    "abbreviation": "GY"
  }, {
    "name": "Haiti",
    "id": 90,
    "abbreviation": "HT"
  }, {
    "name": "Honduras",
    "id": 91,
    "abbreviation": "HN"
  }, {
    "name": "Jamaica",
    "id": 104,
    "abbreviation": "JM"
  }, {
    "name": "Martinique",
    "id": 133,
    "abbreviation": "MQ"
  }, {
    "name": "Montserrat",
    "id": 144,
    "abbreviation": "MS"
  }, {
    "name": "Nicaragua",
    "id": 155,
    "abbreviation": "NI"
  }, {
    "name": "Panama",
    "id": 166,
    "abbreviation": "PA"
  }, {
    "name": "Paraguay",
    "id": 168,
    "abbreviation": "PY"
  }, {
    "name": "Peru",
    "id": 169,
    "abbreviation": "PE"
  }, {
    "name": "Saint Barthelemy",
    "id": 242,
    "abbreviation": "BL"
  }, {
    "name": "Saint Kitts and Nevis",
    "id": 182,
    "abbreviation": "KN"
  }, {
    "name": "Saint Lucia",
    "id": 183,
    "abbreviation": "LC"
  }, {
    "name": "Saint Martin",
    "id": 245,
    "abbreviation": "MF"
  }, {
    "name": "Saint Vincent and the Grenadines",
    "id": 185,
    "abbreviation": "VC"
  }, {
    "name": "Sint Maarten",
    "id": 247,
    "abbreviation": "SX"
  }, {
    "name": "Suriname",
    "id": 201,
    "abbreviation": "SR"
  }, {
    "name": "Trinidad and Tobago",
    "id": 214,
    "abbreviation": "TT"
  }, {
    "name": "Turks and Caicos Islands",
    "id": 218,
    "abbreviation": "TC"
  }, {
    "name": "Uruguay",
    "id": 226,
    "abbreviation": "UY"
  }, {
    "name": "Venezuela",
    "id": 230,
    "abbreviation": "VE"
  }, {
    "name": "Virgin Islands, British",
    "id": 29,
    "abbreviation": "VG"
  }]
});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.import", []);
})(window.angular);

__webpack_require__(351);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(357);
__webpack_require__(358);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(352);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./importStyles.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./importStyles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".importFieldsForm {\n  /*\n  .importScrollWrapper {\n    display: block;\n    max-height: 800px;\n    overflow-y: auto;\n  }\n  */\n}\n.importFieldsForm table {\n  width: 100%;\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.importFieldsForm .fieldHeaderCol {\n  max-width: 150px;\n  padding-right: 5px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: default;\n}\n.importFieldsForm .fieldValueCol {\n  padding-right: 5px;\n}\n.importFieldsForm .firstFiveCol {\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n#dragDropFileDiv {\n  width: 100%;\n  height: 50px;\n  line-height: 50px;\n  border: 2px dashed lightgray;\n  text-align: center;\n  font-size: 12px;\n  border-radius: 5px;\n  color: #aaa;\n  cursor: default;\n  margin-top: 7px;\n  margin-bottom: 5px;\n}\n#dragDropFileDiv.dragDropFileDivHover {\n  border: 2px dashed #87CEFA;\n}\n#importFileName {\n  color: #555555;\n  font-weight: 600;\n  font-size: 12px;\n}\n.import-errors {\n  max-height: 200px;\n  overflow-y: auto;\n  margin-bottom: 6px;\n}\n.import-warnings {\n  margin-bottom: 6px;\n}\n.selectable-match-cell {\n  position: relative;\n  border: 0;\n  cursor: pointer;\n  padding: 5px 15px 5px 10px !important;\n}\n.selectable-match-cell:hover .match-cell-checkbox {\n  display: block;\n}\n.match-cell-select {\n  border: 1px solid #68A6DD;\n  padding: 4px 14px 4px 9px !important;\n}\n.match-cell-checkbox {\n  display: none;\n  position: absolute;\n  color: #ccc;\n  top: -1px;\n  right: 1px;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  outline: none;\n}\n.match-cell-select .match-cell-checkbox {\n  top: -2px;\n  right: 0px;\n  color: #68A6DD;\n  display: block;\n}\n.import-copilot-settings .checkbox {\n  display: inline-block;\n}\n.import-address-warning {\n  display: inline-block;\n  margin-left: 10px;\n  color: #a70101;\n}\n.import-address-row-highlight {\n  background-color: #ffecc4;\n}\n.import-address-row-error-highlight {\n  background-color: #ebccd1;\n}\n", ""]);

// exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
This service contains all import field objects and import helper functions for Content Tools place/modifiers import and PCMWebUI Stops import.
*/
/* globals ALKMaps, _ */
var config = __webpack_require__(1);

(function () {
  "use strict";

  angular.module("alk.import").factory("alkImportService", alkImportService);

  alkImportService.$inject = ["$q", "PCMRegion", "UserProvider", "$http", "alkModalService", "$translate", "placeCloudService", "MAXDBLENGTHS", "STATES", "COUNTRIES", "$injector"];

  function alkImportService($q, PCMRegion, UserProvider, $http, alkModalService, $translate, placeCloudService, MAXDBLENGTHS, STATES, COUNTRIES, $injector) {

    var INVALID_CHAR_REGEX = /^[^\^/\\]+$/;

    //The base import field ES6 class. It holds metadata for an import field (i.e. place name, latitude).
    //All import fields will extend from this class.
    //NOTE: does not store the actual value read from CSV. This is done in importFieldsModal.controller.js.

    var BaseImportField = function () {
      function BaseImportField(params) {
        _classCallCheck(this, BaseImportField);

        this.name = params.name; //Internal name of the import field, used by the code only.
        this.translationId = params.translationId; //Translation ID of the import field that contains the translated user-facing name of the field.
        this.maxLength = params.maxLength; //The max amount of characters this field can have before the import system throws an error.
        //List of necessary import fields: throws error if this field exists, but a dependency does not.
        this.dependencies = [];
        if (params.dependencies)
          //Returns an array of ImportField objects; since they are ES6 classes, they must be instantiated first
          this.dependencies = params.dependencies.map(function (Dependency) {
            return new Dependency();
          });
      }

      //Check if the value provided as header is a suitable header for this import field type (i.e. Place Name, Latitude, etc.)


      _createClass(BaseImportField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase().includes(this.name.toLowerCase()) || headerVal.toLowerCase().includes(this.getTranslatedName());
        }

        //Get a translated name to use in messages (i.e. place name)

      }, {
        key: "getTranslatedName",
        value: function getTranslatedName() {
          return $translate.instant(this.translationId).toLowerCase();
        }

        //Get a translated name to use in messages in title case. (i.e. Place Name)

      }, {
        key: "getTranslatedNameTitleCase",
        value: function getTranslatedNameTitleCase() {
          return $translate.instant(this.translationId);
        }

        //Returns an array of strings. To be overridden by subclasses as necessary.

      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return [];
        }
      }]);

      return BaseImportField;
    }();

    /////////////////////////////////////////////////////////////////////////
    //COMMON FIELDS (SHARED BY BOTH CONTENTTOOLS PLACES AND PCMWEBUI STOPS)//
    /////////////////////////////////////////////////////////////////////////

    var LatitudeField = function (_BaseImportField) {
      _inherits(LatitudeField, _BaseImportField);

      function LatitudeField() {
        _classCallCheck(this, LatitudeField);

        return _possibleConstructorReturn(this, (LatitudeField.__proto__ || Object.getPrototypeOf(LatitudeField)).call(this, {
          name: "Latitude",
          translationId: "common.Latitude"
        }));
      }

      _createClass(LatitudeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase() === "lat" || _get(LatitudeField.prototype.__proto__ || Object.getPrototypeOf(LatitudeField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) return [];
          if (!isLatValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidLatitude") + ")"];
          }
          return [];
        }
      }]);

      return LatitudeField;
    }(BaseImportField);

    var LongitudeField = function (_BaseImportField2) {
      _inherits(LongitudeField, _BaseImportField2);

      function LongitudeField() {
        _classCallCheck(this, LongitudeField);

        return _possibleConstructorReturn(this, (LongitudeField.__proto__ || Object.getPrototypeOf(LongitudeField)).call(this, {
          name: "Longitude",
          translationId: "common.Longitude"
        }));
      }

      _createClass(LongitudeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.toLowerCase() === "lon" || _get(LongitudeField.prototype.__proto__ || Object.getPrototypeOf(LongitudeField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) return [];
          if (!isLonValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidLongitude") + ")"];
          }
          return [];
        }
      }]);

      return LongitudeField;
    }(BaseImportField);

    var LatLonField = function (_BaseImportField3) {
      _inherits(LatLonField, _BaseImportField3);

      function LatLonField() {
        _classCallCheck(this, LatLonField);

        return _possibleConstructorReturn(this, (LatLonField.__proto__ || Object.getPrototypeOf(LatLonField)).call(this, {
          name: "LatLon",
          translationId: "common.latLon"
        }));
      }

      _createClass(LatLonField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          var latIndex = headerVal.toLowerCase().indexOf("lat");
          var lonIndex = headerVal.toLowerCase().indexOf("lon");
          return latIndex !== -1 && lonIndex !== -1 && latIndex < lonIndex || _get(LatLonField.prototype.__proto__ || Object.getPrototypeOf(LatLonField.prototype), "suitableHeader", this).call(this, headerVal);
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
          if (!fieldValue) return [];

          var _fieldValue$split = fieldValue.split(","),
              _fieldValue$split2 = _slicedToArray(_fieldValue$split, 2),
              lat = _fieldValue$split2[0],
              lon = _fieldValue$split2[1];

          if (_.isUndefined(lon)) return [fieldErr + " (" + $translate.instant("common.import.invalidLatLonNoComma") + ")"];

          if (!isLatValid(lat) || !isLonValid(lon)) return [fieldErr + " (" + $translate.instant("common.import.invalidLatLon") + ")"];

          return [];
        }
      }]);

      return LatLonField;
    }(BaseImportField);

    var StreetAddressField = function (_BaseImportField4) {
      _inherits(StreetAddressField, _BaseImportField4);

      function StreetAddressField() {
        _classCallCheck(this, StreetAddressField);

        return _possibleConstructorReturn(this, (StreetAddressField.__proto__ || Object.getPrototypeOf(StreetAddressField)).call(this, {
          name: "StreetAddress",
          translationId: "common.StreetAddress",
          maxLength: MAXDBLENGTHS.STREET
        }));
      }

      _createClass(StreetAddressField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return headerVal.includes("street") || headerVal.includes("address");
        }
      }]);

      return StreetAddressField;
    }(BaseImportField);

    var CityField = function (_BaseImportField5) {
      _inherits(CityField, _BaseImportField5);

      function CityField() {
        _classCallCheck(this, CityField);

        return _possibleConstructorReturn(this, (CityField.__proto__ || Object.getPrototypeOf(CityField)).call(this, {
          name: "City",
          translationId: "common.City",
          maxLength: MAXDBLENGTHS.CITY
        }));
      }

      _createClass(CityField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return CityField;
    }(BaseImportField);

    var StateField = function (_BaseImportField6) {
      _inherits(StateField, _BaseImportField6);

      function StateField() {
        _classCallCheck(this, StateField);

        var _this6 = _possibleConstructorReturn(this, (StateField.__proto__ || Object.getPrototypeOf(StateField)).call(this, {
          name: "State",
          translationId: "common.State"
        }));

        _this6.statesList = UserProvider.getUser().region === "NA" ? STATES : [];
        return _this6;
      }

      _createClass(StateField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (this.statesList.length < 1) {
            return [];
          }
          var found = this.statesList.some(function (state) {
            return state.abbreviation.toLowerCase() === fieldValue.toLowerCase();
          });
          if (!found) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + "               (" + $translate.instant("common.import.invalidState") + ")"];
          }
          return [];
        }
      }, {
        key: "setRegion",
        value: function setRegion() {
          this.statesList = UserProvider.getUser().region === "NA" ? STATES : [];
        }
      }]);

      return StateField;
    }(BaseImportField);

    var ZipField = function (_BaseImportField7) {
      _inherits(ZipField, _BaseImportField7);

      function ZipField() {
        _classCallCheck(this, ZipField);

        return _possibleConstructorReturn(this, (ZipField.__proto__ || Object.getPrototypeOf(ZipField)).call(this, {
          name: "Zip",
          translationId: "common.Zip",
          maxLength: MAXDBLENGTHS.ZIP
        }));
      }

      return ZipField;
    }(BaseImportField);

    var CountyField = function (_BaseImportField8) {
      _inherits(CountyField, _BaseImportField8);

      function CountyField() {
        _classCallCheck(this, CountyField);

        return _possibleConstructorReturn(this, (CountyField.__proto__ || Object.getPrototypeOf(CountyField)).call(this, {
          name: "County",
          translationId: "common.County",
          maxLength: MAXDBLENGTHS.COUNTRY
        }));
      }

      return CountyField;
    }(BaseImportField);

    var CountryField = function (_BaseImportField9) {
      _inherits(CountryField, _BaseImportField9);

      function CountryField() {
        _classCallCheck(this, CountryField);

        return _possibleConstructorReturn(this, (CountryField.__proto__ || Object.getPrototypeOf(CountryField)).call(this, {
          name: "Country",
          translationId: "common.Country",
          maxLength: MAXDBLENGTHS.COUNTRY
        }));
      }

      return CountryField;
    }(BaseImportField);

    ///////////////////////////////////////
    //CONTENTTOOLS SPECIFIC PLACES FIELDS//
    ///////////////////////////////////////

    var PlaceNameField = function (_BaseImportField10) {
      _inherits(PlaceNameField, _BaseImportField10);

      function PlaceNameField() {
        _classCallCheck(this, PlaceNameField);

        return _possibleConstructorReturn(this, (PlaceNameField.__proto__ || Object.getPrototypeOf(PlaceNameField)).call(this, {
          name: "PlaceName",
          translationId: "templates.importPlaces.placeNameField",
          maxLength: MAXDBLENGTHS.PLACE_NAME
        }));
      }

      _createClass(PlaceNameField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _.includes(headerVal, "name");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return PlaceNameField;
    }(BaseImportField);

    var CompanyIdField = function (_BaseImportField11) {
      _inherits(CompanyIdField, _BaseImportField11);

      function CompanyIdField() {
        _classCallCheck(this, CompanyIdField);

        return _possibleConstructorReturn(this, (CompanyIdField.__proto__ || Object.getPrototypeOf(CompanyIdField)).call(this, {
          name: "CompanyId",
          translationId: "common.PID",
          maxLength: MAXDBLENGTHS.CID
        }));
      }

      _createClass(CompanyIdField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!/^[A-Za-z0-9]*$/.test(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.invalidCompanyId") + "): " + fieldValue];
          }
          return [];
        }
      }]);

      return CompanyIdField;
    }(BaseImportField);

    var CountryAbbrevField = function (_BaseImportField12) {
      _inherits(CountryAbbrevField, _BaseImportField12);

      // pchen: back-compat with State (e.g., GB) export
      function CountryAbbrevField() {
        _classCallCheck(this, CountryAbbrevField);

        var _this12 = _possibleConstructorReturn(this, (CountryAbbrevField.__proto__ || Object.getPrototypeOf(CountryAbbrevField)).call(this, {
          name: "CountryAbbreviation",
          translationId: "common.CountryAbbreviation"
        }));

        _this12.countryList = COUNTRIES[UserProvider.getUser().region];
        return _this12;
      }

      _createClass(CountryAbbrevField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          var countries = this.countryList;
          var found = countries.some(function (country) {
            return country.abbreviation.toLowerCase() === fieldValue.toLowerCase();
          });
          if (!found) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + "               (" + $translate.instant("common.import.invalidState") + ")"];
          }
          return [];
        }
      }, {
        key: "setRegion",
        value: function setRegion() {
          this.countryList = COUNTRIES[UserProvider.getUser().region];
        }
      }]);

      return CountryAbbrevField;
    }(BaseImportField);

    var PhoneField = function (_BaseImportField13) {
      _inherits(PhoneField, _BaseImportField13);

      function PhoneField() {
        _classCallCheck(this, PhoneField);

        return _possibleConstructorReturn(this, (PhoneField.__proto__ || Object.getPrototypeOf(PhoneField)).call(this, {
          name: "Phone",
          translationId: "common.PhoneNumber",
          maxLength: MAXDBLENGTHS.PHONE
        }));
      }

      _createClass(PhoneField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return PhoneField;
    }(BaseImportField);

    var CommentsField = function (_BaseImportField14) {
      _inherits(CommentsField, _BaseImportField14);

      function CommentsField() {
        _classCallCheck(this, CommentsField);

        return _possibleConstructorReturn(this, (CommentsField.__proto__ || Object.getPrototypeOf(CommentsField)).call(this, {
          name: "Comments",
          translationId: "templates.importPlaces.commentField",
          maxLength: MAXDBLENGTHS.PLACE_COMMENTS
        }));
      }

      return CommentsField;
    }(BaseImportField);

    var YardNameField = function (_BaseImportField15) {
      _inherits(YardNameField, _BaseImportField15);

      function YardNameField() {
        _classCallCheck(this, YardNameField);

        return _possibleConstructorReturn(this, (YardNameField.__proto__ || Object.getPrototypeOf(YardNameField)).call(this, {
          name: "YardName",
          translationId: "templates.importPlaces.yardNameField",
          maxLength: MAXDBLENGTHS.YARD_NAME
        }));
      }

      _createClass(YardNameField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return YardNameField;
    }(BaseImportField);

    var YardPointsField = function (_BaseImportField16) {
      _inherits(YardPointsField, _BaseImportField16);

      function YardPointsField() {
        _classCallCheck(this, YardPointsField);

        return _possibleConstructorReturn(this, (YardPointsField.__proto__ || Object.getPrototypeOf(YardPointsField)).call(this, {
          name: "YardPoints",
          translationId: "templates.importPlaces.yardPointsField"
        }));
      }

      _createClass(YardPointsField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return []; //Can be blank
          }
          var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
          var errs = [fieldErr];
          var pieces = fieldValue.split("|");
          if (pieces < 3) {
            return errs; //Must have 3 points at least
          }
          // check all pieces valid
          if (!allLatLonValid(pieces)) {
            return errs;
          }

          var mapUtilities = $injector.get("mapUtilities");
          var coords = getYardPointsFromString(fieldValue).map(function (coord) {
            var mercLL = mapUtilities.LLtoMerc(coord[0], coord[1]);
            return new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat);
          });
          if (mapUtilities.isPolygonSelfIntersecting(new ALKMaps.Geometry.LinearRing(coords))) {
            var selfIntersectErr = $translate.instant("templates.importPlaces.siteSelfIntersecting");
            return [fieldErr + ": " + selfIntersectErr];
          }

          return [];
        }
      }]);

      return YardPointsField;
    }(BaseImportField);

    var GatesField = function (_BaseImportField17) {
      _inherits(GatesField, _BaseImportField17);

      function GatesField() {
        _classCallCheck(this, GatesField);

        return _possibleConstructorReturn(this, (GatesField.__proto__ || Object.getPrototypeOf(GatesField)).call(this, {
          name: "Gates",
          translationId: "templates.importPlaces.gates",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(GatesField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var enums = {
            GATE_TYPE: {
              ENTRY: "0",
              EXIT: "1",
              ENTRY_EXIT: "2"
            },
            RESTRICT: {
              FALSE: "0",
              TRUE: "1"
            }
          };

          if (!fieldValue) {
            return [];
          }
          var errors = [];

          var escPipeChar = String.fromCharCode(13);
          var escCaretChar = String.fromCharCode(14);
          var escBackslashChar = String.fromCharCode(15);

          fieldValue = getDecodedImportString(fieldValue, escPipeChar, escCaretChar, escBackslashChar);

          var gates = [];
          var gateStrs = fieldValue.split("^");

          if (gateStrs.length > 5) {
            errors.push(createGateError(fieldParams, "templates.importPlaces.tooManyGates"));
          }

          for (var i = 0; i < gateStrs.length; i++) {
            var gateStr = gateStrs[i];
            var pieces = gateStr.split("|");
            var gateNum = i + 1;

            if (pieces.length !== 6) {
              errors.push(createGateError(fieldParams, "templates.importPlaces.badGateFormat", { gateNum: gateNum }));
            } else {
              var _pieces = _slicedToArray(pieces, 6),
                  latlon = _pieces[0],
                  latlonSnap = _pieces[1],
                  gateType = _pieces[2],
                  autoRestrict = _pieces[3],
                  truckRestrict = _pieces[4],
                  note = _pieces[5];

              if (getLatLonFromString(latlon) === null) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateLatLonInvalid", { gateNum: gateNum }));
              }
              if (getLatLonFromString(latlonSnap) === null) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateLatLonSnapInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.GATE_TYPE, gateType)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateTypeInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.RESTRICT, autoRestrict)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateAutoRestrictInvalid", { gateNum: gateNum }));
              }
              if (!_.includes(enums.RESTRICT, truckRestrict)) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateTruckRestrictInvalid", { gateNum: gateNum }));
              }
              if (autoRestrict === enums.RESTRICT.TRUE && truckRestrict === enums.RESTRICT.TRUE) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.gateCannotRestrictBoth", { gateNum: gateNum }));
              }
              if (note.length > MAXDBLENGTHS.YARD_GATE_NOTE) {
                errors.push(createGateError(fieldParams, "templates.importPlaces.fieldErrGateNoteTooLong", { maxLength: MAXDBLENGTHS.YARD_GATE_NOTE, gateNum: gateNum }));
              }
            }
          }
          return errors;
        }
      }]);

      return GatesField;
    }(BaseImportField);

    var EntryLatLonField = function (_BaseImportField18) {
      _inherits(EntryLatLonField, _BaseImportField18);

      function EntryLatLonField() {
        _classCallCheck(this, EntryLatLonField);

        return _possibleConstructorReturn(this, (EntryLatLonField.__proto__ || Object.getPrototypeOf(EntryLatLonField)).call(this, {
          name: "EntryLatLon",
          translationId: "templates.importPlaces.entryLatLonField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(EntryLatLonField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return EntryLatLonField;
    }(BaseImportField);

    var EntryLatLonSnapField = function (_BaseImportField19) {
      _inherits(EntryLatLonSnapField, _BaseImportField19);

      function EntryLatLonSnapField() {
        _classCallCheck(this, EntryLatLonSnapField);

        return _possibleConstructorReturn(this, (EntryLatLonSnapField.__proto__ || Object.getPrototypeOf(EntryLatLonSnapField)).call(this, {
          name: "EntryLatLonSnap",
          translationId: "templates.importPlaces.entryLatLonSnapField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(EntryLatLonSnapField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return EntryLatLonSnapField;
    }(BaseImportField);

    var EntryNotesField = function (_BaseImportField20) {
      _inherits(EntryNotesField, _BaseImportField20);

      function EntryNotesField() {
        _classCallCheck(this, EntryNotesField);

        return _possibleConstructorReturn(this, (EntryNotesField.__proto__ || Object.getPrototypeOf(EntryNotesField)).call(this, {
          name: "EntryNotes",
          translationId: "templates.importPlaces.entryNotesField",
          maxLength: MAXDBLENGTHS.YARD_GATE_NOTE,
          dependencies: [YardPointsField]
        }));
      }

      return EntryNotesField;
    }(BaseImportField);

    var ExitLatLonField = function (_BaseImportField21) {
      _inherits(ExitLatLonField, _BaseImportField21);

      function ExitLatLonField() {
        _classCallCheck(this, ExitLatLonField);

        return _possibleConstructorReturn(this, (ExitLatLonField.__proto__ || Object.getPrototypeOf(ExitLatLonField)).call(this, {
          name: "ExitLatLon",
          translationId: "templates.importPlaces.exitLatLonField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(ExitLatLonField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return ExitLatLonField;
    }(BaseImportField);

    var ExitLatLonSnapField = function (_BaseImportField22) {
      _inherits(ExitLatLonSnapField, _BaseImportField22);

      function ExitLatLonSnapField() {
        _classCallCheck(this, ExitLatLonSnapField);

        return _possibleConstructorReturn(this, (ExitLatLonSnapField.__proto__ || Object.getPrototypeOf(ExitLatLonSnapField)).call(this, {
          name: "ExitLatLonSnap",
          translationId: "templates.importPlaces.exitLatLonSnapField",
          dependencies: [YardPointsField]
        }));
      }

      _createClass(ExitLatLonSnapField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!isLatLonStringValid(fieldValue)) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams)];
          }
          return [];
        }
      }]);

      return ExitLatLonSnapField;
    }(BaseImportField);

    var ExitNotesField = function (_BaseImportField23) {
      _inherits(ExitNotesField, _BaseImportField23);

      function ExitNotesField() {
        _classCallCheck(this, ExitNotesField);

        return _possibleConstructorReturn(this, (ExitNotesField.__proto__ || Object.getPrototypeOf(ExitNotesField)).call(this, {
          name: "ExitNotes",
          translationId: "templates.importPlaces.exitNotesField",
          maxLength: MAXDBLENGTHS.YARD_GATE_NOTE,
          dependencies: [YardPointsField]
        }));
      }

      return ExitNotesField;
    }(BaseImportField);

    var SiteDetailField = function (_BaseImportField24) {
      _inherits(SiteDetailField, _BaseImportField24);

      function SiteDetailField() {
        _classCallCheck(this, SiteDetailField);

        return _possibleConstructorReturn(this, (SiteDetailField.__proto__ || Object.getPrototypeOf(SiteDetailField)).call(this, {
          name: "SiteDetail",
          translationId: "templates.importPlaces.siteDetailField",
          maxLength: MAXDBLENGTHS.SITE_DETAIL
        }));
      }

      _createClass(SiteDetailField, [{
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          return validateNoInvalidChar(fieldValue, fieldParams);
        }
      }]);

      return SiteDetailField;
    }(BaseImportField);

    ///////////////////////////////////////////
    //PCM WEB UI STOPS SPECIFIC IMPORT FIELDS//
    ///////////////////////////////////////////

    var StopNameField = function (_BaseImportField25) {
      _inherits(StopNameField, _BaseImportField25);

      function StopNameField() {
        _classCallCheck(this, StopNameField);

        return _possibleConstructorReturn(this, (StopNameField.__proto__ || Object.getPrototypeOf(StopNameField)).call(this, {
          name: "StopName",
          translationId: "templates.importStops.stopNameField",
          maxLength: 100
        }));
      }

      _createClass(StopNameField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(StopNameField.prototype.__proto__ || Object.getPrototypeOf(StopNameField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("name");
        }
      }]);

      return StopNameField;
    }(BaseImportField);

    var EstimatedDurationField = function (_BaseImportField26) {
      _inherits(EstimatedDurationField, _BaseImportField26);

      function EstimatedDurationField() {
        _classCallCheck(this, EstimatedDurationField);

        return _possibleConstructorReturn(this, (EstimatedDurationField.__proto__ || Object.getPrototypeOf(EstimatedDurationField)).call(this, {
          name: "EstimatedDuration",
          translationId: "templates.importStops.estimatedDurationField",
          maxLength: 100
        }));
      }

      _createClass(EstimatedDurationField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(EstimatedDurationField.prototype.__proto__ || Object.getPrototypeOf(EstimatedDurationField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("duration");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          var stopService = $injector.get("stopService");
          if (!fieldValue) {
            return [];
          }
          if (stopService.getHoursFromString(fieldValue) === null) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidDuration") + ")"];
          }
          return [];
        }
      }]);

      return EstimatedDurationField;
    }(BaseImportField);

    var EarliestArrivalTimeField = function (_BaseImportField27) {
      _inherits(EarliestArrivalTimeField, _BaseImportField27);

      function EarliestArrivalTimeField() {
        _classCallCheck(this, EarliestArrivalTimeField);

        return _possibleConstructorReturn(this, (EarliestArrivalTimeField.__proto__ || Object.getPrototypeOf(EarliestArrivalTimeField)).call(this, {
          name: "EarliestArrivalTime",
          translationId: "templates.importStops.earliestArrivalTimeField",
          maxLength: 100
        }));
      }

      _createClass(EarliestArrivalTimeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(EarliestArrivalTimeField.prototype.__proto__ || Object.getPrototypeOf(EarliestArrivalTimeField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("earliest");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!moment(fieldValue, "HH:mm").isValid()) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidEarliestArrivalTime") + ")"];
          }
          return [];
        }
      }]);

      return EarliestArrivalTimeField;
    }(BaseImportField);

    var LatestArrivalTimeField = function (_BaseImportField28) {
      _inherits(LatestArrivalTimeField, _BaseImportField28);

      function LatestArrivalTimeField() {
        _classCallCheck(this, LatestArrivalTimeField);

        return _possibleConstructorReturn(this, (LatestArrivalTimeField.__proto__ || Object.getPrototypeOf(LatestArrivalTimeField)).call(this, {
          name: "LatestArrivalTime",
          translationId: "templates.importStops.latestArrivalTimeField",
          maxLength: 100
        }));
      }

      _createClass(LatestArrivalTimeField, [{
        key: "suitableHeader",
        value: function suitableHeader(headerVal) {
          return _get(LatestArrivalTimeField.prototype.__proto__ || Object.getPrototypeOf(LatestArrivalTimeField.prototype), "suitableHeader", this).call(this, headerVal) || headerVal.includes("latest");
        }
      }, {
        key: "getErrors",
        value: function getErrors(fieldValue, fieldParams) {
          if (!fieldValue) {
            return [];
          }
          if (!moment(fieldValue, "HH:mm").isValid()) {
            return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("templates.importStops.invalidLatestArrivalTime") + ")"];
          }
          return [];
        }
      }]);

      return LatestArrivalTimeField;
    }(BaseImportField);

    ////////////////////
    //HELPER FUNCTIONS//
    ////////////////////

    //If FileReader is undefined, the import CSV feature won't work


    function browserImportIncompatible() {
      var oldBrowser = false;
      try {
        var fileReaderTest = FileReader;
      } catch (err) {
        oldBrowser = true;
      }
      return oldBrowser;
    }

    function createGateError(fieldParams, translateKey, gateParams) {
      var fieldErr = $translate.instant("common.import.fieldErrInvalid", fieldParams);
      var gateErr = $translate.instant(translateKey, gateParams);
      return fieldErr + " (" + gateErr + ")";
    }

    function filterErrors(errs) {
      //Hide rest of errors if over 100 AND 50 more will be hidden
      if (errs.length > 100) {
        var hiddenErrCount = errs.length - 100;
        if (hiddenErrCount >= 50) {
          errs = errs.slice(0, 100);
          errs.push($translate.instant("common.import.tooManyErrors", { num: hiddenErrCount }));
        }
      }
      return errs;
    }

    function testCompanyIds(cidList) {
      return placeCloudService.testCompanyIds(cidList);
    }

    function importPlaces(places, importType) {
      var wizardData = alkModalService.getCurrentWizardData();
      var setName = wizardData.setName;
      var setId = wizardData.selectedSet ? wizardData.selectedSet.Id : "";
      var category = wizardData.selectedCategory; // should only be used if importing New Set
      return placeCloudService.getCategoryForSet(wizardData.selectedSet).then(function (catId) {
        if (wizardData.selectedSet && wizardData.selectedSet.Categories && wizardData.selectedSet.Categories[0]) {
          catId = wizardData.selectedSet.Categories[0].Id;
        }
        var setOptions = wizardData.copilotOptions;

        places = _.map(places, function (row) {
          var place = {};
          place.placeName = row.PlaceName;
          place.companyId = row.CompanyId;
          place.latitude = row.Latitude;
          place.longitude = row.Longitude;
          place.street = row.StreetAddress;
          place.city = row.City;
          place.state = row.State;
          place.zip = row.Zip;
          place.country = row.Country;
          place.phone = row.Phone;
          place.info = row.Comments;
          place.yardName = row.YardName;
          place.yardPoints = getYardPointsFromString(row.YardPoints);
          place.gates = getGatesFromString(row.Gates);

          var entryLatLon = getLatLonFromString(row.EntryLatLon);
          var entryLatLonSnap = getLatLonFromString(row.EntryLatLonSnap);
          var entryNotes = row.EntryNotes;
          if (entryLatLon && entryLatLonSnap) {
            var entryGate = {
              Coords: entryLatLon,
              SnapCoords: entryLatLonSnap,
              Type: 0,
              AutoRestricted: false,
              TruckRestricted: false,
              NoteContent: entryNotes
            };
            place.gates.push(entryGate);
          }

          var exitLatLon = getLatLonFromString(row.ExitLatLon);
          var exitLatLonSnap = getLatLonFromString(row.ExitLatLonSnap);
          var exitNotes = row.ExitNotes;
          if (exitLatLon && exitLatLonSnap) {
            var exitGate = {
              Coords: exitLatLon,
              SnapCoords: exitLatLonSnap,
              Type: 1,
              AutoRestricted: false,
              TruckRestricted: false,
              NoteContent: exitNotes
            };
            place.gates.push(exitGate);
          }

          // don't need to send "" to database
          if (row.SiteDetail) {
            place.siteDetail = row.SiteDetail;
          }

          return place;
        });

        return setPLIDsForPlaces(places).then(function () {
          var deferred = $q.defer();
          var promise;
          if (importType === 0) {
            promise = importPlacesNewSet(setName, places, setOptions, category);
          } else if (importType === 1) {
            promise = importPlacesAppend(setId, catId, places);
          } else if (importType === 2) {
            promise = importPlacesReplace(setId, catId, places);
          }
          promise.then(function (result) {
            if (!result) {
              deferred.reject($translate.instant("common.import.unknownError"));
            } else {
              deferred.resolve(result);
            }
          });
          return deferred.promise;
        });
      });
    }

    //Return array of plid promises for each this place's gates
    function setClosestPLIDToLonLat(place) {
      var linkWebService = $injector.get("linkWebService");
      var promises = [];

      var _loop = function _loop(gate) {
        var lon = gate.SnapCoords.Lon;
        var lat = gate.SnapCoords.Lat;
        var deferred = $q.defer();
        var left = lon;
        var bottom = lat;
        var right = lon;
        var top = lat;
        var bounds = new ALKMaps.Bounds(Number(left) - 0.001, Number(bottom) + 0.001, Number(right) + 0.001, Number(top) - 0.001);
        var mapDataVersion = UserProvider.getUser().dataVersion || "Current";
        var promise = linkWebService.getLinks(bounds.toBBOX(), mapDataVersion).then(function (results) {
          //console.log(results.data.features);
          var plid = "";
          var min = Number.POSITIVE_INFINITY;
          var minResult = null;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = results.data.features[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var result = _step2.value;

              var points = _.map(result.geometry.coordinates, function (coord) {
                return new ALKMaps.Geometry.Point(coord[0], coord[1]);
              });
              var linkGeom = new ALKMaps.Geometry.LineString(points);
              var dist = linkGeom.distanceTo(new ALKMaps.Geometry.Point(lon, lat));
              if (dist < min) {
                min = dist;
                minResult = result;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (minResult && minResult.properties.plid) {
            plid = minResult.properties.plid;
          }
          gate.plid = plid;
        });
        promises.push(promise);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = place.gates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var gate = _step.value;

          _loop(gate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return promises;
    }

    //Need to get PLID from snap coords before importing
    function setPLIDsForPlaces(places) {
      var deferred = $q.defer();
      var plidPromises = [];

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = places[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var place = _step3.value;

          plidPromises = plidPromises.concat(setClosestPLIDToLonLat(place));
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      $q.all(plidPromises).then(function () {
        deferred.resolve();
      });
      return deferred.promise;
    }

    //Helper function used by the import functions below that create the places and yards
    function importPlacesAndYardsHelper(setId, catId, places) {
      var deferred = $q.defer();
      var placesWithoutYards = _.remove(places, function (place) {
        return !place.yardPoints; //No points, no yard. Must have points for any of the other yard fields to make sense
      });
      var placeIds, yardIds;

      _.each(places, function (place, index) {
        //If the place doesn't have a yard name, give it one
        if (!place.yardName) {
          place.yardName = $translate.instant("templates.yards.unnamedYard");
        }
      });

      //Add the places without yards (this is batched for performance)
      placeCloudService.saveNewPlaces(setId, catId, placesWithoutYards).then(function (response) {
        if (!response) {
          deferred.resolve(null);
          return;
        }
        //If there are no places with yards, just quit here
        if (places.length === 0) {
          deferred.resolve({
            setId: setId
          });
          return;
        }
        //Add the places with yards
        addPlaceYardRecursiveHelper(0, catId);
      });

      return deferred.promise;

      //Initiates the callback chain for adding a single place and its yard data.
      function addPlaceYardRecursiveHelper(index, catId) {
        if (index >= places.length) {
          deferred.resolve({
            setId: setId
          });
          return;
        }
        var place = places[index];
        var yardId;
        //Add place
        placeCloudService.saveNewPlace(setId, catId, place).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          place.Id = response.Id;
          //Add yard
          return placeCloudService.addYard({
            yardName: place.yardName,
            shapePoints: place.yardPoints,
            siteDetail: place.siteDetail
          });
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          yardId = response.Id;
          //Add place to yard
          return placeCloudService.addPlaceToYard(yardId, place.Id, true);
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          //Add all yard gates
          return placeCloudService.addYardGates(yardId, place.gates).then(function (gatesRes) {
            //Any one failed: return failed
            if (gatesRes.indexOf(null) > -1) {
              deferred.resolve(null);
              return;
            }
            return response;
          });
        }).then(function (response) {
          if (!response) {
            deferred.resolve(null);
            return;
          }
          addPlaceYardRecursiveHelper(index + 1, catId);
        });
      }
    }

    function importPlacesNewSet(setName, places, options, category) {
      var deferred = $q.defer();
      var setId = "";
      var setStyle = category;
      //Add the place set
      placeCloudService.addPlaceSet(setName, null, true, options, setStyle).then(function (response) {
        if (!response) {
          deferred.resolve(null);
          return;
        }
        setId = response.Id;
        placeCloudService.addCategoryForSet(setName, setId, options, category.Icon).then(function (catResponse) {
          importPlacesAndYardsHelper(setId, catResponse.Id, places).then(function (placesResponse) {
            if (!placesResponse)
              // pchen: if failed, manually rollback places creation
              placeCloudService.deletePlaceSet(setId);
            deferred.resolve(placesResponse);
          });
        });
      });

      return deferred.promise;
    }

    function importPlacesAppend(setId, catId, places) {
      var deferred = $q.defer();
      //Add the places
      importPlacesAndYardsHelper(setId, catId, places).then(function (response) {
        deferred.resolve(response);
      });
      return deferred.promise;
    }

    function importPlacesReplace(setId, catId, places) {
      var deferred = $q.defer();
      //Get the places in the set
      placeCloudService.getPlaces(setId).then(function (getResponse) {
        if (!getResponse) {
          deferred.resolve(null);
          return;
        }
        var placeIdList = [];
        _.each(getResponse.Places, function (place) {
          placeIdList.push(place.Id);
        });
        return placeCloudService.deletePlaces(placeIdList);
        //Delete the places in the set
      }).then(function (deleteResponse) {
        if (!deleteResponse) {
          deferred.resolve(null);
          return;
        }
        importPlacesAndYardsHelper(setId, catId, places).then(function (importResponse) {
          deferred.resolve(importResponse);
        });
      });
      return deferred.promise;
    }

    //"file" is js file input variable (i.e. files[0])
    function importExceptions(file, setId, setName, replace) {
      var deferred = $q.defer();
      /*deferred.resolve();
      return deferred.promise;
      */
      var reader = new FileReader();
      reader.onload = function () {
        var base64EncodedString = reader.result;
        base64EncodedString = base64EncodedString.split(",")[1];
        var b = atob(base64EncodedString);
        var byteNumbers = new Array(b.length);
        for (var i = 0; i < b.length; i++) {
          byteNumbers[i] = b.charCodeAt(i);
        }
        var request = {
          method: "POST",
          url: config.pcmwsUrl + "AvoidFavorSets/import",
          headers: {
            Authorization: config.alkmapsApiKey
          },
          params: {
            dataset: UserProvider.getUser().dataset || UserProvider.getUser().dataVersion || "Current"
          },
          data: {
            SetName: !setId ? setName : "",
            SetTag: null,
            SetID: !setId ? -1 : setId,
            FileBytes: byteNumbers,
            Replace: !replace ? false : replace
          }
        };
        $http(request).then(function (response) {
          //success
          deferred.resolve(response.data);
        }, function (response) {
          //fail
          deferred.reject(response);
        });
      };
      reader.onerror = function (err) {
        deferred.reject(err);
      };
      reader.readAsDataURL(file);
      return deferred.promise;
    }

    function isLatLonStringValid(latLonString) {
      if (!latLonString) {
        return true; //Can be blank
      }
      var coords = getLatLonFromString(latLonString);
      if (!coords) {
        return false;
      }
      // fail on null lat/lon
      if (coords.Lat === 0 && coords.Lon === 0) {
        return false;
      }
      return true;
    }

    function getLatLonFromString(str) {
      if (!str) {
        return null;
      }
      var pieces = str.split(",");
      if (pieces.length < 2) {
        return null;
      }
      if (!isLatValid(pieces[0]) || !isLonValid(pieces[1])) {
        return null;
      }
      return {
        Lat: Number(pieces[0]),
        Lon: Number(pieces[1])
      };
    }

    function allLatLonValid(coordStrs) {
      return coordStrs.every(function (coordStr) {
        var latLonSplit = coordStr.split(",");
        //Each coord must have a lat and lon
        if (latLonSplit.length < 2) {
          return false;
        }
        var lat = Number(latLonSplit[0]);
        var lon = Number(latLonSplit[1]);
        //They must be valid lat/lons
        if (!isLatValid(lat) || !isLonValid(lon)) {
          return false;
        }
        return true;
      });
    }

    function isLatLonValid(fieldValue, maxBound) {
      if (isNaN(fieldValue) || Number(fieldValue) < -maxBound || Number(fieldValue) > maxBound) {
        return false;
      }
      return true;
    }

    function isLatValid(fieldValue) {
      return isLatLonValid(fieldValue, 90);
    }

    function isLonValid(fieldValue) {
      return isLatLonValid(fieldValue, 180);
    }

    function getYardPointsFromString(importStr) {
      if (!importStr) {
        return null;
      }
      var points = [];
      _.each(importStr.split("|"), function (coordStr) {
        var lat = Number(coordStr.split(",")[0]);
        var lon = Number(coordStr.split(",")[1]);
        points.push([lon, lat]);
      });
      return points;
    }

    function getGatesFromString(importStr) {
      if (!importStr) {
        return [];
      }
      var gatesField = new GatesField();
      if (gatesField.getErrors(importStr, {}).length > 0) {
        return [];
      }

      var escPipeChar = String.fromCharCode(13);
      var escCaretChar = String.fromCharCode(14);
      var escBackslashChar = String.fromCharCode(15);

      //Gates is double delimited by ^ for gates and | for the gate fields.
      //So the import string must escape '^', '|' and '\' chars by prefacing with a '\' char.
      importStr = getDecodedImportString(importStr, escPipeChar, escCaretChar, escBackslashChar);

      var gates = [];
      var gateStrs = importStr.split("^");
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = gateStrs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var gateStr = _step4.value;

          var pieces = gateStr.split("|");
          var gate = {
            Coords: {
              Lat: pieces[0].split(",")[0],
              Lon: pieces[0].split(",")[1]
            },
            SnapCoords: {
              Lat: pieces[1].split(",")[0],
              Lon: pieces[1].split(",")[1]
            },
            Type: Number(pieces[2]),
            AutoRestricted: pieces[3] === "1" ? true : false,
            TruckRestricted: pieces[4] === "1" ? true : false,
            NoteContent: pieces[5].replace(new RegExp(escPipeChar, "g"), "|").replace(new RegExp(escCaretChar, "g"), "^").replace(new RegExp(escBackslashChar, "g"), "\\")
          };
          gates.push(gate);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return gates;
    }

    //Encode the note by escaping '^', '|' and '\' chars by prefacing with a '\' char.
    function getEncodedNote(noteString) {
      noteString = noteString.replace(/\\/g, "\\\\");
      noteString = noteString.replace(/\|/g, "\\\|");
      noteString = noteString.replace(/\^/g, "\\\^");
      return noteString;
    }

    //Reads importStr from left to right.
    //Upon encountering \\, replaces with escBackslashChar.
    //Upon encountering \|, replaces with escPipeChar.
    //Upon encountering \^, replaces with escCaretChar.
    function getDecodedImportString(importStr, escPipeChar, escCaretChar, escBackslashChar) {
      var c16 = String.fromCharCode(16);

      var importStrArray = importStr.split("");
      for (var i = 0; i < importStr.length - 1; i++) {
        var charPair = importStr.substring(i, i + 2);
        if (charPair === "\\\\") {
          importStrArray[i] = escBackslashChar;
          importStrArray[i + 1] = c16;
          i++;
        } else if (charPair === "\\|") {
          importStrArray[i] = escPipeChar;
          importStrArray[i + 1] = c16;
          i++;
        } else if (charPair === "\\^") {
          importStrArray[i] = escCaretChar;
          importStrArray[i + 1] = c16;
          i++;
        }
      }
      importStr = importStrArray.join("");
      importStr = importStr.replace(new RegExp(c16, "g"), "");
      return importStr;
    }

    function strContainsLonLat(importStr, lon, lat, threshold) {
      if (!importStr) {
        return true;
      }
      var coords = getYardPointsFromString(importStr);
      return containsLonLat(coords, lon, lat, threshold);
    }

    function validateNoInvalidChar(fieldValue, fieldParams) {
      if (!fieldValue) {
        return [];
      }
      if (!INVALID_CHAR_REGEX.test(fieldValue)) {
        return [$translate.instant("common.import.fieldErrInvalid", fieldParams) + " (" + $translate.instant("common.import.canNotContainSpecialCharacters") + "): " + fieldValue];
      }
      return [];
    }

    //Note: will return true for invalid (i.e. blank) paramters. Reason is because "place not in site" error should not show if lat/lon/importCoords are invalid
    function containsLonLat(importCoords, lon, lat, threshold) {
      var mapUtilities = $injector.get("mapUtilities");
      if (!importCoords || !lon || !lat) {
        return true;
      }
      var poly = [];
      var mercLL;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = importCoords[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var coords = _step5.value;

          mercLL = mapUtilities.LLtoMerc(coords[0], coords[1]);
          poly.push(new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat));
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var ring = new ALKMaps.Geometry.LinearRing(poly);
      mercLL = mapUtilities.LLtoMerc(lon, lat);
      var point = new ALKMaps.Geometry.Point(mercLL.lon, mercLL.lat);
      if (ring.containsPoint(point) && ring.distanceTo(point) !== 0) {
        return true;
      } else if (threshold) {
        var dist = ring.distanceTo(point);
        // only 8 digits of gate lat/lon are stored in db, causing uncertainty to be at least 1.2 units
        if (dist < 0.2) {
          return true;
        }
      }
      return false;
    }

    //address object format: obj.StreetAddress, obj.City, obj.State, obj.Zip
    function batchGeocodeAddresses(addresses, progressCallback) {
      var MAX_PER_BATCH = 100;
      var MIN_BATCHES = 6;

      var deferred = $q.defer();
      var results = [];
      var addressBatches = [];
      var counter = 0;

      //Split into MIN_BATCHES separate requests if over MIN_BATCHES addresses to geocode
      if (addresses.length < MIN_BATCHES) {
        addressBatches = [addresses];
      } else {
        //Increase the number of batches until the amount per batch is less than or equal to MAX_PER_BATCH.
        var num_batches = MIN_BATCHES - 1; //Start off at 1 less to account for first increment in do-while loop
        var num_in_batch;
        do {
          num_batches++;
          num_in_batch = Math.round(addresses.length / num_batches);
        } while (num_in_batch > MAX_PER_BATCH);
        //console.log("Splitting " + addresses.length + " entries into " + num_batches + " batches with " + num_in_batch + " entries each");

        //Split the addresses into "num_batches" batches
        addressBatches = chunkify(addresses, num_batches, true);
      }
      progressCallback(0, addressBatches.length);

      _.each(addressBatches, function (addressBatch) {
        counter++;
        var locations = [];
        _.each(addressBatch, function (address) {
          var location = {};
          //Address fields
          location.Address = address;

          //Location fields
          location.Region = PCMRegion[UserProvider.getUser().region];
          locations.push(location);
        });
        var request = {
          method: "POST",
          url: config.pcmwsUrl + "locations/address/batch",
          headers: {
            Authorization: config.alkmapsApiKey,
            BatchIndex: String(counter)
          },
          params: {
            dataset: UserProvider.getUser().dataset || UserProvider.getUser().dataVersion || "Current"
          },
          data: {
            Locations: locations
          }
        };
        return $http(request).then(function (response) {
          //success
          results.push(response);
          progressCallback(results.length, addressBatches.length);
          if (results.length === addressBatches.length) {
            //The responses may not come back in the order they were sent so sort them first
            results.sort(function (a, b) {
              return Number(a.config.headers.BatchIndex) - Number(b.config.headers.BatchIndex);
            });
            //Because we split up calls to the batch geocoder, assemble responses here
            var mergedResults = [];
            for (var j = 0; j < results.length; j++) {
              mergedResults = mergedResults.concat(results[j].data);
            }
            deferred.resolve(mergedResults);
          }
        }, function (response) {
          //fail
          results = null;
          deferred.resolve(null);
        });
      });

      return deferred.promise;
    }

    //Split array a into n arrays (set balanced = true for equal subarray length)
    function chunkify(a, n, balanced) {
      if (n < 2) {
        return [a];
      }
      var len = a.length,
          out = [],
          i = 0,
          size;
      if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
          out.push(a.slice(i, i += size));
        }
      } else if (balanced) {
        while (i < len) {
          size = Math.ceil((len - i) / n--);
          out.push(a.slice(i, i += size));
        }
      } else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) size--;
        while (i < size * n) {
          out.push(a.slice(i, i += size));
        }
        out.push(a.slice(size * n));
      }
      return out;
    }

    return {
      //Constants
      invalidCharRegex: INVALID_CHAR_REGEX,

      //Helper functions
      browserImportIncompatible: browserImportIncompatible,
      filterErrors: filterErrors,
      testCompanyIds: testCompanyIds,
      importPlaces: importPlaces,
      importExceptions: importExceptions,
      isLatLonStringValid: isLatLonStringValid,
      getLatLonFromString: getLatLonFromString,
      isLatLonValid: isLatLonValid,
      isLatValid: isLatValid,
      isLonValid: isLonValid,
      getYardPointsFromString: getYardPointsFromString,
      getGatesFromString: getGatesFromString,
      getEncodedNote: getEncodedNote,
      getDecodedImportString: getDecodedImportString,
      strContainsLonLat: strContainsLonLat,
      containsLonLat: containsLonLat,
      batchGeocodeAddresses: batchGeocodeAddresses,

      //Import fields (since they are ES6 classes must be instantiated first)
      LatitudeField: new LatitudeField(),
      LongitudeField: new LongitudeField(),
      LatLonField: new LatLonField(),
      StreetAddressField: new StreetAddressField(),
      CityField: new CityField(),
      StateField: new StateField(),
      CountryAbbrevField: new CountryAbbrevField(),
      ZipField: new ZipField(),
      CountyField: new CountyField(),
      CountryField: new CountryField(),
      PlaceNameField: new PlaceNameField(),
      CompanyIdField: new CompanyIdField(),
      PhoneField: new PhoneField(),
      CommentsField: new CommentsField(),
      YardNameField: new YardNameField(),
      YardPointsField: new YardPointsField(),
      GatesField: new GatesField(),
      EntryLatLonField: new EntryLatLonField(),
      EntryLatLonSnapField: new EntryLatLonSnapField(),
      EntryNotesField: new EntryNotesField(),
      ExitLatLonField: new ExitLatLonField(),
      ExitLatLonSnapField: new ExitLatLonSnapField(),
      ExitNotesField: new ExitNotesField(),
      SiteDetailField: new SiteDetailField(),
      StopNameField: new StopNameField(),
      EstimatedDurationField: new EstimatedDurationField(),
      EarliestArrivalTimeField: new EarliestArrivalTimeField(),
      LatestArrivalTimeField: new LatestArrivalTimeField()
    };
  }
})();

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.import").controller("importModalController", importModalController);

  importModalController.$inject = ["$uibModalInstance", "$scope", "$translate", "alkModalService", "papaparse", "$timeout", "alkImportService", "$interval"];

  function importModalController($uibModalInstance, $scope, $translate, alkModalService, papaparse, $timeout, alkImportService, $interval) {
    var vm = this;

    vm.clickUpload = clickUpload;
    vm.processFile = processFile;
    vm.processFileLogic = processFileLogic;
    vm.cancel = cancel;
    vm.canSubmit = canSubmit;
    vm.keydownOnFileInput = keydownOnFileInput;
    vm.getFileMessage = getFileMessage;
    vm.getDisplayErrors = getDisplayErrors;
    vm.getDetectedDelimiter = getDetectedDelimiter;
    vm.showDetectedDelimiter = showDetectedDelimiter;
    vm.validate = validate;
    vm.submit = submit;
    vm.errors = [];
    vm.showEmptySetWarning = false; //Don't show the empty set warning when the form first loads
    vm.submitted = false;

    alkModalService.setWizardCleanupFunction(onWizardClose);
    var currentWizardData = alkModalService.getCurrentWizardData();

    vm.oldBrowser = currentWizardData.oldBrowser;

    if (!currentWizardData.file) {
      currentWizardData.file = null;
    }
    if (!currentWizardData.sets) {
      currentWizardData.sets = [];
    }
    if (!currentWizardData.importRows) {
      currentWizardData.importRows = [];
    }
    if (!currentWizardData.delimiter) {
      currentWizardData.delimiter = "AutoDetect";
    }
    if (!currentWizardData.detectedDelimiter) {
      currentWizardData.detectedDelimiter = "";
    }

    vm.file = currentWizardData.file;
    vm.importRows = currentWizardData.importRows;
    vm.delimiter = currentWizardData.delimiter;
    vm.detectedDelimiter = currentWizardData.detectedDelimiter;
    vm.sets = currentWizardData.sets;

    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = importFeatureType === "ContentToolsPlaces";
    vm.isExceptionsImport = importFeatureType === "ContentToolsExceptions";
    vm.isStopsImport = importFeatureType === "PCMWebUIStops";

    if (vm.isPlacesImport) {
      vm.importModalTitle = $translate.instant("templates.importPlaces.importPlacesTitle");
      vm.entityNameText = $translate.instant("templates.importPlaces.places");
      vm.submitButtonText = $translate.instant("common.Continue");
      vm.maxRowsAllowed = 50000;
    } else if (vm.isStopsImport) {
      vm.importModalTitle = $translate.instant("templates.importStops.importStopsTitle");
      vm.entityNameText = $translate.instant("templates.importStops.stops");
      vm.submitButtonText = $translate.instant("common.Continue");
      vm.maxRowsAllowed = 40;
    } else if (vm.isExceptionsImport) {
      //Exceptions(Modifiers) import works very differently (i.e. DAT file, no geocoding) - use different functions.
      vm.importModalTitle = $translate.instant("templates.importModifiers.importModifiers");
      vm.submitButtonText = $translate.instant("common.Submit");
      vm.validate = validateExceptions;
      vm.processFileLogic = processFileLogicExceptions;
    }

    init();

    ////////////////

    function init() {
      if (!vm.importRows) {
        vm.importRows = [];
      }
      //Fix an issue with IE/Edge with binding the elements
      if (angular.element(document)[0].documentMode || /Edge/.test(navigator.userAgent)) {
        //console.log("ie/edge");
        bindElementsIEFix();
      } else {
        //console.log("Not ie/edge")
        $timeout(function () {
          bindElements();
        });
      }
    }

    function bindElements() {

      //Manually bind the file input onchange because this version of Angular doesn't have ng-change for file inputs
      angular.element("#importSetFileInput").off();
      angular.element("#importSetFileInput").on("change", vm.processFile);

      //Setup drag and drop file upload div
      angular.element("#importForm").off();
      angular.element("#importForm").on("drag dragstart dragend dragover dragenter dragleave drop", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      var dragDropDiv = angular.element("#dragDropFileDiv");
      dragDropDiv.off();
      dragDropDiv.on("dragover dragenter", function () {
        $timeout(function () {
          vm.fileUploadHover = true;
        });
      }).on("dragleave dragend drop", function () {
        $timeout(function () {
          vm.fileUploadHover = false;
        });
      }).on("drop", function (e) {
        vm.processFileLogic(e.originalEvent.dataTransfer.files[0]);
      });

      angular.element("#importForm").trigger("drag");
    }

    function bindElementsIEFix() {
      //For some reason, IE can fail randomly to bind elements for some reason if going back from previous modal. Must bind it repeatedly to ensure it works
      vm.interval = $interval(bindElements, 100);
      $scope.$on("$destroy", function () {
        $interval.cancel(vm.interval);
      });
    }

    function getDelimiter() {
      var delimiter = ",";
      switch (vm.delimiter) {
        case "AutoDetect":
          delimiter = null;
          break;
        case "Comma":
          delimiter = ",";
          break;
        case "Tab":
          delimiter = "\t";
          break;
        case "Pipe":
          delimiter = "|";
          break;
        default:
          break;
      }
      return delimiter;
    }

    function onWizardClose() {
      //Whatever is done when showing the list in the fourth modal, also do it when the whole import modal closes
      if (vm.isExceptionsImport) {} else if (currentWizardData.onShowList) currentWizardData.onShowList();
    }

    function clickUpload() {
      $timeout(function () {
        vm.file = null;
        vm.errors = [];
        vm.detectedDelimiter = "";
        document.getElementById("importSetFileInput").value = null;
        vm.validate(true);
        angular.element("#importSetFileInput").trigger("click");
      });
    }

    function processFile() {
      $timeout(function () {
        var file = document.getElementById("importSetFileInput").files[0];
        vm.processFileLogic(file);
      });
    }

    //Given an array of array of strings of results, trim each string of whitespaces from beginning to end. Does it in place.
    function trimParseResults(results) {
      for (var i = 0; i < results.length; i++) {
        for (var j = 0; j < results[i].length; j++) {
          results[i][j] = results[i][j].trim();
        }
      }
    }

    function processFileLogic(file) {
      vm.file = file;
      vm.errors = [];
      vm.importRows = [];
      vm.detectedDelimiter = "";
      if (!file) {
        return;
      }
      vm.fileProcessing = true;
      var config = {
        skipEmptyLines: true,
        complete: function complete(results) {
          $timeout(function () {
            vm.fileProcessing = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = results.errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var err = _step.value;

                if (err.code === "UndetectableDelimiter") {
                  vm.errors = [$translate.instant("common.import.delimiterNotDetected")];
                  return;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            vm.detectedDelimiter = results.meta.delimiter;
            vm.importRows = results.data;
            trimParseResults(vm.importRows); //papaparse doesn't remove whitespace before and after, so do it now.
            vm.validate();
          });
        },
        error: function error(errorResults) {
          $timeout(function () {
            vm.errors = [$translate.instant("common.import.csvErrGenericFileReadErr")];
            vm.fileProcessing = false;
          });
        }
      };
      var delim = getDelimiter();
      if (delim) {
        config.delimiter = delim;
      }
      papaparse.parse(file, config);
    }

    function showDetectedDelimiter() {
      return vm.delimiter === "AutoDetect" && vm.detectedDelimiter;
    }

    function getDetectedDelimiter() {
      var delim = vm.detectedDelimiter;
      if (delim === "\t") {
        delim = $translate.instant("common.import.tabDelimLabel");
      } else {
        delim = "\"" + delim + "\"";
      }
      return $translate.instant("common.import.autoDetectedDelimiter", { delim: delim });
    }

    //Get the majority array size in an array of arrays
    function getMajorityColumnNum(arrayOfArrays) {
      var max = -1,
          maxKey = -1,
          rowLenToFrequency = {};
      for (var i = 0; i < arrayOfArrays.length; i++) {
        var rowLen = arrayOfArrays[i].length;
        if (!rowLenToFrequency[rowLen]) {
          rowLenToFrequency[rowLen] = 0;
        }
        rowLenToFrequency[rowLen]++;
      }
      _.forOwn(rowLenToFrequency, function (value, key) {
        if (value > max) {
          max = value;
          maxKey = key;
        }
      });
      return maxKey;
    }

    function getFileMessage() {
      return vm.file ? vm.file.name : $translate.instant("common.import.noFileSelected");
    }

    //If onlySetName = true, ONLY validate the set name. Leave the other errors untouched. Otherwise clear the errors and validate all from scratch.
    //This parameter is included for performance (so we don't revalidate a huge CSV everytime the set name text changes)
    function validate(onlySetName) {

      //If no file selected, don't validate file
      if (!vm.file) {
        return;
      }

      //Verify that there were rows
      if (vm.importRows.length === 0) {
        vm.errors.push($translate.instant("common.import.csvErrNoData"));
        return vm.errors;
      }

      //Verify that the maximum row count isn't exceeded
      if (vm.importRows.length > vm.maxRowsAllowed) {
        vm.errors.push($translate.instant("common.import.csvErrTooManyRows", {
          max: String(vm.maxRowsAllowed)
        }));
        return vm.errors;
      }

      var majColNum = getMajorityColumnNum(vm.importRows);
      //Verify that columns have at least 2 fields (lat/lon must be provided as minimum)
      if (majColNum < 2) {
        vm.errors.push($translate.instant("common.import.csvErrNotEnoughCols"));
      }

      //Validate equal columns in each row
      var unequalColErrs = [];
      for (var i = 0; i < vm.importRows.length; i++) {
        if (vm.importRows[i].length < majColNum) {
          unequalColErrs.push($translate.instant("common.import.csvErrRowWithTooFewCols", {
            row: (i + 1).toString()
          }));
        } else if (vm.importRows[i].length > majColNum) {
          unequalColErrs.push($translate.instant("common.import.csvErrRowWithTooManyCols", {
            row: (i + 1).toString()
          }));
        }
      }

      vm.errors = vm.errors.concat(unequalColErrs);
    }

    function getDisplayErrors() {
      //Only show 100 of these errors max to prevent UI issues
      return alkImportService.filterErrors(vm.errors);
    }

    function submit() {
      if (!vm.canSubmit()) return;
      vm.submitted = true;

      //Save these fields for next modal
      currentWizardData.file = vm.file;
      currentWizardData.importRows = vm.importRows;
      currentWizardData.delimiter = vm.delimiter;
      currentWizardData.detectedDelimiter = vm.detectedDelimiter;

      $uibModalInstance.close();
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function canSubmit() {
      return !vm.fileProcessing && vm.file && !vm.submitted && vm.errors.length === 0;
    }

    //Enter on file input button should submit form if file is uploaded
    function keydownOnFileInput($event) {
      if ($event.which === 13 && vm.canSubmit()) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.submit();
      }
    }

    $scope.$on("$destroy", function () {
      angular.element("#importForm").off();
      angular.element("#importSetFileInput").off();
      angular.element("#dragDropFileDiv").off();
    });

    /////////////////////////////////////
    //ROUTE Modifiers SPECIFIC OVERRIDES
    /////////////////////////////////////

    function validateExceptions() {
      vm.errors = [];

      //File selected: make sure it's a dat
      if (vm.file) {
        //Must be a .dat file
        var fileNamePieces = vm.file.name.split(".");
        if (fileNamePieces[fileNamePieces.length - 1] !== "dat") {
          vm.errors.push($translate.instant("templates.importModifiers.importModifiersNotDAT"));
        }
        if (vm.file.size > 2 * 1024 * 1024) {
          vm.errors.push($translate.instant("templates.importModifiers.importModifiersMaxFileSize", { maxFileSize: "2.0 MB" }));
        }
      }
    }

    function processFileLogicExceptions(file) {
      vm.file = file;
      vm.errors = [];
      if (!file) {
        return;
      }
      vm.validate();
    }
  }
})();

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

(function () {
  "use strict";

  var getDisplayRowIndex = __webpack_require__(194);
  var getImportDataRows = __webpack_require__(195);

  var _require = __webpack_require__(356),
      getRowsToGeocode = _require.getRowsToGeocode,
      getRowsNotToGeocode = _require.getRowsNotToGeocode;

  angular.module("alk.import").controller("importFieldsModalController", importFieldsModalController);

  importFieldsModalController.$inject = ["$scope", "$uibModalInstance", "alkImportService", "$translate", "alkModalService", "$filter", "$timeout", "$q", "PCMRegion", "UserProvider", "$http", "data", "alkGeocodeService"];

  function importFieldsModalController($scope, $uibModalInstance, alkImportService, $translate, alkModalService, $filter, $timeout, $q, PCMRegion, UserProvider, $http, data, alkGeocodeService) {
    var vm = this;
    vm.submitForm = submitForm;
    vm.validate = validate;
    vm.cancel = cancel;
    vm.back = back;
    vm.firstFiveValuesStr = firstFiveValuesStr;
    vm.getDefaultFieldLabel = getDefaultFieldLabel;
    vm.canSubmit = canSubmit;
    vm.getSubmitButtonText = getSubmitButtonText;
    vm.getDisplayErrors = getDisplayErrors;
    vm.alignColumnLayout = alignColumnLayout;
    vm.getHeaders = getHeaders;
    vm.isLatLonSpecified = isLatLonSpecified;

    vm.isHistoricalDataVersion = data ? data.checkHistoricalVersion : true;

    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = importFeatureType === "ContentToolsPlaces";
    vm.isExceptionsImport = importFeatureType === "ContentToolsExceptions";
    vm.isStopsImport = importFeatureType === "PCMWebUIStops";

    vm.errors = [];
    vm.submitError = "";
    vm.submitted = false;
    vm.geocodeSubmitted = false;
    vm.importCols = [];
    vm.progressPercent = 0;
    vm.progressMessage = "";

    if (vm.isPlacesImport) {
      vm.fields = [alkImportService.PlaceNameField, alkImportService.CompanyIdField, alkImportService.LatitudeField, alkImportService.LongitudeField, alkImportService.LatLonField, alkImportService.StreetAddressField, alkImportService.CityField, alkImportService.StateField, alkImportService.CountryAbbrevField, alkImportService.ZipField, alkImportService.PhoneField, alkImportService.CountryField, alkImportService.CommentsField, alkImportService.YardNameField, alkImportService.YardPointsField, alkImportService.GatesField, alkImportService.EntryLatLonField, alkImportService.EntryLatLonSnapField, alkImportService.EntryNotesField, alkImportService.ExitLatLonField, alkImportService.ExitLatLonSnapField, alkImportService.ExitNotesField, alkImportService.SiteDetailField];
      alkImportService.StateField.setRegion();
      alkImportService.CountryAbbrevField.setRegion();
    } else if (vm.isStopsImport) {
      vm.fields = [alkImportService.StopNameField, alkImportService.LatitudeField, alkImportService.LongitudeField, alkImportService.LatLonField, alkImportService.StreetAddressField, alkImportService.CityField, alkImportService.StateField, alkImportService.ZipField, alkImportService.CountryField, alkImportService.EstimatedDurationField];
      // TODO pchen: add `alkImportService.StateField.setRegion();`?
    }
    vm.importRows = []; //Array of array of strings representing the import rows/columns parsed
    vm.headers = []; //Array of import fields that represent the headers
    vm.headerChecked = false; //Is the header included as part of the first row? (Set by import fields UI)

    vm.importFunction = currentWizardData.importFunction;

    //By default, don't tick header checkbox if there's only one row, or there will be no data
    if (currentWizardData.headerChecked !== undefined) {
      vm.headerChecked = currentWizardData.headerChecked;
    } else if (currentWizardData.importRows && currentWizardData.importRows.length > 1) {
      vm.headerChecked = true;
    } else {
      vm.headerChecked = false;
    }

    init();

    ////////////////

    function init() {
      //Assign headers: Try to guess the field to assign
      if (currentWizardData.headers) {
        vm.headers = currentWizardData.headers;
      } else {
        vm.headers = getHeaders(currentWizardData.importRows[0]);
      }
      vm.importRows = currentWizardData.importRows;

      //Create the columns
      for (var i = 0; i < currentWizardData.importRows[0].length; i++) {
        vm.importCols[i] = [];
      }
      for (var _i = 0; _i < currentWizardData.importRows.length; _i++) {
        for (var j = 0; j < currentWizardData.importRows[_i].length; j++) {
          vm.importCols[j].push(currentWizardData.importRows[_i][j]);
        }
      }

      //Validate on load
      vm.validate();

      alignColumnLayout();
    }

    function alignColumnLayout() {
      $timeout(function () {
        //Hack to set the select model on load (issues for some reason)
        for (var i = 0; i < vm.headers.length; i++) {
          $("#importFieldSelect" + i).val(vm.headers[i]);
        }
        //Adjust width of third column to fit to modal bounds. CSS has issues here for some reason (maybe due to table in a $uibmodal)?
        var tableWidth = $("#fieldSetId").outerWidth();
        var firstColWidth = $(".fieldHeaderCol").outerWidth();
        var secondColWidth = $(".fieldValueCol").outerWidth();
        $(".firstFiveCol").width(tableWidth - firstColWidth - secondColWidth);
      });
    }

    function showError(errorMessage) {
      vm.submitError = errorMessage;
      vm.submitted = false;
      vm.geocodeSubmitted = false;
    }

    function submitForm() {
      if (!vm.canSubmit()) return;

      vm.submitError = "";

      validateCIDsNewBeforeSubmit().then(function () {
        var rowsGeocoded = getRowsToGeocode(vm, $translate);
        // var addresses = getAddresses(rowsGeocoded);
        var rowsNotGeocoded = getRowsNotToGeocode(vm, $translate);

        //Save these fields for next modal
        currentWizardData.headerChecked = vm.headerChecked;
        currentWizardData.headers = vm.headers;

        //Create the import entities directly. Finishes the wizard.
        if (rowsGeocoded.length === 0) {
          //Save these fields for back button from next modal
          currentWizardData.geocodeResults = [];
          currentWizardData.inputRowsNotGeocoded = rowsNotGeocoded;
          //Save these fields for next modal
          currentWizardData.inputRowsToCreate = rowsNotGeocoded.slice();

          $uibModalInstance.close({
            wasGeocoded: false
          });
        }
        //Do a batch geocode first
        else {

            vm.geocodeSubmitted = true;
            vm.progressPercent = 0;
            vm.progressMessage = "";

            var progressCallback = function progressCallback(numCompleted, numTotal) {
              var progStr = Math.floor(100 * numCompleted / numTotal);
              vm.progressMessage = $translate.instant("common.import.geocodingProgessBar", {
                progressString: progStr
              });
              vm.progressPercent = progStr;
            };
            getAddresses(rowsGeocoded).then(function (addresses) {
              alkImportService.batchGeocodeAddresses(addresses, progressCallback).then(function (responses) {
                //Error
                if (!responses) {
                  showError($translate.instant("common.import.unknownError"));
                  return;
                }

                for (var i = 0; i < responses.length; i++) {
                  var response = responses[i];
                  var rowObj = rowsGeocoded[i];

                  response.inputRow = rowObj;

                  //Give the response object the corresponding address string
                  response.requestAddressStr = $filter("fullAddressFilter")({
                    StreetAddress: rowObj.StreetAddress,
                    City: rowObj.City,
                    State: rowObj.State,
                    Zip: rowObj.Zip,
                    County: rowObj.County,
                    Country: rowObj.Country ? rowObj.Country : rowObj.CountryAbbreviation
                  }, false);

                  response.requestAddressStr = String(response.requestAddressStr);
                }

                //Save these fields for next modal
                currentWizardData.geocodeResults = responses;
                currentWizardData.inputRowsNotGeocoded = rowsNotGeocoded;

                $uibModalInstance.close({
                  wasGeocoded: true
                });
              });
            });
          }
      });
      vm.submitted = true; //Prevent double click from submitting twice
    }

    function validateCIDsNewBeforeSubmit() {
      var deferred = $q.defer();

      // abort import if any CID to import is already found in the user's
      //  account in DataAnywhere
      var importRowsToSubmit = getImportDataRows(vm);
      var companyIdIndex = vm.headers.indexOf("CompanyId");
      if (companyIdIndex === -1) {
        deferred.resolve();
        return deferred.promise;
      }
      var uniqueCIDs = _.chain(importRowsToSubmit).map(function (row) {
        return row[companyIdIndex];
      }).filter(function (cid) {
        return cid.length > 0;
      }).uniq().value();
      if (uniqueCIDs.length === 0) {
        deferred.resolve();
        return deferred.promise;
      }
      alkImportService.testCompanyIds(uniqueCIDs).then(function (conflictList) {
        if (!conflictList) {
          showError($translate.instant("common.import.unknownError"));
        } else if (conflictList.length > 0) {
          showError($translate.instant("common.import.companyIdConflictDetected", {
            cids: conflictList.join(", ")
          }));
          deferred.reject();
        } else {
          deferred.resolve();
        }
      });
      return deferred.promise;
    }

    function validate() {
      vm.errors = [];
      vm.submitError = "";

      //Verify that a certain required combination of fields was selected as fields
      if (!hasSufficientFieldsSelected()) {
        vm.errors.push($translate.instant("common.import.fieldErrNotEnoughFields"));
      } else {
        //Verify that a certain required combination of fields was not set to blank for all fields in a particular row
        var blankComboErrs = validateSufficientFieldsSet();
        vm.errors = vm.errors.concat(blankComboErrs);
      }

      //Verify that the same field (besides "skip") was not selected twice
      if (duplicateHeaders()) {
        vm.errors.push($translate.instant("common.import.fieldErrDuplicateHeaders"));
      }

      //Verify no field was selected without its dependencies also selected
      var dependencyErrs = missingHeaderDependencies();
      vm.errors = vm.errors.concat(dependencyErrs);

      //Validate all fields
      var fieldErrs = validateRows();
      vm.errors = vm.errors.concat(fieldErrs);

      if (vm.isPlacesImport) {
        var companyIdConflicts = validateCIDsUnique();
        vm.errors = vm.errors.concat(companyIdConflicts);

        var placeNotInSiteErrs = validatePlaceInSiteShape();
        vm.errors = vm.errors.concat(placeNotInSiteErrs);

        var gateNotInSiteErrs = validateGateInSiteShape();
        vm.errors = vm.errors.concat(gateNotInSiteErrs);

        var insufficientGatesErrs = validateSufficientGates();
        vm.errors = vm.errors.concat(insufficientGatesErrs);
      }
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    function back() {
      //Clear out this data when going back so it doesn't persist when user changes file
      currentWizardData.headers = undefined;
      currentWizardData.headerChecked = undefined;

      $uibModalInstance.close({
        back: true
      });
    }

    //This helper function gets the display text of the first 5 values found for a field in the CSV
    function firstFiveValuesStr(col, headerChecked) {
      var retStr = "";
      var start = 0;
      var end = 5;
      if (headerChecked) {
        start += 1;
        end += 1;
      }
      for (var i = start; i < col.length && i < end; i++) {
        if (i > start) {
          retStr += ", ";
        }
        retStr += col[i];
      }
      if (col.length > end) {
        retStr += "...";
      }
      return retStr;
    }

    function getDefaultFieldLabel(index) {
      return $translate.instant("common.import.defaultFieldLabel") + " " + (index + 1).toString();
    }

    function canSubmit() {
      return vm.errors.length === 0 && !vm.submitted;
    }

    function getSubmitButtonText() {
      if (!vm.submitted) {
        return $translate.instant("common.Continue");
      } else {
        return $translate.instant("common.import.geocoding");
      }
    }

    function getDisplayErrors() {
      return alkImportService.filterErrors(vm.errors); //Hide rest of errors if over 100 AND 50 more will be hidden
    }

    //Given an array of headerVals, return a string of inferred field names
    //i.e. ["name", "lat", "lon"] gives ["PlaceName", "Latitude", "Longitude"]
    function getHeaders(headerVals) {
      var headers = [];
      var headersUsed = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = headerVals[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var headerVal = _step.value;

          headerVal = headerVal.toLowerCase();
          var found = _.some(vm.fields, function (field) {
            if (!headersUsed[field.name] && field.suitableHeader(headerVal)) {
              headersUsed[field.name] = true;
              headers.push(field.name);
              return true;
            }
          });
          if (!found) {
            headers.push("Skip");
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return headers;
    }

    //Must have enough geocode info selected as header fields
    function hasSufficientFieldsSelected() {
      var sufficientCombos = [[alkImportService.LatitudeField, alkImportService.LongitudeField], [alkImportService.LatLonField], [alkImportService.CityField, alkImportService.StateField], [alkImportService.CityField, alkImportService.CountryAbbrevField], [alkImportService.CityField, alkImportService.CountryField], [alkImportService.ZipField]];
      var headerCounts = _.countBy(vm.headers);
      for (var i = 0; i < sufficientCombos.length; i++) {
        var combo = sufficientCombos[i];
        var missingField = false;
        for (var j = 0; j < combo.length; j++) {
          var field = combo[j];
          if (!headerCounts[field.name]) {
            missingField = true;
            break;
          }
        }
        //All it takes is one required group fullfilled to have sufficient fields selected
        if (!missingField) {
          return true;
        }
      }
      return false;
    }

    // SWPWEB-1306
    function hasAddress() {
      var headerCounts = _.countBy(vm.headers);
      if (headerCounts.City && headerCounts.State || headerCounts.Zip) // all address fields skipped
        return true;
      return false;
    }
    function hasLatLon() {
      var headerCounts = _.countBy(vm.headers);
      if (!headerCounts.Latitude && !headerCounts.Longitude && !headerCounts.LatLon) return false;
      return true;
    }

    //Return all errors where a row has invalid values (uses ImportField class methods to validate)
    function validateRows() {
      var fieldAtCol = getHeaderObjects();
      var rows = getImportDataRows(vm);
      var errs = [];
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        for (var j = 0; j < row.length; j++) {
          var val = row[j];
          var field = fieldAtCol[j];
          if (!field) continue;

          var fieldErrors = getFieldErrors(field, val, {
            row: getDisplayRowIndex(i, vm),
            col: String(j + 1),
            fieldName: field.getTranslatedName(),
            maxLength: field.maxLength
          });
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = fieldErrors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var error = _step2.value;

              errs.push(error);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
      return errs;
    }

    function getFieldErrors(field, fieldValue, fieldParams) {
      if (fieldValue.length > field.maxLength) {
        return [$translate.instant("common.import.fieldErrTooLong", fieldParams)];
      }
      return field.getErrors(fieldValue, fieldParams);
    }

    //Return all row errors where a required geocoding combination of fields were all set to blank
    //Currently, the geocoder expects either city+state, or zip
    //Sample error returned:
    //[ "Insufficient address values at row 1 (must provide non-empty city and state, or non-empty zip code)",
    // "Insufficient address values at row 2 (must provide non-empty city and state, or non-empty zip code)",
    // "(6 more occurrances of insufficient address values...)" ]
    function validateSufficientFieldsSet() {

      var insuffFieldsErrs = [];

      var latIndex = vm.headers.indexOf("Latitude");
      var lonIndex = vm.headers.indexOf("Longitude");
      var latLonIndex = vm.headers.indexOf("LatLon");
      var cityIndex = vm.headers.indexOf("City");
      var stateIndex = vm.headers.indexOf("State");
      var zipIndex = vm.headers.indexOf("Zip");

      var importRowsToSubmit = getImportDataRows(vm);
      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var hasLat = false;
        var hasLon = false;
        var hasCity = false;
        var hasState = false;
        var hasZip = false;
        var hasNullLat = false;
        var hasNullLon = false;
        for (var j = 0; j < importRowsToSubmit[i].length; j++) {
          if (importRowsToSubmit[i][j]) {
            if (j === cityIndex) {
              hasCity = true;
            } else if (j === stateIndex) {
              hasState = true;
            } else if (j === zipIndex) {
              hasZip = true;
            } else if (j === latIndex) {
              hasLat = true;
              hasNullLat = parseFloat(importRowsToSubmit[i][j]) === 0;
            } else if (j === lonIndex) {
              hasLon = true;
              hasNullLon = parseFloat(importRowsToSubmit[i][j]) === 0;
            } else if (j === latLonIndex) {
              hasLat = true;
              if (importRowsToSubmit[i][j].indexOf(",") !== -1) {
                hasLon = true;

                var _importRowsToSubmit$i = importRowsToSubmit[i][j].split(","),
                    _importRowsToSubmit$i2 = _slicedToArray(_importRowsToSubmit$i, 2),
                    lat = _importRowsToSubmit$i2[0],
                    lon = _importRowsToSubmit$i2[1];

                hasNullLat = parseFloat(lat) === 0;
                hasNullLon = parseFloat(lon) === 0;
              }
            }
          }
        }
        if (hasLat && hasLon && hasNullLat && hasNullLon) {
          // 0,0 aka null latlon
          hasLat = false;
          hasLon = false;
        }
        if (!(hasCity && hasState || hasLat && hasLon || hasZip)) {
          insuffFieldsErrs.push($translate.instant("common.import.fieldErrInsufficientFields", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }

      return insuffFieldsErrs;
    }

    //Get an array of header objects (vm.headers just has the string keys)
    function getHeaderObjects() {
      var headerObjectArray = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = vm.headers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var headerString = _step3.value;

          var headerObj = _.find(vm.fields, function (field) {
            return field.name === headerString;
          });
          headerObjectArray.push(headerObj);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return headerObjectArray;
    }

    //Return true if duplicate headers, i.e. ["Name", "Name"]
    function duplicateHeaders() {
      var headerCounts = _.countBy(vm.headers);
      var hasSimpleDuplicate = _.some(vm.fields, function (field) {
        return headerCounts[field.name] > 1;
      });
      // latitude + longitude is semantically identical to latlon
      var hasLat = vm.headers.indexOf("Latitude") !== -1;
      var hasLon = vm.headers.indexOf("Longitude") !== -1;
      var hasLatLon = vm.headers.indexOf("LatLon") !== -1;
      return hasSimpleDuplicate || (hasLat || hasLon) && hasLatLon;
    }

    function missingHeaderDependencies() {
      var errs = [];
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = getHeaderObjects()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var header = _step4.value;

          if (!header)
            // undefined = 'Skip'
            continue;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = header.dependencies[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var dependency = _step5.value;

              if (vm.headers.indexOf(dependency.name) === -1) {
                errs.push($translate.instant("common.import.fieldErrMissingDependency", {
                  fieldName: header.getTranslatedNameTitleCase(),
                  dependencyName: dependency.getTranslatedNameTitleCase()
                }));
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return errs;
    }

    //Get addresses from list of row objects
    function getAddresses(rows) {
      var deferred = $q.defer();
      var addresses = [];
      if (hasLatLon()) {
        var total = rows.length;
        var promises = [];
        for (var _i2 = 0; _i2 < total; _i2++) {
          promises.push(geocodingPromises(rows[_i2]));
        }
        $q.all(promises).then(function (response) {
          console.log(response);
          deferred.resolve(response);
          return response;
        });
      } else {
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          var address = {};
          address.StreetAddress = row.StreetAddress;
          address.City = row.City;
          address.State = row.State;
          address.Zip = row.Zip;
          address.County = row.County;
          address.CountryAbbreviation = row.CountryAbbreviation;
          address.Country = row.Country;
          address.AbbreviationFormat = 1; // ISO2
          addresses.push(address);
        }
        deferred.resolve(addresses);
      }

      return deferred.promise;
    }
    function geocodingPromises(row) {

      var deferred = $q.defer();
      alkGeocodeService.reverseGeocode({
        "lat": row.Latitude,
        "lon": row.Longitude
      }, {
        region: UserProvider.getUser().region,
        dataset: UserProvider.getUser().dataset
      }).then(function (resp) {

        console.log(resp);
        var address = {};
        address.StreetAddress = resp[0].Address.StreetAddress;
        address.City = resp[0].Address.City;
        address.State = resp[0].Address.State;
        address.Zip = resp[0].Address.Zip;
        address.County = resp[0].Address.County;
        address.CountryAbbreviation = resp[0].Address.CountryAbbreviation;
        address.Country = resp[0].Address.Country;
        address.AbbreviationFormat = 1;

        deferred.resolve(address);
      });
      return deferred.promise;
    }
    //Only true if lat/lon is specified and an address field isn't.
    function isLatLonSpecified() {
      var headerCounts = _.countBy(vm.headers);
      if (headerCounts.Latitude >= 1 && headerCounts.Longitude >= 1 || headerCounts.LatLon >= 1) {
        if (headerCounts.City >= 1 && headerCounts.State >= 1 || headerCounts.Zip >= 1) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }

    //Return all row errors of duplicate Company Ids in import
    function validateCIDsUnique() {
      var errs = [];
      var importRowsToSubmit = getImportDataRows(vm);
      var companyIdIndex = vm.headers.indexOf("CompanyId");
      if (companyIdIndex === -1) return [];
      // storing into variable to preserve rowIndex, CID pairs
      var cids = _.map(importRowsToSubmit, function (row) {
        return row[companyIdIndex];
      });
      var duplicateCIDs = _.chain(_.range(0, cids.length)).groupBy(function (i) {
        return cids[i];
      })
      // note: should change to pickBy for lodash 4.0.0+
      .pick(function (occurrences) {
        return occurrences.length > 1;
      }).value();
      // multiple places without Company Ids should not count as a conflict
      delete duplicateCIDs[""];
      _.each(duplicateCIDs, function (rowNums, cid) {
        errs.push($translate.instant("templates.importPlaces.fieldErrDuplicateCID", {
          cid: cid,
          rows: _.map(rowNums, function (i) {
            return getDisplayRowIndex(i, vm);
          }).join(", ")
        }));
      });
      return errs;
    }

    //Return all row errors where a place was not in a site shape
    function validatePlaceInSiteShape() {
      var errs = [];
      var importRowsToSubmit = getImportDataRows(vm);
      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var row = importRowsToSubmit[i];
        if (!placeInSiteShape(row)) {
          errs.push($translate.instant("templates.importPlaces.fieldErrPlaceNotInSite", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }
      return errs;
    }

    function placeInSiteShape(row) {
      var placeLatIndex = vm.headers.indexOf("Latitude");
      var placeLonIndex = vm.headers.indexOf("Longitude");
      var placeLatLonIndex = vm.headers.indexOf("LatLon");
      var yardCoordsIndex = vm.headers.indexOf("YardPoints");
      var hasPlace = placeLatIndex !== -1 && placeLonIndex !== -1 || placeLatLonIndex !== -1;
      if (!hasPlace || yardCoordsIndex === -1) {
        return true;
      }

      var placeLat = void 0;
      var placeLon = void 0;
      if (placeLatLonIndex === -1) {
        placeLat = row[placeLatIndex];
        placeLon = row[placeLonIndex];
      } else {
        var _row$placeLatLonIndex = row[placeLatLonIndex].split(",");

        var _row$placeLatLonIndex2 = _slicedToArray(_row$placeLatLonIndex, 2);

        placeLat = _row$placeLatLonIndex2[0];
        placeLon = _row$placeLatLonIndex2[1];
      }

      if (alkImportService.strContainsLonLat(row[yardCoordsIndex], placeLon, placeLat)) {
        return true;
      }

      return false;
    }

    //Return all row errors where an entry or exit gate was not within site shape bounds
    function validateGateInSiteShape() {
      var errs = [];

      var yardCoordsIndex = vm.headers.indexOf("YardPoints");
      var gateCoordsIndex = vm.headers.indexOf("Gates");
      var entryGateCoordsIndex = vm.headers.indexOf("EntryLatLon");
      var exitGateCoordsIndex = vm.headers.indexOf("ExitLatLon");

      if (yardCoordsIndex === -1) return [];

      var importRowsToSubmit = getImportDataRows(vm);
      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var row = importRowsToSubmit[i];
        var siteStr = row[yardCoordsIndex];
        var gatesString = row[gateCoordsIndex];
        var entryVal = row[entryGateCoordsIndex];
        var exitVal = row[exitGateCoordsIndex];

        // TODO pchen: consider taking this out and replacing it with more generic dependency check using BaseImportField#dependencies
        if (!siteStr && (gatesString || entryVal || exitVal)) return [$translate.instant("templates.importPlaces.fieldErrGateButNoSite", {
          row: getDisplayRowIndex(i, vm)
        })];

        if (gatesString) {
          var gates = alkImportService.getGatesFromString(gatesString);
          for (var j = 0; j < gates.length; j++) {
            var gate = gates[j];
            if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], gate.Coords.Lon, gate.Coords.Lat, true)) {
              errs.push($translate.instant("templates.importPlaces.fieldErrGateNotInSite", {
                gateNum: j + 1,
                row: getDisplayRowIndex(i, vm)
              }));
            }
          }
        }

        if (entryVal) {
          var entryLatLon = alkImportService.getLatLonFromString(entryVal);
          if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], entryLatLon.Lon, entryLatLon.Lat, true)) {
            errs.push($translate.instant("templates.importPlaces.fieldErrEntryGateNotInSite", {
              row: getDisplayRowIndex(i, vm)
            }));
          }
        }

        if (exitVal) {
          var exitLatLon = alkImportService.getLatLonFromString(exitVal);
          if (!alkImportService.strContainsLonLat(row[yardCoordsIndex], exitLatLon.Lon, exitLatLon.Lat, true)) {
            errs.push($translate.instant("templates.importPlaces.fieldErrExitGateNotInSite", {
              row: getDisplayRowIndex(i, vm)
            }));
          }
        }
      }

      return errs;
    }

    function validateSufficientGates() {
      var errs = [];

      var importRowsToSubmit = getImportDataRows(vm);
      var siteCoordsIndex = vm.headers.indexOf("YardPoints");
      var gateCoordsIndex = vm.headers.indexOf("Gates");
      var entryGateCoordsIndex = vm.headers.indexOf("EntryLatLon");
      var exitGateCoordsIndex = vm.headers.indexOf("ExitLatLon");

      //No site coords in header at all - there's no site to validate gates for the whole CSV
      if (siteCoordsIndex === -1) {
        return [];
      }

      for (var i = 0; i < importRowsToSubmit.length; i++) {
        var row = importRowsToSubmit[i];

        //A row does not have site coords set - skip this row
        if (!row[siteCoordsIndex]) {
          continue;
        }

        var hasGates = false;
        var hasEntry = false;
        var hasExit = false;
        var gatesString = row[gateCoordsIndex];
        if (gatesString) {
          var gates = alkImportService.getGatesFromString(gatesString);
          hasGates = Array.isArray(gates) && gates.length > 0;
          hasEntry = hasGates && _.some(gates, function (gate) {
            return gate.Type === 0 || gate.Type === 2;
          });
          hasExit = hasGates && _.some(gates, function (gate) {
            return gate.Type === 1 || gate.Type === 2;
          });
        }

        var entryVal = row[entryGateCoordsIndex];
        if (entryVal) {
          var entryLatLon = alkImportService.getLatLonFromString(entryVal);
          var entryLatLonSnap = alkImportService.getLatLonFromString(entryVal);
          if (entryLatLon && entryLatLonSnap) {
            hasGates = true;
            hasEntry = true;
          }
        }

        var exitVal = row[exitGateCoordsIndex];
        if (exitVal) {
          var exitLatLon = alkImportService.getLatLonFromString(exitVal);
          var exitLatLonSnap = alkImportService.getLatLonFromString(exitVal);
          if (exitLatLon && exitLatLonSnap) {
            hasGates = true;
            hasExit = true;
          }
        }

        if (hasGates && (!hasEntry || !hasExit)) {
          errs.push($translate.instant("templates.importPlaces.fieldErrInsufficientGates", {
            row: getDisplayRowIndex(i, vm)
          }));
        }
      }

      return errs;
    }
  }
})();

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getDisplayRowIndex = __webpack_require__(194);
var getImportDataRows = __webpack_require__(195);

function getRowsToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(true, vm, $translate);
}

function getRowsNotToGeocode(vm, $translate) {
  return getRowsGeocodeHelper(false, vm, $translate);
}

function getRowsGeocodeHelper(toGeocode, vm, $translate) {
  var importRowsToSubmit = getImportDataRows(vm);
  var rows = importRowsToSubmit.map(function (row, i) {
    if (shouldGeocodeRow(row, vm) === toGeocode) {
      return getRowObjFromArray(row, i, vm);
    }
  }).filter(function (a) {
    return a;
  });
  if (vm.isPlacesImport) {
    return nameUnnamedRows(rows, $translate);
  } else {
    return rows;
  }
}

//Given a row in array format (i.e. ["1", "2", "08540"]) get an object version of it (i.e. { Latitude: "1", Longitude: "2", "Zip": "08540"})
//The keys are the field names (internal ones, in the importField.js object's name property). The values are the row's CSV input contents
function getRowObjFromArray(row, i, vm) {
  var retObj = {};
  for (var j = 0; j < row.length; j++) {
    if (vm.headers[j] === "Skip") {
      continue;
    }
    if (vm.headers[j] === "LatLon") {
      var _row$j$split = row[j].split(","),
          _row$j$split2 = _slicedToArray(_row$j$split, 2),
          lat = _row$j$split2[0],
          lon = _row$j$split2[1];

      retObj.Latitude = lat;
      retObj.Longitude = lon;
    } else {
      retObj[vm.headers[j]] = row[j];
    }
  }
  retObj.RowNum = getDisplayRowIndex(i, vm);
  return retObj;
}

//Given row and field name get row/col string entry that has that field
// returns non-empty string (good), "" (omitted), or undefined (missing from cols)
function getRowVal(row, fieldKey, vm) {
  var index = vm.headers.indexOf(fieldKey);
  return row[index];
}

function nameUnnamedRows(rows, $translate) {
  var unnamedCounter = 1;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var row = _step.value;

      if (!row.PlaceName) {
        row.PlaceName = $translate.instant("templates.importPlaces.defaultImportedPlaceName", {
          num: unnamedCounter
        });
        unnamedCounter++;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return rows;
}

//Should we geocode vm row? (Row must have valid address combo)
function shouldGeocodeRow(row, vm) {
  var hasCity = Boolean(getRowVal(row, "City", vm));
  var hasState = Boolean(getRowVal(row, "State", vm));
  var hasZip = Boolean(getRowVal(row, "Zip", vm));
  var hasLat = Boolean(getRowVal(row, "Latitude", vm));
  var hasLon = Boolean(getRowVal(row, "Longitude", vm));
  var hasLatLon = Boolean(getRowVal(row, "LatLon", vm));

  return hasLat && hasLon || hasLatLon || hasZip || hasCity && hasState;
}

module.exports = { getRowsToGeocode: getRowsToGeocode, getRowsNotToGeocode: getRowsNotToGeocode };

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.import").controller("importAddressModalController", importAddressModalController);

  importAddressModalController.$inject = ["$scope", "$filter", "$uibModalInstance", "$translate", "alkModalService", "$timeout", "alkImportService"];

  function importAddressModalController($scope, $filter, $uibModalInstance, $translate, alkModalService, $timeout, alkImportService) {
    var vm = this;

    var MAX_MATCH_DISTANCE = 20; //In KM; if input lat/lon difference from geocoded lat/lon > this distance, a warning will be shown

    vm.pageNumber = 1;
    vm.resultsPerPage = 100;
    vm.pages = [];
    vm.currentPageResults = [];
    vm.countTotalPlacesGeocoded = 0;
    vm.countTotalPlaces = 0;
    vm.qualityFilter = "all";

    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;
    vm.isPlacesImport = importFeatureType === "ContentToolsPlaces";
    vm.isStopsImport = importFeatureType === "PCMWebUIStops";
    var entityNameText;
    if (vm.isPlacesImport) entityNameText = $translate.instant("templates.locations.places");else if (vm.isStopsImport) entityNameText = $translate.instant("templates.importStops.stops");

    vm.geocodeResults = currentWizardData.geocodeResults;
    vm.fullGeocodeResults = vm.geocodeResults.slice(0);
    vm.skippedPlaces = currentWizardData.skippedPlaces;
    vm.importType = currentWizardData.importType;
    vm.setName = currentWizardData.setName;
    vm.headers = currentWizardData.headers;
    vm.importFunction = currentWizardData.importFunction;
    vm.inputRowsNotGeocoded = currentWizardData.inputRowsNotGeocoded;
    vm.submitted = false;
    vm.showMapPlace = null;
    vm.showMapButton = null;
    vm.noInputLatLon = noInputLatLon;

    vm.allAddressesHidden = allAddressesHidden;
    vm.getSkippedPlacesCount = getSkippedPlacesCount;
    vm.getResponseAddressStr = getResponseAddressStr;
    vm.getConfidenceStr = getConfidenceStr;
    vm.skipOrUnskipAll = skipOrUnskipAll;
    vm.showMap = showMap;
    vm.showList = showList;
    vm.finish = finish;
    vm.back = back;
    vm.cancel = cancel;
    vm.hasMatchSelected = hasMatchSelected;
    vm.shouldShowResult = shouldShowResult;
    vm.shouldShowAddressSelect = shouldShowAddressSelect;
    vm.matchAddressSelectEnabled = matchAddressSelectEnabled;
    vm.shouldShowLatLonSelect = shouldShowLatLonSelect;
    vm.inputLatLonSelectEnabled = inputLatLonSelectEnabled;
    vm.getRowTextIssue = getRowTextIssue;
    vm.updateSkippedPlaces = updateSkippedPlaces;

    vm.textFilter = "";
    vm.submitError = "";
    vm.onPageChange = onPageChange;
    vm.onFilterChange = onFilterChange;
    vm.getLatLonComparison = getLatLonComparison;
    vm.isHiddenDueToShowMap = isHiddenDueToShowMap;

    if (vm.headers.indexOf("Latitude") > -1 && vm.headers.indexOf("Longitude") > -1) {
      vm.hasLatLon = true;
      // numbers should add up to 12 (bootstrap)
      vm.columnWidths = ["col-xs-1", "col-xs-1", "col-xs-3", "col-xs-3", "col-xs-2", "col-xs-2"];
    } else {
      vm.hasLatLon = false;
      // numbers should add up to 12 (bootstrap)
      vm.columnWidths = ["col-xs-1", "col-xs-1", "col-xs-3", "col-xs-3", "", "col-xs-3"];
    }

    vm.totalCountMessage = $translate.instant("common.import.addressTotalEntities", { importEntity: entityNameText });
    vm.geocodedCountMessage = $translate.instant("common.import.addressGeocodedEntities", { importEntity: entityNameText });
    vm.matchedCountMessage = $translate.instant("common.import.addressMatchedEntities", { importEntity: entityNameText });
    vm.failedCountMessage = $translate.instant("common.import.addressFailedEntities", { importEntity: entityNameText });

    init();

    ////////////////

    function init() {
      chunkVisibleResults();

      vm.countTotalPlaces = vm.geocodeResults.length + vm.inputRowsNotGeocoded.length;
      vm.countTotalPlacesGeocoded = vm.geocodeResults.length;
      for (var i = 0; i < vm.geocodeResults.length; i++) {
        var result = vm.geocodeResults[i];
        result.index = i;
        result.disabled = false;

        if (!result.ConfidenceLevel) {
          result.ConfidenceLevel = "Failed";
          result.Coords = null;
          result.Address = null;
        }

        if (noInputLatLon(result) || nullInputLatLon(result)) {
          if (result.ConfidenceLevel === "Failed") {
            result.disabled = true;
          } else {
            result.useInputLatLon = false;
          }
        } else if (!result.disabled) {
          result.useInputLatLon = true;
        }

        if (getLatLonDistance(result) > MAX_MATCH_DISTANCE) {
          result.latlonMismatch = true;
        }

        if (result.Coords && result.Coords.Lon && result.Coords.Lat && result.inputRow.YardPoints && !alkImportService.strContainsLonLat(result.inputRow.YardPoints, result.Coords.Lon, result.Coords.Lat)) {
          if (vm.noInputLatLon(result) || nullInputLatLon(result)) {
            result.disabled = true;
            result.badSiteCoords = true;
            result.useInputLatLon = undefined;
          } else {
            //We can't select match address since it doesn't fall within site coordinates. We need to disable it.
            result.badMatchAddressCoords = true;
          }
        }

        result.skipped = result.disabled;
      }
      if (vm.skippedPlaces) updateSkippedPlaces();
    }

    function noInputLatLon(result) {
      return !result.inputRow.Latitude || !result.inputRow.Longitude;
    }

    function nullInputLatLon(result) {
      return result.inputRow.Latitude == 0 && result.inputRow.Longitude == 0;
    }

    //Get distance from input lat/lon in KM
    function getLatLonDistance(result) {

      if (noInputLatLon(result) || nullInputLatLon(result)) {
        return -1;
      }
      if (!result.Coords || result.Coords.Lon == null || result.Coords.Lat == null) {
        return -1;
      }

      var userProvidedLatLonGeom = new ALKMaps.Geometry.Point(result.inputRow.Longitude, result.inputRow.Latitude);
      var geocodedLatLonGeom = new ALKMaps.Geometry.Point(result.Coords.Lon, result.Coords.Lat);

      var line = new ALKMaps.Geometry.LineString([userProvidedLatLonGeom, geocodedLatLonGeom]);
      var distance = line.getGeodesicLength(new ALKMaps.Projection("EPSG:4326"));
      distance *= 0.001; //m to km
      return distance;
    }

    //Get lat/lon comparison string
    function getLatLonComparison(result) {
      //No input lat lon at all: tell the user it wasn't provided
      if (noInputLatLon(result)) {
        return $translate.instant("common.import.latLonNotProvided");
      }
      if (nullInputLatLon(result)) {
        return $translate.instant("common.import.nullLatLonProvided");
      }

      //Input lat lon but geocoding failed: don't show the "miles away" message
      var latLonStr = Number(result.inputRow.Latitude).toFixed(4) + ", " + Number(result.inputRow.Longitude).toFixed(4);
      if (!result.Coords || result.Coords.Lon == null || result.Coords.Lat == null) {
        return latLonStr + "<br/>" + $translate.instant("common.import.latLonNotGeocoded");
      }

      var translateKey = "common.import.addressKmDistance";
      var distance = getLatLonDistance(result);

      if ($translate.use() === "en_US") {
        translateKey = "common.import.addressMilesDistance";
        distance *= 0.621371; //Convert KM to miles
      }

      return latLonStr + "<br/>" + $translate.instant(translateKey, {
        distance: distance.toFixed(2)
      });
    }

    function chunkVisibleResults() {
      vm.pageNumber = 1;
      vm.pages = chunk(vm.geocodeResults, vm.resultsPerPage);
      onPageChange();
    }

    function chunk(arr, chunkSize) {
      var groups = [],
          i;
      for (i = 0; i < arr.length; i += chunkSize) {
        groups.push(arr.slice(i, i + chunkSize));
      }
      return groups;
    }

    function onPageChange() {
      angular.element("#resultsScrollDiv").scrollTop(0);
      vm.currentPageResults = vm.pages[vm.pageNumber - 1];
    }

    function getSkippedPlacesCount() {
      var count = 0;
      _.each(vm.fullGeocodeResults, function (result) {
        if (result.disabled || result.skipped) {
          count++;
        }
      });
      count += vm.countTotalPlaces - vm.countTotalPlacesGeocoded; // add unprocessed stops
      return count;
    }

    function skipOrUnskipAll(skip) {
      _.each(vm.geocodeResults, function (result) {
        if (!result.disabled) {
          result.skipped = skip;
        }
      });
    }

    function showMap(result, event) {
      if (!vm.showMapPlace) {
        vm.showMapPlace = result;
        vm.showMapButton = event.target;

        var locationObj;
        if (result.useInputLatLon) {
          locationObj = {
            Coords: {
              Lat: result.inputRow.Latitude,
              Lon: result.inputRow.Longitude
            },
            Address: {}
          };
        } else {
          locationObj = result;
        }

        currentWizardData.onShowMap(locationObj);
      }
    }

    function showList() {
      $timeout(function () {
        vm.showMapButton.blur();
        vm.showMapButton.focus();
      }, 0);
      vm.showMapPlace = null;
      currentWizardData.onShowList();
    }

    function getConfidenceStr(responseConfidenceStr) {
      if (responseConfidenceStr === "Exact") {
        return $translate.instant("common.import.confidenceLevelExact");
      } else if (responseConfidenceStr === "Good") {
        return $translate.instant("common.import.confidenceLevelGood");
      } else if (responseConfidenceStr === "Uncertain") {
        return $translate.instant("common.import.confidenceLevelUncertain");
      } else {
        return $translate.instant("common.import.confidenceLevelFailed");
      }
    }

    function allAddressesHidden() {
      for (var i = 0; i < vm.geocodeResults.length; i++) {
        if (shouldShowResult(vm.geocodeResults[i])) {
          return false;
        }
      }
      return true;
    }

    function onFilterChange() {
      vm.geocodeResults = [];
      _.each(vm.fullGeocodeResults, function (result) {
        if (shouldShowResult(result)) {
          vm.geocodeResults.push(result);
        }
      });
      chunkVisibleResults();
    }

    function isHiddenDueToShowMap(result) {
      if (vm.showMapPlace && vm.showMapPlace !== result) {
        return true;
      }
      return false;
    }

    function shouldShowResult(result) {
      if (vm.textFilter !== "") {
        var reqAddr = result.requestAddressStr.toLowerCase();
        var respAddr = vm.getResponseAddressStr(result).toLowerCase();
        if (!reqAddr.includes(vm.textFilter.toLowerCase()) && !respAddr.includes(vm.textFilter.toLowerCase())) {
          return false;
        }
      }
      if (vm.qualityFilter !== "all") {
        if (vm.qualityFilter === "exact" && result.ConfidenceLevel !== "Exact") {
          return false;
        } else if (vm.qualityFilter === "good" && result.ConfidenceLevel !== "Good") {
          return false;
        } else if (vm.qualityFilter === "uncertain" && result.ConfidenceLevel !== "Uncertain") {
          return false;
        } else if (vm.qualityFilter === "skipped" && result.ConfidenceLevel !== "Failed") {
          return false;
        }
      }
      return true;
    }

    function getResponseAddressStr(result) {
      if (result.disabled && !result.badSiteCoords) {
        return "";
      }
      if (!result.Address) {
        return "";
      }
      // pchen: maybe we should change the filter to use StateAbbreviation instead?
      result.Address.State = result.Address.StateAbbreviation;
      return String($filter("fullAddressFilter")(result.Address, false));
    }

    function hasMatchSelected() {
      //If there are non-geocoded entries, we should always be able to submit
      if (vm.inputRowsNotGeocoded.length > 0) {
        return true;
      }
      for (var i = 0; i < vm.fullGeocodeResults.length; i++) {
        if (!vm.fullGeocodeResults[i].skipped && !vm.fullGeocodeResults[i].disabled) {
          return true;
        }
      }
      return false;
    }

    function shouldShowAddressSelect(result) {
      return vm.hasLatLon;
    }

    function matchAddressSelectEnabled(result) {
      return shouldShowAddressSelect(result) && !result.disabled && result.ConfidenceLevel !== "Failed" && !result.badMatchAddressCoords;
    }

    function shouldShowLatLonSelect(result) {
      return vm.hasLatLon;
    }

    function inputLatLonSelectEnabled(result) {
      return shouldShowLatLonSelect(result) && !result.disabled && !noInputLatLon(result) && !nullInputLatLon(result);
    }

    function getRowTextIssue(result) {
      if (result.badSiteCoords) {
        //This can only happen in places import. Won't translate if not reached
        return $translate.instant("templates.importPlaces.matchAddressNotInSiteCoords");
      } else if (result.latlonMismatch) {
        return $translate.instant("common.import.addressLatLonMismatch");
      }
    }

    function updateSkippedPlaces() {
      vm.skippedPlaces.forEach(function (index) {
        vm.fullGeocodeResults[index].skipped = true;
      });
    }
    function finish() {

      if (vm.submitted) return;
      vm.submitted = true;

      var inputRowsToCreate = [];
      vm.skippedPlaces = [];
      vm.fullGeocodeResults.forEach(function (result, index) {
        if (result.skipped || result.disabled) {
          vm.skippedPlaces.push(index);
          return;
        }

        var inputRow = angular.copy(result.inputRow); //Copy so that the UI doesn't suddenly change briefly when submit is clicked

        //Update input row to create to the new address fields
        //Use geocoded lat lons if not provided
        if (noInputLatLon(result) || !result.useInputLatLon) {
          inputRow.Latitude = result.Coords.Lat;
          inputRow.Longitude = result.Coords.Lon;
        }

        //If a geocoded address was found, use the geocoded address values ONLY if the user didn't provide their own for each specific field
        if (result.Address) {
          if (!inputRow.StreetAddress && result.Address.StreetAddress) {
            inputRow.StreetAddress = result.Address.StreetAddress;
          }
          if (!inputRow.City && result.Address.City) {
            inputRow.City = result.Address.City;
          }
          if (!inputRow.State && result.Address.StateAbbreviation) {
            inputRow.State = result.Address.StateAbbreviation;
          }
          if (!inputRow.Zip && result.Address.Zip) {
            inputRow.Zip = result.Address.Zip;
          }
          if (!inputRow.County && result.Address.County) {
            inputRow.County = result.Address.County;
          }
          if (!inputRow.Country && result.Address.Country) {
            inputRow.Country = result.Address.Country;
          }
        }
        inputRowsToCreate.push(inputRow);
      });
      currentWizardData.skippedPlaces = vm.skippedPlaces;
      inputRowsToCreate = inputRowsToCreate.concat(vm.inputRowsNotGeocoded);
      currentWizardData.inputRowsToCreate = inputRowsToCreate; //save data to currentwizard instead of importfunction
      $uibModalInstance.close({});
    }

    function back() {
      vm.skippedPlaces = [];
      vm.fullGeocodeResults.forEach(function (result, index) {
        if (result.skipped || result.disabled) {
          vm.skippedPlaces.push(index);
          return;
        }
      });
      currentWizardData.skippedPlaces = vm.skippedPlaces;
      $uibModalInstance.close({
        back: true
      });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.import").controller("importDetailsModalController", importDetailsModalController);

  importDetailsModalController.$inject = ["$scope", "$filter", "$uibModalInstance", "$translate", "alkModalService", "$timeout", "alkImportService", "_"];

  function importDetailsModalController($scope, $filter, $uibModalInstance, $translate, alkModalService, $timeout, alkImportService, _) {
    var vm = this;

    var entityNameText;
    var currentWizardData = alkModalService.getCurrentWizardData();
    var importFeatureType = currentWizardData.importFeatureType;

    vm.back = back;
    vm.cancel = cancel;
    vm.canSubmit = canSubmit;
    vm.errors = [];
    vm.categoryIcons = currentWizardData.categoryIcons;
    vm.changeSetCategory = changeSetCategory;
    vm.disableFinish = disableFinish;
    vm.file = currentWizardData.file;
    vm.getSetLabel = getSetLabel;
    vm.getDisplayErrors = getDisplayErrors;
    vm.headers = currentWizardData.headers;
    vm.isExceptionsImport = importFeatureType === "ContentToolsExceptions";
    vm.importModalTitle = $translate.instant("common.import.setDetails");
    vm.importType = currentWizardData.importType || 0;
    vm.invalidCharRegex = alkImportService.invalidCharRegex;
    vm.isPlacesImport = importFeatureType === "ContentToolsPlaces";
    vm.isStopsImport = importFeatureType === "PCMWebUIStops";
    vm.importFunction = currentWizardData.importFunction;
    vm.inputRowsToCreate = currentWizardData.inputRowsToCreate;
    vm.selectedCategory = currentWizardData.categoryDefaultIcon; //if none exists
    vm.setName = "";
    vm.submitted = false;
    vm.setExistsMessage = $translate.instant("common.import.setNameExists");
    vm.setNameExists = setNameExists;
    vm.showSetName = showSetName;
    vm.sets = currentWizardData.sets;
    vm.showSetList = showSetList;
    vm.submit = submit;
    vm.updateSetNameFromFileName = updateSetNameFromFileName;
    vm.validate = validate;

    if (vm.isExceptionsImport) {
      vm.importModalTitle = $translate.instant("templates.importModifiers.importModifiers");
      vm.validate = validateExceptions;
      vm.submit = submitExceptions;
    }

    if (!currentWizardData.importType) {
      currentWizardData.importType = 0;
    }

    if (vm.isPlacesImport) {
      entityNameText = $translate.instant("templates.locations.places");
      if (!currentWizardData.copilotOptions) {
        currentWizardData.copilotOptions = {
          DisplayOnMap: true,
          Searchable: true,
          Alertable: true
        };
      }
      vm.copilotOptions = currentWizardData.copilotOptions;
    } else if (vm.isStopsImport) entityNameText = $translate.instant("templates.importStops.stops");else if (vm.isStopsImport) entityNameText = $translate.instant("templates.importModifiers.importModifiers");

    init();

    function init() {
      if (!vm.selectedSet && vm.sets.length > 0) {
        vm.selectedSet = vm.sets[0];
      }
      updateSetNameFromFileName();
    }

    function back() {
      var geocodeResults = currentWizardData.geocodeResults;

      var wasGeocoded = Array.isArray(geocodeResults) && geocodeResults.length;
      $uibModalInstance.close({
        back: true,
        wasGeocoded: wasGeocoded
      });
    }

    function cancel() {
      $uibModalInstance.dismiss({});
    }

    function canSubmit() {
      return !vm.submitted && vm.errors.length === 0;
    }

    function changeSetCategory(category) {
      vm.showSetIcons = false;
      vm.selectedCategory = category;
    }

    function disableFinish() {
      if (vm.isPlacesImport) return vm.submitted || vm.errors.length > 0 || !vm.setName;

      return vm.submitted || vm.errors.length > 0;
    }

    function getSetLabel() {
      if (showSetName()) {
        return $translate.instant("templates.locations.newSetName");
      } else if (showSetList()) {
        return $translate.instant("common.import.selectSet");
      } else {
        return "";
      }
    }

    function getDisplayErrors() {
      //Only show 100 of these errors max to prevent UI issues
      return alkImportService.filterErrors(vm.errors);
    }

    function setNameExists() {
      if (!vm.setName || vm.importType !== 0) {
        return false;
      }
      return _.some(vm.sets, function (set) {
        if (!set.Name || !vm.setName) {
          return false;
        }
        return set.Name.toLowerCase() === vm.setName.toLowerCase();
      });
    }

    function showSetName() {
      return (vm.isPlacesImport || vm.isExceptionsImport) && vm.importType === 0;
    }

    function showSetList() {
      return (vm.isPlacesImport || vm.isExceptionsImport) && vm.importType >= 1;
    }

    function validate() {
      _.remove(vm.errors, function (error) {
        return error === vm.setExistsMessage;
      });
      if (setNameExists()) {
        vm.errors.push(vm.setExistsMessage);
      }
    }

    //Route Modifier specific function overrides
    function validateExceptions() {
      vm.errors = [];
      if (vm.setNameExists()) {
        vm.errors.push(vm.setExistsMessage);
      }

      //Preventing naming of closure set types for creating new sets
      if (vm.importType === 0) {
        if (vm.setName === "Closures" || vm.setName === "Closure_Default_rc") {
          vm.errors.push($translate.instant("templates.exceptions.invalidClosureName"));
        }
      }
    }

    function submitExceptions() {
      if (!vm.canSubmit()) {
        return;
      }
      vm.submitted = true;

      vm.validate();
      if (vm.errors.length > 0) {
        vm.submitted = false;
        return;
      }

      var setId = "";
      var setName = "";
      var replace = "";
      if (vm.importType === 0) {
        setName = vm.setName;
      } else if (vm.importType === 1) {
        setId = vm.selectedSet.SetID;
      } else if (vm.importType === 2) {
        setId = vm.selectedSet.SetID;
        replace = true;
      }
      alkImportService.importExceptions(vm.file, setId, setName, replace).then(function (response) {
        alkModalService.clearWizardData();
        $uibModalInstance.close({
          SetID: response.SetID
        });
      }, function (error) {
        vm.submitted = false;
        vm.errors.push($translate.instant("templates.importModifiers.importError"));
      });
    }

    function submit() {
      if (vm.submitted) return;
      vm.submitted = true;
      currentWizardData.setName = vm.setName;
      currentWizardData.selectedSet = vm.selectedSet;
      currentWizardData.importType = vm.importType;
      currentWizardData.copilotOptions = vm.copilotOptions;
      currentWizardData.selectedCategory = vm.selectedCategory;

      if (vm.isPlacesImport && vm.sets.length > 0) {
        vm.inputRowsToCreate.selectedSet = vm.selectedSet.name;
        vm.inputRowsToCreate.setName = vm.setName;
      }
      vm.inputRowsToCreate.importType = vm.importType;
      vm.inputRowsToCreate.copilotOptions = vm.copilotOptions;
      vm.inputRowsToCreate.categoryIcon = vm.selectedCategory;
      vm.importFunction(vm.inputRowsToCreate, vm.importType).then(function (response) {
        alkModalService.clearWizardData();
        $uibModalInstance.close(response);
      }, function (error) {
        vm.errors.push(error);
        vm.submitted = false;
      });
    }

    function updateSetNameFromFileName() {
      if (!vm.showSetName()) {
        return;
      }
      //Set a default set name (to the file name, without extension) if none is provided
      if (vm.errors.length === 0 && vm.setName === "" && vm.file) {
        var fileName = vm.file.name;
        var lastIndexOfDot = vm.file.name.lastIndexOf(".");
        if (lastIndexOfDot > 0) fileName = vm.file.name.substring(0, lastIndexOfDot);
        vm.setName = fileName;
        var fileNum = 1;
        while (vm.setNameExists()) {
          vm.setName = fileName + " (" + fileNum + ")";
          fileNum++;
        }
      }
    }
  }
})();

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// alk dependency

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fleetlink = __webpack_require__(360);

var _fleetlink2 = _interopRequireDefault(_fleetlink);

var _fleetlink3 = __webpack_require__(361);

var _fleetlink4 = _interopRequireDefault(_fleetlink3);

var _fleetlink5 = __webpack_require__(362);

var _fleetlink6 = _interopRequireDefault(_fleetlink5);

var _fleetlink7 = __webpack_require__(363);

var _fleetlink8 = _interopRequireDefault(_fleetlink7);

var _fleetlink9 = __webpack_require__(364);

var _fleetlink10 = _interopRequireDefault(_fleetlink9);

var _fleetlink11 = __webpack_require__(365);

var _fleetlink12 = _interopRequireDefault(_fleetlink11);

var _fleetlink13 = __webpack_require__(366);

var _fleetlink14 = _interopRequireDefault(_fleetlink13);

var _fleetlink15 = __webpack_require__(367);

var _fleetlink16 = _interopRequireDefault(_fleetlink15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module("alk.fleetportal", []).constant("alk.fleetportal.config", _fleetlink2.default).service("Vehicles", _fleetlink4.default).service("Drivers", _fleetlink8.default).service("VehicleGroups", _fleetlink6.default).service("DriverGroups", _fleetlink10.default).service("RoutingProfiles", _fleetlink12.default).service("Users", _fleetlink16.default).service("FleetPortalAPI", _fleetlink14.default).name;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  apiUrl: ""
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vehicles = function () {
  function Vehicles($q, API) {
    _classCallCheck(this, Vehicles);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Vehicles, [{
    key: "getVehicleList",
    value: function getVehicleList(groupIds) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var baseUrl = "v1/vehiclelist";
      var param = [];
      param.push.apply(param, this.API.getArrayQuery("includeGroupIds", groupIds));

      if (targetAccount !== null) {
        param.push("targetAccount=" + targetAccount);
      }
      var query = "";
      if (param.length > 0) {
        query += "?" + param.join("&");
      }

      var url = baseUrl + query;
      var ctx = this;
      var promise = new Promise(function (resolve, reject) {
        ctx.API.get(url).success(function (vehicles) {
          return resolve(vehicles);
        }).error(function (err) {
          return reject(err);
        });
      });
      return promise;
    }

    // TODO: DEPRECATE due to performance with 20k+ items

  }, {
    key: "getVehicles",
    value: function getVehicles(groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicles";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicles) {
        //console.log("vehicles: ", vehicles);
        deferred.resolve(vehicles);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Vehicles;
}();

exports.default = Vehicles;


Vehicles.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VehicleGroups = function () {
  function VehicleGroups($q, API) {
    _classCallCheck(this, VehicleGroups);

    this.$q = $q;
    this.API = API;
  }

  _createClass(VehicleGroups, [{
    key: "getVehicleGroups",
    value: function getVehicleGroups(vehicleIds, groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("vehicleId", vehicleIds));
      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicles) {
        //console.log("vehicle groups: ", vehicles);
        deferred.resolve(vehicles);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getById",
    value: function getById(groupId) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups/" + groupId;

      var param = [];
      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicle) {
        return deferred.resolve(vehicle);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return VehicleGroups;
}();

exports.default = VehicleGroups;


VehicleGroups.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Drivers = function () {
  function Drivers($q, API) {
    _classCallCheck(this, Drivers);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Drivers, [{
    key: "getDrivers",
    value: function getDrivers(groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var deferred = this.$q.defer();
      var url = "v1/drivers";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (drivers) {
        //console.log("drivers: ", drivers);
        deferred.resolve(drivers);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Drivers;
}();

exports.default = Drivers;


Drivers.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DriverGroups = function () {
  function DriverGroups($q, API) {
    _classCallCheck(this, DriverGroups);

    this.$q = $q;
    this.API = API;
  }

  _createClass(DriverGroups, [{
    key: "getDriverGroups",
    value: function getDriverGroups(driverIds, groupIds, searchTerm, paging) {
      var targetAccount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var deferred = this.$q.defer();
      var url = "v1/driver-groups";

      var param = [];
      param.push.apply(param, this.API.getPagingQuery(paging));
      if (searchTerm) param.push("searchTerm=" + searchTerm);

      // todo: group id and driver id arrays are not currently implemented yet on the server side.
      // todo: leave these here as placeholders for when they do get put in
      param.push.apply(param, this.API.getArrayQuery("driverId", driverIds));
      param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));

      if (searchTerm) param.push("searchTerm=" + searchTerm);

      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (drivers) {
        //console.log("drivers groups: ", drivers);
        deferred.resolve(drivers);
      }).error(function (err) {
        console.log("error: ", err);
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getById",
    value: function getById(groupId) {
      var targetAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var deferred = this.$q.defer();
      var url = "v1/driver-groups/" + groupId;

      var param = [];
      if (targetAccount !== null) param.push("targetAccount=" + targetAccount);

      if (param.length > 0) {
        url += "?" + param.join("&");
      }

      this.API.get(url).success(function (vehicle) {
        return deferred.resolve(vehicle);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return DriverGroups;
}();

exports.default = DriverGroups;


DriverGroups.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoutingProfiles = function () {
  function RoutingProfiles($q, API) {
    _classCallCheck(this, RoutingProfiles);

    this.$q = $q;
    this.API = API;
  }

  //Given a vehicle id, get all routing profiles associated with all this vehicle's vehicle groups


  _createClass(RoutingProfiles, [{
    key: "getVehicleRoutingProfiles",
    value: function getVehicleRoutingProfiles(vehicleId, options) {
      var deferred = this.$q.defer();
      var url = "v1/vehicle-groups?vehicleId=" + vehicleId;

      var that = this;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise.then(function (results) {
        var vgPromises = _.map(results, function (result) {
          return that.getRoutingProfiles(result.id, options);
        });
        return that.$q.all(vgPromises).then(function (rpArrayOfArrays) {
          var rpFlatArray = [].concat.apply([], rpArrayOfArrays);
          rpFlatArray = _.uniq(rpFlatArray, function (rp) {
            return rp.routingProfileId;
          });
          //console.log("VEHICLE ROUTING PROFILES:");
          //console.log(rpFlatArray);
          return rpFlatArray;
        }, function (error) {
          console.log(error);
          return null;
        });
      }, function (error) {
        console.log(error);
        return null;
      });
    }
  }, {
    key: "getRoutingProfiles",
    value: function getRoutingProfiles(vehicleGroupId, options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles?includeGroupId=" + vehicleGroupId;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getRoutingProfile",
    value: function getRoutingProfile(routingProfileId, options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles/" + routingProfileId;

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getDefaultRoutingProfile",
    value: function getDefaultRoutingProfile(options) {
      var deferred = this.$q.defer();
      var url = "v1/routing-profiles?isDefault=true";

      this.API.get(url, options).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return RoutingProfiles;
}();

exports.default = RoutingProfiles;


RoutingProfiles.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FleetPortalAPI = function () {
  function FleetPortalAPI($http, $window, config) {
    _classCallCheck(this, FleetPortalAPI);

    this.$http = $http;
    this.$window = $window;
    this.config = config;
  }

  _createClass(FleetPortalAPI, [{
    key: "get",
    value: function get(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.get("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "post",
    value: function post(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.post("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "put",
    value: function put(url, data, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.put("" + this.config.apiUrl + url, data, options);
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      if (!this.config.apiUrl) throw Error("API URL Must be set during application startup");

      options = angular.extend({}, options, this.getOptions());

      return this.$http.delete("" + this.config.apiUrl + url, options);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var userString = this.$window.sessionStorage["userAuthInfo"];
      var user = JSON.parse(userString);

      var options = {
        headers: {
          "ALK-Language": undefined,
          "Authorization": "Bearer " + user.authToken
        }
      };

      return options;
    }
  }, {
    key: "getPagingQuery",
    value: function getPagingQuery(paging) {
      if (!paging) return [];

      var p = [];
      if (paging.pageNumber != null) p.push("pageNumber=" + paging.pageNumber);
      if (paging.limit != null) p.push("limit=" + paging.limit);
      if (paging.sortBy != null) p.push("sortBy=" + paging.sortBy);
      if (paging.sortAscending != null) p.push("sortAscending=" + paging.sortAscending);

      return p;
    }
  }, {
    key: "getArrayQuery",
    value: function getArrayQuery(key, arr) {
      if (arr == null) return [];

      var p = [];

      if (this.isArray(arr)) {
        for (var i = 0; i < arr.length; i++) {
          p.push(key + "=" + arr[i]);
        }
      } else {
        // if passed in item is not an array, but instead a single item
        p.push(key + "=" + arr);
      }

      return p;
    }
  }, {
    key: "isArray",
    value: function isArray(arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    }
  }]);

  return FleetPortalAPI;
}();

exports.default = FleetPortalAPI;


FleetPortalAPI.$inject = ["$http", "$window", "alk.fleetportal.config"];

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Users = function () {
  function Users($q, API) {
    _classCallCheck(this, Users);

    this.$q = $q;
    this.API = API;
  }

  _createClass(Users, [{
    key: "_getOpts",
    value: function _getOpts(applicationName) {
      return {
        params: {
          applicationName: applicationName
        }
      };
    }
  }, {
    key: "getUsers",
    value: function getUsers(applicationName) {
      var deferred = this.$q.defer();
      var url = "v1/users";

      this.API.get(url, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "getUserWithGroupInfo",
    value: function getUserWithGroupInfo(userId) {
      var deferred = this.$q.defer();
      var url = "v1/usersWithGroupInfo/" + userId;

      this.API.get(url).success(function (results) {
        deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "createUser",
    value: function createUser(user, applicationName) {

      var deferred = this.$q.defer();
      var url = "v1/users";

      var body = JSON.stringify({
        EmailAddress: user.emailAddress,
        FirstName: user.firstName,
        LastName: user.lastName,
        Enabled: true,
        Role: user.role
      });

      this.API.post(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "updateUser",
    value: function updateUser(user, applicationName) {

      var deferred = this.$q.defer();
      var url = "v1/users/" + user.userId;

      var body = JSON.stringify({
        EmailAddress: user.emailAddress,
        FirstName: user.firstName,
        LastName: user.lastName,
        Role: user.role,
        Enabled: user.enabled
      });

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "removeUser",
    value: function removeUser(userId, applicationName) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId;

      this.API.delete(url, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "setUserVehicleGroups",
    value: function setUserVehicleGroups(userId, applicationName, vehicleGroupIds) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId + "/vehicle-groups";

      var body = JSON.stringify(vehicleGroupIds);

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }, {
    key: "setUserDriverGroups",
    value: function setUserDriverGroups(userId, applicationName, driverGroupIds) {
      var deferred = this.$q.defer();
      var url = "v1/users/" + userId + "/driver-groups";
      var body = JSON.stringify(driverGroupIds);

      this.API.put(url, body, this._getOpts(applicationName)).success(function (results) {
        return deferred.resolve(results);
      }).error(function (err) {
        return deferred.reject(err);
      });

      return deferred.promise;
    }
  }]);

  return Users;
}();

exports.default = Users;


Users.$inject = ["$q", "FleetPortalAPI"];

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.places", []);
})(window.angular);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals _ */

var config = __webpack_require__(1);

(function () {
  "use strict";

  angular.module("alk.places").factory("placeCloudService", placeCloudService);
  placeCloudService.$inject = ["$http", "$q", "mapUtilities", "UserProvider", "PCMRegion"];

  function placeCloudService($http, $q, mapUtilities, UserProvider, PCMRegion) {

    var daUrl = config.daUrl;

    // pchen: temp default params for yard gate notes (since no UI for them)
    var DEFAULT_NOTE_FLAGS = {
      "TriggerDistance": 250,
      "NoteTitle": "",
      //"Sequence": 0,
      //"Active": true,
      "TravelIntent": 0,
      "AlertType": 3
    };

    var COMPANY_PLACES_TYPE_ID = 1803;

    return {
      getPlaceSetWithName: getPlaceSetWithName,
      getPlaceSets: getPlaceSets,
      addPlaceSet: addPlaceSet,
      addCategoryForSet: addCategoryForSet,
      getCategoryForSet: getCategoryForSet,
      getCategoryIcons: getCategoryIcons,
      getCategoryDefaultIcon: getCategoryDefaultIcon,
      updateCategoryForSet: updateCategoryForSet,
      deletePlaceSet: deletePlaceSet,
      updatePlaceSet: updatePlaceSet,
      getPlaces: getPlaces,
      getPlaceByPlaceId: getPlaceByPlaceId,
      testCompanyIds: testCompanyIds,
      saveNewPlace: saveNewPlace,
      saveNewPlaces: saveNewPlaces,
      deletePlace: deletePlace,
      deletePlaces: deletePlaces,
      updatePlace: updatePlace,
      movePlaces: movePlaces,
      getYardByYardId: getYardByYardId,
      addYard: addYard,
      deleteYard: deleteYard,
      addPlaceToYard: addPlaceToYard,
      removeYardFromPlace: removeYardFromPlace,
      addYardGate: addYardGate,
      addYardGates: addYardGates,
      deleteYardGate: deleteYardGate,
      getYardGates: getYardGates,
      parseGateResponse: parseGateResponse,
      updateYard: updateYard,
      updateYardGate: updateYardGate,
      getYardGateNote: getYardGateNote,
      addYardGateNote: addYardGateNote,
      updateYardGateNote: updateYardGateNote,
      deleteYardGateNote: deleteYardGateNote,
      getYardGatePath: getYardGatePath,
      addYardGatePath: addYardGatePath,
      updateYardGatePath: updateYardGatePath,
      deleteYardGatePath: deleteYardGatePath,
      createUniqueId: createUniqueId,
      // TODO pchen: move to separate file specifically for DA routing-profiles
      getRoutingProfileList: getRoutingProfileList
    };

    //Check if a place set with name (exact match) exists.
    // pchen: only used in PCMWeb so far, for favorites
    function getPlaceSetWithName(name) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$onlyMine = _ref.onlyMine,
          onlyMine = _ref$onlyMine === undefined ? true : _ref$onlyMine,
          _ref$useShared = _ref.useShared,
          useShared = _ref$useShared === undefined ? false : _ref$useShared;

      var params = {
        "includePlaces": false,
        "onlyMine": onlyMine,
        "useShared": useShared,
        "name": name,
        // if true, include ALK public sets in response
        "readOnlyPublicData": false
      };

      var request = {
        method: "GET",
        url: daUrl + "place-sets/-1",
        params: params
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function getPlaceSets(filter) {

      var promises = [];
      //Not an admin, don't show private
      if (!UserProvider.getUser() || !UserProvider.getUser().roles || UserProvider.getUser().roles.indexOf("ALK Administrator") === -1) {
        //Get Favorites
        var userPromise = $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=True&useShared=False&readOnlyPublicData=True&nameFilter=" + (filter || ""));
        var accountPromise = $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=True&useShared=True&readOnlyPublicData=True&nameFilter=" + (filter || ""));
        promises = [userPromise, accountPromise];
        return $q.all(promises).then(function (sets) {
          var onlyMine = sets[0].data; // User's private sets.
          var onlyShared = sets[1].data; // All shared sets. (Does not include user's private or anyone else's)
          return _.union(onlyMine, onlyShared, "Name");
        }, function (response) {
          console.log(response);
          return null;
        });
      }
      //An admin, show all (including private)
      else {
          return $http.get(daUrl + "place-sets/-1?getSetOptions=true&includePlaces=false&onlyMine=false&useShared=true&readOnlyPublicData=True&nameFilter=" + (filter || "")).then(function (set) {
            return set.data;
          }, function (response) {
            console.log(response);
            return null;
          });
        }
    };

    function defaultErrorHandler(response) {
      console.log(response);
      return null;
    }

    function addPlaceSet(setName, errorHandler, isShared, setOptions, setStyle) {

      //Default to shared
      if (isShared === undefined) {
        isShared = true;
      }

      var params = {
        "useShared": isShared
      };
      var postData = {
        Name: setName,
        Style: JSON.stringify(setStyle),
        Options: setOptions ? setOptions : {
          DisplayOnMap: true,
          Searchable: true,
          Alertable: true
        }
      };

      var request = {
        method: "POST",
        url: daUrl + "place-sets",
        params: params,
        data: postData
      };

      var respErrorHandler = errorHandler || defaultErrorHandler;

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, respErrorHandler);
    }

    function deletePlaceSet(setId) {
      var request = {
        method: "DELETE",
        url: daUrl + "place-sets/" + setId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function updatePlaceSet(setId, setName, setStyle, errorHandler, setOptions) {
      var putData = {
        Name: setName,
        Style: JSON.stringify(setStyle)
      };

      if (setOptions) {
        putData.Options = setOptions;
      }

      var params = {
        "useShared": true
      };

      var request = {
        method: "PUT",
        url: daUrl + "place-sets/" + setId,
        params: params,
        data: putData
      };

      var respErrorHandler = errorHandler || defaultErrorHandler;

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, respErrorHandler);
    };

    function getCategoryOptionsFromSetOptions(setOptions) {
      var TypeOption_None = 0x0000;
      var TypeOption_DisplayOnMap = 0x0001;
      var TypeOption_DisplayInWalkMode = 0x0002;
      var TypeOption_Searchable = 0x0004;
      var TypeOption_GroupableOnMap = 0x0008;
      var TypeOption_Alertable = 0x0010;

      var catOptions = TypeOption_None;
      if (setOptions) {
        if (setOptions.DisplayOnMap) catOptions = catOptions | TypeOption_DisplayOnMap;
        if (setOptions.Searchable) catOptions = catOptions | TypeOption_Searchable;
        if (setOptions.Alertable) catOptions = catOptions | TypeOption_Alertable;
      } else {
        catOptions = TypeOption_DisplayOnMap | TypeOption_Searchable | TypeOption_Alertable;
      }

      return catOptions;
    }

    function getCategoryDefaultMaxZoomLevel() {
      return 4;
    }

    function updateCategoryForSet(category, setOptions) {
      var catOptions = getCategoryOptionsFromSetOptions(setOptions);
      var catPostData = {
        Icon: category.Icon,
        IconUrl: category.IconURL,
        Name: category.Name,
        MaxZoomLevel: category.MaxZoomLevel,
        Options: catOptions,
        ParentId: category.ParentId,
        ClientParentId: COMPANY_PLACES_TYPE_ID,
        SetId: category.SetId
      };

      var catRequest = {
        method: "PUT",
        url: daUrl + "place-categories/" + category.Id,
        params: null,
        data: catPostData
      };

      var respErrorHandler = defaultErrorHandler;

      return $http(catRequest).then(function (response) {//success
      }, respErrorHandler);
    }

    function getCategoryForSet(set) {
      if (set == null) {
        var deferred = $q.defer();
        deferred.resolve(-1);
        return deferred.promise;
      } else if (set.Categories && set.Categories.length > 0) {
        var deferred = $q.defer();
        deferred.resolve(set.Categories[0].Id);
        return deferred.promise;
      } else {
        return addCategoryForSet(set.Name, set.Id, set.Options).then(function (response) {
          return response.Id;
        });
      }
    }

    function addCategoryForSet(setName, setId, setOptions, icon) {
      icon = icon || getCategoryDefaultIcon().Icon; // default if undefined
      var catOptions = getCategoryOptionsFromSetOptions(setOptions);
      var catPostData = {
        Icon: icon,
        IconUrl: null,
        Name: setName,
        MaxZoomLevel: getCategoryDefaultMaxZoomLevel(),
        Options: catOptions,
        ParentId: null,
        ClientParentId: COMPANY_PLACES_TYPE_ID,
        SetId: setId
      };

      var catRequest = {
        method: "POST",
        url: daUrl + "place-categories?updatePlaces=true",
        params: null,
        data: catPostData
      };

      var respErrorHandler = defaultErrorHandler;

      return $http(catRequest).then(function (response) {
        //success
        return response.data;
      }, respErrorHandler);
    }

    /**
     * Get set details and all places details.
     *  Note: yardId field in response is deprecated in server side. We will use SiteId field value.
     *  However to follow naming convention still called it yardId here.
     * @param {Number} setId
     * @param {String} filter
     * @param {Boolean} includePlaces
     * @param {Boolean} readOnlyPublicData
     */
    function getPlaces(setId, filter, includePlaces) {
      var readOnlyPublicData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var params = {
        "includePlaces": includePlaces == null ? true : includePlaces,
        "onlyMine": false,
        "useShared": true,
        // if true and set is ALK Public, return the set (instead of "DataAccessException")
        "readOnlyPublicData": readOnlyPublicData,
        "placeNameFilter": filter || ""
      };

      var request = {
        method: "GET",
        url: daUrl + "place-sets/" + setId,
        params: params
      };

      return $http(request).then(function (response) {
        //success
        var res = response.data[0];
        var places = res.Places;
        if (places != null && places.length > 0) {
          _.each(places, function (p) {
            p.YardId = p.SiteId;
            delete p.SiteId;
          });
        }
        return res;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    /**
     * Get places details given the place Id.
     *  Note: yardId field in response is deprecated in server side. We will use SiteId field value.
     *  However to follow naming convention still called it yardId here.
     * @param {Number} placeId
     * @param {Boolean} readOnlyPublicData
     */
    function getPlaceByPlaceId(placeId) {
      var readOnlyPublicData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var params = {
        // if true and place is ALK Public, return the place instead of "DataAccessException"
        "readOnlyPublicData": readOnlyPublicData
      };

      var request = {
        method: "GET",
        url: daUrl + "places/" + placeId,
        params: params
      };

      return $http(request).then(function (response) {
        //success
        var res = response.data;
        res[0].YardId = res[0].SiteId;
        delete res[0].SiteId;
        return res;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function getPlacePostData(setId, catId, place) {
      //Guard against null values by defaulting to empty string
      _.each(place, function (value, key) {
        if (value === null || value === undefined) {
          place[key] = "";
        }
      });
      var address = {
        StreetAddress: place.street,
        City: place.city,
        State: place.state.toUpperCase(), //State abbreviations should be capitalized
        Zip: place.zip,
        County: place.county,
        Country: place.country
      };
      var coords = {
        Lat: place.latitude,
        Lon: place.longitude
      };

      var postData = {
        Address: address,
        CategoryId: catId,
        CompanyId: place.companyId,
        Coords: coords,
        PlaceName: place.placeName,
        Phone: place.phone,
        SetId: setId,
        Info: place.info
      };
      return postData;
    };

    // see if CID already exists in database (for this account)
    //  returns CIDs that would conflict
    function testCompanyIds(cidList) {
      var request = {
        method: "POST",
        url: daUrl + "places/id-test",
        data: cidList
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function saveNewPlace(setId, catId, place) {
      var placePostData = getPlacePostData(setId, catId, place);

      var request = {
        method: "POST",
        url: daUrl + "places",
        data: placePostData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    //See getPlacePostData for each object's expected properties in places array argument
    function saveNewPlaces(setId, catId, places) {
      if (places.length === 0) {
        return Promise.resolve(true);
      }
      var postData = [];
      _.each(places, function (place) {
        var placeData = getPlacePostData(setId, catId, place);
        postData.push(placeData);
      });

      var request = {
        method: "POST",
        url: daUrl + "places_multiple?setId=" + setId.toString() + "&catId=" + catId.toString(),
        data: postData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function deletePlace(placeId) {
      var request = {
        method: "DELETE",
        url: daUrl + "places/" + placeId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function deletePlaces(placeIdList) {
      //If no places in list, just resolve promise to true immediately
      if (placeIdList.length === 0) {
        return Promise.resolve(true);
      }

      for (var i = 0; i < placeIdList.length; i++) {
        placeIdList[i] = placeIdList[i].toString();
      }

      var request = {
        method: "POST",
        url: daUrl + "places/delete/multiple",
        data: placeIdList
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function updatePlace(placeObj) {
      var request = {
        method: "PUT",
        url: daUrl + "places/" + placeObj.Id,
        data: placeObj
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function movePlaces(placeIds, destinationSet, catId) {

      var request = {
        method: "PUT",
        url: daUrl + "place-sets/" + destinationSet + "/places",
        data: placeIds
      };

      if (catId) request.url += "?newCatId=" + catId;

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function getCategoryIcons() {
      return [{
        color: "#B84A00",
        shape: "circle",
        Icon: "truck",
        name: "Truck Services"
      }, {
        color: "#123EC4",
        shape: "circle",
        Icon: "auto_rental",
        name: "Vehicle Dealership & Repair"
      }, {
        color: "#1E834C",
        shape: "circle",
        Icon: "entertainment",
        name: "Entertainment"
      }, {
        color: "#1E834C",
        shape: "circle",
        Icon: "retail",
        name: "Retail"
      }, {
        color: "#f78d28",
        shape: "circle",
        Icon: "restaurant",
        name: "Restaurant"
      }, {
        color: "#123EC4",
        shape: "circle",
        Icon: "parking",
        name: "Parking & Rest Area"
      }, {
        color: "#00BAAE",
        shape: "circle",
        Icon: "other",
        name: "Other"
      }, {
        color: "#E63D00",
        shape: "circle",
        Icon: "medical",
        name: "Medical & Emergency"
      }, {
        color: "#913D88",
        shape: "circle",
        Icon: "hotel",
        name: "Hotel & Accommodation"
      }, {
        color: "#450DBD",
        shape: "circle",
        Icon: "fuel",
        name: "Gas Station"
      }, {
        color: "#123EC4",
        shape: "circle",
        Icon: "charging_station",
        name: "Electric Vehicle Charging Station"
      }, {
        color: "#B84A00",
        shape: "circle",
        Icon: "distribution_center",
        name: "Distribution Center"
      }, {
        color: "#1E834C",
        shape: "circle",
        Icon: "bank",
        name: "Bank & ATM"
      }, {
        color: "#123EC4",
        shape: "circle",
        Icon: "airport",
        name: "Airport & Transportation"
      }, {
        color: "#B84A00",
        shape: "circle",
        Icon: "manufacturing_plant",
        name: "Manufacturing Plant"
      }];
    }
    function getCategoryDefaultIcon() {
      return {
        color: "#00BAAE",
        shape: "circle",
        Icon: "other",
        name: "Other"
      };
    }

    /**
     * Return Yard Id, Yard Name and ShapePointsList given the yard Id
     *  Note: in new services YardName field and ShapePointsList fields are deprecated. We will use SiteName and Polygon field.
     *  However to follow naming convention still called YardName and ShapePointsList.
     * @param {Number} yardId
     */
    function getYardByYardId(yardId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/" + yardId
      };

      return $http(request).then(function (response) {
        //success
        var res = response.data;
        res.YardName = res.SiteName;
        res.ShapePointsList = res.Polygon;
        delete res.SiteName;
        delete res.Polygon;
        return res;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    //The WS expects the last point to equal the first (it also returns the last point equal to the first)
    function yardPtsToLLArray(shapePoints) {
      var firstPoint = shapePoints[0];
      var lastPoint = shapePoints[shapePoints.length - 1];

      if (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1]) {
        shapePoints.push(shapePoints[0]);
      }

      return shapePoints;
    }

    function addYard(_ref2) {
      var yardName = _ref2.yardName,
          shapePoints = _ref2.shapePoints,
          siteDetail = _ref2.siteDetail;

      var points = yardPtsToLLArray(shapePoints);
      var postData = {
        SiteName: yardName,
        Polygon: [points],
        SiteDetail: siteDetail
      };

      var request = {
        method: "POST",
        url: daUrl + "sites",
        data: postData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    function deleteYard(yardId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/" + yardId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        return response.data;
      });
    }

    function updateYard(yardId, _ref3) {
      var yardName = _ref3.yardName,
          shapePoints = _ref3.shapePoints,
          siteDetail = _ref3.siteDetail;

      var points = yardPtsToLLArray(shapePoints);
      var putData = {
        SiteName: yardName,
        SiteID: yardId,
        Polygon: [points],
        SiteDetail: siteDetail
      };

      var request = {
        method: "PUT",
        url: daUrl + "sites",
        data: putData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function addPlaceToYard(yardId, placeId, returnNullOnFail) {
      var request = {
        method: "POST",
        url: daUrl + "sites/" + yardId + "/places/" + placeId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        // console.log(response);
        if (!returnNullOnFail) {
          return response.data;
        } else {
          return null;
        }
      });
    };

    function removeYardFromPlace(yardId, placeId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/places/" + placeId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        // console.log(response);
        return response.data;
      });
    };

    function addYardGate(yardId, yardGateType, gate) {
      var plidArray = [];
      var arr = gate.plid.split(',');
      arr = _.uniq(arr);
      _.each(arr, function (p) {
        plidArray.push({ "ID": p });
      });

      var postData = {
        SiteID: yardId,
        GateType: yardGateType,
        Latitude: gate.Coords.Lat,
        Longitude: gate.Coords.Lon,
        SnapLatitude: gate.SnapCoords.Lat,
        SnapLongitude: gate.SnapCoords.Lon,
        PLIDs: plidArray,
        AutoRestricted: gate.AutoRestricted,
        TruckRestricted: gate.TruckRestricted
      };

      var request = {
        method: "POST",
        url: daUrl + "sites/gates",
        data: postData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    };

    //Add multiple yard gates at once.
    function addYardGates(yardId, gates) {
      var promises = [];

      var _loop = function _loop(gate) {
        promise = addYardGate(yardId, gate.Type, gate).then(function (response) {
          if (!response) {
            return null;
          }
          gate.YardGateId = response.Id;
          if (gate.NoteContent) {
            return addYardGateNote(gate, gate.NoteContent);
          } else {
            return response;
          }
        });

        promises.push(promise);
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = gates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var gate = _step.value;
          var promise;

          _loop(gate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return $q.all(promises);
    }

    function deleteYardGate(gate) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/gates/" + gate.YardGateId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        return response.data;
      });
    }

    function updateYardGate(yardId, yardGateType, gate) {
      var plidArray = [];
      var arr = gate.plid.split(',');
      arr = _.uniq(arr);
      _.each(arr, function (p) {
        plidArray.push({ "ID": p });
      });

      var putData = {
        SiteID: yardId,
        SiteGateID: gate.YardGateId,
        GateType: yardGateType,
        Latitude: gate.Coords.Lat,
        Longitude: gate.Coords.Lon,
        SnapLatitude: gate.SnapCoords.Lat,
        SnapLongitude: gate.SnapCoords.Lon,
        PLIDs: plidArray,
        AutoRestricted: gate.AutoRestricted,
        TruckRestricted: gate.TruckRestricted
      };

      var request = {
        method: "PUT",
        url: daUrl + "sites/gates",
        data: putData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    /**
     * Get the site note list given the gate Id
     * @param {Number} gateId
     */
    function getYardGateNote(gateId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/notesforgate/" + gateId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function addYardGateNote(gate, note) {
      if (!note) {
        // TODO pchen: have this check in webservice
        // extra validation to prevent empty notes from getting into DA
        return null;
      }
      var postData = {
        SiteGateID: gate.YardGateId,
        NoteContent: note,
        NoteTitle: "",
        NoteIndex: 0,
        TravelIntent: gate.GateType
      };
      _.defaults(postData, DEFAULT_NOTE_FLAGS);

      var request = {
        method: "POST",
        url: daUrl + "sites/notes",
        data: postData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function updateYardGateNote(gate, note) {
      if (!note) {
        // TODO pchen: have this check in webservice
        // extra validation to prevent empty notes from getting into DA
        return null;
      }
      var putData = {
        NoteContent: note,
        SiteGateID: gate.YardGateId,
        SiteNoteID: gate.YardNoteId,
        NoteTitle: "",
        NoteIndex: 0,
        TravelIntent: gate.GateType
      };
      _.defaults(putData, DEFAULT_NOTE_FLAGS);

      var request = {
        method: "PUT",
        url: daUrl + "sites/notes",
        data: putData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function deleteYardGateNote(gate) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/notes/" + gate.YardNoteId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    /**
     * Return all yard gates given the yard Id
     *  Note: the response object is quite different compared to old getYardGates function.
     * @param {number} yardId
     */
    function getYardGates(yardId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/gatesforsite/" + yardId
      };
      var deferred = $q.defer();
      $http(request).then(function (response) {
        //success
        var yardGates = [];
        _.each(response.data, function (res) {
          res.Coords = {
            "Lon": res.Longitude,
            "Lat": res.Latitude
          };
          res.SnapCoords = {
            "Lon": res.SnapLongitude,
            "Lat": res.SnapLatitude
          };
          res.YardId = res.SiteID; // it's SiteID, not SiteId
          res.YardGateId = res.SiteGateID; // it's SiteGateID, not SiteGateId
          var plidArr = [];
          _.each(res.PLIDs, function (p) {
            plidArr.push(p.ID);
          }); // PLIDs comes in array of object.
          res.PLID = plidArr.join(",");
          res.Type = res.GateType == null ? 0 : res.GateType;
          res.YardGateUUId = createUniqueId(); // used as a reference key

          delete res.SiteID;
          delete res.SiteGateID;
          delete res.Longitude;
          delete res.Latitude;
          delete res.SnapLongitude;
          delete res.SnapLatitude;
          delete res.PLIDs;
          delete res.GateType;

          yardGates.push(res);
        });

        // now we have all the yard gate data, we want to get yard gate note
        var getYardGateNotePromises = [];
        _.each(yardGates, function (gate) {
          var promise = getYardGateNote(gate.YardGateId);
          getYardGateNotePromises.push(promise);
        });

        $q.all(getYardGateNotePromises).then(function (yardGateNoteResponse) {
          for (var i = 0; i < yardGateNoteResponse.length; i++) {
            // each gate can have more than one notes, response is an array.
            // for now, CT only has one note per gate, so always grab the first one.
            if (yardGateNoteResponse[i] != null && yardGateNoteResponse[i][0] != null) {
              yardGates[i].NoteContent = yardGateNoteResponse[i][0].NoteContent;
              yardGates[i].YardNoteId = yardGateNoteResponse[i][0].SiteNoteID;
            } else {
              yardGates[i].NoteContent = "";
            }
          }
          deferred.resolve(yardGates);
        });
      }, function (error) {
        //fail
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function parseGateResponse(site) {
      var yardGates = [];

      _.each(site.SiteGates, function (res) {
        res.Coords = {
          "Lon": res.Longitude,
          "Lat": res.Latitude
        };
        res.SnapCoords = {
          "Lon": res.SnapLongitude,
          "Lat": res.SnapLatitude
        };
        res.YardId = res.SiteID; // it's SiteID, not SiteId
        res.YardGateId = res.SiteGateID; // it's SiteGateID, not SiteGateId
        var plidArr = [];
        _.each(res.PLIDs, function (p) {
          plidArr.push(p.ID);
        }); // PLIDs comes in array of object.
        res.PLID = plidArr.join(",");
        res.Type = res.GateType == null ? 0 : res.GateType;
        res.YardGateUUId = createUniqueId(); // used as a reference key

        var gateNotes = res.GateNotes;

        if (!_.isUndefined(gateNotes) && gateNotes.length > 0) {
          res.NoteContent = gateNotes[0].NoteContent;
          res.YardNoteId = gateNotes[0].SiteNoteID;
        } else {
          res.NoteContent = "";
        }

        res.paths = [];
        if (!_.isUndefined(res.GatePaths) && res.GatePaths.length > 0) {
          _.each(res.GatePaths, function (p) {
            var plidArr = [];

            _.each(p.PLIDs, function (plid) {
              plidArr.push(plid.ID);
            }); // PLIDs comes in array of object.

            res.paths.push({
              "yardPathId": p.SitePathID,
              "yardGateId": p.SiteGateID,
              "yardGateUUId": res.YardGateUUId,
              "yardPathUUId": createUniqueId(), // generate a UUId to be used as a reference Id
              "yardPathType": p.TravelIntent,
              "yardPathWayPoints": p.Waypoints,
              "yardPathPLIDs": plidArr,
              "isPathCurrentlyBeingEdit": false,
              // based on these values, the controller will find the full
              //   routing profile to replace this with
              "routingProfileStub": {
                "routingProfileId": p.RoutingProfileID,
                "defaultRoutingProfileKey": p.DefaultRoutingProfileKey
              }
            });
          });
        }

        delete res.SiteID;
        delete res.SiteGateID;
        delete res.Longitude;
        delete res.Latitude;
        delete res.SnapLongitude;
        delete res.SnapLatitude;
        delete res.PLIDs;
        delete res.GateType;
        delete res.GateNotes;
        delete res.GatePaths;

        yardGates.push(res);
      });

      return yardGates;
    }

    // TODO pchen: remove because it's not being used by anything
    /**
     * Return PLIDs and WayPoints and its yard gate Id given route path Id
     * @param {Number} pathId
     */
    function getYardGatePath(pathId) {
      var request = {
        method: "GET",
        url: daUrl + "sites/paths/" + pathId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function constructPathPostBody(siteGateId, path) {
      var plidArray = [];
      // remove duplicates per Hugo suggests
      path.yardPathPLIDs = _.uniq(path.yardPathPLIDs);
      // TODO pchen: change all this to a .map
      _.each(path.yardPathPLIDs, function (p) {
        plidArray.push({ "ID": p });
      });

      var postData = {
        SiteGateID: siteGateId,
        TravelIntent: path.yardPathType,
        Waypoints: path.yardPathWayPoints,
        PLIDs: plidArray
      };

      if (path.routingProfile) {
        postData.RoutingProfileID = path.routingProfile.routingProfileId;
        postData.DefaultRoutingProfileKey = path.routingProfile.defaultRoutingProfileKey;
      }

      return postData;
    }

    function addYardGatePath(_ref4, path) {
      var YardGateId = _ref4.YardGateId;

      if (!path) {
        return;
      }

      var postData = constructPathPostBody(YardGateId, path);

      var request = {
        method: "POST",
        url: daUrl + "sites/paths",
        data: postData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function updateYardGatePath(_ref5, path) {
      var YardGateId = _ref5.YardGateId;

      if (!path) {
        return;
      }

      var putData = constructPathPostBody(YardGateId, path);
      putData.SitePathID = path.yardPathId;

      var request = {
        method: "PUT",
        url: daUrl + "sites/paths",
        data: putData
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }

    function deleteYardGatePath(pathId) {
      var request = {
        method: "DELETE",
        url: daUrl + "sites/paths/" + pathId
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        return response.data;
      });
    }

    /**
     * generate unique id to be used in yard gate and yard path.
     * Some gate and path have not been saved to db and got an Id yet but we still want to reference it in the code.
     */
    function createUniqueId() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    // TODO pchen: move to separate file specifically for DA routing-profiles
    function getRoutingProfileList() {
      var request = {
        method: "GET",
        url: daUrl + "routing-profiles/id/-1?sortBy=NAME_ASC&includeDeletedContent=false&fleetPortalRoutingProfileOnly=true&onlyMine=false"
      };

      return $http(request).then(function (response) {
        //success
        return response.data;
      }, function (response) {
        //fail
        console.log(response);
        return null;
      });
    }
  }
})();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.singlesearch", []);
})(window.angular);

__webpack_require__(371);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @typedef {Object} singleSearchService
 * @property {Function} search
 */

(function (angular) {
  "use strict";

  angular.module("alk.singlesearch")
  /** @name alk.singlesearch.config
   * @ngdoc constant
   * @description Provides for single search configuration
   * @memberof alk.singlesearch
   */
  .constant("alk.singlesearch.config", {}).service("singleSearchService", ["alk.singlesearch.config", "$q", "$http", "_", "$rootScope",

  /** @name singleSearchService
   * @ngdoc service
   * @param {service} config [Single Search Configuration object](alk.singlesearch.config.html)
   * @param {service} $q angularJS [promises/deferred objects service](https://docs.angularjs.org/api/ng/service/$q)
   * @param {service} $http angularJS [HTTP communication service](https://docs.angularjs.org/api/ng/service/$http)
   * @param {service} _ [Lodash](https://lodash.com/docs/4.17.4)
   * @param {service} angularJS [root scope](https://docs.angularjs.org/api/ng/service/$rootScope) service
   * @description Provides geocoding and reverse geocoding functions through ALK's [Single Search](http://singlesearch-test-aws-qa.alk.com/) geocoder
   * @returns singleSearchService
   * @memberof alk.singlesearch
   */
  function (config, $q, $http, _, $rootScope) {
    var searchRequests = [];
    //Debounce so that fast typing doesn't spam server with too many requests
    var debouncedSearchHelper = _.debounce(searchHelper, 500, {
      leading: true
    });

    var lazyInitdValidPoiCategories = void 0;

    return {
      search: search, // a debounced function with callback
      singleSearchQueryPromise: singleSearchQueryPromise, // a simple promise that can be used for promise chaining
      getValidPoiCategories: getValidPoiCategories
    };

    ////////////

    /**
     * Initiate a single search service request. Will only initiate request if searchParams.query has more than 2 characters.
     * @param {Object} searchParams The same params that the single search API uses. However, do not specify authToken here, it will be handled by this service.
     * @param {Function} searchStartCallback A function that gets invoked before a search network request will be made
     * @param {Function} successCallback A function that gets invoked after a search network request succeeded; first parameter will contain list of search results
     * @param {Function} errorCallback A function that gets invoked after a search network request failed; first parameter will contain error string
     * @memberof singleSearchService
     */
    function search(searchParams, searchStartCallback, successCallback, errorCallback) {
      if (searchParams.query.length <= 2) {
        return;
      }
      debouncedSearchHelper(searchParams, searchStartCallback, successCallback, errorCallback);
    }

    function searchHelper(searchParams, searchStartCallback, successCallback, errorCallback) {
      searchStartCallback();
      clearRequests();
      var request = singleSearchQuery(searchParams, successCallback, errorCallback);
      searchRequests.push(request);
    }

    function clearRequests() {
      for (var i = searchRequests.length - 1; i > -1; i--) {
        searchRequests[i].cancel("new search");
        searchRequests.splice(i, 1);
      }
    }

    function setRegion(url, region) {
      if (region === "NA") {
        url = url.replace(/ww|EU/gi, "NA");
      }
      if (region === "EU") {
        url = url.replace(/ww|NA/gi, "EU");
      }
      return url;
    }

    function singleSearchQuery(searchParams, successCallback, errorCallback) {
      angular.extend(searchParams, {
        authToken: config.authToken
      });
      var canceller = $q.defer();
      var cancel = function cancel(reason) {
        canceller.resolve(reason);
        //console.log("Request cancelled");
      };

      config.url = setRegion(config.url, $rootScope.userInfo.region);
      var requestConfig = {};

      if (searchParams.customPlacesToken) {
        requestConfig.headers = {
          Authorization: "token=" + searchParams.customPlacesToken
        };
        delete searchParams.customPlacesToken;
      }
      requestConfig.params = searchParams;

      var promise = $http.get(config.url, requestConfig).then(function (response) {
        successCallback(response.data.Locations);
        return response.data.Locations;
      }, function (response) {
        console.log("Error");
        errorCallback(response);
        return response;
      });

      return {
        promise: promise,
        cancel: cancel
      };
    }

    function singleSearchQueryPromise(searchParams, successCallback, errorCallback) {
      var deferred = $q.defer();
      singleSearchQuery(searchParams, successCallback, errorCallback).promise.then(function (res) {
        return deferred.resolve(res);
      }, function (err) {
        return deferred.reject(err);
      });
      return deferred.promise;
    }

    function getValidPoiCategories() {
      if (lazyInitdValidPoiCategories === undefined) {
        var url = setRegion(config.url, $rootScope.userInfo.region);
        lazyInitdValidPoiCategories = $http.get(url + "poiCategories", { params: { authToken: "" + config.authToken } }).then(function (_ref) {
          var data = _ref.data;

          return data.POICategories;
        }).catch(function () {
          return [];
        });
      }
      return lazyInitdValidPoiCategories;
    }
  }]);
})(window.angular);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.forms", ["alk.authentication", "alk.services"]);
})(window.angular);

__webpack_require__(373);
__webpack_require__(375);
__webpack_require__(377);
__webpack_require__(378);
__webpack_require__(380);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.forms").directive("alkLogin", alkLogin);

  alkLogin.$inject = [];

  function alkLogin() {

    var directive = {
      template: __webpack_require__(374),
      restrict: "E",
      scope: {
        controllerName: "@",
        marketingLink: "@"
      },
      //Use the passed-in controller-name attribute to create its controller
      controller: ["$controller", "$scope", function ($controller, $scope) {
        var c = $controller($scope.controllerName, { $scope: $scope });
        return c;
      }]
    };

    return directive;
  }
})();

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports = "<form alk-disabled=\"isProcessing\" class=\"hidden-xs\" name=\"loginForm\" novalidate role=\"form\" ng-show=\"!isltIE9\">\n\n  <div class=\"row\">\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.username.$invalid && loginForm.submitted }\">\n      <input id=\"username\" name=\"username\" placeholder=\"{{'common.login.Username' | translate}}\" class=\"form-control input-line\"\n        type=\"text\" alk-email ng-model=\"userInfo.username\" ng-disabled=\"accounts.length>0\" required />\n      <p ng-show=\"loginForm.username.$error.alkEmail && loginForm.submitted\" class=\"help-block pull-left\">{{\"validation.email\" | translate}}</p>\n      <p ng-show=\"loginForm.username.$error.required && loginForm.submitted && !loginForm.username.$error.alkEmail\" class=\"help-block pull-left\">{{\"validation.required\" | translate}}</p>\n    </div>\n    <div class=\"form-group col-sm-6\" ng-class=\"{ 'has-error' : loginForm.password.$invalid && loginForm.submitted }\">\n      <input id=\"password\" name=\"password\" placeholder=\"{{'common.login.Password' | translate}}\" class=\"form-control input-line\"\n        type=\"password\" ng-model=\"userInfo.password\" ng-disabled=\"accounts.length > 0\" required />\n      <p ng-show=\"loginForm.password.$error.required && loginForm.submitted\" class=\"help-block pull-left\">{{\"validation.required\" | translate}}</p>\n      <span class=\"pull-right\"><a ng-click=\"$parent.vm.formTab = 'forgot'\" class=\"btn btn-link btn-sm\">{{\"common.login.Forgot Password?\" | translate}}</a></span>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"form-group col-sm-12\" ng-if=\"accounts.length>0\" ng-class=\"{ 'has-error' : loginForm.account.$invalid && loginForm.submitted }\">\n      <select id=\"account\" name=\"account\" class=\"form-control input-sm input-line\" ng-model=\"userInfo.account\" required>\n        <option value=\"\">{{\"common.login.Select Account\" | translate}}</option>\n        <option ng-repeat=\"account in accounts\" value=\"{{account.accountName}}\">{{account.accountName}}</option>\n      </select>\n      <p ng-show=\"loginForm.account.$error.required && loginForm.submitted\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-6\">\n      <p class=\"text-small\"><a href=\"{{marketingLink}}\" target=\"_blank\">{{\"common.landing.DoIHaveID\" | translate}}</a></p>\n    </div>\n    <div class=\"col-sm-6 text-right form-group\">\n      <button id=\"login-submit\" ng-click=\"loginForm.submitted = true; login(userInfo, loginForm); $event.preventDefault(); $event.stopPropagation();\"\n        type=\"submit\" class=\"btn btn-lg btn-success\" ng-disabled=\"isltIE9 || isIE9\">\n        <i ng-show=\"isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{(isProcessing)? 'common.login.Logging in...': 'common.Go'}}</span>\n      </button>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"has-error\">\n        <p class=\"help-block\" ng-show=\"showAccountDisabled\">{{\"views.login.User or account is disabled\" | translate}}</p>\n        <p id=\"login-error\" class=\"help-block\" ng-show=\"showPasswordIncorrect\">{{\"views.login.Username or password is incorrect\" | translate}}</p>\n        <p id=\"server-error\" class=\"help-block\" ng-show=\"showGenericError || showUserDisabled\">{{\"views.login.GenericServerError\" | translate}}</p>\n        <p class=\"help-block\" ng-show=\"showNoAccountForApplication\">{{\"views.login.NoAccess\" | translate}}</p>\n      </div>\n      <div class=\"ie-old-warn alert alert-danger\" ng-if=\"isltIE9 || isIE9\">\n        <strong>{{\"common.OldIE\" | translate}}</strong>\n      </div>\n    </div>\n  </div>\n</form>\n";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.forms").directive("alkForgotPassword", alkForgotPassword);

  alkForgotPassword.$inject = [];

  function alkForgotPassword() {

    var directive = {
      template: __webpack_require__(376),
      restrict: "E",
      scope: {
        controllerName: "@"
      },
      //Use the passed-in controller-name attribute to create its controller
      controller: ["$controller", "$scope", function ($controller, $scope) {
        var c = $controller($scope.controllerName, { $scope: $scope });
        return c;
      }]
    };

    return directive;
  }
})();

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports = "<form name=\"forgotPasswordForm\" alk-disabled=\"isProcessing\" alk-submit=\"submitForgotPassword()\" novalidate role=\"form\">\n  <div class=\"row\">\n    <alk-messages></alk-messages>\n    <div class=\"form-group col-sm-12\" ng-class=\"{ 'has-error' : forgotPasswordForm.email.$invalid && forgotPasswordForm.submitted }\">\n      <input id=\"email\" name=\"email\" class=\"form-control input-sm\" type=\"text\" ng-model=\"email\" alk-autofocus alk-email placeholder=\"{{ 'views.forgotPassword.Email' | translate }}\"\n        required />\n      <div ng-show=\"forgotPasswordForm.submitted\">\n        <p ng-show=\"forgotPasswordForm.email.$error.alkEmail && !forgotPasswordForm.email.$error.required\" class=\"help-block\">{{\"validation.email\" | translate}}</p>\n        <p ng-show=\"forgotPasswordForm.email.$error.required\" class=\"help-block\">{{\"validation.required\" | translate}}</p>\n      </div>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12 text-right\">\n      <span><a ng-click=\"$parent.vm.formTab = 'login'\" class=\"btn btn-link btn-sm\">{{\"common.BackToLogin\" | translate}}</a></span>\n      <button type=\"submit\" class=\"btn btn-success btn-lg\"><i ng-show=\"isProcessing\" class=\"ico ico-circle-notch ico-spin ng-cloak\" ng-cloak></i> <span translate>{{(isProcessing)? 'common.Submitting': 'common.Go'}}</span> </button>\n    </div>\n  </div>\n</form>\n";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.forms").controller("ChangePasswordController", ChangePasswordController);

  ChangePasswordController.$inject = ["alkAuthenticationService", "Messages", "ALKChangePassword", "$translate", "$uibModalInstance"];

  function ChangePasswordController(alkAuthenticationService, Messages, ALKChangePassword, $translate, $uibModalInstance) {
    var vm = this;

    vm.isProcessing = false;
    vm.updateLogin = updateLogin;
    vm.messageToShow = "";
    vm.loginInfo = {};
    vm.cancel = cancel;

    ////////////////

    function cancel() {
      $uibModalInstance.close();
      Messages.clear();
    }

    function updateLogin() {
      vm.loginInformationForm.$setSubmitted(true);

      if (!vm.loginInformationForm.$valid) {
        return;
      }

      vm.loginInformationForm.$setPristine(false);

      vm.isProcessing = true;
      Messages.clear();

      var changePassword = new ALKChangePassword(vm.loginInfo.existingPassword, vm.loginInfo.newPassword);
      alkAuthenticationService.changePassword(changePassword).then(function () {
        vm.loginInfo = {};

        Messages.add("success", $translate.instant("common.password.changeSuccess"), {
          showOnNextPage: false
        });
      }, function (err) {
        var errData = err.data;
        var message = $translate.instant("common.password.changeUnknownError");
        if (errData.reason === 1) {
          message = $translate.instant("common.password.changeFailedToLogin");
        }

        Messages.add("danger", message, {
          showOnNextPage: false
        });
      }).finally(function () {
        vm.messageToShow = "password";
        vm.isProcessing = false;
      });
    }
  }
})();

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  "use strict";

  partnerAccountSelect.$inject = ["UserProvider"];
  angular.module("alk.forms").directive("partnerAccountSelect", partnerAccountSelect);

  partnerAccountSelect.inject = ["UserProvider"];

  function partnerAccountSelect(UserProvider) {

    function isRole(role) {
      var roles = UserProvider.getUser().roles;
      roles = _.map(roles, function (role) {
        return role.toLowerCase();
      });
      roles = _.uniq(roles);
      return roles.indexOf(role) !== -1;
    }

    function isSupportRole() {
      return isRole("support");
    }

    function isALKSupportRole() {
      return isRole("alk support");
    }

    var partnerAccountController = ["$http", "$window", "$scope", "$state", function ($http, $window, $scope, $state) {

      var vm = this;
      vm.partnerAccountChange = partnerAccountChange;

      init();

      function init() {
        var url = "";
        if (isALKSupportRole()) {
          url = config.ssoUrl + "v1/accounts/application?applicationName=" + PARTNER_APPLICATION_NAME;
        } else if (isSupportRole()) {
          url = config.fleetPortalUrl + "v1/account/partneraccounts?applicationName=" + PARTNER_APPLICATION_NAME;
        } else {
          return;
        }

        var request = {
          method: "GET",
          url: url,
          headers: {
            Authorization: "Bearer " + UserProvider.getUser().authToken,
            "ALK-Language": undefined
          }
        };

        $http(request).then(function (response) {
          vm.partnerAccounts = _.chain(response.data).map(function (acct) {
            // accounts that come from SSO have different attributes
            // than the accounts that come from fleetportal's partner account
            // api.
            if (acct.accountId === undefined) acct.accountId = acct.id;
            if (acct.accountName === undefined) acct.accountName = acct.name;
            return acct;
          }).sortBy("accountName").value();
          var user = UserProvider.getUser();
          var accountId = user.accountId;
          if (user.supportAccount) {
            accountId = user.supportAccount.accountId;
          }

          if (accountId) {
            vm.selectedPartnerAccount = _.find(vm.partnerAccounts, {
              "accountId": Number(accountId)
            });
          }
        });
      }

      function partnerAccountChange() {
        var request = {
          method: "POST",
          url: config.daUrl + ("owner/" + vm.selectedPartnerAccount.accountId + "?application=") + PARTNER_APPLICATION_NAME
        };

        $http(request).then(function (resp) {
          var currentUser = UserProvider.getUser();

          //  if we switch to the account we originally logged in as, just
          //  clear out any support account information.
          if (currentUser.accountId === vm.selectedPartnerAccount.accountId) {
            delete currentUser.supportOwnerId;
            delete currentUser.supportAccount;
          } else {
            currentUser.supportOwnerId = resp.data;
            currentUser.supportAccount = vm.selectedPartnerAccount;
          }
          $state.reload();
        });
      }
    }];

    var directive = {
      template: __webpack_require__(379),
      restrict: "A",
      scope: {
        //Should be the product name stored in the database.
        //i.e. "CloudXChange", "CoPilot FleetView"
        partnerAccountSelect: "@"
      },
      controller: partnerAccountController,
      controllerAs: "vm",
      link: function link(scope, element) {
        //Don't show this directive if not a support role. We must delete the whole element because the navbar will display a
        //divider line to the right otherwise.
        if (!isSupportRole() && !isALKSupportRole()) {
          element.remove();
        }
      }
    };

    return directive;
  }
})();

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "<span tabindex=\"-1\" class=\"partner-account-select-label\">{{ \"views.partnerAccountSelect.label\" | translate }} </span>\n<ui-select class=\"partner-account-select no-trans\" ng-model=\"vm.selectedPartnerAccount\" ng-change=\"vm.partnerAccountChange()\">\n  <ui-select-match>{{ $select.selected.accountName }}</ui-select-match>\n  <ui-select-choices repeat=\"partnerAccount in vm.partnerAccounts | filter: $select.search\">\n    <span ng-bind-html=\"partnerAccount.accountName | highlight: $select.search\"></span>\n  </ui-select-choices>\n</ui-select>\n";

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(381);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(11)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./partnerAccountSelectStyles.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./partnerAccountSelectStyles.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)();
// imports


// module
exports.push([module.i, ".partner-account-select-label {\n  font-size: 11px;\n  text-decoration: none;\n  color: #ddd;\n  cursor: pointer;\n  border-radius: 4px;\n  background: none;\n  border: 1px solid #3b3c3f;\n  font-weight: normal;\n}\n.partner-account-select {\n  width: 150px;\n}\n.partner-account-select .btn-default-focus {\n  box-shadow: none !important;\n  outline: 0;\n}\n.partner-account-select .form-control {\n  outline: 0;\n  box-shadow: none !important;\n  height: 25px;\n  width: 150px;\n  font-size: 9px;\n  text-shadow: none;\n  background: none;\n  border-color: #9f9f9f;\n  color: #DDD;\n}\n.partner-account-select .form-control:focus {\n  box-shadow: none;\n  background: none;\n}\n.partner-account-select .ui-select-match {\n  background: none;\n}\n.partner-account-select .ui-select-match-text > span {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 115px;\n}\n.partner-account-select .ui-select-choices {\n  font-size: 12px;\n}\n.partner-account-select .dropdown-menu {\n  min-width: 200px;\n}\n.partner-account-select .dropdown-menu .ui-select-choices-row-inner div {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  max-width: 180px;\n}\n", ""]);

// exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

    angular.module("app").controller("cancelAccountController", ["$uibModalInstance", "$http", "Messages", "message", function ($uibModalInstance, $http, Messages, message) {
        var vm = this;

        vm.message = message;
        vm.processing = false;

        vm.ok = function () {
            vm.processing = true;

            $http.post("/api/ManageAccount/CancelCustomer").success(function () {
                $uibModalInstance.close();
            }).error(function (err) {
                Messages.add("danger", "Error cancelling your account.", { showOnNextPage: false });
                $uibModalInstance.dismiss("cancel");
            });
        };

        vm.close = function () {
            $uibModalInstance.dismiss("cancel");
        };
    }]);
})(window.angular);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  var controllerId = "termsController";
  angular.module("app").controller(controllerId, ["$scope", "$location", "UserProvider", "alkAuthenticationService", function ($scope, $location, UserProvider, alkAuthenticationService) {
    //todo: take out dependency on $http, should have service for this stuff. probably userservice or some other service for user functions related to the account - get user, accept terms, change password, forgot password, etc.
    $scope.acceptTerms = function () {
      $scope.isProcessing = true;

      alkAuthenticationService.acceptTerms().then(function () {
        UserProvider.getUser().currentTermsOfUseAccepted = true;

        if ($location.search().path) {
          $location.url($location.search().path);
        } else {
          $location.url("/app");
        }
      }, function () {
        // only set the processing back to false in case of error.  In success we are switching pages which may take a second.  Don't want the user to think that the click didn't work.
        $scope.isProcessing = false;
      });
    };
  }]);
})(window.angular);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  pcmtidloginController.$inject = ["$rootScope", "$scope", "pcmtidLoginService", "$routeParams", "ALKLogin", "alkAuthenticationService", "UserProvider", "$location", "alkModalService"];
  angular.module("app").controller("pcmtidloginController", pcmtidloginController);
  pcmtidloginController.inject = ["$rootScope", "$scope", "pcmtidLoginService", "routeParams", "ALKLogin", "alkAuthenticationService", "UserProvider", "$location", "alkModalService"];
  function pcmtidloginController($rootScope, $scope, pcmtidLoginService, $routeParams, ALKLogin, alkAuthenticationService, UserProvider, $location, alkModalService) {

    var vm = this;
    vm.authCode = $routeParams.code;
    vm.state = $routeParams.state;
    vm.formTab = "login";
    vm.isProcessing = false;
    vm.showLegacySignIn = {};
    vm.showLegacySignIn.show = false;
    vm.clientId = pcmtidLoginService.getClientId();
    vm.tidApplicationName = pcmtidLoginService.getTidApplicationName();
    vm.trimbleCloudUrl = pcmtidLoginService.getTrimbleCloudUrl();
    var redirectUrl = pcmtidLoginService.baseUrl() + "/tid/redirect";

    vm.config = { migrationDate: "2022-09-07",
      countdownComponent: {
        useDarkText: false
      },
      migrateComponent: {
        useDarkSignInTidText: false,
        useOutlineSignInTidButton: false
      },
      eventHandler: function eventHandler(event) {
        console.log(event);
        var type = event.type;
        vm.username = event.username;
        vm.password = event.password;
        vm.account = event.account;
        $scope.userNotExistError = false;

        if (type === "SIGN_IN_CONFIRM_CANCEL") {
          vm.tidcontrol.stopSignInWaiting();
        }

        if (type === "SIGN_IN_USERNAME") {
          pcmtidLoginService.checkTidEmail(vm.username).then(function (data) {
            if (data.exists) {
              if (data.migrated) {
                var url = pcmtidLoginService.goToTidSignin(vm.username, redirectUrl);
                window.location.href = url;
              } else {
                vm.tidcontrol.showSignInConfirm();
              }
            } else {
              $scope.userNotExistError = true;
              vm.tidcontrol.stopSignInWaiting();
            }
          }, function (error) {
            console.log("migrate error");
          });
        }
        if (type === "SIGN_IN_PASSWORD") {

          var login = new ALKLogin(vm.username, vm.password, vm.account);
          vm.login(login);
        }
        if (type === "SIGN_IN_ACCOUNT") {
          if (vm.authCode) {
            vm.tidloginAccount(vm.authCode, vm.account);
          } else {
            login = new ALKLogin(vm.username, vm.password, vm.account);
            vm.login(login);
          }
        }

        if (type === "SIGN_IN_TID") {
          var url = pcmtidLoginService.goToTidSignin(vm.username, redirectUrl);
          window.location.href = url;
        }
        if (type === "CREATE_TID") {
          var createUrl = pcmtidLoginService.goToTidSignup(vm.username, redirectUrl);
          window.location.href = createUrl;
        }
      } };
    vm.loadTrimbleID = function () {
      tmxtidmodule.init(vm.config).destroy();
      vm.tidcontrol = tmxtidmodule.init(vm.config);
    };

    $rootScope.$on("forgotPassword", function (msg) {
      vm.formTab = "forgot";
    });

    vm.loadTrimbleID();

    vm.login = function (login) {
      alkAuthenticationService.login(login).then(function () {

        $scope.loginSuccess();

        $scope.checkAuth = true;
      }, function (error) {

        var failedLogin = vm.authenticateErrorHandler(error);

        if (failedLogin) {
          vm.tidcontrol.stopSignInWaiting();
          // $scope.accounts = [];
          // delete $scope.userInfo.account;
        }
        $scope.isProcessing = false;
      });
    };
    $scope.loginSuccess = function () {
      var user = UserProvider.getUser();
      try {
        trackJs.configure({
          userId: user.userName + " (#" + user.userId + "), Account " + user.account + " (#" + user.accountId + ")"
        });
      } catch (err) {
        console.log("trackJs configure error:", err);
      }

      var gotoPage = $location.search().path || "/app";
      var message;

      // if netSuite is down, temporarily allow user to login and disable billing related features.
      if (!user.netSuiteOnline) {
        $location.url(gotoPage);
      } else if (user.hasBillingIssue) {
        message = user.isAdmin() ? "There was an error to the credit card on file.  Go to Account Settings and update your card information to continue." : "There was an error to the credit card on file.  Please have your company’s administrator go to Account Settings to update your card information.";

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Issue",
          bodyText: message,
          okOnly: true,
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(function () {
          $location.url("/account");
        });
      } else if (typeof user.creditExpiresSoon === "function" && user.creditExpiresSoon() && user.isMonthlyPaidCustomer && !user.isInvoiced) {
        message = user.isAdmin() ? "The credit card linked to your account is set to expire on " + user.getCreditExpiresDate().format("MM/DD/YYYY") + ".  To avoid any disruption in service, please update your card information now." : "The credit card linked to your account is set to expire on " + user.getCreditExpiresDate().format("MM/DD/YYYY") + ".  To avoid any disruption in service, please have your company\u2019s administrator update the card information.";

        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Billing Warning",
          bodyText: message,
          okOnly: !user.isAdmin() || user.isMonthlyPaidCustomer && user.checkCreditExpiration(),
          closeButtonText: "Later",
          actionButtonText: user.isAdmin() ? "Update Now" : "OK"
        }).then(function () {
          if (user.isAdmin()) {
            $location.url("/account");
          } else {
            $location.url(gotoPage);
          }
        }).catch(function () {
          $location.url(gotoPage);
        });
      } else {
        $location.url(gotoPage);
      }
    };

    // eslint-disable-next-line complexity
    vm.authenticateErrorHandler = function (error) {
      var failedLogin = true;
      // if username/password was not correct.
      if (error.status !== null && error.status === "FailedToLogin") {
        $scope.showPasswordIncorrect = true;
        vm.tidcontrol.showSignInPassword();
        //  FIXME:
        //  handle this
      } else if (error.status === "FailedToLoginAccountDisabled" || error.status === "AccountDisabled") {
        $scope.showAccountDisabled = true;
      } else if (error.status === "FailedToLoginUserDisabled" || error.status === "UserDisabled") {
        $scope.showUserDisabled = true;
      } else if (error.status === "FailedToValidateTrimbleIdentityToken") {
        $scope.showValidateTrimbleDisabled = true;
      }
      // if username/password was correct but does not belong to any account.
      else if (error.status !== null && error.status === "FailedToLoginNotAuthorized") {
          $scope.showNoAccountForApplication = true;
          // if username/password was correct but has one or more accounts. Display the accounts and user can selecte one.
        } else if (error.status !== null && error.status === "FailedToLoginDueToMultipleAccounts" && error.accounts.length > 0) {
          $scope.accounts = error.accounts;
          var options = [];
          for (var i = 0; i < $scope.accounts.length; i++) {

            var option = { value: $scope.accounts[i].accountName, displayName: $scope.accounts[i].accountName };
            console.log(option);
            options.push(option);
          }

          vm.tidcontrol.showSignInAccounts(options);
          // $scope.userInfo.account = $scope.accounts[0].accountName;
          // loginForm.submitted = false;
          failedLogin = false;
          vm.hideErrorMessage();
        } else if (error.status !== null && error.status === "FailedToLoginAccountExpired") {
          // if the account expired, we need to get userInfo and redirect user to account page for upgrade.
          if (typeof error.userInfo !== 'undefined') {
            alkAuthenticationService.getUserInfo(error.userInfo.authToken, error.userInfo.username, error.userInfo.accountName).then(function (response) {
              UserProvider.loadUser(response.user);
              $scope.loginSuccess();
            }, function (err) {
              $scope.showLoginAccountExpired = true;
              console.log("rejected user info", err);
            });
          } else {
            $scope.showAccountDisabled = true;
          }
        } else {
          //Should handle generic errors, i.e. 500
          $scope.showGenericError = true;
          vm.tidcontrol.showSignInUsername();
        }
      return failedLogin;
    };

    vm.tidloginAccount = function (authCode, account) {
      pcmtidLoginService.tidlogin(authCode, account, redirectUrl).then(function () {

        $scope.loginSuccess();
        $scope.checkAuth = true;
      }, function (error) {

        var failedLogin = vm.authenticateErrorHandler(error);
        if (failedLogin) {
          vm.tidcontrol.setSignInValues();
          vm.tidcontrol.stopSignInWaiting();
          vm.tidcontrol.showSignInUsername();
          // $scope.accounts = [];
          // delete $scope.userInfo.account;
        } else {
          $scope.showAccountDisabled = false;
          $scope.showUserDisabled = false;
          $scope.showPasswordIncorrect = false;
          $scope.showNoAccountForApplication = false;
          $scope.showGenericError = false;
        }
        $scope.isProcessing = false;
      });
    };
    if (vm.authCode) {
      if (vm.tidcontrol) {

        vm.tidcontrol.setSignInValues(vm.state, null, null);
        vm.tidcontrol.startSignInWaiting();
        vm.tidloginAccount(vm.authCode, null, redirectUrl);
      } else {
        vm.loadTrimbleID();
        vm.tidloginAccount(vm.authCode, null, redirectUrl);
      }
    }
    vm.hideErrorMessage = function () {
      $scope.showAccountDisabled = false;
      $scope.showUserDisabled = false;
      $scope.showPasswordIncorrect = false;
      $scope.showNoAccountForApplication = false;
      $scope.showGenericError = false;
      // $scope.$apply();
    };
  }
})();

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("app").factory("pcmtidLoginService", ["$http", "$window", "UserProvider", "$q", "alk.authentication.config", "alkAuthenticationService", function ($http, $window, UserProvider, $q, config, alkAuthenticationService) {
    function tidlogin(authCode, account, redirectUrl) {
      var deferred = $q.defer();

      var loginRequest = {
        method: "POST",
        url: config.ssoUrl + "v1/trimbleid/authenticate",
        data: {
          authorizationCode: authCode,
          redirectUrl: redirectUrl,
          applicationName: config.applicationName,
          account: account,
          trimbleApplication: getTidApplicationName()
        },
        withCredentials: true
      };

      $http(loginRequest).then(function (res) {
        var data = res.data;

        if (data.userId && data.authToken) {
          window.localStorage.removeItem("logoutInProgress");
          $window.sessionStorage["trimbleIdToken"] = data.idToken;
          if (config.applicationUrl) {
            var authToken = data.authToken,
                username = data.username,
                accountName = data.accountName,
                forcePasswordReset = data.forcePasswordReset;

            alkAuthenticationService.getUserInfo(authToken, username, accountName, forcePasswordReset).then(function (userInfo) {
              UserProvider.loadUser(userInfo.user);

              deferred.resolve(userInfo.user);
            }, function (err) {
              console.log("rejected user info", err);
              deferred.reject(err);
            });
          } else {
            UserProvider.loadUser(data);
            deferred.resolve(data);
          }
        } else {
          deferred.reject(data);
        }
      }, function (err) {
        deferred.reject(err.data);
      });

      return deferred.promise;
    }
    function baseUrl() {
      return "" + (window.location.protocol + "//" + window.location.host);
    }
    function getClientId() {

      return config.clientId;
    }
    function getTidApplicationName() {

      return config.tidApplicationName;
    }
    function getTrimbleCloudUrl() {

      return config.trimbleCloudUrl;
    }
    function logOutOfTrimbleIdentity(token) {
      var redirectUrl = baseUrl() + "/tid/logout";
      var url = getTrimbleCloudUrl() + "oauth/logout?";
      url += "&id_token_hint=" + token;
      url += "&post_logout_redirect_uri=" + redirectUrl;
      window.location.href = url;
    }
    function checkTidEmail(username) {
      var deferred = $q.defer();

      var migrationRequest = {
        method: "POST",
        url: config.ssoUrl + "v1/trimbleid/migration-status",
        data: {
          "email": username
        }

      };

      $http(migrationRequest).then(function (res) {
        console.log(res.data);
        deferred.resolve(res.data);
      }, function (err) {
        deferred.reject(err.data);
      });
      return deferred.promise;
    }
    function goToTidSignin(user, redirectUrl, ssoUser) {

      var username = encodeURIComponent(user);
      var url = getTrimbleCloudUrl() + "oauth/authorize?response_type=code&scope=openid " + getTidApplicationName();
      url += "&client_id=" + getClientId();
      url += "&redirect_uri=" + redirectUrl + "&state=" + username + "&prompt=login&login_hint=" + username + "&ssoUser=" + ssoUser;
      return url;
    }
    function goToTidSignup(user, redirectUrl, ssoUser) {
      var username = encodeURIComponent(user);
      var url = getTrimbleCloudUrl() + "oauth/authorize?response_type=code&scope=openid " + getTidApplicationName();
      url += "&client_id=" + getClientId();
      url += "&redirect_uri=" + redirectUrl + "&state=" + username + "&prompt=create&login_hint=" + username + "&ssoUser=" + ssoUser;

      return url;
    }
    return {
      tidlogin: tidlogin,
      baseUrl: baseUrl,
      getClientId: getClientId,
      getTidApplicationName: getTidApplicationName,
      getTrimbleCloudUrl: getTrimbleCloudUrl,
      logOutOfTrimbleIdentity: logOutOfTrimbleIdentity,
      checkTidEmail: checkTidEmail,
      goToTidSignin: goToTidSignin,
      goToTidSignup: goToTidSignup
    };
  }]);
})(angular);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("app").controller("pcmlogoutController", ["$scope", "pcmtidLoginService", "$window", function ($scope, pcmtidLoginService, $window) {
    console.log("logout");

    $window.location.href = "";
  }]);
})(window.angular);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);
(function () {
  var controllerId = "pcmmodernController";

  angular.module("app").controller(controllerId, ["$http", "UserProvider", "eventTracker", function pcmmodernController($http, userProvider, eventTracker) {
    var vm = this;
    vm.pcmModernSite = config.pcmModernSite;
    $http.get('../../resources/deployments.json').then(function (response) {
      var deployments = response.data.deployments;
      var lastDeployment = deployments[deployments.length - 1];
      var currentTimestamp = Date.now();
      var inputTimestamp = new Date(lastDeployment.date).getTime();
      var timeDifference = void 0;
      if (inputTimestamp > currentTimestamp) {
        var _lastDeployment = deployments[deployments.length - 2];
        inputTimestamp = new Date(_lastDeployment.date).getTime();
      }
      timeDifference = currentTimestamp - inputTimestamp;
      var differeces = void 0;
      if (timeDifference < 60000) {
        // Less than a minute
        differeces = 'a few seconds ago';
      } else if (timeDifference < 3600000) {
        // Less than an hour
        var minutes = Math.floor(timeDifference / 60000);
        differeces = minutes + (minutes > 1 ? ' minutes ago' : ' minute ago');
      } else if (timeDifference < 86400000) {
        // Less than a day
        var hours = Math.floor(timeDifference / 3600000);
        differeces = hours + (hours > 1 ? ' hours ago' : ' hour ago');
      } else if (timeDifference < 2592000000) {
        // Less than a month (30 days)
        var days = Math.floor(timeDifference / 86400000);
        differeces = days + (days > 1 ? ' days ago' : ' day ago');
      } else {
        var months = Math.floor(timeDifference / 2592000000);
        console.log('moths==>', months);
        if (months < 12) {
          // Less than a year
          differeces = months + (months > 1 ? ' months ago' : ' month ago');
        } else if (months === 12) {
          // Equal to one year
          differeces = 'a year ago';
        } else {
          // More than one year
          differeces = 'a while ago';
        }
      }
      vm.lastDeploymentDate = differeces;
    });
    vm.newPCMWeb = function () {
      eventTracker.track("Modern Banner Link Click From Legacy");
      window.location.href = config.pcmModernSite + "?token=" + userProvider.getUser().authToken;
    };
  }]);
})();

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.cloud", ["alk.maps"]);

  angular.module("alk.cloud").directive("alkCloudMenu", alkCloudMenu);

  function alkCloudMenu() {

    var directive = {
      bindToController: true,
      controller: cloudMenuController,
      controllerAs: "vm",
      template: __webpack_require__(389),
      link: link,
      restrict: "E",
      scope: {
        onAppChange: "&",
        onLogOut: "&",
        hideChangePassword: "@"
      }
    };
    return directive;

    function link(scope, element, attrs) {}
  }

  cloudMenuController.$inject = ["$translate", "$http", "$window", "alkAuthenticationService", "alkModalService", "savedMapInfo", "UserProvider", "pcmtidLoginService"];

  function cloudMenuController($translate, $http, $window, alkAuthenticationService, alkModalService, savedMapInfo, UserProvider, pcmtidLoginService) {

    var vm = this;
    vm.webToolsImgSrc = "/img/webtools-icon.svg";

    // get licensed products from server
    alkAuthenticationService.getLicensedApps().then(function (data) {
      // "[Temporarily] remove RouteReporter and MapExact products for EU accounts in ALK Cloud menu" SWMI-1173
      if (UserProvider.getUser().region === "EU") {
        data.unlicensed = data.unlicensed.filter(function (app) {
          return app.productTitle !== "RouteReporter" && app.productTitle !== "MapExact";
        });
      }
      vm.alkCloudProducts = data;
    });

    vm.toggleUnlicensedProductInfo = toggleUnlicensedProductInfo;
    vm.goToInfoPage = goToInfoPage;
    vm.goToAppPage = goToAppPage;
    vm.logout = logout;
    vm.showChangePassword = showChangePassword;
    vm.isOpen = false;

    function toggleUnlicensedProductInfo(product) {
      product.showUnlicensedMessage = !product.showUnlicensedMessage;
    }

    function goToAppPage(product) {
      if ("PC*MILER Web UI" === product.productTitle) return;

      vm.onAppChange({ product: product });

      var url = product.productAppUrl;
      var centerParams = savedMapInfo.getSavedInfoAsUrl();
      var urlWithCenter = url + "?center=" + centerParams;
      vm.isOpen = false;
      $window.open(urlWithCenter, "_self");
    }

    function goToInfoPage(product) {
      vm.isOpen = false;
      $window.open(product.productInfoUrl, "_self");
    }

    function logout() {
      var checklogout = vm.onLogOut();
      if (checklogout) {
        alkAuthenticationService.logout().then(function () {
          var idToken = sessionStorage["trimbleIdToken"];
          if (idToken) {
            delete $window.sessionStorage["trimbleIdToken"];
            pcmtidLoginService.logOutOfTrimbleIdentity(idToken);
            // $location.url("/tid/logout");
          } else {
            $window.location.href = "";
          }
        });
      }
    }

    function showChangePassword() {
      vm.isOpen = false;
      alkModalService.show({
        size: "md",
        template: __webpack_require__(390),
        controller: "ChangePasswordController",
        controllerAs: "vm",
        backdrop: true
      });
    }
  }
})();

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "<ul>\n  <li class=\"large-btn cloud-button dropbown\" uib-dropdown auto-close=\"outsideClick\" is-open=\"vm.isOpen\">\n    <button id=\"locations-btn\" class=\"nav-button dropdown-toggle\" uib-dropdown-toggle alk-analytics=\"['ALK Apps']\">\n          <img ng-src=\"{{vm.webToolsImgSrc}}\" /> \n          <span translate=\"common.nav.webTools\"></span> <span class=\"caret\"></span>\n      </button>\n    <div class=\"dropdown-menu dropdown-menu-right popover cloud-panel\" uib-dropdown-menu role=\"menu\">\n      <h5 class=\"legend\">\n        <span translate=\"common.nav.LicensedApps\"></span>\n        <span ng-click=\"vm.isOpen = false\" class=\"cursor-pointer ico ico-times-circle pull-right\" style=\"top: -1px;font-size: 16px;\"></span>\n      </h5>\n      <ul class=\"list-group cloud-menu\">\n        <li class=\"cursor-pointer list-group-item cloud-menu-item\" ng-repeat=\"product in vm.alkCloudProducts.licensed\">\n          <a ng-click=\"vm.goToAppPage(product)\" target=\"_blank\">\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\n          </a>\n        </li>\n      </ul>\n      <h5 ng-if=\"vm.alkCloudProducts.unlicensed.length > 0\" class=\"legend\" translate=\"common.nav.UnlicensedApps\"></h5>\n      <ul ng-if=\"vm.alkCloudProducts.unlicensed.length > 0\" class=\"list-group cloud-menu\">\n        <li class=\"cursor-pointer list-group-item cloud-menu-item cursor-pointer\" ng-repeat=\"product in vm.alkCloudProducts.unlicensed\"\n          ng-click=\"vm.toggleUnlicensedProductInfo(product); $event.preventDefault(); $event.stopPropagation();\">\n          <div>\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\n          </div>\n          <div class=\"container-fluid\" ng-if=\"product.showUnlicensedMessage\">\n            <div class=\"row cloud-menu-unlicensed-alert\">\n              <span class=\"cloud-menu-unlicensed-label\" translate=\"common.nav.NotLicensed\"></span>\n              <a ng-click=\"vm.goToInfoPage(product)\" class=\"btn btn-default btn-xs pull-right cloud-menu-unlicensed-btn\" translate=\"common.nav.LearnMore\"></a>\n            </div>\n          </div>\n        </li>\n      </ul>\n      <h5 ng-if=\"vm.alkCloudProducts.expired.length > 0\" class=\"legend\" translate=\"common.nav.ExpiredApps\"></h5>\n      <ul ng-if=\"vm.alkCloudProducts.expired.length > 0\" class=\"list-group cloud-menu\">\n        <li class=\"cursor-pointer list-group-item cloud-menu-item cursor-pointer\" ng-repeat=\"product in vm.alkCloudProducts.expired\"\n          ng-click=\"vm.toggleUnlicensedProductInfo(product); $event.preventDefault(); $event.stopPropagation();\">\n          <div>\n            <img ng-src=\"{{product.productImgSrc}}\" alt=\"{{product.productTitle}}\" class=\"pull-left\">\n            <div class=\"cloud-menu-title\">{{product.productTitle}}</div>\n            <div class=\"cloud-menu-text\">{{product.productText}}</div>\n          </div>\n          <div class=\"container-fluid\" ng-if=\"product.showUnlicensedMessage\">\n            <div class=\"row cloud-menu-unlicensed-alert\">\n              <span class=\"cloud-menu-unlicensed-label\" translate=\"common.nav.NotLicensed\"></span>\n              <a ng-click=\"vm.goToInfoPage(product)\" class=\"btn btn-default btn-xs pull-right cloud-menu-unlicensed-btn\" translate=\"common.nav.LearnMore\"></a>\n            </div>\n          </div>\n        </li>\n      </ul>\n      <a class=\"btn btn-xs btn-default pull-right cloud-menu-btn cloud-menu-btn-last\" alk-analytics=\"['Logout']\" ng-click=\"vm.logout(); $event.preventDefault(); $event.stopPropagation();\"\n        translate=\"common.nav.Logout\"></a>\n     <a class=\"btn btn-xs btn-default pull-right cloud-menu-btn\" ng-show=\"vm.canShowChangePassword\"  ng-click=\"vm.showChangePassword()\" translate=\"common.password.change\"></a>\n    </div>\n  </li>\n</ul>\n\n";

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n  <h4 class=\"modal-title\" translate=\"common.password.change\"></h4>\n</div>\n<div class=\"modal-body\">\n  <alk-messages></alk-messages>\n  <form name=\"vm.loginInformationForm\" novalidate>\n    <div alk-disabled=\"vm.isProcessing\">\n      <div class=\"form-group sm row\">\n        <div class=\"col-md-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.currentPassword.$invalid && vm.loginInformationForm.$submitted}\">\n          <input id=\"currentPassword\" name=\"currentPassword\" class=\"form-control input-sm input-line\" required type=\"password\" ng-model=\"vm.loginInfo.existingPassword\"\n          />\n          <label for=\"currentPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Current Password\"></label>\n          <p ng-show=\"vm.loginInformationForm.currentPassword.$error.required && vm.loginInformationForm.$submitted\" class=\"help-block\"\n            translate=\"validation.required\"></p>\n        </div>\n        <div class=\"col-md-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.password.$invalid && vm.loginInformationForm.$submitted}\">\n          <input id=\"password\" name=\"password\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"vm.loginInfo.newPassword\"\n            required ng-minlength=\"8\" ng-maxlength=\"20\" />\n          <label for=\"password\" class=\"control-label label-sm label-line\" translate=\"views.user.New Password\"></label>\n          <p ng-show=\"vm.loginInformationForm.password.$error.required && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.required\"></p>\n          <p ng-show=\"vm.loginInformationForm.password.$error.maxlength && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.passwordMaximum\"></p>\n          <p ng-show=\"vm.loginInformationForm.password.$error.minlength && vm.loginInformationForm.$submitted\" class=\"help-block\" translate=\"validation.passwordMinimum\"></p>\n        </div>\n      </div>\n      <div class=\"form-group sm row\">\n        <div class=\"col-md-6 col-md-push-6\" ng-class=\"{ 'has-error' : vm.loginInformationForm.confirmPassword.$invalid && vm.loginInformationForm.$submitted}\">\n          <input id=\"confirmPassword\" name=\"confirmPassword\" class=\"form-control input-sm input-line\" type=\"password\" ng-model=\"vm.loginInfo.confirmPassword\"\n            alk-compare=\"vm.loginInfo.newPassword\" />\n          <label for=\"confirmPassword\" class=\"control-label label-sm label-line\" translate=\"views.user.Confirm Password\"></label>\n          <p ng-show=\"vm.loginInformationForm.confirmPassword.$error.alkCompare && vm.loginInformationForm.$submitted\" class=\"help-block\"\n            translate=\"validation.doesnt match\"></p>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-default btn-sm\" ng-click=\"vm.cancel()\" translate=\"common.Cancel\"></button>\n  <button class=\"btn btn-success btn-sm\" ng-click=\"vm.updateLogin()\" translate=\"common.password.update\"></button>\n</div>\n";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  angular.module("alk.routeExceptions", ["alk.linkMapping"]);
})(window.angular);

__webpack_require__(392);
__webpack_require__(196);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  angular.module("alk.linkMapping", []);
})(window.angular);

__webpack_require__(196);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  "use strict";

  angular.module("alk.routeExceptions").service("routeExceptionService", RouteExceptionService);

  RouteExceptionService.$inject = ["$http", "$q", "UserProvider", "alkLinkMappingService"];

  function RouteExceptionService($http, $q, UserProvider, alkLinkMappingService) {
    var CLOSURE_SET_NAME = "Closures";
    var CLOSURE_OLD_NAME = "Closure_Default_rc";

    return {
      //  route exception set API
      getRouteExceptionSets: getRouteExceptionSets,
      createNewRouteExceptionSet: createNewRouteExceptionSet,
      deleteRouteExceptionSet: deleteRouteExceptionSet,
      updateRouteExceptionSet: updateRouteExceptionSet,
      getRouteExceptionSetByID: getRouteExceptionSetByID,
      moveRouteExceptions: moveRouteExceptions,
      tryCreateClosureSet: tryCreateClosureSet,
      getClosureSet: getClosureSet,

      //  route exception group API
      getGroupsForSet: getGroupsForSet,
      deleteGroup: deleteGroup,
      deleteMultipleGroups: deleteMultipleGroups,
      updateGroup: updateGroup,
      addNewLinksToGroup: addNewLinksToGroup,
      moveGroup: moveGroup,
      moveMultipleGroups: moveMultipleGroups,
      createGroup: createGroup,

      deleteAvoidFavors: deleteAvoidFavors,

      //  individual route exception API
      deleteRouteException: deleteRouteException,
      deleteRouteExceptions: deleteRouteExceptions,
      getRouteException: getRouteException,

      //  route exception groups
      createNewRouteExceptionGroup: createNewRouteExceptionGroup,

      //  misc
      CLOSURE_SET_NAME: CLOSURE_SET_NAME,
      CLOSURE_OLD_NAME: CLOSURE_OLD_NAME,
      UNNAMED_EXCEPTION: "Unnamed",
      AVOID: 1,
      FAVOR: 2,
      CLOSURE: 3
    };

    ////////////////
    //  route exception set API

    function getRouteExceptionSetByID(setID) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return _getRouteExceptionSet(setID, detail, null).then(function (resp) {
        if (resp.errors.length > 0) {
          return resp;
        }

        resp.data = _.head(resp.data);
        return resp;
      });
    }

    function getRouteExceptionSets() {
      var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return _getRouteExceptionSet(-1, detail, filter);
    }

    function getClosureSet() {
      var params = {
        "detail": false,
        "name": CLOSURE_OLD_NAME
      };

      var request = {
        method: "GET",
        url: config.pcmwsUrl + "AvoidFavorSets/-1",
        params: params
      };

      return _submitRequest(request).then(function (resp) {
        if (resp.errors.length > 0) {
          return resp;
        }

        resp.data = _.head(resp.data);
        _.set(resp.data, "Name", CLOSURE_SET_NAME);
        return resp;
      });
    }

    //  setToCreate should be an object like
    //  {
    //    "Name:" xxx,
    //    "Tag":  xxx,
    //    "Links": [],
    //    "DataVersion": xxx,
    //    "SetType": 1 or 2
    //  }
    //  "SetType" = 1 is an AvoidFavor set.
    //  "SetType" = 2 is a Closure set.
    //  TODO:
    //  require set name,
    function createNewRouteExceptionSet(setToCreate) {
      var request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets",
        params: {
          name: setToCreate.Name,
          tag: setToCreate.Tag
        }
      };

      return _submitRequest(request);
    }

    function tryCreateClosureSet() {
      return createNewRouteExceptionSet({
        Name: CLOSURE_OLD_NAME
      });
    }

    function deleteRouteExceptionSet(setID) {
      var request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID
      };

      return _submitRequest(request);
    }

    function getRouteException(setID, exceptionID) {
      getRouteExceptionSetByID(setID).then(function (resp) {
        var exceptions = _.at(resp, ["data.Links"]);
        if (!exceptions) return null;

        return _.find(exceptions, {
          "AvoidFavorID": exceptionID
        });
      });
    }

    function updateRouteExceptionSet(setToUpdate) {
      var request = {
        method: "PUT",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setToUpdate.SetID,
        params: {
          name: setToUpdate.Name,
          tag: setToUpdate.Tag
        }
      };

      return _submitRequest(request);
    }

    function moveRouteExceptions(sourceSet, destinationSetId) {
      var request = {
        method: "PUT",
        url: config.pcmwsUrl + "AvoidFavorSets/" + sourceSet.SetID,
        params: {
          name: sourceSet.Name,
          tag: sourceSet.Tag,
          destinationSetId: destinationSetId
        }
      };

      return _submitRequest(request);
    }

    ////////////////
    //  route exception group API

    function getGroupsForSet(setID) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "GET",
        params: {
          detail: detail,
          filter: filter
        }
      };

      return _submitRequest(request);
    }

    function deleteGroup(setID, groupID) {
      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + groupID,
        method: "DELETE"
      };

      return _submitRequest(request);
    }

    function deleteMultipleGroups(setID) {
      var groupIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (groupIDs.length === 0) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "DELETE",
        data: _.map(groupIDs, function (i) {
          return parseInt(i);
        }),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      };

      return _submitRequest(request);
    }

    //  Group: {
    //    GroupName,
    //    GroupComments,
    //    AvoidFavorType
    //  }
    function updateGroup(setID, groupID, group) {
      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + groupID,
        method: "PUT",
        data: group
      };

      return _submitRequest(request);
    }

    function moveGroup(setID, destinationSetId, group) {
      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Group/" + group.GroupID,
        method: "PUT",
        params: {
          destinationSetId: destinationSetId
        },
        data: group
      };

      return _submitRequest(request);
    }

    function moveMultipleGroups(setID, destinationSetId, groups) {
      var firstGroup = _.head(groups);
      if (_.isUndefined(firstGroup)) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      return moveGroup(setID, destinationSetId, firstGroup).then(function (resp) {
        if (resp.errors.length > 0) {
          return resp;
        }

        return moveMultipleGroups(setID, destinationSetId, _.tail(groups));
      });
    }

    function addNewLinksToGroup(setID, groupID, groupType) {
      var gridAndLinks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      if (gridAndLinks.length === 0) {
        var defer = $q.defer();
        defer.resolve({
          errorCode: 0
        });

        return defer.promise;
      }

      var data = {
        "afGridLinks": []
      };

      //  for each gridAndLink (of the form GRID|LINK), we need to create an AFLink
      //  object that we can send to PCMWS.
      var afGridLinks = _.map(gridAndLinks, function (gl) {
        var gridLink = _.map(gl.split("|"), function (i) {
          return parseInt(i);
        });
        return {
          Type: groupType,
          Grid: gridLink[0],
          Link: gridLink[1],
          Comment: null
        };
      });

      data.afGridLinks = afGridLinks;

      var request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavorGridLink",
        params: {
          groupID: groupID
        },
        data: data
      };

      return _submitRequest(request);
    }

    function createGroup(setID, group) {
      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/Groups",
        method: "POST",
        data: group
      };

      return _submitRequest(request);
    }

    function deleteAvoidFavors(setID) {
      var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (ids.length === 0) {
        var deferred = $q.defer();
        deferred.resolve({
          errorCode: 0,
          data: null
        });
        return deferred.promise;
      }

      var request = {
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavors",
        method: "DELETE",
        data: _.map(ids, function (i) {
          return parseInt(i);
        }),
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        }
      };

      return _submitRequest(request);
    }

    ////////////////
    //  individual route exception set API

    function deleteRouteException(setID, routeExceptionID) {
      var request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavor/" + routeExceptionID
      };

      return _submitRequest(request);
    }

    function deleteRouteExceptions(setID, routeExceptionIDs) {
      var request = {
        method: "DELETE",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/avoid-favors?afIds=" + routeExceptionIDs.toString()
      };

      return _submitRequest(request);
    }

    function createNewRouteExceptionGroup(gridAndLinks, groupType, groupName, setID, dataset) {
      var data = {
        "afGridLinks": []
      };

      //  for each gridAndLink (of the form GRID|LINK), we need to create an AFLink
      //  object that we can send to PCMWS.
      var afGridLinks = _.map(gridAndLinks, function (gl) {
        var gridLink = _.map(gl.split("|"), function (i) {
          return parseInt(i);
        });
        return {
          Type: groupType,
          Grid: gridLink[0],
          Link: gridLink[1],
          Comment: groupName
        };
      });

      data.afGridLinks = afGridLinks;

      var request = {
        method: "POST",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID + "/AvoidFavorGridLink",
        params: {
          dataset: dataset,
          groupID: -1
        },
        data: data
      };

      return _submitRequest(request);
    }

    ////////////////
    //  internal helpers

    function _getRouteExceptionSet(setID) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var params = {
        // "onlyMine": false,
        "detail": detail,
        "plidOnly": false
      };

      if (!_.isNull(filter) && filter.trim() !== "") {
        params.name = filter;
        params.inexactNameMatch = true;
      }

      var request = {
        method: "GET",
        url: config.pcmwsUrl + "AvoidFavorSets/" + setID,
        params: params
      };

      var currentDataVersion = _.get(UserProvider.getUser(), "gridDataVersion");

      return alkLinkMappingService.dataVersionSupportsPLIDs(currentDataVersion).then(function (dataVersionSupportsPLIDs) {
        return _submitRequest(request).then(function (resp) {
          if (resp.errors.length > 0) {
            return resp;
          }

          //  rename the closure_default set at this point
          _.forEach(resp.data, function (set) {
            if (set.Name === CLOSURE_OLD_NAME) set.Name = CLOSURE_SET_NAME;
          });

          //  lock sets
          _.forEach(resp.data, function (set) {
            set.locked = _shouldSetBeLocked(set, dataVersionSupportsPLIDs);
          });

          return resp;
        });
      });

      // return _submitRequest(request)
      //   .then((resp) => {
      //     if (resp.errors.length > 0) {
      //       return resp;
      //     }

      //     //  rename the closure_default set at this point
      //     _.forEach(resp.data, (set) => {
      //       if (set.Name === CLOSURE_OLD_NAME)
      //         set.Name = CLOSURE_SET_NAME;
      //     });

      //     return resp;
      //   });
    }

    function _shouldSetBeLocked(set) {
      var dataVersionAllowsPLIDs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      //  in order to determine if a set should be locked:
      //  1. the set must have links
      //  2. there must be a link without PLIDs
      //  3. the current data version must have PLID support

      //  1.  check if we have links
      if (_.isNull(set.Links) || set.Links.length === 0) {
        return false;
      }

      //  2.  check if there is a link without PLID data
      var hasNonPLIDData = _.some(set.Links, function (link) {
        return _.isNull(link.PLIDs) || link.PLIDs.length === 0;
      });

      //  3.  check if current data version allows PLIDs
      return dataVersionAllowsPLIDs && hasNonPLIDData;
    }

    function _submitRequest(request) {
      var mapDataVersion = UserProvider.getUser().dataVersion || "Current";

      //  add a dataset parameter to our query params if it doesn't exist.
      _.set(request, ["params", "dataset"], mapDataVersion);

      return $http(request).then(function (response) {
        return {
          errors: [],
          data: response.data
        };
      }, function (response) {
        if (!response || !response.data) {
          return {
            errors: ["Something unexpected happened."],
            data: null
          };
        }

        return {
          errors: _.map(response.data, "Description"),
          data: null
        };
      });
    }
  }
})();

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.routeExceptions").service("routeExceptionsLayerFactory", routeExceptionsLayerFactory);

  routeExceptionsLayerFactory.$inject = ["mapService", "mapUtilities"];

  function routeExceptionsLayerFactory(mapService, mapUtilities) {
    return function (layer, featuresByAFIDCache, featuresByGroupIDCache) {
      return {
        clearAllRouteExceptions: function clearAllRouteExceptions() {
          return _clearAllRouteExceptions(layer, featuresByAFIDCache, featuresByGroupIDCache);
        },
        addRouteExceptionsToMap: _.curry(addRouteExceptionsToMap)(layer, featuresByAFIDCache, featuresByGroupIDCache),
        frameAllExceptions: function frameAllExceptions() {
          return _frameAllExceptions(layer);
        },
        frameRouteException: _.curry(frameRouteException)(featuresByAFIDCache, featuresByGroupIDCache),
        frameRouteExceptions: _.curry(frameRouteExceptions)(featuresByAFIDCache, featuresByGroupIDCache),
        flush: function flush() {
          return _flush(layer, featuresByAFIDCache, featuresByGroupIDCache);
        },
        numberOfFeatures: function numberOfFeatures() {
          return _numberOfFeatures(layer);
        },
        isAvoidFavorFeature: isAvoidFavorFeature
      };
    };

    ///////////////////

    function _flush(layer, featuresByAvoidFavorID, featuresByGroupID) {
      layer.removeAllFeatures();
      _.forOwn(featuresByAvoidFavorID, function (_, k) {
        return delete featuresByAvoidFavorID[k];
      });
      _.forOwn(featuresByGroupID, function (_, k) {
        return delete featuresByGroupID[k];
      });
    }

    function _numberOfFeatures(layer) {
      return layer.features.length;
    }

    function isAvoidFavorFeature(feature) {
      return !_.isUndefined(feature.attributes.isAvoidFavorFeature);
    }

    function addGroupedRouteExceptionsToMap(routeExceptionsLayer, featuresByGroupID, groupedExceptions, set) {
      var featuresWithGroupIDs = _.chain(groupedExceptions).filter(function (g) {
        return !featuresByGroupID.hasOwnProperty(g.GroupID);
      }).map(function (g) {
        var features = _.chain(g.GroupLinks).map(function (e) {
          return getFeatureVector(e.Geometries, g, e.AvoidFavorID, g.GroupID, set);
        }).value();
        return {
          id: g.GroupID,
          features: features
        };
      }).value();

      // for all of the new features that we're going to add,
      // cache them by the groupID
      _.forEach(featuresWithGroupIDs, function (o) {
        return featuresByGroupID[o.id] = o.features;
      });

      var featuresToAdd = _.chain(featuresWithGroupIDs).map(function (o) {
        return o.features;
      }).flatten().value();

      routeExceptionsLayer.addFeatures(featuresToAdd);
    }

    function addUngroupedRouteExceptionsToMap(routeExceptionsLayer, featuresByAvoidFavorID, ungroupedExceptions, set) {
      // convert each ungrouped route exception into an object
      // that contains its avoid favor id and a list of features.
      // we will cache each list of features by ID for this layer.
      var featuresWithIDs = _.chain(ungroupedExceptions).map(function (e) {
        var geometries = e.GroupLinks[0].Geometries;
        return {
          id: e.GroupLinks[0].AvoidFavorID,
          features: [getFeatureVector(geometries, e, e.GroupLinks[0].AvoidFavorID, null, set)]
        };
      }).filter(function (o) {
        return !featuresByAvoidFavorID.hasOwnProperty(o.id);
      }).value();

      // for all of the new features that we're going to add,
      // cache them.
      _.forEach(featuresWithIDs, function (o) {
        return featuresByAvoidFavorID[o.id] = o.features;
      });

      // convert each {id, features} object into a list of features,
      // and flatten.
      // too bad _.flatMap isn't available until lodash 4.0.0 :(
      var featuresToAdd = _.chain(featuresWithIDs).map(function (o) {
        return o.features;
      }).flatten().value();

      routeExceptionsLayer.addFeatures(featuresToAdd);
    }

    function addRouteExceptionsToMap(routeExceptionsLayer, featuresByAvoidFavorID, featuresByGroupID, routeExceptions, set) {
      var partitioned = _.partition(routeExceptions, "GroupID", null);
      var ungrouped = partitioned[0];
      var grouped = partitioned[1];

      addUngroupedRouteExceptionsToMap(routeExceptionsLayer, featuresByAvoidFavorID, ungrouped, set);
      addGroupedRouteExceptionsToMap(routeExceptionsLayer, featuresByGroupID, grouped, set);
    }

    function _clearAllRouteExceptions(routeExceptionsLayer, featuresByAvoidFavorID, featuresByGroupID) {
      routeExceptionsLayer.removeAllFeatures();
      _.forEach(_.keys(featuresByAvoidFavorID), function (k) {
        return delete featuresByAvoidFavorID[k];
      });
      _.forEach(_.keys(featuresByGroupID), function (k) {
        return delete featuresByGroupID[k];
      });
    }

    function getFeatureVector(geometryArray, exception, avoidFavorID, groupID, set) {
      //  convert the geometry array into ALKMaps.Geometry.Point objects

      var lineStrings = _.map(geometryArray, function (arr) {
        var pts = _.map(arr, function (geo) {
          var pt = mapUtilities.LLtoMerc(geo[0], geo[1]);
          return new ALKMaps.Geometry.Point(pt.lon, pt.lat);
        });
        return new ALKMaps.Geometry.LineString(pts);
      });

      var feature = new ALKMaps.Feature.Vector(new ALKMaps.Geometry.MultiLineString(lineStrings), {
        exception: exception,
        enabled: true,
        avoidFavorID: avoidFavorID,
        groupID: groupID,
        isAvoidFavorFeature: true,
        set: set
      });
      feature.attributes.trueStyle = feature.style;
      return feature;
    }

    function frameBounds(bounds) {
      if (!bounds) return;
      mapService.getMap().zoomToExtent(bounds);
    }

    function _frameAllExceptions(routeExceptionsLayer) {
      var bounds = routeExceptionsLayer.getDataExtent();
      frameBounds(bounds);
    }

    function frameRouteException(featuresByAvoidFavorID, featuresByGroupID, exception) {
      var bounds = _getBoundsForException(featuresByAvoidFavorID, featuresByGroupID, exception);
      frameBounds(bounds);
    }

    function frameRouteExceptions(featuresByAvoidFavorID, featuresByGroupID, exceptions) {
      var bounds = new ALKMaps.Bounds();
      _.forEach(exceptions, function (exception) {
        bounds.extend(_getBoundsForException(featuresByAvoidFavorID, featuresByGroupID, exception));
      });

      frameBounds(bounds);
    }

    function _getBoundsForException(featuresByAvoidFavorID, featuresByGroupID, exception) {
      var features = [];
      if (exception.GroupID === null) {
        features = featuresByAvoidFavorID[exception.GroupLinks[0].AvoidFavorID];
      } else {
        features = featuresByGroupID[exception.GroupID];
      }
      return _getFeatureBounds(features);
    }

    function _getFeatureBounds(features) {
      var bounds = new ALKMaps.Bounds();
      _.forEach(features, function (feature) {
        bounds.extend(feature.geometry.bounds);
      });

      return bounds;
    }
  }
})();

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.directives").directive("tidPassword", ["$compile", function ($compile) {
    return {
      restrict: "A",
      require: "ngModel",
      scope: {},
      link: function link(scope, element, attrs, ngModel) {

        ngModel.$validators.tidPassword = function (password) {
          if (!password) {
            return true;
          }
          var validationObj = {};
          validationObj.length = password.length >= 8 && password.length <= 20;
          validationObj.lowercase = /[a-z]/.test(password);
          validationObj.uppercase = /[A-Z]/.test(password);
          validationObj.number = /\d/.test(password);
          validationObj.specialCharacter = /[!@#$%&*^_\-+]/.test(password);
          validationObj.overall = Object.values(validationObj).every(function (isTrue) {
            return isTrue;
          });
          return validationObj.overall;
        };
        ngModel.$validators.hasLength = function (password) {
          if (!password) {
            return true;
          }
          var length = password.length >= 8 && password.length <= 20;
          return length;
        };
        ngModel.$validators.hasLowercase = function (password) {
          if (!password) {
            return true;
          }
          var lowercase = /[a-z]/.test(password);
          return lowercase;
        };
        ngModel.$validators.hasUppercase = function (password) {
          if (!password) {
            return true;
          }
          var uppercase = /[A-Z]/.test(password);
          return uppercase;
        };
        ngModel.$validators.hasNumber = function (password) {
          if (!password) {
            return true;
          }
          var number = /\d/.test(password);
          return number;
        };
        ngModel.$validators.hasCharacter = function (password) {
          if (!password) {
            return true;
          }
          var specialCharacter = /[!@#$%&*^_\-+]/.test(password);
          return specialCharacter;
        };
      }
    };
  }]);
})();

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// (function () {
//   angular
//     .module("app")
//     .directive("includeReplace", function () {
//       return {
//         require: "ngInclude",
//         restrict: "A",
//         link: function (scope, el, attrs) {
//           el.replaceWith(el.children());
//         }
//       };
//     });

// })();


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*global ALKMaps*/
var config = __webpack_require__(1);

(function () {
  var serviceId = "siteService";
  angular.module("alk.maps").factory(serviceId, ["$http", "$window", "$rootScope", "$q", "$compile", "$filter", "_", "mapService", "mapUtilities", "LocationItem", "customPlaceSetService", "favoriteLocationsService", function siteService($http, $window, $rootScope, $q, $compile, $filter, _, mapService, mapUtilities, LocationItem, customPlaceSetService, favoriteLocationsService) {

    /*
      Workflow:
      1
        1.1 When menu controller is initialized, it will call initializeSetLayers() function, which will creates one custom set layer for ALL custom sets save features in cachedFeatures.
        No features are added at this moment.
      2. When user enables/disables custom places, siteService will:
        2.1 set value for customPlacesEnabled
        2.2 show/hide custom place sites layer controlled in mapService
        2.3 call updateCustomSetLayer() once to update custom places layer for POIs.
      4. When user pans or zooms the map, menu controller will receive MapMove event and call siteService to updateCustomSetLayer. Only if customPlacesEnabled is true and zoom level
        is no smaller than 10, will it show POIs.
    */
    var placeSets = [];
    var setLayers = [];
    var customPlacesEnabled = false;
    var isCustomPlacesRetrieved = false;

    var baseLayerStyleMap = new ALKMaps.StyleMap({
      "default": new ALKMaps.Style({
        pointRadius: "${radius}",
        strokeColor: "#fff",
        fillColor: "${fill}",
        fontColor: "#fff",
        fontSize: "10px",
        label: "${label}"
      }, {
        context: {
          fill: function fill(feature) {
            return feature.cluster ? feature.cluster[0].attributes.setStyle.color : "#ccc";
          },
          label: function label(feature) {
            return feature.cluster ? feature.cluster.length : "";
          },
          radius: function radius(feature) {
            var r = 9;
            var order = Math.floor(Math.log(feature.cluster.length) / Math.LN10 + 0.000000001); // because float math sucks like that
            return r + order * 2; //make circle bigger for each order of magnitude
          }
        }
      })
    });

    // 1. Create set layer for each alk/custom place sets
    // 2. Add customPlaceSelectCtrl for all set layers
    // 3. Add hover, out and click event listeners for each set layer
    function initializeSetLayers() {
      var initializeSetLayer = function initializeSetLayer(sets, clusterConfig, isALKPlaceSet) {
        var layerName = isALKPlaceSet ? "ALKPlaceSetLayer" : "CustomPlaceSetLayer";
        var setLayer = new ALKMaps.Layer.VectorMarkers(layerName, {
          strategies: [new ALKMaps.Strategy.Cluster(clusterConfig)]
        }, {
          visibility: true
        });
        setLayer.styleMap = baseLayerStyleMap;
        mapService.getMapFromId().map.addLayers([setLayer]);
        setLayers[layerName] = setLayer;

        //Add the places
        addPlaceSetsToLayer(sets, isALKPlaceSet, layerName);
      };

      placeSets = _.values(favoriteLocationsService.getAsSets());

      // favoriteLocationsService.getAsSets() can return a set as undefined if the account
      // or user has not saved a shared or private favorite location to create the account
      // or user level favorite set
      placeSets = placeSets.forEach(function (set) {
        set = typeof set === "undefined" ? [] : set;
      });

      initializeSetLayer(placeSets, {
        distance: 12,
        threshold: 2,
        maxZoomLevel: 15,
        autoActivate: true
      }, false);

      var allSetLayers = getALLSetLayersFromMap();

      mapService.resetFeatureEventControl();

      for (var i = 0; i < allSetLayers.length; i++) {
        createFeatureHoverSelect(allSetLayers[i]);
      }
    }

    var getPinStyle = function getPinStyle(style, isALKPlaceSet) {
      style = style || "{}";
      style = JSON.parse(style);
      if (!style.Icon) {
        style.Icon = "other";
      }
      var graphicUrl = void 0,
          size = void 0;
      if (isALKPlaceSet) {
        graphicUrl = "/img/poi-icons/alk_poi_" + style.Icon + ".png";
        size = 25;
      } else {
        graphicUrl = "/img/poi-icons/poi_" + style.Icon + ".png";
        size = 20;
      }
      var baseStyle = {
        externalGraphic: graphicUrl,
        graphicHeight: size,
        graphicWidth: size
      };
      return baseStyle;
    };

    function addPlaceSetsToLayer(sets, isALKPlaceSet, layerName) {
      var pins = [];

      _.forEach(sets, function (set) {
        var setStyle = JSON.parse(set.Style || "{}");
        // parse places to features and save to cachedFeatures
        _.forEach(set.Places, function (place) {
          var ll = {
            lon: place.Coords.Lon,
            lat: place.Coords.Lat
          };
          var lonLat = mapUtilities.LLtoMerc(ll.lon, ll.lat);
          // create pin
          var geometry = new ALKMaps.Geometry.Point(ll.lon, ll.lat);
          geometry.transform(new ALKMaps.Projection("EPSG:4326"), mapService.getMap().getProjectionObject()); //transform to mercator
          var style = getPinStyle(set.Style, isALKPlaceSet);
          var pin = new ALKMaps.Feature.Vector(geometry, {}, style);
          pin.setId = set.Id;
          // pchen: customPlaceSetService returns a bunch of LocationItems instead of DAPlaces
          pin.place = place.ALKObj;
          pin.lonlat = lonLat;

          pin.attributes.draggable = false;
          pin.attributes.setStyle = setStyle;
          pins.push(pin);
        });
      });

      var layer = mapService.getLayersFromMap({
        name: layerName
      });
      //This stores all the features. Use this, not layer.features, because layer.features only stores features currently in viewport
      layer[0].cachedFeatures = layer[0].cachedFeatures ? layer[0].cachedFeatures.concat(pins) : pins;
    }

    function isCustomPlacesEnabled() {
      return customPlacesEnabled;
    }

    function enableCustomPlaces() {
      customPlacesEnabled = true;
      if (!isCustomPlacesRetrieved) {
        customPlaceSetService.getCustomPlaceSets().then(function (customPlaceSets) {
          placeSets = customPlaceSets;
          addPlaceSetsToLayer(customPlaceSets, false, "CustomPlaceSetLayer");
          mapService.showCustomSitesLayer();
          updateCustomSetLayer();
          isCustomPlacesRetrieved = true;
        });
      } else {
        mapService.showCustomSitesLayer();
        updateCustomSetLayer();
      }
    }

    function disableCustomPlaces() {
      customPlacesEnabled = false;
      mapService.hideCustomSitesLayer();
      updateCustomSetLayer();
    }

    function reDrawPlaces(layer) {
      var mapBounds = mapService.getMapFromId().map.calculateBounds();
      if (layer) {
        layer.removeAllFeatures();
        addFeaturesToLayer(layer);
        layer.redraw();
      }
    }

    function updateCustomSetLayer() {
      var layers = getCustomSetLayerFromMap();
      if (isCustomPlacesEnabled() && mapService.currentZoom() >= 10) {
        for (var i = 0; i < layers.length; i++) {
          if (layers[i] && (!layers[i].features || layers[i].features.length === 0)) {
            layers[i].strategies[0].activate();
          }
          reDrawPlaces(layers[i]);
        }
      } else {
        for (var _i = 0; _i < layers.length; _i++) {
          if (layers[_i] && layers[_i].features && layers[_i].features.length > 0) {
            layers[_i].strategies[0].deactivate();
            layers[_i].removeAllFeatures();
          }
        }
      }
    }

    /////////////////////////////////////////////////////////////////
    // Internal helper function
    /////////////////////////////////////////////////////////////////
    function createFeatureHoverSelect(setLayer) {

      var getPlaceFromFeature = function getPlaceFromFeature(feature) {
        if (!feature) {
          return null;
        }
        if (feature.place) {
          return feature.place;
        }
        return null;
      };

      setLayer.events.register("featureclicked", this, function (featureEvent) {
        var feature = featureEvent.feature;
        var location = getPlaceFromFeature(feature);
        if (location) {
          // remove pop up first
          if (location.CityStateZip === null || location.CityStateZip === undefined) {
            if (location.PlaceName !== null && location.PlaceName !== undefined) {
              location = new LocationItem(location, location.PlaceName);
            } else {
              location = new LocationItem(location);
            }
          }
          $rootScope.$broadcast("MapPlaceClick", location);
        }
      });

      //When hovering over a place POI
      setLayer.events.register("overFeature", this, function (featureEvent) {
        var feature = featureEvent.feature;
        var location = getPlaceFromFeature(feature);
        if (location) {
          $rootScope.$broadcast("MapPlaceHover", location);
        }
      });

      setLayer.events.register("outFeature", this, function (featureEvent) {
        $rootScope.$broadcast("MapPlaceHoverOut");
      });
    }

    function addFeaturesToLayer(layer) {
      var featuresToAdd = [];
      var mapBounds = mapService.getMapFromId().map.calculateBounds();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = layer.cachedFeatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var feature = _step.value;

          if (!mapBounds) {
            //Only happens in tests
            featuresToAdd.push(feature);
          } else if (feature.lonlat && mapBounds.containsLonLat(feature.lonlat)) {
            featuresToAdd.push(feature);
          }
        }
        //console.log("Re-adding " + featuresToAdd.length + " features");
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      layer.addFeatures(featuresToAdd);
    }

    function getALLSetLayersFromMap() {
      return mapService.getLayersFromMap(function (s) {
        return s.name.indexOf("PlaceSetLayer") > -1;
      });
    }

    function getALKSetLayerFromMap() {
      return mapService.getLayersFromMap(function (s) {
        return s.name.indexOf("ALKPlaceSetLayer") > -1;
      });
    }

    function getCustomSetLayerFromMap() {
      return mapService.getLayersFromMap(function (s) {
        return s.name.indexOf("CustomPlaceSetLayer") > -1;
      });
    }

    /////////////////////////////////////////////////////////////////
    // Define the functions and properties to reveal
    /////////////////////////////////////////////////////////////////
    var service = {
      initializeSetLayers: initializeSetLayers,
      isCustomPlacesEnabled: isCustomPlacesEnabled,
      enableCustomPlaces: enableCustomPlaces,
      disableCustomPlaces: disableCustomPlaces,
      updateCustomSetLayer: updateCustomSetLayer
    };

    return service;
  }]);
})();

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "mapController";
  angular.module("app").controller(controllerId, ["$scope", "$rootScope", "$timeout", "mapService", function mapController($scope, $rootScope, $timeout, mapService) {
    $scope.mapId = "pcmMap";
    $scope.locationText = "";

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
    $scope.$on("MapMove", function (event, message) {
      // jshint ignore:line
      mapService.getLocationString($scope.mapId).then(function (locationText) {
        $scope.locationText = locationText;
      }).catch(function () {
        $scope.locationText = "Location unknown";
      });
    });
  }]);
})();

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.maps").directive("mapStyles", mapStyles);

  function mapStyles() {

    var directive = {
      bindToController: true,
      controller: mapSylesController,
      controllerAs: "vm",
      template: __webpack_require__(400),
      restrict: "E",
      scope: {}
    };
    return directive;
  }

  mapSylesController.$inject = ["$scope", "$element", "$attrs", "$translate", "mapService"];

  function mapSylesController($scope, $element, $attrs, $translate, mapService) {

    var vm = this;

    var mapStyles = [{
      name: "Road Map",
      style: "transportation",
      img: __webpack_require__(401)
    }, {
      name: "Satellite Map",
      style: "satellite",
      img: __webpack_require__(402)
    }, {
      name: "Satellite Only",
      style: "satellite_only",
      img: __webpack_require__(403)
    }, {
      name: "Terrain Map",
      style: "terrain",
      img: __webpack_require__(404)
    }, {
      name: "Light Data Map",
      style: "datalight",
      img: __webpack_require__(405)
    }, {
      name: "Dark Data Map",
      style: "datadark",
      img: __webpack_require__(406)
      // {
      //   name: "Trimble Map",
      //   style: "classic",
      //   img: require("../../../Common Style Files/img/mapstyle-default.svg")
      // },
    }];

    function filterStyles() {
      if ($attrs && $attrs.exclude) {
        var exList = $attrs.exclude.split(",");
        var exStyles = _.filter(mapStyles, function (s) {
          var isExcluded = exList.indexOf(s.style) === -1;
          return isExcluded;
        });
        return exStyles;
      } else {
        return mapStyles;
      }
    }

    vm.includedMapStyles = filterStyles();

    vm.changeMapStyle = mapService.setStyle;

    vm.isStyle = function (style) {
      return style === mapService.getStyle();
    };

    vm.currentMapStyle = function () {
      var currentStyle = mapService.getStyle();
      return _.find(mapStyles, function (s) {
        return s.style === currentStyle;
      });
    };
  }
})();

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = "<ul>\n    <li class=\"large-btn btn-group dropdown\" uib-dropdown>\n      <button class=\"dropdown-toggle\" uib-dropdown-toggle id=\"map-style-btn\">\n        <img class=\"square\" src=\"{{vm.currentMapStyle().img}}\" />\n        <span translate=\"common.nav.MapStyle\"></span>\n      <br />\n      <span class=\"caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu\" role=\"menu\">\n        <li role=\"menuitem\" ng-repeat=\"style in vm.includedMapStyles\" ng-click=\"vm.changeMapStyle(style.style)\" ng-class=\"{'active': vm.isStyle(style.style)}\">\n          <a href=\"#\"><img class=\"square small-inline\" ng-src=\"{{style.img}}\" /> {{style.name}}</a></li>\n      </ul>\n    </li>\n  </ul>\n";

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3fc5d40ee783e976f4c8d9698d3f36ba.svg";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49986d5a6342c5e79c314a0a27224649.svg";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2f9660a9a75a5a87a5154b12e87f6710.svg";

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {
  "use strict";

  angular.module("alk.directives").directive("mapsLocation", [function () {
    return {
      restrict: "A",
      replace: false,
      template: "{{vm.location}}",
      scope: {
        mapRegion: "=",
        mapDataset: "=",
        mapObj: "="
      },
      controllerAs: "vm",
      controller: ["$scope", "$timeout", "_", "alkGeocodeService", "STATES", function ($scope, $timeout, _, alkGeocodeService, STATES) {
        var vm = this;
        var map = $scope.mapObj;

        function displayLocation(region, zoom, r) {

          var address = r[0].Address;

          var strCity = address.City + " > ";
          var strCounty = "";

          if (region === "NA") {
            strCounty = address.County ? address.County + " County > " : "";
          } else {
            strCounty = address.County ? address.County + " > " : "";
          }

          var strState = "";
          var strCountry = "";

          if (region === "NA") {
            // North american states will be in the STATES array so we can get the country, state from their
            var stObj = _.find(STATES, {
              abbreviation: address.State
            });

            if (stObj) {
              strState = stObj.name + " > ";
              strCountry = stObj.country;
            }
          } else {
            // Other regions just use the country. todo: make logic more clear and document logic for what should be displayed for different regions
            strCountry = address.Country;
          }

          switch (true) {
            case zoom >= 13:
              vm.location = strCity + strCounty + strState + strCountry;
              break;
            case zoom >= 10:
              vm.location = strCounty + strState + strCountry;
              break;
            case zoom >= 7:
              vm.location = strState + strCountry;
              break;
            case zoom < 7:
              vm.location = strCountry;
          }
        }

        function displayError(err) {
          vm.location = "Location unknown";
        }

        function getUpdatedLocation() {
          if (map) {
            var zoom = map.getZoom();

            var center = map.getCenter().transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));

            alkGeocodeService.reverseGeocode(center, {
              region: $scope.mapRegion,
              dataset: $scope.mapDataset
            }).then(function (r) {
              return displayLocation($scope.mapRegion, zoom, r);
            }, displayError);
          } else {
            displayError();
          }
        }

        function onMoveEnd() {
          $timeout(function () {
            getUpdatedLocation();
          });
        }

        map.events.register("moveend", {}, onMoveEnd);

        // get the intial location of the map
        getUpdatedLocation();
      }]
    };
  }]);

  angular.module("alk.directives").directive("mapsMousePosition", [function () {

    return {
      restrict: "A",
      replace: true,
      template: "<div id=\"mouse-position\"></div",
      scope: {
        mapObj: "="
      },
      controller: ["$scope", "ALKMaps", function ($scope, ALKMaps) {
        var vm = this;
        var map = $scope.mapObj;

        var mousePos = new ALKMaps.Control.MousePosition({
          prefix: "Lon: ", //Optional setting for the text displayed before the longitude value.
          separator: " Lat: ", //Optional setting for text displayed before the latitude value.
          numDigits: 6, //Optional setting for the number of digits to be displayed after the decimal point.
          div: ALKMaps.Util.getElement("mouse-position")
        });

        map.addControl(mousePos);
      }]
    };
  }]);
})(window.angular);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A common footer that is used by Angular 1.x apps with a map (for logged-in pages).
 * Currently used by Mapsure, MapExact, Content Tools, FleetView, and PCM Web UI.
 */

(function () {
  "use strict";

  angular.module("alk.maps").directive("mapFooter", mapFooter);

  mapFooter.$inject = [];

  function mapFooter() {

    var directive = {
      template: __webpack_require__(409),
      controllerAs: "vm",
      controller: ["$scope", "$injector", "$rootScope", function ($scope, $injector, $rootScope) {
        var vm = this;
        vm.app = $scope.app;
        var UserProvider = $injector.get("UserProvider");
        vm.userInfo = UserProvider.getUser();

        vm.isProd = "alkqaaws" === "production";
        if (vm.userInfo.roles) {
          vm.isAdminOrSupport = vm.userInfo.roles.indexOf("ALK Administrator") !== -1 || vm.userInfo.roles.indexOf("ALK Support") !== -1;
        }
        vm.userRoles = _.uniq(vm.userInfo.roles).toString();
        //If not showing the map, only need the copyright and TOS links
        if ($scope.mapShown !== "true") {
          return;
        }

        var mapService = $injector.get("mapService");

        //A bit hacky since the map services differ across apps, should refactor all apps to use same mapService eventually.
        if (vm.app === "PCMWebUI") {
          vm.mapObj = mapService.getMapFromId("pcmMap").map;
        } else {
          vm.mapObj = mapService.getMap();
        }

        $rootScope.$on("RegionUpdated", function () {
          vm.userInfo = UserProvider.getUser();
        });
      }],
      scope: {
        app: "@",
        mapShown: "@"
      }
    };

    return directive;
  }
})();

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = "<div id=\"footer\">\n  <div class=\"pull-left\">\n    <div class=\"legal-text\">\n      <span ng-if=\"vm.app !== 'PCMWebUI'\">\n        <copyright-text></copyright-text> | <a href=\"/terms\" translate=\"views.nav.TOS\"></a> |\n        <a href=\"https://www.alk.com/support\" target=\"_blank\"translate=\"views.nav.ContactSupport\"></a>\n      </span>\n      <span ng-if=\"vm.app === 'PCMWebUI'\">\n        <copyright-text type=\"WebUI\"></copyright-text> |\n        <a href=\"/terms\" translate=\"views.nav.TOS\"></a> |\n        <a href=\"http://support.pcmilerweb.com\" target=\"_blank\"translate=\"views.nav.ContactSupport\"></a>\n        </span>\n      </span>\n    </div>\n  </div>\n  <div >\n    <div ng-if=\"vm.mapObj && vm.userInfo.gridDataVersion\" id=\"grid-data-version\" class=\"pull-right\">{{vm.userInfo.gridDataVersion}}</div>\n    <div id=\"locator-panel\" class=\"pull-right\" ng-if=\"vm.mapObj\">\n      <p>\n        <span id=\"locator-output\" class=\"ng-cloak\" ng-cloak maps-location map-obj=\"vm.mapObj\" map-dataset=\"(vm.userInfo.accountType === 'PCMWeb')? vm.userInfo.dataset : vm.userInfo.dataVersion\"\n          map-region=\"vm.userInfo.region\"></span>\n      </p>\n    </div>\n    <div maps-mouse-position map-obj=\"vm.mapObj\" class=\"pull-right\" ng-if=\"vm.mapObj\"></div>\n    <div id=\"user-info\" class=\"pull-right\" ng-if=\"vm.userInfo.userName\">{{vm.userInfo.userName}} ({{ vm.userRoles }}), {{vm.userInfo.account ? vm.userInfo.account : \"\"}}\n    </div>\n  </ng-if>\n</div>\n";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "supportMenuController";
  angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$location", "routeService", "mapService", "eventTracker", function menuController($rootScope, $scope, $location, routeService, mapService, eventTracker) {
    $scope.currentPath = $location.path();
    $scope.home = function () {
      $location.url("/app");
    };
    $scope.onLogOut = function () {
      var checkRoutes = routeService.checkUnsavedRoutes();
      if (checkRoutes) {
        mapService.clearSavedCenterZoom();
        routeService.deleteAllRoutes();
        eventTracker.track(eventTracker.EVENTS.LOGOUT);
      }
      return checkRoutes;
    };
    $scope.goToAccount = function () {
      eventTracker.track("Clicks My Account");
      $location.url("/account");
    };
  }]);
})();

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("alk.marketing", []);
})(window.angular);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  landingController.$inject = ["$rootScope", "$scope", "$http", "Messages", "$injector"];
  angular.module("alk.marketing").controller("landingController", landingController);

  landingController.inject = ["$rootScope", "$scope", "$http", "Messages", "$injector"];
  function landingController($rootScope, $scope, $http, Messages, $injector) {

    var vm = this;
    vm.formTab = "login";
    vm.isProcessing = false;

    $rootScope.$on("forgotPassword", function (msg) {
      vm.formTab = "forgot";
    });

    $scope.$watch("vm.formTab", function (newValue, oldValue) {
      if (newValue !== oldValue) {
        Messages.clear();
      }
    });
  }
})();

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {

  angular.module("alk.marketing").directive("marketingFooter", marketingFooter);

  //marketingFooter.inject = [];
  function marketingFooter() {
    var directive = {
      template: __webpack_require__(414),
      link: link,
      restrict: "E",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {
      scope.year = new Date().getFullYear();
    }
  }
})();

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "<footer>\n  <style>\n  .pb-5{padding-bottom: 3rem!important;}\n  .pt-5{padding-top: 2rem!important;}\n  .py-3{padding-top: 1rem!important;padding-bottom: 1rem!important;}\n  .py-5{padding-top: 3rem!important;padding-bottom: 3rem!important;}\n  .footer-trimble-maps{background-color: #262533;color: #7b7a86!important;}\n  .footer-trimble-maps a{color: #7b7a86;}\n  .footer-trimble-maps a:hover{text-decoration: none;color: #fff;}\n  .footer-trimble-corp{background-color: #00437b;color:#fff}\n  .rounded-pill {border-radius: 50px!important;}\n  .btn-outline {background: transparent;border: 1px solid;}\n  .footer-trimble-maps a svg {fill:#fff;opacity:.7}\n  .footer-trimble-maps a svg:hover {opacity:.9}\n  .text-white{color:#fff!important}\n  .border{border:1px #7b7a86 solid !important;}\n  .pcmiler-asterisk{line-height: 50%;vertical-align: middle}\n  .text-warning{color:#ffc107!important}\n  </style>\n  <div class=\"container-fluid py-5 footer-trimble-maps\">\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-xs-12 text-white mx-auto text-center pb-5 pt-5\">\n          <img src=\"https://maps.trimble.com/img/footer/footer-trimble-maps.svg\" alt=\"Routing &amp; Scheduling - Visualization - Navigation\"\n            class=\"img-responsive mx-auto text-center center-block\" width=\"850\" height=\"29\" />\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-12 col-md-6\">\n          <p>\n            <a href=\"https://maps.trimble.com\" class=\"text-warning\">Trimble MAPS</a>\n            is dedicated to transforming journeys through innovative routing,\n            scheduling, visualization and navigation solutions. Rooted by map\n            data and map-centric technology specifically designed for commercial\n            vehicles, its development platform and trusted products are made for\n            a broad range of industries, workforces and fleets of all sizes.\n          </p>\n          <a href=\"https://www.trimble.com\"\n            class=\"btn btn-outline btn-rounded border text-light rounded-pill text-uppercase\">\n            More about Trimble\n          </a>\n        </div>\n        <div class=\"col-sm-6 col-md-2\">\n          <ul class=\"list-unstyled notranslate\">\n            <li>\n              <a href=\"https://maps.trimble.com/solutions/#appian\" target=\"_blank\" rel=\"noopener\">Appian</a>\n            </li>\n            <li>\n              <a href=\"https://copilotgps.com/\" target=\"_blank\" rel=\"noopener\">CoPilot GPS</a>\n            </li>\n            <li>\n              <a href=\"https://copilotpro.com/\" target=\"_blank\" rel=\"noopener\">CoPilot Professional</a>\n            </li>\n            <li>\n              <a href=\"https://copilottruck.com/\" target=\"_blank\" rel=\"noopener\">CoPilot Truck</a>\n            </li>\n            <li>\n              <a href=\"https://mileonapp.com/\" target=\"_blank\" rel=\"noopener\">MileOn by PC<span\n                  class=\"pcmiler-asterisk\">*</span>MILER</a>\n            </li>\n            <li>\n              <a href=\"https://www.pcmiler.com/\" target=\"_blank\" rel=\"noopener\">PC<span\n                  class=\"pcmiler-asterisk\">*</span>MILER</a>\n            </li>\n            <li>\n              <a href=\"https://developer.trimblemaps.com\" target=\"_blank\" rel=\"noopener\">Development Platform</a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"col-sm-6 col-md-2\">\n          <ul class=\"list-unstyled\">\n            <li>\n              <a href=\"https://maps.trimble.com/legal/\" target=\"_blank\" rel=\"noopener\">Legal</a>\n            </li>\n            <li>\n              <a href=\"https://maps.trimble.com/privacy/\" target=\"_blank\" rel=\"noopener\">Privacy</a>\n            </li>\n            <li>\n              <a href=\"https://maps.trimble.com/cookies/\" target=\"_blank\" rel=\"noopener\">Cookies</a>\n            </li>\n            <li>\n              <a href=\"https://maps.trimble.com/contact/\" target=\"_blank\" rel=\"noopener\">Contact</a>\n            </li>\n          </ul>\n        </div>\n        <div class=\"col-sm-6 col-md-2\">\n          <a href=\"https://www.linkedin.com/company/trimblemaps\" target=\"_blank\" rel=\"noopener\">\n            <svg width=\"36\" height=\"36\" aria-hidden=\"true\" data-icon=\"linkedin\"\n              class=\"svg-inline--fa fa-linkedin fa-w-14\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\"\n              viewBox=\"0 0 448 512\">\n              <path\n                d=\"M416 32H31.9C14.3 32 0 46.5.0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6.0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3.0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2.0 38.5 17.3 38.5 38.5.0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6.0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2.0 79.7 44.3 79.7 101.9V416z\">\n              </path>\n            </svg>\n          </a>\n          <a href=\"https://twitter.com/trimblemaps\" target=\"_blank\" rel=\"noopener\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" viewBox=\"0 0 448 512\">\n              <path\n                d=\"M4e2 32H48C21.5 32 0 53.5.0 80v352c0 26.5 21.5 48 48 48h352c26.5.0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5.0 86.7-66 186.6-186.6 186.6-37.2.0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7.0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447.0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9.0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z\">\n              </path>\n            </svg>\n          </a>\n          <a href=\"https://vimeo.com/trimblemaps\" target=\"_blank\" rel=\"noopener\">\n            <svg width=\"36\" height=\"36\" aria-hidden=\"true\" data-icon=\"vimeo\" class=\"svg-inline--fa fa-vimeo fa-w-14\"\n              role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n              <path\n                d=\"M403.2 32H44.8C20.1 32 0 52.1.0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7.0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9.0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4.0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z\">\n              </path>\n            </svg>\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"container-fluid footer-trimble-corp\">\n    <div class=\"container\">\n      <div class=\"row py-3 text-white\">\n        <div class=\"col-12\">\n          <a href=\"https://www.trimble.com/Corporate/Copyrights.aspx\" target=\"_blank\" rel=\"noopener\"\n            class=\"text-white mr-3 pl-4\">\n            &copy; Copyright {{year}}, Trimble Inc.\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n</footer>\n";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("app").controller("routeOptionModalController", ["$scope", "UserProvider", "$uibModalInstance", "alkModalService", "$timeout", "routeService", "routeCopy", "optionsUI", "subscriptionLevel", "isDefault", "conversionService", "routingProfile", "_", "defaultDimensions", "applicationSettingsService", "$location", "eventTracker", function routeOptionModalController($scope, UserProvider, $uibModalInstance, alkModalService, $timeout, routeService, routeCopy, optionsUI, subscriptionLevel, isDefault, conversionService, routingProfile, _, defaultDimensions, applicationSettingsService, $location, eventTracker) {
    var vm = this;

    vm.defaultDimensions = defaultDimensions;
    vm.optionsUI = optionsUI;
    vm.routeCopy = routeCopy;
    vm.subscriptionLevel = subscriptionLevel;
    vm.isDefault = isDefault;
    vm.isAlertShowing = false;
    vm.showAlert = function () {
      return vm.isAlertShowing = true;
    };
    vm.hideAlert = function () {
      return vm.isAlertShowing = false;
    };

    vm.prepareForSave = prepareForSave;
    vm.changeElevationDiscouraged = changeElevationDiscouraged;
    vm.changeGovernorSpeedLimit = changeGovernorSpeedLimit;
    vm.depTypeChanged = depTypeChanged;
    vm.vehicleTypeChanged = vehicleTypeChanged;

    vm.resetToDefaults = resetToDefaults;
    vm.goToApplicationSettings = goToApplicationSettings;
    vm.saveAsDefaults = saveAsDefaults;
    vm.ok = ok;
    vm.close = close;
    vm.userCfg = {
      classicSearchView: applicationSettingsService.getUserCfg("classicSearchView"),
      includePOI: applicationSettingsService.getUserCfg("includePOI")
    };

    initializeLocalOptions();
    var disableClassOverrides;
    vm.updateClassOverrides = updateClassOverrides;
    function updateClassOverrides() {
      if (vm.localOptions.lengthFeet > 48 || vm.localOptions.widthEnglish > 96) {
        vm.routeCopy.options.classOverrides = 3;
        disableClassOverrides = true;
      } else {
        vm.routeCopy.options.classOverrides = 0;
        disableClassOverrides = false;
      }
    }

    vm.getDisabledOption = getDisabledOption;
    function getDisabledOption() {
      return disableClassOverrides;
    }

    function initializeLocalOptions() {
      vm.localOptions = {};
      vm.localOptions.name = vm.routeCopy.name;
      // classOverrides(3) means nationalNetwork + fiftyThreeFoot. classOverrides(0) means None.
      vm.localOptions.nationalNetwork = vm.routeCopy.options.classOverrides === 3 ? true : false;
      vm.localOptions.fiftyThreeFoot = vm.routeCopy.options.classOverrides === 3 ? true : false;
      vm.region = UserProvider.getUser().region;
      //if (uiArrDepSelection !== undefined){
      //vm.depTypeChanged();
      //}
      // vm.routeCopy.options.useTraffic=false;
      // if elevation limit is not null, than it is discouraged
      vm.localOptions.isElevationDiscouraged = vm.routeCopy.options.elevLimit != null;
      vm.localOptions.elevationLimit = vm.routeCopy.options.elevLimit || (vm.routeCopy.options.trkUnits === 0 ? vm.defaultDimensions.def.limit.elevationEnglish : vm.defaultDimensions.def.limit.elevationMetric);
      vm.localOptions.isGovernorSpeedLimit = vm.routeCopy.options.governorSpeedLimit != null;
      vm.localOptions.governorSpeedLimit = vm.routeCopy.options.governorSpeedLimit || (vm.routeCopy.options.trkUnits === 0 ? vm.defaultDimensions.def.limit.governorSpeedEnglish : vm.defaultDimensions.def.limit.governorSpeedMetric);

      var height;
      var length;

      if (vm.routeCopy.options.trkUnits === 0) {
        // units are in feet/inches
        height = conversionService.stringToFeetInches(vm.routeCopy.options.trkHeight);
        length = conversionService.stringToFeetInches(vm.routeCopy.options.trkLength);

        vm.localOptions.heightFeet = height[0];
        vm.localOptions.heightInches = height[1];
        vm.localOptions.lengthFeet = length[0];
        vm.localOptions.lengthInches = length[1];
        vm.localOptions.heightMeters = conversionService.feetInchesToMeters(height[0], height[1], 4);
        vm.localOptions.lengthMeters = conversionService.feetInchesToMeters(length[0], length[1], 4);
        vm.localOptions.widthEnglish = conversionService.stringToTotalInches(vm.routeCopy.options.trkWidth);
        vm.localOptions.widthMetric = conversionService.inchesToMeters(vm.localOptions.widthEnglish, 2);
        vm.localOptions.weightPounds = vm.routeCopy.options.trkWeight;
        vm.localOptions.weightKilograms = conversionService.poundsToKilograms(vm.routeCopy.options.trkWeight);

        if (vm.routeCopy.options.classOverrides === 3 && (vm.localOptions.lengthFeet > 48 || vm.localOptions.widthEnglish > 96)) {
          disableClassOverrides = true;
        } else {
          disableClassOverrides = false;
        }
      } else {
        // units are in meters
        height = conversionService.metersToFeetInches(vm.routeCopy.options.trkHeight);
        length = conversionService.metersToFeetInches(vm.routeCopy.options.trkLength);

        vm.localOptions.heightFeet = height[0];
        vm.localOptions.heightInches = height[1];
        vm.localOptions.lengthFeet = length[0];
        vm.localOptions.lengthInches = length[1];
        vm.localOptions.heightMeters = parseFloat(vm.routeCopy.options.trkHeight);
        vm.localOptions.lengthMeters = parseFloat(vm.routeCopy.options.trkLength);
        vm.localOptions.widthEnglish = conversionService.metersToInches(vm.routeCopy.options.trkWidth);
        vm.localOptions.widthMetric = vm.routeCopy.options.trkWidth;
        vm.localOptions.weightPounds = conversionService.kilogramsToPounds(vm.routeCopy.options.trkWeight);
        vm.localOptions.weightKilograms = vm.routeCopy.options.trkWeight;
      }

      //additional columns for EU region (saved in local storage currently)
      if (vm.region === "EU") {
        var trlMaxHt;

        vm.EUOptions = vm.routeCopy.options.EUOptions;
        vm.localOptionsEU = {};
        if (vm.routeCopy.options.trkUnits === 0) {
          trlMaxHt = conversionService.stringToFeetInches(vm.EUOptions.trlMaxHt);

          vm.localOptionsEU.heightFeet = trlMaxHt[0];
          vm.localOptionsEU.heightInches = trlMaxHt[1];
          vm.localOptionsEU.heightMeters = conversionService.feetInchesToMeters(trlMaxHt[0], trlMaxHt[1], 4);
          vm.localOptionsEU.weightPounds = vm.EUOptions.trlMaxWt;
          vm.localOptionsEU.weightKilograms = conversionService.poundsToKilograms(vm.EUOptions.trlMaxWt);
        } else {
          trlMaxHt = conversionService.metersToFeetInches(vm.EUOptions.trlMaxHt);

          vm.localOptionsEU.heightFeet = trlMaxHt[0];
          vm.localOptionsEU.heightInches = trlMaxHt[1];
          vm.localOptionsEU.heightMeters = parseFloat(vm.EUOptions.trlMaxHt);
          vm.localOptionsEU.weightPounds = conversionService.kilogramsToPounds(vm.EUOptions.trlMaxWt);
          vm.localOptionsEU.weightKilograms = vm.EUOptions.trlMaxWt;
        }
      }
    }

    function prepareForSave() {
      vm.routeCopy.options.elevLimit = vm.localOptions.isElevationDiscouraged ? vm.localOptions.elevationLimit : null;
      vm.routeCopy.options.governorSpeedLimit = vm.localOptions.isGovernorSpeedLimit ? vm.localOptions.governorSpeedLimit : null;

      if (vm.routeCopy.options.trkUnits === 0) {
        vm.routeCopy.options.trkHeight = conversionService.feetInchesToString([vm.localOptions.heightFeet, vm.localOptions.heightInches]);
        vm.routeCopy.options.trkLength = conversionService.feetInchesToString([vm.localOptions.lengthFeet, vm.localOptions.lengthInches]);
        vm.routeCopy.options.trkWidth = conversionService.totalInchesToString(vm.localOptions.widthEnglish, true);
        vm.routeCopy.options.trkWeight = vm.localOptions.weightPounds;
      } else {
        vm.routeCopy.options.trkHeight = vm.localOptions.heightMeters;
        vm.routeCopy.options.trkLength = vm.localOptions.lengthMeters;
        vm.routeCopy.options.trkWidth = vm.localOptions.widthMetric;
        vm.routeCopy.options.trkWeight = vm.localOptions.weightKilograms;
      }

      // addtional columns for EU region
      if (vm.region === "EU") {
        if (vm.routeCopy.options.trkUnits === 0) {
          vm.EUOptions.trlMaxHt = conversionService.feetInchesToString([vm.localOptionsEU.heightFeet, vm.localOptionsEU.heightInches]);
          vm.EUOptions.trlMaxWt = vm.localOptionsEU.weightPounds;
        } else {
          vm.EUOptions.trlMaxHt = vm.localOptionsEU.heightMeters;
          vm.EUOptions.trlMaxWt = vm.localOptionsEU.weightKilograms;
        }
        vm.routeCopy.options.EUOptions = vm.EUOptions;
      }
    }

    function changeElevationDiscouraged() {
      if (!vm.localOptions.isElevationDiscouraged) {
        vm.routeCopy.options.elevLimit = null;
      }
    }

    function changeGovernorSpeedLimit() {
      if (!vm.localOptions.isGovernorSpeedLimit) {
        vm.routeCopy.options.governorSpeedLimit = null;
      }
    }

    function depTypeChanged() {
      if (vm.routeCopy.uiArrDepSelection.type === "now") {
        vm.routeCopy.options.useTraffic = true;
      } else {
        vm.routeCopy.options.useTraffic = false;
      }
    }

    function vehicleTypeChanged() {
      // when vehicle type changes, set the default values for all fields

      var vehicle;
      var max = vm.defaultDimensions.max;
      var min = vm.defaultDimensions.min;

      if (vm.routeCopy.options.vehicleType === 0) {
        vehicle = vm.defaultDimensions.def.truck;
      } else if (vm.routeCopy.options.vehicleType === 1) {
        vehicle = vm.defaultDimensions.def.light;
      } else if (vm.routeCopy.options.vehicleType === 2) {
        vehicle = vm.defaultDimensions.def.car;
      }

      if (vm.region === "EU") {
        vm.EUOptions.hasTrailer = vm.routeCopy.options.vehicleType === 2 ? false : true;
      }

      vm.routeCopy.options.trkAxles = vehicle.axles;

      // the english units are the default values, they do not need to be run through bounds to make sure they are within the limit.
      vm.localOptions.heightFeet = conversionService.feet(vehicle.height);
      vm.localOptions.heightInches = conversionService.inches(vehicle.height);
      vm.localOptions.lengthFeet = conversionService.feet(vehicle.length);
      vm.localOptions.lengthInches = conversionService.inches(vehicle.length);
      vm.localOptions.widthEnglish = vehicle.width;
      vm.localOptions.weightPounds = vehicle.weight;

      // conversion is being done, make sure to keep the values within the correct max/min and correct number of decimal places.
      vm.localOptions.heightMeters = conversionService.bounds(min.heightMetric, max.heightMetric, conversionService.feetInchesToMeters(vm.localOptions.heightFeet, vm.localOptions.heightInches, 4)); // ensure we stay within bounds because of rounding
      vm.localOptions.lengthMeters = conversionService.bounds(min.lengthMetric, max.lengthMetric, conversionService.feetInchesToMeters(vm.localOptions.lengthFeet, vm.localOptions.lengthInches, 4));
      vm.localOptions.widthMetric = conversionService.inchesToMeters(vehicle.width, 2);
      vm.localOptions.weightKilograms = conversionService.bounds(min.weightMetric, max.weightMetric, conversionService.poundsToKilograms(vehicle.weight, 2));
    }

    function resetToDefaults() {
      vm.routeCopy.options = routingProfile.getSystemDefaultOptions();
      vm.userCfg = {
        classicSearchView: applicationSettingsService.getDefaultUserCfg("classicSearchView"),
        includePOI: applicationSettingsService.getDefaultUserCfg("includePOI")
      };

      $scope.$broadcast("resetAFSelection");
      initializeLocalOptions();
    }

    function goToApplicationSettings() {
      if (!$scope.routeOptionsForm.$pristine) {
        alkModalService.show({
          size: "sm"
        }, {
          headerText: "Exit Route Options",
          bodyText: "Are you sure you want to exit without saving your changes?"
        }).then(function () {
          vm.close();
          $location.url("/applicationSettings");
        });
      } else {
        vm.close();
        $location.url("/applicationSettings");
      }
    }

    function saveAsDefaults() {
      vm.prepareForSave();
      routingProfile.setDefaultOptions(vm.routeCopy.options);
      vm.showAlert();
      $timeout(vm.hideAlert, 2000);
    }

    function ok() {
      vm.prepareForSave();
      if (vm.isDefault) {
        applicationSettingsService.updateUserCfg(vm.userCfg);
      }
      $uibModalInstance.close(vm.routeCopy);
      eventTracker.track(eventTracker.EVENTS.RT_OPTIONS, {
        options: vm.routeCopy.options
      });
    }

    function close() {
      $uibModalInstance.dismiss("cancel");
    }

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////

    $scope.$watch("vm.routeCopy.options.classOverrides", function () {
      if (vm.routeCopy.options.classOverrides === 0) {
        vm.localOptions.nationalNetwork = false;
        vm.localOptions.fiftyThreeFoot = false;
      } else {
        vm.localOptions.nationalNetwork = true;
        vm.localOptions.fiftyThreeFoot = true;
      }
    });

    // if the elevation discouraged is not enabled and the elevation limit is not a valid number, set it to the default.
    $scope.$watch("vm.localOptions.isElevationDiscouraged", function () {
      if (vm.localOptions.isElevationDiscouraged === false && !vm.localOptions.elevationLimit) {
        vm.localOptions.elevationLimit = vm.routeCopy.options.trkUnits === 0 ? vm.defaultDimensions.def.limit.elevationEnglish : vm.defaultDimensions.def.limit.elevationMetric;
      }
    });

    // if the gorvernor speed is not enabled and the gorvernor speed limit is not a valid number, set it to the default.
    $scope.$watch("vm.localOptions.isGovernorSpeedLimit", function () {
      if (vm.localOptions.isGovernorSpeedLimit === false && !vm.localOptions.governorSpeedLimit) {
        vm.localOptions.governorSpeedLimit = vm.routeCopy.options.trkUnits === 0 ? vm.defaultDimensions.def.limit.governorSpeedEnglish : vm.defaultDimensions.def.limit.governorSpeedMetric;
      }
    });
  }]);
})();

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  angular.module("app").controller("leastCostModalController", ["$scope", "$uibModalInstance", "ALKMaps", "data", "$timeout", "$q", "$window", "$filter", "mapService", "UserProvider", function leastCostModalController($scope, $uibModalInstance, ALKMaps, data, $timeout, $q, $window, $filter, mapService, userProvider) {
    ALKMaps.APIKey = userProvider.getUser().authToken;

    var trackDisplays = [{
      color: "#00ff06",
      title: "Practical"
    }, {
      color: "#fe9300",
      title: "Practical, Toll Avoid"
    }, {
      color: "#027ffb",
      title: "Shortest"
    }, {
      color: "#a55fff",
      title: "Shortest, Toll Avoid"
    }, {
      color: "#2448ff",
      title: "Fastest"
    }, {
      color: "#fc5800",
      title: "Fastest, Toll Avoid"
    }];
    var trackStrokeWidth = 10;
    var selectedTrackOpacity = 1;
    var otherTrackOpacity = 0.4;

    var map = null;
    var leastCostLayers = []; // Total 6 layers at most
    var trackConfigs = [];
    var modalOptions = {
      closeButtonText: "Cancel",
      actionButtonText: "OK",
      okOnly: false,
      headerText: "Least Cost Routing - " + data.route.name,
      bodyText: "",
      bodyTemplate: "/app/modal/leastCostDialog.template.html",
      data: {
        routes: trackConfigs
      }
    };

    var convertTimeStrToNum = function convertTimeStrToNum(str) {
      var items = str.split(":");
      return parseInt(items[0]) * 60 + parseInt(items[1]);
    };

    var updateRoutesConfigs = function updateRoutesConfigs(reportLines) {
      var minMiles = reportLines[0].Miles;
      var minHours = reportLines[0].Hours;
      var minCosts = reportLines[0].Cost;
      var minTolls = reportLines[0].Tolls;
      for (var lcIndex = 0; lcIndex < reportLines.length; lcIndex++) {
        // Todo: exclude Fastest? Remove the IF statement if not
        //if (reportLines[lcIndex].LeastCostTripOptions !== "Fastest Tolls Allowed" && reportLines[lcIndex].LeastCostTripOptions !== "Fastest Avoid Tolls") {
        if (reportLines[lcIndex].Miles < minMiles) {
          minMiles = reportLines[lcIndex].Miles;
        }
        if (convertTimeStrToNum(reportLines[lcIndex].Hours) < convertTimeStrToNum(minHours)) {
          minHours = reportLines[lcIndex].Hours;
        }
        if (reportLines[lcIndex].Cost < minCosts) {
          minCosts = reportLines[lcIndex].Cost;
        }
        if (reportLines[lcIndex].Tolls < minTolls) {
          minTolls = reportLines[lcIndex].Tolls;
        }
        //}
      }

      for (var rptIndex = 0; rptIndex < reportLines.length; rptIndex++) {
        // Todo: exclude Fastest? Remove the IF statement if not
        //if (reportLines[rptIndex].LeastCostTripOptions !== "Fastest Tolls Allowed" && reportLines[rptIndex].LeastCostTripOptions !== "Fastest Avoid Tolls") {
        var trackConfig = {
          tripOptionName: reportLines[rptIndex].LeastCostTripOptions,
          miles: reportLines[rptIndex].Miles,
          hours: reportLines[rptIndex].Hours,
          costs: reportLines[rptIndex].Cost,
          tolls: reportLines[rptIndex].Tolls,
          fuel: reportLines[rptIndex].Fuel,
          labor: reportLines[rptIndex].Labor,
          other: reportLines[rptIndex].Other,
          estghg: reportLines[rptIndex].Estghg,
          checked: true,
          minMiles: reportLines[rptIndex].Miles === minMiles ? true : false,
          minHours: reportLines[rptIndex].Hours === minHours ? true : false,
          minCosts: reportLines[rptIndex].Cost === minCosts ? true : false,
          minTolls: reportLines[rptIndex].Tolls === minTolls ? true : false
        };

        if (trackConfig.tripOptionName === "Practical Tolls Allowed") {
          trackConfig.dispOptions = trackDisplays[0].title;
          trackConfig.routingOptions = {
            routingType: 0,
            tollDiscourage: false
          };
          trackConfig.strokeColor = trackDisplays[0].color;
        }
        if (trackConfig.tripOptionName === "Practical Avoid Tolls") {
          trackConfig.dispOptions = trackDisplays[1].title;
          trackConfig.routingOptions = {
            routingType: 0,
            tollDiscourage: true
          };
          trackConfig.strokeColor = trackDisplays[1].color;
        }
        if (trackConfig.tripOptionName === "Shortest Tolls Allowed") {
          trackConfig.dispOptions = trackDisplays[2].title;
          trackConfig.routingOptions = {
            routingType: 1,
            tollDiscourage: false
          };
          trackConfig.strokeColor = trackDisplays[2].color;
        }
        if (trackConfig.tripOptionName === "Shortest Avoid Tolls") {
          trackConfig.dispOptions = trackDisplays[3].title;
          trackConfig.routingOptions = {
            routingType: 1,
            tollDiscourage: true
          };
          trackConfig.strokeColor = trackDisplays[3].color;
        }
        if (trackConfig.tripOptionName === "Fastest Tolls Allowed") {
          trackConfig.dispOptions = trackDisplays[4].title;
          trackConfig.routingOptions = {
            routingType: 2,
            tollDiscourage: false
          };
          trackConfig.strokeColor = trackDisplays[4].color;
        }
        if (trackConfig.tripOptionName === "Fastest Avoid Tolls") {
          trackConfig.dispOptions = trackDisplays[5].title;
          trackConfig.routingOptions = {
            routingType: 2,
            tollDiscourage: true
          };
          trackConfig.strokeColor = trackDisplays[5].color;
        }
        if (data.route.options.routingType === trackConfig.routingOptions.routingType && data.route.options.tollDiscourage === trackConfig.routingOptions.tollDiscourage) {
          trackConfig.strokeColor = data.route.color;
          trackConfig.selected = true;
        }
        trackConfigs.push(trackConfig);
        //}
      }
    };

    var getStops = function getStops(transform) {
      var stops = [];
      for (var sIndex = 0; sIndex < data.route.stops.length; sIndex++) {
        var stop = data.route.stops[sIndex];
        var lonLat;
        if (transform === true) {
          lonLat = new ALKMaps.LonLat(stop.Coords.Lon, stop.Coords.Lat).transform(new ALKMaps.Projection("EPSG:4326"), map.getProjectionObject());
        } else {
          lonLat = [stop.Coords.Lon, stop.Coords.Lat]; //[[-75.173297, 39.942892], [-74.438942, 39.362469]];
        }
        stops.push(lonLat);
      }
      return stops;
    };

    var modifyRouteOptions = function modifyRouteOptions(config) {
      var rOptions = angular.copy(data.route.options);
      rOptions.routingType = config.routingType;
      rOptions.tollDiscourage = config.tollDiscourage;
      return rOptions;
    };

    var createLayers = function createLayers() {
      var layers = [];
      //layers.push(data.baseMap);
      for (var index = 0; index < trackConfigs.length; index++) {
        var leastCostLayer = new ALKMaps.Layer.Routing(trackConfigs[index].tripOptionName, {
          isDraggable: false,
          originURL: "",
          waypointURL: "",
          destinationURL: ""
          //waypointURL: ALKMaps.IMAGE.FLAG_STOP
        });
        leastCostLayers.push(leastCostLayer);
        layers.push(leastCostLayer);
      }
      //layers.push(data.trafficLayer);
      return layers;
    };

    var cleanup = function cleanup() {
      //data.trafficLayer.destroy();
      //data.baseMap.destroy();
      for (var lIndex = 0; lIndex < leastCostLayers.length; lIndex++) {
        leastCostLayers[lIndex].destroy();
      }
      //map.destroy();
    };

    var addRoutesToLayers = function addRoutesToLayers(input) {
      var promises = input.map(function (rt) {
        var deferred = $q.defer();
        rt.layer.addRoute({
          stops: getStops(true),
          routeOptions: rt.routeOptions,
          functionOptions: {
            routeId: rt.layer.name,
            async: true,
            success: function success(resp) {
              //draw stops
              for (var i = 0; i < data.route.stops.length; i++) {
                var fontColor = $filter("colorFilter")(rt.strokeColor, "lighten", 0.25);
                var fillColor = "#FFFFFF";
                var strokeColor = $filter("colorFilter")(rt.strokeColor, "lighten", 0.2);
                if (i === 0) {
                  fontColor = "#259800";
                  strokeColor = "#279E00";
                } else if (i === data.route.stops.length - 1 && !rt.routeOptions.hubRouting) {
                  fontColor = "#e25656";
                  strokeColor = "#be2525";
                }

                rt.layer.setRouteHandle(rt.layer.name, i, {
                  externalGraphic: "",
                  fontColor: fontColor,
                  fontSize: "11",
                  fontWeight: "700",
                  strokeColor: strokeColor,
                  pointRadius: "9",
                  strokeWidth: 3,
                  fillColor: fillColor,
                  label: data.route.stops[i].IconText
                });
              }
              deferred.resolve(resp);
            },
            failure: function failure(resp) {
              deferred.reject(resp);
            },
            frameRoute: false,
            style: {
              strokeWidth: trackStrokeWidth,
              strokeColor: rt.strokeColor
            }
          }
        });

        return deferred.promise;
      });

      var qAll = $q.all(promises);
      qAll.then(function (results) {
        // jshint ignore:line
        var maxExtent = null;
        map.resetLayersZIndex();
        for (var qIndex = 0; qIndex < leastCostLayers.length; qIndex++) {
          if (maxExtent === null) {
            maxExtent = new ALKMaps.Bounds();
          }

          var leastCostLayer = leastCostLayers[qIndex];
          for (var fIndex = 0; fIndex < leastCostLayer.features.length; fIndex++) {
            var fbounds = leastCostLayer.features[fIndex].geometry.getBounds();
            maxExtent.extend(fbounds);
          }
          for (var opIndex = 0; opIndex < trackConfigs.length; opIndex++) {
            if (trackConfigs[opIndex].tripOptionName === leastCostLayer.name) {
              if (trackConfigs[opIndex].selected === true) {
                leastCostLayer.setOpacity(selectedTrackOpacity);
                map.setLayerZIndex(leastCostLayer, 100);
              } else {
                leastCostLayer.setOpacity(otherTrackOpacity);
              }
            }
          }
        }

        map.zoomToExtent(maxExtent, false);
      }, function (error) {// jshint ignore:line
        // Todo: show this error to where?
      });
    };

    var doHeavyLoading = function doHeavyLoading() {
      //map = new ALKMaps.Map("leastcostMap");
      map = mapService.getMap("leastcostMap");
      //map.addControl(new ALKMaps.Control.TouchZoom());
      var onSuccess = function onSuccess(mreport) {
        var dest = mreport[0].Destination.Address;
        dest = dest.City + ", " + dest.State + " " + dest.Zip;
        var origin = mreport[0].Origin.Address;
        origin = origin.City + ", " + origin.State + " " + origin.Zip;
        modalOptions.bodyText = modalOptions.bodyText + " Origin: " + origin + " Destination: " + dest;
        updateRoutesConfigs(mreport[0].ReportLines);
        map.addLayers(createLayers());
        var routesConfigs = [];
        for (var confIndex = 0; confIndex < trackConfigs.length; confIndex++) {
          routesConfigs.push({
            layer: leastCostLayers[confIndex],
            routeOptions: modifyRouteOptions(trackConfigs[confIndex].routingOptions),
            strokeColor: trackConfigs[confIndex].strokeColor
          });
        }
        addRoutesToLayers(routesConfigs);
      };

      var onFailure = function onFailure(response) {
        if (response.responseText) {
          var respJson = JSON.parse(response.responseText);
          var msg = "";
          for (var index = 0; index < respJson.length; index++) {
            var err = respJson[index];
            msg = msg + err.Description + "\n\n";
          }
          /* alert(response.status + " " + response.statusText + "\n\n" + msg); 
           Todo: show this error on page? */
        }
      };

      var reportStops = getStops(false);
      var routeOption = data.route.options;
      var reportOptions = {
        dataVersion: "current", //Todo
        type: "leastCost",
        format: "json"
      };
      ALKMaps.Services.getReports({
        "coords": reportStops,
        "options": routeOption,
        "reportOptions": reportOptions,
        "success": onSuccess,
        "failure": onFailure
      });
    };

    $scope.modalOptions = modalOptions;

    $scope.changeTrackVisibility = function (track) {
      for (var vIndex = 0; vIndex < leastCostLayers.length; vIndex++) {
        if (leastCostLayers[vIndex].name === track.tripOptionName) {
          leastCostLayers[vIndex].setVisibility(track.checked);
          break;
        }
      }
    };

    $scope.selectRow = function (track) {
      for (var hIndex = 0; hIndex < trackConfigs.length; hIndex++) {
        if (trackConfigs[hIndex].dispOptions === track.dispOptions) {
          trackConfigs[hIndex].selected = true;
        } else {
          trackConfigs[hIndex].selected = false;
        }
      }
      map.resetLayersZIndex();
      for (var hsIndex = 0; hsIndex < leastCostLayers.length; hsIndex++) {
        if (leastCostLayers[hsIndex].name === track.tripOptionName) {
          leastCostLayers[hsIndex].setOpacity(selectedTrackOpacity);
          map.setLayerZIndex(leastCostLayers[hsIndex], 100);
        } else {
          leastCostLayers[hsIndex].setOpacity(otherTrackOpacity);
        }
      }
    };

    $timeout(doHeavyLoading, 100);

    $scope.modalOptions.ok = function (result) {
      // jshint ignore:line
      var selectedObj;
      for (var rIndex = 0; rIndex < trackConfigs.length; rIndex++) {
        if (trackConfigs[rIndex].selected === true) {
          selectedObj = trackConfigs[rIndex];
        }
      }
      cleanup();
      $uibModalInstance.close({
        routingType: selectedObj.routingOptions.routingType,
        tollDiscourage: selectedObj.routingOptions.tollDiscourage
      });
    };

    $scope.modalOptions.close = function (result) {
      // jshint ignore:line
      cleanup();
      $uibModalInstance.dismiss("cancel");
    };
  }]);
})();

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var serviceId = "applicationSettingsService";
  angular.module("app").service(serviceId, applicationSettingsService);
  applicationSettingsService.$inject = ["$window", "defaultDimensions", "UserProvider", "conversionService", "_"];

  function applicationSettingsService($window, defaultDimensions, UserProvider, conversionService, _) {
    var isPremium = UserProvider.getUser().isPremium();
    var storageKey = "userCfg" + hashCode(UserProvider.getUser().userId, UserProvider.getUser().accountId);
    var service = {
      getUserCfg: getUserCfg,
      setUserCfg: setUserCfg,
      updateUserCfg: updateUserCfg,
      getDefaultUserCfg: getDefaultUserCfg,
      resetUserCfg: resetUserCfg,
      changeUnits: changeUnits

    };

    return service;

    //////////////////////////////////////////////////////////

    function getUserCfg(key) {
      var userCfg = $window.localStorage.getItem(storageKey);
      if (userCfg != null && userCfg != "undefined") {
        var obj = JSON.parse(userCfg);
        return key ? obj[key] : obj;
      }
      var cfg = getDefaultUserCfg();
      setUserCfg(cfg);
      return key ? cfg[key] : cfg;
    }

    function getDefaultUserCfg(key) {
      var userCfg = {};
      userCfg.afSetIDs = "";
      var currentUserConfig = $window.localStorage.getItem(storageKey);
      if (currentUserConfig != null && currentUserConfig != "undefined") {
        var obj = JSON.parse(currentUserConfig);
        if (obj && obj.Minimum_Data_Version_Used) {
          userCfg.Minimum_Data_Version_Used = obj.Minimum_Data_Version_Used;
        }
      }
      if (isPremium) {
        userCfg.classicSearchView = false;
        userCfg.includePOI = false;
        userCfg.mapLayers = {
          traffic: false,
          weatherRadar: false,
          weatherCloud: false,
          roadSurface: false,
          weatherAlerts: false,
          alkPlaces: false,
          customPlaces: false
        };
      } else {
        userCfg.classicSearchView = true;
      }
      return key ? userCfg[key] : userCfg;
    }

    function setUserCfg(config) {
      $window.localStorage.setItem(storageKey, JSON.stringify(config));
    }

    function updateUserCfg(config) {
      var val = JSON.stringify(_.defaults(config, getUserCfg()));
      $window.localStorage.setItem(storageKey, val);
    }

    function resetUserCfg() {
      $window.localStorage.setItem(storageKey, JSON.stringify(getDefaultUserCfg()));
      return getUserCfg();
    }

    function hashCode(a, b) {
      var num = 3 * a + 7 * b;
      var str = num.toString();
      var hash = 5381;
      for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + c */
      }
      return hash;
    }

    function changeUnits(routeOptions) {
      var max = defaultDimensions.max;
      var min = defaultDimensions.min;
      var NUM_INCHES_IN_FOOT = 12;
      var region = UserProvider.getUser().region;
      // english unit, check bounds for each value
      if (routeOptions.trkUnits === 0) {
        routeOptions.trkWeight = conversionService.bounds(min.weightEnglish, max.weightEnglish, conversionService.kilogramsToPounds(routeOptions.trkWeight));

        var lengthInInches = conversionService.bounds(min.lengthEnglish * NUM_INCHES_IN_FOOT, max.lengthEnglish * NUM_INCHES_IN_FOOT, conversionService.metersToInches(routeOptions.trkLength));
        routeOptions.trkLength = conversionService.totalInchesToString(lengthInInches);

        var heightInInches = conversionService.bounds(min.heightEnglish * NUM_INCHES_IN_FOOT, max.heightEnglish * NUM_INCHES_IN_FOOT, conversionService.metersToInches(routeOptions.trkHeight));
        routeOptions.trkHeight = conversionService.totalInchesToString(heightInInches);
        // 2.43 => "96\""
        routeOptions.trkWidth = conversionService.bounds(min.widthEnglish, max.widthEnglish, conversionService.metersToInches(routeOptions.trkWidth));
        routeOptions.trkWidth = conversionService.totalInchesToString(routeOptions.trkWidth, true);

        routeOptions.governorSpeedLimit = routeOptions.governorSpeedLimit != null ? Math.floor(routeOptions.governorSpeedLimit / 1.60) : routeOptions.governorSpeedLimit; // km to miles
        routeOptions.elevLimit = routeOptions.elevLimit != null ? Math.floor(routeOptions.elevLimit * 3.28) : routeOptions.elevLimit; // meters to feet
        // we will use same unit for distance and truck.
        routeOptions.distanceUnits = 0;

        if (region === "EU") {
          routeOptions.EUOptions.trlMaxWt = Math.floor(conversionService.bounds(min.trlWeightEnglish, max.trlWeightEnglish, conversionService.kilogramsToPounds(routeOptions.EUOptions.trlMaxWt)));

          var trlHeightInInches = conversionService.bounds(min.trlHeightEnglish * NUM_INCHES_IN_FOOT, max.trlHeightEnglish * NUM_INCHES_IN_FOOT, conversionService.metersToInches(routeOptions.EUOptions.trlMaxHt));
          routeOptions.EUOptions.trlMaxHt = conversionService.totalInchesToString(trlHeightInInches);
        }
      } else {
        // metric unit, check bounds for each value
        routeOptions.trkWeight = conversionService.bounds(min.weightMetric, max.weightMetric, conversionService.poundsToKilograms(routeOptions.trkWeight, 2));

        if (!Array.isArray(routeOptions.trkLength)) {
          routeOptions.trkLength = conversionService.stringToFeetInches(routeOptions.trkLength);
          routeOptions.trkHeight = conversionService.stringToFeetInches(routeOptions.trkHeight);
        }
        routeOptions.trkLength = conversionService.bounds(min.lengthMetric, max.lengthMetric, conversionService.feetInchesToMeters(routeOptions.trkLength[0], routeOptions.trkLength[1], 4));
        routeOptions.trkHeight = conversionService.bounds(min.heightMetric, max.heightMetric, conversionService.feetInchesToMeters(routeOptions.trkHeight[0], routeOptions.trkHeight[1], 4));
        // "96\"" => 2.43
        routeOptions.trkWidth = conversionService.bounds(min.widthMetric, max.widthMetric, conversionService.inchesToMeters(conversionService.stringToTotalInches(routeOptions.trkWidth), 2));

        routeOptions.governorSpeedLimit = routeOptions.governorSpeedLimit != null ? Math.floor(routeOptions.governorSpeedLimit * 1.60) : routeOptions.governorSpeedLimit; // miles to km
        routeOptions.elevLimit = routeOptions.elevLimit != null ? Math.floor(routeOptions.elevLimit / 3.28) : routeOptions.elevLimit; // feet to meters
        // we will use same unit for distance and truck.
        routeOptions.distanceUnits = 1;

        if (region === "EU") {
          routeOptions.EUOptions.trlMaxWt = Math.floor(conversionService.bounds(min.trlWeightMetric, max.trlWeightMetric, conversionService.poundsToKilograms(routeOptions.EUOptions.trlMaxWt)));

          if (!Array.isArray(routeOptions.EUOptions.trlMaxHt)) {
            routeOptions.EUOptions.trlMaxHt = conversionService.stringToFeetInches(routeOptions.EUOptions.trlMaxHt);
          }
          routeOptions.EUOptions.trlMaxHt = conversionService.bounds(min.heightMetric, max.heightMetric, conversionService.feetInchesToMeters(routeOptions.EUOptions.trlMaxHt[0], routeOptions.EUOptions.trlMaxHt[1], 4));
        }
      }
      return routeOptions;
    }
  };
})();

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  var controllerId = "searchController";
  angular.module("app").controller(controllerId, ["$window", "$scope", "$rootScope", "$http", "$q", "$timeout", "alkModalService", "_", "STATES", "alkGeocodeService", "routeService", "mapService", "LocationItem", "UserProvider", "GeoParser", "singleSearchService", "applicationSettingsService", "$document", "favoriteLocationsService", function searchController($window, $scope, $rootScope, $http, $q, $timeout, alkModalService, _, STATES, alkGeocodeService, routeService, mapService, LocationItem, userProvider, GeoParser, singleSearchService, applicationSettingsService, $document, favoriteLocationsService) {
    var vm = this;

    vm.opt = {
      region: userProvider.getUser().region,
      dataset: routeService.getDataset()
    };
    vm.title = "searchController";
    vm.mapId = "pcmMap";
    vm.userIsPremium = userProvider.getUser().isPremium();
    vm.userIsAdmin = userProvider.getUser().isAdmin();
    vm.isSingleSearch = !applicationSettingsService.getUserCfg("classicSearchView");
    vm.excludePOI = !applicationSettingsService.getUserCfg("includePOI");
    vm.isSearchVisible = true;
    vm.activeTab = 0;
    vm.hideClose = $scope.hideClose;
    vm.getActiveTab = function () {
      return vm.activeTab;
    };

    var lazyInitdValidAthenaCategories = void 0;
    function getValidAthenaCategories() {
      if (lazyInitdValidAthenaCategories === undefined) {
        // pchen: hard-coded Single-Search-friendly strings, one for each Athena place set
        var athenaCategories = ["CAT Scales", "Truck Services", "Manufacturing Plant", "Distribution Center", "Weigh Station", "Walmart Overnight Parking", "Intermodal Terminal", "LCV Lot"];
        return singleSearchService.getValidPoiCategories().then(function (validPoiCategories) {
          lazyInitdValidAthenaCategories = _.intersection(athenaCategories, validPoiCategories);
          return lazyInitdValidAthenaCategories;
        });
      } else {
        return $q.resolve(lazyInitdValidAthenaCategories);
      }
    }

    vm.focusClass = function (className) {
      if (routeService.getSelectedRoute() && routeService.getSelectedRoute().isCalculating) {
        return;
      }
      $timeout(function () {
        var inputs = $document[0].getElementsByClassName(className);
        for (var i = 0; i < inputs.length; i++) {
          inputs[i].focus();
        }
      });
    };

    vm.searchFocus = function () {
      if (userProvider.getUser().isPremium()) {
        vm.focusClass("search-address-input");
        vm.focusClass("single-search-input");
      } else {
        vm.focusClass("search-city-input");
      }
      vm.focusClass("favorite-filter-input");
      vm.focusClass("search-splc-input");
    };

    vm.labelText = function () {
      if ($scope.labelText) {
        return $scope.labelText;
      } else {
        return "";
      }
    };

    vm.labelClass = function () {
      return $scope.labelClass;
    };

    //two search boxes
    vm.searchCityString = "";
    vm.searchAddrString = "";

    vm.searchSplcString = "";

    vm.isSearching = false;

    vm.searchResults = [];
    vm.searchResultsVisibility = function () {
      return vm.searchResults.length > 0 || vm.searchError !== "" || vm.isSearching;
    };
    vm.splcResults = [];
    vm.splcResultsVisibility = function () {
      return vm.splcResults.length > 0 || vm.splcError !== "" || vm.isSearching;
    };

    vm.selectedLocation = null;

    vm.searchError = "";
    vm.splcError = "";

    vm.clearSearch = function () {
      vm.searchCityString = "";
      vm.searchAddrString = "";
      vm.searchResults = [];
      vm.searchError = "";
    };

    vm.clearSplc = function () {
      vm.searchSplcString = "";
      vm.searchResults = [];
      vm.splcError = "";
    };

    vm.searchClassic = function () {
      vm.searchResults = [];

      if (vm.searchCityString === "") {
        vm.searchError = "You must enter a city and/or zip/postal code";
        vm.focusClass("search-city-input");
        return;
      }

      vm.isSearching = true;
      vm.searchError = "";

      var querySearchString = vm.searchCityString;
      if (vm.searchAddrString != null && vm.searchAddrString !== "") {
        querySearchString = querySearchString + "; " + vm.searchAddrString;
      }

      var addrObj = {
        searchString: querySearchString,
        postcodefilter: "both" // we don't know if user is attempting to search Mexico or USA.  Send both.
      };
      var geoOpt = {
        listSize: 10,
        region: userProvider.getUser().region,
        dataset: routeService.getDataset()
      };
      alkGeocodeService.geocode(addrObj, geoOpt).then(function (response) {
        if (response.length === 1) {
          if (response[0].Coords === null) {
            vm.searchError = "No results found";
          } else {
            response[0].origLatlon = null;
            var selectedLocation = response[0];
            // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
            if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
              var hasNegative = selectedLocation.Coords.Lat.includes("-");
              var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
              selectedLocation.Coords.Lat = selectedLocation.Coords.Lat.substring(0, indexPosition) + "." + selectedLocation.Coords.Lat.substring(indexPosition);
            }
            if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
              var hasNegative = selectedLocation.Coords.Lon.includes("-");
              var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
              selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition) + "." + selectedLocation.Coords.Lon.substring(indexPosition);
            }
            // Ends Temporary fix
            vm.addStopToRoute(new LocationItem(selectedLocation));
            //ga("send", "event", "Search", "Address", "Add Stop");
          }
        } else {
          vm.searchResults = processResults(response, "splc");
        }
      }, function (err) {
        if (geoOpt && geoOpt.dataset && geoOpt.dataset.toUpperCase() === "PCM18" && err.messages && err.messages.includes("Internal failure with requested version of PCMiler")) {
          vm.searchError = "Internal error from PCMiler 18, please consider using the latest PCMiler version.";
        } else {
          vm.searchError = "Couldn't recognize the input as a location";
        }
      }).finally(function () {
        vm.isSearching = false;
        vm.focusClass("csList0");
      });
    };

    vm.searchSplc = function () {
      vm.searchResults = [];

      if (!vm.searchSplcString) return;

      vm.isSearching = true;
      vm.splcError = "";

      var latlon = GeoParser.getLatLon(vm.searchSplcString);
      var geoOpt = {
        region: userProvider.getUser().region,
        dataset: routeService.getDataset()
      };
      // if the fields look like the format, "<lat>, <lon>", than do a reverse geocode on this lat/lon, otherwise search by splc
      if (latlon) {

        alkGeocodeService.reverseGeocode(latlon, geoOpt).then(function (r) {
          var pr = processResults(r, "latlon");
          var selectedLocation = pr[0];
          // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
          if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
            var hasNegative = selectedLocation.Coords.Lat.includes("-");
            var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
            selectedLocation.Coords.Lat = selectedLocation.Coords.Lat.substring(0, indexPosition) + "." + selectedLocation.Coords.Lat.substring(indexPosition);
          }
          if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
            var hasNegative = selectedLocation.Coords.Lon.includes("-");
            var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
            selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition) + "." + selectedLocation.Coords.Lon.substring(indexPosition);
          }
          // Ends Temporary fix
          selectLocation(selectedLocation, false);
        }, function (err) {
          vm.splcError = "No matching Latitude and Longitude";
        }).finally(function () {
          vm.isSearching = false;
        });
      } else {
        alkGeocodeService.geocode({
          splc: vm.searchSplcString
        }, geoOpt).then(function (r) {
          if (r.length === 1) {
            if (r[0].Coords === null) {
              vm.splcError = "No matching SPLC found";
            } else {
              r[0].origLatlon = null;
              var selectedLocation = r[0];
              // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
              if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
                var hasNegative = selectedLocation.Coords.Lat.includes("-");
                var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
                selectedLocation.Coords.Lat = selectedLocation.Coords.Lat.substring(0, indexPosition) + "." + selectedLocation.Coords.Lat.substring(indexPosition);
              }
              if (selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
                var hasNegative = selectedLocation.Coords.Lon.includes("-");
                var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
                selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition) + "." + selectedLocation.Coords.Lon.substring(indexPosition);
              }
              // Ends Temporary fix
              vm.addStopToRoute(new LocationItem(r[0]));
              //ga("send", "event", "Search", "SPLC", "Add Stop");
            }
          } else {
            vm.splcResults = processResults(r, "splc");
          }
        }, function (err) {
          vm.splcError = "No matching SPLC found";
        }).finally(function () {
          vm.isSearching = false;
        });
      }
    };

    vm.singleSearchResults = [];

    vm.singleSearch = function () {

      // var centerLL = mapService.getMap().getCenter().transform(mapService.getMap().getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));

      var searchStartCallback = function searchStartCallback() {
        vm.isSearching = true;
      };

      var successCallback = function successCallback(results) {
        vm.singleSearchResults = processResults(results, "singlesearch");
        vm.isSearching = false;
        vm.focusClass("single-search-input"); //Re-focus so that if user was in the list and it changed, they don't lose focus on the page
      };

      var errorCallback = function errorCallback(error) {
        console.log(error);
        vm.isSearching = false;
      };

      var searchParam = {
        query: vm.singleSearchString,
        maxResults: 10,
        countryType: "FIPS" // PCMWS's default country type is FIPS
        //currentLonLat: centerLL.lon + "," + centerLL.lat,
      };

      // custom place search is not available in Dev.
      if (config.env !== "Dev") {
        searchParam.useCustomPlaces = true;
        searchParam.customPlacesToken = userProvider.getUser().authToken;
      }

      if (vm.excludePOI) {
        getValidAthenaCategories().then(function (validAthenaCategories) {
          _.extend(searchParam, {
            poiCategories: validAthenaCategories.join(","),
            excludedSearchTypes: "POIType"
          });
          singleSearchService.search(searchParam, searchStartCallback, successCallback, errorCallback);
        });
      } else {
        singleSearchService.search(searchParam, searchStartCallback, successCallback, errorCallback);
      }
    };

    function processResults(r, type) {
      var retVal = [];
      angular.forEach(r, function (value, key) {
        // jshint ignore:line
        if (type == "singlesearch" && value.ResultType == 14) {
          value.origLatlon = vm.singleSearchString;
        } else if (type == 'latlon') {
          // splc
          value.origLatlon = vm.searchSplcString;
        } else {
          // or undefined type
          value.origLatlon = null;
        }
        var temp = new LocationItem(value);
        this.push(temp);
      }, retVal);
      return retVal;
    }

    function selectLocation(loc, pan) {
      vm.selectedLocation = loc;

      vm.showLocation(vm.selectedLocation, pan);

      vm.searchResults = [];
      vm.searchSplcString = "";
    }

    vm.showLocation = function (loc, pan) {
      vm.selectedLocation = loc;
      $rootScope.$broadcast("ShowPin", { location: loc, pan: pan, mapId: vm.mapId });
    };

    vm.locationClass = function (loc) {
      var className = "";

      if (loc !== null && loc.Address.StreetAddress === "") {
        className = "noAddress";
      }

      return className;
    };

    vm.addStopToRoute = function (loc) {
      $rootScope.$broadcast("AddStop", loc);
      vm.clearSearch();
      vm.searchFocus();
    };

    vm.hideSortableItem = function () {
      var index = Number($scope.sortableItemIndex);
      $rootScope.$broadcast("RemoveSortableItem", index);
    };

    vm.getFavorites = function () {
      return favoriteLocationsService.getAllLocations();
    };

    vm.hideFavorites = function () {
      vm.favorites = [];
    };

    vm.canSaveFavorite = function (loc) {
      return favoriteLocationsService.canSave(angular.copy(loc));
    };

    vm.deleteFavorite = function (fav) {
      alkModalService.show({
        size: "sm"
      }, {
        headerText: "Delete Saved Location",
        bodyText: "Are you sure you want to delete this location?"
      }).then(function () {
        favoriteLocationsService.deleteFavorite(fav);
      });
    };

    vm.pickFavorite = function (fav) {
      $rootScope.$broadcast("SelectLocation", fav);
    };

    vm.addFavoriteToRoute = function (fav) {
      $rootScope.$broadcast("AddStop", angular.copy(fav));
    };

    vm.filterFunction = function (favorite) {
      if (!vm.favoriteFilter) return true;

      var regex = new RegExp(vm.favoriteFilter, "i");
      var name = favorite.Name;
      var cityStateZip = favorite.CityStateZip;
      var street = favorite.Address.StreetAddress;
      var matchResult = false;
      if (name == null && cityStateZip == null && street == null) {
        matchResult = false;
      } else if (cityStateZip != null && cityStateZip.match(regex) || name != null && name.match(regex) || street != null && street.match(regex)) {
        matchResult = true;
      }
      return matchResult;
    };

    vm.focusInput = function (elemSelector) {
      $timeout(function () {
        angular.element(elemSelector).focus();
      }, 50);
    };

    vm.showMorePlaces = function () {
      alkModalService.show({
        size: "md",
        templateUrl: "/app/modal/placesDialog.template.html",
        controller: "placesController",
        controllerAs: "vm"
      }).then(function (result) {});
    };

    $scope.$on("MapClick", function (event, message) {
      // jshint ignore:line
      vm.clearSearch();
    });

    $scope.$on("SelectLocation", function (event, message) {
      // jshint ignore:line
      selectLocation(message, true);
    });

    $scope.$on("ShowLocation", function (event, message) {
      // jshint ignore:line
      selectLocation(message, true);
    });

    $scope.$on("FocusSearchField", function (event, message) {
      // jshint ignore:line
      vm.activeTab = 0;
      vm.searchFocus();
    });
  }]);
})();

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("app").directive("searchStop", searchStop);

  function searchStop() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: "E",
      templateUrl: "/app/search/search.template.html",
      scope: {
        labelText: "@",
        labelClass: "@",
        sortableItemIndex: "=",
        hideClose: "="
      }
    };
    return directive;

    function link($scope, $element, $attrs) {
      $scope.labelText = $attrs.labelText;
      $scope.labelClass = $attrs.labelClass;
    }
  }
})();

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var config = __webpack_require__(1);

(function () {
  angular.module("app").factory("customPlaceSetService", ["$http", "$q", "favoriteLocationsService", "LocationItem", "_", function ($http, $q, favoriteLocationsService, LocationItem, _) {

    // pchen: promise that resolves to
    //   [ <DASet where Places: [ LocationItem instead of DAPlace ]> ]
    // unresolved promise means existing webservice call in-progress, in which case new calls should NOT be started
    var lazyInitdCustomPlaceSets = void 0;
    // used to check whether the data is ready for favorite name validation
    var inProgress = false;

    function loadCustomPlaceData() {
      inProgress = true;
      lazyInitdCustomPlaceSets = $q.all([
      // TODO pchen: have an endpoint specifically to get this data in one call, instead of having two calls
      getDAPlaceSetsWithPlaces({ onlyMine: true, useShared: false }), getDAPlaceSetsWithPlaces({ onlyMine: true, useShared: true })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            ownerSets = _ref2[0],
            accountSets = _ref2[1];

        return ownerSets.concat(accountSets);
      }).then(function (daPlaceSets) {
        // filter out favorites; they are managed by a different service
        daPlaceSets = favoriteLocationsService.filterOutFavoriteSets(daPlaceSets);
        daPlaceSets.forEach(function (daPlaceSet) {
          daPlaceSet.Places = daPlaceSet.Places.map(function (daPlace) {
            return new LocationItem(daPlace, daPlace.PlaceName);
          });
        });
        return daPlaceSets;
      }).catch(function (err) {
        // pchen: reset state; no longer "in progress"
        // TODO pchen: expose the errors to the user
        lazyInitdCustomPlaceSets = undefined;
      }).finally(function () {
        inProgress = false;
      });

      return lazyInitdCustomPlaceSets;
    }

    function isDataLoaded() {
      return lazyInitdCustomPlaceSets !== undefined && !inProgress;
    }

    function getDAPlaceSetsWithPlaces() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$onlyMine = _ref3.onlyMine,
          onlyMine = _ref3$onlyMine === undefined ? true : _ref3$onlyMine,
          _ref3$useShared = _ref3.useShared,
          useShared = _ref3$useShared === undefined ? false : _ref3$useShared;

      var params = {
        "includePlaces": true,
        onlyMine: onlyMine,
        useShared: useShared,
        "readOnlyPublicData": false
      };

      var request = {
        method: "GET",
        url: config.daUrl + "place-sets/-1",
        params: params
      };

      return $http(request).then(function (_ref4) {
        var placeSetList = _ref4.data;

        return placeSetList;
      });
    }

    function getCustomPlaceSets() {
      if (lazyInitdCustomPlaceSets === undefined) {
        loadCustomPlaceData();
      }
      return lazyInitdCustomPlaceSets;
    }

    return {
      getCustomPlaceSets: getCustomPlaceSets,
      isDataLoaded: isDataLoaded
    };
  }]);
})();

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var config = __webpack_require__(1);

(function () {
  angular.module("app").factory("favoriteLocationsService", ["UserProvider", "placeCloudService", "$q", "LocationItem", "$http", "_", function (userProvider, placeCloudService, $q, LocationItem, $http, _) {
    // This set is for new favorites added to the users pcm web set
    var personalSetName = userProvider.getUser().account + " - " + userProvider.getUser().userName;
    var personalFavoritesSetId = -1;
    // pchen: DA place set without Places
    var personalSet = void 0;
    // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
    var personalFavoriteLocations = [];

    // This set is for new favorites added to the accounts pcm web set
    var sharedSetName = userProvider.getUser().account;
    var sharedFavoritesSetId = -1;
    // pchen: DA place set without Places
    var sharedSet = void 0;
    // array of PCMWeb LocationItems (1 for each place in above set); populated by loadData
    var sharedFavoriteLocations = [];

    function loadData() {
      // TODO pchen: load favorite places in the background; have "loading..." placeholder in list view
      // sets globals for saving (setids needed for saving new favorites) and viewing favorites
      var personalFavoritesPromise = placeCloudService.getPlaceSetWithName(personalSetName).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            firstPlaceSet = _ref2[0];

        personalSet = firstPlaceSet;
        personalFavoritesSetId = personalSet ? personalSet.Id : -1;
        return getFavoriteLocationsFromSetId(personalFavoritesSetId, { isSharedFavorite: false });
      }).then(function (locations) {
        personalFavoriteLocations = locations;
      });
      var sharedFavoritesPromise = placeCloudService.getPlaceSetWithName(sharedSetName, { useShared: true }).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
            firstPlaceSet = _ref4[0];

        sharedSet = firstPlaceSet;
        sharedFavoritesSetId = sharedSet ? sharedSet.Id : -1;
        return getFavoriteLocationsFromSetId(sharedFavoritesSetId, { isSharedFavorite: true });
      }).then(function (locations) {
        sharedFavoriteLocations = locations;
      });

      return $q.all([personalFavoritesPromise, sharedFavoritesPromise]);
    }
    // pchen: isSharedFavorite is only used to set the property in the LocationItem
    function getFavoriteLocationsFromSetId(setId, _ref5) {
      var isSharedFavorite = _ref5.isSharedFavorite;

      if (setId === -1) {
        // set does not exist (yet)
        return $q.resolve([]);
      } else {
        return placeCloudService.getPlaces(setId,
        // filter = ""
        undefined,
        // includePlaces = true
        undefined,
        // readOnlyPublicData
        false).then(function (placeSet) {
          return placeSet.Places.map(function (daPlace) {
            // pchen: move this "DAPlace to Personal/Shared Favorite Location" conversion to LocationItem.module?
            var loc = new LocationItem(daPlace, daPlace.PlaceName);
            loc.IsShared = isSharedFavorite;
            return loc;
          });
        });
      }
    }

    function getAllLocations() {
      // pchen: personal favs override shared favs with same name
      return _.union(personalFavoriteLocations, sharedFavoriteLocations, "Name");
    }

    function getAsSets() {
      return {
        personal: _.assign(personalSet, { Places: personalFavoriteLocations }),
        shared: _.assign(sharedSet, { Places: sharedFavoriteLocations })
      };
    }

    function filterOutFavoriteSets(sets) {
      return sets.filter(function (_ref6) {
        var Id = _ref6.Id;
        return Id !== personalFavoritesSetId && Id !== sharedFavoritesSetId;
      });
    }

    function saveNew(loc, name, isShared) {
      if (canSave(loc)) {

        loc.Name = name;
        loc.IsShared = isShared === true;
        loc.OnlyMine = true;

        return createDASetIfNeeded(isShared).then(function (setId) {
          var dataAnywhereCustomPlace = {
            street: loc.ALKObj.Address.StreetAddress,
            city: loc.ALKObj.Address.City,
            state: loc.ALKObj.Address.State,
            zip: loc.ALKObj.Address.Zip,
            latitude: loc.ALKObj.Coords.Lat,
            longitude: loc.ALKObj.Coords.Lon,
            placeName: name,
            county: loc.ALKObj.Address.County
          };

          return placeCloudService.saveNewPlace(setId, null, dataAnywhereCustomPlace).then(function (resp) {
            loc.Id = resp.Id;
            loc.TypeIcon = "ico-star";
            loc.SetId = setId;
            if (isShared) {
              sharedFavoriteLocations.push(loc);
            } else {
              personalFavoriteLocations.push(loc);
            }
          });
        });
      }
    }

    function canSave(loc) {
      if (!userProvider.getUser().isPremium()) {
        return false;
      }
      if (loc === null || loc === undefined) {
        return false;
      }

      var favs = getAllLocations();

      return userProvider.getUser().isLoggedIn && _.find(favs, function (obj) {
        if (loc.ALKObj && Number(obj.ALKObj.Coords.Lat) === Number(loc.ALKObj.Coords.Lat) && //temporary fix @vani @bpan
        Number(obj.ALKObj.Coords.Lon) === Number(loc.ALKObj.Coords.Lon)) {
          return true;
        } else {
          return false;
        }
      }) === undefined;
    }

    function setSavedSetId(respSet, isShared) {
      if (isShared) {
        sharedFavoritesSetId = respSet.Id;
      } else {
        personalFavoritesSetId = respSet.Id;
      }
    }

    function createDASetIfNeeded(isShared) {
      var deferred = $q.defer();
      var setName = isShared ? sharedSetName : personalSetName;

      placeCloudService.getPlaceSetWithName(setName, { useShared: isShared }).then(function (respSets) {
        if (respSets.length === 0) {
          placeCloudService.addPlaceSet(setName, null, isShared).then(function (respSet) {
            setSavedSetId(respSet, isShared);
            deferred.resolve(respSet.Id);
          });
        } else {
          var respSet = respSets[0];
          setSavedSetId(respSet, isShared);
          deferred.resolve(respSet.Id);
        }
      });

      return deferred.promise;
    }

    function deleteFavorite(fav) {
      $http.delete(config.daUrl + "places/" + fav.Id).success(function () {
        if (fav.isShared) {
          _.remove(sharedFavoriteLocations, fav);
        } else {
          _.remove(personalFavoriteLocations, fav);
        }
      });
    }

    function clearData() {
      personalFavoritesSetId = -1; // This set is for new favorites added to the users pcm web set
      personalFavoriteLocations = [];
      sharedFavoritesSetId = -1; // This set is for new favorites added to the accounts pcm web set
      sharedFavoriteLocations = [];
    }

    return {
      loadData: loadData,
      getAllLocations: getAllLocations,
      getAsSets: getAsSets,
      filterOutFavoriteSets: filterOutFavoriteSets,
      saveNew: saveNew,
      canSave: canSave,
      deleteFavorite: deleteFavorite,
      clearData: clearData
    };
  }]);
})();

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  angular.module("app").factory("favoriteNameValidator", ["$http", "$q", "customPlaceSetService", "favoriteLocationsService", "_", function ($http, $q, customPlaceSetService, favoriteLocationsService, _) {
    // returns promise that resolves if unique and rejects if not unique
    //   tests against all custom places for the user/account, including favorites
    function isNameUnique(newName) {
      if (customPlaceSetService.isDataLoaded()) {
        return isCustomPlaceOrFavoriteNameUniqueToLocalData(newName);
      } else {
        return isCustomPlaceOrFavoriteNameUniqueToCloudData(newName);
      }
    }
    // returns promise that resolves if unique and rejects if not unique
    function isCustomPlaceOrFavoriteNameUniqueToLocalData(newName) {
      var deferred = $q.defer();
      customPlaceSetService.getCustomPlaceSets().then(function (sets) {
        var customPlaceLocations = _.flatten(sets.map(function (set) {
          return set.Places;
        }));
        var isUniqueToCustomPlaceNames = customPlaceLocations.every(function (loc) {
          return angular.lowercase(loc.Name) !== angular.lowercase(newName);
        });

        var isUniqueToFavoriteNames = favoriteLocationsService.getAllLocations().every(function (loc) {
          return angular.lowercase(loc.Name) !== angular.lowercase(newName);
        });

        if (isUniqueToCustomPlaceNames && isUniqueToFavoriteNames) {
          deferred.resolve(true);
        } else {
          deferred.reject();
        }
      });
      return deferred.promise;
    }

    // TODO pchen: write new back-end for this specific use case
    //   (to do everything in 1 call instead of 2)
    // returns promise that resolves if unique and rejects if not unique
    function isCustomPlaceOrFavoriteNameUniqueToCloudData(newName) {
      // pchen: compares to private custom places (includes personal favs)
      // TODO pchen: check if prod customers have private custom places outside of personal favs
      return checkPlaceNameMatchInDA(newName, { useShared: false }).then(function () {
        // pchen: nesting these for the small performance improvement where
        //   we don't need to check shared if we've already failed for private
        // pchen: compares to shared account-level custom places (includes shared favs)
        return checkPlaceNameMatchInDA(newName, { useShared: true });
      });
    }
    // checks if place name is already in user/account places
    //   should be called twice: 1. useShared = false and 2. useShared = true;
    //   useShared=false will come back with private custom
    //   places (including personal favs) useShared=true will
    //   come back with shared account-level custom places
    //   (including shared favs)
    // returns promise that resolves if unique and rejects if not unique
    function checkPlaceNameMatchInDA(newName) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$useShared = _ref.useShared,
          useShared = _ref$useShared === undefined ? true : _ref$useShared;

      if (!newName) {
        return $q.reject();
      }

      var deferred = $q.defer();

      var params = {
        "includePlaces": true,
        // pchen: don't want other users' personal favs
        "onlyMine": true,
        "useShared": useShared,
        "readOnlyPublicData": false,
        // get only places whose names contain "name"
        //   (others are definitely unique to "name")
        "placeNameFilter": newName
      };

      var request = {
        method: "GET",
        url: config.daUrl + "place-sets/-1",
        params: params
      };

      $http(request).then(function (_ref2) {
        var placeSetList = _ref2.data;

        // expect placeSetList: [ { Places: [ { PlaceName } ] | null } ]
        var isUnique = placeSetList.filter(function (placeSet) {
          return placeSet && Array.isArray(placeSet.Places) && placeSet.Places.length > 0;
        }).map(function (placeSet) {
          return placeSet.Places;
        })
        // return true if every existing name is unique to "name" arg
        .every(function (placesList) {
          return placesList.every(function (place) {
            return place.PlaceName.toLowerCase() !== newName.toLowerCase();
          });
        });
        if (isUnique) {
          deferred.resolve(true);
        } else {
          deferred.reject();
        }
      }).catch(function (err) {
        // pchen let the user save if the webservice isn't working as expected
        // TODO pchen: err handling - maybe show a warning?
        deferred.resolve(true);
      });

      return deferred.promise;
    }

    return {
      isNameUnique: isNameUnique
    };
  }]);
})();

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var controllerId = "placesController";
  angular.module("app").controller(controllerId, ["$rootScope", "$scope", "UserProvider", "$uibModalInstance", "userService", "mapService", "_", "customPlaceSetService", function placesController($rootScope, $scope, userProvider, $uibModalInstance, userService, mapService, _, customPlaceSetService) {
    var vm = this;
    vm.loading = false;
    vm.customPlaceSets = [];
    vm.places = [];
    vm.selectedPlacesDict = {};
    vm.display = "sets";
    vm.setName = "";
    vm.mapId = "pcmMap";
    vm.hideContent = false;

    vm.showCategories = showCategories;
    vm.showPlacesInSet = showPlacesInSet;
    vm.showPlaceOnMap = showPlaceOnMap;
    vm.getSelectedPlacesLength = getSelectedPlacesLength;

    vm.ok = ok;
    vm.close = close;
    vm.back = back;

    init();
    ////////////////
    function init() {
      vm.loading = true;
      // this will get you the list of sets for more place Modal. (Everything minus the ones already show in Favorite)
      customPlaceSetService.getCustomPlaceSets().then(function (customPlaceSets) {
        vm.customPlaceSets = customPlaceSets;
      }).finally(function () {
        vm.loading = false;
      });
    }

    function showPlaceOnMap(result) {
      $rootScope.$broadcast("ShowPin", { location: result, pan: true, mapId: vm.mapId });
      vm.hideContent = true;
    }

    function showPlacesInSet(_ref) {
      var Name = _ref.Name,
          Places = _ref.Places;

      vm.setName = Name;
      vm.places = Places;
      vm.hideContent = false;
      vm.display = "places";
    }

    function getSelectedPlacesLength() {
      return Object.values(vm.selectedPlacesDict).filter(function (v) {
        return !!v;
      }).length;
    }

    function showCategories(set) {
      return set.Categories && set.Categories.length && set.Categories[0].Icon; // and if category belongs to one of those
    }

    function ok() {
      var Ids = [];
      _.each(vm.selectedPlacesDict, function (val, key) {
        if (val) {
          Ids.push(parseInt(key));
        }
      });
      var stops = [];
      _.each(vm.places, function (p) {
        if (_.contains(Ids, p.Id)) {
          stops.push(p);
        }
      });
      $rootScope.$broadcast("AddStop", stops);
      $uibModalInstance.close();
    }

    function close() {
      $uibModalInstance.dismiss("cancel");
      //switch to search
      $rootScope.$broadcast("FocusSearchField");
    }

    function back() {
      if (vm.hideContent === true) {
        vm.hideContent = false;
        vm.display = "places";
      } else {
        vm.display = "sets";
        vm.selectedPlacesDict = {};
      }
    }

    /////////////////////////////////////////////////////////////////
    // Event handlers section
    /////////////////////////////////////////////////////////////////
  }]);
})();

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(1);

(function () {
  "use strict";

  var serviceId = "routeSyncService";

  angular.module("app").service("routeSyncService", routeSyncService);

  routeSyncService.$inject = ["VehicleGroups", "RoutingProfiles", "Vehicles", "$http"];

  function routeSyncService(VehicleGroups, RoutingProfiles, Vehicles, $http) {
    return {
      getVehicleGroups: getVehicleGroups,
      getRoutingProfilesForVehicleGroup: getRoutingProfilesForVehicleGroup,
      getVehiclesForVehicleGroup: getVehiclesForVehicleGroup,
      getVehicles: getVehicles,
      sendRouteSyncMessage: sendRouteSyncMessage
    };

    ////////////////

    /** getVehicles
     *  Returns the valid vehicles for the currently logged in user
     * @returns {Promise} Promise to get all vehicles
     */
    function getVehicles() {
      var request = {
        url: config.daUrl + "routesync-user"
      };

      return _sendRequest(request);
    }

    /** sendRouteSyncMessage
     *  Accepts a RouteSync object and posts it as a routesync message to data anywhere.
     * @param {Object} message - the RouteSync message
     */
    function sendRouteSyncMessage(message) {
      var request = {
        url: config.daUrl + "routesync-message",
        data: message,
        method: "POST"
      };

      return _sendRequest(request);
    }

    /** getVehicleGroups
     *  Returns the valid vehicle groups for the currently logged in user.
     * @param {String} filterString - string by which to filter vehicle group names. defaults to null.
     * @param {Object} pageOptions - options to control how results are paginated: Valid options include
     * pageNumber, limit, sortBy (which should be a string that is the name of a property of a vehicle group), and
     * sortAscending, which is a bool. Defaults to null.
     * Valid properties for the vehicle group are:
     * Id, Name, NumberOfVehicles
     */
    function getVehicleGroups() {
      var filterString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var pageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      return VehicleGroups.getVehicleGroups([], [], filterString, pageOptions);
    }

    /** getRoutingProfilesForVehicleGroup
     *  Returns the routing profiles for the given vehicle group ID.
     * @param {Number} vehicleGroupID  - id of the vehicle group for which we will retrieve routing profiles.
     */
    function getRoutingProfilesForVehicleGroup(vehicleGroupID) {
      return RoutingProfiles.getRoutingProfiles(vehicleGroupID);
    }

    /** getVehiclesForVehicleGroup
     *  Returns all of the vehicles part of the given vehicle group ID.
     * @param {Number} vehicleGroupID  - id of the vehicle group for which we will retrieve routing profiles.
     * @param {String} filterString - string by which to filter vehicle names. defaults to null.
     * @param {Object} pageOptions - options to control how results are paginated: Valid options include
     * pageNumber, limit, sortBy (which should be a string that is the name of a property of a vehicle group), and
     * sortAscending, which is a bool. Defaults to null.
     * Valid properties for the vehicle group are:
     * Id, Name, VehicleId
     */
    function getVehiclesForVehicleGroup(vehicleGroupID) {
      var filterString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var pageOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return Vehicles.getVehicles([vehicleGroupID].filterString, pageOptions);
    }

    //  Service internals

    function _sendRequest(request) {
      return $http(request).then(function (resp) {
        return resp.data;
      });
    }
  }
})();

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("app").service("routeSyncErrors", routeSyncErrors);

  routeSyncErrors.$inject = ["$translate", "_"];

  function routeSyncErrors($translate, _) {

    return {
      areRouteOptionsValid: areRouteOptionsValid,
      getErrorsFromRouteOptions: getErrorsFromRouteOptions
    };

    ////////////////

    /** areRouteOptionsValid
     *  Returns whether or not the route has options that are valid for routeSync.
     * @param {Object} route - the route that contains the options we want to validate
     */
    function areRouteOptionsValid(route) {
      if (!route || !route.options) return false;

      if (route.options.highwayOnly === true) {
        return false;
      }

      if (route.options.overrideRestrict === true) {
        return false;
      }

      return true;
    }

    /** getErrorsFromRouteOptions
     *  Returns the translated error string that describes why the route's options prevent
     *  it from being valid for route sync.
     * @param {*} route - the route that contains the options for which we are getting errors
     */
    function getErrorsFromRouteOptions(route) {
      if (!route || !route.options) return "";

      var highwayOnly = route.options.highwayOnly === true;
      var overrideRestrict = route.options.overrideRestrict === true;
      if (highwayOnly && overrideRestrict) {
        return $translate.instant("templates.routeSyncErrors.useHighwayOnlyAndOverrideRestrictionsMessage");
      } else if (highwayOnly) {
        return $translate.instant("templates.routeSyncErrors.useHighwayOnlyMessage");
      } else if (overrideRestrict) {
        return $translate.instant("templates.routeSyncErrors.overrideRestrictionsMessage");
      } else {
        return "";
      }
    }
  }
})();

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  routeSyncSummaryController.$inject = ["$filter", "routeService"];
  angular.module("app").directive("routeSyncSummary", routeSyncSummary);

  routeSyncSummary.$inject = [];

  function routeSyncSummary() {
    // Usage: Display origin-destination info, route stats, and vehicle summary info
    //
    var directive = {
      bindToController: true,
      controller: routeSyncSummaryController,
      controllerAs: "vm",
      link: link,
      restrict: "E",
      templateUrl: "/app/route-sync/route-sync-summary/routeSyncSummary.template.html"
    };
    return directive;

    function link(scope, element, attrs) {}
  }

  /* @ngInject */
  function routeSyncSummaryController($filter, routeService) {
    var vm = this;

    vm.routeODInfo = routeODInfo;
    vm.routeStats = routeStats;
    vm.getCurrentRoute = getCurrentRoute;

    function routeODInfo() {
      var route = routeService.getSelectedRoute();
      var infoStr = "";
      var numStops = route.stops.length;
      if (numStops === 0) return;
      infoStr += route.stops[0].CityStateZip;
      infoStr += " to " + route.stops[numStops - 1].CityStateZip;
      infoStr += " : " + (numStops === 2 ? "No " : numStops - 2) + " Stop" + (numStops === 3 ? "" : "s");
      return infoStr;
    }

    function routeStats() {
      var route = routeService.getSelectedRoute();
      var statStr = distanceUnit() + ": " + $filter("number")(route.routeTMiles, 1) + " | Time: " + route.routeTHours + " | Cost: $" + $filter("number")(route.routeTCost, 2);
      return statStr;
    }

    function distanceUnit() {
      var route = routeService.getSelectedRoute();
      return route.options.distanceUnits === 0 ? "Miles" : "KMs";
    }

    function getCurrentRoute() {
      return routeService.getSelectedRoute();
    }
  }
})();

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  routeSyncPanelController.$inject = ["vehicleService", "routeService", "mapService", "alkGeocodeService", "_", "$scope", "$timeout"];
  angular.module("app").directive("routeSyncPanel", routeSyncPanel);

  routeSyncPanel.$inject = [];

  function routeSyncPanel() {
    // Usage: Creates a routeSync panel that presents vehicles, and allows you to send a route sync package
    //
    var directive = {
      bindToController: true,
      controller: routeSyncPanelController,
      controllerAs: "rsCtrl",
      link: link,
      restrict: "E",
      templateUrl: "/app/route-sync/route-sync-panel/routeSyncPanel.template.html"
    };
    return directive;

    function link(scope, element, attrs) {
      scope.close = function () {
        scope.$parent.routeVm.hideRouteSync();
      };
    }
  }

  /* @ngInject */
  function routeSyncPanelController(vehicleService, routeService, mapService, alkGeocodeService, _, $scope, $timeout) {
    var vm = this;

    vm.complianceAmounts = [{
      "display": "Strict",
      "value": 0
    }, {
      "display": "Moderate",
      "value": 1
    }, {
      "display": "Minimum",
      "value": 2
    }];

    vm.isLoadingVehicles = false;
    vm.vehicleList = [];
    vm.selectedVehicle = null;
    vm.showSearch = false;
    vm.searchText = "";
    vm.currentRoute = null;
    vm.routeSyncOptions = {
      "alertDist": 0.2,
      "complianceAmount": vm.complianceAmounts[0].value
    };

    vm.filterVehicles = filterVehicles;
    vm.cancelSearch = cancelSearch;
    vm.getVehicles = getVehicles;
    vm.getSelectedVehicle = getSelectedVehicle;
    vm.setSelectedVehicle = setSelectedVehicle;
    vm.showLocation = showLocation;
    vm.frameClosest = frameClosest;
    vm.getClosestToOrigin = getClosestToOrigin;
    vm.frameRouteAndVehicle = frameRouteAndVehicle;
    vm.send = send;

    init();

    function getSelectedVehicle() {
      return vm.selectedVehicle;
    }

    function setSelectedVehicle(vehicle) {
      vm.selectedVehicle = vehicle;
    }

    function showLocation(vehicle, pan) {
      if (!pan) {
        pan = false;
      }

      if (!vehicle.Latitude || !vehicle.Longitude) {
        return;
      }

      alkGeocodeService.reverseGeocode({
        "lat": vehicle.Latitude,
        "lon": vehicle.Longitude
      }).then(function (data) {
        vehicle.Address = data[0].Address;
        vehicleService.showVehicle(vehicle, pan, this);
      });
    }

    function frameClosest() {
      var closest = getClosestToOrigin();
      frameRouteAndVehicle(closest);
      setSelectedVehicle(closest);
    }

    function getClosestToOrigin() {
      var selRouteOrigin = vm.route.stops[0].Coords;
      var oPoint = new ALKMaps.Geometry.Point(selRouteOrigin.Lon, selRouteOrigin.Lat);
      var closest = _.min(vm.vehicleList, function (v) {
        var vPoint = new ALKMaps.Geometry.Point(v.Longitude, v.Latitude);
        return vPoint.distanceTo(oPoint);
      });
      return closest;
    }

    function frameRouteAndVehicle(vehicle) {
      showLocation(vehicle, false);
      var routeElements = mapService.getRouteElements(vm.route.id);
      var mapObj = mapService.getMap();
      var vehLL = new ALKMaps.LonLat(vehicle.Longitude, vehicle.Latitude).transform(new ALKMaps.Projection("EPSG:4326"), mapObj.getProjectionObject());
      var routeExtent = routeElements.routingLayer.getDataExtent();
      routeExtent.extend(vehLL);
      mapObj.zoomToExtent(routeExtent);
    }

    function send() {
      var currentVehicle = getSelectedVehicle();
      if (!currentVehicle) {
        return;
      }

      vm.routeSyncOptions.ownerId = currentVehicle.OwnerID;
      vm.routeSyncOptions.routeId = vm.route.id;
      vehicleService.sendRSMessage(vm.routeSyncOptions).then(function () {
        vm.displaySuccessMessage = true;
        vm.displayErrorMessage = false;
        $timeout(function () {
          $scope.$parent.routeVm.hideRouteSync();
        }, 3000);
      }, function () {
        vm.displaySuccessMessage = false;
        vm.displayErrorMessage = true;
      });
    }

    function filterVehicles() {
      vm.showSearch = !vm.showSearch;
    }

    function cancelSearch() {
      vm.searchText = "";
      vm.showSearch = false;
    }

    function getVehicles() {
      vehicleService.getVehicleList().then(function (vehicleList) {
        vm.vehicleList = vehicleList;
      }, function (err) {
        console.error(err);
        vm.vehicleList = [];
      });
    }

    function init() {
      getVehicles();
      vm.route = angular.copy(routeService.getSelectedRoute());
    }
  }
})();

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("app").directive("avoidFavorsPanel", avoidFavorsPanel);

  avoidFavorsPanel.$inject = [];

  function avoidFavorsPanel() {
    // Usage: Display avoid favor sets list info
    //
    var directive = {
      bindToController: true,
      controller: avoidFavorsPanelController,
      controllerAs: "vm",
      scope: {
        avoidFavorsSetList: "="
      },
      restrict: "E",
      templateUrl: "/app/avoidFavors/avoidFavors.template.html"
    };
    return directive;
  }

  avoidFavorsPanelController.$inject = ["$scope", "$rootScope", "_", "$http", "UserProvider", "mapService", "userService", "routeExceptionService", "routeExceptionsLayerService"];
  function avoidFavorsPanelController($scope, $rootScope, _, $http, UserProvider, mapService, userService, routeExceptionService, routeExceptionsLayerService) {
    var vm = this;
    vm.sets = [];
    vm.updateResult = updateResult;
    vm.isAvoidFavorsVisible = isAvoidFavorsVisible;
    init();

    function init() {
      vm.sets = angular.copy(userService.getAvoidFavorsSets());
      if (vm.avoidFavorsSetList && vm.avoidFavorsSetList !== "") {
        var temp = vm.avoidFavorsSetList.split(",").map(Number);
        _.forEach(vm.sets, function (s) {
          if (_.indexOf(temp, s.SetID) > -1) {
            s.visible = true;
          }
        });
      }
    }

    function isAvoidFavorsVisible() {
      return routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    // function getSelectedSetsLength() {
    //   return _.reduce(vm.sets, (sum, s) => (s.visible) ? ++sum : sum, 0);
    // }

    function updateResult(set) {
      var selectedSets = _.transform(vm.sets, function (rst, s) {
        if (s.visible) {
          return rst.push(s.SetID);
        }
      }, []);
      vm.avoidFavorsSetList = selectedSets.join();
    }

    $scope.$on("resetAFSelection", function (event, message) {
      _.forEach(vm.sets, function (set) {
        set.visible = false;
      });
    });
  }
})();

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*global ALKMaps*/
(function () {
  "use strict";

  angular.module("app").service("routeExceptionsLayerService", routeExceptionsLayerService);

  routeExceptionsLayerService.$inject = ["$rootScope", "mapService", "routeExceptionsLayerFactory", "routeExceptionService", "userService", "_"];

  function routeExceptionsLayerService($rootScope, mapService, routeExceptionsLayerFactory, routeExceptionService, userService, _) {
    var featuresByAvoidFavorID = {};
    var featuresByGroupID = {};
    var mapObj = mapService.getMapFromId();
    var factoryService = null;

    var service = {
      initRouteExceptionsLayerFactory: initRouteExceptionsLayerFactory,
      hasAvoidFavors: hasAvoidFavors,
      showAvoidFavorsLayer: showAvoidFavorsLayer,
      hideAvoidFavorsLayer: hideAvoidFavorsLayer,
      isAvoidFavorsLayerVisible: isAvoidFavorsLayerVisible,
      clearSet: clearSet,
      addSet: addSet,
      isAvoidFavorsSetReady: isAvoidFavorsSetReady,
      getAvoidFavorsSets: getAvoidFavorsSets,
      frameRouteExceptions: frameRouteExceptions
    };

    return service;

    /////////////////////

    function initRouteExceptionsLayerFactory() {
      var styleMap = new ALKMaps.StyleMap({
        "default": new ALKMaps.Style({
          cursor: "pointer",
          strokeColor: "${stroke}",
          strokeWidth: "${strokeWidth}",
          strokeDashstyle: "longdash",
          strokeOpacity: 0.8
        }, {
          context: {
            stroke: function stroke(feature) {
              return feature.attributes.exception.AvoidFavorType === routeExceptionService.FAVOR ? "#00b300" : "#b30000";
            },
            strokeWidth: function strokeWidth(feature) {
              var zoom = mapService.currentZoom();
              var width = 2;
              if (zoom > 12) {
                width = 2;
              }
              if (zoom > 14) {
                width = 4;
              }
              if (zoom > 17) {
                width = 8;
              }
              if (zoom > 19) {
                width = 14;
              }
              return width;
            }
          }
        })
      });

      mapObj.avoidFavorsLayer = new ALKMaps.Layer.Vector("Avoid Favors", {
        styleMap: styleMap,
        visibility: false
      });
      mapObj.map.addLayers([mapObj.avoidFavorsLayer]);
      featuresByAvoidFavorID = {};
      featuresByGroupID = {};
      factoryService = routeExceptionsLayerFactory(mapObj.avoidFavorsLayer, featuresByAvoidFavorID, featuresByGroupID);
    }

    function hasAvoidFavors() {
      return userService.hasAvoidFavorsSet();
    }

    function showAvoidFavorsLayer() {
      mapObj.avoidFavorsLayer.setVisibility(true);
      mapObj.savedInfo.showAvoidFavors = true;
    }

    function hideAvoidFavorsLayer() {
      mapObj.avoidFavorsLayer.setVisibility(false);
      mapObj.savedInfo.showAvoidFavors = false;
    }

    function isAvoidFavorsLayerVisible() {
      if (mapObj.avoidFavorsLayer) {
        return mapObj.avoidFavorsLayer.getVisibility();
      } else {
        return false;
      }
    }

    function clearSet(set) {
      var IDs = _.map(set.Links, function (link) {
        return link.AvoidFavorID;
      });
      var feature = _.filter(mapObj.avoidFavorsLayer.features, function (f) {
        return IDs.indexOf(f.attributes.avoidFavorID) > -1;
      });
      if (feature) {
        mapObj.avoidFavorsLayer.removeFeatures(feature);
        _.forEach(set.groups, function (group) {
          // delete grouped features
          delete featuresByGroupID[group.GroupID];
          // delete ungrouped features
          _.forEach(group.GroupLinks, function (link) {
            delete featuresByAvoidFavorID[link.AvoidFavorID];
          });
        });
      }
    }

    function addSet(set) {
      factoryService.addRouteExceptionsToMap(set.groups, set);
    }

    function isAvoidFavorsSetReady() {
      return userService.isAvoidFavorsSetReady();
    }

    function getAvoidFavorsSets() {
      return userService.getAvoidFavorsSets();
    }

    function frameRouteExceptions(set) {
      return factoryService.frameRouteExceptions(set.groups);
    }

    // function getIDsFromExceptions(exceptions) {
    //   var partitioned = _.partition(exceptions, "GroupID");
    //   var groupIDs = _.map(partitioned[0], "GroupID");
    //   var ungroupedIDs = _.map(partitioned[1], "GroupLinks[0].AvoidFavorID");
    //   return {
    //     grouped: groupIDs,
    //     ungrouped: ungroupedIDs
    //   };
    // }
  }
})();

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  "use strict";

  angular.module("alk.maps").directive("avoidFavorsMap", avoidFavorsMap);

  avoidFavorsMap.$inject = [];

  function avoidFavorsMap() {

    var directive = {
      bindToController: true,
      controller: avoidFavorsMapController,
      controllerAs: "vm",
      template: __webpack_require__(431),
      restrict: "E",
      scope: {}
    };
    return directive;
  }

  avoidFavorsMapController.$inject = ["$window", "$scope", "$element", "$attrs", "$translate", "UserProvider", "routeExceptionsLayerService", "_", "eventTracker"];

  function avoidFavorsMapController($window, $scope, $element, $attrs, $translate, userProvider, routeExceptionsLayerService, _, eventTracker) {
    var vm = this;
    vm.isPremium = isPremium;
    vm.frameAvoidFavorsSet = frameAvoidFavorsSet;
    vm.showAll = showAll;
    vm.hideAll = hideAll;
    vm.isAvoidFavorsLayerVisible = isAvoidFavorsLayerVisible;
    vm.toggleSetOnMap = toggleSetOnMap;
    vm.hasAvoidFavors = hasAvoidFavors;
    vm.isAvoidFavorsSetReady = isAvoidFavorsSetReady;
    vm.sets = [];
    vm.isInit = true;
    vm.getSets = getSets;
    vm.isDropDownShow = false;

    routeExceptionsLayerService.initRouteExceptionsLayerFactory();

    function isPremium() {
      return userProvider.getUser().isPremium();
    }

    function frameAvoidFavorsSet(set) {
      routeExceptionsLayerService.frameRouteExceptions(set);
    }

    function getSets() {
      // we can not get sets data during directive init phase as it's still not ready from userService.
      if (vm.isInit) {
        vm.sets = angular.copy(routeExceptionsLayerService.getAvoidFavorsSets());
        showAll();
        vm.isInit = false;
      }
    }

    function hideAll() {
      _.forEach(vm.sets, function (set) {
        set.visible = false;
        routeExceptionsLayerService.clearSet(set);
      });
      routeExceptionsLayerService.hideAvoidFavorsLayer();
    }

    function showAll() {
      routeExceptionsLayerService.showAvoidFavorsLayer();
      _.forEach(vm.sets, function (set) {
        set.visible = true;
        routeExceptionsLayerService.addSet(set);
      });
    }

    function isAvoidFavorsLayerVisible() {
      return routeExceptionsLayerService.isAvoidFavorsLayerVisible();
    }

    function toggleSetOnMap(set) {
      if (set.visible) {
        routeExceptionsLayerService.clearSet(set);
        set.visible = false;
        eventTracker.track("Hide Route Modifiers");
      } else {
        routeExceptionsLayerService.showAvoidFavorsLayer();
        set.visible = true;
        routeExceptionsLayerService.addSet(set);
        eventTracker.track("Show Route Modifiers");
      }
    }

    function hasAvoidFavors() {
      return routeExceptionsLayerService.hasAvoidFavors();
    }

    function isAvoidFavorsSetReady() {
      return routeExceptionsLayerService.isAvoidFavorsSetReady();
    }
  }
})();

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "<ul>\n<li class=\"large-btn btn-group dropdown\" uib-dropdown auto-close=\"outsideClick\" is-open=\"vm.isDropDownShow\">\n  <button id=\"route-modifiers-btn\" uib-dropdown-toggle ng-click=\"vm.getSets()\" ng-disabled=\"!vm.isPremium() || !vm.isAvoidFavorsSetReady()\"\n    title=\"{{(vm.isPremium())?'Toggle Route Modifiers':'Premium Only'}}\" alkmaps-input alk-analytics=\"['Map Style','AvoidFavors','{{(vm.isAvoidFavorsLayerVisible() !== '')?'On':'Off'}}']\">\n    <img class=\"\" src=\"/img/icons/route-exceptions.svg\" />Route<br/>Modifiers\n    <span class=\"caret\"></span>\n  </button>\n  <span ng-hide=\"vm.isPremium()\" tooltip-placement=\"bottom\" uib-tooltip=\"Premium Only\" ng-cloak class=\"ng-cloak premium-feature-note\"\n    style=\"position: absolute; right: 4px; top: -5px;\"></span>\n\n  <ul class=\"list-group item-list exceptions-dropdown\" uib-dropdown-menu role=\"menu\" ng-show=\"vm.isDropDownShow\" ng-if=\"vm.hasAvoidFavors()\">\n  <li class=\"list-group-item\" alkmaps-input style=\"cursor: default\">\n     <div class=\"flex-group\">\n    <button class=\"btn btn-default btn-xs list-buttons\" alkmaps-input ng-show=\"vm.isDropDownShow\" ng-click=\"vm.showAll(); $event.preventDefault(); $event.stopPropagation();\">\n      Show All\n      <!-- <i class=\"ico ico-eye-open\"></i> -->\n    </button>\n    <button class=\"btn btn-default btn-xs list-buttons\"  alkmaps-input ng-show=\"vm.isDropDownShow\" ng-click=\"vm.hideAll(); $event.preventDefault(); $event.stopPropagation();\">\n     Show None\n     <!-- <i class=\"ico ico-eye-blocked\"></i>  -->\n    </button>\n     </div>\n    </li>\n    <li class=\"list-group-item\" ng-repeat=\"set in vm.sets\" alkmaps-input ng-if=\"set.groups.length > 0\">\n      <div class=\"flex-group\">\n        <!-- Switch and name-->\n        <div class=\"result-info text-ellipsis flex-element\" >\n          <switch ng-click=\"vm.toggleSetOnMap(set);$event.preventDefault(); $event.stopPropagation();\" ng-model=\"set.visible\"\n          ng-style=\"{'background-color':(set.visible)?('#123ec4' | hexToRGBa : 0.5):'', 'border-color': (set.visible)?('#123ec4' | hexToRGBa : 0.6):''}\"\n            title=\"{{(set.visible)?'Hide set':'View set'}}\" >\n          </switch>\n          <span ng-click=\"vm.toggleSetOnMap(set);$event.preventDefault(); $event.stopPropagation();\" class=\"exception-name\">\n            <span class=\"name\"><strong> {{set.Name}} </strong></span>\n          </span>\n        </div>\n        <span class=\"badge with-actions pull-right\" title=\"{{set.groups.length}} Modifiers\">{{set.groups.length}}</span>\n          <button tabindex=\"-1\" class=\"btn btn-xs btn-link\" ng-disabled=\"!set.visible\" ng-click=\"vm.frameAvoidFavorsSet(set); $event.preventDefault(); $event.stopPropagation();\"\n            analytics=\"['Route Modifiers','More','Frame']\" title=\"Frame Set\">\n            <i class=\"ico ico-frame-box\"></i>\n          </button>\n      </div>\n    </li>\n\n  </ul>\n  <ul class=\"list-group item-list exceptions-dropdown\" role=\"menu\" ng-show=\"vm.isDropDownShow\" ng-if=\"!vm.hasAvoidFavors()\">\n        <li class=\"list-group-item\" alkmaps-input  ng-show=\"vm.isDropDownShow\">\n          <p> Get access to Route Modifiers by using Content Tools available in the Web Tools menu </p>\n    </li>\n  </ul>\n</li>\n</ul>\n";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (angular) {

  angular.module("app").directive("alkAutofocus", ["$timeout", "$parse", function ($timeout, $parse) {
    return {
      restrict: "A",
      link: function link($scope, $element, attrs) {
        if (attrs.alkAutofocus === "" || $parse(attrs.alkAutofocus)($scope)) {
          $timeout(function () {
            $element[0].focus();
          }, 0);
        }
      }
    };
  }]);
})(angular);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundleIndex.cfc0ca3c52738b14d4c4.js